// src/subgraph-config.ts
var version = "1.0.6";
var subgraph_config_default = {
  graph: "/axis-origin",
  version
};

// src/tokenlist-metadata.ts
var tokenlist_metadata_default = {
  name: "Axis Finance",
  logoURI: "/logo-color.png",
  keywords: ["axis", "default"],
  timestamp: Date.now().toString(),
  version: {
    major: 0,
    minor: 0,
    patch: 0
  }
};

// src/deployment-creator.ts
function createDeployment(config13) {
  return {
    name: config13.name,
    addresses: config13.addresses,
    callbacks: config13.callbacks,
    subgraphURL: withVersion(config13.subgraphURL, subgraph_config_default.version),
    chain: withCustomConfiguration(config13),
    tokenList: withMetadata(config13.tokenList, config13.chain.id)
  };
}
function createDeploymentRecord(chains) {
  return chains.reduce((acc, deployment) => {
    return {
      ...acc,
      [deployment.chain.id]: deployment
    };
  }, {});
}
function withVersion(url, version3) {
  return url.replace("<VERSION>", version3.toString());
}
function withCustomConfiguration({
  chain,
  ...config13
}) {
  if (!config13.rpcURL) return chain;
  return {
    ...chain,
    iconUrl: config13.chainIconUrl,
    rpcUrls: {
      ...chain.rpcUrls,
      axis: { http: [config13.rpcURL] }
    },
    nativeCurrency: {
      ...chain.nativeCurrency,
      wrapperContract: config13.wrapperContract
    }
  };
}
function withMetadata(tokens, chainId) {
  return {
    ...tokenlist_metadata_default,
    isActive: true,
    tokens: tokens.map((t) => ({ ...t, chainId }))
  };
}

// ../../node_modules/viem/_esm/utils/chain/defineChain.js
function defineChain(chain) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...chain
  };
}

// ../../node_modules/viem/_esm/errors/version.js
var version2 = "2.23.11";

// ../../node_modules/viem/_esm/errors/base.js
var errorConfig = {
  getDocsUrl: ({ docsBaseUrl, docsPath = "", docsSlug }) => docsPath ? `${docsBaseUrl ?? "https://viem.sh"}${docsPath}${docsSlug ? `#${docsSlug}` : ""}` : void 0,
  version: `viem@${version2}`
};
var BaseError = class _BaseError extends Error {
  constructor(shortMessage, args = {}) {
    const details = (() => {
      if (args.cause instanceof _BaseError)
        return args.cause.details;
      if (args.cause?.message)
        return args.cause.message;
      return args.details;
    })();
    const docsPath = (() => {
      if (args.cause instanceof _BaseError)
        return args.cause.docsPath || args.docsPath;
      return args.docsPath;
    })();
    const docsUrl = errorConfig.getDocsUrl?.({ ...args, docsPath });
    const message = [
      shortMessage || "An error occurred.",
      "",
      ...args.metaMessages ? [...args.metaMessages, ""] : [],
      ...docsUrl ? [`Docs: ${docsUrl}`] : [],
      ...details ? [`Details: ${details}`] : [],
      ...errorConfig.version ? [`Version: ${errorConfig.version}`] : []
    ].join("\n");
    super(message, args.cause ? { cause: args.cause } : void 0);
    Object.defineProperty(this, "details", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "docsPath", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "metaMessages", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shortMessage", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "version", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "BaseError"
    });
    this.details = details;
    this.docsPath = docsPath;
    this.metaMessages = args.metaMessages;
    this.name = args.name ?? this.name;
    this.shortMessage = shortMessage;
    this.version = version2;
  }
  walk(fn) {
    return walk(this, fn);
  }
};
function walk(err, fn) {
  if (fn?.(err))
    return err;
  if (err && typeof err === "object" && "cause" in err && err.cause !== void 0)
    return walk(err.cause, fn);
  return fn ? null : err;
}

// ../../node_modules/viem/_esm/errors/encoding.js
var IntegerOutOfRangeError = class extends BaseError {
  constructor({ max, min, signed, size: size2, value }) {
    super(`Number "${value}" is not in safe ${size2 ? `${size2 * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, { name: "IntegerOutOfRangeError" });
  }
};
var SizeOverflowError = class extends BaseError {
  constructor({ givenSize, maxSize }) {
    super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, { name: "SizeOverflowError" });
  }
};

// ../../node_modules/viem/_esm/utils/data/isHex.js
function isHex(value, { strict = true } = {}) {
  if (!value)
    return false;
  if (typeof value !== "string")
    return false;
  return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

// ../../node_modules/viem/_esm/utils/data/size.js
function size(value) {
  if (isHex(value, { strict: false }))
    return Math.ceil((value.length - 2) / 2);
  return value.length;
}

// ../../node_modules/viem/_esm/utils/data/trim.js
function trim(hexOrBytes, { dir = "left" } = {}) {
  let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
  let sliceLength = 0;
  for (let i = 0; i < data.length - 1; i++) {
    if (data[dir === "left" ? i : data.length - i - 1].toString() === "0")
      sliceLength++;
    else
      break;
  }
  data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
  if (typeof hexOrBytes === "string") {
    if (data.length === 1 && dir === "right")
      data = `${data}0`;
    return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
  }
  return data;
}

// ../../node_modules/viem/_esm/errors/data.js
var SliceOffsetOutOfBoundsError = class extends BaseError {
  constructor({ offset, position, size: size2 }) {
    super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size2}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
};
var SizeExceedsPaddingSizeError = class extends BaseError {
  constructor({ size: size2, targetSize, type }) {
    super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size2}) exceeds padding size (${targetSize}).`, { name: "SizeExceedsPaddingSizeError" });
  }
};

// ../../node_modules/viem/_esm/utils/data/pad.js
function pad(hexOrBytes, { dir, size: size2 = 32 } = {}) {
  if (typeof hexOrBytes === "string")
    return padHex(hexOrBytes, { dir, size: size2 });
  return padBytes(hexOrBytes, { dir, size: size2 });
}
function padHex(hex_, { dir, size: size2 = 32 } = {}) {
  if (size2 === null)
    return hex_;
  const hex = hex_.replace("0x", "");
  if (hex.length > size2 * 2)
    throw new SizeExceedsPaddingSizeError({
      size: Math.ceil(hex.length / 2),
      targetSize: size2,
      type: "hex"
    });
  return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size2 * 2, "0")}`;
}
function padBytes(bytes, { dir, size: size2 = 32 } = {}) {
  if (size2 === null)
    return bytes;
  if (bytes.length > size2)
    throw new SizeExceedsPaddingSizeError({
      size: bytes.length,
      targetSize: size2,
      type: "bytes"
    });
  const paddedBytes = new Uint8Array(size2);
  for (let i = 0; i < size2; i++) {
    const padEnd = dir === "right";
    paddedBytes[padEnd ? i : size2 - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
  }
  return paddedBytes;
}

// ../../node_modules/viem/_esm/utils/encoding/toHex.js
var hexes = /* @__PURE__ */ Array.from({ length: 256 }, (_v, i) => i.toString(16).padStart(2, "0"));
function toHex(value, opts = {}) {
  if (typeof value === "number" || typeof value === "bigint")
    return numberToHex(value, opts);
  if (typeof value === "string") {
    return stringToHex(value, opts);
  }
  if (typeof value === "boolean")
    return boolToHex(value, opts);
  return bytesToHex(value, opts);
}
function boolToHex(value, opts = {}) {
  const hex = `0x${Number(value)}`;
  if (typeof opts.size === "number") {
    assertSize(hex, { size: opts.size });
    return pad(hex, { size: opts.size });
  }
  return hex;
}
function bytesToHex(value, opts = {}) {
  let string = "";
  for (let i = 0; i < value.length; i++) {
    string += hexes[value[i]];
  }
  const hex = `0x${string}`;
  if (typeof opts.size === "number") {
    assertSize(hex, { size: opts.size });
    return pad(hex, { dir: "right", size: opts.size });
  }
  return hex;
}
function numberToHex(value_, opts = {}) {
  const { signed, size: size2 } = opts;
  const value = BigInt(value_);
  let maxValue;
  if (size2) {
    if (signed)
      maxValue = (1n << BigInt(size2) * 8n - 1n) - 1n;
    else
      maxValue = 2n ** (BigInt(size2) * 8n) - 1n;
  } else if (typeof value_ === "number") {
    maxValue = BigInt(Number.MAX_SAFE_INTEGER);
  }
  const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
  if (maxValue && value > maxValue || value < minValue) {
    const suffix = typeof value_ === "bigint" ? "n" : "";
    throw new IntegerOutOfRangeError({
      max: maxValue ? `${maxValue}${suffix}` : void 0,
      min: `${minValue}${suffix}`,
      signed,
      size: size2,
      value: `${value_}${suffix}`
    });
  }
  const hex = `0x${(signed && value < 0 ? (1n << BigInt(size2 * 8)) + BigInt(value) : value).toString(16)}`;
  if (size2)
    return pad(hex, { size: size2 });
  return hex;
}
var encoder = /* @__PURE__ */ new TextEncoder();
function stringToHex(value_, opts = {}) {
  const value = encoder.encode(value_);
  return bytesToHex(value, opts);
}

// ../../node_modules/viem/_esm/utils/encoding/toBytes.js
var encoder2 = /* @__PURE__ */ new TextEncoder();
function toBytes(value, opts = {}) {
  if (typeof value === "number" || typeof value === "bigint")
    return numberToBytes(value, opts);
  if (typeof value === "boolean")
    return boolToBytes(value, opts);
  if (isHex(value))
    return hexToBytes(value, opts);
  return stringToBytes(value, opts);
}
function boolToBytes(value, opts = {}) {
  const bytes = new Uint8Array(1);
  bytes[0] = Number(value);
  if (typeof opts.size === "number") {
    assertSize(bytes, { size: opts.size });
    return pad(bytes, { size: opts.size });
  }
  return bytes;
}
var charCodeMap = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function charCodeToBase16(char) {
  if (char >= charCodeMap.zero && char <= charCodeMap.nine)
    return char - charCodeMap.zero;
  if (char >= charCodeMap.A && char <= charCodeMap.F)
    return char - (charCodeMap.A - 10);
  if (char >= charCodeMap.a && char <= charCodeMap.f)
    return char - (charCodeMap.a - 10);
  return void 0;
}
function hexToBytes(hex_, opts = {}) {
  let hex = hex_;
  if (opts.size) {
    assertSize(hex, { size: opts.size });
    hex = pad(hex, { dir: "right", size: opts.size });
  }
  let hexString = hex.slice(2);
  if (hexString.length % 2)
    hexString = `0${hexString}`;
  const length = hexString.length / 2;
  const bytes = new Uint8Array(length);
  for (let index = 0, j = 0; index < length; index++) {
    const nibbleLeft = charCodeToBase16(hexString.charCodeAt(j++));
    const nibbleRight = charCodeToBase16(hexString.charCodeAt(j++));
    if (nibbleLeft === void 0 || nibbleRight === void 0) {
      throw new BaseError(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
    }
    bytes[index] = nibbleLeft * 16 + nibbleRight;
  }
  return bytes;
}
function numberToBytes(value, opts) {
  const hex = numberToHex(value, opts);
  return hexToBytes(hex);
}
function stringToBytes(value, opts = {}) {
  const bytes = encoder2.encode(value);
  if (typeof opts.size === "number") {
    assertSize(bytes, { size: opts.size });
    return pad(bytes, { dir: "right", size: opts.size });
  }
  return bytes;
}

// ../../node_modules/viem/_esm/utils/encoding/fromHex.js
function assertSize(hexOrBytes, { size: size2 }) {
  if (size(hexOrBytes) > size2)
    throw new SizeOverflowError({
      givenSize: size(hexOrBytes),
      maxSize: size2
    });
}
function hexToBigInt(hex, opts = {}) {
  const { signed } = opts;
  if (opts.size)
    assertSize(hex, { size: opts.size });
  const value = BigInt(hex);
  if (!signed)
    return value;
  const size2 = (hex.length - 2) / 2;
  const max = (1n << BigInt(size2) * 8n - 1n) - 1n;
  if (value <= max)
    return value;
  return value - BigInt(`0x${"f".padStart(size2 * 2, "f")}`) - 1n;
}
function hexToNumber(hex, opts = {}) {
  return Number(hexToBigInt(hex, opts));
}

// ../../node_modules/viem/_esm/utils/formatters/formatter.js
function defineFormatter(type, format) {
  return ({ exclude, format: overrides }) => {
    return {
      exclude,
      format: (args) => {
        const formatted = format(args);
        if (exclude) {
          for (const key of exclude) {
            delete formatted[key];
          }
        }
        return {
          ...formatted,
          ...overrides(args)
        };
      },
      type
    };
  };
}

// ../../node_modules/viem/_esm/utils/formatters/transaction.js
var transactionType = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844",
  "0x4": "eip7702"
};
function formatTransaction(transaction) {
  const transaction_ = {
    ...transaction,
    blockHash: transaction.blockHash ? transaction.blockHash : null,
    blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
    chainId: transaction.chainId ? hexToNumber(transaction.chainId) : void 0,
    gas: transaction.gas ? BigInt(transaction.gas) : void 0,
    gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : void 0,
    maxFeePerBlobGas: transaction.maxFeePerBlobGas ? BigInt(transaction.maxFeePerBlobGas) : void 0,
    maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : void 0,
    nonce: transaction.nonce ? hexToNumber(transaction.nonce) : void 0,
    to: transaction.to ? transaction.to : null,
    transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
    type: transaction.type ? transactionType[transaction.type] : void 0,
    typeHex: transaction.type ? transaction.type : void 0,
    value: transaction.value ? BigInt(transaction.value) : void 0,
    v: transaction.v ? BigInt(transaction.v) : void 0
  };
  if (transaction.authorizationList)
    transaction_.authorizationList = formatAuthorizationList(transaction.authorizationList);
  transaction_.yParity = (() => {
    if (transaction.yParity)
      return Number(transaction.yParity);
    if (typeof transaction_.v === "bigint") {
      if (transaction_.v === 0n || transaction_.v === 27n)
        return 0;
      if (transaction_.v === 1n || transaction_.v === 28n)
        return 1;
      if (transaction_.v >= 35n)
        return transaction_.v % 2n === 0n ? 1 : 0;
    }
    return void 0;
  })();
  if (transaction_.type === "legacy") {
    delete transaction_.accessList;
    delete transaction_.maxFeePerBlobGas;
    delete transaction_.maxFeePerGas;
    delete transaction_.maxPriorityFeePerGas;
    delete transaction_.yParity;
  }
  if (transaction_.type === "eip2930") {
    delete transaction_.maxFeePerBlobGas;
    delete transaction_.maxFeePerGas;
    delete transaction_.maxPriorityFeePerGas;
  }
  if (transaction_.type === "eip1559") {
    delete transaction_.maxFeePerBlobGas;
  }
  return transaction_;
}
var defineTransaction = /* @__PURE__ */ defineFormatter("transaction", formatTransaction);
function formatAuthorizationList(authorizationList) {
  return authorizationList.map((authorization) => ({
    contractAddress: authorization.address,
    chainId: Number(authorization.chainId),
    nonce: Number(authorization.nonce),
    r: authorization.r,
    s: authorization.s,
    yParity: Number(authorization.yParity)
  }));
}

// ../../node_modules/viem/_esm/utils/formatters/block.js
function formatBlock(block) {
  const transactions = (block.transactions ?? []).map((transaction) => {
    if (typeof transaction === "string")
      return transaction;
    return formatTransaction(transaction);
  });
  return {
    ...block,
    baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
    blobGasUsed: block.blobGasUsed ? BigInt(block.blobGasUsed) : void 0,
    difficulty: block.difficulty ? BigInt(block.difficulty) : void 0,
    excessBlobGas: block.excessBlobGas ? BigInt(block.excessBlobGas) : void 0,
    gasLimit: block.gasLimit ? BigInt(block.gasLimit) : void 0,
    gasUsed: block.gasUsed ? BigInt(block.gasUsed) : void 0,
    hash: block.hash ? block.hash : null,
    logsBloom: block.logsBloom ? block.logsBloom : null,
    nonce: block.nonce ? block.nonce : null,
    number: block.number ? BigInt(block.number) : null,
    size: block.size ? BigInt(block.size) : void 0,
    timestamp: block.timestamp ? BigInt(block.timestamp) : void 0,
    transactions,
    totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
  };
}
var defineBlock = /* @__PURE__ */ defineFormatter("block", formatBlock);

// ../../node_modules/viem/_esm/utils/formatters/log.js
function formatLog(log, { args, eventName } = {}) {
  return {
    ...log,
    blockHash: log.blockHash ? log.blockHash : null,
    blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
    logIndex: log.logIndex ? Number(log.logIndex) : null,
    transactionHash: log.transactionHash ? log.transactionHash : null,
    transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
    ...eventName ? { args, eventName } : {}
  };
}

// ../../node_modules/viem/_esm/utils/formatters/transactionReceipt.js
var receiptStatuses = {
  "0x0": "reverted",
  "0x1": "success"
};
function formatTransactionReceipt(transactionReceipt) {
  const receipt = {
    ...transactionReceipt,
    blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
    contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
    cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
    effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
    gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
    logs: transactionReceipt.logs ? transactionReceipt.logs.map((log) => formatLog(log)) : null,
    to: transactionReceipt.to ? transactionReceipt.to : null,
    transactionIndex: transactionReceipt.transactionIndex ? hexToNumber(transactionReceipt.transactionIndex) : null,
    status: transactionReceipt.status ? receiptStatuses[transactionReceipt.status] : null,
    type: transactionReceipt.type ? transactionType[transactionReceipt.type] || transactionReceipt.type : null
  };
  if (transactionReceipt.blobGasPrice)
    receipt.blobGasPrice = BigInt(transactionReceipt.blobGasPrice);
  if (transactionReceipt.blobGasUsed)
    receipt.blobGasUsed = BigInt(transactionReceipt.blobGasUsed);
  return receipt;
}
var defineTransactionReceipt = /* @__PURE__ */ defineFormatter("transactionReceipt", formatTransactionReceipt);

// ../../node_modules/viem/_esm/constants/number.js
var maxInt8 = 2n ** (8n - 1n) - 1n;
var maxInt16 = 2n ** (16n - 1n) - 1n;
var maxInt24 = 2n ** (24n - 1n) - 1n;
var maxInt32 = 2n ** (32n - 1n) - 1n;
var maxInt40 = 2n ** (40n - 1n) - 1n;
var maxInt48 = 2n ** (48n - 1n) - 1n;
var maxInt56 = 2n ** (56n - 1n) - 1n;
var maxInt64 = 2n ** (64n - 1n) - 1n;
var maxInt72 = 2n ** (72n - 1n) - 1n;
var maxInt80 = 2n ** (80n - 1n) - 1n;
var maxInt88 = 2n ** (88n - 1n) - 1n;
var maxInt96 = 2n ** (96n - 1n) - 1n;
var maxInt104 = 2n ** (104n - 1n) - 1n;
var maxInt112 = 2n ** (112n - 1n) - 1n;
var maxInt120 = 2n ** (120n - 1n) - 1n;
var maxInt128 = 2n ** (128n - 1n) - 1n;
var maxInt136 = 2n ** (136n - 1n) - 1n;
var maxInt144 = 2n ** (144n - 1n) - 1n;
var maxInt152 = 2n ** (152n - 1n) - 1n;
var maxInt160 = 2n ** (160n - 1n) - 1n;
var maxInt168 = 2n ** (168n - 1n) - 1n;
var maxInt176 = 2n ** (176n - 1n) - 1n;
var maxInt184 = 2n ** (184n - 1n) - 1n;
var maxInt192 = 2n ** (192n - 1n) - 1n;
var maxInt200 = 2n ** (200n - 1n) - 1n;
var maxInt208 = 2n ** (208n - 1n) - 1n;
var maxInt216 = 2n ** (216n - 1n) - 1n;
var maxInt224 = 2n ** (224n - 1n) - 1n;
var maxInt232 = 2n ** (232n - 1n) - 1n;
var maxInt240 = 2n ** (240n - 1n) - 1n;
var maxInt248 = 2n ** (248n - 1n) - 1n;
var maxInt256 = 2n ** (256n - 1n) - 1n;
var minInt8 = -(2n ** (8n - 1n));
var minInt16 = -(2n ** (16n - 1n));
var minInt24 = -(2n ** (24n - 1n));
var minInt32 = -(2n ** (32n - 1n));
var minInt40 = -(2n ** (40n - 1n));
var minInt48 = -(2n ** (48n - 1n));
var minInt56 = -(2n ** (56n - 1n));
var minInt64 = -(2n ** (64n - 1n));
var minInt72 = -(2n ** (72n - 1n));
var minInt80 = -(2n ** (80n - 1n));
var minInt88 = -(2n ** (88n - 1n));
var minInt96 = -(2n ** (96n - 1n));
var minInt104 = -(2n ** (104n - 1n));
var minInt112 = -(2n ** (112n - 1n));
var minInt120 = -(2n ** (120n - 1n));
var minInt128 = -(2n ** (128n - 1n));
var minInt136 = -(2n ** (136n - 1n));
var minInt144 = -(2n ** (144n - 1n));
var minInt152 = -(2n ** (152n - 1n));
var minInt160 = -(2n ** (160n - 1n));
var minInt168 = -(2n ** (168n - 1n));
var minInt176 = -(2n ** (176n - 1n));
var minInt184 = -(2n ** (184n - 1n));
var minInt192 = -(2n ** (192n - 1n));
var minInt200 = -(2n ** (200n - 1n));
var minInt208 = -(2n ** (208n - 1n));
var minInt216 = -(2n ** (216n - 1n));
var minInt224 = -(2n ** (224n - 1n));
var minInt232 = -(2n ** (232n - 1n));
var minInt240 = -(2n ** (240n - 1n));
var minInt248 = -(2n ** (248n - 1n));
var minInt256 = -(2n ** (256n - 1n));
var maxUint8 = 2n ** 8n - 1n;
var maxUint16 = 2n ** 16n - 1n;
var maxUint24 = 2n ** 24n - 1n;
var maxUint32 = 2n ** 32n - 1n;
var maxUint40 = 2n ** 40n - 1n;
var maxUint48 = 2n ** 48n - 1n;
var maxUint56 = 2n ** 56n - 1n;
var maxUint64 = 2n ** 64n - 1n;
var maxUint72 = 2n ** 72n - 1n;
var maxUint80 = 2n ** 80n - 1n;
var maxUint88 = 2n ** 88n - 1n;
var maxUint96 = 2n ** 96n - 1n;
var maxUint104 = 2n ** 104n - 1n;
var maxUint112 = 2n ** 112n - 1n;
var maxUint120 = 2n ** 120n - 1n;
var maxUint128 = 2n ** 128n - 1n;
var maxUint136 = 2n ** 136n - 1n;
var maxUint144 = 2n ** 144n - 1n;
var maxUint152 = 2n ** 152n - 1n;
var maxUint160 = 2n ** 160n - 1n;
var maxUint168 = 2n ** 168n - 1n;
var maxUint176 = 2n ** 176n - 1n;
var maxUint184 = 2n ** 184n - 1n;
var maxUint192 = 2n ** 192n - 1n;
var maxUint200 = 2n ** 200n - 1n;
var maxUint208 = 2n ** 208n - 1n;
var maxUint216 = 2n ** 216n - 1n;
var maxUint224 = 2n ** 224n - 1n;
var maxUint232 = 2n ** 232n - 1n;
var maxUint240 = 2n ** 240n - 1n;
var maxUint248 = 2n ** 248n - 1n;
var maxUint256 = 2n ** 256n - 1n;

// ../../node_modules/viem/_esm/utils/data/concat.js
function concatHex(values) {
  return `0x${values.reduce((acc, x) => acc + x.replace("0x", ""), "")}`;
}

// ../../node_modules/viem/_esm/errors/cursor.js
var NegativeOffsetError = class extends BaseError {
  constructor({ offset }) {
    super(`Offset \`${offset}\` cannot be negative.`, {
      name: "NegativeOffsetError"
    });
  }
};
var PositionOutOfBoundsError = class extends BaseError {
  constructor({ length, position }) {
    super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`, { name: "PositionOutOfBoundsError" });
  }
};
var RecursiveReadLimitExceededError = class extends BaseError {
  constructor({ count, limit }) {
    super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`, { name: "RecursiveReadLimitExceededError" });
  }
};

// ../../node_modules/viem/_esm/utils/cursor.js
var staticCursor = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new RecursiveReadLimitExceededError({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(position) {
    if (position < 0 || position > this.bytes.length - 1)
      throw new PositionOutOfBoundsError({
        length: this.bytes.length,
        position
      });
  },
  decrementPosition(offset) {
    if (offset < 0)
      throw new NegativeOffsetError({ offset });
    const position = this.position - offset;
    this.assertPosition(position);
    this.position = position;
  },
  getReadCount(position) {
    return this.positionReadCount.get(position || this.position) || 0;
  },
  incrementPosition(offset) {
    if (offset < 0)
      throw new NegativeOffsetError({ offset });
    const position = this.position + offset;
    this.assertPosition(position);
    this.position = position;
  },
  inspectByte(position_) {
    const position = position_ ?? this.position;
    this.assertPosition(position);
    return this.bytes[position];
  },
  inspectBytes(length, position_) {
    const position = position_ ?? this.position;
    this.assertPosition(position + length - 1);
    return this.bytes.subarray(position, position + length);
  },
  inspectUint8(position_) {
    const position = position_ ?? this.position;
    this.assertPosition(position);
    return this.bytes[position];
  },
  inspectUint16(position_) {
    const position = position_ ?? this.position;
    this.assertPosition(position + 1);
    return this.dataView.getUint16(position);
  },
  inspectUint24(position_) {
    const position = position_ ?? this.position;
    this.assertPosition(position + 2);
    return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
  },
  inspectUint32(position_) {
    const position = position_ ?? this.position;
    this.assertPosition(position + 3);
    return this.dataView.getUint32(position);
  },
  pushByte(byte) {
    this.assertPosition(this.position);
    this.bytes[this.position] = byte;
    this.position++;
  },
  pushBytes(bytes) {
    this.assertPosition(this.position + bytes.length - 1);
    this.bytes.set(bytes, this.position);
    this.position += bytes.length;
  },
  pushUint8(value) {
    this.assertPosition(this.position);
    this.bytes[this.position] = value;
    this.position++;
  },
  pushUint16(value) {
    this.assertPosition(this.position + 1);
    this.dataView.setUint16(this.position, value);
    this.position += 2;
  },
  pushUint24(value) {
    this.assertPosition(this.position + 2);
    this.dataView.setUint16(this.position, value >> 8);
    this.dataView.setUint8(this.position + 2, value & ~4294967040);
    this.position += 3;
  },
  pushUint32(value) {
    this.assertPosition(this.position + 3);
    this.dataView.setUint32(this.position, value);
    this.position += 4;
  },
  readByte() {
    this.assertReadLimit();
    this._touch();
    const value = this.inspectByte();
    this.position++;
    return value;
  },
  readBytes(length, size2) {
    this.assertReadLimit();
    this._touch();
    const value = this.inspectBytes(length);
    this.position += size2 ?? length;
    return value;
  },
  readUint8() {
    this.assertReadLimit();
    this._touch();
    const value = this.inspectUint8();
    this.position += 1;
    return value;
  },
  readUint16() {
    this.assertReadLimit();
    this._touch();
    const value = this.inspectUint16();
    this.position += 2;
    return value;
  },
  readUint24() {
    this.assertReadLimit();
    this._touch();
    const value = this.inspectUint24();
    this.position += 3;
    return value;
  },
  readUint32() {
    this.assertReadLimit();
    this._touch();
    const value = this.inspectUint32();
    this.position += 4;
    return value;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(position) {
    const oldPosition = this.position;
    this.assertPosition(position);
    this.position = position;
    return () => this.position = oldPosition;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const count = this.getReadCount();
    this.positionReadCount.set(this.position, count + 1);
    if (count > 0)
      this.recursiveReadCount++;
  }
};
function createCursor(bytes, { recursiveReadLimit = 8192 } = {}) {
  const cursor = Object.create(staticCursor);
  cursor.bytes = bytes;
  cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  cursor.positionReadCount = /* @__PURE__ */ new Map();
  cursor.recursiveReadLimit = recursiveReadLimit;
  return cursor;
}

// ../../node_modules/viem/_esm/utils/encoding/toRlp.js
function toRlp(bytes, to = "hex") {
  const encodable = getEncodable(bytes);
  const cursor = createCursor(new Uint8Array(encodable.length));
  encodable.encode(cursor);
  if (to === "hex")
    return bytesToHex(cursor.bytes);
  return cursor.bytes;
}
function getEncodable(bytes) {
  if (Array.isArray(bytes))
    return getEncodableList(bytes.map((x) => getEncodable(x)));
  return getEncodableBytes(bytes);
}
function getEncodableList(list) {
  const bodyLength = list.reduce((acc, x) => acc + x.length, 0);
  const sizeOfBodyLength = getSizeOfLength(bodyLength);
  const length = (() => {
    if (bodyLength <= 55)
      return 1 + bodyLength;
    return 1 + sizeOfBodyLength + bodyLength;
  })();
  return {
    length,
    encode(cursor) {
      if (bodyLength <= 55) {
        cursor.pushByte(192 + bodyLength);
      } else {
        cursor.pushByte(192 + 55 + sizeOfBodyLength);
        if (sizeOfBodyLength === 1)
          cursor.pushUint8(bodyLength);
        else if (sizeOfBodyLength === 2)
          cursor.pushUint16(bodyLength);
        else if (sizeOfBodyLength === 3)
          cursor.pushUint24(bodyLength);
        else
          cursor.pushUint32(bodyLength);
      }
      for (const { encode } of list) {
        encode(cursor);
      }
    }
  };
}
function getEncodableBytes(bytesOrHex) {
  const bytes = typeof bytesOrHex === "string" ? hexToBytes(bytesOrHex) : bytesOrHex;
  const sizeOfBytesLength = getSizeOfLength(bytes.length);
  const length = (() => {
    if (bytes.length === 1 && bytes[0] < 128)
      return 1;
    if (bytes.length <= 55)
      return 1 + bytes.length;
    return 1 + sizeOfBytesLength + bytes.length;
  })();
  return {
    length,
    encode(cursor) {
      if (bytes.length === 1 && bytes[0] < 128) {
        cursor.pushBytes(bytes);
      } else if (bytes.length <= 55) {
        cursor.pushByte(128 + bytes.length);
        cursor.pushBytes(bytes);
      } else {
        cursor.pushByte(128 + 55 + sizeOfBytesLength);
        if (sizeOfBytesLength === 1)
          cursor.pushUint8(bytes.length);
        else if (sizeOfBytesLength === 2)
          cursor.pushUint16(bytes.length);
        else if (sizeOfBytesLength === 3)
          cursor.pushUint24(bytes.length);
        else
          cursor.pushUint32(bytes.length);
        cursor.pushBytes(bytes);
      }
    }
  };
}
function getSizeOfLength(length) {
  if (length < 2 ** 8)
    return 1;
  if (length < 2 ** 16)
    return 2;
  if (length < 2 ** 24)
    return 3;
  if (length < 2 ** 32)
    return 4;
  throw new BaseError("Length is too large.");
}

// ../../node_modules/viem/_esm/constants/unit.js
var gweiUnits = {
  ether: -9,
  wei: 9
};

// ../../node_modules/viem/_esm/utils/unit/formatUnits.js
function formatUnits(value, decimals) {
  let display = value.toString();
  const negative = display.startsWith("-");
  if (negative)
    display = display.slice(1);
  display = display.padStart(decimals, "0");
  let [integer, fraction] = [
    display.slice(0, display.length - decimals),
    display.slice(display.length - decimals)
  ];
  fraction = fraction.replace(/(0+)$/, "");
  return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

// ../../node_modules/viem/_esm/utils/unit/formatGwei.js
function formatGwei(wei, unit = "wei") {
  return formatUnits(wei, gweiUnits[unit]);
}

// ../../node_modules/viem/_esm/errors/transaction.js
function prettyPrint(args) {
  const entries = Object.entries(args).map(([key, value]) => {
    if (value === void 0 || value === false)
      return null;
    return [key, value];
  }).filter(Boolean);
  const maxLength = entries.reduce((acc, [key]) => Math.max(acc, key.length), 0);
  return entries.map(([key, value]) => `  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
var InvalidLegacyVError = class extends BaseError {
  constructor({ v }) {
    super(`Invalid \`v\` value "${v}". Expected 27 or 28.`, {
      name: "InvalidLegacyVError"
    });
  }
};
var InvalidSerializableTransactionError = class extends BaseError {
  constructor({ transaction }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        prettyPrint(transaction),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- an EIP-7702 Transaction with `authorizationList`, or",
        "- a Legacy Transaction with `gasPrice`"
      ],
      name: "InvalidSerializableTransactionError"
    });
  }
};
var InvalidStorageKeySizeError = class extends BaseError {
  constructor({ storageKey }) {
    super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`, { name: "InvalidStorageKeySizeError" });
  }
};

// ../../node_modules/viem/_esm/utils/blob/blobsToCommitments.js
function blobsToCommitments(parameters) {
  const { kzg } = parameters;
  const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
  const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x) => hexToBytes(x)) : parameters.blobs;
  const commitments = [];
  for (const blob of blobs)
    commitments.push(Uint8Array.from(kzg.blobToKzgCommitment(blob)));
  return to === "bytes" ? commitments : commitments.map((x) => bytesToHex(x));
}

// ../../node_modules/viem/_esm/utils/blob/blobsToProofs.js
function blobsToProofs(parameters) {
  const { kzg } = parameters;
  const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
  const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x) => hexToBytes(x)) : parameters.blobs;
  const commitments = typeof parameters.commitments[0] === "string" ? parameters.commitments.map((x) => hexToBytes(x)) : parameters.commitments;
  const proofs = [];
  for (let i = 0; i < blobs.length; i++) {
    const blob = blobs[i];
    const commitment = commitments[i];
    proofs.push(Uint8Array.from(kzg.computeBlobKzgProof(blob, commitment)));
  }
  return to === "bytes" ? proofs : proofs.map((x) => bytesToHex(x));
}

// ../../node_modules/@noble/hashes/esm/_assert.js
function anumber(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error("positive integer expected, got " + n);
}
function isBytes(a) {
  return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function abytes(b, ...lengths) {
  if (!isBytes(b))
    throw new Error("Uint8Array expected");
  if (lengths.length > 0 && !lengths.includes(b.length))
    throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
function aexists(instance, checkFinished = true) {
  if (instance.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (checkFinished && instance.finished)
    throw new Error("Hash#digest() has already been called");
}
function aoutput(out, instance) {
  abytes(out);
  const min = instance.outputLen;
  if (out.length < min) {
    throw new Error("digestInto() expects output buffer of length at least " + min);
  }
}

// ../../node_modules/@noble/hashes/esm/utils.js
function u32(arr) {
  return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function createView(arr) {
  return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function rotr(word, shift) {
  return word << 32 - shift | word >>> shift;
}
var isLE = /* @__PURE__ */ (() => new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68)();
function byteSwap(word) {
  return word << 24 & 4278190080 | word << 8 & 16711680 | word >>> 8 & 65280 | word >>> 24 & 255;
}
function byteSwap32(arr) {
  for (let i = 0; i < arr.length; i++) {
    arr[i] = byteSwap(arr[i]);
  }
}
function utf8ToBytes(str) {
  if (typeof str !== "string")
    throw new Error("utf8ToBytes expected string, got " + typeof str);
  return new Uint8Array(new TextEncoder().encode(str));
}
function toBytes2(data) {
  if (typeof data === "string")
    data = utf8ToBytes(data);
  abytes(data);
  return data;
}
var Hash = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function wrapConstructor(hashCons) {
  const hashC = (msg) => hashCons().update(toBytes2(msg)).digest();
  const tmp = hashCons();
  hashC.outputLen = tmp.outputLen;
  hashC.blockLen = tmp.blockLen;
  hashC.create = () => hashCons();
  return hashC;
}
function wrapXOFConstructorWithOpts(hashCons) {
  const hashC = (msg, opts) => hashCons(opts).update(toBytes2(msg)).digest();
  const tmp = hashCons({});
  hashC.outputLen = tmp.outputLen;
  hashC.blockLen = tmp.blockLen;
  hashC.create = (opts) => hashCons(opts);
  return hashC;
}

// ../../node_modules/@noble/hashes/esm/_md.js
function setBigUint64(view, byteOffset, value, isLE2) {
  if (typeof view.setBigUint64 === "function")
    return view.setBigUint64(byteOffset, value, isLE2);
  const _32n2 = BigInt(32);
  const _u32_max = BigInt(4294967295);
  const wh = Number(value >> _32n2 & _u32_max);
  const wl = Number(value & _u32_max);
  const h = isLE2 ? 4 : 0;
  const l = isLE2 ? 0 : 4;
  view.setUint32(byteOffset + h, wh, isLE2);
  view.setUint32(byteOffset + l, wl, isLE2);
}
function Chi(a, b, c) {
  return a & b ^ ~a & c;
}
function Maj(a, b, c) {
  return a & b ^ a & c ^ b & c;
}
var HashMD = class extends Hash {
  constructor(blockLen, outputLen, padOffset, isLE2) {
    super();
    this.blockLen = blockLen;
    this.outputLen = outputLen;
    this.padOffset = padOffset;
    this.isLE = isLE2;
    this.finished = false;
    this.length = 0;
    this.pos = 0;
    this.destroyed = false;
    this.buffer = new Uint8Array(blockLen);
    this.view = createView(this.buffer);
  }
  update(data) {
    aexists(this);
    const { view, buffer, blockLen } = this;
    data = toBytes2(data);
    const len = data.length;
    for (let pos = 0; pos < len; ) {
      const take = Math.min(blockLen - this.pos, len - pos);
      if (take === blockLen) {
        const dataView = createView(data);
        for (; blockLen <= len - pos; pos += blockLen)
          this.process(dataView, pos);
        continue;
      }
      buffer.set(data.subarray(pos, pos + take), this.pos);
      this.pos += take;
      pos += take;
      if (this.pos === blockLen) {
        this.process(view, 0);
        this.pos = 0;
      }
    }
    this.length += data.length;
    this.roundClean();
    return this;
  }
  digestInto(out) {
    aexists(this);
    aoutput(out, this);
    this.finished = true;
    const { buffer, view, blockLen, isLE: isLE2 } = this;
    let { pos } = this;
    buffer[pos++] = 128;
    this.buffer.subarray(pos).fill(0);
    if (this.padOffset > blockLen - pos) {
      this.process(view, 0);
      pos = 0;
    }
    for (let i = pos; i < blockLen; i++)
      buffer[i] = 0;
    setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE2);
    this.process(view, 0);
    const oview = createView(out);
    const len = this.outputLen;
    if (len % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const outLen = len / 4;
    const state = this.get();
    if (outLen > state.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let i = 0; i < outLen; i++)
      oview.setUint32(4 * i, state[i], isLE2);
  }
  digest() {
    const { buffer, outputLen } = this;
    this.digestInto(buffer);
    const res = buffer.slice(0, outputLen);
    this.destroy();
    return res;
  }
  _cloneInto(to) {
    to || (to = new this.constructor());
    to.set(...this.get());
    const { blockLen, buffer, length, finished, destroyed, pos } = this;
    to.length = length;
    to.pos = pos;
    to.finished = finished;
    to.destroyed = destroyed;
    if (length % blockLen)
      to.buffer.set(buffer);
    return to;
  }
};

// ../../node_modules/@noble/hashes/esm/sha256.js
var SHA256_K = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]);
var SHA256_IV = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]);
var SHA256_W = /* @__PURE__ */ new Uint32Array(64);
var SHA256 = class extends HashMD {
  constructor() {
    super(64, 32, 8, false);
    this.A = SHA256_IV[0] | 0;
    this.B = SHA256_IV[1] | 0;
    this.C = SHA256_IV[2] | 0;
    this.D = SHA256_IV[3] | 0;
    this.E = SHA256_IV[4] | 0;
    this.F = SHA256_IV[5] | 0;
    this.G = SHA256_IV[6] | 0;
    this.H = SHA256_IV[7] | 0;
  }
  get() {
    const { A, B, C, D, E, F, G, H } = this;
    return [A, B, C, D, E, F, G, H];
  }
  // prettier-ignore
  set(A, B, C, D, E, F, G, H) {
    this.A = A | 0;
    this.B = B | 0;
    this.C = C | 0;
    this.D = D | 0;
    this.E = E | 0;
    this.F = F | 0;
    this.G = G | 0;
    this.H = H | 0;
  }
  process(view, offset) {
    for (let i = 0; i < 16; i++, offset += 4)
      SHA256_W[i] = view.getUint32(offset, false);
    for (let i = 16; i < 64; i++) {
      const W15 = SHA256_W[i - 15];
      const W2 = SHA256_W[i - 2];
      const s0 = rotr(W15, 7) ^ rotr(W15, 18) ^ W15 >>> 3;
      const s1 = rotr(W2, 17) ^ rotr(W2, 19) ^ W2 >>> 10;
      SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
    }
    let { A, B, C, D, E, F, G, H } = this;
    for (let i = 0; i < 64; i++) {
      const sigma1 = rotr(E, 6) ^ rotr(E, 11) ^ rotr(E, 25);
      const T1 = H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
      const sigma0 = rotr(A, 2) ^ rotr(A, 13) ^ rotr(A, 22);
      const T2 = sigma0 + Maj(A, B, C) | 0;
      H = G;
      G = F;
      F = E;
      E = D + T1 | 0;
      D = C;
      C = B;
      B = A;
      A = T1 + T2 | 0;
    }
    A = A + this.A | 0;
    B = B + this.B | 0;
    C = C + this.C | 0;
    D = D + this.D | 0;
    E = E + this.E | 0;
    F = F + this.F | 0;
    G = G + this.G | 0;
    H = H + this.H | 0;
    this.set(A, B, C, D, E, F, G, H);
  }
  roundClean() {
    SHA256_W.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0);
    this.buffer.fill(0);
  }
};
var sha256 = /* @__PURE__ */ wrapConstructor(() => new SHA256());

// ../../node_modules/viem/_esm/utils/hash/sha256.js
function sha2562(value, to_) {
  const to = to_ || "hex";
  const bytes = sha256(isHex(value, { strict: false }) ? toBytes(value) : value);
  if (to === "bytes")
    return bytes;
  return toHex(bytes);
}

// ../../node_modules/viem/_esm/utils/blob/commitmentToVersionedHash.js
function commitmentToVersionedHash(parameters) {
  const { commitment, version: version3 = 1 } = parameters;
  const to = parameters.to ?? (typeof commitment === "string" ? "hex" : "bytes");
  const versionedHash = sha2562(commitment, "bytes");
  versionedHash.set([version3], 0);
  return to === "bytes" ? versionedHash : bytesToHex(versionedHash);
}

// ../../node_modules/viem/_esm/utils/blob/commitmentsToVersionedHashes.js
function commitmentsToVersionedHashes(parameters) {
  const { commitments, version: version3 } = parameters;
  const to = parameters.to ?? (typeof commitments[0] === "string" ? "hex" : "bytes");
  const hashes = [];
  for (const commitment of commitments) {
    hashes.push(commitmentToVersionedHash({
      commitment,
      to,
      version: version3
    }));
  }
  return hashes;
}

// ../../node_modules/viem/_esm/constants/blob.js
var blobsPerTransaction = 6;
var bytesPerFieldElement = 32;
var fieldElementsPerBlob = 4096;
var bytesPerBlob = bytesPerFieldElement * fieldElementsPerBlob;
var maxBytesPerTransaction = bytesPerBlob * blobsPerTransaction - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * fieldElementsPerBlob * blobsPerTransaction;

// ../../node_modules/viem/_esm/constants/kzg.js
var versionedHashVersionKzg = 1;

// ../../node_modules/viem/_esm/errors/blob.js
var BlobSizeTooLargeError = class extends BaseError {
  constructor({ maxSize, size: size2 }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${maxSize} bytes`, `Given: ${size2} bytes`],
      name: "BlobSizeTooLargeError"
    });
  }
};
var EmptyBlobError = class extends BaseError {
  constructor() {
    super("Blob data must not be empty.", { name: "EmptyBlobError" });
  }
};
var InvalidVersionedHashSizeError = class extends BaseError {
  constructor({ hash, size: size2 }) {
    super(`Versioned hash "${hash}" size is invalid.`, {
      metaMessages: ["Expected: 32", `Received: ${size2}`],
      name: "InvalidVersionedHashSizeError"
    });
  }
};
var InvalidVersionedHashVersionError = class extends BaseError {
  constructor({ hash, version: version3 }) {
    super(`Versioned hash "${hash}" version is invalid.`, {
      metaMessages: [
        `Expected: ${versionedHashVersionKzg}`,
        `Received: ${version3}`
      ],
      name: "InvalidVersionedHashVersionError"
    });
  }
};

// ../../node_modules/viem/_esm/utils/blob/toBlobs.js
function toBlobs(parameters) {
  const to = parameters.to ?? (typeof parameters.data === "string" ? "hex" : "bytes");
  const data = typeof parameters.data === "string" ? hexToBytes(parameters.data) : parameters.data;
  const size_ = size(data);
  if (!size_)
    throw new EmptyBlobError();
  if (size_ > maxBytesPerTransaction)
    throw new BlobSizeTooLargeError({
      maxSize: maxBytesPerTransaction,
      size: size_
    });
  const blobs = [];
  let active = true;
  let position = 0;
  while (active) {
    const blob = createCursor(new Uint8Array(bytesPerBlob));
    let size2 = 0;
    while (size2 < fieldElementsPerBlob) {
      const bytes = data.slice(position, position + (bytesPerFieldElement - 1));
      blob.pushByte(0);
      blob.pushBytes(bytes);
      if (bytes.length < 31) {
        blob.pushByte(128);
        active = false;
        break;
      }
      size2++;
      position += 31;
    }
    blobs.push(blob);
  }
  return to === "bytes" ? blobs.map((x) => x.bytes) : blobs.map((x) => bytesToHex(x.bytes));
}

// ../../node_modules/viem/_esm/utils/blob/toBlobSidecars.js
function toBlobSidecars(parameters) {
  const { data, kzg, to } = parameters;
  const blobs = parameters.blobs ?? toBlobs({ data, to });
  const commitments = parameters.commitments ?? blobsToCommitments({ blobs, kzg, to });
  const proofs = parameters.proofs ?? blobsToProofs({ blobs, commitments, kzg, to });
  const sidecars = [];
  for (let i = 0; i < blobs.length; i++)
    sidecars.push({
      blob: blobs[i],
      commitment: commitments[i],
      proof: proofs[i]
    });
  return sidecars;
}

// ../../node_modules/viem/_esm/experimental/eip7702/utils/serializeAuthorizationList.js
function serializeAuthorizationList(authorizationList) {
  if (!authorizationList || authorizationList.length === 0)
    return [];
  const serializedAuthorizationList = [];
  for (const authorization of authorizationList) {
    const { contractAddress, chainId, nonce, ...signature } = authorization;
    serializedAuthorizationList.push([
      chainId ? toHex(chainId) : "0x",
      contractAddress,
      nonce ? toHex(nonce) : "0x",
      ...toYParitySignatureArray({}, signature)
    ]);
  }
  return serializedAuthorizationList;
}

// ../../node_modules/viem/_esm/errors/address.js
var InvalidAddressError = class extends BaseError {
  constructor({ address }) {
    super(`Address "${address}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
};

// ../../node_modules/viem/_esm/errors/chain.js
var InvalidChainIdError = class extends BaseError {
  constructor({ chainId }) {
    super(typeof chainId === "number" ? `Chain ID "${chainId}" is invalid.` : "Chain ID is invalid.", { name: "InvalidChainIdError" });
  }
};

// ../../node_modules/viem/_esm/errors/node.js
var ExecutionRevertedError = class extends BaseError {
  constructor({ cause, message } = {}) {
    const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
    super(`Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`, {
      cause,
      name: "ExecutionRevertedError"
    });
  }
};
Object.defineProperty(ExecutionRevertedError, "code", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 3
});
Object.defineProperty(ExecutionRevertedError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /execution reverted/
});
var FeeCapTooHighError = class extends BaseError {
  constructor({ cause, maxFeePerGas } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause,
      name: "FeeCapTooHighError"
    });
  }
};
Object.defineProperty(FeeCapTooHighError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
var FeeCapTooLowError = class extends BaseError {
  constructor({ cause, maxFeePerGas } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause,
      name: "FeeCapTooLowError"
    });
  }
};
Object.defineProperty(FeeCapTooLowError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
var NonceTooHighError = class extends BaseError {
  constructor({ cause, nonce } = {}) {
    super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`, { cause, name: "NonceTooHighError" });
  }
};
Object.defineProperty(NonceTooHighError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /nonce too high/
});
var NonceTooLowError = class extends BaseError {
  constructor({ cause, nonce } = {}) {
    super([
      `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join("\n"), { cause, name: "NonceTooLowError" });
  }
};
Object.defineProperty(NonceTooLowError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /nonce too low|transaction already imported|already known/
});
var NonceMaxValueError = class extends BaseError {
  constructor({ cause, nonce } = {}) {
    super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`, { cause, name: "NonceMaxValueError" });
  }
};
Object.defineProperty(NonceMaxValueError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /nonce has max value/
});
var InsufficientFundsError = class extends BaseError {
  constructor({ cause } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join("\n"), {
      cause,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ],
      name: "InsufficientFundsError"
    });
  }
};
Object.defineProperty(InsufficientFundsError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /insufficient funds|exceeds transaction sender account balance/
});
var IntrinsicGasTooHighError = class extends BaseError {
  constructor({ cause, gas } = {}) {
    super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause,
      name: "IntrinsicGasTooHighError"
    });
  }
};
Object.defineProperty(IntrinsicGasTooHighError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /intrinsic gas too high|gas limit reached/
});
var IntrinsicGasTooLowError = class extends BaseError {
  constructor({ cause, gas } = {}) {
    super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`, {
      cause,
      name: "IntrinsicGasTooLowError"
    });
  }
};
Object.defineProperty(IntrinsicGasTooLowError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /intrinsic gas too low/
});
var TransactionTypeNotSupportedError = class extends BaseError {
  constructor({ cause }) {
    super("The transaction type is not supported for this chain.", {
      cause,
      name: "TransactionTypeNotSupportedError"
    });
  }
};
Object.defineProperty(TransactionTypeNotSupportedError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /transaction type not valid/
});
var TipAboveFeeCapError = class extends BaseError {
  constructor({ cause, maxPriorityFeePerGas, maxFeePerGas } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${formatGwei(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)} gwei` : ""}).`
    ].join("\n"), {
      cause,
      name: "TipAboveFeeCapError"
    });
  }
};
Object.defineProperty(TipAboveFeeCapError, "nodeMessage", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});

// ../../node_modules/viem/_esm/utils/lru.js
var LruMap = class extends Map {
  constructor(size2) {
    super();
    Object.defineProperty(this, "maxSize", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.maxSize = size2;
  }
  get(key) {
    const value = super.get(key);
    if (super.has(key) && value !== void 0) {
      this.delete(key);
      super.set(key, value);
    }
    return value;
  }
  set(key, value) {
    super.set(key, value);
    if (this.maxSize && this.size > this.maxSize) {
      const firstKey = this.keys().next().value;
      if (firstKey)
        this.delete(firstKey);
    }
    return this;
  }
};

// ../../node_modules/@noble/hashes/esm/_u64.js
var U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
var _32n = /* @__PURE__ */ BigInt(32);
function fromBig(n, le = false) {
  if (le)
    return { h: Number(n & U32_MASK64), l: Number(n >> _32n & U32_MASK64) };
  return { h: Number(n >> _32n & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
function split(lst, le = false) {
  let Ah = new Uint32Array(lst.length);
  let Al = new Uint32Array(lst.length);
  for (let i = 0; i < lst.length; i++) {
    const { h, l } = fromBig(lst[i], le);
    [Ah[i], Al[i]] = [h, l];
  }
  return [Ah, Al];
}
var rotlSH = (h, l, s) => h << s | l >>> 32 - s;
var rotlSL = (h, l, s) => l << s | h >>> 32 - s;
var rotlBH = (h, l, s) => l << s - 32 | h >>> 64 - s;
var rotlBL = (h, l, s) => h << s - 32 | l >>> 64 - s;

// ../../node_modules/@noble/hashes/esm/sha3.js
var SHA3_PI = [];
var SHA3_ROTL = [];
var _SHA3_IOTA = [];
var _0n = /* @__PURE__ */ BigInt(0);
var _1n = /* @__PURE__ */ BigInt(1);
var _2n = /* @__PURE__ */ BigInt(2);
var _7n = /* @__PURE__ */ BigInt(7);
var _256n = /* @__PURE__ */ BigInt(256);
var _0x71n = /* @__PURE__ */ BigInt(113);
for (let round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
  [x, y] = [y, (2 * x + 3 * y) % 5];
  SHA3_PI.push(2 * (5 * y + x));
  SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
  let t = _0n;
  for (let j = 0; j < 7; j++) {
    R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
    if (R & _2n)
      t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
  }
  _SHA3_IOTA.push(t);
}
var [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ split(_SHA3_IOTA, true);
var rotlH = (h, l, s) => s > 32 ? rotlBH(h, l, s) : rotlSH(h, l, s);
var rotlL = (h, l, s) => s > 32 ? rotlBL(h, l, s) : rotlSL(h, l, s);
function keccakP(s, rounds = 24) {
  const B = new Uint32Array(5 * 2);
  for (let round = 24 - rounds; round < 24; round++) {
    for (let x = 0; x < 10; x++)
      B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
    for (let x = 0; x < 10; x += 2) {
      const idx1 = (x + 8) % 10;
      const idx0 = (x + 2) % 10;
      const B0 = B[idx0];
      const B1 = B[idx0 + 1];
      const Th = rotlH(B0, B1, 1) ^ B[idx1];
      const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
      for (let y = 0; y < 50; y += 10) {
        s[x + y] ^= Th;
        s[x + y + 1] ^= Tl;
      }
    }
    let curH = s[2];
    let curL = s[3];
    for (let t = 0; t < 24; t++) {
      const shift = SHA3_ROTL[t];
      const Th = rotlH(curH, curL, shift);
      const Tl = rotlL(curH, curL, shift);
      const PI = SHA3_PI[t];
      curH = s[PI];
      curL = s[PI + 1];
      s[PI] = Th;
      s[PI + 1] = Tl;
    }
    for (let y = 0; y < 50; y += 10) {
      for (let x = 0; x < 10; x++)
        B[x] = s[y + x];
      for (let x = 0; x < 10; x++)
        s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
    }
    s[0] ^= SHA3_IOTA_H[round];
    s[1] ^= SHA3_IOTA_L[round];
  }
  B.fill(0);
}
var Keccak = class _Keccak extends Hash {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
    super();
    this.blockLen = blockLen;
    this.suffix = suffix;
    this.outputLen = outputLen;
    this.enableXOF = enableXOF;
    this.rounds = rounds;
    this.pos = 0;
    this.posOut = 0;
    this.finished = false;
    this.destroyed = false;
    anumber(outputLen);
    if (0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200);
    this.state32 = u32(this.state);
  }
  keccak() {
    if (!isLE)
      byteSwap32(this.state32);
    keccakP(this.state32, this.rounds);
    if (!isLE)
      byteSwap32(this.state32);
    this.posOut = 0;
    this.pos = 0;
  }
  update(data) {
    aexists(this);
    const { blockLen, state } = this;
    data = toBytes2(data);
    const len = data.length;
    for (let pos = 0; pos < len; ) {
      const take = Math.min(blockLen - this.pos, len - pos);
      for (let i = 0; i < take; i++)
        state[this.pos++] ^= data[pos++];
      if (this.pos === blockLen)
        this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = true;
    const { state, suffix, pos, blockLen } = this;
    state[pos] ^= suffix;
    if ((suffix & 128) !== 0 && pos === blockLen - 1)
      this.keccak();
    state[blockLen - 1] ^= 128;
    this.keccak();
  }
  writeInto(out) {
    aexists(this, false);
    abytes(out);
    this.finish();
    const bufferOut = this.state;
    const { blockLen } = this;
    for (let pos = 0, len = out.length; pos < len; ) {
      if (this.posOut >= blockLen)
        this.keccak();
      const take = Math.min(blockLen - this.posOut, len - pos);
      out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
      this.posOut += take;
      pos += take;
    }
    return out;
  }
  xofInto(out) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(out);
  }
  xof(bytes) {
    anumber(bytes);
    return this.xofInto(new Uint8Array(bytes));
  }
  digestInto(out) {
    aoutput(out, this);
    if (this.finished)
      throw new Error("digest() was already called");
    this.writeInto(out);
    this.destroy();
    return out;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = true;
    this.state.fill(0);
  }
  _cloneInto(to) {
    const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
    to || (to = new _Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
    to.state32.set(this.state32);
    to.pos = this.pos;
    to.posOut = this.posOut;
    to.finished = this.finished;
    to.rounds = rounds;
    to.suffix = suffix;
    to.outputLen = outputLen;
    to.enableXOF = enableXOF;
    to.destroyed = this.destroyed;
    return to;
  }
};
var gen = (suffix, blockLen, outputLen) => wrapConstructor(() => new Keccak(blockLen, suffix, outputLen));
var sha3_224 = /* @__PURE__ */ gen(6, 144, 224 / 8);
var sha3_256 = /* @__PURE__ */ gen(6, 136, 256 / 8);
var sha3_384 = /* @__PURE__ */ gen(6, 104, 384 / 8);
var sha3_512 = /* @__PURE__ */ gen(6, 72, 512 / 8);
var keccak_224 = /* @__PURE__ */ gen(1, 144, 224 / 8);
var keccak_256 = /* @__PURE__ */ gen(1, 136, 256 / 8);
var keccak_384 = /* @__PURE__ */ gen(1, 104, 384 / 8);
var keccak_512 = /* @__PURE__ */ gen(1, 72, 512 / 8);
var genShake = (suffix, blockLen, outputLen) => wrapXOFConstructorWithOpts((opts = {}) => new Keccak(blockLen, suffix, opts.dkLen === void 0 ? outputLen : opts.dkLen, true));
var shake128 = /* @__PURE__ */ genShake(31, 168, 128 / 8);
var shake256 = /* @__PURE__ */ genShake(31, 136, 256 / 8);

// ../../node_modules/viem/_esm/utils/hash/keccak256.js
function keccak256(value, to_) {
  const to = to_ || "hex";
  const bytes = keccak_256(isHex(value, { strict: false }) ? toBytes(value) : value);
  if (to === "bytes")
    return bytes;
  return toHex(bytes);
}

// ../../node_modules/viem/_esm/utils/address/getAddress.js
var checksumAddressCache = /* @__PURE__ */ new LruMap(8192);
function checksumAddress(address_, chainId) {
  if (checksumAddressCache.has(`${address_}.${chainId}`))
    return checksumAddressCache.get(`${address_}.${chainId}`);
  const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
  const hash = keccak256(stringToBytes(hexAddress), "bytes");
  const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
  for (let i = 0; i < 40; i += 2) {
    if (hash[i >> 1] >> 4 >= 8 && address[i]) {
      address[i] = address[i].toUpperCase();
    }
    if ((hash[i >> 1] & 15) >= 8 && address[i + 1]) {
      address[i + 1] = address[i + 1].toUpperCase();
    }
  }
  const result = `0x${address.join("")}`;
  checksumAddressCache.set(`${address_}.${chainId}`, result);
  return result;
}

// ../../node_modules/viem/_esm/utils/address/isAddress.js
var addressRegex = /^0x[a-fA-F0-9]{40}$/;
var isAddressCache = /* @__PURE__ */ new LruMap(8192);
function isAddress(address, options) {
  const { strict = true } = options ?? {};
  const cacheKey = `${address}.${strict}`;
  if (isAddressCache.has(cacheKey))
    return isAddressCache.get(cacheKey);
  const result = (() => {
    if (!addressRegex.test(address))
      return false;
    if (address.toLowerCase() === address)
      return true;
    if (strict)
      return checksumAddress(address) === address;
    return true;
  })();
  isAddressCache.set(cacheKey, result);
  return result;
}

// ../../node_modules/viem/_esm/utils/data/slice.js
function slice(value, start, end, { strict } = {}) {
  if (isHex(value, { strict: false }))
    return sliceHex(value, start, end, {
      strict
    });
  return sliceBytes(value, start, end, {
    strict
  });
}
function assertStartOffset(value, start) {
  if (typeof start === "number" && start > 0 && start > size(value) - 1)
    throw new SliceOffsetOutOfBoundsError({
      offset: start,
      position: "start",
      size: size(value)
    });
}
function assertEndOffset(value, start, end) {
  if (typeof start === "number" && typeof end === "number" && size(value) !== end - start) {
    throw new SliceOffsetOutOfBoundsError({
      offset: end,
      position: "end",
      size: size(value)
    });
  }
}
function sliceBytes(value_, start, end, { strict } = {}) {
  assertStartOffset(value_, start);
  const value = value_.slice(start, end);
  if (strict)
    assertEndOffset(value, start, end);
  return value;
}
function sliceHex(value_, start, end, { strict } = {}) {
  assertStartOffset(value_, start);
  const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
  if (strict)
    assertEndOffset(value, start, end);
  return value;
}

// ../../node_modules/viem/_esm/utils/transaction/assertTransaction.js
function assertTransactionEIP7702(transaction) {
  const { authorizationList } = transaction;
  if (authorizationList) {
    for (const authorization of authorizationList) {
      const { contractAddress, chainId } = authorization;
      if (!isAddress(contractAddress))
        throw new InvalidAddressError({ address: contractAddress });
      if (chainId < 0)
        throw new InvalidChainIdError({ chainId });
    }
  }
  assertTransactionEIP1559(transaction);
}
function assertTransactionEIP4844(transaction) {
  const { blobVersionedHashes } = transaction;
  if (blobVersionedHashes) {
    if (blobVersionedHashes.length === 0)
      throw new EmptyBlobError();
    for (const hash of blobVersionedHashes) {
      const size_ = size(hash);
      const version3 = hexToNumber(slice(hash, 0, 1));
      if (size_ !== 32)
        throw new InvalidVersionedHashSizeError({ hash, size: size_ });
      if (version3 !== versionedHashVersionKzg)
        throw new InvalidVersionedHashVersionError({
          hash,
          version: version3
        });
    }
  }
  assertTransactionEIP1559(transaction);
}
function assertTransactionEIP1559(transaction) {
  const { chainId, maxPriorityFeePerGas, maxFeePerGas, to } = transaction;
  if (chainId <= 0)
    throw new InvalidChainIdError({ chainId });
  if (to && !isAddress(to))
    throw new InvalidAddressError({ address: to });
  if (maxFeePerGas && maxFeePerGas > maxUint256)
    throw new FeeCapTooHighError({ maxFeePerGas });
  if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas)
    throw new TipAboveFeeCapError({ maxFeePerGas, maxPriorityFeePerGas });
}
function assertTransactionEIP2930(transaction) {
  const { chainId, maxPriorityFeePerGas, gasPrice, maxFeePerGas, to } = transaction;
  if (chainId <= 0)
    throw new InvalidChainIdError({ chainId });
  if (to && !isAddress(to))
    throw new InvalidAddressError({ address: to });
  if (maxPriorityFeePerGas || maxFeePerGas)
    throw new BaseError("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
  if (gasPrice && gasPrice > maxUint256)
    throw new FeeCapTooHighError({ maxFeePerGas: gasPrice });
}
function assertTransactionLegacy(transaction) {
  const { chainId, maxPriorityFeePerGas, gasPrice, maxFeePerGas, to } = transaction;
  if (to && !isAddress(to))
    throw new InvalidAddressError({ address: to });
  if (typeof chainId !== "undefined" && chainId <= 0)
    throw new InvalidChainIdError({ chainId });
  if (maxPriorityFeePerGas || maxFeePerGas)
    throw new BaseError("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
  if (gasPrice && gasPrice > maxUint256)
    throw new FeeCapTooHighError({ maxFeePerGas: gasPrice });
}

// ../../node_modules/viem/_esm/utils/transaction/getTransactionType.js
function getTransactionType(transaction) {
  if (transaction.type)
    return transaction.type;
  if (typeof transaction.authorizationList !== "undefined")
    return "eip7702";
  if (typeof transaction.blobs !== "undefined" || typeof transaction.blobVersionedHashes !== "undefined" || typeof transaction.maxFeePerBlobGas !== "undefined" || typeof transaction.sidecars !== "undefined")
    return "eip4844";
  if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") {
    return "eip1559";
  }
  if (typeof transaction.gasPrice !== "undefined") {
    if (typeof transaction.accessList !== "undefined")
      return "eip2930";
    return "legacy";
  }
  throw new InvalidSerializableTransactionError({ transaction });
}

// ../../node_modules/viem/_esm/utils/transaction/serializeAccessList.js
function serializeAccessList(accessList) {
  if (!accessList || accessList.length === 0)
    return [];
  const serializedAccessList = [];
  for (let i = 0; i < accessList.length; i++) {
    const { address, storageKeys } = accessList[i];
    for (let j = 0; j < storageKeys.length; j++) {
      if (storageKeys[j].length - 2 !== 64) {
        throw new InvalidStorageKeySizeError({ storageKey: storageKeys[j] });
      }
    }
    if (!isAddress(address, { strict: false })) {
      throw new InvalidAddressError({ address });
    }
    serializedAccessList.push([address, storageKeys]);
  }
  return serializedAccessList;
}

// ../../node_modules/viem/_esm/utils/transaction/serializeTransaction.js
function serializeTransaction(transaction, signature) {
  const type = getTransactionType(transaction);
  if (type === "eip1559")
    return serializeTransactionEIP1559(transaction, signature);
  if (type === "eip2930")
    return serializeTransactionEIP2930(transaction, signature);
  if (type === "eip4844")
    return serializeTransactionEIP4844(transaction, signature);
  if (type === "eip7702")
    return serializeTransactionEIP7702(transaction, signature);
  return serializeTransactionLegacy(transaction, signature);
}
function serializeTransactionEIP7702(transaction, signature) {
  const { authorizationList, chainId, gas, nonce, to, value, maxFeePerGas, maxPriorityFeePerGas, accessList, data } = transaction;
  assertTransactionEIP7702(transaction);
  const serializedAccessList = serializeAccessList(accessList);
  const serializedAuthorizationList = serializeAuthorizationList(authorizationList);
  return concatHex([
    "0x04",
    toRlp([
      toHex(chainId),
      nonce ? toHex(nonce) : "0x",
      maxPriorityFeePerGas ? toHex(maxPriorityFeePerGas) : "0x",
      maxFeePerGas ? toHex(maxFeePerGas) : "0x",
      gas ? toHex(gas) : "0x",
      to ?? "0x",
      value ? toHex(value) : "0x",
      data ?? "0x",
      serializedAccessList,
      serializedAuthorizationList,
      ...toYParitySignatureArray(transaction, signature)
    ])
  ]);
}
function serializeTransactionEIP4844(transaction, signature) {
  const { chainId, gas, nonce, to, value, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, accessList, data } = transaction;
  assertTransactionEIP4844(transaction);
  let blobVersionedHashes = transaction.blobVersionedHashes;
  let sidecars = transaction.sidecars;
  if (transaction.blobs && (typeof blobVersionedHashes === "undefined" || typeof sidecars === "undefined")) {
    const blobs2 = typeof transaction.blobs[0] === "string" ? transaction.blobs : transaction.blobs.map((x) => bytesToHex(x));
    const kzg = transaction.kzg;
    const commitments2 = blobsToCommitments({
      blobs: blobs2,
      kzg
    });
    if (typeof blobVersionedHashes === "undefined")
      blobVersionedHashes = commitmentsToVersionedHashes({
        commitments: commitments2
      });
    if (typeof sidecars === "undefined") {
      const proofs2 = blobsToProofs({ blobs: blobs2, commitments: commitments2, kzg });
      sidecars = toBlobSidecars({ blobs: blobs2, commitments: commitments2, proofs: proofs2 });
    }
  }
  const serializedAccessList = serializeAccessList(accessList);
  const serializedTransaction = [
    toHex(chainId),
    nonce ? toHex(nonce) : "0x",
    maxPriorityFeePerGas ? toHex(maxPriorityFeePerGas) : "0x",
    maxFeePerGas ? toHex(maxFeePerGas) : "0x",
    gas ? toHex(gas) : "0x",
    to ?? "0x",
    value ? toHex(value) : "0x",
    data ?? "0x",
    serializedAccessList,
    maxFeePerBlobGas ? toHex(maxFeePerBlobGas) : "0x",
    blobVersionedHashes ?? [],
    ...toYParitySignatureArray(transaction, signature)
  ];
  const blobs = [];
  const commitments = [];
  const proofs = [];
  if (sidecars)
    for (let i = 0; i < sidecars.length; i++) {
      const { blob, commitment, proof } = sidecars[i];
      blobs.push(blob);
      commitments.push(commitment);
      proofs.push(proof);
    }
  return concatHex([
    "0x03",
    sidecars ? (
      // If sidecars are enabled, envelope turns into a "wrapper":
      toRlp([serializedTransaction, blobs, commitments, proofs])
    ) : (
      // If sidecars are disabled, standard envelope is used:
      toRlp(serializedTransaction)
    )
  ]);
}
function serializeTransactionEIP1559(transaction, signature) {
  const { chainId, gas, nonce, to, value, maxFeePerGas, maxPriorityFeePerGas, accessList, data } = transaction;
  assertTransactionEIP1559(transaction);
  const serializedAccessList = serializeAccessList(accessList);
  const serializedTransaction = [
    toHex(chainId),
    nonce ? toHex(nonce) : "0x",
    maxPriorityFeePerGas ? toHex(maxPriorityFeePerGas) : "0x",
    maxFeePerGas ? toHex(maxFeePerGas) : "0x",
    gas ? toHex(gas) : "0x",
    to ?? "0x",
    value ? toHex(value) : "0x",
    data ?? "0x",
    serializedAccessList,
    ...toYParitySignatureArray(transaction, signature)
  ];
  return concatHex([
    "0x02",
    toRlp(serializedTransaction)
  ]);
}
function serializeTransactionEIP2930(transaction, signature) {
  const { chainId, gas, data, nonce, to, value, accessList, gasPrice } = transaction;
  assertTransactionEIP2930(transaction);
  const serializedAccessList = serializeAccessList(accessList);
  const serializedTransaction = [
    toHex(chainId),
    nonce ? toHex(nonce) : "0x",
    gasPrice ? toHex(gasPrice) : "0x",
    gas ? toHex(gas) : "0x",
    to ?? "0x",
    value ? toHex(value) : "0x",
    data ?? "0x",
    serializedAccessList,
    ...toYParitySignatureArray(transaction, signature)
  ];
  return concatHex([
    "0x01",
    toRlp(serializedTransaction)
  ]);
}
function serializeTransactionLegacy(transaction, signature) {
  const { chainId = 0, gas, data, nonce, to, value, gasPrice } = transaction;
  assertTransactionLegacy(transaction);
  let serializedTransaction = [
    nonce ? toHex(nonce) : "0x",
    gasPrice ? toHex(gasPrice) : "0x",
    gas ? toHex(gas) : "0x",
    to ?? "0x",
    value ? toHex(value) : "0x",
    data ?? "0x"
  ];
  if (signature) {
    const v = (() => {
      if (signature.v >= 35n) {
        const inferredChainId = (signature.v - 35n) / 2n;
        if (inferredChainId > 0)
          return signature.v;
        return 27n + (signature.v === 35n ? 0n : 1n);
      }
      if (chainId > 0)
        return BigInt(chainId * 2) + BigInt(35n + signature.v - 27n);
      const v2 = 27n + (signature.v === 27n ? 0n : 1n);
      if (signature.v !== v2)
        throw new InvalidLegacyVError({ v: signature.v });
      return v2;
    })();
    const r = trim(signature.r);
    const s = trim(signature.s);
    serializedTransaction = [
      ...serializedTransaction,
      toHex(v),
      r === "0x00" ? "0x" : r,
      s === "0x00" ? "0x" : s
    ];
  } else if (chainId > 0) {
    serializedTransaction = [
      ...serializedTransaction,
      toHex(chainId),
      "0x",
      "0x"
    ];
  }
  return toRlp(serializedTransaction);
}
function toYParitySignatureArray(transaction, signature_) {
  const signature = signature_ ?? transaction;
  const { v, yParity } = signature;
  if (typeof signature.r === "undefined")
    return [];
  if (typeof signature.s === "undefined")
    return [];
  if (typeof v === "undefined" && typeof yParity === "undefined")
    return [];
  const r = trim(signature.r);
  const s = trim(signature.s);
  const yParity_ = (() => {
    if (typeof yParity === "number")
      return yParity ? toHex(1) : "0x";
    if (v === 0n)
      return "0x";
    if (v === 1n)
      return toHex(1);
    return v === 27n ? "0x" : toHex(1);
  })();
  return [yParity_, r === "0x00" ? "0x" : r, s === "0x00" ? "0x" : s];
}

// ../../node_modules/viem/_esm/op-stack/contracts.js
var contracts = {
  gasPriceOracle: { address: "0x420000000000000000000000000000000000000F" },
  l1Block: { address: "0x4200000000000000000000000000000000000015" },
  l2CrossDomainMessenger: {
    address: "0x4200000000000000000000000000000000000007"
  },
  l2Erc721Bridge: { address: "0x4200000000000000000000000000000000000014" },
  l2StandardBridge: { address: "0x4200000000000000000000000000000000000010" },
  l2ToL1MessagePasser: {
    address: "0x4200000000000000000000000000000000000016"
  }
};

// ../../node_modules/viem/_esm/op-stack/formatters.js
var formatters = {
  block: /* @__PURE__ */ defineBlock({
    format(args) {
      const transactions = args.transactions?.map((transaction) => {
        if (typeof transaction === "string")
          return transaction;
        const formatted = formatTransaction(transaction);
        if (formatted.typeHex === "0x7e") {
          formatted.isSystemTx = transaction.isSystemTx;
          formatted.mint = transaction.mint ? hexToBigInt(transaction.mint) : void 0;
          formatted.sourceHash = transaction.sourceHash;
          formatted.type = "deposit";
        }
        return formatted;
      });
      return {
        transactions,
        stateRoot: args.stateRoot
      };
    }
  }),
  transaction: /* @__PURE__ */ defineTransaction({
    format(args) {
      const transaction = {};
      if (args.type === "0x7e") {
        transaction.isSystemTx = args.isSystemTx;
        transaction.mint = args.mint ? hexToBigInt(args.mint) : void 0;
        transaction.sourceHash = args.sourceHash;
        transaction.type = "deposit";
      }
      return transaction;
    }
  }),
  transactionReceipt: /* @__PURE__ */ defineTransactionReceipt({
    format(args) {
      return {
        l1GasPrice: args.l1GasPrice ? hexToBigInt(args.l1GasPrice) : null,
        l1GasUsed: args.l1GasUsed ? hexToBigInt(args.l1GasUsed) : null,
        l1Fee: args.l1Fee ? hexToBigInt(args.l1Fee) : null,
        l1FeeScalar: args.l1FeeScalar ? Number(args.l1FeeScalar) : null
      };
    }
  })
};

// ../../node_modules/viem/_esm/op-stack/serializers.js
function serializeTransaction2(transaction, signature) {
  if (isDeposit(transaction))
    return serializeTransactionDeposit(transaction);
  return serializeTransaction(transaction, signature);
}
var serializers = {
  transaction: serializeTransaction2
};
function serializeTransactionDeposit(transaction) {
  assertTransactionDeposit(transaction);
  const { sourceHash, data, from, gas, isSystemTx, mint, to, value } = transaction;
  const serializedTransaction = [
    sourceHash,
    from,
    to ?? "0x",
    mint ? toHex(mint) : "0x",
    value ? toHex(value) : "0x",
    gas ? toHex(gas) : "0x",
    isSystemTx ? "0x1" : "0x",
    data ?? "0x"
  ];
  return concatHex([
    "0x7e",
    toRlp(serializedTransaction)
  ]);
}
function isDeposit(transaction) {
  if (transaction.type === "deposit")
    return true;
  if (typeof transaction.sourceHash !== "undefined")
    return true;
  return false;
}
function assertTransactionDeposit(transaction) {
  const { from, to } = transaction;
  if (from && !isAddress(from))
    throw new InvalidAddressError({ address: from });
  if (to && !isAddress(to))
    throw new InvalidAddressError({ address: to });
}

// ../../node_modules/viem/_esm/op-stack/chainConfig.js
var chainConfig = {
  contracts,
  formatters,
  serializers
};

// ../../node_modules/viem/_esm/chains/definitions/arbitrum.js
var arbitrum = /* @__PURE__ */ defineChain({
  id: 42161,
  name: "Arbitrum One",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://arb1.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://arbiscan.io",
      apiUrl: "https://api.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7654707
    }
  }
});

// ../../node_modules/viem/_esm/chains/definitions/arbitrumSepolia.js
var arbitrumSepolia = /* @__PURE__ */ defineChain({
  id: 421614,
  name: "Arbitrum Sepolia",
  nativeCurrency: {
    name: "Arbitrum Sepolia Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rollup.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://sepolia.arbiscan.io",
      apiUrl: "https://api-sepolia.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 81930
    }
  },
  testnet: true
});

// ../../node_modules/viem/_esm/chains/definitions/base.js
var sourceId = 1;
var base = /* @__PURE__ */ defineChain({
  ...chainConfig,
  id: 8453,
  name: "Base",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://basescan.org",
      apiUrl: "https://api.basescan.org/api"
    }
  },
  contracts: {
    ...chainConfig.contracts,
    disputeGameFactory: {
      [sourceId]: {
        address: "0x43edB88C4B80fDD2AdFF2412A7BebF9dF42cB40e"
      }
    },
    l2OutputOracle: {
      [sourceId]: {
        address: "0x56315b90c40730925ec5485cf004d835058518A0"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 5022
    },
    portal: {
      [sourceId]: {
        address: "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e",
        blockCreated: 17482143
      }
    },
    l1StandardBridge: {
      [sourceId]: {
        address: "0x3154Cf16ccdb4C6d922629664174b904d80F2C35",
        blockCreated: 17482143
      }
    }
  },
  sourceId
});

// ../../node_modules/viem/_esm/chains/definitions/baseSepolia.js
var sourceId2 = 11155111;
var baseSepolia = /* @__PURE__ */ defineChain({
  ...chainConfig,
  id: 84532,
  network: "base-sepolia",
  name: "Base Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://sepolia.basescan.org",
      apiUrl: "https://api-sepolia.basescan.org/api"
    }
  },
  contracts: {
    ...chainConfig.contracts,
    disputeGameFactory: {
      [sourceId2]: {
        address: "0xd6E6dBf4F7EA0ac412fD8b65ED297e64BB7a06E1"
      }
    },
    l2OutputOracle: {
      [sourceId2]: {
        address: "0x84457ca9D0163FbC4bbfe4Dfbb20ba46e48DF254"
      }
    },
    portal: {
      [sourceId2]: {
        address: "0x49f53e41452c74589e85ca1677426ba426459e85",
        blockCreated: 4446677
      }
    },
    l1StandardBridge: {
      [sourceId2]: {
        address: "0xfd0Bf71F60660E2f608ed56e1659C450eB113120",
        blockCreated: 4446677
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1059647
    }
  },
  testnet: true,
  sourceId: sourceId2
});

// ../../node_modules/viem/_esm/chains/definitions/blast.js
var sourceId3 = 1;
var blast = /* @__PURE__ */ defineChain({
  ...chainConfig,
  id: 81457,
  name: "Blast",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc.blast.io"] }
  },
  blockExplorers: {
    default: {
      name: "Blastscan",
      url: "https://blastscan.io",
      apiUrl: "https://api.blastscan.io/api"
    }
  },
  contracts: {
    ...chainConfig.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 212929
    }
  },
  sourceId: sourceId3
});

// ../../node_modules/viem/_esm/chains/definitions/blastSepolia.js
var sourceId4 = 11155111;
var blastSepolia = /* @__PURE__ */ defineChain({
  id: 168587773,
  name: "Blast Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.blast.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blastscan",
      url: "https://sepolia.blastscan.io",
      apiUrl: "https://api-sepolia.blastscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 756690
    }
  },
  testnet: true,
  sourceId: sourceId4
});

// ../../node_modules/viem/_esm/chains/definitions/mainnet.js
var mainnet = /* @__PURE__ */ defineChain({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://eth.merkle.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
});

// ../../node_modules/viem/_esm/chains/definitions/mantle.js
var mantle = /* @__PURE__ */ defineChain({
  id: 5e3,
  name: "Mantle",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    default: { http: ["https://rpc.mantle.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "Mantle Explorer",
      url: "https://mantlescan.xyz/",
      apiUrl: "https://api.mantlescan.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 304717
    }
  }
});

// ../../node_modules/viem/_esm/chains/definitions/mantleTestnet.js
var mantleTestnet = /* @__PURE__ */ defineChain({
  id: 5001,
  name: "Mantle Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.mantle.xyz"] }
  },
  blockExplorers: {
    default: {
      name: "Mantle Testnet Explorer",
      url: "https://explorer.testnet.mantle.xyz",
      apiUrl: "https://explorer.testnet.mantle.xyz/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 561333
    }
  },
  testnet: true
});

// ../../node_modules/viem/_esm/chains/definitions/mode.js
var sourceId5 = 1;
var mode = /* @__PURE__ */ defineChain({
  ...chainConfig,
  id: 34443,
  name: "Mode Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.mode.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Modescan",
      url: "https://modescan.io"
    }
  },
  contracts: {
    ...chainConfig.contracts,
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 2465882
    },
    l2OutputOracle: {
      [sourceId5]: {
        address: "0x4317ba146D4933D889518a3e5E11Fe7a53199b04"
      }
    },
    portal: {
      [sourceId5]: {
        address: "0x8B34b14c7c7123459Cf3076b8Cb929BE097d0C07"
      }
    },
    l1StandardBridge: {
      [sourceId5]: {
        address: "0x735aDBbE72226BD52e818E7181953f42E3b0FF21"
      }
    }
  },
  sourceId: sourceId5
});

// ../../node_modules/viem/_esm/chains/definitions/modeTestnet.js
var sourceId6 = 11155111;
var modeTestnet = /* @__PURE__ */ defineChain({
  ...chainConfig,
  id: 919,
  name: "Mode Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.mode.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://sepolia.explorer.mode.network",
      apiUrl: "https://sepolia.explorer.mode.network/api"
    }
  },
  contracts: {
    ...chainConfig.contracts,
    l2OutputOracle: {
      [sourceId6]: {
        address: "0x2634BD65ba27AB63811c74A63118ACb312701Bfa",
        blockCreated: 3778393
      }
    },
    portal: {
      [sourceId6]: {
        address: "0x320e1580effF37E008F1C92700d1eBa47c1B23fD",
        blockCreated: 3778395
      }
    },
    l1StandardBridge: {
      [sourceId6]: {
        address: "0xbC5C679879B2965296756CD959C3C739769995E2",
        blockCreated: 3778392
      }
    },
    multicall3: {
      address: "0xBAba8373113Fb7a68f195deF18732e01aF8eDfCF",
      blockCreated: 3019007
    }
  },
  testnet: true,
  sourceId: sourceId6
});

// ../../node_modules/viem/_esm/chains/definitions/sepolia.js
var sepolia = /* @__PURE__ */ defineChain({
  id: 11155111,
  name: "Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.drpc.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io",
      apiUrl: "https://api-sepolia.etherscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 751532
    },
    ensRegistry: { address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e" },
    ensUniversalResolver: {
      address: "0xc8Af999e38273D658BE1b921b88A9Ddf005769cC",
      blockCreated: 5317080
    }
  },
  testnet: true
});

// src/tokens/common.ts
var imageRoot = "https://storage.bondprotocol.finance/6e41a561-e275-4698-bc36-548d30a80e96-bucket";
var dai = {
  name: "DAI",
  symbol: "DAI",
  logoURI: `${imageRoot}/DAI.png`,
  decimals: 18
};
var lusd = {
  name: "Liquity USD",
  symbol: "LUSD",
  logoURI: `${imageRoot}/LUSD.png`,
  decimals: 18
};
var usdc = {
  name: "USD Coin",
  symbol: "USDC",
  logoURI: `${imageRoot}/USDC.png`,
  decimals: 6
};
var usdt = {
  name: "Tether USD",
  symbol: "USDT",
  logoURI: `${imageRoot}/USDT.png`,
  decimals: 6
};
var weth = {
  name: "Wrapped Ethereum",
  symbol: "WETH",
  logoURI: `${imageRoot}/WETH.png`,
  decimals: 18
};
var wbtc = {
  name: "Wrapped Bitcoin",
  symbol: "WBTC",
  logoURI: `${imageRoot}/WBTC.png`,
  decimals: 8
};

// src/axis-core/.blast-sepolia.json
var blast_sepolia_default = {
  "deployments.BatchAuctionHouse": "0xBA0000C3153dc5b7B266b0ac37B1d640ba40c445",
  "deployments.BatchCatalogue": "0x26e5Fd9ea25a5719D4EbA3b1966dd4864c48e517",
  "deployments.auctionModules.EncryptedMarginalPrice": "0x1043ef1f242e3FC5E90fd67Bb5a1B1356b102b39",
  "deployments.auctionModules.FixedPriceBatch": "0xf1E5FA9008fC3a62D90c7e569E02D98315C19DC3",
  "deployments.derivativeModules.BatchLinearVesting": "0x9011aC431f91Fd92437cBfdAE30a4ee4b76fEE1F"
};

// src/axis-periphery/.blast-sepolia.json
var blast_sepolia_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x98Fa90B451171389a2132191a95a0d4109C16B36"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x98bd3C7ddF2510553A858e3Fb636299BDD61992b"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x983df377a8c64F26f947312374e6859ebc00dA81"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x98e37312E0Bdb9012Eb1F6b70fe5b1cB82AC07dc"
  ],
  "deployments.callbacks.BatchUniswapV2DirectToLiquidity": [
    "0xE6BFCC5C3f3e71b5A7a9F4c0C8952f084d649850"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidity": [
    "0xE6531D363c29A453c2589D9CDEFcC02773f8ee95"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [],
  "deployments.callbacks.Baseline": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [
    "0xEF7CDf8963d32413a6bB0d023dBAE50347ae4567"
  ],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/chains/helpers.ts
function extractAddresses(addresses) {
  return {
    addresses: {
      batchAuctionHouse: addresses["deployments.BatchAuctionHouse"],
      batchCatalogue: addresses["deployments.BatchCatalogue"],
      encryptedMarginalPrice: addresses["deployments.auctionModules.EncryptedMarginalPrice"],
      fixedPriceBatch: addresses["deployments.auctionModules.FixedPriceBatch"],
      batchLinearVesting: addresses["deployments.derivativeModules.BatchLinearVesting"]
    }
  };
}
function extractCallbacks(addresses) {
  return {
    callbacks: {
      cappedMerkleAllowlist: addresses["deployments.callbacks.BatchMerkleAllowlist"],
      merkleAllowlist: addresses["deployments.callbacks.BatchMerkleAllowlist"],
      tokenAllowlist: addresses["deployments.callbacks.BatchTokenAllowlist"],
      allocatedMerkleAllowlist: addresses["deployments.callbacks.BatchAllocatedMerkleAllowlist"],
      uniV2Dtl: addresses["deployments.callbacks.BatchUniswapV2DirectToLiquidity"],
      uniV3Dtl: addresses["deployments.callbacks.BatchUniswapV3DirectToLiquidity"],
      baseline: addresses["deployments.callbacks.Baseline"],
      baselineAllowlist: addresses["deployments.callbacks.BaselineAllowlist"],
      baselineAllocatedAllowlist: addresses["deployments.callbacks.BaselineAllocatedAllowlist"],
      baselineCappedAllowlist: addresses["deployments.callbacks.BaselineCappedAllowlist"],
      baselineTokenAllowlist: addresses["deployments.callbacks.BaselineTokenAllowlist"],
      uniswapV3DtlWithAllocatedMerkleAllowlist: addresses["deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist"]
    }
  };
}

// src/chains/testnet/blast-sepolia.ts
var config = {
  name: "blast-sepolia",
  chain: blastSepolia,
  chainIconUrl: "/blast-logo.png",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-blast-sepolia/version/v<VERSION>/api",
  rpcURL: "https://blast-sepolia.g.alchemy.com/v2/h6OEviwRZGmTSXHYPRmMquo5u-YoWLeY",
  wrapperContract: "0x4200000000000000000000000000000000000023",
  tokenList: [
    {
      mintable: true,
      decimals: 18,
      symbol: "USDB",
      name: "Blast USD",
      address: "0x47F12ccE28D1A2ac9184777fa8a993C6067Df728",
      logoURI: "https://assets-global.website-files.com/65a6baa1a3f8ed336f415cb4/65c67eafd3569b7e2f834b8d_usdb-icon-yellow.svg"
    },
    {
      ...weth,
      mintable: true,
      decimals: 18,
      address: "0x1095e2650accccc10daaac305b380f23158f1d94"
    },
    {
      decimals: 18,
      symbol: "SLO",
      name: "SLO Token",
      address: "0xB24D0b6ae015DC6fd279E330db101bB890d8060c"
    }
  ],
  ...extractAddresses(blast_sepolia_default),
  ...extractCallbacks(blast_sepolia_default2)
};
var blast_sepolia_default3 = config;

// src/axis-core/.arbitrum-sepolia.json
var arbitrum_sepolia_default = {
  "deployments.BatchAuctionHouse": "0xBA0000c28179CE533233a943d432eddD154E62A3",
  "deployments.BatchCatalogue": "0xBC1a6e1327c0CdA84Bc6feC65f99cdfCA976DD97",
  "deployments.auctionModules.EncryptedMarginalPrice": "0x9099dd8Db39B8aD5D31d9865F013F1d2278c3506",
  "deployments.auctionModules.FixedPriceBatch": "0xAF4AaFC046FB329EB1181c0094a95DA7Cee38211",
  "deployments.derivativeModules.BatchLinearVesting": "0x14726B9D69d4Fb957e4F3C736bda029Fd96e1FFb"
};

// src/axis-periphery/.arbitrum-sepolia.json
var arbitrum_sepolia_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x9859AcCA8a9afEbb9b3986036d4E0efc0246cEeA"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x98d64E00D9d6550913E73C940Ff476Cf1723d834"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x9801e45362a2bb7C9F22486CC3F5cA9224e9CC55"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x98C8ffFf24bcfC3A5B0b463c43F10932Cedb7B8F"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/chains/testnet/arbitrum-sepolia.ts
var config2 = {
  name: "arbitrum-sepolia",
  chain: arbitrumSepolia,
  chainIconUrl: "/arbitrum-logo.png",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-arbitrum-sepolia/version/v<VERSION>/api",
  rpcURL: "https://arb-sepolia.g.alchemy.com/v2/ijPbOvV9qNWHPGz-x-7JRvPwzUdBn1TJ",
  wrapperContract: "0x2836ae2eA2c013acD38028fD0C77B92cccFa2EE4",
  //WETH9
  tokenList: [
    {
      ...usdc,
      address: "0x4f3cf5d09a3e47bf9d6a9d295e4a643c79c43429",
      decimals: 18,
      mintable: true
    },
    {
      ...weth,
      address: "0x67dac8d7aeacc88c512f089a0abfff17e714535e",
      decimals: 18,
      mintable: true
    },
    {
      name: "TEST",
      symbol: "TST",
      address: "0x536f26fbbf0c6aedf9aaa04033d148efd1a24281",
      decimals: 18,
      mintable: true
    }
  ],
  ...extractAddresses(arbitrum_sepolia_default),
  ...extractCallbacks(arbitrum_sepolia_default2)
};
var arbitrum_sepolia_default3 = config2;

// src/axis-core/.mode-sepolia.json
var mode_sepolia_default = {
  "deployments.BatchAuctionHouse": "0xBA0000c28179CE533233a943d432eddD154E62A3",
  "deployments.BatchCatalogue": "0x2eF571199c0BA4923FCf18cB802e302C0aF544Ef",
  "deployments.auctionModules.EncryptedMarginalPrice": "0xD6F9425776eE91b7181a16256768fAB9aB8B20a4",
  "deployments.auctionModules.FixedPriceBatch": "0x8e5a555bcaB474C91dcA326bE3DFdDa7e30c3765",
  "deployments.derivativeModules.BatchLinearVesting": "0xE8546C3f5d5dB707081ffAfDB5416d808758D120"
};

// src/axis-periphery/.mode-sepolia.json
var mode_sepolia_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x98a0826b19B412a159cedb38Bd38899930382972"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x98E56d6466fC7B2c88acb39e9e4C6E7671e28CBd"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x98a16dF00DB1ea2bC4Cb05E8e2c06d43F56f8e62"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x98b7402E399ff864a3277bd4c3e01Df8ef0234e8"
  ],
  "deployments.callbacks.BatchUniswapV2DirectToLiquidity": [
    "0xE60c0BFa8DE1250eFDF46d80F98AE5eAe947e5E2"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidity": [
    "0xE68d298ef59B3ddFc82d12aFC9B8Db67ac068266"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [],
  "deployments.callbacks.Baseline": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/chains/testnet/mode-testnet.ts
var config3 = {
  name: "mode-testnet",
  chain: modeTestnet,
  chainIconUrl: "/mode-logo.svg",
  subgraphURL: "https://api.goldsky.com/api/public/project_clu16lu24lqh201x9f0qh135t/subgraphs/axis-origin-mode-testnet/<VERSION>/gn",
  rpcURL: "https://sepolia.mode.network",
  tokenList: [
    {
      ...usdc,
      address: "0xfc3156a0a9295dcd83b8f405bae7a4b73f4e2306",
      decimals: 18,
      mintable: true
    },
    {
      ...weth,
      address: "0xfdf5fe07a9c888f383aea34f152dee04baee7a2e",
      decimals: 18,
      mintable: true
    }
  ],
  ...extractAddresses(mode_sepolia_default),
  ...extractCallbacks(mode_sepolia_default2)
};
var mode_testnet_default = config3;

// src/axis-core/.base-sepolia.json
var base_sepolia_default = {
  "deployments.BatchAuctionHouse": "0xBA0000c28179CE533233a943d432eddD154E62A3",
  "deployments.BatchCatalogue": "0x97145edD2F06ADF1d91CB9Aa5eb52D842a3f5c54",
  "deployments.auctionModules.EncryptedMarginalPrice": "0xf0a4d1f805312438ea146E5df873bD8d64D9dBe4",
  "deployments.auctionModules.FixedPriceBatch": "0x1A6Ba70B8e5957bCd03C20f9CF42D9e6D3d9b514",
  "deployments.derivativeModules.BatchLinearVesting": "0x909F26919989167d051312fBB0a1Df4CD93Bf70b"
};

// src/axis-periphery/.base-sepolia.json
var base_sepolia_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x9859AcCA8a9afEbb9b3986036d4E0efc0246cEeA"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x98d64E00D9d6550913E73C940Ff476Cf1723d834"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x9801e45362a2bb7C9F22486CC3F5cA9224e9CC55"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x98C8ffFf24bcfC3A5B0b463c43F10932Cedb7B8F"
  ],
  "deployments.callbacks.BatchUniswapV2DirectToLiquidity": [
    "0xE6546c03B1b9DFC4238f0A2923FdefD5E4af7659"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidity": [
    "0xE68b21C071534781BC4c40E6BF1bCFC23638fF4B"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [
    "0xEE4d06C1c96Ae19D1D77ac279881a639307E97E2"
  ],
  "deployments.callbacks.Baseline": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/axis-utils/.base-sepolia.json
var base_sepolia_default3 = {
  "deployments.utils.registry": ["0xc94404218178149ebebfc1f47f0df14b5fd881c5"]
};

// src/chains/testnet/base-sepolia.ts
var config4 = {
  name: "base-sepolia",
  chain: baseSepolia,
  chainIconUrl: "/base-logo.png",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-base-sepolia/version/v<VERSION>/api",
  rpcURL: "https://base-sepolia.g.alchemy.com/v2/h6OEviwRZGmTSXHYPRmMquo5u-YoWLeY",
  wrapperContract: "0x4200000000000000000000000000000000000006",
  //WETH9
  tokenList: [
    {
      ...usdc,
      address: "0x4c9d75fbdf764d05df654340a48f85bc0216f8ab",
      decimals: 18,
      mintable: true
    },
    {
      ...weth,
      address: "0x5384c9408f65978b4318a95b70af383ca06f1cf0",
      mintable: true
    }
  ],
  ...extractAddresses(base_sepolia_default),
  ...extractCallbacks(base_sepolia_default2),
  registry: base_sepolia_default3["deployments.utils.registry"][0]
};
var base_sepolia_default4 = config4;

// src/axis-core/.mantle-sepolia.json
var mantle_sepolia_default = {
  "deployments.BatchAuctionHouse": "0xBA0000c28179CE533233a943d432eddD154E62A3",
  "deployments.BatchCatalogue": "0xB1e9E16a40321Fe06Cfd797619C345c143D11Aa7",
  "deployments.auctionModules.EncryptedMarginalPrice": "0x04974BcFC715c148818724d9Caab3Fe8d0391b8b",
  "deployments.auctionModules.FixedPriceBatch": "0xacD10C2B4aA625dd00cba40E4466c8Ff07288a16",
  "deployments.derivativeModules.BatchLinearVesting": "0x6CC5b76C2c98cB347F07C07a74a88134265312FF"
};

// src/axis-periphery/.mantle-sepolia.json
var mantle_sepolia_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x98a0826b19B412a159cedb38Bd38899930382972"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x98E56d6466fC7B2c88acb39e9e4C6E7671e28CBd"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x98a16dF00DB1ea2bC4Cb05E8e2c06d43F56f8e62"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x98b7402E399ff864a3277bd4c3e01Df8ef0234e8"
  ],
  "deployments.callbacks.BatchUniswapV2DirectToLiquidity": [
    "0xE60a178a2f5e86BF77fB1D6814Ed47790B0993f0"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidity": [
    "0xE6bF04764268B46ddE10e9e8a13c3E7fF0a181d6"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [],
  "deployments.callbacks.Baseline": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/chains/testnet/mantle-sepolia.ts
var config5 = {
  name: "mantle-sepolia-testnet",
  chain: mantleTestnet,
  chainIconUrl: "/mantle-logo.svg",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-mantle-sepolia/version/v<VERSION>/api",
  rpcURL: "https://rpc.sepolia.mantle.xyz",
  tokenList: [
    {
      ...usdc,
      address: "0x831b513392cd10d7720380f877383ee8ed543f0f",
      decimals: 18,
      mintable: true
    },
    {
      ...weth,
      address: "0xc83696ec858e370fb9e109ce141c4c86cb705a73",
      mintable: true
    },
    {
      symbol: "WMNT",
      name: "Wrapped Mantle",
      address: "0x4a7d9a72c29c6f1e74ce6a972c5cad1b1b00dff9",
      decimals: 18,
      logoURI: "https://storage.bondprotocol.finance/6e41a561-e275-4698-bc36-548d30a80e96-bucket/chains/mantle.svg",
      mintable: true
    }
  ],
  ...extractAddresses(mantle_sepolia_default),
  ...extractCallbacks(mantle_sepolia_default2)
};
var mantle_sepolia_default3 = config5;

// src/axis-core/.sepolia.json
var sepolia_default = {
  "deployments.BatchAuctionHouse": "0xBA000002400309EfAdeee661426F5183338e5382",
  "deployments.BatchCatalogue": "0xe6c04Ce6ca70eeE60bEc40E2e6e62958D91E02CC",
  "deployments.auctionModules.EncryptedMarginalPrice": "0x63Fb97Dd80060cFd70c87Aa54F594F3988B6Fc66",
  "deployments.auctionModules.FixedPriceBatch": "0x08B87749b379f5BCA1d74A7B3d4e9f3DeD41C706",
  "deployments.derivativeModules.BatchLinearVesting": "0xC11a71a304aB4c147e926342BA4CcCFd62d7368e"
};

// src/chains/testnet/sepolia.ts
var config6 = {
  name: "sepolia",
  chain: sepolia,
  chainIconUrl: "/sepolia-logo.png",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-sepolia/version/v<VERSION>/api",
  rpcURL: "https://eth-sepolia.g.alchemy.com/v2/h6OEviwRZGmTSXHYPRmMquo5u-YoWLeY",
  wrapperContract: "0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9",
  tokenList: [
    {
      ...usdc,
      address: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
      decimals: 18
    },
    {
      ...weth,
      address: "0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9"
    }
  ],
  ...extractAddresses(sepolia_default)
};
var sepolia_default2 = config6;

// src/chains/testnet/index.ts
var testnet_default = [
  blast_sepolia_default3,
  arbitrum_sepolia_default3,
  mode_testnet_default,
  base_sepolia_default4,
  mantle_sepolia_default3,
  sepolia_default2
];

// src/axis-core/.base.json
var base_default = {
  "deployments.BatchAuctionHouse": "0xBA0000c59d144f2a9aEa064dcb2f963e1a0B3212",
  "deployments.BatchCatalogue": "0x2B63Aa737a1AD617A6d6894698Abd043F95cCecb",
  "deployments.auctionModules.EncryptedMarginalPrice": "0x408fB738592232372069B592022F03BF3a241613",
  "deployments.auctionModules.FixedPriceBatch": "0x4042D4F2236D055212d485E028E8FE4939252F88",
  "deployments.derivativeModules.BatchLinearVesting": "0x5C439EAa3F039Bac9Bf1ea4Eb6121d5767C63864"
};

// src/axis-periphery/.base.json
var base_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x986ADD36BEF1B7a5aF9C659776a601fdECF27ccC"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x98c5c24eB3FFEFeCd1a666423978f7A030319A78"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x98a5d4827A57056d30df93C7Bd4Bc294cC6dC0b9"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x98F28A689275dFC6376dFe54280dfac85fB7bA69"
  ],
  "deployments.callbacks.BatchUniswapV2DirectToLiquidity": [
    "0xE6F93df14cB554737A26acd2aB5fEf649921D7F2"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidity": [
    "0xE64d6e058dD5F76CCc8566c07b994090a24CCB75"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [],
  "deployments.callbacks.Baseline": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/chains/mainnet/arbitrum.ts
var config7 = {
  name: "arbitrum",
  chain: arbitrum,
  chainIconUrl: "arbitrum-logo.png",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-arbitrum-one/version/v<VERSION>/api",
  rpcURL: "https://arb-mainnet.g.alchemy.com/v2/h6OEviwRZGmTSXHYPRmMquo5u-YoWLeY",
  wrapperContract: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
  tokenList: [
    {
      ...dai,
      address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1"
    },
    {
      ...usdc,
      address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8"
    },
    {
      ...usdt,
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9"
    },
    {
      ...weth,
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
    }
  ],
  ...extractAddresses(base_default),
  ...extractCallbacks(base_default2)
};
var arbitrum_default = config7;

// src/axis-utils/.base.json
var base_default3 = {
  "deployments.utils.registry": ["0xA12307d3cba3F0854cf92faDce07f7bff0B6a2BA"]
};

// src/chains/mainnet/base.ts
var config8 = {
  name: "base",
  chain: base,
  chainIconUrl: "/base-logo.png",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-base/version/v<VERSION>/api",
  rpcURL: "https://base-mainnet.g.alchemy.com/v2/h6OEviwRZGmTSXHYPRmMquo5u-YoWLeY",
  wrapperContract: "0x4200000000000000000000000000000000000006",
  tokenList: [
    {
      ...usdc,
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"
    },
    {
      ...weth,
      address: "0x4200000000000000000000000000000000000006"
    }
  ],
  ...extractAddresses(base_default),
  ...extractCallbacks(base_default2),
  registry: base_default3["deployments.utils.registry"][0]
};
var base_default4 = config8;

// src/axis-core/.blast.json
var blast_default = {
  "deployments.BatchAuctionHouse": "0xBA000055DF41Da8584e1251Bcdf45e91aCb61108",
  "deployments.BatchCatalogue": "0xBFfBef6f8a0Ef38121716860E2Ff824c018a467d",
  "deployments.auctionModules.EncryptedMarginalPrice": "0x16D5Aab9d35f8B3ac7BD086eEDcCe5343682D5F0",
  "deployments.auctionModules.FixedPriceBatch": "0x0e4996960731Fec8E7C9DBbD51383fC71174DD88",
  "deployments.derivativeModules.BatchLinearVesting": "0x5998a28a71e6BDc2b592c14e3517212391782db0"
};

// src/axis-periphery/.blast.json
var blast_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x980997561d92D30Cae5bae01CCdfc6923E0c54a6"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x9817F12e9461e9D68b0ecB7ff2e8E9da5cf0959C"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x989Dc1DAa66139ed26361cc3A24CdA372370a7dA"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x986827E5FC7ECE5704449aAA3B4A4b16b417b8e7"
  ],
  "deployments.callbacks.BatchUniswapV2DirectToLiquidity": [
    "0xE6512c5F23403585916C936a194D63880DAd7EDF"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidity": [
    "0xE6B27B702DB07a3a7b6d5572f9fA5dc7F201a439"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [],
  "deployments.callbacks.Baseline": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [
    "0xEF818C84cced3e263573b28733A2A0278CE0d985",
    "0xEF4a387850c288EBDA79c0b4aA3108416644D3b8"
  ],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/chains/mainnet/blast.ts
var config9 = {
  name: "blast-mainnet",
  chain: blast,
  chainIconUrl: "/blast-logo.png",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-blast/version/v<VERSION>/api",
  rpcURL: "https://blast-mainnet.g.alchemy.com/v2/h6OEviwRZGmTSXHYPRmMquo5u-YoWLeY",
  wrapperContract: "0x4300000000000000000000000000000000000004",
  tokenList: [
    {
      address: "0x4300000000000000000000000000000000000003",
      decimals: 18,
      symbol: "USDB",
      name: "Blast USD",
      logoURI: "https://assets-global.website-files.com/65a6baa1a3f8ed336f415cb4/65c67eafd3569b7e2f834b8d_usdb-icon-yellow.svg"
    },
    {
      ...weth,
      address: "0x4300000000000000000000000000000000000004"
    }
  ],
  ...extractAddresses(blast_default),
  ...extractCallbacks(blast_default2)
};
var blast_default3 = config9;

// src/axis-core/.mantle.json
var mantle_default = {
  "deployments.BatchAuctionHouse": "0xBA0000c59d144f2a9aEa064dcb2f963e1a0B3212",
  "deployments.BatchCatalogue": "0x8b7e483d96004ca7893EfB14E049f7648b62322b",
  "deployments.auctionModules.EncryptedMarginalPrice": "0xBFfBef6f8a0Ef38121716860E2Ff824c018a467d",
  "deployments.auctionModules.FixedPriceBatch": "0xB5F02BA844D7A6D07d614eFF40a054E9e24dD4B8",
  "deployments.derivativeModules.BatchLinearVesting": "0x16006e7C3015dC53CD102A9a5eCcfB9749779D91"
};

// src/axis-periphery/.mantle.json
var mantle_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x986ADD36BEF1B7a5aF9C659776a601fdECF27ccC"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x98c5c24eB3FFEFeCd1a666423978f7A030319A78"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x98a5d4827A57056d30df93C7Bd4Bc294cC6dC0b9"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x98F28A689275dFC6376dFe54280dfac85fB7bA69"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [],
  "deployments.callbacks.Baseline": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/chains/mainnet/mantle.ts
var config10 = {
  name: "mantle",
  chain: mantle,
  chainIconUrl: "/mantle-logo.svg",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-mantle/version/v<VERSION>/api",
  rpcURL: "https://mantle-mainnet.g.alchemy.com/v2/h6OEviwRZGmTSXHYPRmMquo5u-YoWLeY",
  wrapperContract: "0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8",
  tokenList: [
    {
      ...usdc,
      address: "0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9"
    },
    {
      ...usdt,
      address: "0x201EBa5CC46D216Ce6DC03F6a759e8E766e956aE"
    },
    {
      ...weth,
      address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111"
    },
    {
      symbol: "WMNT",
      name: "Mantle",
      address: "0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8",
      decimals: 18,
      logoURI: "https://storage.bondprotocol.finance/6e41a561-e275-4698-bc36-548d30a80e96-bucket/chains/mantle.svg"
    }
  ],
  ...extractAddresses(mantle_default),
  ...extractCallbacks(mantle_default2)
};
var mantle_default3 = config10;

// src/axis-core/.mode.json
var mode_default = {
  "deployments.BatchAuctionHouse": "0xBA0000c59d144f2a9aEa064dcb2f963e1a0B3212",
  "deployments.BatchCatalogue": "0x8Db46375e73545226E99b5e8cBfe2794ac835D38",
  "deployments.auctionModules.EncryptedMarginalPrice": "0xA17fC2B153222bdC549AE22Af5AcA7aC773979Fc",
  "deployments.auctionModules.FixedPriceBatch": "0x3A327c856AF41EcF4d783975CE38f669dEeaB298",
  "deployments.derivativeModules.BatchLinearVesting": "0xc20918b09dE9708d2A7997dfFc3c5ACB34d4a15b"
};

// src/axis-periphery/.mode.json
var mode_default2 = {
  "deployments.callbacks.BatchCappedMerkleAllowlist": [
    "0x986ADD36BEF1B7a5aF9C659776a601fdECF27ccC"
  ],
  "deployments.callbacks.BatchMerkleAllowlist": [
    "0x98c5c24eB3FFEFeCd1a666423978f7A030319A78"
  ],
  "deployments.callbacks.BatchTokenAllowlist": [
    "0x98a5d4827A57056d30df93C7Bd4Bc294cC6dC0b9"
  ],
  "deployments.callbacks.BatchAllocatedMerkleAllowlist": [
    "0x98F28A689275dFC6376dFe54280dfac85fB7bA69"
  ],
  "deployments.callbacks.BatchUniswapV3DirectToLiquidityWithAllocatedAllowlist": [],
  "deployments.callbacks.Baseline": [],
  "deployments.callbacks.BaselineAllowlist": [],
  "deployments.callbacks.BaselineAllocatedAllowlist": [],
  "deployments.callbacks.BaselineCappedAllowlist": [],
  "deployments.callbacks.BaselineTokenAllowlist": []
};

// src/chains/mainnet/mode.ts
var config11 = {
  name: "mode",
  chain: mode,
  chainIconUrl: "/mode-logo.svg",
  subgraphURL: "https://api.goldsky.com/api/public/project_clu16lu24lqh201x9f0qh135t/subgraphs/axis-origin-mode-mainnet/<VERSION>/gn",
  rpcURL: "https://mainnet.mode.network",
  wrapperContract: "0x4200000000000000000000000000000000000006",
  tokenList: [
    {
      ...usdc,
      address: "0xd988097fb8612cc24eeC14542bC03424c656005f"
    },
    {
      ...usdt,
      address: "0xf0F161fDA2712DB8b566946122a5af183995e2eD"
    },
    {
      ...weth,
      address: "0x4200000000000000000000000000000000000006"
    }
  ],
  ...extractAddresses(mode_default),
  ...extractCallbacks(mode_default2)
};
var mode_default3 = config11;

// src/axis-core/.mainnet.json
var mainnet_default = {
  "deployments.BatchAuctionHouse": "0xBA000020Fed3cf3bF473f09Ca0A72Ba123e20926",
  "deployments.BatchCatalogue": "0xD33e5cC03ad1C8F73cc57053f8a749ac76F14988",
  "deployments.auctionModules.EncryptedMarginalPrice": "0xB5973CabD553F34C32ae2FbC91c94b3bf76DB62e",
  "deployments.auctionModules.FixedPriceBatch": "0x4ED7160dA0020070ADf1AB149c730E8A4bD73d15",
  "deployments.derivativeModules.BatchLinearVesting": "0x605A7105CA51FD5F107258362f52d8269eeA851A"
};

// src/chains/mainnet/mainnet.ts
var config12 = {
  name: "mainnet",
  chain: mainnet,
  chainIconUrl: "/mainnet-logo.png",
  subgraphURL: "https://subgraph.satsuma-prod.com/44c4cc082f74/spaces-team/axis-origin-mainnet/version/v<VERSION>/api",
  rpcURL: "https://eth-mainnet.g.alchemy.com/v2/h6OEviwRZGmTSXHYPRmMquo5u-YoWLeY",
  wrapperContract: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  tokenList: [
    {
      ...dai,
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F"
    },
    {
      ...usdc,
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
    },
    {
      ...usdt,
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7"
    },
    {
      ...lusd,
      address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0"
    },
    {
      ...weth,
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
    }
  ],
  ...extractAddresses(mainnet_default)
};
var mainnet_default2 = config12;

// src/chains/mainnet/index.ts
var mainnet_default3 = [arbitrum_default, base_default4, blast_default3, mantle_default3, mode_default3, mainnet_default2];

// src/main.ts
var mainnetDeployments = mainnet_default3.map(createDeployment);
var testnetDeployments = testnet_default.map(createDeployment);
var allDeployments = [testnetDeployments, mainnetDeployments];
var testnets = createDeploymentRecord(testnetDeployments);
var mainnets = createDeploymentRecord(mainnetDeployments);
var deployments = { ...testnets, ...mainnets };
var lists = [mainnetDeployments, testnetDeployments].flatMap(
  (list) => list.flatMap((t) => t.tokenList)
);
var defaultTokenlist = compileTokenList(lists);
function compileTokenList(tokenlist) {
  const [metadata] = tokenlist;
  return {
    ...metadata,
    isActive: true,
    tokens: tokenlist.flatMap((l) => l.tokens)
  };
}

// src/contracts.ts
import { abis } from "@axis-finance/abis";
var addressesPerChain = allDeployments.flat().reduce((acc, deployment) => {
  return {
    ...acc,
    [deployment.chain.id]: { ...deployment.addresses, ...deployment.callbacks }
  };
}, {});
var axisContracts = {
  addresses: addressesPerChain,
  abis
};

// ../types/dist/index.js
var AuctionType = /* @__PURE__ */ ((AuctionType2) => {
  AuctionType2["SEALED_BID"] = "EMPA";
  AuctionType2["FIXED_PRICE_BATCH"] = "FPBA";
  return AuctionType2;
})(AuctionType || {});

// src/mainnet-tokenlist.json
var mainnet_tokenlist_default = {
  name: "CoinGecko",
  logoURI: "https://static.coingecko.com/s/thumbnail-007177f3eca19695592f0b8b0eabbdae282b54154e1be912285c9034ea6cbaf2.png",
  keywords: ["defi"],
  timestamp: "2024-05-08T20:02:23.919+00:00",
  tokens: [
    {
      chainId: 1,
      address: "0xd2877702675e6ceb975b4a1dff9fb7baf4c91ea9",
      name: "Wrapped Terra Classic",
      symbol: "LUNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13628/thumb/wluna.png?1696513376"
    },
    {
      chainId: 1,
      address: "0x5bb29c33c4a3c29f56f8aca40b4db91d8a5fe2c5",
      name: "One Share",
      symbol: "ONS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13531/thumb/bss.a1671c75.png?1696513292"
    },
    {
      chainId: 1,
      address: "0xd49ff13661451313ca1553fd6954bd1d9b6e02b9",
      name: "Electrify Asia",
      symbol: "ELEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3415/thumb/d45b1d82743c749d05697da200179874.jpg?1696504111"
    },
    {
      chainId: 1,
      address: "0x77c6e4a580c0dce4e5c7a17d0bc077188a83a059",
      name: "Swerve fi USD",
      symbol: "SWUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12918/thumb/swerve.png?1696512706"
    },
    {
      chainId: 1,
      address: "0xa58a4f5c4bb043d2cc1e170613b74e767c94189b",
      name: "UTU Coin",
      symbol: "UTU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12831/thumb/Aa5nmbkJ_400x400.png?1696512622"
    },
    {
      chainId: 1,
      address: "0x3212b29e33587a00fb1c83346f5dbfa69a458923",
      name: "The Tokenized Bitcoin",
      symbol: "IMBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/10702/thumb/imbtc.png?1696510670"
    },
    {
      chainId: 1,
      address: "0xc3eb2622190c57429aac3901808994443b64b466",
      name: "ORO",
      symbol: "ORO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13114/thumb/oro_logo.png?1696512899"
    },
    {
      chainId: 1,
      address: "0xdcd85914b8ae28c1e62f1c488e1d968d5aaffe2b",
      name: "TOP Network",
      symbol: "TOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7058/thumb/topnetwork-logo.png?1696507364"
    },
    {
      chainId: 1,
      address: "0xa14ea0e11121e6e951e87c66afe460a00bcd6a16",
      name: "IdleDAI  Risk Adjusted ",
      symbol: "IDLEDAISAFE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11929/thumb/idledai-safe.png?1696511790"
    },
    {
      chainId: 1,
      address: "0x634239cfa331df0291653139d1a6083b9cf705e3",
      name: "DeSpace Protocol",
      symbol: "DES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18517/thumb/NQQu-EsT_400x400.jpg?1696517998"
    },
    {
      chainId: 1,
      address: "0x431d5dff03120afa4bdf332c61a6e1766ef37bdb",
      name: "JPY Coin",
      symbol: "JPYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25971/thumb/2023jpyc.png?1696525049"
    },
    {
      chainId: 1,
      address: "0x7f5e1a2424ebdd141b0df15f974ddcb87751a012",
      name: "LLM eth",
      symbol: "LLM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37091/thumb/LLM_bot_200x200.png?1713270823"
    },
    {
      chainId: 1,
      address: "0x3391bc034f2935ef0e1e41619445f998b2680d35",
      name: "IdleUSDC  Risk Adjusted ",
      symbol: "IDLEUSDCSAFE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11930/thumb/idleusdc-safe.png?1696511791"
    },
    {
      chainId: 1,
      address: "0x22b6c31c2beb8f2d0d5373146eed41ab9ede3caf",
      name: "The Cocktailbar",
      symbol: "COC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13121/thumb/Cocktail_Bar_logo_%281%29_%281%29.png?1696512909"
    },
    {
      chainId: 1,
      address: "0x2370f9d504c7a6e775bf6e14b3f12846b594cd53",
      name: "JPY Coin v1",
      symbol: "JPYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17277/thumb/WoZ8rruL_400x400.png?1696516831"
    },
    {
      chainId: 1,
      address: "0xb6ca7399b4f9ca56fc27cbff44f4d2e4eef1fc81",
      name: "Muse DAO",
      symbol: "MUSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13230/thumb/muse_logo.png?1696513008"
    },
    {
      chainId: 1,
      address: "0x246908bff0b1ba6ecadcf57fb94f6ae2fcd43a77",
      name: "Divi",
      symbol: "DIVI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/1273/thumb/red_logomark.png?1696502345"
    },
    {
      chainId: 1,
      address: "0xdf35988d795d90711e785b488bb2127692e6f956",
      name: "BabyFloki",
      symbol: "BABYFLOKI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/16712/thumb/floki.jpg?1696516286"
    },
    {
      chainId: 1,
      address: "0x28fac5334c9f7262b3a3fe707e250e01053e07b5",
      name: "IdleUSDT  Risk Adjusted ",
      symbol: "IDLEUSDTSAFE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11931/thumb/idleusdt-safe.png?1696511792"
    },
    {
      chainId: 1,
      address: "0x77607588222e01bf892a29abab45796a2047fc7b",
      name: "Unagii ETH",
      symbol: "UETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14624/thumb/uETH.png?1696514302"
    },
    {
      chainId: 1,
      address: "0xdf801468a808a32656d2ed2d2d80b72a129739f4",
      name: "Somnium Space CUBEs",
      symbol: "CUBE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/10687/thumb/CUBE_icon.png?1696510656"
    },
    {
      chainId: 1,
      address: "0xc5fdf3569af74f3b3e97e46a187a626352d2d508",
      name: "Zombie Inu",
      symbol: "ZINU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28562/thumb/zinu_new.png?1696527552"
    },
    {
      chainId: 1,
      address: "0xb478c6245e3d85d6ec3486b62ea872128d562541",
      name: "LootBot",
      symbol: "LOOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30985/thumb/K7dMTTKi_400x400.png?1696529824"
    },
    {
      chainId: 1,
      address: "0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b",
      name: "Goldfinch",
      symbol: "GFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19081/thumb/GOLDFINCH.png?1696518531"
    },
    {
      chainId: 1,
      address: "0x19d97d8fa813ee2f51ad4b4e04ea08baf4dffc28",
      name: "Badger Sett Badger",
      symbol: "BBADGER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14502/thumb/BADGER_DAO.png?1696514188"
    },
    {
      chainId: 1,
      address: "0x7051faed0775f664a0286af4f75ef5ed74e02754",
      name: "Changex",
      symbol: "CHANGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26487/thumb/Changex-mark-200x200.png?1696525560"
    },
    {
      chainId: 1,
      address: "0x471a202f69d6e975da55e363dab1bdb2e86e0c0f",
      name: "Geke",
      symbol: "GEKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30332/thumb/geke.jpg?1696529233"
    },
    {
      chainId: 1,
      address: "0x35bd01fc9d6d5d81ca9e055db88dc49aa2c699a8",
      name: "Friends With Benefits Pro",
      symbol: "FWB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14391/thumb/xRGEXmQN_400x400.png?1696514082"
    },
    {
      chainId: 1,
      address: "0x30cf203b48edaa42c3b4918e955fed26cd012a3f",
      name: "MetaGame",
      symbol: "SEED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13099/thumb/V8phEz8V.png?1696512885"
    },
    {
      chainId: 1,
      address: "0xfad45e47083e4607302aa43c65fb3106f1cd7607",
      name: "Hoge Finance",
      symbol: "HOGE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/14360/thumb/hoge.jpg?1696514046"
    },
    {
      chainId: 1,
      address: "0x3af5ba94c29a8407785f5f6d90ef5d69a8eb2436",
      name: "Unagii Wrapped Bitcoin",
      symbol: "UWBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/14625/thumb/uBTC.png?1696514303"
    },
    {
      chainId: 1,
      address: "0x5274891bec421b39d23760c04a6755ecb444797c",
      name: "IdleUSDC  Yield ",
      symbol: "IDLEUSDCYIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11932/thumb/idleusdcv3_32.png?1696511793"
    },
    {
      chainId: 1,
      address: "0x723cbfc05e2cfcc71d3d89e770d32801a5eef5ab",
      name: "Bitcoin Pro",
      symbol: "BTCP",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/3545/thumb/DSiD9ZhWsAE_8cS.png?1696504231"
    },
    {
      chainId: 1,
      address: "0x6fa5e1c43b5a466cbd1cae7993b67c982400d481",
      name: "CoinBot",
      symbol: "COINBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31234/thumb/1-removebg-preview_%282%29.png?1696530060"
    },
    {
      chainId: 1,
      address: "0x54d1c019c53501f76361bb656542fec427bf13aa",
      name: "Peer to Peer",
      symbol: "P2P",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33123/thumb/IMG_7077.PNG?1700794851"
    },
    {
      chainId: 1,
      address: "0x20c64dee8fda5269a78f2d5bdba861ca1d83df7a",
      name: "Backed HIGH   High Yield Corp Bond",
      symbol: "BHIGH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31868/thumb/b-HIGH-200x200.png?1696530680"
    },
    {
      chainId: 1,
      address: "0xbe9895146f7af43049ca1c1ae358b0541ea49704",
      name: "Coinbase Wrapped Staked ETH",
      symbol: "CBETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27008/thumb/cbeth.png?1709186989"
    },
    {
      chainId: 1,
      address: "0xf34842d05a1c888ca02769a633df37177415c2f8",
      name: "IdleUSDT  Yield ",
      symbol: "IDLEUSDTYIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11933/thumb/idleusdtv3maxyield_32.png?1696511794"
    },
    {
      chainId: 1,
      address: "0x5dfc78c4d073fd343bc6661668948178522a0de5",
      name: "Derp",
      symbol: "DERP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33069/thumb/derpdex_%281%29.png?1700793428"
    },
    {
      chainId: 1,
      address: "0x7f3edcdd180dbe4819bd98fee8929b5cedb3adeb",
      name: "xToken",
      symbol: "XTK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14089/thumb/xtk.png?1696513811"
    },
    {
      chainId: 1,
      address: "0xd7c1eb0fe4a30d3b2a846c04aa6300888f087a5f",
      name: "Points",
      symbol: "POINTS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33666/thumb/points_%281%29.png?1703050357"
    },
    {
      chainId: 1,
      address: "0xf52cdcd458bf455aed77751743180ec4a595fd3f",
      name: "IdleSUSD  Yield ",
      symbol: "IDLESUSDYIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11934/thumb/idlesusdv3mmaxyield_32.png?1696511795"
    },
    {
      chainId: 1,
      address: "0x5f0e628b693018f639d10e4a4f59bd4d8b2b6b44",
      name: "Whiteheart",
      symbol: "WHITE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13484/thumb/whiteheart.png?1696513245"
    },
    {
      chainId: 1,
      address: "0x1beef31946fbbb40b877a72e4ae04a8d1a5cee06",
      name: "Parachute",
      symbol: "PAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7590/thumb/Parachute_Logo.png?1696507850"
    },
    {
      chainId: 1,
      address: "0x70e8de73ce538da2beed35d14187f6959a8eca96",
      name: "XSGD",
      symbol: "XSGD",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/12832/thumb/StraitsX_Singapore_Dollar_%28XSGD%29_Token_Logo.png?1696512623"
    },
    {
      chainId: 1,
      address: "0xc278041fdd8249fe4c1aad1193876857eea3d68c",
      name: "IdleTUSD  Best Yield ",
      symbol: "IDLETUSDYIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11935/thumb/idletusdv3mMaxyield_32.png?1696511796"
    },
    {
      chainId: 1,
      address: "0x5732046a883704404f284ce41ffadd5b007fd668",
      name: "Bluzelle",
      symbol: "BLZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2848/thumb/ColorIcon_3x.png?1696503607"
    },
    {
      chainId: 1,
      address: "0xec681f28f4561c2a9534799aa38e0d36a83cf478",
      name: "YVS Finance",
      symbol: "YVS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13471/thumb/cu0LSzE.png?1696513232"
    },
    {
      chainId: 1,
      address: "0x7a73839bd0e5cded853cb01aa9773f8989381065",
      name: "UpBots",
      symbol: "UBXN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12476/thumb/UBXT.png?1696512294"
    },
    {
      chainId: 1,
      address: "0x89ab32156e46f46d02ade3fecbe5fc4243b9aaed",
      name: "pNetwork",
      symbol: "PNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11659/thumb/pNetwork.png?1696511550"
    },
    {
      chainId: 1,
      address: "0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645",
      name: "Stader MaticX",
      symbol: "MATICX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25383/thumb/maticx.png?1696524516"
    },
    {
      chainId: 1,
      address: "0x72630b1e3b42874bf335020ba0249e3e9e47bafc",
      name: "Paypolitan",
      symbol: "EPAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13192/thumb/ava3.png?1696512973"
    },
    {
      chainId: 1,
      address: "0x0eb3032bcac2be1fa95e296442f225edb80fc3cd",
      name: "Aster",
      symbol: "ATC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17325/thumb/atc.png?1696516878"
    },
    {
      chainId: 1,
      address: "0xdb25f211ab05b1c97d595516f45794528a807ad8",
      name: "STASIS EURO",
      symbol: "EURS",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/5164/thumb/EURS_300x300.png?1696505680"
    },
    {
      chainId: 1,
      address: "0xfbeea1c75e4c4465cb2fccc9c6d6afe984558e20",
      name: "DuckDaoDime",
      symbol: "DDIM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12146/thumb/token_DDIM-01.png?1696511987"
    },
    {
      chainId: 1,
      address: "0x8ae4bf2c33a8e667de34b54938b0ccd03eb8cc06",
      name: "Patientory",
      symbol: "PTOY",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/746/thumb/patientory.png?1696501901"
    },
    {
      chainId: 1,
      address: "0xd337382da15d12bb6e56498e91df64f86c8f1ea8",
      name: "Aelysir",
      symbol: "AEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12955/thumb/ael_logo.png?1696512743"
    },
    {
      chainId: 1,
      address: "0xca0e7269600d353f70b14ad118a49575455c0f2f",
      name: "AMLT Network",
      symbol: "AMLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2703/thumb/amlt.png?1696503486"
    },
    {
      chainId: 1,
      address: "0x5394794be8b6ed5572fcd6b27103f46b5f390e8f",
      name: "Aave AMM UniYFIWETH",
      symbol: "AAMMUNIYFIWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17258/thumb/aAmmUniYFIWETH.png?1696516814"
    },
    {
      chainId: 1,
      address: "0x90de74265a416e1393a450752175aed98fe11517",
      name: "Unlock Protocol",
      symbol: "UDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14545/thumb/unlock.jpg?1696514228"
    },
    {
      chainId: 1,
      address: "0x8d75959f1e61ec2571aa72798237101f084de63a",
      name: "Substratum",
      symbol: "SUB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/950/thumb/substratum.png?1696502066"
    },
    {
      chainId: 1,
      address: "0xf9fb4ad91812b704ba883b11d2b576e890a6730a",
      name: "Aave AMM WETH",
      symbol: "AAMMWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17259/thumb/aAMMWETH_2x.png?1696516814"
    },
    {
      chainId: 1,
      address: "0xc4d5545392f5fc57eba3af8981815669bb7e2a48",
      name: "HEdpAY",
      symbol: "HDP",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/7496/thumb/icon_hedpay.png?1696507765"
    },
    {
      chainId: 1,
      address: "0x2de509bf0014ddf697b220be628213034d320ece",
      name: "Don t Buy Inu",
      symbol: "DBI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28058/thumb/1Artboard_1_%282%29.png?1696527070"
    },
    {
      chainId: 1,
      address: "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
      name: "LTO Network",
      symbol: "LTO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/6068/thumb/lto.png?1696506473"
    },
    {
      chainId: 1,
      address: "0x0e0989b1f9b8a38983c2ba8053269ca62ec9b195",
      name: "Po et",
      symbol: "POE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/910/thumb/poet.png?1696502031"
    },
    {
      chainId: 1,
      address: "0x2edf094db69d6dcd487f1b3db9febe2eec0dd4c5",
      name: "ZeroSwap",
      symbol: "ZEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12861/thumb/logo.?1696512650"
    },
    {
      chainId: 1,
      address: "0x24b47299e756af0571f512232a3629e0dabb52ed",
      name: "concertVR",
      symbol: "CVT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2914/thumb/cvt.png?1696503662"
    },
    {
      chainId: 1,
      address: "0x358bd0d980e031e23eba9aa793926857703783bd",
      name: "Aave AMM BptWBTCWETH",
      symbol: "AAMMBPTWBTCWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17260/thumb/aAmmBptWBTCWETH.png?1696516815"
    },
    {
      chainId: 1,
      address: "0x378cb52b00f9d0921cb46dfc099cff73b42419dc",
      name: "LUSD yVault",
      symbol: "YVLUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28788/thumb/yvLUSD-128-0x378cb52b00F9D0921cb46dFc099CFf73b42419dC.png?1696527767"
    },
    {
      chainId: 1,
      address: "0xc0c293ce456ff0ed870add98a0828dd4d2903dbf",
      name: "Aura Finance",
      symbol: "AURA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25942/thumb/logo.png?1696525021"
    },
    {
      chainId: 1,
      address: "0xcc6f15be8573cb8243c42d300565566d328213dd",
      name: "OWN Token",
      symbol: "OWN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10950/thumb/cropped-WhatsApp-Image-2020-04-04-at-9.04.01-PM.jpeg?1696510899"
    },
    {
      chainId: 1,
      address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
      name: "Everex",
      symbol: "EVX",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/997/thumb/everex.png?1696502109"
    },
    {
      chainId: 1,
      address: "0xd31e53966bf212e860d48a3a8651a23d09a7fdc3",
      name: "DogeAi",
      symbol: "DOGEAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33023/thumb/DogeAI_logo_200x200.png?1700316738"
    },
    {
      chainId: 1,
      address: "0x7a41e0517a5eca4fdbc7fbeba4d4c47b9ff6dc63",
      name: "Zeusshield",
      symbol: "ZSC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1009/thumb/zeusshield.png?1696502121"
    },
    {
      chainId: 1,
      address: "0x6d765cbe5bc922694afe112c140b8878b9fb0390",
      name: "SUSHI yVault",
      symbol: "YVSUSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28789/thumb/yvSUSHI-128-0x6d765CbE5bC922694afE112C140b8878b9FB0390.png?1696527767"
    },
    {
      chainId: 1,
      address: "0xd2d6158683aee4cc838067727209a0aaf4359de3",
      name: "Bounty0x",
      symbol: "BNTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1444/thumb/bounty0x.png?1696502494"
    },
    {
      chainId: 1,
      address: "0x9c78ee466d6cb57a4d01fd887d2b5dfb2d46288f",
      name: "Must",
      symbol: "MUST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13688/thumb/must_logo.png?1696513436"
    },
    {
      chainId: 1,
      address: "0x7533d63a2558965472398ef473908e1320520ae2",
      name: "INTEXCOIN",
      symbol: "INTX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/11854/thumb/INTX.png?1696511724"
    },
    {
      chainId: 1,
      address: "0x220b71671b649c03714da9c621285943f3cbcdc6",
      name: "TosDis",
      symbol: "DIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13745/thumb/Tosdis-black.png?1696513488"
    },
    {
      chainId: 1,
      address: "0xd109b2a304587569c84308c55465cd9ff0317bfb",
      name: "Aave AMM BptBALWETH",
      symbol: "AAMMBPTBALWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17261/thumb/aAmmBptBALWETH.png?1696516816"
    },
    {
      chainId: 1,
      address: "0x5dfe42eea70a3e6f93ee54ed9c321af07a85535c",
      name: "Union Finance",
      symbol: "UNION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30556/thumb/Mark.png?1712560901"
    },
    {
      chainId: 1,
      address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
      name: "Band Protocol",
      symbol: "BAND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9545/thumb/Band_token_blue_violet_token.png?1696509627"
    },
    {
      chainId: 1,
      address: "0xb1f66997a5760428d3a87d68b90bfe0ae64121cc",
      name: "LuaSwap",
      symbol: "LUA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12627/thumb/Screenshot_2020-09-28_at_6.24.59_PM.jpg?1696512435"
    },
    {
      chainId: 1,
      address: "0x8f0921f30555624143d427b340b1156914882c10",
      name: "FlypMe",
      symbol: "FYP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1098/thumb/flypme.png?1696502196"
    },
    {
      chainId: 1,
      address: "0xec67005c4e498ec7f55e092bd1d35cbc47c91892",
      name: "Enzyme",
      symbol: "MLN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/605/thumb/Enzyme_Icon_Secondary.png?1696501803"
    },
    {
      chainId: 1,
      address: "0xfd0877d9095789caf24c98f7cce092fa8e120775",
      name: "TUSD yVault",
      symbol: "YVTUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28790/thumb/yvTUSD-128-0xFD0877d9095789cAF24c98F7CCe092fa8E120775.png?1696527768"
    },
    {
      chainId: 1,
      address: "0x6c2adc2073994fb2ccc5032cc2906fa221e9b391",
      name: "Delphy",
      symbol: "DPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1133/thumb/delphy.png?1696502226"
    },
    {
      chainId: 1,
      address: "0x1500205f50bf3fd976466d0662905c9ff254fc9c",
      name: "BitBoost",
      symbol: "BBT",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/1194/thumb/bitboost.jpg?1696502276"
    },
    {
      chainId: 1,
      address: "0x3893b9422cd5d70a81edeffe3d5a1c6a978310bb",
      name: "Mithril",
      symbol: "MITH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3484/thumb/mithril.png?1696504172"
    },
    {
      chainId: 1,
      address: "0xedbf98724a86f92baefac101082c366e96f1e9d9",
      name: "BiFinance Exchange",
      symbol: "BFT",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0x4db2c02831c9ac305ff9311eb661f80f1df61e07",
      name: "oneICHI",
      symbol: "ONEICHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25908/thumb/74116843.png?1696524989"
    },
    {
      chainId: 1,
      address: "0xf4134146af2d511dd5ea8cdb1c4ac88c57d60404",
      name: "SunContract",
      symbol: "SNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1166/thumb/suncontract.png?1696502255"
    },
    {
      chainId: 1,
      address: "0x71fc860f7d3a592a4a98740e39db31d25db65ae8",
      name: "Aave USDT v1",
      symbol: "AUSDT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/11725/thumb/aUSDT.png?1696511607"
    },
    {
      chainId: 1,
      address: "0x0000000000095413afc295d19edeb1ad7b71c952",
      name: "Tokenlon",
      symbol: "LON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13454/thumb/lon_logo.png?1696513217"
    },
    {
      chainId: 1,
      address: "0xb1f1ee126e9c96231cc3d3fad7c08b4cf873b1f1",
      name: "Beefy",
      symbol: "BIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12704/thumb/bifi.png?1698202580"
    },
    {
      chainId: 1,
      address: "0xfc05987bd2be489accf0f509e44b0145d68240f7",
      name: "Essentia",
      symbol: "ESS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2483/thumb/Essentia-token.jpg?1696503302"
    },
    {
      chainId: 1,
      address: "0x20c3fa331a385b63ee39137e99d0cf2db142fce1",
      name: "Shila Inu",
      symbol: "SHIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28847/thumb/rsz_logo1.png?1696527823"
    },
    {
      chainId: 1,
      address: "0x1f16d41f9b3db03b462bdd6c92245ee708d1c103",
      name: "Rangers Protocol Gas",
      symbol: "RPG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18791/thumb/tO8MlqiM_400x400.png?1633421196"
    },
    {
      chainId: 1,
      address: "0x35a18000230da775cac24873d00ff85bccded550",
      name: "cUNI",
      symbol: "CUNI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/12696/thumb/compound-uni.png?1696512499"
    },
    {
      chainId: 1,
      address: "0x679badc551626e01b23ceecefbc9b877ea18fc46",
      name: "Ccore",
      symbol: "CCO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1287/thumb/LOGO_CCO.png?1696502358"
    },
    {
      chainId: 1,
      address: "0x70efdc485a10210b056ef8e0a32993bc6529995e",
      name: "Blaze Network",
      symbol: "BLZN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12248/thumb/A8JOuPSJ_400x400.jpg?1696512079"
    },
    {
      chainId: 1,
      address: "0x1e797ce986c3cff4472f7d38d5c4aba55dfefe40",
      name: "BlockCDN",
      symbol: "BCDN",
      decimals: 15,
      logoURI: "https://assets.coingecko.com/coins/images/1301/thumb/blockcdn.png?1696502370"
    },
    {
      chainId: 1,
      address: "0x441761326490cacf7af299725b6292597ee822c2",
      name: "Unifi Protocol DAO",
      symbol: "UNFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13152/thumb/logo-2.png?1696512937"
    },
    {
      chainId: 1,
      address: "0x6ff2241756549b5816a177659e766eaf14b34429",
      name: "AQTIS",
      symbol: "AQTIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29910/thumb/Screenshot_2023-04-14_at_17.23.46.png?1696528839"
    },
    {
      chainId: 1,
      address: "0xbdab72602e9ad40fc6a6852caf43258113b8f7a5",
      name: "Sovryn",
      symbol: "SOV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16248/thumb/sovryn_logo_orange.png?1709174299"
    },
    {
      chainId: 1,
      address: "0x66186008c1050627f979d464eabb258860563dbe",
      name: "MediShares",
      symbol: "MDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1343/thumb/medishares.png?1696502404"
    },
    {
      chainId: 1,
      address: "0x21f15966e07a10554c364b988e91dab01d32794a",
      name: "SmartMesh",
      symbol: "SMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1346/thumb/smartmesh.png?1696502406"
    },
    {
      chainId: 1,
      address: "0x3505f494c3f0fed0b594e01fa41dd3967645ca39",
      name: "Swarm Network",
      symbol: "SWM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/197/thumb/swarm.jpg?1696501567"
    },
    {
      chainId: 1,
      address: "0x8b1f49491477e0fb46a29fef53f1ea320d13c349",
      name: "MicroMoney",
      symbol: "AMM",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/1356/thumb/micromoney.png?1696502415"
    },
    {
      chainId: 1,
      address: "0x2dca19e944453e46d9130950ca135461b3bc0c30",
      name: "EYES Protocol",
      symbol: "EYES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9734/thumb/pTaAZUI6_400x400.jpg?1696509797"
    },
    {
      chainId: 1,
      address: "0x6ec8a24cabdc339a06a172f8223ea557055adaa5",
      name: "Genaro Network",
      symbol: "GNX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/1361/thumb/genaro-network.png?1696502420"
    },
    {
      chainId: 1,
      address: "0xc86d054809623432210c107af2e3f619dcfbf652",
      name: "Sentinel Protocol",
      symbol: "UPP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3369/thumb/Sentinel_Protocol.jpg?1696504069"
    },
    {
      chainId: 1,
      address: "0x16b0a1a87ae8af5c792fabc429c4fe248834842b",
      name: "Algory",
      symbol: "ALG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12231/thumb/logo-2.png?1696512064"
    },
    {
      chainId: 1,
      address: "0xa5f2211b9b8170f694421f2046281775e8468044",
      name: "THORSwap",
      symbol: "THOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19292/thumb/THORSwap_Logo-removebg-preview.png?1696518735"
    },
    {
      chainId: 1,
      address: "0xb44b653f147569d88a684cbf6549e1968e8b2a1d",
      name: "2DAI io",
      symbol: "2DAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30542/thumb/2dai.jpg?1696529414"
    },
    {
      chainId: 1,
      address: "0x0c93b616933b0cd03b201b29cd8a22681dd9e0d9",
      name: "HollyGold",
      symbol: "HGOLD",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13652/thumb/QnfGCea3aO_Qb-Gd9n6MSFE_eBVAr87WPoxAzf0gKdcGOEL4K5J6A5cpGinzLvHclj_UHkCnw9XTlGoNYd0H8T_Ebe8voLS49MAZO2NIknCxytaYFtt5_u12RQg-kpmWHcETzAFlDgk9iNXAL-88fB_l-DRi8WEsgSJzXXjztKzQlpXuET6d4_98pykED6uyq1-4PMVg05P7tUN.jpg?1696513401"
    },
    {
      chainId: 1,
      address: "0x7968bc6a03017ea2de509aaa816f163db0f35148",
      name: "Hedget",
      symbol: "HGET",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/12453/thumb/Hedget.png?1696512273"
    },
    {
      chainId: 1,
      address: "0x671a912c10bba0cfa74cfc2d6fba9ba1ed9530b2",
      name: "LINK yVault",
      symbol: "YVLINK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28791/thumb/yvLINK-128-0x671a912C10bba0CFA74Cfc2d6Fba9BA1ed9530B2.png?1696527769"
    },
    {
      chainId: 1,
      address: "0x873fb544277fd7b977b196a826459a69e27ea4ea",
      name: "RAI yVault",
      symbol: "YVRAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28792/thumb/yvRAI-128-0x873fB544277FD7b977B196a826459a69E27eA4ea.png?1696527770"
    },
    {
      chainId: 1,
      address: "0xafa42b8ba6ba9dace46dae129a2a1ef54b73fa8b",
      name: "MODAI",
      symbol: "MODAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35625/thumb/p5200x200.jpg?1709290896"
    },
    {
      chainId: 1,
      address: "0x6f222e04f6c53cc688ffb0abe7206aac66a8ff98",
      name: "Roko Network",
      symbol: "ROKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29427/thumb/1.618_200.jpg?1696528376"
    },
    {
      chainId: 1,
      address: "0xa5b947687163fe88c3e6af5b17ae69896f4abccf",
      name: "Poseidon",
      symbol: "PSDN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25316/thumb/psdn_32.png?1696524451"
    },
    {
      chainId: 1,
      address: "0xb753428af26e81097e7fd17f40c88aaa3e04902c",
      name: "saffron finance",
      symbol: "SFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13117/thumb/sfi_red_250px.png?1696512904"
    },
    {
      chainId: 1,
      address: "0xdcb5645eda1ed34c5641d81b927d33ebae9cf2a4",
      name: "PayB",
      symbol: "PAYB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25805/thumb/logo_payb_200_x_200.png?1696524891"
    },
    {
      chainId: 1,
      address: "0x24d73bca2bd9c3a61e99dfc7cb86d3c379ebded7",
      name: "Micro AI",
      symbol: "MAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32811/thumb/mai.png?1699537844"
    },
    {
      chainId: 1,
      address: "0x6f40d4a6237c257fff2db00fa0510deeecd303eb",
      name: "Instadapp",
      symbol: "INST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14688/thumb/30hFM0-n_400x400.jpg?1696514361"
    },
    {
      chainId: 1,
      address: "0xa258c4606ca8206d8aa700ce2143d7db854d168c",
      name: "WETH yVault",
      symbol: "YVWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28793/thumb/yvWETH-128-0xa258C4606Ca8206D8aA700cE2143D7db854D168c.png?1696527771"
    },
    {
      chainId: 1,
      address: "0xa5ca62d95d24a4a350983d5b8ac4eb8638887396",
      name: "sUSD yVault",
      symbol: "YVSUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28794/thumb/yvsUSD-128-0xa5cA62D95D24A4a350983D5B8ac4EB8638887396.png?1696527772"
    },
    {
      chainId: 1,
      address: "0x89fb927240750c1b15d4743cd58440fc5f14a11c",
      name: "Attila",
      symbol: "ATT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11337/thumb/LOGO_%2874%29.png?1696511258"
    },
    {
      chainId: 1,
      address: "0xb26631c6dda06ad89b93c71400d25692de89c068",
      name: "Minds",
      symbol: "MINDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11517/thumb/Minds.png?1696511420"
    },
    {
      chainId: 1,
      address: "0xe5867608b51a2c9c78b9587355cc093140a49b0a",
      name: "Speed Mining Service",
      symbol: "SMS",
      decimals: 3,
      logoURI: "https://assets.coingecko.com/coins/images/1807/thumb/speed-mining-service.png?1548610827"
    },
    {
      chainId: 1,
      address: "0x6251e725cd45fb1af99354035a414a2c0890b929",
      name: "MixTrust",
      symbol: "MXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12148/thumb/MXT_LOGO_200_200.png?1696511988"
    },
    {
      chainId: 1,
      address: "0xfa3118b34522580c35ae27f6cf52da1dbb756288",
      name: "Linkeye",
      symbol: "LET",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/1814/thumb/linkeye.png?1696502815"
    },
    {
      chainId: 1,
      address: "0xb8c3b7a2a618c552c23b1e4701109a9e756bab67",
      name: "1INCH yVault",
      symbol: "YV1INCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28795/thumb/yv1INCH-128-0xB8C3B7A2A618C552C23B1E4701109a9E756Bab67.png?1696527773"
    },
    {
      chainId: 1,
      address: "0xa696a63cc78dffa1a63e9e50587c197387ff6c7e",
      name: "WBTC yVault",
      symbol: "YVWBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/28796/thumb/yvWBTC-128-0xA696a63cc78DfFa1a63E9E50587C197387FF6C7E.png?1696527774"
    },
    {
      chainId: 1,
      address: "0xf29ae508698bdef169b89834f76704c3b205aedf",
      name: "SNX yVault",
      symbol: "YVSNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28797/thumb/yvSNX-128-0xF29AE508698bDeF169B89834F76704C3B205aedf.png?1696527775"
    },
    {
      chainId: 1,
      address: "0x88d50b466be55222019d71f9e8fae17f5f45fca1",
      name: "Cryptaur",
      symbol: "CPT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2481/thumb/n3w6Z9xW_400x400.jpg?1696503301"
    },
    {
      chainId: 1,
      address: "0xf406f7a9046793267bc276908778b29563323996",
      name: "APY vision",
      symbol: "VISION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13288/thumb/apyvisionlogo200circle.png?1696513060"
    },
    {
      chainId: 1,
      address: "0xea01906843ea8d910658a2c485ffce7c104ab2b6",
      name: "Qtoken",
      symbol: "QTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26024/thumb/8QyOrTCm_400x400.jpg?1696525101"
    },
    {
      chainId: 1,
      address: "0xdffa3a7f5b40789c7a437dbe7b31b47f9b08fe75",
      name: "CryptoPunk  7171",
      symbol: "HOODIE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17842/thumb/cryptopunk-hoodie.png?1696517365"
    },
    {
      chainId: 1,
      address: "0x411099c0b413f4feddb10edf6a8be63bd321311c",
      name: "HELLO",
      symbol: "HELLO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27891/thumb/uFXN2S1N_400x400.jpeg?1696526908"
    },
    {
      chainId: 1,
      address: "0x4a8f5f96d5436e43112c2fbc6a9f70da9e4e16d4",
      name: "Internxt",
      symbol: "INXT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/986/thumb/inxt.png?1696502099"
    },
    {
      chainId: 1,
      address: "0x3fd8f39a962efda04956981c31ab89fab5fb8bc8",
      name: "Rotharium",
      symbol: "RTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2030/thumb/L7kpRMda_400x400.jpg?1696503000"
    },
    {
      chainId: 1,
      address: "0x4cf488387f035ff08c371515562cba712f9015d4",
      name: "WePower",
      symbol: "WPR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1951/thumb/wpr.png?1696502934"
    },
    {
      chainId: 1,
      address: "0xea38eaa3c86c8f9b751533ba2e562deb9acded40",
      name: "Etherparty",
      symbol: "FUEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1082/thumb/etherparty.png?1696502182"
    },
    {
      chainId: 1,
      address: "0x3d658390460295fb963f54dc0899cfb1c30776df",
      name: "Circuits of Value",
      symbol: "COVAL",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/588/thumb/coval-logo.png?1696501792"
    },
    {
      chainId: 1,
      address: "0x5cac718a3ae330d361e39244bf9e67ab17514ce8",
      name: "Cosplay Token",
      symbol: "COT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21294/thumb/brave_ZxsjzUc8xn.png?1696520664"
    },
    {
      chainId: 1,
      address: "0x36905fc93280f52362a1cbab151f25dc46742fb5",
      name: "Bottos",
      symbol: "BTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2048/thumb/bottos.png?1696503016"
    },
    {
      chainId: 1,
      address: "0x4ddc2d193948926d02f9b1fe9e1daa0718270ed5",
      name: "cETH",
      symbol: "CETH",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/10643/thumb/ceth.png?1696510617"
    },
    {
      chainId: 1,
      address: "0xee573a945b01b788b9287ce062a0cfc15be9fd86",
      name: "Exeedme",
      symbol: "XED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13518/thumb/exeedme.png?1696513279"
    },
    {
      chainId: 1,
      address: "0x5c6ee304399dbdb9c8ef030ab642b10820db8f56",
      name: "Balancer 80 BAL 20 WETH",
      symbol: "B-80BAL-20WETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26452/thumb/0x5c6ee304399dbdb9c8ef030ab642b10820db8f56.png?1696525525"
    },
    {
      chainId: 1,
      address: "0xbe428c3867f05dea2a89fc76a102b544eac7f772",
      name: "CyberVein",
      symbol: "CVT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3886/thumb/CyberVein_LOGO.png?1696504547"
    },
    {
      chainId: 1,
      address: "0xd0929d411954c47438dc1d871dd6081f5c5e149c",
      name: "Refereum",
      symbol: "RFR",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/2102/thumb/refereum.png?1696503069"
    },
    {
      chainId: 1,
      address: "0xa64dfe8d86963151e6496bee513e366f6e42ed79",
      name: "Goku",
      symbol: "GOKU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17947/thumb/goku.png?1696517467"
    },
    {
      chainId: 1,
      address: "0xa15c7ebe1f07caf6bff097d8a589fb8ac49ae5b3",
      name: "Pundi X  OLD ",
      symbol: "NPXS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2170/thumb/pundi-x.png?1696503130"
    },
    {
      chainId: 1,
      address: "0x515d7e9d75e2b76db60f8a051cd890eba23286bc",
      name: "Governor DAO",
      symbol: "GDAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13140/thumb/GDAOlogo2-bird.png?1696512926"
    },
    {
      chainId: 1,
      address: "0xf5aed4f6a1ad00f39dd21febb6f400ea020030c2",
      name: "Hodless Bot",
      symbol: "HBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32489/thumb/logo-200-200.png?1698476298"
    },
    {
      chainId: 1,
      address: "0xe11ba472f74869176652c35d30db89854b5ae84d",
      name: "HEGIC yVault",
      symbol: "YVHEGIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28798/thumb/yvHEGIC-128-0xe11ba472F74869176652C35D30dB89854b5ae84D.png?1696527776"
    },
    {
      chainId: 1,
      address: "0x4da9b813057d04baef4e5800e36083717b4a0341",
      name: "Aave TUSD v1",
      symbol: "ATUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11724/thumb/aTUSD.png?1696511606"
    },
    {
      chainId: 1,
      address: "0xef53462838000184f35f7d991452e5f25110b207",
      name: "Knit Finance",
      symbol: "KFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15632/thumb/knit.jpg?1696515264"
    },
    {
      chainId: 1,
      address: "0xb40c535c8899f95e3b722df2f0619ebd28c4a4ea",
      name: "Kenda",
      symbol: "KNDA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31692/thumb/kenda_200_200.png?1696530510"
    },
    {
      chainId: 1,
      address: "0xe477292f1b3268687a29376116b0ed27a9c76170",
      name: "HEROcoin",
      symbol: "PLAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2221/thumb/herocoin.png?1696503173"
    },
    {
      chainId: 1,
      address: "0x9d86b1b2554ec410eccffbf111a6994910111340",
      name: "Open Platform",
      symbol: "OPEN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2953/thumb/open-platform.png?1696503697"
    },
    {
      chainId: 1,
      address: "0xd578779dbc9252218e12d18d628e3cb27e4a56f2",
      name: "Britto",
      symbol: "BRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22830/thumb/britto-coin-logo.jpg?1696522131"
    },
    {
      chainId: 1,
      address: "0x2bba3cf6de6058cc1b4457ce00deb359e2703d7f",
      name: "HashCoin",
      symbol: "HSC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4989/thumb/hashfuture-logo.png?1696505523"
    },
    {
      chainId: 1,
      address: "0x3a1bda28adb5b0a812a7cf10a1950c920f79bcd3",
      name: "Gameflip",
      symbol: "FLP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2173/thumb/flp.png?1696503133"
    },
    {
      chainId: 1,
      address: "0x1571ed0bed4d987fe2b498ddbae7dfa19519f651",
      name: "iFARM",
      symbol: "IFARM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14472/thumb/ifarm.png?1696514159"
    },
    {
      chainId: 1,
      address: "0x4740735aa98dc8aa232bd049f8f0210458e7fca3",
      name: "Ridotto",
      symbol: "RDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18671/thumb/200x200_%2832%29.png?1696518141"
    },
    {
      chainId: 1,
      address: "0x370adc71f67f581158dc56f539df5f399128ddf9",
      name: "Aave AMM UniMKRWETH",
      symbol: "AAMMUNIMKRWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17222/thumb/aAmmUniMKRWETH.png?1696516777"
    },
    {
      chainId: 1,
      address: "0x275f5ad03be0fa221b4c6649b8aee09a42d9412a",
      name: "Monavale",
      symbol: "MONA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13298/thumb/monavale_logo.jpg?1696513070"
    },
    {
      chainId: 1,
      address: "0xf921ae2dac5fa128dc0f6168bf153ea0943d2d43",
      name: "Fire Protocol",
      symbol: "FIRE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13495/thumb/fire.jpg?1696513256"
    },
    {
      chainId: 1,
      address: "0xf8483e2d6560585c02d46bf7b3186bf154a96166",
      name: "IdeaChain",
      symbol: "ICH",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/11053/thumb/4fJlFzca_400x400.jpg?1696510995"
    },
    {
      chainId: 1,
      address: "0xc96df921009b790dffca412375251ed1a2b75c60",
      name: "Ormeus Coin",
      symbol: "ORME",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/964/thumb/ORMEUS_logo.png?1696502079"
    },
    {
      chainId: 1,
      address: "0x0abdace70d3790235af448c88547603b945604ea",
      name: "district0x",
      symbol: "DNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/849/thumb/district0x.png?1696501985"
    },
    {
      chainId: 1,
      address: "0x40bb3f1be815ecc5e8279385a8f2893252a6ccbd",
      name: "XVM",
      symbol: "XVM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37022/thumb/XVM_SOLO_%282%29.png?1713155563"
    },
    {
      chainId: 1,
      address: "0xaa99199d1e9644b588796f3215089878440d58e0",
      name: "Alphr",
      symbol: "ALPHR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15029/thumb/alphr.jpg?1696514689"
    },
    {
      chainId: 1,
      address: "0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7",
      name: "TokenClub",
      symbol: "TCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2455/thumb/tokenclub.png?1696503285"
    },
    {
      chainId: 1,
      address: "0x9d91be44c06d373a8a226e1f3b146956083803eb",
      name: "Aave KNC v1",
      symbol: "AKNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11727/thumb/aKNC.png?1696511608"
    },
    {
      chainId: 1,
      address: "0x712db54daa836b53ef1ecbb9c6ba3b9efb073f40",
      name: "Aave ENJ v1",
      symbol: "AENJ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12484/thumb/aENJ.png?1696512301"
    },
    {
      chainId: 1,
      address: "0xf7413489c474ca4399eee604716c72879eea3615",
      name: "APYSwap",
      symbol: "APYS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14163/thumb/apys.png?1696513881"
    },
    {
      chainId: 1,
      address: "0x7deb5e830be29f91e298ba5ff1356bb7f8146998",
      name: "Aave MKR v1",
      symbol: "AMKR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11731/thumb/aMKR.png?1696511612"
    },
    {
      chainId: 1,
      address: "0x5d3a536e4d6dbd6114cc1ead35777bab948e3643",
      name: "cDAI",
      symbol: "CDAI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9281/thumb/cDAI.png?1696509390"
    },
    {
      chainId: 1,
      address: "0x79650799e7899a802cb96c0bc33a6a8d4ce4936c",
      name: "AICHAIN",
      symbol: "AIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2525/thumb/aichain.png?1696503338"
    },
    {
      chainId: 1,
      address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
      name: "Reef",
      symbol: "REEF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13504/thumb/Group_10572.png?1696513266"
    },
    {
      chainId: 1,
      address: "0x92e52a1a235d9a103d970901066ce910aacefd37",
      name: "U CASH",
      symbol: "UCASH",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2901/thumb/ucash.png?1696503651"
    },
    {
      chainId: 1,
      address: "0x23894dc9da6c94ecb439911caf7d337746575a72",
      name: "Geojam",
      symbol: "JAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24648/thumb/200px_Transparent_Bubble_Token_Icon.png?1696523818"
    },
    {
      chainId: 1,
      address: "0xdfbc9050f5b01df53512dcc39b4f2b2bbacd517a",
      name: "Jobchain",
      symbol: "JOB",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9352/thumb/Logo_%283%29.png?1696509452"
    },
    {
      chainId: 1,
      address: "0x39aa39c021dfbae8fac545936693ac917d5e7563",
      name: "cUSDC",
      symbol: "CUSDC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9442/thumb/Compound_USDC.png?1696509534"
    },
    {
      chainId: 1,
      address: "0xbf776e4fca664d791c4ee3a71e2722990e003283",
      name: "Smoothy",
      symbol: "SMTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15039/thumb/dDxKgwPN_400x400.jpg?1696514698"
    },
    {
      chainId: 1,
      address: "0x9f5f3cfd7a32700c93f971637407ff17b91c7342",
      name: "Scry info",
      symbol: "DDD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2569/thumb/Scry.info.jpg?1696503374"
    },
    {
      chainId: 1,
      address: "0x63f584fa56e60e4d0fe8802b27c7e6e3b33e007f",
      name: "ContentBox",
      symbol: "BOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4929/thumb/contentbox.png?1696505470"
    },
    {
      chainId: 1,
      address: "0x1a57367c6194199e5d9aea1ce027431682dfb411",
      name: "MatrixETF",
      symbol: "MDF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18538/thumb/MDF.png?1696518018"
    },
    {
      chainId: 1,
      address: "0x72108a8cc3254813c6be2f1b77be53e185abfdd9",
      name: "Era Swap",
      symbol: "ES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6031/thumb/era_swap.PNG?1696506442"
    },
    {
      chainId: 1,
      address: "0x29cbd0510eec0327992cd6006e63f9fa8e7f33b7",
      name: "Tidal Finance",
      symbol: "TIDAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14460/thumb/Tidal-mono.png?1696514147"
    },
    {
      chainId: 1,
      address: "0x9a64977ebf739dff35ed4281a4b5e833bfdb1314",
      name: "NFTFN",
      symbol: "NFTFN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36624/thumb/NFTFN_TokenPng_%281%29.png?1711982088"
    },
    {
      chainId: 1,
      address: "0xf278c1ca969095ffddded020290cf8b5c424ace2",
      name: "Ruff",
      symbol: "RUFF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2726/thumb/ruff.png?1696503504"
    },
    {
      chainId: 1,
      address: "0xa2847348b58ced0ca58d23c7e9106a49f1427df6",
      name: "Convex FPIS",
      symbol: "CVXFPIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29678/thumb/photo_2023-03-18_21-37-17.jpg?1696528612"
    },
    {
      chainId: 1,
      address: "0xf1f508c7c9f0d1b15a76fba564eef2d956220cf7",
      name: "Pepedex",
      symbol: "PPDEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13022/thumb/output-onlinepngtools-1.png?1696512811"
    },
    {
      chainId: 1,
      address: "0x2001f2a0cf801ecfda622f6c28fb6e10d803d969",
      name: "CoinLoan",
      symbol: "CLT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/1713/thumb/blue-logo-transparent-200x200.png?1696502730"
    },
    {
      chainId: 1,
      address: "0x0cec1a9154ff802e7934fc916ed7ca50bde6844e",
      name: "PoolTogether",
      symbol: "POOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14003/thumb/PoolTogether.png?1696513732"
    },
    {
      chainId: 1,
      address: "0x40955d77f87123b71b145098358a60573ac7be96",
      name: "Daisy Protocol",
      symbol: "DAISY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17844/thumb/daisy.PNG?1696517367"
    },
    {
      chainId: 1,
      address: "0x1e87d63d11d1c16052bbca06d43ba4ceb4ee686c",
      name: "BRC on the ERC",
      symbol: "BRC20",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33534/thumb/brcontheerc.jpg?1702354054"
    },
    {
      chainId: 1,
      address: "0x0aa1582bebf8d96ea384b6829a5d41278579cd88",
      name: "Lyve Finance",
      symbol: "LYVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34627/thumb/e-lox52v_400x400.jpeg?1705546422"
    },
    {
      chainId: 1,
      address: "0x60c24407d01782c2175d32fe7c8921ed732371d1",
      name: "LemoChain",
      symbol: "LEMO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3108/thumb/lemochain.png?1696503836"
    },
    {
      chainId: 1,
      address: "0x7fd4d7737597e7b4ee22acbf8d94362343ae0a79",
      name: "Wrapped MistCoin",
      symbol: "WMC",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/32490/thumb/MistCOin200.png?1698293182"
    },
    {
      chainId: 1,
      address: "0x1b6e9c73bee68102d9dd4a2627f97bff4183ab0a",
      name: "OpenLeverage",
      symbol: "OLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26098/thumb/256x256_OLE_Token_Logo.png?1696525189"
    },
    {
      chainId: 1,
      address: "0x06a01a4d579479dd5d884ebf61a31727a3d8d442",
      name: "Skey Network",
      symbol: "SKEY",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13425/thumb/SKEY_Network_logo_black.png?1696513185"
    },
    {
      chainId: 1,
      address: "0xdf347911910b6c9a4286ba8e2ee5ea4a39eb2134",
      name: "Bob s Repair",
      symbol: "BOB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3550/thumb/PNG_BOB_Token_Large.png?1696504237"
    },
    {
      chainId: 1,
      address: "0x0b4bdc478791897274652dc15ef5c135cae61e60",
      name: "DAEX",
      symbol: "DAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4063/thumb/daex.png?1696504696"
    },
    {
      chainId: 1,
      address: "0x0557e0d15aec0b9026dd17aa874fdf7d182a2ceb",
      name: "CFX Quantum",
      symbol: "CFXQ",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/15031/thumb/CFXQ_TOKEN_LOGO_200x200.png?1696514691"
    },
    {
      chainId: 1,
      address: "0x4c6ec08cf3fc987c6c4beb03184d335a2dfc4042",
      name: "MurAll",
      symbol: "PAINT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14103/thumb/paint_logo_200x200.png?1696513825"
    },
    {
      chainId: 1,
      address: "0x0335a7610d817aeca1bebbefbd392ecc2ed587b8",
      name: "Nitro League",
      symbol: "NITRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21668/thumb/_X6vYBDM_400x400.jpg?1696521025"
    },
    {
      chainId: 1,
      address: "0x6a969d379700b2e5ea4e684d273d63c1c050ba49",
      name: "Pacific",
      symbol: "PAF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20915/thumb/paf.png?1696520306"
    },
    {
      chainId: 1,
      address: "0xd71ecff9342a5ced620049e616c5035f1db98620",
      name: "sEUR",
      symbol: "SEUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13637/thumb/sEUR.png?1696513385"
    },
    {
      chainId: 1,
      address: "0x78132543d8e20d2417d8a07d9ae199d458a0d581",
      name: "Luna Inu",
      symbol: "LINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25623/thumb/output-onlinepngtools.png?1696524757"
    },
    {
      chainId: 1,
      address: "0x6d614686550b9e1c1df4b2cd8f91c9d4df66c810",
      name: "Skeb",
      symbol: "SKEB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27155/thumb/skebcoin-cmc.png?1696526206"
    },
    {
      chainId: 1,
      address: "0x46d0dac0926fa16707042cadc23f1eb4141fe86b",
      name: "SONM",
      symbol: "SNM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/861/thumb/sonm.png?1696501995"
    },
    {
      chainId: 1,
      address: "0xc221b7e65ffc80de234bbb6667abdd46593d34f0",
      name: "Wrapped Centrifuge",
      symbol: "WCFG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17106/thumb/WCFG.jpg?1696516667"
    },
    {
      chainId: 1,
      address: "0xcda2f16c6aa895d533506b426aff827b709c87f5",
      name: "Fairum",
      symbol: "FAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13894/thumb/logo-65ce48ea8d2b64b6478a42c0050214e2.png?1696513637"
    },
    {
      chainId: 1,
      address: "0xaf9f549774ecedbd0966c52f250acc548d3f36e5",
      name: "RioDeFi",
      symbol: "RFUEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12623/thumb/RFUEL_SQR.png?1696512430"
    },
    {
      chainId: 1,
      address: "0x444444444444c1a66f394025ac839a535246fcc8",
      name: "Genius",
      symbol: "GENI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28621/thumb/GENI200x200.png?1696527606"
    },
    {
      chainId: 1,
      address: "0x85b6acaba696b9e4247175274f8263f99b4b9180",
      name: "Spiral",
      symbol: "SPR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33300/thumb/logo6s1_4_%281%29.png?1701403013"
    },
    {
      chainId: 1,
      address: "0x29ceddcf0da3c1d8068a7dfbd0fb06c2e438ff70",
      name: "Freela",
      symbol: "FREL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15856/thumb/freela.PNG?1696515472"
    },
    {
      chainId: 1,
      address: "0x50de6856358cc35f3a9a57eaaa34bd4cb707d2cd",
      name: "Razor Network",
      symbol: "RAZOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13797/thumb/icon.png?1696513545"
    },
    {
      chainId: 1,
      address: "0x9b00e6e8d787b13756eb919786c9745054db64f9",
      name: "Sienna  ERC 20 ",
      symbol: "WSIENNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15420/thumb/sienna.jpeg?1696515066"
    },
    {
      chainId: 1,
      address: "0xa13f0743951b4f6e3e3aa039f682e17279f52bc3",
      name: "Sentinel Chain",
      symbol: "SENC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2960/thumb/sentinel-chain.jpg?1696503703"
    },
    {
      chainId: 1,
      address: "0xa1e349fac47e50b42cd323c4285ef4622b60a5e0",
      name: "Pepy coin",
      symbol: "PEPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36966/thumb/pepy_cr_%281%29.jpg?1712908045"
    },
    {
      chainId: 1,
      address: "0x6c8c6b02e7b2be14d4fa6022dfd6d75921d90e4e",
      name: "cBAT",
      symbol: "CBAT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/10645/thumb/cBAT1.JPG?1696510619"
    },
    {
      chainId: 1,
      address: "0x15b543e986b8c34074dfc9901136d9355a537e7e",
      name: "Student Coin",
      symbol: "STC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6260/thumb/logo_in_circle_%281%29.png?1696506642"
    },
    {
      chainId: 1,
      address: "0xaae3cf9968d26925bdb73ce3864e0084a20f4687",
      name: "Farmland Protocol",
      symbol: "FAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13497/thumb/70059912.jpg?1696513260"
    },
    {
      chainId: 1,
      address: "0xc25a3a3b969415c80451098fa907ec722572917f",
      name: "LP sCurve",
      symbol: "SCURVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11899/thumb/Curvefi_sCrv_32.png?1696511765"
    },
    {
      chainId: 1,
      address: "0xb3319f5d18bc0d84dd1b4825dcde5d5f7266d407",
      name: "c0x",
      symbol: "CZRX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/10644/thumb/czrx1.JPG?1696510618"
    },
    {
      chainId: 1,
      address: "0xa8b0f154a688c22142e361707df64277e0a0be66",
      name: "Rake Finance",
      symbol: "RAK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13078/thumb/rake-logo-200x200.png?1696512866"
    },
    {
      chainId: 1,
      address: "0x23352036e911a22cfc692b5e2e196692658aded9",
      name: "Friendz",
      symbol: "FDZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3685/thumb/download_%2812%29.png?1696504361"
    },
    {
      chainId: 1,
      address: "0xab846fb6c81370327e784ae7cbb6d6a6af6ff4bf",
      name: "Paladin",
      symbol: "PAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24558/thumb/Circle-Logo.png?1696523734"
    },
    {
      chainId: 1,
      address: "0xa64bd6c70cb9051f6a9ba1f163fdc07e0dfb5f84",
      name: "Aave LINK v1",
      symbol: "ALINK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11729/thumb/aLINK.png?1696511610"
    },
    {
      chainId: 1,
      address: "0xad5fe5b0b8ec8ff4565204990e4405b2da117d8e",
      name: "TronClassic",
      symbol: "TRXC",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/4626/thumb/trxc.png?1696505197"
    },
    {
      chainId: 1,
      address: "0xe5b826ca2ca02f09c1725e9bd98d9a8874c30532",
      name: "ZEON Network",
      symbol: "ZEON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4247/thumb/XZqXYc2j_400x400.jpg?1696504861"
    },
    {
      chainId: 1,
      address: "0x1f8a626883d7724dbd59ef51cbd4bf1cf2016d13",
      name: "Jigstack",
      symbol: "STAK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14978/thumb/jigstack.PNG?1696514641"
    },
    {
      chainId: 1,
      address: "0x6a4c76874e686a7d080d173987a35a9c48905583",
      name: "Luxurious Pro Network",
      symbol: "LPNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14126/thumb/logo_%2894%29.png?1696513847"
    },
    {
      chainId: 1,
      address: "0xcbcc0f036ed4788f63fc0fee32873d6a7487b908",
      name: "Humaniq",
      symbol: "HMQ",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/647/thumb/humaniq.jpg?1696501841"
    },
    {
      chainId: 1,
      address: "0xad78d154baec2e9b4e78182d02388981b5093f80",
      name: "Soyjak",
      symbol: "SOY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33041/thumb/soyjak256_%282%29.png?1700428317"
    },
    {
      chainId: 1,
      address: "0x05d3606d5c81eb9b7b18530995ec9b29da05faba",
      name: "TomoChain ERC 20",
      symbol: "TOMOE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12646/thumb/tomoe_logo.png?1696512453"
    },
    {
      chainId: 1,
      address: "0xb2617246d0c6c0087f18703d576831899ca94f01",
      name: "Zignaly",
      symbol: "ZIG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14796/thumb/zignaly.jpg?1704292004"
    },
    {
      chainId: 1,
      address: "0x03042482d64577a7bdb282260e2ea4c8a89c064b",
      name: "Centaur",
      symbol: "CNTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12743/thumb/logo_%2898%29.png?1696512542"
    },
    {
      chainId: 1,
      address: "0xb67718b98d52318240c52e71a898335da4a28c42",
      name: "Innovative Bioresearch Coin",
      symbol: "INNBC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/4043/thumb/INNBC.png?1696504678"
    },
    {
      chainId: 1,
      address: "0x0cdf9acd87e940837ff21bb40c9fd55f68bba059",
      name: "Public Mint",
      symbol: "MINT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14106/thumb/Public_Mint_Icon_200x200.png?1696513827"
    },
    {
      chainId: 1,
      address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
      name: "Pundi X",
      symbol: "PUNDIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14571/thumb/vDyefsXq_400x400.jpg?1696514252"
    },
    {
      chainId: 1,
      address: "0x4bcea5e4d0f6ed53cf45e7a28febb2d3621d7438",
      name: "Modex",
      symbol: "MODEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2851/thumb/LhWIeAg.png?1696503608"
    },
    {
      chainId: 1,
      address: "0xf0d33beda4d734c72684b5f9abbebf715d0a7935",
      name: "NuNet",
      symbol: "NTX",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/20950/thumb/8Zb2W2Wi_400x400.png?1696520338"
    },
    {
      chainId: 1,
      address: "0x3f5294df68f871241c4b18fcf78ebd8ac18ab654",
      name: "99Starz",
      symbol: "STZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21467/thumb/stz.png?1696520828"
    },
    {
      chainId: 1,
      address: "0x6aeb95f06cda84ca345c2de0f3b7f96923a44f4c",
      name: "Rentberry",
      symbol: "BERRY",
      decimals: 14,
      logoURI: "https://assets.coingecko.com/coins/images/1787/thumb/rentberry.png?1696502792"
    },
    {
      chainId: 1,
      address: "0x7e9e431a0b8c4d532c745b1043c7fa29a48d4fba",
      name: "eosDAC",
      symbol: "EOSDAC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3878/thumb/2644.png?1696504539"
    },
    {
      chainId: 1,
      address: "0xaf91e8afbe87642dc628786188a54b78580a4d76",
      name: "Fund Of Yours",
      symbol: "FOY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16648/thumb/foy200.png?1696516209"
    },
    {
      chainId: 1,
      address: "0x159a1dfae19057de57dfffcbb3da1ae784678965",
      name: "Reflex",
      symbol: "RFX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/12745/thumb/2MKGMRCT_400x400.png?1696512543"
    },
    {
      chainId: 1,
      address: "0xc7bba5b765581efb2cdd2679db5bea9ee79b201f",
      name: "Gems",
      symbol: "GEM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3945/thumb/Webp.net-resizeimage_%2817%29.jpg?1696504590"
    },
    {
      chainId: 1,
      address: "0x9e10f61749c4952c320412a6b26901605ff6da1d",
      name: "Theos",
      symbol: "THEOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18150/thumb/theos_logo.png?1696517652"
    },
    {
      chainId: 1,
      address: "0xada86b1b313d1d5267e3fc0bb303f0a2b66d0ea7",
      name: "Covesting",
      symbol: "COV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1950/thumb/covesting.png?1696502933"
    },
    {
      chainId: 1,
      address: "0x4ec1b60b96193a64acae44778e51f7bff2007831",
      name: "Edge",
      symbol: "EDGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1848/thumb/EDGE.png?1696502846"
    },
    {
      chainId: 1,
      address: "0x9d9e399e5385e2b9a58d4f775a1e16441b571afb",
      name: "Metano",
      symbol: "METANO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28183/thumb/logo200x.jpeg?1696527186"
    },
    {
      chainId: 1,
      address: "0xadd5e881984783dd432f80381fb52f45b53f3e70",
      name: "Vite",
      symbol: "VITE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4513/thumb/VITE_new_logo_200px.png?1709175957"
    },
    {
      chainId: 1,
      address: "0x5b322514ff727253292637d9054301600c2c81e8",
      name: "DAD",
      symbol: "DAD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/9833/thumb/q_Vt0ajV_400x400.jpg?1696509888"
    },
    {
      chainId: 1,
      address: "0x006bea43baa3f7a6f765f14f10a1a1b08334ef45",
      name: "Stox",
      symbol: "STX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1230/thumb/stox-token.png?1696502307"
    },
    {
      chainId: 1,
      address: "0x4c341d939444e79e68074b0d1e96ddd3bc618104",
      name: "Brick Block",
      symbol: "BB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36982/thumb/IMG_1013.jpeg?1712943445"
    },
    {
      chainId: 1,
      address: "0xb81408a1cc2f4be70a6a3178d351ca95a77c5a06",
      name: "Xodex",
      symbol: "XODEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25551/thumb/XODEX_Avatar_02.png?1711716939"
    },
    {
      chainId: 1,
      address: "0x31e6506751437428ae8f2e15ec4a3d2e33d4f8a4",
      name: "AePos Network",
      symbol: "AEPOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35402/thumb/logo_%284%29.png?1708494833"
    },
    {
      chainId: 1,
      address: "0x23ddbd36547d43627afa9b42d4e9fb0515f48b09",
      name: "hiBEANZ",
      symbol: "HIBEANZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29281/thumb/hibeanz.png?1696528234"
    },
    {
      chainId: 1,
      address: "0x228ba514309ffdf03a81a205a6d040e429d6e80c",
      name: "Global Social Chain",
      symbol: "GSC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4304/thumb/global-social-chain.png?1696504911"
    },
    {
      chainId: 1,
      address: "0x9b4e2b4b13d125238aa0480dd42b4f6fc71b37cc",
      name: "MyToken",
      symbol: "MT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4109/thumb/2712.png?1696504736"
    },
    {
      chainId: 1,
      address: "0x3ebb4a4e91ad83be51f8d596533818b246f4bee1",
      name: "Signata",
      symbol: "SATA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14704/thumb/logo.png?1696514375"
    },
    {
      chainId: 1,
      address: "0xa8b12cc90abf65191532a12bb5394a714a46d358",
      name: "pBTC35A",
      symbol: "PBTC35A",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13653/thumb/pBTC35A.png?1696513402"
    },
    {
      chainId: 1,
      address: "0x8b937af714ac7e2129bd33d93641f52b665ca352",
      name: "JizzRocket",
      symbol: "JIZZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28985/thumb/bLQvXuh_%281%29.png?1696527958"
    },
    {
      chainId: 1,
      address: "0xc08512927d12348f6620a698105e1baac6ecd911",
      name: "GYEN",
      symbol: "GYEN",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/14191/thumb/icon_gyen_200_200.png?1696513909"
    },
    {
      chainId: 1,
      address: "0x47481c1b44f2a1c0135c45aa402ce4f4dde4d30e",
      name: "Meetple",
      symbol: "MPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14323/thumb/Tqlsvhn1_400x400.png?1696514012"
    },
    {
      chainId: 1,
      address: "0x7240ac91f01233baaf8b064248e80feaa5912ba3",
      name: "OctoFi",
      symbol: "OCTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12594/thumb/octofi-256x256-radius-22percent.png?1696512403"
    },
    {
      chainId: 1,
      address: "0xbc4171f45ef0ef66e76f979df021a34b46dcc81d",
      name: "Dora Factory  OLD ",
      symbol: "DORA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14478/thumb/dora_logo.jpg?1696514164"
    },
    {
      chainId: 1,
      address: "0x3a8d5bc8a8948b68dfc0ce9c14ac4150e083518c",
      name: "Paralink Network",
      symbol: "PARA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15789/thumb/para.PNG?1696515412"
    },
    {
      chainId: 1,
      address: "0x4abb9cc67bd3da9eb966d1159a71a0e68bd15432",
      name: "KelVPN",
      symbol: "KEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14851/thumb/logokelvpn200x200.png?1696514517"
    },
    {
      chainId: 1,
      address: "0xa21af1050f7b26e0cff45ee51548254c41ed6b5c",
      name: "Osaka Protocol",
      symbol: "OSAK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30911/thumb/osak_logo.png?1696529756"
    },
    {
      chainId: 1,
      address: "0xdb2f2bcce3efa95eda95a233af45f3e0d4f00e2a",
      name: "Aegis",
      symbol: "AGS",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/12391/thumb/logo-3.png?1696512214"
    },
    {
      chainId: 1,
      address: "0xd945d2031b4c63c0e363304fb771f709b502dc0a",
      name: "BountyMarketCap",
      symbol: "BMC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13472/thumb/bmc-logo-200.png?1696513233"
    },
    {
      chainId: 1,
      address: "0xc834fa996fa3bec7aad3693af486ae53d8aa8b50",
      name: "Convergence",
      symbol: "CONV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14519/thumb/Convergence_Logo_%28Final%29.png?1696514204"
    },
    {
      chainId: 1,
      address: "0x624d520bab2e4ad83935fa503fb130614374e850",
      name: "Smartshare",
      symbol: "SSP",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/4642/thumb/smartshare.png?1696505210"
    },
    {
      chainId: 1,
      address: "0x5228a22e72ccc52d415ecfd199f99d0665e7733b",
      name: "pTokens BTC  OLD ",
      symbol: "PBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10805/thumb/J51iIea.png?1696510764"
    },
    {
      chainId: 1,
      address: "0xaec7d1069e3a914a3eb50f0bfb1796751f2ce48a",
      name: "S4FE",
      symbol: "S4F",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7405/thumb/logo_%284%29.png?1696507681"
    },
    {
      chainId: 1,
      address: "0x76960dccd5a1fe799f7c29be9f19ceb4627aeb2f",
      name: "Red",
      symbol: "RED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4523/thumb/red.png?1696505107"
    },
    {
      chainId: 1,
      address: "0xadb2437e6f65682b85f814fbc12fec0508a7b1d0",
      name: "UNCX Network",
      symbol: "UNCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12871/thumb/uncx.png?1696512659"
    },
    {
      chainId: 1,
      address: "0x62359ed7505efc61ff1d56fef82158ccaffa23d7",
      name: "cVault finance",
      symbol: "CORE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12635/thumb/cvault.finance_logo.png?1601353499"
    },
    {
      chainId: 1,
      address: "0x068e3563b1c19590f822c0e13445c4fa1b9eefa5",
      name: "Wrapped USD",
      symbol: "WUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28854/thumb/wusd.png?1696527828"
    },
    {
      chainId: 1,
      address: "0x20fcefa41045080764c48c2b9429e44c644e5dea",
      name: "Foox  Ordinals ",
      symbol: "FOOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33692/thumb/Foox_Logo.png?1702796923"
    },
    {
      chainId: 1,
      address: "0x837ee5a664d51bc2e7d26eb63cffeb48e037bde2",
      name: "NomotaAI",
      symbol: "NMAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37055/thumb/logo_spaced_200.png?1713171582"
    },
    {
      chainId: 1,
      address: "0x0f8c45b896784a1e408526b9300519ef8660209c",
      name: "XMax",
      symbol: "XMX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/4643/thumb/xmx.png?1696505211"
    },
    {
      chainId: 1,
      address: "0x446c9033e7516d820cc9a2ce2d0b7328b579406f",
      name: "SOLVE",
      symbol: "SOLVE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/1768/thumb/Solve.Token_logo_200_200_wiyhout_BG.png?1696502776"
    },
    {
      chainId: 1,
      address: "0x5afff9876c1f98b7d2b53bcb69eb57e92408319f",
      name: "metavisa",
      symbol: "MESA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23246/thumb/twitteravatar_circle.png?1696522466"
    },
    {
      chainId: 1,
      address: "0x8793fb615eb92822f482f88b3137b00aad4c00d2",
      name: "revoAI",
      symbol: "REVOAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28952/thumb/roveAI1_%283%29.png?1696527925"
    },
    {
      chainId: 1,
      address: "0x0b9ae6b1d4f0eeed904d1cef68b9bd47499f3fff",
      name: "IlluminatiCoin",
      symbol: "NATI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32399/thumb/CMCIcon.png?1698055172"
    },
    {
      chainId: 1,
      address: "0xb2e96a63479c2edd2fd62b382c89d5ca79f572d3",
      name: "Zenon",
      symbol: "ZNN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/30753/thumb/zenon.jpg?1696529622"
    },
    {
      chainId: 1,
      address: "0xe530441f4f73bdb6dc2fa5af7c3fc5fd551ec838",
      name: "GSENetwork",
      symbol: "GSE",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/4776/thumb/gsenetwork.png?1696505333"
    },
    {
      chainId: 1,
      address: "0xccf4429db6322d5c611ee964527d42e5d685dd6a",
      name: "cWBTC",
      symbol: "CWBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/10823/thumb/cwbtc.png?1696510780"
    },
    {
      chainId: 1,
      address: "0x62b9c7356a2dc64a1969e19c23e4f579f9810aa7",
      name: "Convex CRV",
      symbol: "CVXCRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15586/thumb/convex-crv.png?1696515222"
    },
    {
      chainId: 1,
      address: "0x3a4cab3dcfab144fe7eb2b5a3e288cc03dc07659",
      name: "OnGo",
      symbol: "FTG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20154/thumb/IMG-20220728-WA0004.jpg?1696519568"
    },
    {
      chainId: 1,
      address: "0xe1ba0fb44ccb0d11b80f92f4f8ed94ca3ff51d00",
      name: "Aave BAT v1",
      symbol: "ABAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11726/thumb/aBAT.png?1696511608"
    },
    {
      chainId: 1,
      address: "0xe1bad922f84b198a08292fb600319300ae32471b",
      name: "Firmachain",
      symbol: "FCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9892/thumb/6mHcLurm_400x400.jpg?1696509941"
    },
    {
      chainId: 1,
      address: "0xd559f20296ff4895da39b5bd9add54b442596a61",
      name: "FintruX",
      symbol: "FTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1928/thumb/token-500x500.png?1696502917"
    },
    {
      chainId: 1,
      address: "0xbea0000029ad1c77d3d5d23ba2d8893db9d1efab",
      name: "Bean",
      symbol: "BEAN",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/18447/thumb/bean-logo-coingecko.png?1696517934"
    },
    {
      chainId: 1,
      address: "0x38e68a37e401f7271568cecaac63c6b1e19130b4",
      name: "Banana Gun",
      symbol: "BANANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31744/thumb/bgg.jpeg?1696530563"
    },
    {
      chainId: 1,
      address: "0x69948cc03f478b95283f7dbf1ce764d0fc7ec54c",
      name: "Aave REN v1",
      symbol: "AREN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12483/thumb/aREN.png?1696512300"
    },
    {
      chainId: 1,
      address: "0xca3ea3061d638e02113aa960340c98343b5acd62",
      name: "Bittwatt",
      symbol: "BWT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4777/thumb/bittwatt.png?1547274101"
    },
    {
      chainId: 1,
      address: "0x4e4a47cac6a28a62dcc20990ed2cda9bc659469f",
      name: "I will poop it NFT",
      symbol: "SHIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25945/thumb/PCNoOl8.png?1696525024"
    },
    {
      chainId: 1,
      address: "0xfc1e690f61efd961294b3e1ce3313fbd8aa4f85d",
      name: "Aave DAI v1",
      symbol: "ADAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10843/thumb/aDAI.png?1696510799"
    },
    {
      chainId: 1,
      address: "0x6fb0855c404e09c47c3fbca25f08d4e41f9f062f",
      name: "Aave ZRX v1",
      symbol: "AZRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11735/thumb/aZRX.png?1696511616"
    },
    {
      chainId: 1,
      address: "0x328c4c80bc7aca0834db37e6600a6c49e12da4de",
      name: "Aave SNX v1",
      symbol: "ASNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11733/thumb/aSNX.png?1696511614"
    },
    {
      chainId: 1,
      address: "0x996229d0c6a485c7f4b52e092eaa907cb2def5c6",
      name: "BuckHath Coin",
      symbol: "BHIG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7821/thumb/logstex.PNG?1585121237"
    },
    {
      chainId: 1,
      address: "0x916c5de09cf63f6602d1e1793fb41f6437814a62",
      name: "JACY",
      symbol: "JACY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19740/thumb/tBwbvjZK_400x400.jpg?1696519164"
    },
    {
      chainId: 1,
      address: "0x30f271c9e86d2b7d00a6376cd96a1cfbd5f0b9b3",
      name: "Decentr",
      symbol: "DEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11816/thumb/Decentr.png?1696511689"
    },
    {
      chainId: 1,
      address: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
      name: "Rai Reflex Index",
      symbol: "RAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1696513733"
    },
    {
      chainId: 1,
      address: "0xe8ff5c9c75deb346acac493c463c8950be03dfba",
      name: "VIBE",
      symbol: "VIBE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/948/thumb/vibe.png?1696502064"
    },
    {
      chainId: 1,
      address: "0x471d113059324321749e097705197a2b44a070fc",
      name: "Kanga Exchange",
      symbol: "KNG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21188/thumb/KNG_logo-200.png?1696520564"
    },
    {
      chainId: 1,
      address: "0x8edc6f7d2f23c10653972e611f707ce0562d61b1",
      name: "MultiDEX AI",
      symbol: "MDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35403/thumb/Multidex.jpg?1708499023"
    },
    {
      chainId: 1,
      address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
      name: "Swerve",
      symbol: "SWRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12361/thumb/swerve.png?1696512186"
    },
    {
      chainId: 1,
      address: "0x4fe83213d56308330ec302a8bd641f1d0113a4cc",
      name: "NuCypher",
      symbol: "NU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3318/thumb/photo1198982838879365035.jpg?1696504026"
    },
    {
      chainId: 1,
      address: "0xda31d0d1bc934fc34f7189e38a413ca0a5e8b44f",
      name: "BitStable Finance",
      symbol: "BSSB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33545/thumb/07LKCLMU_400x400.jpg?1705046428"
    },
    {
      chainId: 1,
      address: "0x4db26817c88a57d2ef84cfd90168f535ee83bda9",
      name: "hiAZUKI",
      symbol: "HIAZUKI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28565/thumb/hiazuki.png?1696527554"
    },
    {
      chainId: 1,
      address: "0x2dd1b9410c73e16b60240e529e38e30425f00d4e",
      name: "Kay Pacha",
      symbol: "PACHA",
      decimals: 10,
      logoURI: "https://assets.coingecko.com/coins/images/27194/thumb/0_Lzf-8HxwOnPjYWi-.jpeg?1696526243"
    },
    {
      chainId: 1,
      address: "0xdf8ef8fef6fa5489d097652dedfb6617ce28a0d6",
      name: "dump trade",
      symbol: "DUMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36984/thumb/logo.png?1712945749"
    },
    {
      chainId: 1,
      address: "0x5dc60c4d5e75d22588fa17ffeb90a63e535efce0",
      name: "dKargo",
      symbol: "DKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11875/thumb/bVD0g0dlmrEOPIkt943KZIBZ086eCshyY0jIQFti4zxYdOlFltU8tKa6uJlcA14HvNjX4bc7dxdMvlpoW5NFMND85oG4aiiCbFRhI6eowDfKEBY3BoSVY0IrBbA9SFGIxh_IYrkNC5uNdG-roZ0_TlGO3098now6Tbzga0p4IDqVk6lnaX3TuRC7pgnAYWZM15RD-uEIHr3O_3OoIIWP-.jpg?1696511743"
    },
    {
      chainId: 1,
      address: "0x5fa20d59d2a907e5fed9fb80b4a8d9f0d069a48d",
      name: "Noggles",
      symbol: "NOGS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37238/thumb/nogs.jpeg?1713851209"
    },
    {
      chainId: 1,
      address: "0x943ed852dadb5c3938ecdc6883718df8142de4c8",
      name: "FansTime",
      symbol: "FTI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4952/thumb/fanstime.png?1696505490"
    },
    {
      chainId: 1,
      address: "0x3802c218221390025bceabbad5d8c59f40eb74b8",
      name: "Guarded Ether",
      symbol: "GETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14001/thumb/guarda-shield-logo.png?1696513730"
    },
    {
      chainId: 1,
      address: "0x990e081a7b7d3ccba26a2f49746a68cc4ff73280",
      name: "KStarCoin",
      symbol: "KSC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1630/thumb/ksc.png?1696502658"
    },
    {
      chainId: 1,
      address: "0xbc0e2969d23a084a0bb65a2b9a4242e7f9ea65b6",
      name: "Clippy AI",
      symbol: "CLIPPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33124/thumb/PHOTO-2023-11-10-23-46-27.jpg?1700794900"
    },
    {
      chainId: 1,
      address: "0x5c59a5b139b0538cb106d775a022cad98dd14b5a",
      name: "XREATORS",
      symbol: "ORT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25678/thumb/XREATORS_ORT_Logo.png?1696524806"
    },
    {
      chainId: 1,
      address: "0xd26114cd6ee289accf82350c8d8487fedb8a0c07",
      name: "OMG Network",
      symbol: "OMG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/776/thumb/OMG_Network.jpg?1696501928"
    },
    {
      chainId: 1,
      address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
      name: "Frontier",
      symbol: "FRONT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12479/thumb/frontier_logo.png?1696512296"
    },
    {
      chainId: 1,
      address: "0x6e98e5401adcb0d76f4debfc3d794b3031f48790",
      name: "Aurix",
      symbol: "AUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14372/thumb/gold-brown-2.png?1696514064"
    },
    {
      chainId: 1,
      address: "0x6b15602f008a05d9694d777dead2f05586216cb4",
      name: "Cyclix Games",
      symbol: "CYG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37247/thumb/CG_LOGO.png?1714070727"
    },
    {
      chainId: 1,
      address: "0x6cacdb97e3fc8136805a9e7c342d866ab77d0957",
      name: "Swapr",
      symbol: "SWPR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18740/thumb/swapr.jpg?1696518206"
    },
    {
      chainId: 1,
      address: "0xebb4c56dd5490156ae94a96e11903a2d5ff81deb",
      name: "GMBot",
      symbol: "GMBT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32823/thumb/SD6IB_md_400x400.jpg?1699582313"
    },
    {
      chainId: 1,
      address: "0x6ad2d2c22bb58ea94be18cff11ef67e8bb97b652",
      name: "Trestle Wrapped TIA",
      symbol: "WTIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36385/thumb/trestle.jpeg?1711349480"
    },
    {
      chainId: 1,
      address: "0x299a1503e88433c0fd1bd68625c25c5a703eb64f",
      name: "TEAR",
      symbol: "TEAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35416/thumb/tearcoin.png?1708507106"
    },
    {
      chainId: 1,
      address: "0x419777d3e39aa9b00405724eace5ea57620c9062",
      name: "PAW",
      symbol: "PAW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32118/thumb/photo1701025138-removebg-preview__5_-removebg-preview.png?1701386426"
    },
    {
      chainId: 1,
      address: "0xe3818504c1b32bf1557b16c238b2e01fd3149c17",
      name: "Pillar",
      symbol: "PLR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/809/thumb/v2logo-1.png?1696501958"
    },
    {
      chainId: 1,
      address: "0x0fcbc31c503b4a9ed90e87f8ff46c318a4a14260",
      name: "Quantfury",
      symbol: "QTF",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/14033/thumb/FtSOX9Vy_400x400.jpg?1696513760"
    },
    {
      chainId: 1,
      address: "0x37e1160184f7dd29f00b78c050bf13224780b0b0",
      name: "Yuan Chain Coin",
      symbol: "YCC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/5328/thumb/G5gCEo-J_400x400.jpg?1696505823"
    },
    {
      chainId: 1,
      address: "0x4e12eb8e506ccd1427f6b8f7faa3e88fb698eb28",
      name: "Jack Token",
      symbol: "JACK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10991/thumb/Jacktoken200x200.png?1696510939"
    },
    {
      chainId: 1,
      address: "0x8cc379a292a47cb8406fb1bd8a6d98f442275f0e",
      name: "Uranium3o8",
      symbol: "U",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32571/thumb/Logo_Black_Background.png?1698608787"
    },
    {
      chainId: 1,
      address: "0x31c2415c946928e9fd1af83cdfa38d3edbd4326f",
      name: "MADworld",
      symbol: "UMAD",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/20939/thumb/UMAD_.png?1696520328"
    },
    {
      chainId: 1,
      address: "0xd377f28245bc505190c8f34d2bfe5f215754f634",
      name: "0xLiquidity",
      symbol: "0XLP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35367/thumb/Logo_MAIN.jpg?1708400938"
    },
    {
      chainId: 1,
      address: "0x2565ae0385659badcada1031db704442e1b69982",
      name: "Assemble Protocol",
      symbol: "ASM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11605/thumb/gpvrlkSq_400x400_%281%29.jpg?1696511500"
    },
    {
      chainId: 1,
      address: "0x7ecbb21346c501fd07eb165e406120fa32381c16",
      name: "Ecoreal Estate",
      symbol: "ECOREAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6431/thumb/golden_leave_in_200_x_200.png?1696506796"
    },
    {
      chainId: 1,
      address: "0x07e3c70653548b04f0a75970c1f81b4cbbfb606f",
      name: "Agrello",
      symbol: "DLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/900/thumb/delta_200x200.png?1696502023"
    },
    {
      chainId: 1,
      address: "0x23fa3aa82858e7ad1f0f04352f4bb7f5e1bbfb68",
      name: "Frictionless",
      symbol: "FRIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36783/thumb/Fric_logo_200X200.png?1712331864"
    },
    {
      chainId: 1,
      address: "0xe02f72be83855c9e400fd9cd9f83158abfc87053",
      name: "CHECKMATE",
      symbol: "CMBOT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/33348/thumb/checkmate200x200.png?1701561194"
    },
    {
      chainId: 1,
      address: "0xcdbb2498fa9e7b5849bed5d3661386d0ce2733b2",
      name: "FuturesAI",
      symbol: "FAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36830/thumb/photo_2024-04-03_22.01.57.jpeg?1712557619"
    },
    {
      chainId: 1,
      address: "0x7d8daff6d70cead12c6f077048552cf89130a2b1",
      name: "ARCS",
      symbol: "ARX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10068/thumb/arcs.png?1696510099"
    },
    {
      chainId: 1,
      address: "0x6d10e0194400a04600881057787eb9e9c063dca0",
      name: "Proton Project",
      symbol: "PRTN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14888/thumb/prtn_200_px_.png?1710000932"
    },
    {
      chainId: 1,
      address: "0xc7ff1e126cc81e816915ff48c940ed9d4e6d05d6",
      name: "IjasCoin",
      symbol: "IJC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14099/thumb/Ijascode-Flat-Logo-2-24-2021.png?1696513821"
    },
    {
      chainId: 1,
      address: "0x9aeb50f542050172359a0e1a25a9933bc8c01259",
      name: "OIN Finance",
      symbol: "OIN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/12339/thumb/OIN_FInance_-_cLogo-01.png?1696512166"
    },
    {
      chainId: 1,
      address: "0x0e573ce2736dd9637a0b21058352e1667925c7a8",
      name: "Verified USD",
      symbol: "USDV",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/32948/thumb/usdv_%281%29.png?1699933314"
    },
    {
      chainId: 1,
      address: "0xff19138b039d938db46bdda0067dc4ba132ec71c",
      name: "Snetwork",
      symbol: "SNET",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/5382/thumb/snetwork.png?1696505867"
    },
    {
      chainId: 1,
      address: "0xe8663a64a96169ff4d95b4299e7ae9a76b905b31",
      name: "DPRating",
      symbol: "RATING",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/5383/thumb/dprating.png?1696505868"
    },
    {
      chainId: 1,
      address: "0x177ba0cac51bfc7ea24bad39d81dcefd59d74faa",
      name: "KittenFinance",
      symbol: "KIF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12340/thumb/SnQPkABT_400x400.png?1696512167"
    },
    {
      chainId: 1,
      address: "0xfc226294dafb6e69905b3e7635b575d0508a42c5",
      name: "0xBlack",
      symbol: "0XB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33301/thumb/oxb_metal.png?1701403803"
    },
    {
      chainId: 1,
      address: "0xb1f871ae9462f1b2c6826e88a7827e76f86751d4",
      name: "GNY",
      symbol: "GNY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5300/thumb/GNY_LOGO_NEW_TRANS.png?1696505799"
    },
    {
      chainId: 1,
      address: "0x6468e79a80c0eab0f9a2b574c8d5bc374af59414",
      name: "e Radix",
      symbol: "EXRD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13145/thumb/exrd_logo.png?1696512931"
    },
    {
      chainId: 1,
      address: "0xec213f83defb583af3a000b1c0ada660b1902a0f",
      name: "Presearch",
      symbol: "PRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1299/thumb/presearch.png?1696502369"
    },
    {
      chainId: 1,
      address: "0x6eff556748ee452cbdaf31bcb8c76a28651509bd",
      name: "TiUSD",
      symbol: "TIUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30697/thumb/TIUDS.png?1696529566"
    },
    {
      chainId: 1,
      address: "0x4fb721ef3bf99e0f2c193847afa296b9257d3c30",
      name: "Tokenplace",
      symbol: "TOK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/15779/thumb/output-onlinepngtools_%283%29.png?1696515403"
    },
    {
      chainId: 1,
      address: "0x7995ab36bb307afa6a683c24a25d90dc1ea83566",
      name: "HitChain",
      symbol: "HIT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/5555/thumb/hitchain.png?1696506024"
    },
    {
      chainId: 1,
      address: "0xaf05ce8a2cef336006e933c02fc89887f5b3c726",
      name: "Lockheed Martin Inu",
      symbol: "LMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32484/thumb/photo_2023-10-11_22-41-52_%281%29_%281%29.jpg?1698290653"
    },
    {
      chainId: 1,
      address: "0x3e70f6806171873d17d4bfc984a6f9d20f5a9018",
      name: "BrianArmstrongTrumpYellenGTA6",
      symbol: "COIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33839/thumb/0x3e70f6806171873d17d4bfc984a6f9d20f5a9018.png?1703108075"
    },
    {
      chainId: 1,
      address: "0x22fc5a29bd3d6cce19a06f844019fd506fce4455",
      name: "Equilibria Finance ePENDLE",
      symbol: "EPENDLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33379/thumb/photo_2023-12-02_19-45-14.jpg?1701665986"
    },
    {
      chainId: 1,
      address: "0xa2a54f1ec1f09316ef12c1770d32ed8f21b1fb6a",
      name: "DigiFinex",
      symbol: "DFT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/4819/thumb/digifinextoken.png?1696505369"
    },
    {
      chainId: 1,
      address: "0xd7f5cabdf696d7d1bf384d7688926a4bdb092c67",
      name: "DRC Mobility",
      symbol: "DRC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13457/thumb/drc_symbol.png?1696513220"
    },
    {
      chainId: 1,
      address: "0x80ee5c641a8ffc607545219a3856562f56427fe9",
      name: "Brett ETH",
      symbol: "BRETT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36832/thumb/zD21_tw__400x400.jpg?1712559083"
    },
    {
      chainId: 1,
      address: "0x474021845c4643113458ea4414bdb7fb74a01a77",
      name: "Uno Re",
      symbol: "UNO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15073/thumb/c0vbqVE.png?1696514732"
    },
    {
      chainId: 1,
      address: "0x07ef9e82721ac16809d24dafbe1792ce01654db4",
      name: "Chimpion",
      symbol: "BNANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7522/thumb/banana-token-logo.jpg?1696507789"
    },
    {
      chainId: 1,
      address: "0x1a23a6bfbadb59fa563008c0fb7cf96dfcf34ea1",
      name: "CoFiX",
      symbol: "COFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12781/thumb/dnPnSkfa_400x400.png?1696512576"
    },
    {
      chainId: 1,
      address: "0x93dfaf57d986b9ca77df9376c50878e013d9c7c8",
      name: "Unique One",
      symbol: "RARE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13458/thumb/Logo_Unique.png?1696513221"
    },
    {
      chainId: 1,
      address: "0xb6ed7644c69416d67b522e20bc294a9a9b405b31",
      name: "0xBitcoin",
      symbol: "0XBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/4454/thumb/0xbtc.png?1696505045"
    },
    {
      chainId: 1,
      address: "0x3aada3e213abf8529606924d8d1c55cbdc70bf74",
      name: "XMON",
      symbol: "XMON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14008/thumb/xmon_logo.png?1696513737"
    },
    {
      chainId: 1,
      address: "0x625ae63000f46200499120b906716420bd059240",
      name: "Aave SUSD v1",
      symbol: "ASUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11723/thumb/aSUSD.png?1696511605"
    },
    {
      chainId: 1,
      address: "0xc07a150ecadf2cc352f5586396e344a6b17625eb",
      name: "Bio Passport",
      symbol: "BIOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/14167/thumb/logo_%2895%29.png?1696513885"
    },
    {
      chainId: 1,
      address: "0x10bc518c32fbae5e38ecb50a612160571bd81e44",
      name: "VeraOne",
      symbol: "VRO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/11112/thumb/wsBaVF.png?1696511051"
    },
    {
      chainId: 1,
      address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
      name: "Chiliz",
      symbol: "CHZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8834/thumb/CHZ_Token_updated.png?1696508986"
    },
    {
      chainId: 1,
      address: "0xb893a8049f250b57efa8c62d51527a22404d7c9a",
      name: "American Shiba",
      symbol: "USHIBA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15650/thumb/american_shiba.PNG?1696515282"
    },
    {
      chainId: 1,
      address: "0x3b544e6fcf6c8dce9d8b45a4fdf21c9b02f9fda9",
      name: "Giftedhands",
      symbol: "GHD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12540/thumb/K-8uHktJ.png?1696512351"
    },
    {
      chainId: 1,
      address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
      name: "Request",
      symbol: "REQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1031/thumb/Request_icon_green.png?1696502140"
    },
    {
      chainId: 1,
      address: "0xbed4ab0019ff361d83ddeb74883dac8a70f5ea1e",
      name: "MerchDAO",
      symbol: "MRCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14540/thumb/logo_256x256.png?1696514224"
    },
    {
      chainId: 1,
      address: "0x52928c95c4c7e934e0efcfab08853a0e4558861d",
      name: "Hara",
      symbol: "HART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5138/thumb/hara.jpg?1696505657"
    },
    {
      chainId: 1,
      address: "0x3449fc1cd036255ba1eb19d65ff4ba2b8903a69a",
      name: "Basis Cash",
      symbol: "BAC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13246/thumb/BAC.png?1696513021"
    },
    {
      chainId: 1,
      address: "0x75ecb52e403c617679fbd3e77a50f9d10a842387",
      name: "CSR",
      symbol: "CSR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25585/thumb/CSR-LOGO-200x200-1.png?1696524717"
    },
    {
      chainId: 1,
      address: "0xba745513acebcbb977497c569d4f7d340f2a936b",
      name: "Mainstream For The Underground",
      symbol: "MFTU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5519/thumb/Mainstream_for_the_underground.png?1696505989"
    },
    {
      chainId: 1,
      address: "0x01ff50f8b7f74e4f00580d9596cd3d0d6d6e326f",
      name: "BnkToTheFuture",
      symbol: "BFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3468/thumb/bnktothefuture.png?1696504157"
    },
    {
      chainId: 1,
      address: "0xa5ef74068d04ba0809b7379dd76af5ce34ab7c57",
      name: "LunaChow",
      symbol: "LUCHOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18805/thumb/J-MwYfhD_400x400.jpg?1696518267"
    },
    {
      chainId: 1,
      address: "0x70e36f6bf80a52b3b46b3af8e106cc0ed743e8e4",
      name: "cCOMP",
      symbol: "CCOMP",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/12840/thumb/1_z8UrVtod3bme4-J_pXAQQA_2x.png?1696512631"
    },
    {
      chainId: 1,
      address: "0x607f4c5bb672230e8672085532f7e901544a7375",
      name: "iExec RLC",
      symbol: "RLC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/646/thumb/pL1VuXm.png?1696501840"
    },
    {
      chainId: 1,
      address: "0x697ef32b4a3f5a4c39de1cb7563f24ca7bfc5947",
      name: "Insula",
      symbol: "ISLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10884/thumb/isla.PNG?1696510837"
    },
    {
      chainId: 1,
      address: "0xc64500dd7b0f1794807e67802f8abbf5f8ffb054",
      name: "Locus Chain",
      symbol: "LOCUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6903/thumb/32169759_2050428658545017_7287666225423843328_n.jpg?1696507221"
    },
    {
      chainId: 1,
      address: "0x08389495d7456e1951ddf7c3a1314a4bfb646d8b",
      name: "Crypterium",
      symbol: "CRPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1901/thumb/crypt.png?1696502894"
    },
    {
      chainId: 1,
      address: "0xc4c2614e694cf534d407ee49f8e44d125e4681c4",
      name: "Chain Games",
      symbol: "CHAIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12257/thumb/chain-pfp-logo.png?1696512087"
    },
    {
      chainId: 1,
      address: "0x2e85ae1c47602f7927bcabc2ff99c40aa222ae15",
      name: "Katana Inu",
      symbol: "KATA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21872/thumb/Katana_Inu512.png?1696521226"
    },
    {
      chainId: 1,
      address: "0x26946ada5ecb57f3a1f91605050ce45c482c9eb1",
      name: "BitcoinSoV",
      symbol: "BSOV",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9205/thumb/bsov.png?1696509323"
    },
    {
      chainId: 1,
      address: "0xfbcb5cbedeebcc55dcd136d34db1daaf74cf67e8",
      name: "Animalia",
      symbol: "ANIM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22706/thumb/1_rHlkmYoebSJ_wn0iE_-d-g_2x.png?1696522016"
    },
    {
      chainId: 1,
      address: "0x024b6e7dc26f4d5579bdd936f8d7bc31f2339999",
      name: "Mithril Share",
      symbol: "MIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13516/thumb/MIS.png?1696513277"
    },
    {
      chainId: 1,
      address: "0x41c21693e60fc1a5dbb7c50e54e7a6016aa44c99",
      name: "SO COL",
      symbol: "SIMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28760/thumb/Frame_427318605.png?1696527739"
    },
    {
      chainId: 1,
      address: "0xa3ad8c7ab6b731045b5b16e3fdf77975c71abe79",
      name: "Dinerobet",
      symbol: "DINERO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28248/thumb/CABA1DE1-2CB1-46D3-97BC-20305EA67FBB.png?1696527251"
    },
    {
      chainId: 1,
      address: "0x9dfad1b7102d46b1b197b90095b5c4e9f5845bba",
      name: "Botto",
      symbol: "BOTTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18892/thumb/bottos_logo.jpg?1696518350"
    },
    {
      chainId: 1,
      address: "0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa",
      name: "Orbs",
      symbol: "ORBS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4630/thumb/Orbs.jpg?1696505200"
    },
    {
      chainId: 1,
      address: "0xebd9d99a3982d547c5bb4db7e3b1f9f14b67eb83",
      name: "Everest",
      symbol: "ID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5209/thumb/Everest.jpg?1696505719"
    },
    {
      chainId: 1,
      address: "0xbadff0ef41d2a68f22de21eabca8a59aaf495cf0",
      name: "Kabosu Inu",
      symbol: "KABOSU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28619/thumb/Kabosu_Inu.png?1696527604"
    },
    {
      chainId: 1,
      address: "0xf8ad7dfe656188a23e89da09506adf7ad9290d5d",
      name: "Blocery",
      symbol: "BLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12095/thumb/Blocery_logo_200x200_.png?1696511941"
    },
    {
      chainId: 1,
      address: "0xeed3ae7b0f8b5b9bb8c035a9941382b1822671cd",
      name: "EveryCoin",
      symbol: "EVY",
      decimals: 12,
      logoURI: "https://assets.coingecko.com/coins/images/5629/thumb/TutkUC1x_400x400_%281%29.jpg?1696506092"
    },
    {
      chainId: 1,
      address: "0x340d2bde5eb28c1eed91b2f790723e3b160613b7",
      name: "BLOCKv",
      symbol: "VEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1266/thumb/blockv.png?1696502339"
    },
    {
      chainId: 1,
      address: "0x130914e1b240a7f4c5d460b7d3a2fd3846b576fa",
      name: "Aureus Nummus Gold",
      symbol: "ANG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12134/thumb/AureusNummusGold-logo.png?1696511976"
    },
    {
      chainId: 1,
      address: "0xd23ac27148af6a2f339bd82d0e3cff380b5093de",
      name: "Siren",
      symbol: "SI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13955/thumb/siren_token_200x200.png?1696513692"
    },
    {
      chainId: 1,
      address: "0x6adb2e268de2aa1abf6578e4a8119b960e02928f",
      name: "ShibaDoge",
      symbol: "SHIBDOGE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/22018/thumb/5HMWoFW0_400x400.jpg?1696521364"
    },
    {
      chainId: 1,
      address: "0x000000007a58f5f58e697e51ab0357bc9e260a04",
      name: "Concave",
      symbol: "CNV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24492/thumb/concave.jpg?1696523672"
    },
    {
      chainId: 1,
      address: "0xa1a36d3537bbe375cc9694795f663ddc8d516db9",
      name: "Polinate",
      symbol: "POLI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18096/thumb/Polinate_Games___Guilds_Elements-05.png?1696517601"
    },
    {
      chainId: 1,
      address: "0x32e6c34cd57087abbd59b5a4aecc4cb495924356",
      name: "BitBase Token",
      symbol: "BTBS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17414/thumb/btbs.PNG?1696516962"
    },
    {
      chainId: 1,
      address: "0x4f14cdbd815b79e9624121f564f24685c6b1211b",
      name: "Angry Doge",
      symbol: "ANFD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25921/thumb/angry-doge-anfd.png?1696525001"
    },
    {
      chainId: 1,
      address: "0x5d43b66da68706d39f6c97f7f1415615672b446b",
      name: "ROGin AI",
      symbol: "ROG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25922/thumb/20490.png?1696525002"
    },
    {
      chainId: 1,
      address: "0x3b604747ad1720c01ded0455728b62c0d2f100f0",
      name: "WAGMI Games",
      symbol: "WAGMIGAMES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25906/thumb/WAGMI_DEFENSE_LOGO24_coingecko.png?1708591845"
    },
    {
      chainId: 1,
      address: "0x4c9edd5852cd905f086c759e8383e09bff1e68b3",
      name: "Ethena USDe",
      symbol: "USDE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33613/thumb/3466ef_3c088c66c7d941e8856339d0bddf33cc_mv2.png?1702514458"
    },
    {
      chainId: 1,
      address: "0xe66747a101bff2dba3697199dcce5b743b454759",
      name: "Gate",
      symbol: "GT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8183/thumb/gate.png?1696508395"
    },
    {
      chainId: 1,
      address: "0xe5a733681bbe6cd8c764bb8078ef8e13a576dd78",
      name: "Devour",
      symbol: "DPAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27191/thumb/DPAY_-_Icon_%28200_%C3%97_200_px%29.png?1696526240"
    },
    {
      chainId: 1,
      address: "0x92d529163c5e880b9de86f01de0cb8924d790357",
      name: "Eyeverse",
      symbol: "EYE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28623/thumb/EYE.png?1696527608"
    },
    {
      chainId: 1,
      address: "0x66a0f676479cee1d7373f3dc2e2952778bff5bd6",
      name: "Wise",
      symbol: "WISE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13552/thumb/Wise.jpg.jpg?1696513309"
    },
    {
      chainId: 1,
      address: "0xe51b8ab09008285a0380dd2680cd9dd5e13924d3",
      name: "BallSwap",
      symbol: "BSP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14050/thumb/bsp.png?1696513775"
    },
    {
      chainId: 1,
      address: "0x83984d6142934bb535793a82adb0a46ef0f66b6d",
      name: "Remme",
      symbol: "REM",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/2152/thumb/semme.png?1696503115"
    },
    {
      chainId: 1,
      address: "0xb683d83a532e2cb7dfa5275eed3698436371cc9f",
      name: "BTU Protocol",
      symbol: "BTU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3697/thumb/logo-btu-white-background_%281%29.png?1707407754"
    },
    {
      chainId: 1,
      address: "0xeadc218ac4cb7895a5a56e6484646b48f841c45a",
      name: "MetaFinance",
      symbol: "MFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17365/thumb/meta.PNG?1696516916"
    },
    {
      chainId: 1,
      address: "0x298d492e8c1d909d3f63bc4a36c66c64acb3d695",
      name: "PolkaBridge",
      symbol: "PBR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13744/thumb/symbol-whitebg200x200.png?1696513488"
    },
    {
      chainId: 1,
      address: "0xb13de094cc5cee6c4cc0a3737bf0290166d9ca5d",
      name: "GoWithMi",
      symbol: "GMAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7162/thumb/qXNbxVny_400x400.png?1696507459"
    },
    {
      chainId: 1,
      address: "0xa1d6df714f91debf4e0802a542e13067f31b8262",
      name: "RFOX",
      symbol: "RFOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12956/thumb/rfox.png?1696512744"
    },
    {
      chainId: 1,
      address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
      name: "Tether Gold",
      symbol: "XAUT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/10481/thumb/Tether_Gold.png?1696510471"
    },
    {
      chainId: 1,
      address: "0x1b40183efb4dd766f11bda7a7c3ad8982e998421",
      name: "Vesper Finance",
      symbol: "VSP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13527/thumb/vesper_logo.jpg?1696513288"
    },
    {
      chainId: 1,
      address: "0x06e0feb0d74106c7ada8497754074d222ec6bcdf",
      name: "Bitball",
      symbol: "BTB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7039/thumb/B_Logo.png?1697617213"
    },
    {
      chainId: 1,
      address: "0xc57d533c50bc22247d49a368880fb49a1caa39f7",
      name: "PowerTrade Fuel",
      symbol: "PTF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12590/thumb/powertrade_logo.jpg?1696512400"
    },
    {
      chainId: 1,
      address: "0x6fce4a401b6b80ace52baaefe4421bd188e76f6f",
      name: "Aave MANA v1",
      symbol: "AMANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11730/thumb/aMANA.png?1696511611"
    },
    {
      chainId: 1,
      address: "0x923b83c26b3809d960ff80332ed00aa46d7ed375",
      name: "Creator Platform",
      symbol: "CTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18252/thumb/logo_%281%29.png?1696517748"
    },
    {
      chainId: 1,
      address: "0x3f9bec82c776c47405bcb38070d2395fd18f89d3",
      name: "Phantom Protocol",
      symbol: "PHM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18253/thumb/phm.PNG?1696517748"
    },
    {
      chainId: 1,
      address: "0x793786e2dd4cc492ed366a94b88a3ff9ba5e7546",
      name: "Axia",
      symbol: "AXIAV3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12906/thumb/axia_200x200.png?1696512694"
    },
    {
      chainId: 1,
      address: "0x048fe49be32adfc9ed68c37d32b5ec9df17b3603",
      name: "Skrumble Network",
      symbol: "SKM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3826/thumb/skrumble-network.png?1696504495"
    },
    {
      chainId: 1,
      address: "0x14da7b27b2e0fedefe0a664118b0c9bc68e2e9af",
      name: "Blockchain Cuties Universe Governance",
      symbol: "BCUG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14425/thumb/bcug_logo.png?1696514115"
    },
    {
      chainId: 1,
      address: "0xbb1ee07d6c7baeb702949904080eb61f5d5e7732",
      name: "Dogey Inu",
      symbol: "DINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16374/thumb/512x512_dinu_logo.jpg?1696515973"
    },
    {
      chainId: 1,
      address: "0x9ba00d6856a4edf4665bca2c2309936572473b7e",
      name: "Aave USDC v1",
      symbol: "AUSDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/11674/thumb/aUSDC.png?1696511564"
    },
    {
      chainId: 1,
      address: "0xbb97e381f1d1e94ffa2a5844f6875e6146981009",
      name: "WiBX",
      symbol: "WBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11009/thumb/wibx_new_logo.png?1696510957"
    },
    {
      chainId: 1,
      address: "0xbcca60bb61934080951369a648fb03df4f96263c",
      name: "Aave v2 USDC",
      symbol: "AUSDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/14318/thumb/aUSDC.e260d492.png?1696514006"
    },
    {
      chainId: 1,
      address: "0xc0f1728d9513efc316d0e93a0758c992f88b0809",
      name: "SWTCoin",
      symbol: "SWAT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/5985/thumb/swtcoin.jpg?1696506402"
    },
    {
      chainId: 1,
      address: "0xeeee2a2e650697d2a8e8bc990c2f3d04203be06f",
      name: "Forgotten Playland",
      symbol: "FP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35339/thumb/200.png?1708515043"
    },
    {
      chainId: 1,
      address: "0x07b701ac44aacb03d8bed42eb85ec38210bdf513",
      name: "Taproot",
      symbol: "TAPROOT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/35368/thumb/200.png?1708401189"
    },
    {
      chainId: 1,
      address: "0xf8b358b3397a8ea5464f8cc753645d42e14b79ea",
      name: "Airbloc",
      symbol: "ABL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4393/thumb/airbloc-protocol-logo.png?1696504991"
    },
    {
      chainId: 1,
      address: "0x05bd6b9bc125fee6e670420f11d4e1817c0fc132",
      name: "404WHEELS",
      symbol: "404WHEELS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35340/thumb/d02e6933-7b6a-48c4-b84a-6e3383bdef8f.jpeg?1708316971"
    },
    {
      chainId: 1,
      address: "0x00059ae69c1622a7542edc15e8d17b060fe307b6",
      name: "AmonD",
      symbol: "AMON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8952/thumb/AmonD_512x512.png?1696509099"
    },
    {
      chainId: 1,
      address: "0x115ec79f1de567ec68b7ae7eda501b406626478e",
      name: "Carry",
      symbol: "CRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3994/thumb/Carry.png?1696504635"
    },
    {
      chainId: 1,
      address: "0xc53342fd7575f572b0ff4569e31941a5b821ac76",
      name: "Ethereum Volatility Index Token",
      symbol: "ETHV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16716/thumb/logo_-_2021-06-28T092549.772.png?1696516290"
    },
    {
      chainId: 1,
      address: "0x98c23e9d8f34fefb1b7bd6a91b7ff122f4e16f5c",
      name: "Aave v3 USDC",
      symbol: "AUSDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/32847/thumb/usdc_%281%29.png?1699619355"
    },
    {
      chainId: 1,
      address: "0xde4ee8057785a7e8e800db58f9784845a5c2cbd6",
      name: "DeXe",
      symbol: "DEXE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12713/thumb/DEXE_token_logo.png?1696512514"
    },
    {
      chainId: 1,
      address: "0x2e2364966267b5d7d2ce6cd9a9b5bd19d9c7c6a9",
      name: "Voice",
      symbol: "VOICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12926/thumb/OjCQtdL.png?1696512714"
    },
    {
      chainId: 1,
      address: "0xd714d91a169127e11d8fab3665d72e8b7ef9dbe2",
      name: "BlackHole Protocol",
      symbol: "BLACK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15124/thumb/blackhole.PNG?1696514781"
    },
    {
      chainId: 1,
      address: "0xa23c1194d421f252b4e6d5edcc3205f7650a4ebe",
      name: "LaunchBlock",
      symbol: "LBP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24181/thumb/S6z_-9GB_400x400.jpg?1696523370"
    },
    {
      chainId: 1,
      address: "0x55a380d134d722006a5ce2d510562e1239d225b1",
      name: "Marvin Inu",
      symbol: "MARVIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22039/thumb/lVshyCp.png?1696521384"
    },
    {
      chainId: 1,
      address: "0xd2be3722b17b616c51ed9b8944a227d1ce579c24",
      name: "Dtube Coin",
      symbol: "DTUBE",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/13126/thumb/dtube_logo.png?1696512913"
    },
    {
      chainId: 1,
      address: "0x23b608675a2b2fb1890d3abbd85c5775c51691d5",
      name: "Unisocks",
      symbol: "SOCKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10717/thumb/qFrcoiM.png?1696510685"
    },
    {
      chainId: 1,
      address: "0x67954768e721fad0f0f21e33e874497c73ed6a82",
      name: "KeKChain",
      symbol: "KEK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27061/thumb/20220816_155427.png?1696526111"
    },
    {
      chainId: 1,
      address: "0xc5d27f27f08d1fd1e3ebbaa50b3442e6c0d50439",
      name: "Moon App",
      symbol: "APP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34492/thumb/moon-app.jpeg?1705131046"
    },
    {
      chainId: 1,
      address: "0xadc3f2c3d728202658930860158c726d8180a38f",
      name: "StarkMeta",
      symbol: "SMETA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25851/thumb/YcUYwy5f_400x400.jpg?1696524935"
    },
    {
      chainId: 1,
      address: "0xa2881f7f441267042f9778ffa0d4f834693426be",
      name: "The HUSL",
      symbol: "HUSL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18619/thumb/W8ZIHKU.png?1696518092"
    },
    {
      chainId: 1,
      address: "0xab37e1358b639fd877f015027bb62d3ddaa7557e",
      name: "Lien",
      symbol: "LIEN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/12224/thumb/Lien.png?1696512057"
    },
    {
      chainId: 1,
      address: "0x033e223870f766644f7f7a4b7dc2e91573707d06",
      name: "Zin",
      symbol: "ZIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13250/thumb/coingecko_logo.png?1696513025"
    },
    {
      chainId: 1,
      address: "0xb4a677b0e363c3815d46326954a4e4d2b1ace357",
      name: "THENODE",
      symbol: "THE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10292/thumb/thenode_logo.png?1696510297"
    },
    {
      chainId: 1,
      address: "0x40fd72257597aa14c7231a7b1aaa29fce868f677",
      name: "Sora",
      symbol: "XOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11093/thumb/sora_logo_cg_white.png?1696511034"
    },
    {
      chainId: 1,
      address: "0x106538cc16f938776c7c180186975bca23875287",
      name: "Basis Share",
      symbol: "BAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13251/thumb/BAS.png?1696513026"
    },
    {
      chainId: 1,
      address: "0xd90e69f67203ebe02c917b5128629e77b4cd92dc",
      name: "One Cash",
      symbol: "ONC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13529/thumb/onc_logo.png?1696513290"
    },
    {
      chainId: 1,
      address: "0xfeeeef4d7b4bf3cc8bd012d02d32ba5fd3d51e31",
      name: "Tail",
      symbol: "TAIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28260/thumb/IMG_20221210_122215_723.jpg?1696527262"
    },
    {
      chainId: 1,
      address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
      name: "Holo",
      symbol: "HOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3348/thumb/Holologo_Profile.png?1696504052"
    },
    {
      chainId: 1,
      address: "0x076641af1b8f06b7f8c92587156143c109002cbe",
      name: "SoPay",
      symbol: "SOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6736/thumb/sopay.png?1696507071"
    },
    {
      chainId: 1,
      address: "0x0b4c2708f052dca413600e237675e4d6778a9375",
      name: "CoinClaim",
      symbol: "CLM",
      decimals: 16,
      logoURI: "https://assets.coingecko.com/coins/images/6687/thumb/coinclaim.jpg?1696507028"
    },
    {
      chainId: 1,
      address: "0x09617f6fd6cf8a71278ec86e23bbab29c04353a7",
      name: "Shardus",
      symbol: "ULT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8383/thumb/final_logo_photoshop.png?1696508575"
    },
    {
      chainId: 1,
      address: "0x487d62468282bd04ddf976631c23128a425555ee",
      name: "UPCX",
      symbol: "UPC",
      decimals: 5,
      logoURI: "https://assets.coingecko.com/coins/images/33308/thumb/02_UPC_logo_RGB_black_200_200.png?1701409035"
    },
    {
      chainId: 1,
      address: "0xdc5864ede28bd4405aa04d93e05a0531797d9d59",
      name: "Falcon Project",
      symbol: "FNT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/11579/thumb/falcon_ava_black.png?1696511476"
    },
    {
      chainId: 1,
      address: "0x009c43b42aefac590c719e971020575974122803",
      name: "Bibox",
      symbol: "BIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1441/thumb/bibox-token.png?1696502491"
    },
    {
      chainId: 1,
      address: "0x954b890704693af242613edef1b603825afcd708",
      name: "Cardstack",
      symbol: "CARD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3247/thumb/cardstack.png?1696503962"
    },
    {
      chainId: 1,
      address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
      name: "Dent",
      symbol: "DENT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/1152/thumb/gLCEA2G.png?1696502243"
    },
    {
      chainId: 1,
      address: "0x6c5024cd4f8a59110119c56f8933403a539555eb",
      name: "Aave SUSD",
      symbol: "ASUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14266/thumb/aSUSD.9b00ffc6.png?1696513967"
    },
    {
      chainId: 1,
      address: "0x6524b87960c2d573ae514fd4181777e7842435d4",
      name: "Benzene",
      symbol: "BZN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17368/thumb/bzn-logo-200.png?1696516919"
    },
    {
      chainId: 1,
      address: "0x1788430620960f9a70e3dc14202a3a35dde1a316",
      name: "OpenAlexa Protocol",
      symbol: "OAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12400/thumb/256x256-OAP.png?1696512222"
    },
    {
      chainId: 1,
      address: "0xcf3c8be2e2c42331da80ef210e9b1b307c03d36a",
      name: "Bepro",
      symbol: "BEPRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10251/thumb/logo.png?1696510261"
    },
    {
      chainId: 1,
      address: "0x6b4c7a5e3f0b99fcd83e9c089bddd6c7fce5c611",
      name: "Million",
      symbol: "MM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16825/thumb/logo200x200.png?1696516393"
    },
    {
      chainId: 1,
      address: "0x39c6b3e42d6a679d7d776778fe880bc9487c2eda",
      name: "Aave KNC",
      symbol: "AKNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14250/thumb/aKNC.42bcd2e3.png?1696513964"
    },
    {
      chainId: 1,
      address: "0xc40af1e4fecfa05ce6bab79dcd8b373d2e436c4e",
      name: "Hokkaidu Inu",
      symbol: "HOKK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34890/thumb/IMG29529FNM3.png?1710943740"
    },
    {
      chainId: 1,
      address: "0x6b9f031d718dded0d681c20cb754f97b3bb81b78",
      name: "GEEQ",
      symbol: "GEEQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11953/thumb/GeeqLogoPNGTransparent-1.png?1696511812"
    },
    {
      chainId: 1,
      address: "0x4f3afec4e5a3f2a6a1a411def7d7dfe50ee057bf",
      name: "Digix Gold",
      symbol: "DGX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/4171/thumb/DGX_Token.png?1696504794"
    },
    {
      chainId: 1,
      address: "0xc8871267e07408b89aa5aecc58adca5e574557f8",
      name: "Instadapp USDC",
      symbol: "IUSDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/25820/thumb/iUSDC_100x100.png?1696524905"
    },
    {
      chainId: 1,
      address: "0x4af5ff1a60a6ef6c7c8f9c4e304cd9051fca3ec0",
      name: "Rigel Protocol",
      symbol: "RGP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15837/thumb/A_qRYvB2_400x400.png?1696515455"
    },
    {
      chainId: 1,
      address: "0x40a9d39aa50871df092538c5999b107f34409061",
      name: "Instadapp DAI",
      symbol: "IDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25821/thumb/iDAI_100x100.png?1696524906"
    },
    {
      chainId: 1,
      address: "0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d",
      name: "Kleros",
      symbol: "PNK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3833/thumb/kleros.png?1696504500"
    },
    {
      chainId: 1,
      address: "0x5d285f735998f36631f678ff41fb56a10a4d0429",
      name: "MixMarvel",
      symbol: "MIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8222/thumb/8878caf93b1e3b6cfb3b414bda3b5250.png?1696508428"
    },
    {
      chainId: 1,
      address: "0x009178997aff09a67d4caccfeb897fb79d036214",
      name: "1Sol",
      symbol: "1SOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21615/thumb/YyGDie9f_400x400.jpg?1696520976"
    },
    {
      chainId: 1,
      address: "0x0e6fa9c050c8a707e7f56a2b3695665e4f9eac9b",
      name: "Robo Inu Finance",
      symbol: "RBIF",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/20821/thumb/O68Gs5SE_400x400.jpg?1696520214"
    },
    {
      chainId: 1,
      address: "0x946551dd05c5abd7cc808927480225ce36d8c475",
      name: "One",
      symbol: "ONE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4960/thumb/Screenshot_39.png?1696505497"
    },
    {
      chainId: 1,
      address: "0xa7a5c1058194af8f00c187adb7fcc0c95f1c6c2d",
      name: "SPACE iZ",
      symbol: "SPIZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12213/thumb/Frame_1000002608.png?1703058029"
    },
    {
      chainId: 1,
      address: "0x99295f1141d58a99e939f7be6bbe734916a875b8",
      name: "LinkPool",
      symbol: "LPL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14548/thumb/linkpool-logo-256x256.png?1696514231"
    },
    {
      chainId: 1,
      address: "0x056fd409e1d7a124bd7017459dfea2f387b6d5cd",
      name: "Gemini Dollar",
      symbol: "GUSD",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/5992/thumb/gemini-dollar-gusd.png?1696506408"
    },
    {
      chainId: 1,
      address: "0x25e1474170c4c0aa64fa98123bdc8db49d7802fa",
      name: "Bidao",
      symbol: "BID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12596/thumb/bidao.png?1696512405"
    },
    {
      chainId: 1,
      address: "0x73c9275c3a2dd84b5741fd59aebf102c91eb033f",
      name: "Bitball Treasure",
      symbol: "BTRS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7273/thumb/btrs.png?1696507565"
    },
    {
      chainId: 1,
      address: "0xf74751c07c92b668f02527d0e1384ee6d68ac90e",
      name: "AltCTRL",
      symbol: "CTRL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35472/thumb/200x200.png?1708770112"
    },
    {
      chainId: 1,
      address: "0xf7970499814654cd13cb7b6e7634a12a7a8a9abc",
      name: "TOM Finance",
      symbol: "TOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13173/thumb/TOM_logo.png?1696512956"
    },
    {
      chainId: 1,
      address: "0x4527a3b4a8a150403090a99b87effc96f2195047",
      name: "P2P solutions foundation",
      symbol: "P2PS",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2798/thumb/p2ps.png?1696503565"
    },
    {
      chainId: 1,
      address: "0x6d1dc3928604b00180bb570bdae94b9698d33b79",
      name: "UnitedCrowd",
      symbol: "UCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14956/thumb/eUvRU9wm.png?1696514614"
    },
    {
      chainId: 1,
      address: "0x8ce55da273fb5cf4b1ffc5d4066bd62445a43543",
      name: "Burners",
      symbol: "BRNR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33911/thumb/Burners.jpeg?1703310206"
    },
    {
      chainId: 1,
      address: "0x2b89bf8ba858cd2fcee1fada378d5cd6936968be",
      name: "Secret  ERC20 ",
      symbol: "WSCRT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/13767/thumb/Secret_S_Black_Coingecko.png?1696513509"
    },
    {
      chainId: 1,
      address: "0x2fc246aa66f0da5bb1368f688548ecbbe9bdee5d",
      name: "TEMCO",
      symbol: "TEMCO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6210/thumb/bSZ7HUuS_400x400.jpg?1696506595"
    },
    {
      chainId: 1,
      address: "0x9ceb84f92a0561fa3cc4132ab9c0b76a59787544",
      name: "Doki Doki",
      symbol: "DOKI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12759/thumb/doki_logo.png?1696512556"
    },
    {
      chainId: 1,
      address: "0x6781a0f84c7e9e846dcb84a9a5bd49333067b104",
      name: "Zap",
      symbol: "ZAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2180/thumb/zap.png?1696503138"
    },
    {
      chainId: 1,
      address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
      name: "Keep3rV1",
      symbol: "KP3R",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12966/thumb/kp3r_logo.jpg?1696512754"
    },
    {
      chainId: 1,
      address: "0x9e68250f3031dba94a0b430b881e574a500aa78c",
      name: "CortexLPU",
      symbol: "LPU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37133/thumb/photo_2024-03-08_15-11-00.jpg?1713408303"
    },
    {
      chainId: 1,
      address: "0xd585aaafa2b58b1cd75092b51ade9fa4ce52f247",
      name: "peg eUSD",
      symbol: "PEUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31521/thumb/peUSD_200x200.png?1696530331"
    },
    {
      chainId: 1,
      address: "0xbd356a39bff2cada8e9248532dd879147221cf76",
      name: "WOM Protocol",
      symbol: "WOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4559/thumb/wom_logo_small.png?1696505139"
    },
    {
      chainId: 1,
      address: "0x120a3879da835a5af037bb2d1456bebd6b54d4ba",
      name: "Revest Finance",
      symbol: "RVST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18622/thumb/Qma94n6waADECpde1ukBBS8iNiECcdVcxjfgubnWPE9ZT7.png?1696518094"
    },
    {
      chainId: 1,
      address: "0x97a9bac06f90940bce9caec2b880ff17707519e4",
      name: "Minato",
      symbol: "MNTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24622/thumb/MNTO_200x200.png?1696523794"
    },
    {
      chainId: 1,
      address: "0x83e6f1e41cdd28eaceb20cb649155049fac3d5aa",
      name: "Polkastarter",
      symbol: "POLS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12648/thumb/polkastarter.png?1696512455"
    },
    {
      chainId: 1,
      address: "0xbf52f2ab39e26e0951d2a02b49b7702abe30406a",
      name: "ODEM",
      symbol: "ODE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3752/thumb/odem.png?1696504428"
    },
    {
      chainId: 1,
      address: "0x5b7533812759b45c2b44c19e320ba2cd2681b542",
      name: "SingularityNET",
      symbol: "AGIX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2138/thumb/singularitynet.png?1696503103"
    },
    {
      chainId: 1,
      address: "0xef6344de1fcfc5f48c30234c16c1389e8cdc572c",
      name: "EncrypGen",
      symbol: "DNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1215/thumb/encrypgen.png?1696502295"
    },
    {
      chainId: 1,
      address: "0xbd3de9a069648c84d27d74d701c9fa3253098b15",
      name: "EQIFi",
      symbol: "EQX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17490/thumb/EQIFI_Logo_Color.png?1696517031"
    },
    {
      chainId: 1,
      address: "0x630d98424efe0ea27fb1b3ab7741907dffeaad78",
      name: "PEAKDEFI",
      symbol: "PEAK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9626/thumb/PEAKDEFI_Logo_250x250.png?1696509698"
    },
    {
      chainId: 1,
      address: "0xf2051511b9b121394fa75b8f7d4e7424337af687",
      name: "DAOhaus",
      symbol: "HAUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14551/thumb/jN3kkqke_400x400.png?1696514234"
    },
    {
      chainId: 1,
      address: "0xc8c424b91d8ce0137bab4b832b7f7d154156ba6c",
      name: "apM Coin",
      symbol: "APM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10069/thumb/PvDCvh5h_400x400.png?1696510100"
    },
    {
      chainId: 1,
      address: "0x2391b8147caef113787972abbdaf77f4bae0cf22",
      name: "ArcaneDEX",
      symbol: "ARC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34575/thumb/ARC_%281%29.png?1705411582"
    },
    {
      chainId: 1,
      address: "0x6293bbe52c3682057163172850002f18f993da6a",
      name: "TruthGPT  ETH ",
      symbol: "TRUTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30993/thumb/LOGO_200.png?1696529831"
    },
    {
      chainId: 1,
      address: "0x8f43ee50942e96d84052253ab13f59c1d942fb98",
      name: "Paragon Network",
      symbol: "PARA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36967/thumb/0x8f43ee50942e96d84052253ab13f59c1d942fb98.png?1712908143"
    },
    {
      chainId: 1,
      address: "0x1e0b2992079b620aa13a7c2e7c88d2e1e18e46e9",
      name: "KOMPETE",
      symbol: "KOMPETE",
      decimals: 10,
      logoURI: "https://assets.coingecko.com/coins/images/24298/thumb/KOMPETE_LOGO.?1696523480"
    },
    {
      chainId: 1,
      address: "0x067def80d66fb69c276e53b641f37ff7525162f6",
      name: "OPEN GPU",
      symbol: "OGPU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36985/thumb/logo-icon-200.png?1712945992"
    },
    {
      chainId: 1,
      address: "0x47e67ba66b0699500f18a53f94e2b9db3d47437e",
      name: "PlayGame",
      symbol: "PXG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7242/thumb/pxg-coin_3x.png?1696507536"
    },
    {
      chainId: 1,
      address: "0x8de5b80a0c1b02fe4976851d030b36122dbb8624",
      name: "Vanar Chain",
      symbol: "VANRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33466/thumb/apple-touch-icon.png?1701942541"
    },
    {
      chainId: 1,
      address: "0x86772b1409b61c639eaac9ba0acfbb6e238e5f83",
      name: "Indexed Finance",
      symbol: "NDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13546/thumb/indexed-light.74bb5471.png?1696513306"
    },
    {
      chainId: 1,
      address: "0xacd2c239012d17beb128b0944d49015104113650",
      name: "Karrat",
      symbol: "KARRAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37237/thumb/SmallLogo.png?1714755426"
    },
    {
      chainId: 1,
      address: "0x0c9c7712c83b3c70e7c5e11100d33d9401bdf9dd",
      name: "Wombat",
      symbol: "WOMBAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26430/thumb/Project_Page_Icon.png?1696525504"
    },
    {
      chainId: 1,
      address: "0x0198f46f520f33cd4329bd4be380a25a90536cd5",
      name: "PlayChip",
      symbol: "PLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4567/thumb/pla.png?1696505147"
    },
    {
      chainId: 1,
      address: "0xb97048628db6b661d4c2aa833e95dbe1a905b280",
      name: "TenX",
      symbol: "PAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/775/thumb/TenX-Icon-CircleBlack.png?1696501927"
    },
    {
      chainId: 1,
      address: "0x0f71b8de197a1c84d31de0f1fa7926c365f052b3",
      name: "Arcona",
      symbol: "ARCONA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4312/thumb/icon_ARCONA_%281%29.png?1696504918"
    },
    {
      chainId: 1,
      address: "0x3543638ed4a9006e4840b105944271bcea15605d",
      name: "U Network",
      symbol: "UUU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3877/thumb/2645.png?1696504538"
    },
    {
      chainId: 1,
      address: "0x543ff227f64aa17ea132bf9886cab5db55dcaddf",
      name: "DAOstack",
      symbol: "GEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3479/thumb/gen.png?1696504167"
    },
    {
      chainId: 1,
      address: "0x99d8a9c45b2eca8864373a26d1459e3dff1e17f3",
      name: "Magic Internet Money",
      symbol: "MIM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1696516358"
    },
    {
      chainId: 1,
      address: "0x3136ef851592acf49ca4c825131e364170fa32b3",
      name: "CoinFi",
      symbol: "COFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1709/thumb/coinfi.png?1696502727"
    },
    {
      chainId: 1,
      address: "0x4092678e4e78230f46a1534c0fbc8fa39780892b",
      name: "Odyssey",
      symbol: "OCN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2559/thumb/ocn.png?1696503367"
    },
    {
      chainId: 1,
      address: "0x45080a6531d671ddff20db42f93792a489685e32",
      name: "Finance Vote",
      symbol: "FVT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13181/thumb/finance.png?1696512964"
    },
    {
      chainId: 1,
      address: "0x501e8726d06cdef66f3e0cb67f54924cca1cc894",
      name: "BRMV",
      symbol: "BRMV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14389/thumb/brmv-logo-256px.png?1696514080"
    },
    {
      chainId: 1,
      address: "0xc4cb5793bd58bad06bf51fb37717b86b02cbe8a4",
      name: "PROXI DeFi",
      symbol: "CREDIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12212/thumb/_credit.png?1696512046"
    },
    {
      chainId: 1,
      address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
      name: "AppCoins",
      symbol: "APPC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1876/thumb/appcoins.png?1696502872"
    },
    {
      chainId: 1,
      address: "0x33c04bed4533e31f2afb8ac4a61a48eda38c4fa0",
      name: "Gorilla",
      symbol: "GORILLA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33006/thumb/IMG_20231110_124057_942.jpg?1700123171"
    },
    {
      chainId: 1,
      address: "0x73484a262730d1d422610729e828346f9b2ff480",
      name: "BRCP",
      symbol: "BRCP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14388/thumb/brcp-500x500-verde.png?1696514079"
    },
    {
      chainId: 1,
      address: "0x221657776846890989a759ba2973e427dff5c9bb",
      name: "Augur",
      symbol: "REP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/309/thumb/REP.png?1696501648"
    },
    {
      chainId: 1,
      address: "0x544c42fbb96b39b21df61cf322b5edc285ee7429",
      name: "InsurAce",
      symbol: "INSUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14226/thumb/insur.png?1696513941"
    },
    {
      chainId: 1,
      address: "0xe3fedaecd47aa8eab6b23227b0ee56f092c967a9",
      name: "Primas",
      symbol: "PST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/917/thumb/primas.png?1696502039"
    },
    {
      chainId: 1,
      address: "0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359",
      name: "Sai",
      symbol: "SAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1442/thumb/dai.png?1696502492"
    },
    {
      chainId: 1,
      address: "0x04a020325024f130988782bd5276e53595e8d16e",
      name: "Herbalist",
      symbol: "HERB",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/6892/thumb/herbalist-token-twitter.png?1696507211"
    },
    {
      chainId: 1,
      address: "0x41dbecc1cdc5517c6f76f6a6e836adbee2754de3",
      name: "Medicalchain",
      symbol: "MTN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2850/thumb/medicalchain.png?1696503608"
    },
    {
      chainId: 1,
      address: "0x46d473a0b3eeec9f55fade641bc576d5bc0b2246",
      name: "SurfExUtilityToken",
      symbol: "SURF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10783/thumb/200x200-logo-blu-grey-bkg-4-e1583512409629.png?1696510744"
    },
    {
      chainId: 1,
      address: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
      name: "Arcblock",
      symbol: "ABT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2341/thumb/arcblock.png?1696503220"
    },
    {
      chainId: 1,
      address: "0x20910e5b5f087f6439dfcb0dda4e27d1014ac2b8",
      name: "BananaTok",
      symbol: "BNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10289/thumb/sMCxdYBa_400x400.jpg?1696510295"
    },
    {
      chainId: 1,
      address: "0x558ec3152e2eb2174905cd19aea4e34a23de9ad6",
      name: "Bread",
      symbol: "BRD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1440/thumb/bread.png?1696502490"
    },
    {
      chainId: 1,
      address: "0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4",
      name: "Router Protocol",
      symbol: "ROUTE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13709/thumb/route_token_200x200-19.png?1696513454"
    },
    {
      chainId: 1,
      address: "0xf0939011a9bb95c3b791f0cb546377ed2693a574",
      name: "0 exchange",
      symbol: "ZERO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13706/thumb/0.exchange_%28logo%29.jpg?1696513452"
    },
    {
      chainId: 1,
      address: "0xff931a7946d2fa11cf9123ef0dc6f6c7c6cb60c4",
      name: "Dancing Baby",
      symbol: "BABY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32641/thumb/IMG_20231101_135519_737.jpg?1698889030"
    },
    {
      chainId: 1,
      address: "0xf3dcbc6d72a4e1892f7917b7c43b74131df8480e",
      name: "Big Data Protocol",
      symbol: "BDP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14222/thumb/logo_BDP_200.png?1696513937"
    },
    {
      chainId: 1,
      address: "0x6b785a0322126826d8226d77e173d75dafb84d11",
      name: "Bankroll Vault",
      symbol: "VLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11638/thumb/vlt-200.png?1696511531"
    },
    {
      chainId: 1,
      address: "0x6149c26cd2f7b5ccdb32029af817123f6e37df5b",
      name: "Launchpool",
      symbol: "LPOOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14041/thumb/dGUvV0HQ_400x400.jpg?1696513767"
    },
    {
      chainId: 1,
      address: "0x668dbf100635f593a3847c0bdaf21f0a09380188",
      name: "BNSD Finance",
      symbol: "BNSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12368/thumb/bnsd.png?1696512193"
    },
    {
      chainId: 1,
      address: "0x72f020f8f3e8fd9382705723cd26380f8d0c66bb",
      name: "PlotX",
      symbol: "PLOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12795/thumb/PlotX.png?1696512589"
    },
    {
      chainId: 1,
      address: "0x5a666c7d92e5fa7edcb6390e4efd6d0cdd69cf37",
      name: "Unmarshal",
      symbol: "MARSH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14554/thumb/img_circle_256x256.png?1696514237"
    },
    {
      chainId: 1,
      address: "0x40d1f63b5d2048e67e9bedb1b4c2f1a9fb4b6817",
      name: "Golden Goose",
      symbol: "GOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7892/thumb/tsRcntSR_400x400.png?1696508124"
    },
    {
      chainId: 1,
      address: "0x0563dce613d559a47877ffd1593549fb9d3510d6",
      name: "SuperBid",
      symbol: "SUPERBID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14179/thumb/sign_super_bid.png?1696513897"
    },
    {
      chainId: 1,
      address: "0x2942e3b38e33123965bfbc21e802be943a76bbc6",
      name: "EHash",
      symbol: "EHASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14180/thumb/ehash.png?1696513898"
    },
    {
      chainId: 1,
      address: "0xd076c4ba62c57b3fa10800bcfd8da66742110e0e",
      name: "HAVAH",
      symbol: "HVH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29156/thumb/hvh.png?1696528115"
    },
    {
      chainId: 1,
      address: "0x53884b61963351c283118a8e1fc05ba464a11959",
      name: "Monnos",
      symbol: "MNS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11640/thumb/logo_%2880%29.png?1696511533"
    },
    {
      chainId: 1,
      address: "0x75231f58b43240c9718dd58b4967c5114342a86c",
      name: "OKB",
      symbol: "OKB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4463/thumb/WeChat_Image_20220118095654.png?1696505053"
    },
    {
      chainId: 1,
      address: "0x1900e8b5619a3596745f715d0427fe617c729ba9",
      name: "Chainbing",
      symbol: "CBG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18052/thumb/j3saoPU.png?1696517564"
    },
    {
      chainId: 1,
      address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
      name: "OST",
      symbol: "OST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1367/thumb/ost.jpg?1696502425"
    },
    {
      chainId: 1,
      address: "0x4dd672e77c795844fe3a464ef8ef0faae617c8fb",
      name: "CONUN",
      symbol: "CON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7480/thumb/conun.png?1696507750"
    },
    {
      chainId: 1,
      address: "0x7a5ce6abd131ea6b148a022cb76fc180ae3315a6",
      name: "bAlpha",
      symbol: "BALPHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14224/thumb/logo_bAlpha_200.png?1696513939"
    },
    {
      chainId: 1,
      address: "0x4159862bcf6b4393a80550b1ed03dffa6f90533c",
      name: "One Hundred Million Inu",
      symbol: "OHMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28625/thumb/ohmi-shield-200.png?1696527610"
    },
    {
      chainId: 1,
      address: "0x7ae0d42f23c33338de15bfa89c7405c068d9dc0a",
      name: "Shibaverse",
      symbol: "VERSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18407/thumb/logo_200.png?1696517897"
    },
    {
      chainId: 1,
      address: "0xbc19712feb3a26080ebf6f2f7849b417fdd792ca",
      name: "BoringDAO",
      symbol: "BORING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16429/thumb/Tjq3pXEH_400x400.jpg?1696516025"
    },
    {
      chainId: 1,
      address: "0x6f87d756daf0503d08eb8993686c7fc01dc44fb1",
      name: "Unitrade",
      symbol: "TRADE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11982/thumb/unitrade.PNG?1696511840"
    },
    {
      chainId: 1,
      address: "0x55c08ca52497e2f1534b59e2917bf524d4765257",
      name: "UwU Lend",
      symbol: "UWU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27408/thumb/uwu_logo_no-bg_1024.png?1696526449"
    },
    {
      chainId: 1,
      address: "0x5c872500c00565505f3624ab435c222e558e9ff8",
      name: "CoTrader",
      symbol: "COT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4205/thumb/logo_black.png?1696504825"
    },
    {
      chainId: 1,
      address: "0xd6a5ab46ead26f49b03bbb1f9eb1ad5c1767974a",
      name: "Ethermon",
      symbol: "EMON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15889/thumb/LtET0reH_400x400.jpg?1696515504"
    },
    {
      chainId: 1,
      address: "0x35f6b052c598d933d69a4eec4d04c73a191fe6c2",
      name: "Aave SNX",
      symbol: "ASNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14265/thumb/aSNX.3238f3e7.png?1696513966"
    },
    {
      chainId: 1,
      address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
      name: "AirSwap",
      symbol: "AST",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/1019/thumb/Airswap.png?1696502130"
    },
    {
      chainId: 1,
      address: "0xeef9f339514298c6a857efcfc1a762af84438dee",
      name: "Hermez Network",
      symbol: "HEZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12826/thumb/hermez_logo.png?1696512617"
    },
    {
      chainId: 1,
      address: "0x038a68ff68c393373ec894015816e33ad41bd564",
      name: "Glitch Protocol",
      symbol: "GLCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13712/thumb/glitch_logo.jpeg?1696513457"
    },
    {
      chainId: 1,
      address: "0x73374ea518de7addd4c2b624c0e8b113955ee041",
      name: "Juggernaut",
      symbol: "JGN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12761/thumb/juggernaut_logo.png?1696512558"
    },
    {
      chainId: 1,
      address: "0xc0ec8caec55f37d47fbfa595727418868a21fd48",
      name: "EcoG9coin",
      symbol: "EGC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/8038/thumb/Screenshot_2019-12-05_at_7.14.34_AM.png?1696508259"
    },
    {
      chainId: 1,
      address: "0xb1e9157c2fdcc5a856c8da8b2d89b6c32b3c1229",
      name: "Zenfuse",
      symbol: "ZEFU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12796/thumb/zenfuse.jpg?1696512590"
    },
    {
      chainId: 1,
      address: "0xddb3422497e61e13543bea06989c0789117555c5",
      name: "COTI",
      symbol: "COTI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2962/thumb/Coti.png?1696503705"
    },
    {
      chainId: 1,
      address: "0xfb7b4564402e5500db5bb6d63ae671302777c75a",
      name: "DexTools",
      symbol: "DEXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11603/thumb/dext.png?1696511498"
    },
    {
      chainId: 1,
      address: "0x6afcff9189e8ed3fcc1cffa184feb1276f6a82a5",
      name: "PolkaPet World",
      symbol: "PETS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19409/thumb/pets_polka.PNG?1696518848"
    },
    {
      chainId: 1,
      address: "0x5150956e082c748ca837a5dfa0a7c10ca4697f9c",
      name: "Zeedex",
      symbol: "ZDEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12412/thumb/Untitled-design-4.png?1696512234"
    },
    {
      chainId: 1,
      address: "0x4d2ee5dae46c86da2ff521f7657dad98834f97b8",
      name: "Pepemon Pepeballs",
      symbol: "PPBLZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12823/thumb/200pepebball-BIG.png?1696512615"
    },
    {
      chainId: 1,
      address: "0x217ddead61a42369a266f1fb754eb5d3ebadc88a",
      name: "Don key",
      symbol: "DON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15482/thumb/donkey_logo.jpg?1696515127"
    },
    {
      chainId: 1,
      address: "0xb4fbed161bebcb37afb1cb4a6f7ca18b977ccb25",
      name: "Dogeswap",
      symbol: "DOGES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12763/thumb/20200926-220107.png?1696512560"
    },
    {
      chainId: 1,
      address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
      name: "Aergo",
      symbol: "AERGO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4490/thumb/aergo.png?1696505079"
    },
    {
      chainId: 1,
      address: "0x9506d37f70eb4c3d79c398d326c871abbf10521d",
      name: "Media Licensing Token",
      symbol: "MLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15659/thumb/milc_200x200.png?1696515290"
    },
    {
      chainId: 1,
      address: "0xd26a9c3437f7d121098c8c05c7413f5cc70bb070",
      name: "Azuma Coin",
      symbol: "AZUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10483/thumb/WDncHJ5.png?1696510473"
    },
    {
      chainId: 1,
      address: "0x08711d3b02c8758f2fb3ab4e80228418a7f8e39c",
      name: "Edgeless",
      symbol: "EDG",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/635/thumb/Edgeless-Token.jpg?1696501830"
    },
    {
      chainId: 1,
      address: "0x3b484b82567a09e2588a13d54d032153f0c0aee0",
      name: "OpenDAO",
      symbol: "SOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21956/thumb/fo42wXI6_400x400.jpg?1696521305"
    },
    {
      chainId: 1,
      address: "0xfb559ce67ff522ec0b9ba7f5dc9dc7ef6c139803",
      name: "Probit",
      symbol: "PROB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6765/thumb/ProBit-Exchange-logo.png?1696507099"
    },
    {
      chainId: 1,
      address: "0xc713e5e149d5d0715dcd1c156a020976e7e56b88",
      name: "Aave MKR",
      symbol: "AMKR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14248/thumb/aMKR.ac965178.png?1696513962"
    },
    {
      chainId: 1,
      address: "0x6e0dade58d2d89ebbe7afc384e3e4f15b70b14d8",
      name: "QuiverX",
      symbol: "QRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12916/thumb/qrx_logo.png?1696512704"
    },
    {
      chainId: 1,
      address: "0x8e964e35a76103af4c7d7318e1b1a82c682ae296",
      name: "Fellaz",
      symbol: "FLZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26169/thumb/NUERy1Wy_400x400.png?1696525257"
    },
    {
      chainId: 1,
      address: "0x7707aada3ce7722ac63b91727daf1999849f6835",
      name: "Bankera",
      symbol: "BNK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/1949/thumb/bankera.png?1696502933"
    },
    {
      chainId: 1,
      address: "0xf94b5c5651c888d928439ab6514b93944eee6f48",
      name: "Yield App",
      symbol: "YLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13365/thumb/Google_Play_Store_Icon.png?1696513130"
    },
    {
      chainId: 1,
      address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
      name: "NKN",
      symbol: "NKN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3375/thumb/nkn.png?1696504074"
    },
    {
      chainId: 1,
      address: "0xf058501585023d040ea9493134ed72c083553eed",
      name: "Dymmax",
      symbol: "DMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13476/thumb/dmmx.png?1696513237"
    },
    {
      chainId: 1,
      address: "0xe64b47931f28f89cc7a0c6965ecf89eadb4975f5",
      name: "Ludos Protocol",
      symbol: "LUD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5118/thumb/Ludos_Protocol.jpg?1557216263"
    },
    {
      chainId: 1,
      address: "0x7c8155909cd385f120a56ef90728dd50f9ccbe52",
      name: "Nahmii",
      symbol: "NII",
      decimals: 15,
      logoURI: "https://assets.coingecko.com/coins/images/9786/thumb/nahmii-sm_icon-full-color.png?1696509845"
    },
    {
      chainId: 1,
      address: "0xe0ad1806fd3e7edf6ff52fdb822432e847411033",
      name: "OnX Finance",
      symbol: "ONX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13445/thumb/onxlogo-1.png?1696513209"
    },
    {
      chainId: 1,
      address: "0x909e34d3f6124c324ac83dcca84b74398a6fa173",
      name: "Panther Protocol",
      symbol: "ZKP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18611/thumb/panther.jpg?1696518084"
    },
    {
      chainId: 1,
      address: "0x965d79f1a1016b574a62986e13ca8ab04dfdd15c",
      name: "M2",
      symbol: "M2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18239/thumb/m2_%281%29.png?1696517735"
    },
    {
      chainId: 1,
      address: "0x8e0fe2947752be0d5acf73aae77362daf79cb379",
      name: "NFTrade",
      symbol: "NFTD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18578/thumb/nftrade.png?1696518055"
    },
    {
      chainId: 1,
      address: "0x34bdf48a8f753de4822a6cfb1fee275f9b4d662e",
      name: "FACTS",
      symbol: "BKC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8461/thumb/sFNOkmVx_400x400.jpg?1696508647"
    },
    {
      chainId: 1,
      address: "0x72e203a17add19a3099137c9d7015fd3e2b7dba9",
      name: "BlockchainPoland",
      symbol: "BCP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8143/thumb/43Stz1Tw.png?1696508359"
    },
    {
      chainId: 1,
      address: "0x64a60493d888728cf42616e034a0dfeae38efcf0",
      name: "OneLedger",
      symbol: "OLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3422/thumb/One_Ledger.jpeg?1696504117"
    },
    {
      chainId: 1,
      address: "0x6c3f90f043a72fa612cbac8115ee7e52bde6e490",
      name: "LP 3pool Curve",
      symbol: "3CRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12972/thumb/3pool_128.png?1696512759"
    },
    {
      chainId: 1,
      address: "0x8c4e7f814d40f8929f9112c5d09016f923d34472",
      name: "XCELTOKEN PLUS",
      symbol: "XLAB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8508/thumb/CXQJPNyO_400x400.jpg?1696508687"
    },
    {
      chainId: 1,
      address: "0x4297394c20800e8a38a619a243e9bbe7681ff24e",
      name: "Hot Cross",
      symbol: "HOTCROSS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15706/thumb/Hotcross.png?1696515334"
    },
    {
      chainId: 1,
      address: "0x667102bd3413bfeaa3dffb48fa8288819e480a88",
      name: "Tokenize Xchange",
      symbol: "TKX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/4984/thumb/TKX_-_Logo_-_RGB-15.png?1696505519"
    },
    {
      chainId: 1,
      address: "0x8ef47555856f6ce2e0cd7c36aef4fab317d2e2e2",
      name: "PayAccept",
      symbol: "PAYT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12513/thumb/logo.png?1696512328"
    },
    {
      chainId: 1,
      address: "0xd32641191578ea9b208125ddd4ec5e7b84fcab4c",
      name: "MDsquare",
      symbol: "TMED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8558/thumb/bAdnHTWUIl4rFB4EfbH2L50BW7xi2T9ubci7v6xfYDipXkrG8Wb4LS8g6eAiMsSKqLJfV-FjH5TrYALqACw4MM2A9NfK_L6Ujnddhw1uEgL0hmVQnY96xZeL0C4kkFRJalreK9wUBzjZ4pRhZLdQf9h1drSTF7NE9moAdQ7KtuOvJqommn_q-TjQpF8GUB7J2Ejs7zIvhXXsUHGI1.jpg?1696508730"
    },
    {
      chainId: 1,
      address: "0x4d953cf077c0c95ba090226e59a18fcf97db44ec",
      name: "Mini",
      symbol: "MINI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12298/thumb/IrTAVc_GqZ7iQucAa3fNYlh_Cqt3tY9wM_pmzOl5SifscRMpuzrp_dizMzGTiMr_NxDJPCKigBgz8THrzvO_DqT3JLzqZIYeytDBRw3qKI73dljS0BnFaaI2aLadpdCZah4RkhydddLIDDbQlGit77farlQRaq7qEgxdjVe0aqEeh4phE-DWAKi_KS_Yz-fFdDfjWgifVCKkZRBeNSWWQEplxxl.jpg?1696512125"
    },
    {
      chainId: 1,
      address: "0x0954906da0bf32d5479e25f46056d22f08464cab",
      name: "Index Cooperative",
      symbol: "INDEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12729/thumb/index.png?1696512528"
    },
    {
      chainId: 1,
      address: "0x1e18821e69b9faa8e6e75dffe54e7e25754beda0",
      name: "KIMCHI finance",
      symbol: "KIMCHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12302/thumb/VBa2Z60o_400x400.png?1696512132"
    },
    {
      chainId: 1,
      address: "0x39795344cbcc76cc3fb94b9d1b15c23c2070c66d",
      name: "Seigniorage Shares",
      symbol: "SHARE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/12306/thumb/logo_%281%29.png?1696512136"
    },
    {
      chainId: 1,
      address: "0x4a621d9f1b19296d1c0f87637b3a8d4978e9bf82",
      name: "CyberFM",
      symbol: "CYFM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5476/thumb/cyberfm.png?1696505952"
    },
    {
      chainId: 1,
      address: "0x07150e919b4de5fd6a63de1f9384828396f25fdc",
      name: "Base Protocol",
      symbol: "BASE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/13265/thumb/200x200green.png?1696513039"
    },
    {
      chainId: 1,
      address: "0x054d64b73d3d8a21af3d764efd76bcaa774f3bb2",
      name: "Plasma Finance",
      symbol: "PPAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13340/thumb/Hi9sEGAD.png?1696513107"
    },
    {
      chainId: 1,
      address: "0x41a08648c3766f9f9d85598ff102a08f4ef84f84",
      name: "Aave Balancer Pool Token",
      symbol: "ABPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16788/thumb/ABPT_2x.png?1696516360"
    },
    {
      chainId: 1,
      address: "0x4fbb350052bca5417566f188eb2ebce5b19bc964",
      name: "RigoBlock",
      symbol: "GRG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1532/thumb/Symbol-RigoblockRGB.png?1696502572"
    },
    {
      chainId: 1,
      address: "0x31fdd1c6607f47c14a2821f599211c67ac20fa96",
      name: "Burency",
      symbol: "BUY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12216/thumb/Ddphl9BD.png?1696512050"
    },
    {
      chainId: 1,
      address: "0xdf7ff54aacacbff42dfe29dd6144a69b629f8c9e",
      name: "Aave ZRX",
      symbol: "AZRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14264/thumb/aZRX.9be555a9.png?1696513965"
    },
    {
      chainId: 1,
      address: "0xa1116930326d21fb917d5a27f1e9943a9595fb47",
      name: "Staked Aave Balancer Pool Token",
      symbol: "STKABPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16789/thumb/StkABPT_2x.png?1696516360"
    },
    {
      chainId: 1,
      address: "0x03cce75a4795c1cfab8b7c0a1fb38df46d2f4159",
      name: "Major Dog",
      symbol: "MAJOR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37436/thumb/CC_20240503_195115.png?1715028421"
    },
    {
      chainId: 1,
      address: "0x32a7c02e79c4ea1008dd6564b35f131428673c41",
      name: "Crust Network",
      symbol: "CRU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12549/thumb/sAB3KVzD_400x400.jpg?1696512360"
    },
    {
      chainId: 1,
      address: "0x87e75025d6607564ad005088ab549dd76ca2ce48",
      name: "Pier Protocol",
      symbol: "PIER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35305/thumb/Design_sans_titre__42_-removebg-preview.png?1708154849"
    },
    {
      chainId: 1,
      address: "0xf418588522d5dd018b425e472991e52ebbeeeeee",
      name: "Push Protocol",
      symbol: "PUSH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14769/thumb/aiOxYOJI_400x400.jpeg?1696514438"
    },
    {
      chainId: 1,
      address: "0x2904b9b16652d7d0408eccfa23a19d4a3358230f",
      name: "Puriever",
      symbol: "PURE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12600/thumb/200x200_pure_logo.png?1696512409"
    },
    {
      chainId: 1,
      address: "0x4156d3342d5c385a87d264f90653733592000581",
      name: "SALT",
      symbol: "SALT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/962/thumb/salt.png?1696502077"
    },
    {
      chainId: 1,
      address: "0x940bdcb99a0ee5fb008a606778ae87ed9789f257",
      name: "JFIN Coin",
      symbol: "JFIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13370/thumb/JFin-Coin-Logo.png?1696513134"
    },
    {
      chainId: 1,
      address: "0x6d4ca1177087924edfe0908ef655169ea766fdc3",
      name: "Hedgehog",
      symbol: "HEDGEHOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28552/thumb/hedgie.png?1696527543"
    },
    {
      chainId: 1,
      address: "0x7a771a90b8f2a10afd9a75b8e49d646d1139bb98",
      name: "Stealth Deals",
      symbol: "DEAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33562/thumb/Stealth-Deals-2.png?1702443551"
    },
    {
      chainId: 1,
      address: "0xdc47f2ba852669b178699449e50682d6ceaf8c07",
      name: "Ston",
      symbol: "STON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13001/thumb/ston-v2-200x200.png?1696512790"
    },
    {
      chainId: 1,
      address: "0x3d3d35bb9bec23b06ca00fe472b50e7a4c692c30",
      name: "Vidya",
      symbol: "VIDYA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12219/thumb/VIDYA_TOKEN.png?1696512053"
    },
    {
      chainId: 1,
      address: "0x0aacfbec6a24756c20d41914f2caba817c0d8521",
      name: "YAM",
      symbol: "YAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12530/thumb/YAM-icon.png?1696512343"
    },
    {
      chainId: 1,
      address: "0x0a6c7d5b442ddf53d963581d87932f25743dd3a0",
      name: "SimpleHub",
      symbol: "SHUB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33024/thumb/imgonline-com-ua-Resize-1akYG0UVinM7FOR4.png?1700317445"
    },
    {
      chainId: 1,
      address: "0x65ccd72c0813ce6f2703593b633202a0f3ca6a0c",
      name: "Nestree",
      symbol: "EGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9362/thumb/nestree.png?1696509461"
    },
    {
      chainId: 1,
      address: "0x0a913bead80f321e7ac35285ee10d9d922659cb7",
      name: "DOS Network",
      symbol: "DOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7991/thumb/DOS.png?1696508217"
    },
    {
      chainId: 1,
      address: "0x38a2fdc11f526ddd5a607c1f251c065f40fbf2f7",
      name: "PhoenixDAO",
      symbol: "PHNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11523/thumb/Token_Icon.png?1696511425"
    },
    {
      chainId: 1,
      address: "0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373",
      name: "GAMEE",
      symbol: "GMEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14716/thumb/gmee-200x200.png?1696514386"
    },
    {
      chainId: 1,
      address: "0x2c537e5624e4af88a7ae4060c022609376c8d0eb",
      name: "BiLira",
      symbol: "TRYB",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/10119/thumb/JBs9jiXO_400x400.jpg?1696510144"
    },
    {
      chainId: 1,
      address: "0xa8262eb913fccea4c3f77fc95b8b4043b384cfbb",
      name: "Krypton Galaxy Coin",
      symbol: "KGC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9152/thumb/krypton.PNG?1696509275"
    },
    {
      chainId: 1,
      address: "0x49849c98ae39fff122806c06791fa73784fb3675",
      name: "LP renBTC Curve",
      symbol: "RENBTCCURVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11957/thumb/Curvefi_renCrv_32.png?1696511817"
    },
    {
      chainId: 1,
      address: "0x84ca8bc7997272c7cfb4d0cd3d55cd942b3c9419",
      name: "DIA",
      symbol: "DIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11955/thumb/Token_Logo.png?1696511815"
    },
    {
      chainId: 1,
      address: "0x593114f03a0a575aece9ed675e52ed68d2172b8c",
      name: "BidiPass",
      symbol: "BDP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3890/thumb/AxiFAoHc_400x400.jpg?1696504552"
    },
    {
      chainId: 1,
      address: "0x8806926ab68eb5a7b909dcaf6fdbe5d93271d6e2",
      name: "Uquid Coin",
      symbol: "UQC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1341/thumb/uquid-coin.png?1696502403"
    },
    {
      chainId: 1,
      address: "0x7a939bb714fd2a48ebeb1e495aa9aaa74ba9fa68",
      name: "Electric Vehicle Zone",
      symbol: "EVZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9456/thumb/kLohzILUIln6mHFYOlecpWjINVIH-BVghP2vRTeuD0XteaQa7Lpn4sLcuPN4gHw8MU2pKWZCJRNwBmyyl1CYxplCLDcgSVihMC7vvfmkepY-_O_ImWBA27s4pKNlhcBnBYrc8y5WH0ZB2CjmqPh-32nPslrv329tqFWr2DAR8dl4R5LZGgeZ1ubCdtMoUua6gEL3umYShHBxrYLto.jpg?1696509547"
    },
    {
      chainId: 1,
      address: "0xaa2ce7ae64066175e0b90497ce7d9c190c315db4",
      name: "Suterusu",
      symbol: "SUTER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9830/thumb/p-NFlBlw_400x400.jpg?1696509886"
    },
    {
      chainId: 1,
      address: "0xface851a4921ce59e912d19329929ce6da6eb0c7",
      name: "cLINK",
      symbol: "CLINK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/23943/thumb/iShot2022-02-25_14.35.54.png?1696523139"
    },
    {
      chainId: 1,
      address: "0x2fd61567c29e7adb4ca17e60e1f4a3fcfe68acb8",
      name: "SymVerse",
      symbol: "SYM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9449/thumb/Picture1.png?1696509540"
    },
    {
      chainId: 1,
      address: "0x8e30ea2329d95802fd804f4291220b0e2f579812",
      name: "Decentralized Vulnerability Platform",
      symbol: "DVP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9424/thumb/4520.png?1696509517"
    },
    {
      chainId: 1,
      address: "0x20c36f062a31865bed8a5b1e512d9a1a20aa333a",
      name: "DefiDollar DAO",
      symbol: "DFD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12959/thumb/DFD.jpg?1696512747"
    },
    {
      chainId: 1,
      address: "0xffe510a92434a0df346c5e72a3494b043cf249eb",
      name: "LUX BIO EXCHANGE COIN",
      symbol: "LBXC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9482/thumb/sam7Fy3A_400x400.jpg?1696509569"
    },
    {
      chainId: 1,
      address: "0xc77b230f31b517f1ef362e59c173c2be6540b5e8",
      name: "VIDY",
      symbol: "VIDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5088/thumb/vidy-logo.jpg?1696505610"
    },
    {
      chainId: 1,
      address: "0x37f74e99794853777a10ea1dc08a64c86958f06a",
      name: "D Community",
      symbol: "DILI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9485/thumb/BYf_d6kekNWOY34VLGPvf7RcVj8SeRi7P65Nk0W7ji1jir_qSLfssffnNW0ZzQSWzhhsNRkMCL7qcX4CCaMTbgKb0D7b5yNeStKVMm2deZd9cONMuItgoKUXxIYkHElfk1PW2uiNZbg6a2K0OHtZTvkt1xo8YVKuthskXaryOkM6Ax-MXQlHOfbjwCcnQQjHxAucufrCZJfDgrY.jpg?1696509571"
    },
    {
      chainId: 1,
      address: "0x7fbec0bb6a7152e77c30d005b5d49cbc08a602c3",
      name: "disBalancer",
      symbol: "DDOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14791/thumb/communityIcon_o2yriheuszk61.png?1696514460"
    },
    {
      chainId: 1,
      address: "0x6fe56c0bcdd471359019fcbc48863d6c3e9d4f41",
      name: "Props",
      symbol: "PROPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6735/thumb/photo-2017-10-10-03-32-02.png?1696507070"
    },
    {
      chainId: 1,
      address: "0xfd957f21bd95e723645c07c48a2d8acb8ffb3794",
      name: "Ethereum Meta",
      symbol: "ETHM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6586/thumb/ethereum-meta.png?1696506937"
    },
    {
      chainId: 1,
      address: "0x05bbe7240de66f6480c9aeda77c1376b13393f83",
      name: "Xeno",
      symbol: "XNO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13830/thumb/XNO_logo_200x200.png?1696513573"
    },
    {
      chainId: 1,
      address: "0x808632424440f6483d9be7509812b53ed0f00344",
      name: "Mechazilla",
      symbol: "MECHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33025/thumb/MECHA.jpg?1700318938"
    },
    {
      chainId: 1,
      address: "0xb19dd661f076998e3b0456935092a233e12c2280",
      name: "Continuum World",
      symbol: "UM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18798/thumb/Moneda.png?1696518260"
    },
    {
      chainId: 1,
      address: "0xf2cdf38e24738ba379ffa38d47bc88a941df5627",
      name: "Ally",
      symbol: "ALY",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/9619/thumb/BTf_sTXi_400x400.jpg?1696509692"
    },
    {
      chainId: 1,
      address: "0x6c3be406174349cfa4501654313d97e6a31072e1",
      name: "CNNS",
      symbol: "CNNS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8362/thumb/cnns.png?1696508555"
    },
    {
      chainId: 1,
      address: "0x62dc4817588d53a056cbbd18231d91ffccd34b2a",
      name: "DeHive",
      symbol: "DHV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14926/thumb/logo_200x200.png?1696514587"
    },
    {
      chainId: 1,
      address: "0x3e8203e0b1d56984abc66f183a8d0b1a09a7e607",
      name: "Liquid Protocol",
      symbol: "LP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32078/thumb/5000x5000.png?1696530875"
    },
    {
      chainId: 1,
      address: "0xe0b9bcd54bf8a730ea5d3f1ffce0885e911a502c",
      name: "ZUM",
      symbol: "ZUM",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9721/thumb/zum256x256.png?1696509787"
    },
    {
      chainId: 1,
      address: "0x467bccd9d29f223bce8043b84e8c8b282827790f",
      name: "Telcoin",
      symbol: "TEL",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/1899/thumb/tel.png?1696502892"
    },
    {
      chainId: 1,
      address: "0x5d60d8d7ef6d37e16ebabc324de3be57f135e0bc",
      name: "MyBit",
      symbol: "MYB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1240/thumb/mybit.png?1696502315"
    },
    {
      chainId: 1,
      address: "0x8a854288a5976036a725879164ca3e91d30c6a1b",
      name: "GET Protocol",
      symbol: "GET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1927/thumb/GET_Protocol.png?1696502916"
    },
    {
      chainId: 1,
      address: "0x65a8fba02f641a13bb7b01d5e1129b0521004f52",
      name: "Amasa",
      symbol: "AMAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18799/thumb/agmqWjv8_400x400.png?1696518261"
    },
    {
      chainId: 1,
      address: "0x5fbc2ffe91ac74e3e286bd7504b233f0e5291c69",
      name: "EarnBet",
      symbol: "EBET",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32032/thumb/logo.png?1696530829"
    },
    {
      chainId: 1,
      address: "0xd7d05bda4bf5876ba1254b3eaaf8b47d2f5676eb",
      name: "STABLE ASSET",
      symbol: "STA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12313/thumb/stable_200x200.png?1696512142"
    },
    {
      chainId: 1,
      address: "0xfae4ee59cdd86e3be9e8b90b53aa866327d7c090",
      name: "CPChain",
      symbol: "CPC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2760/thumb/cpchain.png?1696503533"
    },
    {
      chainId: 1,
      address: "0x33d0568941c0c64ff7e0fb4fba0b11bd37deed9f",
      name: "RAMP  OLD ",
      symbol: "RAMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12837/thumb/RAMP-Logo-v2-1000pxsq.png?1696512628"
    },
    {
      chainId: 1,
      address: "0x249e38ea4102d0cf8264d3701f1a0e39c4f2dc3b",
      name: "UFO Gaming",
      symbol: "UFO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16801/thumb/ufo.png?1696516371"
    },
    {
      chainId: 1,
      address: "0xaac679720204aaa68b6c5000aa87d789a3ca0aa5",
      name: "Huobi Bitcoin Cash",
      symbol: "HBCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14105/thumb/HBCh.png?1696513826"
    },
    {
      chainId: 1,
      address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
      name: "IDEX",
      symbol: "IDEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2565/thumb/idexlogo.png?1696503371"
    },
    {
      chainId: 1,
      address: "0x24da31e7bb182cb2cabfef1d88db19c2ae1f5572",
      name: "Shikoku",
      symbol: "SHIK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28560/thumb/shikoku_inu02.png?1696527550"
    },
    {
      chainId: 1,
      address: "0xc1abb8c93be6811affc70675b0432926c4bfbb5d",
      name: "UERII",
      symbol: "UERII",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29388/thumb/Avatar512.png?1696528334"
    },
    {
      chainId: 1,
      address: "0x6c936d4ae98e6d2172db18c16c4b601c99918ee6",
      name: "Life Crypto",
      symbol: "LIFE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18245/thumb/communityIcon_t3kzc5skazh81.png?1696517741"
    },
    {
      chainId: 1,
      address: "0xf80d589b3dbe130c270a69f1a69d050f268786df",
      name: "Datamine",
      symbol: "DAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11695/thumb/qxsFH8W.png?1696511584"
    },
    {
      chainId: 1,
      address: "0x03806ce5ef69bd9780edfb04c29da1f23db96294",
      name: "Tesla TSL",
      symbol: "TSL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1222/thumb/energo.png?1696502301"
    },
    {
      chainId: 1,
      address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
      name: "Viberate",
      symbol: "VIB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/983/thumb/Viberate.png?1696502096"
    },
    {
      chainId: 1,
      address: "0x5d5e244660ca05c42073c9a526616d99f2c99516",
      name: "Game Tree",
      symbol: "GTCOIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24719/thumb/hUEmunGU_400x400.jpg?1696523883"
    },
    {
      chainId: 1,
      address: "0xf5717f5df41ea67ef67dfd3c1d02f9940bcf5d08",
      name: "SeChain",
      symbol: "SNN",
      decimals: 3,
      logoURI: "https://assets.coingecko.com/coins/images/11961/thumb/2AsGMTeI_400x400.jpg?1696511821"
    },
    {
      chainId: 1,
      address: "0x0ff6ffcfda92c53f615a4a75d982f399c989366b",
      name: "UniLayer",
      symbol: "LAYER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12164/thumb/logo-layer.jpg?1696512002"
    },
    {
      chainId: 1,
      address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
      name: "SingularDTV",
      symbol: "SNGLS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/521/thumb/singulardtv.png?1696501742"
    },
    {
      chainId: 1,
      address: "0x604026696fdb3c6720ae3049c46d59ac604dea0a",
      name: "eXciting Japan Coin",
      symbol: "XJP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11963/thumb/XJP_LOGO.png?1696511822"
    },
    {
      chainId: 1,
      address: "0x301c755ba0fca00b1923768fffb3df7f4e63af31",
      name: "Global Digital Content",
      symbol: "GDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10122/thumb/Vp4L1x4Hu4HEuEPUl0gSocDaVifkXlCqSd8A72ml_Q0uwEc9uBWBTwjS43_NP8eiiZVveJDIQXguWUXYk3MLZiFOER-8CGO120I0NGU_L8aTJ8c50a-O_AbkY-4nUkPYhUTNgf3rkcqkXnKecixQwLfkJG2XTCLwNvo_ox05x0_hU1Z__FOT4O7AeU-PC6skc85NCVS68cnZjxcUBOY9K.jpg?1696510147"
    },
    {
      chainId: 1,
      address: "0x0a7b89e66a1dc16633abdfd132bae05827d3bfa5",
      name: "hiMOONBIRDS",
      symbol: "HIMOONBIRDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28663/thumb/himoonbirds.png?1696527648"
    },
    {
      chainId: 1,
      address: "0xfca47962d45adfdfd1ab2d972315db4ce7ccf094",
      name: "iXledger",
      symbol: "IXT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/814/thumb/ixledger.png?1696501963"
    },
    {
      chainId: 1,
      address: "0x79be75ffc64dd58e66787e4eae470c8a1fd08ba4",
      name: "Aave AMM DAI",
      symbol: "AAMMDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17197/thumb/aAMMDAI_2x.png?1696516754"
    },
    {
      chainId: 1,
      address: "0x17a79792fe6fe5c95dfe95fe3fcee3caf4fe4cb7",
      name: "Aave AMM USDT",
      symbol: "AAMMUSDT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/17200/thumb/aAMMUSDT_2x.png?1696516757"
    },
    {
      chainId: 1,
      address: "0x98968f0747e0a261532cacc0be296375f5c08398",
      name: "MOONCAT Vault  NFTX ",
      symbol: "MOONCAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17055/thumb/Mooncats.png?1696516618"
    },
    {
      chainId: 1,
      address: "0x2c8ea636345a231e4b1a28f6eeb2072ed909c406",
      name: "Meme Elon Doge Floki",
      symbol: "MEMELON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32609/thumb/MEMELON.jpg?1698733326"
    },
    {
      chainId: 1,
      address: "0xacbd826394189cf2623c6df98a18b41fc8ffc16d",
      name: "NFTify",
      symbol: "N1",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16095/thumb/n1-token-logo-circle-200x200.png?1696515703"
    },
    {
      chainId: 1,
      address: "0x89509aa1d14a8e1e5364ec4c3b041213bcdbe08d",
      name: "ZURRENCY",
      symbol: "ZURR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22240/thumb/logo.png?1696521585"
    },
    {
      chainId: 1,
      address: "0x2e95cea14dd384429eb3c4331b776c4cfbb6fcd9",
      name: "Throne",
      symbol: "THN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16965/thumb/aXhD3i_g_400x400.jpg?1696516531"
    },
    {
      chainId: 1,
      address: "0xe67f943af5eb6051ef56f05979cc30b732717fa6",
      name: "WATTTON",
      symbol: "WATT",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/27215/thumb/CG_WATT_LOGO.png?1696526262"
    },
    {
      chainId: 1,
      address: "0x2fe39f22eac6d3c1c86dd9d143640ebb94609fce",
      name: "JD Coin",
      symbol: "JDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9958/thumb/Cv-2ca6p_400x400.jpg?1696509998"
    },
    {
      chainId: 1,
      address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
      name: "Alchemix",
      symbol: "ALCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14113/thumb/Alchemix.png?1696513834"
    },
    {
      chainId: 1,
      address: "0x6a7ef4998eb9d0f706238756949f311a59e05745",
      name: "Keysians Network",
      symbol: "KEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12141/thumb/Keysians_logo.jpg?1696511982"
    },
    {
      chainId: 1,
      address: "0x48fb253446873234f2febbf9bdeaa72d9d387f94",
      name: "Bancor Governance",
      symbol: "VBNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14053/thumb/Bancor_Token.png?1710479583"
    },
    {
      chainId: 1,
      address: "0xbc6da0fe9ad5f3b0d58160288917aa56653660e9",
      name: "Alchemix USD",
      symbol: "ALUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14114/thumb/Alchemix_USD.png?1696513835"
    },
    {
      chainId: 1,
      address: "0x3301ee63fb29f863f2333bd4466acb46cd8323e6",
      name: "Akita Inu",
      symbol: "AKITA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14115/thumb/akita.png?1696513836"
    },
    {
      chainId: 1,
      address: "0xac6df26a590f08dcc95d5a4705ae8abbc88509ef",
      name: "Aave ENJ",
      symbol: "AENJ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14251/thumb/aENJ.ed76293b.png?1696513964"
    },
    {
      chainId: 1,
      address: "0x7866e48c74cbfb8183cd1a929cd9b95a7a5cb4f4",
      name: "DexKit",
      symbol: "KIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13187/thumb/7739.png?1696512969"
    },
    {
      chainId: 1,
      address: "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
      name: "MATH",
      symbol: "MATH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11335/thumb/2020-05-19-token-200.png?1696511257"
    },
    {
      chainId: 1,
      address: "0x035df12e0f3ac6671126525f1015e47d79dfeddf",
      name: "0xMonero",
      symbol: "0XMR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11035/thumb/0xmnr.PNG?1696510979"
    },
    {
      chainId: 1,
      address: "0xdf574c24545e5ffecb9a659c229253d4111d87e1",
      name: "HUSD",
      symbol: "HUSD",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9567/thumb/HUSD.jpg?1696509647"
    },
    {
      chainId: 1,
      address: "0xc7283b66eb1eb5fb86327f08e1b5816b0720212b",
      name: "Tribe",
      symbol: "TRIBE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14575/thumb/tribe.PNG?1696514256"
    },
    {
      chainId: 1,
      address: "0x50bc2ecc0bfdf5666640048038c1aba7b7525683",
      name: "carVertical",
      symbol: "CV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2098/thumb/carvertical.png?1696503065"
    },
    {
      chainId: 1,
      address: "0x70881d5c8a5950ceedf1f1b4b5d4105718642548",
      name: "Bagholder",
      symbol: "BAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30503/thumb/rsz_bagholdrpepecut-sq%281%29.png?1696529389"
    },
    {
      chainId: 1,
      address: "0xa685a61171bb30d4072b338c80cb7b2c865c873e",
      name: "Aave MANA",
      symbol: "AMANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14267/thumb/aMANA.f89a1098.png?1696513968"
    },
    {
      chainId: 1,
      address: "0xb53ecf1345cabee6ea1a65100ebb153cebcac40f",
      name: "Childhoods End",
      symbol: "O",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25670/thumb/photo_2022-05-27_12-45-29.jpg?1696524798"
    },
    {
      chainId: 1,
      address: "0xdd16ec0f66e54d453e6756713e533355989040e4",
      name: "Tokenomy",
      symbol: "TEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2286/thumb/logo_%281%29.png?1696503190"
    },
    {
      chainId: 1,
      address: "0x0d15009896efe9972f8e086bdd3bcba5c1f74bf3",
      name: "SonoCoin",
      symbol: "SONO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/7230/thumb/MeWTs09-_400x400.jpg?1696507526"
    },
    {
      chainId: 1,
      address: "0x9ee91f9f426fa633d227f7a9b000e28b9dfd8599",
      name: "Lido Staked Matic",
      symbol: "STMATIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24185/thumb/stMATIC.png?1696523373"
    },
    {
      chainId: 1,
      address: "0x85614a474dbeed440d5bbdb8ac50b0f22367f997",
      name: "Verge  ETH ",
      symbol: "XVG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32585/thumb/Verge_Token_%28erc-20%29_icon_200x200.jpg?1699220724"
    },
    {
      chainId: 1,
      address: "0x74faab6986560fd1140508e4266d8a7b87274ffd",
      name: "HyperDAO",
      symbol: "HDAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10780/thumb/B7-ppPfE_400x400.png?1696510742"
    },
    {
      chainId: 1,
      address: "0xedee9cc3bf9cfd86a493a23a0775508e0f826644",
      name: "Atalis",
      symbol: "ALS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35857/thumb/logo200.jpg?1709896205"
    },
    {
      chainId: 1,
      address: "0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3",
      name: "LEO Token",
      symbol: "LEO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8418/thumb/leo-token.png?1696508607"
    },
    {
      chainId: 1,
      address: "0x666d875c600aa06ac1cf15641361dec3b00432ef",
      name: "BTSE Token",
      symbol: "BTSE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/10807/thumb/BTSE_logo_Square.jpeg?1696510765"
    },
    {
      chainId: 1,
      address: "0x95e40e065afb3059dcabe4aaf404c1f92756603a",
      name: "King DAG",
      symbol: "KDAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10809/thumb/3xcLUorv_400x400.jpg?1696510767"
    },
    {
      chainId: 1,
      address: "0x4e9fcd48af4738e3bf1382009dc1e93ebfce698f",
      name: "TAO INU",
      symbol: "TAONU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33145/thumb/656b24d78397f73bfbadb752_TAONU_Logo_100x100.jpg?1701861274"
    },
    {
      chainId: 1,
      address: "0x8400d94a5cb0fa0d041a3788e395285d61c9ee5e",
      name: "Unibright",
      symbol: "UBT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2707/thumb/UnibrightLogo_colorful_500x500_preview.png?1696503489"
    },
    {
      chainId: 1,
      address: "0x62431de84c503e152a8957ff51c8945aaaa7d929",
      name: "BlastAI",
      symbol: "BLAST",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35858/thumb/Design_sans_titre_%2818%29_15.51.23.png?1709896264"
    },
    {
      chainId: 1,
      address: "0xcb2b9b5b136dc29feb0548dff315021b9b6c2ba0",
      name: "GigaToken",
      symbol: "GIGA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34899/thumb/Giga_Logo.png?1708020799"
    },
    {
      chainId: 1,
      address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
      name: "XPR Network",
      symbol: "XPR",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/10941/thumb/XPR.jpg?1696510891"
    },
    {
      chainId: 1,
      address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
      name: "Marlin",
      symbol: "POND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8903/thumb/200x200.png?1706115827"
    },
    {
      chainId: 1,
      address: "0x8578530205cecbe5db83f7f29ecfeec860c297c2",
      name: "smARTOFGIVING",
      symbol: "AOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6050/thumb/logo_%286%29.png?1696506459"
    },
    {
      chainId: 1,
      address: "0x979aca85ba37c675e78322ed5d97fa980b9bdf00",
      name: "FUSION",
      symbol: "FSN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2515/thumb/Fusion_200x200.png?1696503329"
    },
    {
      chainId: 1,
      address: "0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6",
      name: "LBK",
      symbol: "LBK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9492/thumb/lbk.jpeg?1696509578"
    },
    {
      chainId: 1,
      address: "0x79c9e0410b6615e7ba9dd69614b0519325a2b047",
      name: "hiFLUF",
      symbol: "HIFLUF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28602/thumb/hifluf.png?1696527588"
    },
    {
      chainId: 1,
      address: "0x8290333cef9e6d528dd5618fb97a76f268f3edd4",
      name: "Ankr Network",
      symbol: "ANKR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1696504928"
    },
    {
      chainId: 1,
      address: "0x42726d074bba68ccc15200442b72afa2d495a783",
      name: "Isiklar Coin",
      symbol: "ISIKC",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/10992/thumb/logo_%2866%29.png?1696510941"
    },
    {
      chainId: 1,
      address: "0x2ef52ed7de8c5ce03a4ef0efbe9b7450f2d7edc9",
      name: "Revain",
      symbol: "REV",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/1107/thumb/256x256.png?1696502203"
    },
    {
      chainId: 1,
      address: "0xc237868a9c5729bdf3173dddacaa336a0a5bb6e0",
      name: "Wagerr",
      symbol: "WGR",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/759/thumb/syGKmAT.png?1696501912"
    },
    {
      chainId: 1,
      address: "0xa0cf46eb152656c7090e769916eb44a138aaa406",
      name: "Spheroid Universe",
      symbol: "SPH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11968/thumb/Frame_36.png?1696511827"
    },
    {
      chainId: 1,
      address: "0xde2f7766c8bf14ca67193128535e5c7454f8387c",
      name: "Metadium",
      symbol: "META",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5247/thumb/META_Logo_black.png?1696505751"
    },
    {
      chainId: 1,
      address: "0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131",
      name: "NAGA",
      symbol: "NGC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1439/thumb/naga.jpg?1696502489"
    },
    {
      chainId: 1,
      address: "0xd31a59c85ae9d8edefec411d448f90841571b89c",
      name: "SOL  Wormhole ",
      symbol: "SOL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/22876/thumb/SOL_wh_small.png?1696522175"
    },
    {
      chainId: 1,
      address: "0x69cbaf6c147086c3c234385556f8a0c6488d3420",
      name: "69420",
      symbol: "69420",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32830/thumb/bg_f8f8f8-flat_750x_075_f-pad_750x1000_f8f8f8.jpg?1699585611"
    },
    {
      chainId: 1,
      address: "0xb1a30851e3f7d841b231b086479608e17198363a",
      name: "Homeros",
      symbol: "HMR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11048/thumb/g1jAE5knZSlNUdLN8fEAQFMI4mTXCuNdrjj3i77rWhsIQADp3VWH2BHTkH7-oWwExxJk7Fu545LPeT3gMNzGlCZ63oX3-9sTjiqlSDo3fRLwHmhUgjD_jtKTl1AJ_F_UOOpsTqob9CxiWHXsSTlz0zODxOrjnqpMe4_cPT_C4EskSEVee_oooTasTQ6ONrv85Zcvc8Eeb8cHLsV.jpg?1696510991"
    },
    {
      chainId: 1,
      address: "0x0e4188bda0a92ff4fff62392211b076c0119198d",
      name: "0xSnipeProAi",
      symbol: "0XSPAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34331/thumb/0XSPAI.jpg?1704668642"
    },
    {
      chainId: 1,
      address: "0xe5acbb03d73267c03349c76ead672ee4d941f499",
      name: "BEAM",
      symbol: "BEAM",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/7339/thumb/BEAM.png?1696507623"
    },
    {
      chainId: 1,
      address: "0xc4de189abf94c57f396bd4c52ab13b954febefd8",
      name: "B20",
      symbol: "B20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13803/thumb/b20.png?1696513550"
    },
    {
      chainId: 1,
      address: "0x8fc9b6354e839ab1c8b31f4afa53607092b8c2e5",
      name: "ECOSC",
      symbol: "ECU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10989/thumb/ecosc-logo.png?1696510938"
    },
    {
      chainId: 1,
      address: "0x3d382228c54736d831fac2748f4734d9177c7332",
      name: "Aniverse",
      symbol: "ANV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16348/thumb/anv.PNG?1696515948"
    },
    {
      chainId: 1,
      address: "0xb8fa12f8409da31a4fc43d15c4c78c33d8213b9b",
      name: "CaliCoin",
      symbol: "CALI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14998/thumb/cropped-Logo-transparent-background-1.png?1696514662"
    },
    {
      chainId: 1,
      address: "0x8716fc5da009d3a208f0178b637a50f4ef42400f",
      name: "Ultrain",
      symbol: "UGAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4684/thumb/ultrain.png?1696505251"
    },
    {
      chainId: 1,
      address: "0x8a9c67fee641579deba04928c4bc45f66e26343a",
      name: "Jarvis Reward",
      symbol: "JRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10390/thumb/cfeii0y.png?1696510389"
    },
    {
      chainId: 1,
      address: "0x3affcca64c2a6f4e3b6bd9c64cd2c969efd1ecbe",
      name: "DSLA Protocol",
      symbol: "DSLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6694/thumb/dsla_logo-squared_200x200.png?1696507035"
    },
    {
      chainId: 1,
      address: "0x9343e24716659a3551eb10aff9472a2dcad5db2d",
      name: "STFX",
      symbol: "STFX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28631/thumb/stfx.png?1696527615"
    },
    {
      chainId: 1,
      address: "0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4",
      name: "Sylo",
      symbol: "SYLO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6430/thumb/SYLO.svg?1696506795"
    },
    {
      chainId: 1,
      address: "0xfd6c31bb6f05fc8db64f4b740ab758605c271fd8",
      name: "Contracoin",
      symbol: "CTCN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10801/thumb/Contracoin-symbol.png?1696510760"
    },
    {
      chainId: 1,
      address: "0x8bc2bcb1b1896291942c36f3cca3c1afa0aaa7fd",
      name: "3SPACE ART",
      symbol: "PACE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33575/thumb/3space-art.png?1702901855"
    },
    {
      chainId: 1,
      address: "0xe0bceef36f3a6efdd5eebfacd591423f8549b9d5",
      name: "Defactor",
      symbol: "FACTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19201/thumb/jFLSu4U9_400x400.png?1696518648"
    },
    {
      chainId: 1,
      address: "0x52498f8d9791736f1d6398fe95ba3bd868114d10",
      name: "Netvrk",
      symbol: "NETVR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15721/thumb/netvrk_icon.png?1696515348"
    },
    {
      chainId: 1,
      address: "0x73d7c860998ca3c01ce8c808f5577d94d545d1b4",
      name: "IX Swap",
      symbol: "IXS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18069/thumb/ixswap.PNG?1696517577"
    },
    {
      chainId: 1,
      address: "0xa7de087329bfcda5639247f96140f9dabe3deed1",
      name: "Statera",
      symbol: "STA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11472/thumb/Statera.png?1696511379"
    },
    {
      chainId: 1,
      address: "0x82a77710495a35549d2add797412b4a4497d33ef",
      name: "Dogz",
      symbol: "DOGZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7544/thumb/dogz.png?1696507809"
    },
    {
      chainId: 1,
      address: "0x6fb3e0a217407efff7ca062d46c26e5d60a14d69",
      name: "IoTeX",
      symbol: "IOTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3334/thumb/iotex-logo.png?1696504041"
    },
    {
      chainId: 1,
      address: "0xc4c346edc55504574cceb00aa1091d22404a4bc3",
      name: "MEZZ",
      symbol: "MEZZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29344/thumb/20230307_234212.png?1696528293"
    },
    {
      chainId: 1,
      address: "0x506b8f75bdef0edac36b0a6f9cf313485e4341b0",
      name: "WCAPES",
      symbol: "WCA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29361/thumb/wca.png?1696528309"
    },
    {
      chainId: 1,
      address: "0x580c8520deda0a441522aeae0f9f7a5f29629afa",
      name: "Dawn Protocol",
      symbol: "DAWN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11555/thumb/dawn_protocol.png?1696511454"
    },
    {
      chainId: 1,
      address: "0x3a880652f47bfaa771908c07dd8673a787daed3a",
      name: "DerivaDAO",
      symbol: "DDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13453/thumb/ddx_logo.png?1696513216"
    },
    {
      chainId: 1,
      address: "0x05030203674173fa6df6f9f7e34d6e70e9a761d7",
      name: "Muverse",
      symbol: "MU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28857/thumb/20230130_100626.jpg?1696527831"
    },
    {
      chainId: 1,
      address: "0x5e3346444010135322268a4630d2ed5f8d09446c",
      name: "LockTrip",
      symbol: "LOC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1357/thumb/LOC_Transparent_New.png?1696502416"
    },
    {
      chainId: 1,
      address: "0x1c95b093d6c236d3ef7c796fe33f9cc6b8606714",
      name: "BOMB",
      symbol: "BOMB",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/7713/thumb/Bomb-token.png?1549944422"
    },
    {
      chainId: 1,
      address: "0xc538143202f3b11382d8606aae90a96b042a19db",
      name: "Coinsbit Token",
      symbol: "CNB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10340/thumb/cbicon.png?1696510342"
    },
    {
      chainId: 1,
      address: "0xc06d9013a1d3f25f76ee5291bbc04a181985814e",
      name: "Yertle The Turtle",
      symbol: "YERTLE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32518/thumb/IMG_6911.jpeg?1698406852"
    },
    {
      chainId: 1,
      address: "0x9ed8e7c9604790f7ec589f99b94361d8aab64e5e",
      name: "Unistake",
      symbol: "UNISTAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12813/thumb/unistake.png?1696512606"
    },
    {
      chainId: 1,
      address: "0x58b6a8a3302369daec383334672404ee733ab239",
      name: "Livepeer",
      symbol: "LPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7137/thumb/logo-circle-green.png?1696507437"
    },
    {
      chainId: 1,
      address: "0xe69d699cbcd79cb1b55f82cf36bf1a2836053562",
      name: "DropCoin",
      symbol: "DROP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32835/thumb/Frame_5_%2848%29.jpg?1699586509"
    },
    {
      chainId: 1,
      address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
      name: "XYO Network",
      symbol: "XYO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4519/thumb/XYO_Network-logo.png?1696505103"
    },
    {
      chainId: 1,
      address: "0xfa14fa6958401314851a17d6c5360ca29f74b57b",
      name: "Saito",
      symbol: "SAITO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14750/thumb/SAITO.png?1696514419"
    },
    {
      chainId: 1,
      address: "0x8c543aed163909142695f2d2acd0d55791a9edb9",
      name: "Velas",
      symbol: "VLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9651/thumb/logo_blue.png?1696509720"
    },
    {
      chainId: 1,
      address: "0xc9eb61ffb66d5815d643bbb8195e17c49687ae1e",
      name: "Morpheus Labs",
      symbol: "MIND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3164/thumb/mitx.png?1696503886"
    },
    {
      chainId: 1,
      address: "0x7c5d5100b339fe7d995a893af6cb496b9474373c",
      name: "Loon Network",
      symbol: "LOON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11673/thumb/ErUvUA2D4Q8hPWXxZBIuiI8MD0nrU2rDEY56d6EtVzJDTqlflAFXa2bgJ_kFwb8OtotfAvESvm-dik7d_SeJJh23f6RosUJ0AzU64QcKk5H3fu300KOJjFDFsntpRWARFKI5S4Cc8F3pcRPBkFIw6oPF58mKi83sa2DJPl-E5JMqmj6rJh5acb7Fvi80kfziWv3DHhhpg1YJYMP.jpg?1696511563"
    },
    {
      chainId: 1,
      address: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
      name: "Aleph im",
      symbol: "ALEPH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11676/thumb/Aleph-Logo-BW.png?1696511566"
    },
    {
      chainId: 1,
      address: "0xcc12abe4ff81c9378d670de1b57f8e0dd228d77a",
      name: "Aave REN",
      symbol: "AREN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14249/thumb/aREN.382be386.png?1696513963"
    },
    {
      chainId: 1,
      address: "0xa19f5264f7d7be11c451c093d8f92592820bea86",
      name: "Neo Tokyo",
      symbol: "BYTES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28858/thumb/bytes.png?1696527832"
    },
    {
      chainId: 1,
      address: "0x4dfae3690b93c47470b03036a17b23c1be05127c",
      name: "The Original Pepe",
      symbol: "PEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35702/thumb/logo.png?1709567988"
    },
    {
      chainId: 1,
      address: "0x0aee8703d34dd9ae107386d3eff22ae75dd616d1",
      name: "Tranche Finance",
      symbol: "SLICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14119/thumb/slice.png?1696513839"
    },
    {
      chainId: 1,
      address: "0x5aaefe84e0fb3dd1f0fcff6fa7468124986b91bd",
      name: "Evedo",
      symbol: "EVED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7721/thumb/Variations-09.png?1696507968"
    },
    {
      chainId: 1,
      address: "0x03042ae6fcfd53e3a0baa1fab5ce70e0cb74e6fb",
      name: "Ten Best Coins",
      symbol: "TBC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27312/thumb/tbc.png?1696526362"
    },
    {
      chainId: 1,
      address: "0x701c244b988a513c945973defa05de933b23fe1d",
      name: "OAX",
      symbol: "OAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/853/thumb/OAXlogo.png?1696501987"
    },
    {
      chainId: 1,
      address: "0x1c9922314ed1415c95b9fd453c3818fd41867d0b",
      name: "Tower",
      symbol: "TOWER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14134/thumb/tower-circular-1000.png?1696513854"
    },
    {
      chainId: 1,
      address: "0x662b67d00a13faf93254714dd601f5ed49ef2f51",
      name: "Orbit Chain",
      symbol: "ORC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9782/thumb/-p1Br7oh_400x400.png?1696509841"
    },
    {
      chainId: 1,
      address: "0xd6bd97a26232ba02172ff86b055d5d7be789335b",
      name: "Ormeus Cash",
      symbol: "OMC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11798/thumb/Vooo8SX.png?1696511674"
    },
    {
      chainId: 1,
      address: "0xd3e4ba569045546d09cf021ecc5dfe42b1d7f6e4",
      name: "Morpheus Network",
      symbol: "MNW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2379/thumb/MRPH_CoinGecko.png?1696503245"
    },
    {
      chainId: 1,
      address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
      name: "Immutable",
      symbol: "IMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17233/thumb/immutableX-symbol-BLK-RGB.png?1696516787"
    },
    {
      chainId: 1,
      address: "0x213c53c96a01a89e6dcc5683cf16473203e17513",
      name: "Defi Shopping Stake",
      symbol: "DSS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12602/thumb/DSS.png?1696512411"
    },
    {
      chainId: 1,
      address: "0x0ad896863ce4cd84f10a9d30d4f509ceffd53c84",
      name: "Chocolate Like Butterfly",
      symbol: "CLB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28859/thumb/clb.png?1696527833"
    },
    {
      chainId: 1,
      address: "0x6226e00bcac68b0fe55583b90a1d727c14fab77f",
      name: "MultiVAC",
      symbol: "MTV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4937/thumb/MultiVAC.png?1696505477"
    },
    {
      chainId: 1,
      address: "0x400b1d8a7dd8c471026b2c8cbe1062b27d120538",
      name: "Limestone Network",
      symbol: "LIMEX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/11907/thumb/nw1FE_f4_400x400.png?1696511771"
    },
    {
      chainId: 1,
      address: "0xe1fc4455f62a6e89476f1072530c20cf1a0622da",
      name: "Phuture",
      symbol: "PHTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16071/thumb/phtr.png?1696515680"
    },
    {
      chainId: 1,
      address: "0xc05d14442a510de4d3d71a3d316585aa0ce32b50",
      name: "LINA",
      symbol: "LINA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5412/thumb/3083.png?1696505898"
    },
    {
      chainId: 1,
      address: "0x7e77dcb127f99ece88230a64db8d595f31f1b068",
      name: "Escrowed Illuvium 2",
      symbol: "SILV2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28860/thumb/silv2.png?1696527834"
    },
    {
      chainId: 1,
      address: "0x32c4adb9cf57f972bc375129de91c897b4f364f1",
      name: "Flowchain",
      symbol: "FLC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7446/thumb/logo_%2889%29.png?1597459811"
    },
    {
      chainId: 1,
      address: "0x7199b5a15c7fb79aa861780230adc65fff99ec73",
      name: "0xAnon",
      symbol: "0XANON",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32836/thumb/IMG_20231108_161217_519.jpg?1699587007"
    },
    {
      chainId: 1,
      address: "0x6f80310ca7f2c654691d1383149fa1a57d8ab1f8",
      name: "Silo Finance",
      symbol: "SILO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21454/thumb/y0iYKZOv_400x400.png?1696520816"
    },
    {
      chainId: 1,
      address: "0xe6fd75ff38adca4b97fbcd938c86b98772431867",
      name: "Elastos",
      symbol: "ELA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2780/thumb/Elastos.png?1696503549"
    },
    {
      chainId: 1,
      address: "0x722f97a435278b7383a1e3c47f41773bebf3232c",
      name: "UCROWDME",
      symbol: "UCM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12079/thumb/UKm2qXh.png?1696511926"
    },
    {
      chainId: 1,
      address: "0x990f341946a3fdb507ae7e52d17851b87168017c",
      name: "Strong",
      symbol: "STRONG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12092/thumb/STRONG-Token-256x256.png?1696511938"
    },
    {
      chainId: 1,
      address: "0xe63684bcf2987892cefb4caa79bd21b34e98a291",
      name: "Chicken",
      symbol: "KFC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12569/thumb/download.png?1696512378"
    },
    {
      chainId: 1,
      address: "0x70d2b7c19352bb76e4409858ff5746e500f2b67c",
      name: "Pawtocol",
      symbol: "UPI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12186/thumb/pawtocol.jpg?1696512023"
    },
    {
      chainId: 1,
      address: "0x5d65d971895edc438f465c17db6992698a52318d",
      name: "Nebulas",
      symbol: "NAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2431/thumb/193394331.png?1696503264"
    },
    {
      chainId: 1,
      address: "0xc813ea5e3b48bebeedb796ab42a30c5599b01740",
      name: "Autonio",
      symbol: "NIOX",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/1122/thumb/NewLogo.png?1696502216"
    },
    {
      chainId: 1,
      address: "0x9f7fc686cfd64aa5ae15b351d03071e91533094b",
      name: "Trace Network Labs",
      symbol: "TRACE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23266/thumb/Token_Icon_02.png?1696522486"
    },
    {
      chainId: 1,
      address: "0xd8912c10681d8b21fd3742244f44658dba12264e",
      name: "Pluton",
      symbol: "PLU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1241/thumb/pluton.png?1696502316"
    },
    {
      chainId: 1,
      address: "0xcb8d1260f9c92a3a545d409466280ffdd7af7042",
      name: "NFT Protocol",
      symbol: "NFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12174/thumb/nftprotocol_32.png?1696512011"
    },
    {
      chainId: 1,
      address: "0x56015bbe3c01fe05bc30a8a9a9fd9a88917e7db3",
      name: "Mooncat CAT",
      symbol: "CAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12177/thumb/happy2-2.jpg?1696512014"
    },
    {
      chainId: 1,
      address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
      name: "Enigma",
      symbol: "ENG",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/1007/thumb/enigma-logo.png?1696502119"
    },
    {
      chainId: 1,
      address: "0xc975342a95ccb75378ddc646b8620fa3cd5bc051",
      name: "MetaStreet V2 mwstETH WPUNKS 20",
      symbol: "PUNKETH-20",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xecc0f1f860a82ab3b442382d93853c02d6384389",
      name: "Axis DeFi",
      symbol: "AXIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12199/thumb/YeLWZ3V.jpg?1696512035"
    },
    {
      chainId: 1,
      address: "0x8a6aca71a218301c7081d4e96d64292d3b275ce0",
      name: "S Finance",
      symbol: "SFG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12605/thumb/Z7D8B4b.png?1696512414"
    },
    {
      chainId: 1,
      address: "0x2a79324c19ef2b89ea98b23bc669b7e7c9f8a517",
      name: "WAX",
      symbol: "WAXP",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/1372/thumb/WAX_Coin_Tickers_P_512px.png?1696502430"
    },
    {
      chainId: 1,
      address: "0x04e0af0af1b7f0023c6b12af5a94df59b0e8cf59",
      name: "Sensitrust",
      symbol: "SETS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15035/thumb/SETS-token-logo-200.png?1696514695"
    },
    {
      chainId: 1,
      address: "0x2be5e8c109e2197d077d13a82daead6a9b3433c5",
      name: "Tokamak Network",
      symbol: "TON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12260/thumb/D919x5-s_400x400.png?1696512091"
    },
    {
      chainId: 1,
      address: "0x6a6c2ada3ce053561c2fbc3ee211f23d9b8c520a",
      name: "TON Community",
      symbol: "TON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12334/thumb/ton.jpg?1696512162"
    },
    {
      chainId: 1,
      address: "0xcbd55d4ffc43467142761a764763652b48b969ff",
      name: "AstroTools",
      symbol: "ASTRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12345/thumb/AT-flat-purple_logo.png?1696512172"
    },
    {
      chainId: 1,
      address: "0x3a8cccb969a61532d1e6005e2ce12c200caece87",
      name: "TitanSwap",
      symbol: "TITAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12606/thumb/nqGlQzdz_400x400.png?1696512414"
    },
    {
      chainId: 1,
      address: "0x464ebe77c293e473b48cfe96ddcf88fcf7bfdac0",
      name: "KRYLL",
      symbol: "KRL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2807/thumb/krl.png?1696503571"
    },
    {
      chainId: 1,
      address: "0xc28e27870558cf22add83540d2126da2e4b464c2",
      name: "Sashimi",
      symbol: "SASHIMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12427/thumb/SashimiSwap-200x200.png?1696512248"
    },
    {
      chainId: 1,
      address: "0x1f19d846d99a0e75581913b64510fe0e18bbc31f",
      name: "Feels Good Man",
      symbol: "FGM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37143/thumb/fgm200px.jpg?1713437673"
    },
    {
      chainId: 1,
      address: "0xe91598331a36a78f7fefe277ce7c1915da0afb93",
      name: "RunesBridge",
      symbol: "RB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36974/thumb/rsz_logo11.png?1714674275"
    },
    {
      chainId: 1,
      address: "0x035bfe6057e15ea692c0dfdcab3bb41a64dd2ad4",
      name: "Universal Liquidity Union",
      symbol: "ULU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12376/thumb/ulu_finance_logo.ico?1696512200"
    },
    {
      chainId: 1,
      address: "0xa1afffe3f4d611d252010e3eaf6f4d77088b0cd7",
      name: "reflect finance",
      symbol: "RFI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/13189/thumb/reflect_finance_logo.png?1696512971"
    },
    {
      chainId: 1,
      address: "0x488e0369f9bc5c40c002ea7c1fe4fd01a198801c",
      name: "Golff",
      symbol: "GOF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12445/thumb/_x-AmLBv_400x400.jpg?1696512264"
    },
    {
      chainId: 1,
      address: "0x5befbb272290dd5b8521d4a938f6c4757742c430",
      name: "Xfinance",
      symbol: "XFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12449/thumb/go.png?1696512268"
    },
    {
      chainId: 1,
      address: "0xf89674f18309a2e97843c6e9b19c07c22caef6d5",
      name: "cyb3rgam3r420",
      symbol: "GAMER",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32071/thumb/GamerLogo.jpg?1696586649"
    },
    {
      chainId: 1,
      address: "0x31429d1856ad1377a8a0079410b297e1a9e214c2",
      name: "ANGLE",
      symbol: "ANGLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19060/thumb/ANGLE_Token-light.png?1696518509"
    },
    {
      chainId: 1,
      address: "0xeb986da994e4a118d5956b02d8b7c3c7ce373674",
      name: "Gather",
      symbol: "GTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12458/thumb/Gather-Logo-Working-File.png?1696512278"
    },
    {
      chainId: 1,
      address: "0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6",
      name: "Abyss",
      symbol: "ABYSS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2105/thumb/NrFmpxs.png?1696503072"
    },
    {
      chainId: 1,
      address: "0xc3071803b9d23460820b516673fd3cec0415d0ed",
      name: "KuKu",
      symbol: "KUKU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31235/thumb/dssad_%281%29.png?1696530061"
    },
    {
      chainId: 1,
      address: "0x0e5f00da8aaef196a719d045db89b5da8f371b32",
      name: "Connectome",
      symbol: "CNTM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8528/thumb/200_200_CNTM-LOGO-07.png?1696508705"
    },
    {
      chainId: 1,
      address: "0xedeec5691f23e4914cf0183a4196bbeb30d027a0",
      name: "Wrapped Statera",
      symbol: "WSTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13599/thumb/wsta_logo.png?1696513350"
    },
    {
      chainId: 1,
      address: "0xc71d8baaa436aa7e42da1f40bec48f11ab3c9e4a",
      name: "iEthereum",
      symbol: "IETH",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/1065/thumb/ieth.png?1696502169"
    },
    {
      chainId: 1,
      address: "0x5d942f9872863645bcb181aba66c7d9646a91378",
      name: "AltSignals",
      symbol: "ASI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35709/thumb/ASIlogo.png?1709625768"
    },
    {
      chainId: 1,
      address: "0xd13c7342e1ef687c5ad21b27c2b65d772cab5c8c",
      name: "Ultra",
      symbol: "UOS",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/4480/thumb/Ultra.png?1696505069"
    },
    {
      chainId: 1,
      address: "0x9e78b8274e1d6a76a0dbbf90418894df27cbceb5",
      name: "Covenants",
      symbol: "UNIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12258/thumb/Unifi.png?1696512090"
    },
    {
      chainId: 1,
      address: "0x0c37bcf456bc661c14d596683325623076d7e283",
      name: "Aeron",
      symbol: "ARNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1124/thumb/ARNX-token-logo-256x256.png?1696502218"
    },
    {
      chainId: 1,
      address: "0x329c6e459ffa7475718838145e5e85802db2a303",
      name: "MaidSafeCoin",
      symbol: "EMAID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/80/thumb/maidsafecoin.png?1696501470"
    },
    {
      chainId: 1,
      address: "0x9be89d2a4cd102d8fecc6bf9da793be995c22541",
      name: "Binance Wrapped BTC",
      symbol: "BBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/14867/thumb/binance-btc_32.png?1696514532"
    },
    {
      chainId: 1,
      address: "0xa4ef4b0b23c1fc81d3f9ecf93510e64f58a4a016",
      name: "1MillionNFTs",
      symbol: "1MIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14990/thumb/4kQ8hRnU_400x400.jpg?1696514654"
    },
    {
      chainId: 1,
      address: "0xcc7ab8d78dba187dc95bf3bb86e65e0c26d0041f",
      name: "Spacelens",
      symbol: "SPACE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16979/thumb/SPACE___Spacelens.png?1696516545"
    },
    {
      chainId: 1,
      address: "0x8e57c27761ebbd381b0f9d09bb92ceb51a358abb",
      name: "extraDNA",
      symbol: "XDNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12667/thumb/Logo_coin_black.png?1696512473"
    },
    {
      chainId: 1,
      address: "0x6369c3dadfc00054a42ba8b2c09c48131dd4aa38",
      name: "Morpher",
      symbol: "MPH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12619/thumb/morpher_200_200.png?1696512426"
    },
    {
      chainId: 1,
      address: "0x998ffe1e43facffb941dc337dd0468d52ba5b48a",
      name: "Rupiah Token",
      symbol: "IDRT",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/9441/thumb/57421944_1371636006308255_3647136573922738176_n.jpg?1696509533"
    },
    {
      chainId: 1,
      address: "0x7122985656e38bdc0302db86685bb972b145bd3c",
      name: "StakeStone ETH",
      symbol: "STONE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33103/thumb/200_200.png?1702602672"
    },
    {
      chainId: 1,
      address: "0x80fb784b7ed66730e8b1dbd9820afd29931aab03",
      name: "Aave  OLD ",
      symbol: "LEND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1365/thumb/ethlend.png?1696502424"
    },
    {
      chainId: 1,
      address: "0xaac41ec512808d64625576eddd580e7ea40ef8b2",
      name: "Gameswap",
      symbol: "GSWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13026/thumb/gameswap.jpg?1696512814"
    },
    {
      chainId: 1,
      address: "0x0391d2021f89dc339f60fff84546ea23e337750f",
      name: "BarnBridge",
      symbol: "BOND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12811/thumb/barnbridge.jpg?1696512604"
    },
    {
      chainId: 1,
      address: "0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af",
      name: "Blox",
      symbol: "CDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1231/thumb/Blox_Staking_Logo_2.png?1696502308"
    },
    {
      chainId: 1,
      address: "0x418d75f65a02b3d53b2418fb8e1fe493759c7605",
      name: "Binance Coin  Wormhole ",
      symbol: "BNB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22884/thumb/BNB_wh_small.png?1696522182"
    },
    {
      chainId: 1,
      address: "0x16587cf43f044aba0165ffa00acf412631194e4b",
      name: "Simracer Coin",
      symbol: "SRC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13027/thumb/SimRacer-500px.png?1696512815"
    },
    {
      chainId: 1,
      address: "0x25c7b64a93eb1261e130ec21a3e9918caa38b611",
      name: "Wrapped Virgin Gen 0 CryptoKittties",
      symbol: "WVG0",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12875/thumb/wvg0.png?1696512663"
    },
    {
      chainId: 1,
      address: "0x0202be363b8a4820f3f4de7faf5224ff05943ab1",
      name: "UniLend Finance",
      symbol: "UFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12819/thumb/UniLend_Finance_logo_PNG.png?1696512611"
    },
    {
      chainId: 1,
      address: "0xe0b9a2c3e9f40cf74b2c7f591b2b0cca055c3112",
      name: "Genesis Shards",
      symbol: "GS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14784/thumb/gs.png?1696514453"
    },
    {
      chainId: 1,
      address: "0xe75f2acafba1ad56c5ed712ffbc1d31910e74396",
      name: "Komputai",
      symbol: "KAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37145/thumb/W0WXzwID_400x400.png?1713444313"
    },
    {
      chainId: 1,
      address: "0xbbff34e47e559ef680067a6b1c980639eeb64d24",
      name: "Leverj Gluon",
      symbol: "L2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12950/thumb/Gluon256x256.png?1696512739"
    },
    {
      chainId: 1,
      address: "0xdc580d4dc6b702b72a3511ac1802fa700ad182bb",
      name: "Pumpkin",
      symbol: "PUMPKIN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32842/thumb/IMG_20231108_220727_983.jpg?1699589128"
    },
    {
      chainId: 1,
      address: "0xc5bddf9843308380375a611c18b50fb9341f502a",
      name: "veCRV DAO yVault",
      symbol: "YVE-CRVDAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13065/thumb/yearn_veCRV.png?1696512854"
    },
    {
      chainId: 1,
      address: "0xc3c221fe28c33814c28c822b631fd76047ef1a63",
      name: "Millimeter",
      symbol: "MM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12941/thumb/mm%EB%A1%9C%EA%B3%A0-2.png?1696512730"
    },
    {
      chainId: 1,
      address: "0x74e5e53056526b2609d82e85486005ef2a2db001",
      name: "TruMATIC MATIC Stable Pool",
      symbol: "TRUMATIC-MATIC",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xdacd69347de42babfaecd09dc88958378780fb62",
      name: "Atari",
      symbol: "ATRI",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/12992/thumb/AtariLogoPS_200x200_%281%29.png?1696512782"
    },
    {
      chainId: 1,
      address: "0xd849882983f1ba8a3c23b16b65bb0173a7f63b63",
      name: "De Layer",
      symbol: "DEAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35879/thumb/Frame_1_%2816%29.png?1709983222"
    },
    {
      chainId: 1,
      address: "0x725c263e32c72ddc3a19bea12c5a0479a81ee688",
      name: "Bridge Mutual",
      symbol: "BMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13808/thumb/bmi_logo.png?1696513554"
    },
    {
      chainId: 1,
      address: "0x11613b1f840bb5a40f8866d857e24da126b79d73",
      name: "Cappasity",
      symbol: "CAPP",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/1302/thumb/cappasity.png?1696502371"
    },
    {
      chainId: 1,
      address: "0x10633216e7e8281e33c86f02bf8e565a635d9770",
      name: "Dvision Network",
      symbol: "DVI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13020/thumb/WGAhHOLv_400x400.png?1696512809"
    },
    {
      chainId: 1,
      address: "0x84c722e6f1363e8d5c6db3ea600bef9a006da824",
      name: "Misbloc",
      symbol: "MSB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13021/thumb/xREV4lXV.png?1696512810"
    },
    {
      chainId: 1,
      address: "0x50b0696468f42cab1ddc76413a1312aff3cabdf6",
      name: "ClosedAI",
      symbol: "CLOSEDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36143/thumb/CLOSEDAI.jpg?1710689243"
    },
    {
      chainId: 1,
      address: "0xfe9a29ab92522d14fc65880d817214261d8479ae",
      name: "Snowswap",
      symbol: "SNOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12751/thumb/uQBJL3A.png?1696512549"
    },
    {
      chainId: 1,
      address: "0x1fc5ef0337aea85c5f9198853a6e3a579a7a6987",
      name: "ReapChain",
      symbol: "REAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13109/thumb/REAP.jpg?1696512894"
    },
    {
      chainId: 1,
      address: "0x63b4f3e3fa4e438698ce330e365e831f7ccd1ef4",
      name: "CyberFi",
      symbol: "CFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13112/thumb/cyberfi_logo.jpeg?1696512897"
    },
    {
      chainId: 1,
      address: "0x26a604dffe3ddab3bee816097f81d3c4a2a4cf97",
      name: "CorionX",
      symbol: "CORX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13129/thumb/x_log.png?1696512916"
    },
    {
      chainId: 1,
      address: "0x67b66c99d3eb37fa76aa3ed1ff33e8e39f0b9c7a",
      name: "Interest Bearing ETH",
      symbol: "IBETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13131/thumb/7675.png?1696512918"
    },
    {
      chainId: 1,
      address: "0x2c2f7e7c5604d162d75641256b80f1bf6f4dc796",
      name: "Polkarare",
      symbol: "PRARE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15388/thumb/Image_from_iOS.png?1696515035"
    },
    {
      chainId: 1,
      address: "0x4946fcea7c692606e8908002e55a582af44ac121",
      name: "FOAM",
      symbol: "FOAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3345/thumb/K51lJQc.png?1696504049"
    },
    {
      chainId: 1,
      address: "0x910524678c0b1b23ffb9285a81f99c29c11cbaed",
      name: "Azuki",
      symbol: "AZUKI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13091/thumb/bdUBSCo.png?1696512878"
    },
    {
      chainId: 1,
      address: "0x191557728e4d8caa4ac94f86af842148c0fa8f7e",
      name: "Ormeus Ecosystem",
      symbol: "ECO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/8923/thumb/logo_eco_low.png?1696509072"
    },
    {
      chainId: 1,
      address: "0x581911b360b6eb3a14ef295a83a91dc2bce2d6f7",
      name: "MileVerse",
      symbol: "MVC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13146/thumb/kXSdwuxD_400x400.jpg?1696512931"
    },
    {
      chainId: 1,
      address: "0x3175df0976dfa876431c2e9ee6bc45b65d3473cc",
      name: "Curve fi FRAX USDC",
      symbol: "CRVFRAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26829/thumb/W1sQNVWo_400x400.jpeg?1696525888"
    },
    {
      chainId: 1,
      address: "0xb7cb1c96db6b22b0d3d9536e0108d062bd488f74",
      name: "Waltonchain",
      symbol: "WTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1093/thumb/ggx6nnW.png?1696502192"
    },
    {
      chainId: 1,
      address: "0x2ab6bb8408ca3199b8fa6c92d5b455f820af03c4",
      name: "TE FOOD",
      symbol: "TONE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2325/thumb/tec.png?1696503214"
    },
    {
      chainId: 1,
      address: "0xcbe7142f5c16755d8683ba329efa1abf7b54482d",
      name: "MedicalVeda",
      symbol: "MVEDA",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13069/thumb/medicalveda_new_logo_final_%281%29.png?1696512858"
    },
    {
      chainId: 1,
      address: "0xd794dd1cada4cf79c9eebaab8327a1b0507ef7d4",
      name: "Hyve",
      symbol: "HYVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13072/thumb/bAe1G-lD_400x400.png?1696512861"
    },
    {
      chainId: 1,
      address: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
      name: "ClinTex CTi",
      symbol: "CTI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13266/thumb/CTI.png?1696513039"
    },
    {
      chainId: 1,
      address: "0x485d17a6f1b8780392d53d64751824253011a260",
      name: "chrono tech",
      symbol: "TIME",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/604/thumb/time-32x32.png?1696501802"
    },
    {
      chainId: 1,
      address: "0xf0655dcee37e5c0b70fffd70d85f88f8edf0aff6",
      name: "UniDex",
      symbol: "UNIDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13178/thumb/unidx.png?1696512961"
    },
    {
      chainId: 1,
      address: "0xb04dfdb8271ed2d5e13858562c44a77d3ceb9e57",
      name: "BuildUp",
      symbol: "BUP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13206/thumb/BUP_-_LOGO.png?1696512987"
    },
    {
      chainId: 1,
      address: "0x86ed939b500e121c0c5f493f399084db596dad20",
      name: "SpaceChain  ERC 20 ",
      symbol: "SPC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6659/thumb/Spacechain.jpg?1696507004"
    },
    {
      chainId: 1,
      address: "0x3a810ff7211b40c4fa76205a14efe161615d0385",
      name: "AI Network",
      symbol: "AIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13211/thumb/AI_Network_Logo_200x200.png?1696512991"
    },
    {
      chainId: 1,
      address: "0xce593a29905951e8fc579bc092eca72577da575c",
      name: "GROM",
      symbol: "GR",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/13216/thumb/gr.png?1696512995"
    },
    {
      chainId: 1,
      address: "0xa1d65e8fb6e87b60feccbc582f7f97804b725521",
      name: "DXdao",
      symbol: "DXD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11148/thumb/dxdao.png?1696511083"
    },
    {
      chainId: 1,
      address: "0x69bbc3f8787d573f1bbdd0a5f40c7ba0aee9bcc9",
      name: "Yup",
      symbol: "YUP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12322/thumb/photo_2021-10-26_00-47-35.jpg?1696512151"
    },
    {
      chainId: 1,
      address: "0xcaeaf8381d4b20b43afa42061d6f80319a8881f6",
      name: "R34P",
      symbol: "R34P",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13393/thumb/r34p_logo.png?1696513155"
    },
    {
      chainId: 1,
      address: "0x6876eba317272fe221c67405c5e8eb3b24535547",
      name: "MicroTuber",
      symbol: "MCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15489/thumb/mct.PNG?1696515134"
    },
    {
      chainId: 1,
      address: "0x1de852cd18323bc5ebda842b8eef46c6e551aa47",
      name: "hiRENGA",
      symbol: "HIRENGA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28999/thumb/hirenga.png?1696527971"
    },
    {
      chainId: 1,
      address: "0x0789dbae94fb18e5789b8e4489bcb7a1adb58622",
      name: "FISCO Coin",
      symbol: "FSCC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/6507/thumb/AnyConv.com__fscc_icon_fin.png?1696506865"
    },
    {
      chainId: 1,
      address: "0x07ac55797d4f43f57ca92a49e65ca582cc287c27",
      name: "Rebasing TBT",
      symbol: "TBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29792/thumb/TBT.png?1696528722"
    },
    {
      chainId: 1,
      address: "0x6628606c321faf52b7230a57b26c01b19aa68e82",
      name: "BitHash",
      symbol: "BT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13224/thumb/bt.png?1696513003"
    },
    {
      chainId: 1,
      address: "0xb6ff96b8a8d214544ca0dbc9b33f7ad6503efd32",
      name: "Sync Network",
      symbol: "SYNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13231/thumb/sync_network.png?1696513009"
    },
    {
      chainId: 1,
      address: "0x44f5909e97e1cbf5fbbdf0fc92fd83cde5d5c58a",
      name: "Acria AI",
      symbol: "ACRIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28598/thumb/image002.png?1696527585"
    },
    {
      chainId: 1,
      address: "0x34950ff2b487d9e5282c5ab342d08a2f712eb79f",
      name: "Efforce",
      symbol: "WOZX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13310/thumb/rZ6Oe3dm_400x400.jpg?1696513080"
    },
    {
      chainId: 1,
      address: "0xc12d099be31567add4e4e4d0d45691c3f58f5663",
      name: "Auctus",
      symbol: "AUC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2165/thumb/Auc_Discord_Avatar1.png?1696503126"
    },
    {
      chainId: 1,
      address: "0xbcd4b7de6fde81025f74426d43165a5b0d790fdd",
      name: "SpiderDAO",
      symbol: "SPDR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13378/thumb/spiderdao_logo.png?1696513142"
    },
    {
      chainId: 1,
      address: "0xdf49c9f599a0a9049d97cff34d0c30e468987389",
      name: "SaTT",
      symbol: "SATT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4070/thumb/r3s9XKk.png?1696504702"
    },
    {
      chainId: 1,
      address: "0xedf6568618a00c6f0908bf7758a16f76b6e04af9",
      name: "Arianee",
      symbol: "ARIA20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5054/thumb/Aria_Logo_256.png?1696505581"
    },
    {
      chainId: 1,
      address: "0x374cb8c27130e2c9e04f44303f3c8351b9de61c1",
      name: "Bao Finance",
      symbol: "BAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13547/thumb/BaoLogo.png?1696513307"
    },
    {
      chainId: 1,
      address: "0xc014186cf1ba36032aaec7f96088f09eb3934347",
      name: "WeCoOwn",
      symbol: "WCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14497/thumb/WCX-Token-Logo.png?1696514184"
    },
    {
      chainId: 1,
      address: "0xbd434a09191d401da3283a5545bb3515d033b8c4",
      name: "GoldFinX",
      symbol: "GIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13292/thumb/KAB_611E_400x400.jpg?1696513064"
    },
    {
      chainId: 1,
      address: "0x27c70cd1946795b66be9d954418546998b546634",
      name: "Doge Killer",
      symbol: "LEASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15802/thumb/Leash.png?1696515425"
    },
    {
      chainId: 1,
      address: "0x0488401c3f535193fa8df029d9ffe615a06e74e6",
      name: "SparkPoint",
      symbol: "SRK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8371/thumb/SRK.png?1696508564"
    },
    {
      chainId: 1,
      address: "0xff44b937788215eca197baaf9af69dbdc214aa04",
      name: "Rocki",
      symbol: "ROCKI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13465/thumb/rocki_logo.png?1696513227"
    },
    {
      chainId: 1,
      address: "0xe65cdb6479bac1e22340e4e755fae7e509ecd06c",
      name: "cAAVE",
      symbol: "CAAVE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17527/thumb/caave.PNG?1696517065"
    },
    {
      chainId: 1,
      address: "0x185ece9bc75164f9fc0fbe44738e8dd1863f8464",
      name: "UNODEX",
      symbol: "UNDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34115/thumb/UNODEX_LOGO_PNG_200X200.png?1704020683"
    },
    {
      chainId: 1,
      address: "0xf16e81dce15b08f326220742020379b855b87df9",
      name: "Popsicle Finance",
      symbol: "ICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14586/thumb/ice.png?1696514266"
    },
    {
      chainId: 1,
      address: "0xf0acf8949e705e0ebb6cb42c2164b0b986454223",
      name: "Barter",
      symbol: "BRTR",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13401/thumb/BRTR.png?1696513163"
    },
    {
      chainId: 1,
      address: "0x96c645d3d3706f793ef52c19bbace441900ed47d",
      name: "Mt Pelerin Shares",
      symbol: "MPS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/11471/thumb/MPS.png?1696511378"
    },
    {
      chainId: 1,
      address: "0x7a2bc711e19ba6aff6ce8246c546e8c4b4944dfd",
      name: "WAXE",
      symbol: "WAXE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13508/thumb/waxe_logo.png?1696513270"
    },
    {
      chainId: 1,
      address: "0x8162b5bc8f651007cc38a09f557bab2bf4cefb5b",
      name: "Streamer Inu",
      symbol: "STRM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27994/thumb/logo.png?1696527011"
    },
    {
      chainId: 1,
      address: "0x853d955acef822db058eb8505911ed77f175b99e",
      name: "Frax",
      symbol: "FRAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/FRAX_icon.png?1696513182"
    },
    {
      chainId: 1,
      address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
      name: "Frax Share",
      symbol: "FXS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13423/thumb/Frax_Shares_icon.png?1696513183"
    },
    {
      chainId: 1,
      address: "0x6522f491df42651cf5e6636b7261adaa096d095f",
      name: "Asap Sniper Bot",
      symbol: "ASAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30707/thumb/LOGO_%281%29.jpeg?1696529578"
    },
    {
      chainId: 1,
      address: "0x5ea82c27efc7634f1c5ad20a3561c453433a2f3a",
      name: "BTRIPS",
      symbol: "BTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19273/thumb/btr.png?1696518716"
    },
    {
      chainId: 1,
      address: "0x0c7d5ae016f806603cb1782bea29ac69471cab9c",
      name: "Bifrost",
      symbol: "BFC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4639/thumb/BFC_Symbol.png?1696505208"
    },
    {
      chainId: 1,
      address: "0x7f0c8b125040f707441cad9e5ed8a8408673b455",
      name: "CSP DAO Network",
      symbol: "NEBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13436/thumb/csp_dao.png?1696513200"
    },
    {
      chainId: 1,
      address: "0xcbfef8fdd706cde6f208460f2bf39aa9c785f05d",
      name: "Kine Protocol",
      symbol: "KINE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14339/thumb/kine.jpg?1696514026"
    },
    {
      chainId: 1,
      address: "0x73968b9a57c6e53d41345fd57a6e6ae27d6cdb2f",
      name: "Stake DAO",
      symbol: "SDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13724/thumb/stakedao_logo.jpg?1696513468"
    },
    {
      chainId: 1,
      address: "0x28cb7e841ee97947a86b06fa4090c8451f64c0be",
      name: "YF Link",
      symbol: "YFL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12081/thumb/YFLink.png?1696511928"
    },
    {
      chainId: 1,
      address: "0x65f9a292f1aeed5d755aa2fd2fb17ab2e9431447",
      name: "SoMee Social",
      symbol: "SOMEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16406/thumb/SoMeeBallLogo200x200.png?1696516003"
    },
    {
      chainId: 1,
      address: "0x94d863173ee77439e4292284ff13fad54b3ba182",
      name: "Delphi",
      symbol: "ADEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12300/thumb/adel_on_white_10x.png?1696512130"
    },
    {
      chainId: 1,
      address: "0x8798249c2e607446efb7ad49ec89dd1865ff4272",
      name: "xSUSHI",
      symbol: "XSUSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13725/thumb/xsushi.png?1696513469"
    },
    {
      chainId: 1,
      address: "0x4b0181102a0112a2ef11abee5563bb4a3176c9d7",
      name: "cSUSHI",
      symbol: "CSUSHI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17529/thumb/csushi.PNG?1696517067"
    },
    {
      chainId: 1,
      address: "0x6d0f5149c502faf215c89ab306ec3e50b15e2892",
      name: "Portion",
      symbol: "PRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13617/thumb/OKeO2FI.png?1696513366"
    },
    {
      chainId: 1,
      address: "0xd1ba9bac957322d6e8c07a160a3a8da11a0d2867",
      name: "HUMAN Protocol",
      symbol: "HMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16412/thumb/human_protocol.PNG?1696516009"
    },
    {
      chainId: 1,
      address: "0x80a2ae356fc9ef4305676f7a3e2ed04e12c33946",
      name: "cYFI",
      symbol: "CYFI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17530/thumb/cyfi.PNG?1696517068"
    },
    {
      chainId: 1,
      address: "0x7690202e2c2297bcd03664e31116d1dffe7e3b73",
      name: "Cat in a Box Ether",
      symbol: "BOXETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29927/thumb/boxETH.png?1696528855"
    },
    {
      chainId: 1,
      address: "0x0590cc9232ebf68d81f6707a119898219342ecb9",
      name: "BananaCat",
      symbol: "BCAT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32557/thumb/imresizer-1698351889115.jpg?1698503559"
    },
    {
      chainId: 1,
      address: "0xeabb8996ea1662cad2f7fb715127852cd3262ae9",
      name: "Connect Financial",
      symbol: "CNFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13592/thumb/cf-logo-iconic-black.png?1696513344"
    },
    {
      chainId: 1,
      address: "0xc0f9bd5fa5698b6505f643900ffa515ea5df54a9",
      name: "Donut",
      symbol: "DONUT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7538/thumb/Donut.png?1696507804"
    },
    {
      chainId: 1,
      address: "0x5c2975269e74cb3a8514e5b800a1e66c694d4df8",
      name: "Caroline",
      symbol: "HER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30146/thumb/caroline.jpeg?1696529067"
    },
    {
      chainId: 1,
      address: "0x8642a849d0dcb7a15a974794668adcfbe4794b56",
      name: "Prosper",
      symbol: "PROS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13668/thumb/heD6cg22l3sF5VgPh4G1xC6lnKEWXJif-jbaqUpv8CDP6jbWaqn9UjBdkXWNrw1CewaQOxb8zXRdNeNJWWiUDjfsEl_d7E3bPLg4cFoilQF5TGKHfWyJlnpm3UYc9ytvRvOjxOevMuiu8-lusnNoOcwgsJpMkYWHqe322GAxLt0_30kFMVAcjEDUrOlkK6hUYi0m9P433mvNlOm.jpg?1696513418"
    },
    {
      chainId: 1,
      address: "0x87de305311d5788e8da38d19bb427645b09cb4e5",
      name: "Verox",
      symbol: "VRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13669/thumb/IMG-20210115-000024.png?1696513419"
    },
    {
      chainId: 1,
      address: "0x49e833337ece7afe375e44f4e3e8481029218e5c",
      name: "Value DeFi",
      symbol: "VALUE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12525/thumb/value_logo_-_500x500.png?1696512338"
    },
    {
      chainId: 1,
      address: "0x2791bfd60d232150bff86b39b7146c0eaaa2ba81",
      name: "BiFi",
      symbol: "BIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13671/thumb/ysYIu7Q.png?1696513420"
    },
    {
      chainId: 1,
      address: "0xaa19961b6b858d9f18a115f25aa1d98abc1fdba8",
      name: "LocalCoinSwap",
      symbol: "LCS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3998/thumb/LocalCoinSwap.png?1696504639"
    },
    {
      chainId: 1,
      address: "0x7d4b8cce0591c9044a22ee543533b72e976e36c3",
      name: "Change",
      symbol: "CAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1021/thumb/200x200.png?1696502132"
    },
    {
      chainId: 1,
      address: "0x5caf454ba92e6f2c929df14667ee360ed9fd5b26",
      name: "Dev Protocol",
      symbol: "DEV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11560/thumb/Dev_Protocol__CoinGecko_Logo___Jan.18.2021_.png?1696511459"
    },
    {
      chainId: 1,
      address: "0x6e5970dbd6fc7eb1f29c6d2edf2bc4c36124c0c1",
      name: "Polytrade",
      symbol: "TRADE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16416/thumb/Logo_colored_200.png?1696516012"
    },
    {
      chainId: 1,
      address: "0x26c8afbbfe1ebaca03c2bb082e69d0476bffe099",
      name: "Cellframe",
      symbol: "CELL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14465/thumb/cellframe-coingecko.png?1696514152"
    },
    {
      chainId: 1,
      address: "0x8666cb197af5103f7a3a0295b50efea47f3df78b",
      name: "Ducks",
      symbol: "DUCKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30147/thumb/ducks.png?1696529068"
    },
    {
      chainId: 1,
      address: "0xca1207647ff814039530d7d35df0e1dd2e91fa84",
      name: "dHEDGE DAO",
      symbol: "DHT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12508/thumb/dht.png?1696512323"
    },
    {
      chainId: 1,
      address: "0x12e2b8033420270db2f3b328e32370cb5b2ca134",
      name: "SafePal",
      symbol: "SFP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13905/thumb/sfp.png?1696513647"
    },
    {
      chainId: 1,
      address: "0x178bf8fd04b47d2de3ef3f6b3d112106375ad584",
      name: "Unagii Tether USD",
      symbol: "UUSDT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/13778/thumb/uUSDT.png?1696513519"
    },
    {
      chainId: 1,
      address: "0x0d02755a5700414b26ff040e1de35d337df56218",
      name: "BendDAO",
      symbol: "BEND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22829/thumb/benddao.PNG?1696522130"
    },
    {
      chainId: 1,
      address: "0xe9b076b476d8865cdf79d1cf7df420ee397a7f75",
      name: "Unification",
      symbol: "FUND",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/7845/thumb/DV80FOp.png?1696508079"
    },
    {
      chainId: 1,
      address: "0x41aa9df60c41b07bf4f4cc1b8b3e6c9e25669a9e",
      name: "Digipolis",
      symbol: "DIGI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37029/thumb/IMG_1010.jpeg?1713158393"
    },
    {
      chainId: 1,
      address: "0xdb05ea0877a2622883941b939f0bb11d1ac7c400",
      name: "Opacity",
      symbol: "OPCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7237/thumb/Opacity.jpg?1696507532"
    },
    {
      chainId: 1,
      address: "0xbc5991ccd8caceba01edc44c2bb9832712c29cab",
      name: "Unagii USD Coin",
      symbol: "UUSDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/13781/thumb/uUSDC.png?1696513522"
    },
    {
      chainId: 1,
      address: "0x4ad0b81f92b16624bbcf46fc0030cfbbf8d02376",
      name: "Unagii Dai",
      symbol: "UDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13782/thumb/uDAI.png?1696513523"
    },
    {
      chainId: 1,
      address: "0xf4172630a656a47ece8616e75791290446fa41a0",
      name: "PEPPA",
      symbol: "PEPPA",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/30492/thumb/200_x_200_JPG.jpg?1696529379"
    },
    {
      chainId: 1,
      address: "0xc691bc298a304d591ad9b352c7a8d216de9f2ced",
      name: "Polaris Share",
      symbol: "POLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13817/thumb/tHQrxdYQ_400x400.png?1696513563"
    },
    {
      chainId: 1,
      address: "0x9d7b68970d2be6dc93124477b4e2e1c9a6b180aa",
      name: "Dede",
      symbol: "DEDE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30976/thumb/dede_png_%281%29.png?1696529815"
    },
    {
      chainId: 1,
      address: "0xec5483804e637d45cde22fa0869656b64b5ab1ab",
      name: "Acent",
      symbol: "ACE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15211/thumb/acent-logo.png?1696514867"
    },
    {
      chainId: 1,
      address: "0x081f67afa0ccf8c7b17540767bbe95df2ba8d97f",
      name: "CoinEx",
      symbol: "CET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4817/thumb/coinex-token.png?1696505367"
    },
    {
      chainId: 1,
      address: "0x8f693ca8d21b157107184d29d398a8d082b38b76",
      name: "Streamr",
      symbol: "DATA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17869/thumb/DATA_new_symbol_3x.png?1696517392"
    },
    {
      chainId: 1,
      address: "0x4f5fa8f2d12e5eb780f6082dd656c565c48e0f24",
      name: "Gourmet Galaxy",
      symbol: "GUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13846/thumb/gum.png?1696513592"
    },
    {
      chainId: 1,
      address: "0x59e9261255644c411afdd00bd89162d09d862e38",
      name: "ETHA Lend",
      symbol: "ETHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14141/thumb/etha_logo200x200.png?1696513861"
    },
    {
      chainId: 1,
      address: "0x9d5963ba32e877871dff3e2e697283dc64066271",
      name: "Edcoin",
      symbol: "EDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13872/thumb/EDCOIN-1.png?1696513617"
    },
    {
      chainId: 1,
      address: "0x7420b4b9a0110cdc71fb720908340c03f9bc03ec",
      name: "JasmyCoin",
      symbol: "JASMY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13876/thumb/JASMY200x200.jpg?1696513620"
    },
    {
      chainId: 1,
      address: "0xf680429328caaacabee69b7a9fdb21a71419c063",
      name: "Butterfly Protocol",
      symbol: "BFLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13882/thumb/ButterflyProtocolNoText_sm.png?1696513626"
    },
    {
      chainId: 1,
      address: "0x6fc13eace26590b80cccab1ba5d51890577d83b2",
      name: "Umbrella Network",
      symbol: "UMB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13913/thumb/Apple_Watch_45mm_-_3.png?1705486680"
    },
    {
      chainId: 1,
      address: "0x3fe7940616e5bc47b0775a0dccf6237893353bb4",
      name: "IdleDAI  Best Yield ",
      symbol: "IDLEDAIYIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11901/thumb/idledai_32.png?1696511767"
    },
    {
      chainId: 1,
      address: "0x8c81121b15197fa0eeaee1dc75533419dcfd3151",
      name: "IdleWBTC  Best Yield ",
      symbol: "IDLEWBTCYIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11936/thumb/idlewbtcv3maxyield_32.png?1696511797"
    },
    {
      chainId: 1,
      address: "0x93b1e78a3e652cd2e71c4a767595b77282344932",
      name: "BITO Coin",
      symbol: "BITO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7796/thumb/bitopro_28.png?1696508036"
    },
    {
      chainId: 1,
      address: "0xc5fb36dd2fb59d3b98deff88425a3f425ee469ed",
      name: "Dejitaru Tsuka",
      symbol: "TSUKA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26405/thumb/Dejitaru_Tsuka_Logo.jpg?1696525481"
    },
    {
      chainId: 1,
      address: "0x196c81385bc536467433014042788eb707703934",
      name: "CryptoTask",
      symbol: "CTASK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13965/thumb/cryptotask_logo.png?1696513700"
    },
    {
      chainId: 1,
      address: "0x14c3f2ce251eb9385839d291c40bf085f3c6f266",
      name: "Runes Glyphs",
      symbol: "RG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37146/thumb/1000042638.jpg?1713454793"
    },
    {
      chainId: 1,
      address: "0xd4342a57ecf2fe7ffa37c33cb8f63b1500e575e6",
      name: "Apron",
      symbol: "APN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14916/thumb/1_GOjoDhGzzpqnMPGpHGeWhg.png?1696514578"
    },
    {
      chainId: 1,
      address: "0xe516d78d784c77d479977be58905b3f2b1111126",
      name: "Bitspawn",
      symbol: "SPWN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16513/thumb/token_logo.png?1696516077"
    },
    {
      chainId: 1,
      address: "0xb49fa25978abf9a248b8212ab4b87277682301c0",
      name: "RAI Finance",
      symbol: "SOFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14686/thumb/sofi.png?1696514359"
    },
    {
      chainId: 1,
      address: "0xe75ad3aab14e4b0df8c5da4286608dabb21bd864",
      name: "Double A Chain",
      symbol: "AAC",
      decimals: 5,
      logoURI: "https://assets.coingecko.com/coins/images/2577/thumb/acute-angle-cloud.png?1696503381"
    },
    {
      chainId: 1,
      address: "0x3d3af44cf092a49280e316f09c8f20ecf97bc933",
      name: "UCX",
      symbol: "UCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10131/thumb/UCX_200200.png?1696510155"
    },
    {
      chainId: 1,
      address: "0x5d3a4f62124498092ce665f865e0b38ff6f5fbea",
      name: "Ideaology",
      symbol: "IDEA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13938/thumb/idea_logo.png?1696513676"
    },
    {
      chainId: 1,
      address: "0x14cc8dfaf2258e1b8b2869300dba1b734dc0fe43",
      name: "K Tune",
      symbol: "KTT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13939/thumb/KakaoTalk_20220928_162525453.png?1696513677"
    },
    {
      chainId: 1,
      address: "0xfdb15e5e6799be72798b1ccfaecbf186bf73a0c4",
      name: "NitroEX",
      symbol: "NTX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13976/thumb/ntx-icon.png?1696513709"
    },
    {
      chainId: 1,
      address: "0xea1ea0972fa092dd463f2968f9bb51cc4c981d71",
      name: "Modefi",
      symbol: "MOD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13980/thumb/modefi_logo.png?1696513713"
    },
    {
      chainId: 1,
      address: "0xd13cfd3133239a3c73a9e535a5c4dadee36b395c",
      name: "Vaiot",
      symbol: "VAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13981/thumb/VAIOT_logo.png?1696513714"
    },
    {
      chainId: 1,
      address: "0xf5581dfefd8fb0e4aec526be659cfab1f8c781da",
      name: "HOPR",
      symbol: "HOPR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14061/thumb/Shared_HOPR_logo_512px.png?1696513786"
    },
    {
      chainId: 1,
      address: "0xd478161c952357f05f0292b56012cd8457f1cfbf",
      name: "Polkamarkets",
      symbol: "POLK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14084/thumb/polkamarkets.jpg?1696513807"
    },
    {
      chainId: 1,
      address: "0xaaca86b876ca011844b5798eca7a67591a9743c8",
      name: "0x nodes",
      symbol: "BIOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15600/thumb/BIOS_01.png?1696515235"
    },
    {
      chainId: 1,
      address: "0x1d6405138a335ce5fd7364086334efb3e4f28b59",
      name: "ClearCryptos",
      symbol: "CCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27900/thumb/3e88b61451995da1a5aa572cd4f48e78023e010c0bf984cd5456b2a7bd85f7a5.png?1696526921"
    },
    {
      chainId: 1,
      address: "0x2fda8c6783aa36bed645bad28a4cdc8769dcd252",
      name: "Deuterium",
      symbol: "D2O",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28732/thumb/LinkedIn_d2o_Icon_300x300px.png?1696527712"
    },
    {
      chainId: 1,
      address: "0x63f88a2298a5c4aee3c216aa6d926b184a4b2437",
      name: "GameCredits",
      symbol: "GAME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/193/thumb/XlQmXoU.png?1696501564"
    },
    {
      chainId: 1,
      address: "0x89bd2e7e388fab44ae88bef4e1ad12b4f1e0911c",
      name: "Peanut",
      symbol: "NUX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13958/thumb/2sAMZXpO_400x400.jpg?1696513694"
    },
    {
      chainId: 1,
      address: "0xb9d99c33ea2d86ec5ec6b8a4dd816ebba64404af",
      name: "K21",
      symbol: "K21",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14466/thumb/k21-token.png?1696514153"
    },
    {
      chainId: 1,
      address: "0x852e5427c86a3b46dd25e5fe027bb15f53c4bcb8",
      name: "NiiFi",
      symbol: "NIIFI",
      decimals: 15,
      logoURI: "https://assets.coingecko.com/coins/images/16033/thumb/niifi.PNG?1696515643"
    },
    {
      chainId: 1,
      address: "0x9355372396e3f6daf13359b7b607a3374cc638e0",
      name: "WHALE",
      symbol: "WHALE",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/11797/thumb/WHALE.png?1696511673"
    },
    {
      chainId: 1,
      address: "0x8f3470a7388c05ee4e7af3d01d8c722b0ff52374",
      name: "Veritaseum",
      symbol: "VERI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/695/thumb/veritaseum.png?1696501884"
    },
    {
      chainId: 1,
      address: "0x469eda64aed3a3ad6f868c44564291aa415cb1d9",
      name: "Datamine FLUX",
      symbol: "FLUX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11756/thumb/fluxres.png?1696511637"
    },
    {
      chainId: 1,
      address: "0x6399c842dd2be3de30bf99bc7d1bbf6fa3650e70",
      name: "Premia",
      symbol: "PREMIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13962/thumb/apple-touch-icon.png?1696513698"
    },
    {
      chainId: 1,
      address: "0xcadc0acd4b445166f12d2c07eac6e2544fbe2eef",
      name: "CAD Coin",
      symbol: "CADC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14149/thumb/cadc_2.png?1696513868"
    },
    {
      chainId: 1,
      address: "0x850aab69f0e0171a9a49db8be3e71351c8247df4",
      name: "Konomi Network",
      symbol: "KONO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14406/thumb/konomi.jpg?1696514098"
    },
    {
      chainId: 1,
      address: "0x252b9f56359901a0bde52d0675b1f1130d86f471",
      name: "Pando",
      symbol: "PANDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14150/thumb/pando_logo.png?1696513869"
    },
    {
      chainId: 1,
      address: "0x53c8395465a84955c95159814461466053dedede",
      name: "DeGate",
      symbol: "DG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14415/thumb/DG_token_brand_web_rgb_blue.png?1696514106"
    },
    {
      chainId: 1,
      address: "0xfc4b8ed459e00e5400be803a9bb3954234fd50e3",
      name: "Aave WBTC v1",
      symbol: "AWBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/11734/thumb/aWBTC.png?1696511615"
    },
    {
      chainId: 1,
      address: "0x044d078f1c86508e13328842cc75ac021b272958",
      name: "Peercoin",
      symbol: "PPC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/4/thumb/peercoin-icon-green-transparent_6x.png?1696501402"
    },
    {
      chainId: 1,
      address: "0x037a54aab062628c9bbae1fdb1583c195585fe41",
      name: "LCX",
      symbol: "LCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9985/thumb/zRPSu_0o_400x400.jpg?1696510023"
    },
    {
      chainId: 1,
      address: "0x6ee0f7bb50a54ab5253da0667b0dc2ee526c30a8",
      name: "Aave BUSD v1",
      symbol: "ABUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11736/thumb/aBUSD.png?1696511617"
    },
    {
      chainId: 1,
      address: "0xfc98e825a2264d890f9a1e68ed50e1526abccacd",
      name: "Moss Carbon Credit",
      symbol: "MCO2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14414/thumb/ENtxnThA_400x400.jpg?1696514105"
    },
    {
      chainId: 1,
      address: "0x3ed3b47dd13ec9a98b44e6204a523e766b225811",
      name: "Aave USDT",
      symbol: "AUSDT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/14243/thumb/aUSDT.78f5faae.png?1696513958"
    },
    {
      chainId: 1,
      address: "0x8c15ef5b4b21951d50e53e4fbda8298ffad25057",
      name: "Function X",
      symbol: "FX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8186/thumb/47271330_590071468072434_707260356350705664_n.jpg?1696508396"
    },
    {
      chainId: 1,
      address: "0x05ec93c0365baaeabf7aeffb0972ea7ecdd39cf1",
      name: "Aave BAT",
      symbol: "ABAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14246/thumb/aBAT.1fe436f7_-_Copy.png?1696513961"
    },
    {
      chainId: 1,
      address: "0x9ff58f4ffb29fa2266ab25e75e2a8b3503311656",
      name: "Aave WBTC",
      symbol: "AWBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/14244/thumb/aWBTC.41453c2a.png?1696513959"
    },
    {
      chainId: 1,
      address: "0xa361718326c15715591c299427c62086f69923d9",
      name: "Aave BUSD",
      symbol: "ABUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14245/thumb/aBUSD.346a65d7_-_Copy.png?1696513960"
    },
    {
      chainId: 1,
      address: "0x028171bca77440897b824ca71d1c56cac55b68a3",
      name: "Aave DAI",
      symbol: "ADAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14242/thumb/aDAI.84b6c41f.png?1696513957"
    },
    {
      chainId: 1,
      address: "0xd69f306549e9d96f183b1aeca30b8f4353c2ecc3",
      name: "MCH Coin",
      symbol: "MCHC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15399/thumb/MCHC.jpg?1696515045"
    },
    {
      chainId: 1,
      address: "0xfbbe9b1142c699512545f47937ee6fae0e4b0aa9",
      name: "EDDASwap",
      symbol: "EDDA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14368/thumb/edda.png?1696514061"
    },
    {
      chainId: 1,
      address: "0x19ac2659599fd01c853de846919544276ad26f50",
      name: "Covenant",
      symbol: "COVN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22280/thumb/16837.png?1696521627"
    },
    {
      chainId: 1,
      address: "0x79126d32a86e6663f3aaac4527732d0701c1ae6c",
      name: "Dark Matter",
      symbol: "DMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14223/thumb/dmt.jpg?1696513938"
    },
    {
      chainId: 1,
      address: "0x86efc496dca70bcfd92d19194290e8457a375773",
      name: "Silent Notary",
      symbol: "UBSN",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/1599/thumb/silent-notary.png?1696502631"
    },
    {
      chainId: 1,
      address: "0x101cc05f4a51c0319f570d5e146a8c625198e636",
      name: "Aave TUSD",
      symbol: "ATUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14317/thumb/aTUSD.08592b49.png?1696514005"
    },
    {
      chainId: 1,
      address: "0x5c8c8d560048f34e5f7f8ad71f2f81a89dbd273e",
      name: "CryptoArt Ai",
      symbol: "CART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17583/thumb/logo-64.png?1696517117"
    },
    {
      chainId: 1,
      address: "0x8185bc4757572da2a610f887561c32298f1a5748",
      name: "Aluna",
      symbol: "ALN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14379/thumb/uaLoLU8c_400x400_%281%29.png?1696514071"
    },
    {
      chainId: 1,
      address: "0xa06bc25b5805d5f8d82847d191cb4af5a3e873e0",
      name: "Aave LINK",
      symbol: "ALINK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14315/thumb/aLINK.412c6589.png?1696514004"
    },
    {
      chainId: 1,
      address: "0x1796ae0b0fa4862485106a0de9b654efe301d0b2",
      name: "Polychain Monsters",
      symbol: "PMON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14604/thumb/polkamon.png?1696514282"
    },
    {
      chainId: 1,
      address: "0x5218e472cfcfe0b64a064f055b43b4cdc9efd3a6",
      name: "Residual Token",
      symbol: "ERSDL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12975/thumb/ERSDL.jpg?1706998787"
    },
    {
      chainId: 1,
      address: "0x1fe24f25b1cf609b9c4e7e12d802e3640dfa5e43",
      name: "Chain Guardians",
      symbol: "CGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14326/thumb/cgg_logo.png?1696514015"
    },
    {
      chainId: 1,
      address: "0x657b83a0336561c8f64389a6f5ade675c04b0c3b",
      name: "Playcent",
      symbol: "PCNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14335/thumb/1_B5bFcgBld5poUj_c-_K1Jw.png?1696514023"
    },
    {
      chainId: 1,
      address: "0xb5fe099475d3030dde498c3bb6f3854f762a48ad",
      name: "Fnk com",
      symbol: "FNK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13483/thumb/fnk.png?1696513243"
    },
    {
      chainId: 1,
      address: "0xb6c3dc857845a713d3531cea5ac546f6767992f4",
      name: "Advertise Coin",
      symbol: "ADCO",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/14344/thumb/advertisecoin200x200.png?1696514031"
    },
    {
      chainId: 1,
      address: "0x269877f972622d3c293fca595c65cf34b7f527ce",
      name: "Friends with Benefits Network",
      symbol: "FWB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33783/thumb/Group.png?1702981073"
    },
    {
      chainId: 1,
      address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
      name: "Dogelon Mars",
      symbol: "ELON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14962/thumb/6GxcPRo3_400x400.jpg?1696514622"
    },
    {
      chainId: 1,
      address: "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
      name: "Swarm",
      symbol: "BZZ",
      decimals: 16,
      logoURI: "https://assets.coingecko.com/coins/images/16509/thumb/Circle_Orange_onWhite.png?1696516071"
    },
    {
      chainId: 1,
      address: "0x92868a5255c628da08f550a858a802f5351c5223",
      name: "Cross Chain Bridge",
      symbol: "BRIDGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20223/thumb/0x92868A5255C628dA08F550a858A802f5351C5223.png?1696519632"
    },
    {
      chainId: 1,
      address: "0xcd2828fc4d8e8a0ede91bb38cf64b1a81de65bf6",
      name: "Oddz",
      symbol: "ODDZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14421/thumb/NewLogo.png?1696514112"
    },
    {
      chainId: 1,
      address: "0x0fd3822072ad001aac1c90a09d9506f097f24458",
      name: "NOA PLAY",
      symbol: "NOA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15723/thumb/XHFjmBTx_400x400.png?1696515350"
    },
    {
      chainId: 1,
      address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
      name: "PAX Gold",
      symbol: "PAXG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9519/thumb/paxgold.png?1696509604"
    },
    {
      chainId: 1,
      address: "0x7cda79830faf07ed696fe220566116951ced36a7",
      name: "Maya Preferred",
      symbol: "MAYP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8081/thumb/2u0OXhT9_400x400.png?1696508303"
    },
    {
      chainId: 1,
      address: "0x9695e0114e12c0d3a3636fab5a18e6b737529023",
      name: "Dfyn Network",
      symbol: "DFYN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15368/thumb/SgqhfWz4_400x400_%281%29.jpg?1696515016"
    },
    {
      chainId: 1,
      address: "0x5833dbb0749887174b254ba4a5df747ff523a905",
      name: "XRun",
      symbol: "XRUN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25272/thumb/19787.png?1696524411"
    },
    {
      chainId: 1,
      address: "0xb17c88bda07d28b3838e0c1de6a30eafbcf52d85",
      name: "Shyft Network",
      symbol: "SHFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14534/thumb/TOKEN-Gradient.png?1696514218"
    },
    {
      chainId: 1,
      address: "0x20bc832ca081b91433ff6c17f85701b6e92486c5",
      name: "rETH2",
      symbol: "RETH2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16570/thumb/red256.png?1696516131"
    },
    {
      chainId: 1,
      address: "0x74232704659ef37c08995e386a2e26cc27a8d7b1",
      name: "Strike",
      symbol: "STRK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14607/thumb/Jw-36llq_400x400.jpg?1696514286"
    },
    {
      chainId: 1,
      address: "0xe796d6ca1ceb1b022ece5296226bf784110031cd",
      name: "Blind Boxes",
      symbol: "BLES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14537/thumb/BLES-Logo-BW.png?1696514221"
    },
    {
      chainId: 1,
      address: "0x9ea3b5b4ec044b70375236a281986106457b20ef",
      name: "Delta Financial",
      symbol: "DELTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14564/thumb/Delta_logo.png?1696514246"
    },
    {
      chainId: 1,
      address: "0xfe2e637202056d30016725477c5da089ab0a043a",
      name: "sETH2",
      symbol: "SETH2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16569/thumb/emerald256.png?1696516130"
    },
    {
      chainId: 1,
      address: "0x36919a60a2b67b6d2329863093d180d23d5a0308",
      name: "Kusunoki Samurai",
      symbol: "KUSUNOKI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24688/thumb/68747470733a2f2f7777772e6b7573756e6f6b6973616d757261692e636f6d2f696d616765732f6b7573756e6f6b692d30312e706e67.png?1696523855"
    },
    {
      chainId: 1,
      address: "0x741b0428efdf4372a8df6fb54b018db5e5ab7710",
      name: "ARTX",
      symbol: "ARTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14652/thumb/ARTX.png?1708198632"
    },
    {
      chainId: 1,
      address: "0x88acdd2a6425c3faae4bc9650fd7e27e0bebb7ab",
      name: "Alchemist",
      symbol: "MIST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14655/thumb/79158662.png?1696514331"
    },
    {
      chainId: 1,
      address: "0x0100546f2cd4c9d97f798ffc9755e47865ff7ee6",
      name: "Alchemix ETH",
      symbol: "ALETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16271/thumb/aleth.png?1696515869"
    },
    {
      chainId: 1,
      address: "0x04969cd041c0cafb6ac462bd65b536a5bdb3a670",
      name: "Wrapped ECOMI",
      symbol: "WOMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14675/thumb/ecomi.jpg?1696514349"
    },
    {
      chainId: 1,
      address: "0x30672ae2680c319ec1028b69670a4a786baa0f35",
      name: "NodeSynapse",
      symbol: "NS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35679/thumb/NodeSynapse_%281%29.png?1709525297"
    },
    {
      chainId: 1,
      address: "0x777fd20c983d6658c1d50b3958b3a1733d1cd1e1",
      name: "PUBLISH",
      symbol: "NEWS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/9572/thumb/PUBLISH_Logo_280X280.png?1696509652"
    },
    {
      chainId: 1,
      address: "0x6dea81c8171d0ba574754ef6f8b412f2ed88c54d",
      name: "Liquity",
      symbol: "LQTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14665/thumb/200-lqty-icon.png?1696514340"
    },
    {
      chainId: 1,
      address: "0x5f98805a4e8be255a32880fdec7f6728c6568ba0",
      name: "Liquity USD",
      symbol: "LUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1696514341"
    },
    {
      chainId: 1,
      address: "0xf45f6c8bb3d77ea762175b8f7ca4d251941649fa",
      name: "Lemond",
      symbol: "LEMD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14964/thumb/D-smP_i-_400x400.png?1696514624"
    },
    {
      chainId: 1,
      address: "0x9a0aba393aac4dfbff4333b06c407458002c6183",
      name: "ACoconut",
      symbol: "AC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12779/thumb/ac_logo.png?1696512574"
    },
    {
      chainId: 1,
      address: "0x1735db6ab5baa19ea55d0adceed7bcdc008b3136",
      name: "UREEQA",
      symbol: "URQA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14605/thumb/R_O2enOX_400x400.png?1696514283"
    },
    {
      chainId: 1,
      address: "0x0db8d8b76bc361bacbb72e2c491e06085a97ab31",
      name: "IQeon",
      symbol: "IQN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1736/thumb/IQN_logo_64x64.png?1696502750"
    },
    {
      chainId: 1,
      address: "0x99c6e435ec259a7e8d65e1955c9423db624ba54c",
      name: "Finminity",
      symbol: "FMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14696/thumb/finminity.png?1696514368"
    },
    {
      chainId: 1,
      address: "0x3c72fca8523686fd9e5740b0826fa4bb376e0241",
      name: "300FIT",
      symbol: "FIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9690/thumb/6mkyI4Ss_400x400.png?1696509759"
    },
    {
      chainId: 1,
      address: "0xff75ced57419bcaebe5f05254983b013b0646ef5",
      name: "Cook",
      symbol: "COOK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14603/thumb/logo-200x200.jpg?1696514281"
    },
    {
      chainId: 1,
      address: "0x794fcee2c16e9495c3f590958b1209400751ba80",
      name: "Syntax AI",
      symbol: "SYNTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35680/thumb/syntax-3.jpeg?1709525443"
    },
    {
      chainId: 1,
      address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
      name: "Monetha",
      symbol: "MTH",
      decimals: 5,
      logoURI: "https://assets.coingecko.com/coins/images/902/thumb/LOGO-MTH-200-200.png?1696502024"
    },
    {
      chainId: 1,
      address: "0x056c1d42fb1326f57da7f19ebb7dda4673f1ff55",
      name: "Gains",
      symbol: "GAINS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14681/thumb/200x200.png?1696514354"
    },
    {
      chainId: 1,
      address: "0xec363faa5c4dd0e51f3d9b5d0101263760e7cdeb",
      name: "Instadapp WBTC",
      symbol: "IWBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/25784/thumb/iWBTC-100x100.png?1696524871"
    },
    {
      chainId: 1,
      address: "0x083d41d6dd21ee938f0c055ca4fb12268df0efac",
      name: "GogolCoin",
      symbol: "GOL",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/14824/thumb/GOL.png?1696514492"
    },
    {
      chainId: 1,
      address: "0xbd2949f67dcdc549c6ebe98696449fa79d988a9f",
      name: "Meter Governance mapped by Meter io",
      symbol: "EMTRG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12175/thumb/Dark-blue-icon-transparent-vector-white-icon200x200.png?1696512012"
    },
    {
      chainId: 1,
      address: "0x4fee21439f2b95b72da2f9f901b3956f27fe91d5",
      name: "FrogSwap",
      symbol: "FROG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21449/thumb/logo.54d7099f.png?1696520811"
    },
    {
      chainId: 1,
      address: "0xbf2179859fc6d5bee9bf9158632dc51678a4100e",
      name: "aelf",
      symbol: "ELF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1371/thumb/aelf-logo.png?1696502429"
    },
    {
      chainId: 1,
      address: "0xee503d43ad447cdfc719f688207bfcb2fbb9471c",
      name: "Daomatian",
      symbol: "DAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30784/thumb/3Vwa_H8f_400x400.jpg?1696529651"
    },
    {
      chainId: 1,
      address: "0x2008e3057bd734e10ad13c9eae45ff132abc1722",
      name: "Zebi",
      symbol: "ZCO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2756/thumb/zebi.png?1696503529"
    },
    {
      chainId: 1,
      address: "0x6ef6610d24593805144d73b13d4405e00a4e4ac7",
      name: "Die Protocol",
      symbol: "DIE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27903/thumb/newlogo.jpg?1696526924"
    },
    {
      chainId: 1,
      address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
      name: "Vulcan Forged",
      symbol: "PYR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14770/thumb/1617088937196.png?1696514439"
    },
    {
      chainId: 1,
      address: "0x2f109021afe75b949429fe30523ee7c0d5b27207",
      name: "OccamFi",
      symbol: "OCC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14801/thumb/occfi.PNG?1696514470"
    },
    {
      chainId: 1,
      address: "0x728f30fa2f100742c7949d1961804fa8e0b1387d",
      name: "GamerCoin",
      symbol: "GHX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14714/thumb/ghx_icon.png?1696514385"
    },
    {
      chainId: 1,
      address: "0x87931e7ad81914e7898d07c68f145fc0a553d8fb",
      name: "WIZARD Vault  NFTX ",
      symbol: "WIZARD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17068/thumb/Wizards.png?1696516630"
    },
    {
      chainId: 1,
      address: "0x21381e026ad6d8266244f2a583b35f9e4413fa2a",
      name: "Formation FI",
      symbol: "FORM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16145/thumb/FORM.png?1696515750"
    },
    {
      chainId: 1,
      address: "0xb39185e33e8c28e0bb3dbbce24da5dea6379ae91",
      name: "PHUNK Vault  NFTX ",
      symbol: "PHUNK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17074/thumb/Phunks.png?1696516636"
    },
    {
      chainId: 1,
      address: "0xed0439eacf4c4965ae4613d77a5c2efe10e5f183",
      name: "Niftyx Protocol",
      symbol: "SHROOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12341/thumb/niftyx_logo.jpg?1696512168"
    },
    {
      chainId: 1,
      address: "0xa364a9f85f61dc5e3118be282a23edc5e09f62ac",
      name: "Golden Zen Token",
      symbol: "GZT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33467/thumb/Zen.jpeg?1701942862"
    },
    {
      chainId: 1,
      address: "0x7ca4408137eb639570f8e647d9bd7b7e8717514a",
      name: "Alpaca City",
      symbol: "ALPA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13070/thumb/alpaca_logo.png?1696512859"
    },
    {
      chainId: 1,
      address: "0x397deb686c72384fad502a81f4d7fdb89e1f1280",
      name: "XELS",
      symbol: "XELS",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/14729/thumb/Xels_logo_square_%281%29.png?1696514398"
    },
    {
      chainId: 1,
      address: "0xa4e8c3ec456107ea67d3075bf9e3df3a75823db0",
      name: "Loom Network  OLD ",
      symbol: "LOOMOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3387/thumb/1_K76UVoLq-FOL7l-_Fag-Qw_2x.png?1696504085"
    },
    {
      chainId: 1,
      address: "0x42476f744292107e34519f9c357927074ea3f75d",
      name: "Loom Network  NEW ",
      symbol: "LOOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14735/thumb/LOOM.png?1696514405"
    },
    {
      chainId: 1,
      address: "0xcf9fbffec9e0e5bbc62e79bf1965f5db76955661",
      name: "MeshBox",
      symbol: "MESH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6200/thumb/DPuEPJQ6_400x400.jpg?1696506586"
    },
    {
      chainId: 1,
      address: "0x6307b25a665efc992ec1c1bc403c38f3ddd7c661",
      name: "Global Coin Research",
      symbol: "GCR",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/14815/thumb/gcr.jpeg?1696514483"
    },
    {
      chainId: 1,
      address: "0xb0e99627bc29adef1178f16117bf495351e81997",
      name: "Dex Trade Coin",
      symbol: "DXC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15025/thumb/R1A63oDx_400x400.jpg?1696514686"
    },
    {
      chainId: 1,
      address: "0x09970aec766b6f3223aca9111555e99dc50ff13a",
      name: "Levolution",
      symbol: "LEVL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7370/thumb/L_Icon_Blue_200x200.png?1696507652"
    },
    {
      chainId: 1,
      address: "0x6d551bd441fb65513c0d815747b3409c1eb56886",
      name: "Sky Raiders",
      symbol: "SKY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37249/thumb/favicon200.png?1713862510"
    },
    {
      chainId: 1,
      address: "0xdbb7a34bf10169d6d2d0d02a6cbb436cf4381bfa",
      name: "Zentry",
      symbol: "ZENT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36979/thumb/Zentry-rebrand-Primary_200px.png?1713743277"
    },
    {
      chainId: 1,
      address: "0x0f17bc9a994b87b5225cfb6a2cd4d667adb4f20b",
      name: "Jarvis Synthetic Euro",
      symbol: "JEUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15725/thumb/jEUR.png?1696515352"
    },
    {
      chainId: 1,
      address: "0x5d858bcd53e085920620549214a8b27ce2f04670",
      name: "POP Network",
      symbol: "POP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7281/thumb/Logo_%28Light_Mode%29_%281%29.png?1696507572"
    },
    {
      chainId: 1,
      address: "0xa44e5137293e855b1b7bc7e2c6f8cd796ffcb037",
      name: "Sentinel  OLD ",
      symbol: "DVPN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/3625/thumb/Sentinel_512X512.png?1696504304"
    },
    {
      chainId: 1,
      address: "0x0b5326da634f9270fb84481dd6f94d3dc2ca7096",
      name: "Etho Protocol",
      symbol: "ETHO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5194/thumb/IconOnly_Transparent_NoBuffer_resized.png?1713297055"
    },
    {
      chainId: 1,
      address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
      name: "Unizen",
      symbol: "ZCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14830/thumb/logo128px.png?1700169101"
    },
    {
      chainId: 1,
      address: "0x321c2fe4446c7c963dc41dd58879af648838f98d",
      name: "Cryptex Finance",
      symbol: "CTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14932/thumb/glossy_icon_-_C200px.png?1696514592"
    },
    {
      chainId: 1,
      address: "0xd85ad783cc94bd04196a13dc042a3054a9b52210",
      name: "TribeOne",
      symbol: "HAKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16575/thumb/USqW1QX.png?1696516136"
    },
    {
      chainId: 1,
      address: "0x565d3902d6a5a2d5ce28ff427423e88933334dd2",
      name: "Adult Playground",
      symbol: "ADULT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32053/thumb/0x565d3902d6a5a2d5ce28ff427423e88933334dd2.png?1696530850"
    },
    {
      chainId: 1,
      address: "0x48c3399719b582dd63eb5aadf12a40b4c3f52fa2",
      name: "StakeWise",
      symbol: "SWISE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15044/thumb/stakewise200.png?1696514703"
    },
    {
      chainId: 1,
      address: "0x8cc0f052fff7ead7f2edcccac895502e884a8a71",
      name: "ARTH",
      symbol: "ARTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16876/thumb/Ik5dhOq.png?1696516444"
    },
    {
      chainId: 1,
      address: "0xd62baa6f3c579316b2798262a219b367c549c7dc",
      name: "Reflect Audit",
      symbol: "REF",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35681/thumb/ref.jpeg?1709525682"
    },
    {
      chainId: 1,
      address: "0x43a96962254855f16b925556f9e97be436a43448",
      name: "Hord",
      symbol: "HORD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14972/thumb/HORD_TOKEN_%281%29_1.png?1705414356"
    },
    {
      chainId: 1,
      address: "0xb5f1457d6fba1956fb8d31b0b7caca14bde0be4b",
      name: "Stilton",
      symbol: "STILT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26132/thumb/2vfQHbe9_400x400.png?1696525220"
    },
    {
      chainId: 1,
      address: "0x3a82d3111ab5faf39d847d46023d9090261a658f",
      name: "Tycoon",
      symbol: "TYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15165/thumb/coingecko.png?1696514820"
    },
    {
      chainId: 1,
      address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
      name: "Ampleforth Governance",
      symbol: "FORTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14917/thumb/photo_2021-04-22_00.00.03.jpeg?1696514579"
    },
    {
      chainId: 1,
      address: "0x20cd2e7ec8f5d8b337fe46a4f565ccef1561b9a9",
      name: "ESG",
      symbol: "ESG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24932/thumb/esg.png?1696524088"
    },
    {
      chainId: 1,
      address: "0xedadeb5faa413e6c8623461849dfd0b7c3790c32",
      name: "Obortech",
      symbol: "OBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14929/thumb/OBORTECH_200.png?1696514590"
    },
    {
      chainId: 1,
      address: "0x27778e14ce36d3b85e1effeb43816a17bbb7088a",
      name: "Lyfe Gold",
      symbol: "LGOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14938/thumb/LGOLD-Logo-200.png?1696514597"
    },
    {
      chainId: 1,
      address: "0xd64809f5f7d772d9112a6bd379de00a77188199e",
      name: "Lyfe Silver",
      symbol: "LSILVER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14939/thumb/LSILVER-Logo-200.png?1696514598"
    },
    {
      chainId: 1,
      address: "0xc55c2175e90a46602fd42e931f62b3acc1a013ca",
      name: "Mogul Productions",
      symbol: "STARS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14975/thumb/STARS_LOGO_PNG.png?1696514635"
    },
    {
      chainId: 1,
      address: "0xb6ee9668771a79be7967ee29a63d4184f8097143",
      name: "CargoX",
      symbol: "CXO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2580/thumb/cargox.png?1696503384"
    },
    {
      chainId: 1,
      address: "0xf4cd3d3fda8d7fd6c5a500203e38640a70bf9577",
      name: "YfDAI finance",
      symbol: "YF-DAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12385/thumb/1619048513068.png?1696512208"
    },
    {
      chainId: 1,
      address: "0x4a615bb7166210cce20e6642a6f8fb5d4d044496",
      name: "NAOS Finance",
      symbol: "NAOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15144/thumb/bafybeibkztkshitabrf7yqqkqtbjqestjknpgv7lsjfzdsa3ufspagqs2e.ipfs.infura-ipfs.io.png?1696514800"
    },
    {
      chainId: 1,
      address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
      name: "League of Kingdoms",
      symbol: "LOKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22572/thumb/loka_64pix.png?1696521891"
    },
    {
      chainId: 1,
      address: "0x0352557b007a4aae1511c114409b932f06f9e2f4",
      name: "sRUNE",
      symbol: "SRUNE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14953/thumb/sRUNE.png?1696514611"
    },
    {
      chainId: 1,
      address: "0x20a62aca58526836165ca53fe67dd884288c8abf",
      name: "Rentible",
      symbol: "RNB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15176/thumb/rnb_200x200.png?1703145247"
    },
    {
      chainId: 1,
      address: "0x253a5b4f0a210b8d33b702a938b1d56d06b5449e",
      name: "Omni Foundation",
      symbol: "OMN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36675/thumb/Layer_1_%281%29_%282%29.png?1712062599"
    },
    {
      chainId: 1,
      address: "0x808507121b80c02388fad14726482e061b8da827",
      name: "Pendle",
      symbol: "PENDLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15069/thumb/Pendle_Logo_Normal-03.png?1696514728"
    },
    {
      chainId: 1,
      address: "0x7697b462a7c4ff5f8b55bdbc2f4076c2af9cf51a",
      name: "Sarcophagus",
      symbol: "SARCO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15091/thumb/E2S2-CcUcAAyNxD.jpeg?1696514749"
    },
    {
      chainId: 1,
      address: "0x5fbc3cb8b428cc00a04808870295d39962cc7fee",
      name: "Bitazza",
      symbol: "BTZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24597/thumb/BTZ_Logo_%28200x200%29.png?1696523771"
    },
    {
      chainId: 1,
      address: "0xcef46305d096fa876dd23048bf80f9345282e3fc",
      name: "Banque Universal",
      symbol: "CBU",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/8112/thumb/png_tr.png?1696508329"
    },
    {
      chainId: 1,
      address: "0x4575f41308ec1483f3d399aa9a2826d74da13deb",
      name: "Orchid Protocol",
      symbol: "OXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3916/thumb/download_%285%29.png?1696504574"
    },
    {
      chainId: 1,
      address: "0xc67b12049c2d0cf6e476bc64c7f82fc6c63cffc5",
      name: "Globe Derivative Exchange",
      symbol: "GDT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/15335/thumb/gdt.PNG?1696514983"
    },
    {
      chainId: 1,
      address: "0x9d409a0a012cfba9b15f6d4b36ac57a46966ab9a",
      name: "Yearn Compounding veCRV yVault",
      symbol: "YVBOOST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15152/thumb/yvBOOST.png?1696514808"
    },
    {
      chainId: 1,
      address: "0x358aa737e033f34df7c54306960a38d09aabd523",
      name: "Ares Protocol",
      symbol: "ARES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15153/thumb/Ares-logo.png?1696514809"
    },
    {
      chainId: 1,
      address: "0xf519381791c03dd7666c142d4e49fd94d3536011",
      name: "Asia Coin",
      symbol: "ASIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18589/thumb/Ou7mp_R1TQ5B9vsBiZ8oQnSv36M6hiA2hESxV_7YSw0.png?1696518065"
    },
    {
      chainId: 1,
      address: "0xbbbbbbb5aa847a2003fbc6b5c16df0bd1e725f61",
      name: "B Protocol",
      symbol: "BPRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15110/thumb/66428641.jpg?1696514768"
    },
    {
      chainId: 1,
      address: "0x1614f18fc94f47967a3fbe5ffcd46d4e7da3d787",
      name: "PAID Network",
      symbol: "PAID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13761/thumb/512.png?1696513503"
    },
    {
      chainId: 1,
      address: "0xc064f4f215b6a1e4e7f39bd8530c4de0fc43ee9d",
      name: "LeisureMeta",
      symbol: "LM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25761/thumb/SVG_16533804486374586M.jpg?1696524846"
    },
    {
      chainId: 1,
      address: "0x668c50b1c7f46effbe3f242687071d7908aab00a",
      name: "CoShi Inu",
      symbol: "COSHI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15219/thumb/200.jpg?1696514874"
    },
    {
      chainId: 1,
      address: "0x2d94aa3e47d9d5024503ca8491fce9a2fb4da198",
      name: "Bankless DAO",
      symbol: "BANK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15227/thumb/j4WEJrwU.png?1696514882"
    },
    {
      chainId: 1,
      address: "0xdd1ad9a21ce722c151a836373babe42c868ce9a4",
      name: "Universal Basic Income",
      symbol: "UBI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15269/thumb/ubi.png?1696514921"
    },
    {
      chainId: 1,
      address: "0xac5b038058bcd0424c9c252c6487c25f032e5ddc",
      name: "EpiK Protocol",
      symbol: "AIEPK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15188/thumb/AIEPK_logo.png?1696514845"
    },
    {
      chainId: 1,
      address: "0x8baef8c9568c21b1a2b2fd048f8b4da835691fd0",
      name: "USD ZEE",
      symbol: "USDZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24876/thumb/003.png?1696524035"
    },
    {
      chainId: 1,
      address: "0x68c85b9f78f30a0df5ac5723e4e700037f185415",
      name: "AiWork",
      symbol: "AWO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15373/thumb/aiwork.PNG?1696515021"
    },
    {
      chainId: 1,
      address: "0x0c572544a4ee47904d54aaa6a970af96b6f00e1b",
      name: "Wasder",
      symbol: "WAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15374/thumb/wasderBoxedLogoWhite-200x200.png?1696515022"
    },
    {
      chainId: 1,
      address: "0xc8807f0f5ba3fa45ffbdc66928d71c5289249014",
      name: "Ispolink",
      symbol: "ISP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15283/thumb/isolink.PNG?1696514934"
    },
    {
      chainId: 1,
      address: "0xd2adc1c84443ad06f0017adca346bd9b6fc52cab",
      name: "dFund",
      symbol: "DFND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15286/thumb/1zbdX36.png?1696514937"
    },
    {
      chainId: 1,
      address: "0x464fdb8affc9bac185a7393fd4298137866dcfb8",
      name: "Realm",
      symbol: "REALM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18366/thumb/realm.PNG?1696517859"
    },
    {
      chainId: 1,
      address: "0x537edd52ebcb9f48ff2f8a28c51fcdb9d6a6e0d4",
      name: "Small Doge",
      symbol: "SDOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15377/thumb/small_dog.PNG?1696515024"
    },
    {
      chainId: 1,
      address: "0x5d30ad9c6374bf925d0a75454fa327aacf778492",
      name: "PERI Finance",
      symbol: "PERI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15313/thumb/6xVEMS1.png?1696514963"
    },
    {
      chainId: 1,
      address: "0xd084944d3c05cd115c09d072b9f44ba3e0e45921",
      name: "Manifold Finance",
      symbol: "FOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15928/thumb/Manifold.png?1696515541"
    },
    {
      chainId: 1,
      address: "0x48c276e8d03813224bb1e55f953adb6d02fd3e02",
      name: "Kuma Inu",
      symbol: "KUMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15526/thumb/kuma_inu.PNG?1696515168"
    },
    {
      chainId: 1,
      address: "0xacfa209fb73bf3dd5bbfb1101b9bc999c49062a5",
      name: "EvidenZ",
      symbol: "BCDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2014/thumb/evidenz-512.png?1696502988"
    },
    {
      chainId: 1,
      address: "0x993864e43caa7f7f12953ad6feb1d1ca635b875f",
      name: "SingularityDAO",
      symbol: "SDAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15385/thumb/200x200_logo.png?1696515032"
    },
    {
      chainId: 1,
      address: "0xd89310f4baedb33afb36d7cc45bb8847f4463060",
      name: "MEMEX",
      symbol: "MEMEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15448/thumb/V46Sq63d_400x400.jpg?1696515092"
    },
    {
      chainId: 1,
      address: "0x2a03a891add2dc6d0f7b94419086630ba5cb65b6",
      name: "Dreamverse",
      symbol: "DV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21554/thumb/dv.png?1696520916"
    },
    {
      chainId: 1,
      address: "0x18c1074845c389907762a71242bfe271c9da2d9c",
      name: "BULL Token",
      symbol: "BULL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30785/thumb/BULL200x200.jpg?1696529652"
    },
    {
      chainId: 1,
      address: "0x29ef81cc8737f19449d501396d4968d138140675",
      name: "0xConnect",
      symbol: "0XCON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33258/thumb/ox200.png?1701318655"
    },
    {
      chainId: 1,
      address: "0x74d2d73b455540b037298c0e0925bc702aedbe4a",
      name: "Schrodinger",
      symbol: "MEOW",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19649/thumb/kitty_dinger.png?1696519077"
    },
    {
      chainId: 1,
      address: "0xc0b68eb52c89e3fffa62d78012ac8b661bfaa323",
      name: "Vixco",
      symbol: "VIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15405/thumb/vixco.png?1696515051"
    },
    {
      chainId: 1,
      address: "0xc28e931814725bbeb9e670676fabbcb694fe7df2",
      name: "Quadrant Protocol",
      symbol: "EQUAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4462/thumb/equad.png?1696505053"
    },
    {
      chainId: 1,
      address: "0xfc979087305a826c2b2a0056cfaba50aad3e6439",
      name: "Dafi Protocol",
      symbol: "DAFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14428/thumb/Dafi_Black_Icon.png?1696514118"
    },
    {
      chainId: 1,
      address: "0x81f8f0bb1cb2a06649e51913a151f0e7ef6fa321",
      name: "VitaDAO",
      symbol: "VITA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16580/thumb/QmRjwywiAfpzSfQTuWM3zCTghSHN7G6ohQaar7Ht6WANUp.png?1696516140"
    },
    {
      chainId: 1,
      address: "0x380bd08929d4ae51de22f708dccb6b4c534ab79a",
      name: "TINFA",
      symbol: "TINFA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34542/thumb/TINFA_%281%29.png?1705339483"
    },
    {
      chainId: 1,
      address: "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
      name: "REVV",
      symbol: "REVV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12373/thumb/REVV_TOKEN_Refined_2021_%281%29.png?1696512197"
    },
    {
      chainId: 1,
      address: "0x5cb888182fbffdb62c08fb4b5a343914f00fdfee",
      name: "Moneybrain BiPS",
      symbol: "BIPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15556/thumb/bips_logo_200x200_Trans.png?1696515197"
    },
    {
      chainId: 1,
      address: "0x64a77277e37d44957fe5815d6ff442ab8b16cc29",
      name: "SpaceDawgs",
      symbol: "DAWGS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17076/thumb/twitter-facebook-Instagram-pfp.png?1696516638"
    },
    {
      chainId: 1,
      address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
      name: "Storj",
      symbol: "STORJ",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/949/thumb/storj.png?1696502065"
    },
    {
      chainId: 1,
      address: "0x4a1d542b52a95ad01ddc70c2e7df0c7bbaadc56f",
      name: "Niftify",
      symbol: "NIFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20558/thumb/AWPDLxLK_400x400.jpg?1696519967"
    },
    {
      chainId: 1,
      address: "0x887168120cb89fb06f3e74dc4af20d67df0977f6",
      name: "Sekuritance",
      symbol: "SKRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15495/thumb/skrt.png?1696515139"
    },
    {
      chainId: 1,
      address: "0x675bbc7514013e2073db7a919f6e4cbef576de37",
      name: "Coldstack",
      symbol: "CLS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15499/thumb/logo_200x200.png?1696515143"
    },
    {
      chainId: 1,
      address: "0x108a850856db3f85d0269a2693d896b394c80325",
      name: "THORWallet DEX",
      symbol: "TGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21843/thumb/tgt_logo.png?1696521198"
    },
    {
      chainId: 1,
      address: "0x53dfea0a8cc2a2a2e425e1c174bc162999723ea0",
      name: "Jarvis Synthetic Swiss Franc",
      symbol: "JCHF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15727/thumb/jCHF.png?1696515353"
    },
    {
      chainId: 1,
      address: "0x6100dd79fcaa88420750dcee3f735d168abcb771",
      name: "Ethereans",
      symbol: "OS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19592/thumb/eherian.jpg?1697038777"
    },
    {
      chainId: 1,
      address: "0x6bb61215298f296c55b19ad842d3df69021da2ef",
      name: "Drops Ownership Power",
      symbol: "DOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15696/thumb/dop.png?1696515325"
    },
    {
      chainId: 1,
      address: "0x997507cc49fbf0cd6ce5e1ee543218556fafdebc",
      name: "Bitenium",
      symbol: "BT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14618/thumb/BT-token-logo-200.png?1696514296"
    },
    {
      chainId: 1,
      address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
      name: "Measurable Data",
      symbol: "MDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2441/thumb/mdt_icon_120x120.png?1711452723"
    },
    {
      chainId: 1,
      address: "0x616ef40d55c0d2c506f4d6873bda8090b79bf8fc",
      name: "Kounotori",
      symbol: "KTO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/21251/thumb/KTO.png?1696520624"
    },
    {
      chainId: 1,
      address: "0x6710c63432a2de02954fc0f851db07146a6c0312",
      name: "Smart MFG",
      symbol: "MFG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1842/thumb/Smart_MFG_Cropped_Logo.png?1696502841"
    },
    {
      chainId: 1,
      address: "0xf55a93b613d172b86c2ba3981a849dae2aecde2f",
      name: "Your Futures Exchange",
      symbol: "YFX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15654/thumb/yfx.PNG?1696515285"
    },
    {
      chainId: 1,
      address: "0xda23d301761e4e2bf474951f978f6dfb6f3c9f14",
      name: "Tsuki Inu",
      symbol: "TKINU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15681/thumb/tkinu.png?1696515311"
    },
    {
      chainId: 1,
      address: "0x72a66e54b66892ae3bbe54df7bb7dd5ae927a6f9",
      name: "Crypto Village Accelerator CVAG",
      symbol: "CVAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17124/thumb/cvag.PNG?1696516684"
    },
    {
      chainId: 1,
      address: "0xf720e38f678b29b243f7d53b56acbf5de98f2385",
      name: "Upfire",
      symbol: "UPR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20562/thumb/UPR256.png?1696519971"
    },
    {
      chainId: 1,
      address: "0x846c66cf71c43f80403b51fe3906b3599d63336f",
      name: "PumaPay",
      symbol: "PMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2307/thumb/pumapay_dark_rounded_256x256.png?1696503200"
    },
    {
      chainId: 1,
      address: "0xfc70cbb442d5c115ee1497d22b421b1f9bd9f3da",
      name: "Biblical Truth",
      symbol: "BTRU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36677/thumb/BTRU_Logo.png?1712062960"
    },
    {
      chainId: 1,
      address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
      name: "Moeda Loyalty Points",
      symbol: "MDA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/895/thumb/moeda-loyalty-points.png?1696502019"
    },
    {
      chainId: 1,
      address: "0x00d8318e44780edeefcf3020a5448f636788883c",
      name: "dAppstore",
      symbol: "DAPPX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15780/thumb/large-logo.png?1696515404"
    },
    {
      chainId: 1,
      address: "0x107c4504cd79c5d2696ea0030a8dd4e92601b82e",
      name: "Bloom",
      symbol: "BLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2662/thumb/bloom.png?1696503453"
    },
    {
      chainId: 1,
      address: "0x2ebd53d035150f328bd754d6dc66b99b0edb89aa",
      name: "Metronome",
      symbol: "MET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3249/thumb/met.png?1696503964"
    },
    {
      chainId: 1,
      address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
      name: "LooksRare",
      symbol: "LOOKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22173/thumb/circle-black-256.png?1696521517"
    },
    {
      chainId: 1,
      address: "0xcb84d72e61e383767c4dfeb2d8ff7f4fb89abc6e",
      name: "Vega Protocol",
      symbol: "VEGA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15870/thumb/vega.PNG?1696515485"
    },
    {
      chainId: 1,
      address: "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
      name: "Ribbon Finance",
      symbol: "RBN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15823/thumb/ribbon.png?1709186956"
    },
    {
      chainId: 1,
      address: "0x47da5456bc2e1ce391b645ce80f2e97192e4976a",
      name: "PL Gnet",
      symbol: "PLUG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15824/thumb/PLUG_token.png?1696515442"
    },
    {
      chainId: 1,
      address: "0x1ffefd8036409cb6d652bd610de465933b226917",
      name: "Everscale",
      symbol: "EVER",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/12783/thumb/everscale_badge_main_round_1x.png?1696512578"
    },
    {
      chainId: 1,
      address: "0x5eeaa2dcb23056f4e8654a349e57ebe5e76b5e6e",
      name: "Virtue Poker Points",
      symbol: "VPP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3386/thumb/vp-logo-200x200.png?1696504084"
    },
    {
      chainId: 1,
      address: "0x618e75ac90b12c6049ba3b27f5d5f8651b0037f6",
      name: "QASH",
      symbol: "QASH",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/1220/thumb/qash.jpeg?1696502299"
    },
    {
      chainId: 1,
      address: "0xcc802c45b55581713cecd1eb17be9ab7fccb0844",
      name: "SBU Honey",
      symbol: "BHNY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26079/thumb/honey.png?1696525163"
    },
    {
      chainId: 1,
      address: "0xf6650117017ffd48b725b4ec5a00b414097108a7",
      name: "Xido Finance",
      symbol: "XIDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16161/thumb/KJw4clj.png?1696515765"
    },
    {
      chainId: 1,
      address: "0xb67beb26ebeb0dceec354ae0942256d03c01771b",
      name: "DeStorage",
      symbol: "DS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15984/thumb/DS_LOG_Transparent_200x200.png?1696515597"
    },
    {
      chainId: 1,
      address: "0x5f474906637bdcda05f29c74653f6962bb0f8eda",
      name: "DeFinity",
      symbol: "DEFX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15875/thumb/definity-listing-logo.png?1696515490"
    },
    {
      chainId: 1,
      address: "0x9d7630adf7ab0b0cb00af747db76864df0ec82e4",
      name: "GATENet",
      symbol: "GATE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16009/thumb/82168105.png?1696515621"
    },
    {
      chainId: 1,
      address: "0x2620638eda99f9e7e902ea24a285456ee9438861",
      name: "Crust Shadow",
      symbol: "CSM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16037/thumb/2_mnCYZfHmLg2bFrjM3vKtPw.png?1696515647"
    },
    {
      chainId: 1,
      address: "0x7b7983967409fce461ea8bbdf9ed37631b1d59c9",
      name: "KPOP Coin",
      symbol: "KPOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15923/thumb/kpop.PNG?1696515536"
    },
    {
      chainId: 1,
      address: "0x8a001303158670e284950565164933372807cd48",
      name: "WaifuAI",
      symbol: "WFAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30606/thumb/waifuai.jpg?1696529476"
    },
    {
      chainId: 1,
      address: "0xed6bb4700abd545575f0642bb5ea8e0d3b24e9f3",
      name: "Digital Files",
      symbol: "DIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29282/thumb/DIFI_logo.png?1696528234"
    },
    {
      chainId: 1,
      address: "0xdd974d5c2e2928dea5f71b9825b8b646686bd200",
      name: "Kyber Network Crystal Legacy",
      symbol: "KNCL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/947/thumb/logo-kncl.png?1696502063"
    },
    {
      chainId: 1,
      address: "0xaa4e3edb11afa93c41db59842b29de64b72e355b",
      name: "Marginswap",
      symbol: "MFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13899/thumb/marginswap_logo.png?1696513642"
    },
    {
      chainId: 1,
      address: "0x9aab071b4129b083b01cb5a0cb513ce7eca26fa5",
      name: "Hunt",
      symbol: "HUNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7989/thumb/HUNT.png?1696508215"
    },
    {
      chainId: 1,
      address: "0x16980b3b4a3f9d89e33311b5aa8f80303e5ca4f8",
      name: "KIRA Network",
      symbol: "KEX",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/13232/thumb/KEX-200x200.png?1705676884"
    },
    {
      chainId: 1,
      address: "0x3267c5b73cc15e253b1a90c01366b17d560bc6fb",
      name: "President Ron DeSantis",
      symbol: "RON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30620/thumb/Desantis-200x200.jpg?1696529494"
    },
    {
      chainId: 1,
      address: "0xc314b0e758d5ff74f63e307a86ebfe183c95767b",
      name: "Adappter",
      symbol: "ADP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14203/thumb/logo_on.png?1696513920"
    },
    {
      chainId: 1,
      address: "0x5d6f4e7b3f57b238eea545f16f9d6d17b77ec2fb",
      name: "Basix",
      symbol: "BSX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37666/thumb/basix-usdx-logo-200x200.png?1715176576"
    },
    {
      chainId: 1,
      address: "0x8355dbe8b0e275abad27eb843f3eaf3fc855e525",
      name: "Wolf Game Wool",
      symbol: "WOOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20760/thumb/KM3RwIVx_400x400.jpg?1696520155"
    },
    {
      chainId: 1,
      address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
      name: "Ripio Credit Network",
      symbol: "RCN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1057/thumb/ripio-credit-network.png?1696502162"
    },
    {
      chainId: 1,
      address: "0x64d91f12ece7362f91a6f8e7940cd55f05060b92",
      name: "ASH",
      symbol: "ASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15714/thumb/omnPqaTY.png?1696515341"
    },
    {
      chainId: 1,
      address: "0x97b65710d03e12775189f0d113202cc1443b0aa2",
      name: "AstroElon",
      symbol: "ELONONE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/16082/thumb/AstroElon.png?1696515690"
    },
    {
      chainId: 1,
      address: "0x4da34f8264cb33a5c9f17081b9ef5ff6091116f4",
      name: "ELYFI",
      symbol: "ELFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23733/thumb/elyfi_logo.png?1696522936"
    },
    {
      chainId: 1,
      address: "0xfd414e39155f91e94443a9fe97e856569d0f5eec",
      name: "Shibarium Perpetuals",
      symbol: "SERP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29465/thumb/photo_2023-03-15_22.44.48-removebg-preview_%281%29.png?1696528411"
    },
    {
      chainId: 1,
      address: "0x8f828a0644f12fa352888e645a90333d30f6fd7d",
      name: "Rinia Inu",
      symbol: "RINIA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29466/thumb/rinia.png?1696528411"
    },
    {
      chainId: 1,
      address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
      name: "Mask Network",
      symbol: "MASK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14051/thumb/Mask_Network.jpg?1696513776"
    },
    {
      chainId: 1,
      address: "0x13b2f6928d7204328b0e8e4bcd0379aa06ea21fa",
      name: "Aave AMM WBTC",
      symbol: "AAMMWBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17215/thumb/aAMMWBTC_2x.png?1696516771"
    },
    {
      chainId: 1,
      address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
      name: "Cindicator",
      symbol: "CND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1006/thumb/cindicator.png?1696502118"
    },
    {
      chainId: 1,
      address: "0xcb86c6a22cb56b6cf40cafedb06ba0df188a416e",
      name: "inSure DeFi",
      symbol: "SURE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10354/thumb/logo-grey-circle.png?1696510355"
    },
    {
      chainId: 1,
      address: "0xa1b0edf4460cc4d8bfaa18ed871bff15e5b57eb4",
      name: "Aave AMM UniBATWETH",
      symbol: "AAMMUNIBATWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17217/thumb/aAmmUniBATWETH.png?1696516773"
    },
    {
      chainId: 1,
      address: "0xe340b25fe32b1011616bb8ec495a4d503e322177",
      name: "Aave AMM UniDAIUSDC",
      symbol: "AAMMUNIDAIUSDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17218/thumb/aAmmUniDAIUSDC.png?1696516773"
    },
    {
      chainId: 1,
      address: "0x947aeb02304391f8fbe5b25d7d98d649b57b1788",
      name: "Mandala Exchange",
      symbol: "MDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13736/thumb/png-cmc.png?1696513480"
    },
    {
      chainId: 1,
      address: "0x8d137e3337eb1b58a222fef2b2cc7c423903d9cf",
      name: "SQGL Vault  NFTX ",
      symbol: "SQGL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17041/thumb/SQGL.png?1696516604"
    },
    {
      chainId: 1,
      address: "0xcfa0885131f602d11d4da248d2c65a62063567a9",
      name: "TORG",
      symbol: "TORG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17596/thumb/TORG_Logo_200x200.png?1696517129"
    },
    {
      chainId: 1,
      address: "0x391e86e2c002c70dee155eaceb88f7a3c38f5976",
      name: "Aave AMM UniUSDCWETH",
      symbol: "AAMMUNIUSDCWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17219/thumb/aAmmUniUSDCWETH.png?1696516774"
    },
    {
      chainId: 1,
      address: "0x09ce2b746c32528b7d864a1e3979bd97d2f095ab",
      name: "DeFIL",
      symbol: "DFL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17708/thumb/defillogo200200.png?1696517235"
    },
    {
      chainId: 1,
      address: "0x0ea20e7ffb006d4cfe84df2f72d8c7bd89247db0",
      name: "Aave AMM UniCRVWETH",
      symbol: "AAMMUNICRVWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17220/thumb/aAmmUniCRVWETH.png?1696516775"
    },
    {
      chainId: 1,
      address: "0x491e136ff7ff03e6ab097e54734697bb5802fc1c",
      name: "Kattana",
      symbol: "KTN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14739/thumb/256-256-1.png?1696514409"
    },
    {
      chainId: 1,
      address: "0x069f967be0ca21c7d793d8c343f71e597d9a49b3",
      name: "HZM Coin",
      symbol: "HZM",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/18032/thumb/HZM_new_Logo_PNG_CoinGecko.png?1696517548"
    },
    {
      chainId: 1,
      address: "0xb8db81b84d30e2387de0ff330420a4aaa6688134",
      name: "Aave AMM UniLINKWETH",
      symbol: "AAMMUNILINKWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17221/thumb/aAmmUniLINKWETH.png?1696516776"
    },
    {
      chainId: 1,
      address: "0x93c9175e26f57d2888c7df8b470c9eea5c0b0a93",
      name: "B cube ai",
      symbol: "BCUBE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15948/thumb/bcube.PNG?1696515560"
    },
    {
      chainId: 1,
      address: "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
      name: "Across Protocol",
      symbol: "ACX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28161/thumb/across-200x200.png?1696527165"
    },
    {
      chainId: 1,
      address: "0x508df5aa4746be37b5b6a69684dfd8bdc322219d",
      name: "Crafting Finance",
      symbol: "CRF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21559/thumb/tokenlogo.png?1696520920"
    },
    {
      chainId: 1,
      address: "0x70401dfd142a16dc7031c56e862fc88cb9537ce0",
      name: "Bird Money",
      symbol: "BIRD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13260/thumb/favicon-180x180.png?1696513035"
    },
    {
      chainId: 1,
      address: "0x3e2324342bf5b8a1dca42915f0489497203d640e",
      name: "Barley Finance",
      symbol: "BARL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34867/thumb/logo_200.png?1706410358"
    },
    {
      chainId: 1,
      address: "0xa9e201a4e269d6cd5e9f0fcbcb78520cf815878b",
      name: "Aave AMM UniRENWETH",
      symbol: "AAMMUNIRENWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17223/thumb/aAmmUniRENWETH.png?1696516778"
    },
    {
      chainId: 1,
      address: "0x6368e1e18c4c419ddfc608a0bed1ccb87b9250fc",
      name: "Tap",
      symbol: "XTP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10291/thumb/0_3SJYkk_400x400.jpg?1696510296"
    },
    {
      chainId: 1,
      address: "0x38e491a71291cd43e8de63b7253e482622184894",
      name: "Aave AMM UniSNXWETH",
      symbol: "AAMMUNISNXWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17224/thumb/aAmmUniSNXWETH.png?1696516779"
    },
    {
      chainId: 1,
      address: "0x3d26dcd840fcc8e4b2193ace8a092e4a65832f9f",
      name: "Aave AMM UniUNIWETH",
      symbol: "AAMMUNIUNIWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17225/thumb/aAmmUniUNIWETH.png?1696516780"
    },
    {
      chainId: 1,
      address: "0xb009bfaaf85e53f55d8657781eb69feaaed83672",
      name: "EdgeSwap",
      symbol: "EGS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24878/thumb/egs.png?1696524036"
    },
    {
      chainId: 1,
      address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
      name: "Convex Finance",
      symbol: "CVX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15585/thumb/convex.png?1696515221"
    },
    {
      chainId: 1,
      address: "0xed0d5747a9ab03a75fbfec3228cd55848245b75d",
      name: "e Money",
      symbol: "NGM",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/13722/thumb/logo-200x200.jpg?1696513466"
    },
    {
      chainId: 1,
      address: "0x37a15c92e67686aa268df03d4c881a76340907e8",
      name: "Pixiu Finance",
      symbol: "PIXIU",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/17297/thumb/pixiu_picture_.png?1696516850"
    },
    {
      chainId: 1,
      address: "0x08c32b0726c5684024ea6e141c50ade9690bbdcc",
      name: "Stratos",
      symbol: "STOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16213/thumb/token_512x512.png?1696515814"
    },
    {
      chainId: 1,
      address: "0x9f9913853f749b3fe6d6d4e16a1cc3c1656b6d51",
      name: "BITT",
      symbol: "BITT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13783/thumb/BITT_Logo_256pixels.png?1696513523"
    },
    {
      chainId: 1,
      address: "0x08037036451c768465369431da5c671ad9b37dbc",
      name: "NFT Stars",
      symbol: "NFTS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16141/thumb/j2KHi8zR_400x400.png?1696515746"
    },
    {
      chainId: 1,
      address: "0xd24946147829deaa935be2ad85a3291dbf109c80",
      name: "Aave AMM USDC",
      symbol: "AAMMUSDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/17226/thumb/aAMMUSDC_2x.png?1696516780"
    },
    {
      chainId: 1,
      address: "0xcd7492db29e2ab436e819b249452ee1bbdf52214",
      name: "SafeMoon Inu",
      symbol: "SMI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/16091/thumb/SMI.png?1696515699"
    },
    {
      chainId: 1,
      address: "0x559b7bfc48a5274754b08819f75c5f27af53d53b",
      name: "Qi Dao",
      symbol: "QI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15329/thumb/qidao.jpeg?1697093140"
    },
    {
      chainId: 1,
      address: "0xb8647e90c0645152fccf4d9abb6b59eb4aa99052",
      name: "KeyFi",
      symbol: "KEYFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15098/thumb/keyfi_logo.jpg?1696514756"
    },
    {
      chainId: 1,
      address: "0xc58f53a8adff2fb4eb16ed56635772075e2ee123",
      name: "Aave AMM UniWBTCWETH",
      symbol: "AAMMUNIWBTCWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17231/thumb/aAmmUniWBTCWETH.png?1696516785"
    },
    {
      chainId: 1,
      address: "0xf5eda6c581f4373b07ce111baf8d1c4fc21cbaa1",
      name: "Game Tournament Trophy",
      symbol: "GTT",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0x8013266cb5c9dd48be3ad7d1ce832874d64b3ce1",
      name: "Boop",
      symbol: "BOOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27918/thumb/boop.png?1696526938"
    },
    {
      chainId: 1,
      address: "0xe59d2ff6995a926a574390824a657eed36801e55",
      name: "Aave AMM UniAAVEWETH",
      symbol: "AAMMUNIAAVEWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17232/thumb/aAmmUniAAVEWETH.png?1696516786"
    },
    {
      chainId: 1,
      address: "0x9196e18bc349b1f64bc08784eae259525329a1ad",
      name: "Pussy Financial",
      symbol: "PUSSY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15213/thumb/pussytoken.png?1696514869"
    },
    {
      chainId: 1,
      address: "0x9f9643209dcce8d7399d7bf932354768069ebc64",
      name: "Invest Club Global",
      symbol: "ICG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34316/thumb/thatone_200%281%29.png?1704621005"
    },
    {
      chainId: 1,
      address: "0x450e7f6e3a2f247a51b98c39297a9a5bfbdb3170",
      name: "Elon GOAT",
      symbol: "EGT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/22301/thumb/ElonGoat.jpg?1696521647"
    },
    {
      chainId: 1,
      address: "0x7c28310cc0b8d898c57b93913098e74a3ba23228",
      name: "PEACE COIN",
      symbol: "PCE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32470/thumb/PEACE.jpg?1698259975"
    },
    {
      chainId: 1,
      address: "0x9303eabc860a743aabcc3a1629014cabcc3f8d36",
      name: "Aave AMM UniDAIWETH",
      symbol: "AAMMUNIDAIWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17230/thumb/aAmmUniDAIWETH.png?1696516784"
    },
    {
      chainId: 1,
      address: "0x37fe0f067fa808ffbdd12891c0858532cfe7361d",
      name: "Civilization",
      symbol: "CIV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17626/thumb/civ-200x200.png?1696517157"
    },
    {
      chainId: 1,
      address: "0xcdb9d30a3ba48cdfcb0ecbe19317e6cf783672f1",
      name: "Mondo Community Coin",
      symbol: "MNDCC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18680/thumb/mndcc_bildmarke_256px.png?1696518149"
    },
    {
      chainId: 1,
      address: "0x1a4b46696b2bb4794eb3d4c26f1c55f9170fa4c5",
      name: "BitDAO",
      symbol: "BIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17627/thumb/rI_YptK8.png?1696517158"
    },
    {
      chainId: 1,
      address: "0x030ba81f1c18d280636f32af80b9aad02cf0854e",
      name: "Aave WETH",
      symbol: "AWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17238/thumb/aWETH_2x.png?1696516795"
    },
    {
      chainId: 1,
      address: "0x641927e970222b10b2e8cdbc96b1b4f427316f16",
      name: "MEEB Vault  NFTX ",
      symbol: "MEEB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17044/thumb/Meebs.png?1696516607"
    },
    {
      chainId: 1,
      address: "0xd1b624f07a4d9b3e3746e33cb58f42df079b5444",
      name: "NKCL Classic",
      symbol: "NKCLC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17893/thumb/w02Nksm-.png?1696517413"
    },
    {
      chainId: 1,
      address: "0x272f97b7a56a387ae942350bbc7df5700f8a4576",
      name: "Aave BAL",
      symbol: "ABAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17242/thumb/aBAL_2x.png?1696516799"
    },
    {
      chainId: 1,
      address: "0xac1419ee74f203c6b9daa3635ad7169b7ebb5c1a",
      name: "Nebula",
      symbol: "NEBULA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33029/thumb/20231116_120200.jpg?1700347575"
    },
    {
      chainId: 1,
      address: "0x409c4d8cd5d2924b9bc5509230d16a61289c8153",
      name: "TONStarter",
      symbol: "TOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17878/thumb/tos.PNG?1696517400"
    },
    {
      chainId: 1,
      address: "0x841fb148863454a3b3570f515414759be9091465",
      name: "Shih Tzu",
      symbol: "SHIH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15309/thumb/shit.PNG?1696514959"
    },
    {
      chainId: 1,
      address: "0x99bb69ee1bbfc7706c3ebb79b21c5b698fe58ec0",
      name: "DeHub",
      symbol: "DHB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18094/thumb/dehub.PNG?1696517599"
    },
    {
      chainId: 1,
      address: "0x320d31183100280ccdf69366cd56180ea442a3e8",
      name: "Lightcoin",
      symbol: "LHC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/16381/thumb/lhc.PNG?1696515979"
    },
    {
      chainId: 1,
      address: "0xc9bc48c72154ef3e5425641a3c747242112a46af",
      name: "Aave RAI",
      symbol: "ARAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17245/thumb/aRAI_2x.png?1696516802"
    },
    {
      chainId: 1,
      address: "0xd37ee7e4f452c6638c96536e68090de8cbcdb583",
      name: "Aave GUSD",
      symbol: "AGUSD",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/17246/thumb/aGUSD_2x.png?1696516803"
    },
    {
      chainId: 1,
      address: "0xffc97d72e13e01096502cb8eb52dee56f74dad7b",
      name: "Aave AAVE",
      symbol: "AAAVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17248/thumb/amAAVE_2x.png?1696516804"
    },
    {
      chainId: 1,
      address: "0x0d86eb9f43c57f6ff3bc9e23d8f9d82503f0e84b",
      name: "Maximus DAO",
      symbol: "MAXI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/25126/thumb/maxilogo200.png?1696524276"
    },
    {
      chainId: 1,
      address: "0xb9d7cb55f463405cdfbe4e90a6d2df01c2b92bf1",
      name: "Aave UNI",
      symbol: "AUNI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17247/thumb/aUNI_2x.png?1696516804"
    },
    {
      chainId: 1,
      address: "0xb794ad95317f75c44090f64955954c3849315ffe",
      name: "Ribbit Meme",
      symbol: "RIBBIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30145/thumb/ribbit-logo.png?1696529066"
    },
    {
      chainId: 1,
      address: "0x03d1e72765545729a035e909edd9371a405f77fb",
      name: "Nabox",
      symbol: "NABOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16445/thumb/NyemjVRA_400x400.png?1696516042"
    },
    {
      chainId: 1,
      address: "0x20a8cec5fffea65be7122bcab2ffe32ed4ebf03a",
      name: "DinoX",
      symbol: "DNXC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17321/thumb/asset_icon_dnxc_200.png?1696516875"
    },
    {
      chainId: 1,
      address: "0x9a2af0abb12bee5369b180976be01e8c80d0e7b6",
      name: "Empire",
      symbol: "EMPIRE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/16390/thumb/pb_ranDy_400x400.png?1696515988"
    },
    {
      chainId: 1,
      address: "0x7dc85f00715c9d9ec1b50731a9bcc8df95087c55",
      name: "Clexy",
      symbol: "CLEXY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34318/thumb/clexylogopurple_notext_%281%29.png?1704621766"
    },
    {
      chainId: 1,
      address: "0xd31695a1d35e489252ce57b129fd4b1b05e6acac",
      name: "TOKPIE",
      symbol: "TKP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3731/thumb/tokpie-200x200.png?1696504401"
    },
    {
      chainId: 1,
      address: "0xeca82185adce47f39c684352b0439f030f860318",
      name: "PERL eco",
      symbol: "PERL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4682/thumb/PERL.eco-Icon-green_6x.png?1696505249"
    },
    {
      chainId: 1,
      address: "0xeec2be5c91ae7f8a338e1e5f3b5de49d07afdc81",
      name: "Dopex",
      symbol: "DPX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16652/thumb/DPX_%281%29.png?1696516213"
    },
    {
      chainId: 1,
      address: "0x0ff5a8451a839f5f0bb3562689d9a44089738d11",
      name: "Dopex Rebate",
      symbol: "RDPX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16659/thumb/rDPX_200x200_Coingecko.png?1696516221"
    },
    {
      chainId: 1,
      address: "0x02e7ac540409d32c90bfb51114003a9e1ff0249c",
      name: "JPG NFT Index",
      symbol: "JPG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25071/thumb/JPG-token-logo-01.png?1696524219"
    },
    {
      chainId: 1,
      address: "0x35e78b3982e87ecfd5b3f3265b601c046cdbe232",
      name: "SideShift",
      symbol: "XAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15719/thumb/sideshift-icon_3x.png?1696515346"
    },
    {
      chainId: 1,
      address: "0x1341a2257fa7b770420ef70616f888056f90926c",
      name: "Zoo",
      symbol: "ZOOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15629/thumb/gyzERsO.png?1696515262"
    },
    {
      chainId: 1,
      address: "0x0fd67b4ceb9b607ef206904ec73459c4880132c9",
      name: "ShoeFy",
      symbol: "SHOE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19082/thumb/SHOEFY.jpg?1696518532"
    },
    {
      chainId: 1,
      address: "0xaaef88cea01475125522e117bfe45cf32044e238",
      name: "GuildFi",
      symbol: "GF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20933/thumb/guildfi-logo-200.png?1696520322"
    },
    {
      chainId: 1,
      address: "0x8dae6cb04688c62d939ed9b68d32bc62e49970b1",
      name: "Aave CRV",
      symbol: "ACRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17250/thumb/aCRV_2x.png?1696516806"
    },
    {
      chainId: 1,
      address: "0xde5ed76e7c05ec5e4572cfc88d1acea165109e44",
      name: "DEUS Finance",
      symbol: "DEUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18778/thumb/Black_Background_200x200.png?1696518242"
    },
    {
      chainId: 1,
      address: "0x618679df9efcd19694bb1daa8d00718eacfa2883",
      name: "Universe XYZ",
      symbol: "XYZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15809/thumb/universexyz.png?1696515429"
    },
    {
      chainId: 1,
      address: "0x69fa0fee221ad11012bab0fdb45d444d3d2ce71c",
      name: "Thorstarter",
      symbol: "XRUNE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16835/thumb/thorstarter.jpg?1696516403"
    },
    {
      chainId: 1,
      address: "0x3b58c52c03ca5eb619eba171091c86c34d603e5f",
      name: "Cyclub",
      symbol: "CYCLUB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/12524/thumb/mcicoin-logo.png?1696512337"
    },
    {
      chainId: 1,
      address: "0xc382e04099a435439725bb40647e2b32dc136806",
      name: "Cogecoin",
      symbol: "COGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16791/thumb/Dog-Logo_1x.png?1696516362"
    },
    {
      chainId: 1,
      address: "0x692accdd8b86692427e0aa4752ae917df01cc56f",
      name: "Sunrise",
      symbol: "SUNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17601/thumb/ticker_sunc_200_200.png?1696517134"
    },
    {
      chainId: 1,
      address: "0xe76c6c83af64e4c60245d8c7de953df673a7a33d",
      name: "Railgun",
      symbol: "RAIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16840/thumb/railgun.jpeg?1696516407"
    },
    {
      chainId: 1,
      address: "0x53bd789f2cdb846b227d8ffc7b46ed4263231fdf",
      name: "SimbCoin Swap",
      symbol: "SMBSWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16808/thumb/smb.png?1696516378"
    },
    {
      chainId: 1,
      address: "0xe0a189c975e4928222978a74517442239a0b86ff",
      name: "Keys",
      symbol: "KEYS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/20604/thumb/200x200_%2843%29.png?1696520010"
    },
    {
      chainId: 1,
      address: "0x1da87b114f35e1dc91f72bf57fc07a768ad40bb0",
      name: "Equalizer",
      symbol: "EQZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14741/thumb/X2p5mb2f_400x400.png?1696514410"
    },
    {
      chainId: 1,
      address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
      name: "WOO",
      symbol: "WOO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12921/thumb/WOO_Logos_2023_Profile_Pic_WOO.png?1696512709"
    },
    {
      chainId: 1,
      address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
      name: "Linear",
      symbol: "LINA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12509/thumb/1649227343-linalogo200px.png?1696512324"
    },
    {
      chainId: 1,
      address: "0x155ff1a85f440ee0a382ea949f24ce4e0b751c65",
      name: "Behodler",
      symbol: "EYE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12804/thumb/etherscan-eye-2-1.png?1696512597"
    },
    {
      chainId: 1,
      address: "0xad996a45fd2373ed0b10efa4a8ecb9de445a4302",
      name: "Shirtum",
      symbol: "SHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16955/thumb/4fWlpC0.png?1696516523"
    },
    {
      chainId: 1,
      address: "0xf0c5831ec3da15f3696b4dad8b21c7ce2f007f28",
      name: "AXIS",
      symbol: "AXIS",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/16972/thumb/lUeFYUeu_400x400.png?1696516538"
    },
    {
      chainId: 1,
      address: "0x269616d549d7e8eaa82dfb17028d0b212d11232a",
      name: "Punk Vault  NFTX ",
      symbol: "PUNK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17018/thumb/Punk.png?1696516582"
    },
    {
      chainId: 1,
      address: "0xd779eea9936b4e323cddff2529eb6f13d0a4d66e",
      name: "EnterDAO",
      symbol: "ENTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18684/thumb/entr.png?1696518153"
    },
    {
      chainId: 1,
      address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
      name: "Status",
      symbol: "SNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/779/thumb/status.png?1696501931"
    },
    {
      chainId: 1,
      address: "0xc31cebf8f9e825d1d1244d73d0a65e44bd5210db",
      name: "CRYN",
      symbol: "CRYN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/24601/thumb/cryn.png?1696523774"
    },
    {
      chainId: 1,
      address: "0xced6a1b885ee79899422d3a2f61fa9c77282c573",
      name: "CodeGenie",
      symbol: "CODEG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36784/thumb/CMC_CG.png?1712337652"
    },
    {
      chainId: 1,
      address: "0x96eb50804d0ef2790f2e1a33670feff6040cf89d",
      name: "Space Xmitter",
      symbol: "SX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28335/thumb/X200.png?1696527341"
    },
    {
      chainId: 1,
      address: "0xceeb07dd26b36287b6d109f0b06d7e8202ce8c1d",
      name: "Got Guaranteed",
      symbol: "GOTG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26107/thumb/%EA%B0%93%EC%A7%80%EB%A1%9C%EA%B3%A0.png?1696525197"
    },
    {
      chainId: 1,
      address: "0x6b1a8f210ec6b7b6643cea3583fb0c079f367898",
      name: "Baanx",
      symbol: "BXX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17108/thumb/BXX_Token_logo.png?1696516669"
    },
    {
      chainId: 1,
      address: "0xee06a81a695750e71a662b51066f2c74cf4478a0",
      name: "Decentral Games  Old ",
      symbol: "DG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13267/thumb/%28Old%29_DG.png?1696513041"
    },
    {
      chainId: 1,
      address: "0xa2085073878152ac3090ea13d1e41bd69e60dc99",
      name: "Escoin",
      symbol: "ELG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13566/thumb/escoin-200.png?1696513320"
    },
    {
      chainId: 1,
      address: "0x4ece5c5cfb9b960a49aae739e15cdb6cfdcc5782",
      name: "Doont Buy",
      symbol: "DBUY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17895/thumb/VaxEiZ3.png?1696517415"
    },
    {
      chainId: 1,
      address: "0xc525abf65169e6d443f698276761eb9ea7d921a4",
      name: "Bitnex AI",
      symbol: "BTX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33649/thumb/logo-small.png?1702543587"
    },
    {
      chainId: 1,
      address: "0xfa99a87b14b02e2240c79240c5a20f945ca5ef76",
      name: "GG",
      symbol: "GGTK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13666/thumb/ggtk.png?1696513416"
    },
    {
      chainId: 1,
      address: "0x72e5390edb7727e3d4e3436451dadaff675dbcc0",
      name: "Hanu Yokia",
      symbol: "HANU",
      decimals: 12,
      logoURI: "https://assets.coingecko.com/coins/images/17161/thumb/Goji_Hanu_Logo_200x200.png?1696516720"
    },
    {
      chainId: 1,
      address: "0x2365a4890ed8965e564b7e2d27c38ba67fec4c6f",
      name: "Aave AMM UniWBTCUSDC",
      symbol: "AAMMUNIWBTCUSDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17255/thumb/aAmmUniWBTCUSDC.png?1696516811"
    },
    {
      chainId: 1,
      address: "0xf256cc7847e919fac9b808cc216cac87ccf2f47a",
      name: "Aave XSUSHI",
      symbol: "AXSUSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17256/thumb/aXSUSHI_2x.png?1696516812"
    },
    {
      chainId: 1,
      address: "0x5165d24277cd063f5ac44efd447b27025e888f37",
      name: "Aave YFI",
      symbol: "AYFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17257/thumb/aYFI_2x.png?1696516813"
    },
    {
      chainId: 1,
      address: "0xd6caf5bd23cf057f5fccce295dcc50c01c198707",
      name: "Evanesco Network",
      symbol: "EVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16722/thumb/evan.PNG?1696516296"
    },
    {
      chainId: 1,
      address: "0xa0bed124a09ac2bd941b10349d8d224fe3c955eb",
      name: "DePay",
      symbol: "DEPAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13183/thumb/DEPAY.png?1696512965"
    },
    {
      chainId: 1,
      address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
      name: "Enjin Coin",
      symbol: "ENJ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1102/thumb/Symbol_Only_-_Purple.png?1709725966"
    },
    {
      chainId: 1,
      address: "0xfb130d93e49dca13264344966a611dc79a456bc5",
      name: "DogeGF",
      symbol: "DOGEGF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18651/thumb/dogegf_logo_200x200.png?1712082872"
    },
    {
      chainId: 1,
      address: "0x2c9aceb63181cd08a093d052ec041e191f229692",
      name: "Angryb",
      symbol: "ANB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17270/thumb/AngryBlockchain.png?1696516825"
    },
    {
      chainId: 1,
      address: "0x3bbbb6a231d0a1a12c6b79ba5bc2ed6358db5160",
      name: "Zenith",
      symbol: "ZEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35861/thumb/o7lSBgbb_400x400.jpg?1709921042"
    },
    {
      chainId: 1,
      address: "0x188e817b02e635d482ae4d81e25dda98a97c4a42",
      name: "Lithium Finance",
      symbol: "LITH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17278/thumb/Lithium_Logo-03200x200.png?1696516832"
    },
    {
      chainId: 1,
      address: "0xa1e770be76bde604f8ebb66f640250a787b9422b",
      name: "Anduschain",
      symbol: "DEB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20842/thumb/DEB.png?1696520234"
    },
    {
      chainId: 1,
      address: "0x8c6bf16c273636523c29db7db04396143770f6a0",
      name: "Moon Rabbit",
      symbol: "AAA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17310/thumb/logo_moon_no_inscriptions-01.png?1696516863"
    },
    {
      chainId: 1,
      address: "0x226f7b842e0f0120b7e194d05432b3fd14773a9d",
      name: "UNION Protocol Governance",
      symbol: "UNN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13408/thumb/unn_finance.png?1696513169"
    },
    {
      chainId: 1,
      address: "0x9ab7bb7fdc60f4357ecfef43986818a2a3569c62",
      name: "Guild of Guardians",
      symbol: "GOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17362/thumb/V2QDNoLg_400x400.jpg?1696516913"
    },
    {
      chainId: 1,
      address: "0x3d9a4d8ab4f5bd1d5d08ae3a95e8ed8bb4d7e3b9",
      name: "STONKSDAO",
      symbol: "STONKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29976/thumb/Final_Logo_%281%29_%281%29.png?1696528901"
    },
    {
      chainId: 1,
      address: "0xcda4e840411c00a614ad9205caec807c7458a0e3",
      name: "PureFi",
      symbol: "UFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17341/thumb/purefi.PNG?1696516893"
    },
    {
      chainId: 1,
      address: "0x777e2ae845272a2f540ebf6a3d03734a5a8f618e",
      name: "Ryoshis Vision",
      symbol: "RYOSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17614/thumb/OFFICIAL_RYOSHI_LOGO-removebg-preview_2_200x200.png?1696517146"
    },
    {
      chainId: 1,
      address: "0x94804dc4948184ffd7355f62ccbb221c9765886f",
      name: "Rage Fan",
      symbol: "RAGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14585/thumb/Copy_of_RAGE_FAN_LOGO_ONLY.png?1696514265"
    },
    {
      chainId: 1,
      address: "0x8db1d28ee0d822367af8d220c0dc7cb6fe9dc442",
      name: "ETHPad",
      symbol: "ETHPAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17520/thumb/tHAbIBQK_400x400.jpg?1696517058"
    },
    {
      chainId: 1,
      address: "0xc4f6e93aeddc11dc22268488465babcaf09399ac",
      name: "hi Dollar",
      symbol: "HI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17618/thumb/unnamed_%281%29.png?1696517150"
    },
    {
      chainId: 1,
      address: "0x0ab902bd4de7521a565f3058fb43d6d01d0d2670",
      name: "CogniTechAI",
      symbol: "CTI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36672/thumb/dp.png?1712061998"
    },
    {
      chainId: 1,
      address: "0x7815bda662050d84718b988735218cffd32f75ea",
      name: "Yel Finance",
      symbol: "YEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17429/thumb/Logo200.png?1696516976"
    },
    {
      chainId: 1,
      address: "0xc0ba369c8db6eb3924965e5c4fd0b4c1b91e305f",
      name: "DLP Duck",
      symbol: "DUCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13440/thumb/DLP_Duck_Token.png?1696513204"
    },
    {
      chainId: 1,
      address: "0x3446dd70b2d52a6bf4a5a192d9b0a161295ab7f9",
      name: "sudoswap",
      symbol: "SUDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27151/thumb/sudo.png?1696526202"
    },
    {
      chainId: 1,
      address: "0xab306326bc72c2335bd08f42cbec383691ef8446",
      name: "PPizza",
      symbol: "PPIZZA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30063/thumb/iconArtboard_1_10x.png?1696528985"
    },
    {
      chainId: 1,
      address: "0x0ec9f76202a7061eb9b3a7d6b59d36215a7e37da",
      name: "BlackPool",
      symbol: "BPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15887/thumb/uyO7dQzR_400x400.jpg?1696515502"
    },
    {
      chainId: 1,
      address: "0x94e496474f1725f1c1824cb5bdb92d7691a4f03a",
      name: "Banana",
      symbol: "BANANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17521/thumb/banana-token-cg.png?1696517059"
    },
    {
      chainId: 1,
      address: "0xd81b71cbb89b2800cdb000aa277dc1491dc923c3",
      name: "NFTMart",
      symbol: "NMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15811/thumb/NFTMART.png?1696515430"
    },
    {
      chainId: 1,
      address: "0x9fa69536d1cda4a04cfb50688294de75b505a9ae",
      name: "DeRace",
      symbol: "DERC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17438/thumb/DERC_logo_coingecko.png?1696516984"
    },
    {
      chainId: 1,
      address: "0x2be1e42bf263aab47d27ba92e72c14823e101d7c",
      name: "Fluid FRAX",
      symbol: "FFRAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28475/thumb/fFRAX-200x200.png?1696527469"
    },
    {
      chainId: 1,
      address: "0xe7ae6d0c56cacaf007b7e4d312f9af686a9e9a04",
      name: "Vabble",
      symbol: "VAB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17508/thumb/vabble.png?1705376555"
    },
    {
      chainId: 1,
      address: "0xd85a6ae55a7f33b0ee113c234d2ee308edeaf7fd",
      name: "Cobak",
      symbol: "CBK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13459/thumb/cbk-128-128.png?1696513222"
    },
    {
      chainId: 1,
      address: "0x2e9d63788249371f1dfc918a52f8d799f4a38c94",
      name: "Tokemak",
      symbol: "TOKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17495/thumb/tokemak-avatar-200px-black.png?1696517036"
    },
    {
      chainId: 1,
      address: "0xcbe771323587ea16dacb6016e269d7f08a7acc4e",
      name: "Spores Network",
      symbol: "SPO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17431/thumb/SPO_token.png?1696516978"
    },
    {
      chainId: 1,
      address: "0x42e70913b53cfcc38b18ffbd124e8f65c706deaf",
      name: "SALAMANDER",
      symbol: "SALLY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31826/thumb/Sally200x200.png?1696530640"
    },
    {
      chainId: 1,
      address: "0x4c11249814f11b9346808179cf06e71ac328c1b5",
      name: "Oraichain",
      symbol: "ORAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12931/thumb/orai.png?1696512718"
    },
    {
      chainId: 1,
      address: "0x009668a9691e456972c8ec4cc84e99486308b84d",
      name: "Terareum  OLD ",
      symbol: "TERA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23880/thumb/Tera-200x200-1.png?1696523080"
    },
    {
      chainId: 1,
      address: "0x6e765d26388a17a6e86c49a8e41df3f58abcd337",
      name: "Kangal",
      symbol: "KANGAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14241/thumb/logo-200.png?1696513956"
    },
    {
      chainId: 1,
      address: "0x70bef3bb2f001da2fddb207dae696cd9faff3f5d",
      name: "Ninja Squad",
      symbol: "NST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22248/thumb/nst-logo-200x200.png?1711559985"
    },
    {
      chainId: 1,
      address: "0xb9d4b6dc1e1ee3577cc442de015cc11f238b35ed",
      name: "Magnum",
      symbol: "MAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33531/thumb/20231213_112204.jpg?1702499402"
    },
    {
      chainId: 1,
      address: "0x6286a9e6f7e745a6d884561d88f94542d6715698",
      name: "Cryptomeda",
      symbol: "TECH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17983/thumb/tech.png?1696517501"
    },
    {
      chainId: 1,
      address: "0xbeab712832112bd7664226db7cd025b153d3af55",
      name: "Bright Union",
      symbol: "BRIGHT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17552/thumb/BrightToken_Token-only_200x200-1.png?1696517088"
    },
    {
      chainId: 1,
      address: "0x0e192d382a36de7011f795acc4391cd302003606",
      name: "Futureswap",
      symbol: "FST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14520/thumb/futureswap_logo.png?1696514206"
    },
    {
      chainId: 1,
      address: "0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559",
      name: "EDEN",
      symbol: "EDEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17470/thumb/Iyc0XM5-_400x400.jpg?1696517012"
    },
    {
      chainId: 1,
      address: "0x4c2e59d098df7b6cbae0848d66de2f8a4889b9c3",
      name: "Fodl Finance",
      symbol: "FODL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19040/thumb/Fodl_Symbol_Gradient.png?1696518491"
    },
    {
      chainId: 1,
      address: "0x62959c699a52ec647622c91e79ce73344e4099f5",
      name: "DeFine",
      symbol: "DFA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17579/thumb/define.PNG?1696517113"
    },
    {
      chainId: 1,
      address: "0x368bf9f1a1ca767935e39f20439d9041707e2634",
      name: "Chainflix",
      symbol: "CFXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17671/thumb/Logo_200_%282%29.png?1696517201"
    },
    {
      chainId: 1,
      address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
      name: "Spell",
      symbol: "SPELL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15861/thumb/abracadabra-3.png?1696515477"
    },
    {
      chainId: 1,
      address: "0x4463e6a3ded0dbe3f6e15bc8420dfc55e5fea830",
      name: "TXA",
      symbol: "TXA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17746/thumb/jwjcN5Kx_400x400.jpg?1696517273"
    },
    {
      chainId: 1,
      address: "0xe33ae4e795114279721047484e5ad5cc7df24fcb",
      name: "MCFinance",
      symbol: "MCF",
      decimals: 10,
      logoURI: "https://assets.coingecko.com/coins/images/17608/thumb/arFRQ0b.png?1696517140"
    },
    {
      chainId: 1,
      address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
      name: "Polymath",
      symbol: "POLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2784/thumb/inKkF01.png?1696503553"
    },
    {
      chainId: 1,
      address: "0x2a9bdcff37ab68b95a53435adfd8892e86084f93",
      name: "Alpha Quark",
      symbol: "AQT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12872/thumb/alpha_quark_logo.png?1696512660"
    },
    {
      chainId: 1,
      address: "0x8727c112c712c4a03371ac87a74dd6ab104af768",
      name: "Jetcoin",
      symbol: "JET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2487/thumb/jetcoin.png?1696503306"
    },
    {
      chainId: 1,
      address: "0xe94b97b6b43639e238c851a7e693f50033efd75c",
      name: "HaloDAO",
      symbol: "RNBW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16754/thumb/RNBW-256x256.png?1696516327"
    },
    {
      chainId: 1,
      address: "0xf203ca1769ca8e9e8fe1da9d147db68b6c919817",
      name: "Wrapped NCG",
      symbol: "WNCG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17747/thumb/WNCG_Color.png?1696517274"
    },
    {
      chainId: 1,
      address: "0xa735a3af76cc30791c61c10d585833829d36cbe0",
      name: "Image Generation AI",
      symbol: "IMGNAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28666/thumb/imgnai-200x200.png?1698476572"
    },
    {
      chainId: 1,
      address: "0xa11bd36801d8fa4448f0ac4ea7a62e3634ce8c7c",
      name: "Allbridge",
      symbol: "ABR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18690/thumb/logo.png?1701737985"
    },
    {
      chainId: 1,
      address: "0xd4ae236a5080a09c0f7bd6e6b84919523573a43b",
      name: "Future T I M E Dividend",
      symbol: "FUTURE",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0x302cae5dcf8f051d0177043c3438020b89b33218",
      name: "Boost",
      symbol: "BOOST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17657/thumb/02FjG1Og.png?1696517188"
    },
    {
      chainId: 1,
      address: "0x012e0e6342308b247f36ee500ecb14dc77a7a8c1",
      name: "Sukhavati Network",
      symbol: "SKT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17674/thumb/logo2.png?1696517204"
    },
    {
      chainId: 1,
      address: "0x72377f31e30a405282b522d588aebbea202b4f23",
      name: "Varen",
      symbol: "VRN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17633/thumb/vrn.png?1696517164"
    },
    {
      chainId: 1,
      address: "0xaec65404ddc3af3c897ad89571d5772c1a695f22",
      name: "Phoenix Finance",
      symbol: "PHX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17675/thumb/phx_logo.png?1696517205"
    },
    {
      chainId: 1,
      address: "0xd528cf2e081f72908e086f8800977df826b5a483",
      name: "Paribus",
      symbol: "PBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18410/thumb/paribus.PNG?1696517900"
    },
    {
      chainId: 1,
      address: "0xbd9908b0cdd50386f92efcc8e1d71766c2782df0",
      name: "DAOSquare",
      symbol: "RICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19084/thumb/tw5gu1dW_400x400.jpeg?1696518537"
    },
    {
      chainId: 1,
      address: "0xa150db9b1fa65b44799d4dd949d922c0a33ee606",
      name: "Digital Reserve Currency",
      symbol: "DRC",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/12802/thumb/DRC_Logo.jpg?1696512595"
    },
    {
      chainId: 1,
      address: "0xd6327ce1fb9d6020e8c2c0e124a1ec23dcab7536",
      name: "Cuminu",
      symbol: "CUMINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15832/thumb/CUMINU.png?1696515450"
    },
    {
      chainId: 1,
      address: "0xe362a9415d8c332a78ba6734620f1afc19099bbc",
      name: "Send Finance",
      symbol: "SEND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33639/thumb/IMG_20231213_084952_753.jpg?1702537949"
    },
    {
      chainId: 1,
      address: "0xdfdb7f72c1f195c5951a234e8db9806eb0635346",
      name: "Feisty Doge NFT",
      symbol: "NFD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17834/thumb/doge-fractionalized.png?1696517355"
    },
    {
      chainId: 1,
      address: "0x55986c1dcbf2fa1f3402c5df256272621624821f",
      name: "Bank BTC",
      symbol: "BANKBTC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17827/thumb/logo_200x200.png?1696517349"
    },
    {
      chainId: 1,
      address: "0xcfcecfe2bd2fed07a9145222e8a7ad9cf1ccd22a",
      name: "Adshares",
      symbol: "ADS",
      decimals: 11,
      logoURI: "https://assets.coingecko.com/coins/images/868/thumb/rnO9DyJ.png?1696502001"
    },
    {
      chainId: 1,
      address: "0x3757232b55e60da4a8793183ac030cfce4c3865d",
      name: "YDragon",
      symbol: "YDR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17807/thumb/icon.png?1696517328"
    },
    {
      chainId: 1,
      address: "0x8a0cdfab62ed35b836dc0633482798421c81b3ec",
      name: "Spherium",
      symbol: "SPHRI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17787/thumb/Group_15.png?1696517311"
    },
    {
      chainId: 1,
      address: "0x9d71ce49ab8a0e6d2a1e7bfb89374c9392fd6804",
      name: "NvirWorld",
      symbol: "NVIR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21359/thumb/Nvir_symbol.png?1696520724"
    },
    {
      chainId: 1,
      address: "0xa01199c61841fce3b3dafb83fefc1899715c8756",
      name: "Cirus",
      symbol: "CIRUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17798/thumb/8p0Bvi90_400x400.jpg?1696517320"
    },
    {
      chainId: 1,
      address: "0x4c5cb5d87709387f8821709f7a6664f00dcf0c93",
      name: "Raft",
      symbol: "RAFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30915/thumb/Logomark_Transparent_Background_200x200.png?1696529760"
    },
    {
      chainId: 1,
      address: "0x06a00715e6f92210af9d7680b584931faf71a833",
      name: "Chronicle",
      symbol: "XNL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18413/thumb/xnl_logo.png?1696517903"
    },
    {
      chainId: 1,
      address: "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
      name: "Streamr XDATA",
      symbol: "XDATA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1115/thumb/streamr.png?1696502210"
    },
    {
      chainId: 1,
      address: "0x61107a409fffe1965126aa456af679719695c69c",
      name: "Umi Digital",
      symbol: "UMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17874/thumb/Umi-200-x-200.png?1696517396"
    },
    {
      chainId: 1,
      address: "0x4116f14b6d462b32a1c10f98049e4b1765e34fa9",
      name: "dotmoovs",
      symbol: "MOOV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15817/thumb/token.png?1714928800"
    },
    {
      chainId: 1,
      address: "0xea7cc765ebc94c4805e3bff28d7e4ae48d06468a",
      name: "Pad Fi",
      symbol: "PAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18117/thumb/pad.fi.png?1696517620"
    },
    {
      chainId: 1,
      address: "0xc0ae17eb994fa828540ffa53776b3830233a1b02",
      name: "Element Black",
      symbol: "ELT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25160/thumb/4TCtUKHs_400x400.jpg?1696524307"
    },
    {
      chainId: 1,
      address: "0x1f19f83fc9a25f3c861260143e36c17706257986",
      name: "DAO Invest",
      symbol: "VEST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17901/thumb/logo-round-200.png?1696517421"
    },
    {
      chainId: 1,
      address: "0x4da0c48376c277cdbd7fc6fdc6936dee3e4adf75",
      name: "Epik Prime",
      symbol: "EPIK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17907/thumb/EPIK_Prime_LOGO.jpg?1696517427"
    },
    {
      chainId: 1,
      address: "0x665f4709940f557e9dde63df0fd9cf6425852b4d",
      name: "Halving",
      symbol: "HALVING",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35732/thumb/halving_%284%29.png?1709691354"
    },
    {
      chainId: 1,
      address: "0x1f4cb968b76931c494ff92ed80ccb169ad641cb1",
      name: "Structure Finance",
      symbol: "STF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18409/thumb/v4RAXKdq_400x400_%281%29.jpg?1696517899"
    },
    {
      chainId: 1,
      address: "0x5e67e49a95b8ccc7a46b68bcdc1c35dc799ef9e0",
      name: "DigiFund V1",
      symbol: "DFUND",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32951/thumb/photo_2023-11-08_13-27-36.jpg?1699935822"
    },
    {
      chainId: 1,
      address: "0xdb5c3c46e28b53a39c255aa39a411dd64e5fed9c",
      name: "Neos Credits",
      symbol: "NCR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17935/thumb/s4C4tVi.png?1696517456"
    },
    {
      chainId: 1,
      address: "0x5dd57da40e6866c9fcc34f4b6ddc89f1ba740dfe",
      name: "BrightID",
      symbol: "BRIGHT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18415/thumb/bright.PNG?1696517905"
    },
    {
      chainId: 1,
      address: "0xc8ef1460277ea47d179dec66d1c5f8b7f7ae5a28",
      name: "Rikkei Finance",
      symbol: "RIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21309/thumb/rikkei-finance.jpeg?1696520678"
    },
    {
      chainId: 1,
      address: "0x5f0bc16d50f72d10b719dbf6845de2e599eb5624",
      name: "Vent Finance",
      symbol: "VENT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17925/thumb/Artboard_29.png?1696517445"
    },
    {
      chainId: 1,
      address: "0x734c90044a0ba31b3f2e640c10dc5d3540499bfd",
      name: "TradeStars",
      symbol: "TSX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15229/thumb/WsO9siKG_400x400.png?1696514884"
    },
    {
      chainId: 1,
      address: "0xf64265e65c4529879a7abf467e00d39e39c0b0da",
      name: "Independence Token",
      symbol: "RFKJ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37105/thumb/Screenshot_2024-04-10_at_7.45.30_PM.png?1713322477"
    },
    {
      chainId: 1,
      address: "0x9cf98eb8a8b28c83e8612046cf55701ce3eb0063",
      name: "Unreal Finance",
      symbol: "UGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17943/thumb/11292.png?1696517464"
    },
    {
      chainId: 1,
      address: "0x2610f0bfc21ef389fe4d03cfb7de9ac1e6c99d6e",
      name: "Skyrim Finance",
      symbol: "SKYRIM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18003/thumb/Xo3oCb53_400x400.png?1696517519"
    },
    {
      chainId: 1,
      address: "0x1e4e46b7bf03ece908c88ff7cc4975560010893a",
      name: "Internet of Energy Network",
      symbol: "IOEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19095/thumb/12799.png?1696518548"
    },
    {
      chainId: 1,
      address: "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
      name: "Gelato",
      symbol: "GEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15026/thumb/Gelato_Icon_Logo_1024x1024.png?1696514687"
    },
    {
      chainId: 1,
      address: "0xae697f994fc5ebc000f8e22ebffee04612f98a0d",
      name: "LGCY Network",
      symbol: "LGCY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12181/thumb/LGCY_network.jpg?1696512018"
    },
    {
      chainId: 1,
      address: "0x1bbf25e71ec48b84d773809b4ba55b6f4be946fb",
      name: "Vow",
      symbol: "VOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18202/thumb/72Nd63R0_400x400.png?1696517701"
    },
    {
      chainId: 1,
      address: "0xe74be071f3b62f6a4ac23ca68e5e2a39797a3c30",
      name: "Recharge",
      symbol: "RCG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18120/thumb/thecharge.PNG?1696517623"
    },
    {
      chainId: 1,
      address: "0x4dd28568d05f09b02220b09c2cb307bfd837cb95",
      name: "FingerprintsDAO",
      symbol: "PRINTS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18143/thumb/prints.png?1696517646"
    },
    {
      chainId: 1,
      address: "0xe7f72bc0252ca7b16dbb72eeee1afcdb2429f2dd",
      name: "NFTLaunch",
      symbol: "NFTL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18140/thumb/nftl.PNG?1696517643"
    },
    {
      chainId: 1,
      address: "0x34f797e7190c131cf630524655a618b5bd8738e7",
      name: "BaconDAO",
      symbol: "BACON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18059/thumb/xDV_bhdA_400x400.jpg?1696517567"
    },
    {
      chainId: 1,
      address: "0xf009f5531de69067435e32c4b9d36077f4c4a673",
      name: "Unvest",
      symbol: "UNV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18119/thumb/UNV.jpg?1696517622"
    },
    {
      chainId: 1,
      address: "0x6abaf438f098f75c5892e1fabf08b1896c805967",
      name: "Bloodboy",
      symbol: "BLOOD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37279/thumb/bloodboy200x200icon.png?1713941790"
    },
    {
      chainId: 1,
      address: "0x799ebfabe77a6e34311eeee9825190b9ece32824",
      name: "Braintrust",
      symbol: "BTRST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18100/thumb/braintrust.PNG?1696517605"
    },
    {
      chainId: 1,
      address: "0xc6dddb5bc6e61e0841c54f3e723ae1f3a807260b",
      name: "Aurox",
      symbol: "URUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14122/thumb/Aurox.png?1696513842"
    },
    {
      chainId: 1,
      address: "0x60f63b76e2fc1649e57a3489162732a90acf59fe",
      name: "Flurry Finance",
      symbol: "FLURRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16235/thumb/flurry_logo_only_200x200.png?1696515836"
    },
    {
      chainId: 1,
      address: "0x7ae1d57b58fa6411f32948314badd83583ee0e8c",
      name: "Dope Wars Paper",
      symbol: "PAPER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18166/thumb/EQHGcBO__400x400.jpeg?1696517667"
    },
    {
      chainId: 1,
      address: "0x39d30828a163713d91c4eadbba2c497a9139ec5c",
      name: "Happy Birthday Coin",
      symbol: "HBDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12814/thumb/%EC%A7%84%ED%92%88.png?1696512607"
    },
    {
      chainId: 1,
      address: "0x356a5160f2b34bc8d88fb084745465ebbbed0174",
      name: "INVI",
      symbol: "INVI",
      decimals: 13,
      logoURI: "https://assets.coingecko.com/coins/images/17363/thumb/INVI-Ticker.png?1696516914"
    },
    {
      chainId: 1,
      address: "0x42a501903afaa1086b5975773375c80e363f4063",
      name: "Cryptyk",
      symbol: "CTK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2729/thumb/Cryptyk_-1.PNG?1714721271"
    },
    {
      chainId: 1,
      address: "0xbb3d7f42c58abd83616ad7c8c72473ee46df2678",
      name: "VectorChat ai",
      symbol: "CHAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33969/thumb/gecko.png?1703576146"
    },
    {
      chainId: 1,
      address: "0x5516ac1aaca7bb2fd5b7bdde1549ef1ea242953d",
      name: "Decentralized ETF",
      symbol: "DETF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24232/thumb/DETF.png?1697123799"
    },
    {
      chainId: 1,
      address: "0xc73c167e7a4ba109e4052f70d5466d0c312a344d",
      name: "Sanshu Inu  OLD ",
      symbol: "SANSHU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15370/thumb/m9DgRlXY.jpg?1696515018"
    },
    {
      chainId: 1,
      address: "0x794baab6b878467f93ef17e2f2851ce04e3e34c8",
      name: "YIN Finance",
      symbol: "YIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18272/thumb/e37387ae6ee756fd.jpg?1696517766"
    },
    {
      chainId: 1,
      address: "0x37ac5730cfb1549715647828a05b3a8ed781134b",
      name: "AiFi Protocol",
      symbol: "AIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33642/thumb/image_%282%29.png?1702540762"
    },
    {
      chainId: 1,
      address: "0x87a92428bbc876d463c21c8e51b903f127d9a9f4",
      name: "Advanced United Continent",
      symbol: "AUC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24369/thumb/200x200.png?1696523553"
    },
    {
      chainId: 1,
      address: "0xb26c4b3ca601136daf98593feaeff9e0ca702a8d",
      name: "Aladdin DAO",
      symbol: "ALD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18277/thumb/78200839.png?1696517771"
    },
    {
      chainId: 1,
      address: "0x131157c6760f78f7ddf877c0019eba175ba4b6f6",
      name: "BigShortBets",
      symbol: "BIGSB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18235/thumb/bigsb-token-logo.png?1696517731"
    },
    {
      chainId: 1,
      address: "0x0026dfbd8dbb6f8d0c88303cc1b1596409fda542",
      name: "SANSHU ",
      symbol: "SANSHU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35739/thumb/blobid0.png?1710233593"
    },
    {
      chainId: 1,
      address: "0x9783b81438c24848f85848f8df31845097341771",
      name: "Dog Collar",
      symbol: "COLLAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18324/thumb/dcLogo.png?1696517815"
    },
    {
      chainId: 1,
      address: "0xee9e5eff401ee921b138490d00ca8d1f13f67a72",
      name: "Asian Fintech",
      symbol: "AFIN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/7519/thumb/Afinlogo-200x200.png?1696507786"
    },
    {
      chainId: 1,
      address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
      name: "QuarkChain",
      symbol: "QKC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3849/thumb/quarkchain.png?1696504513"
    },
    {
      chainId: 1,
      address: "0xfca89d55a768375ab7ca04485a35a964bea828dd",
      name: "Delrey Inu",
      symbol: "DELREY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29661/thumb/Delrey_Inu.png?1696528596"
    },
    {
      chainId: 1,
      address: "0x232fb065d9d24c34708eedbf03724f2e95abe768",
      name: "Sheesha Finance  ERC20 ",
      symbol: "SHEESHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23053/thumb/MLBmh4z0.png?1696522345"
    },
    {
      chainId: 1,
      address: "0x51cb253744189f11241becb29bedd3f1b5384fdb",
      name: "Dimitra",
      symbol: "DMTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18530/thumb/HqEiru32_400x400.jpg?1696518010"
    },
    {
      chainId: 1,
      address: "0x5ca9a71b1d01849c0a95490cc00559717fcf0d1d",
      name: "Aeternity",
      symbol: "AE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1091/thumb/aeternity.png?1696502190"
    },
    {
      chainId: 1,
      address: "0xd76050f75627e508fa14b84036fbf40b8cc549bd",
      name: "SCRIV",
      symbol: "SCRIV",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/5684/thumb/Al7TZrAN_400x400.jpg?1696506143"
    },
    {
      chainId: 1,
      address: "0xdb298285fe4c5410b05390ca80e8fbe9de1f259b",
      name: "handle fi",
      symbol: "FOREX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18533/thumb/handle.fiFOREXLogoDark200x200.png?1696518013"
    },
    {
      chainId: 1,
      address: "0x80d55c03180349fff4a229102f62328220a96444",
      name: "Opulous",
      symbol: "OPUL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16548/thumb/opulous.PNG?1696516110"
    },
    {
      chainId: 1,
      address: "0x28b5e12cce51f15594b0b91d5b5adaa70f684a02",
      name: "Napoleon X",
      symbol: "NPX",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/1471/thumb/napoleon-x.jpg?1696502517"
    },
    {
      chainId: 1,
      address: "0x866f8a50a64e68ca66e97e032c5da99538b3f942",
      name: "eBlockStock",
      symbol: "EBSO",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/18636/thumb/eBSO_logo_szines.png?1696518108"
    },
    {
      chainId: 1,
      address: "0x2ed2cc2c858a8a8219fd2f2d9e170285dbd02756",
      name: "Sports Bet",
      symbol: "SBET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25312/thumb/sbet_logo_256.png?1696524449"
    },
    {
      chainId: 1,
      address: "0x1410434b0346f5be678d0fb554e5c7ab620f8f4a",
      name: "BitKan",
      symbol: "KAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4651/thumb/kan-token.png?1696505219"
    },
    {
      chainId: 1,
      address: "0x4da08a1bff50be96bded5c7019227164b49c2bfc",
      name: "Mononoke Inu",
      symbol: "MONONOKE-INU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/18769/thumb/z9YDK0f.png?1696518234"
    },
    {
      chainId: 1,
      address: "0x922e2708462c7a3d014d8344f7c4d92b27ecf332",
      name: "Neuroni AI",
      symbol: "NEURONI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28887/thumb/200X200.png?1696527864"
    },
    {
      chainId: 1,
      address: "0xfb782396c9b20e564a64896181c7ac8d8979d5f4",
      name: "Divergence Protocol",
      symbol: "DIVER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18666/thumb/DIVER.jpg?1696518136"
    },
    {
      chainId: 1,
      address: "0x765f0c16d1ddc279295c1a7c24b0883f62d33f75",
      name: "DaTa eXchange DTX",
      symbol: "DTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2920/thumb/dtx.png?1696503667"
    },
    {
      chainId: 1,
      address: "0x8dcaec45365e5ada5676073a07b418c2f538145a",
      name: "Shell",
      symbol: "SHELL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35192/thumb/shellprotocoltoken-reduced.png?1712428374"
    },
    {
      chainId: 1,
      address: "0x58f9102bf53cf186682bd9a281d3cd3c616eec41",
      name: "Triall",
      symbol: "TRL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18679/thumb/-B7ftfN8_400x400.png?1696518148"
    },
    {
      chainId: 1,
      address: "0x16cda4028e9e872a38acb903176719299beaed87",
      name: "MARS4",
      symbol: "MARS4",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18709/thumb/mars4_logo.jpg?1696518177"
    },
    {
      chainId: 1,
      address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
      name: "Beta Finance",
      symbol: "BETA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18715/thumb/beta_finance.jpg?1696518183"
    },
    {
      chainId: 1,
      address: "0x96610186f3ab8d73ebee1cf950c750f3b1fb79c2",
      name: "Enjinstarter",
      symbol: "EJS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18732/thumb/l-R1nYA0_400x400.jpg?1696518198"
    },
    {
      chainId: 1,
      address: "0xe03b2642a5111ad0efc0cbce766498c2dd562ae9",
      name: "Old Bitcoin",
      symbol: "BC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28832/thumb/bitcoinlogo.png?1696527808"
    },
    {
      chainId: 1,
      address: "0x4674a4f24c5f63d53f22490fb3a08eaaad739ff8",
      name: "Brokoli",
      symbol: "BRKL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18763/thumb/brkl.png?1696518228"
    },
    {
      chainId: 1,
      address: "0x8eef5a82e6aa222a60f009ac18c24ee12dbf4b41",
      name: "Autobahn Network",
      symbol: "TXL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12432/thumb/txl.png?1696512252"
    },
    {
      chainId: 1,
      address: "0x536381a8628dbcc8c70ac9a30a7258442eab4c92",
      name: "Pantos",
      symbol: "PAN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9639/thumb/Pantos-logo-compact.png?1696509709"
    },
    {
      chainId: 1,
      address: "0x122303734c898e9d233affc234271f04e42e77ad",
      name: "Maxwell the spinning cat",
      symbol: "CAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35859/thumb/maxwell-cg.png?1709896910"
    },
    {
      chainId: 1,
      address: "0x1cc7047e15825f639e0752eb1b89e4225f5327f2",
      name: "Pullix",
      symbol: "PLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34319/thumb/IMG-20231231-WA0003.jpg?1704625607"
    },
    {
      chainId: 1,
      address: "0xd7c302fc3ac829c7e896a32c4bd126f3e8bd0a1f",
      name: "Bit2Me",
      symbol: "B2M",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19848/thumb/b2m-circle-solid-default.png?1696519271"
    },
    {
      chainId: 1,
      address: "0xdf290b162a7d3e0a328cf198308d421954f08b94",
      name: "Beyond Protocol",
      symbol: "BP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4732/thumb/b-logo-200x200.png?1696505293"
    },
    {
      chainId: 1,
      address: "0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515",
      name: "DOSE",
      symbol: "DOSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18847/thumb/dose.PNG?1696518308"
    },
    {
      chainId: 1,
      address: "0x781fbc4c6edf7a37dcc08a3b323f122e8a09eac5",
      name: "OAT Network",
      symbol: "OAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37248/thumb/oat_logo.jpg?1713862457"
    },
    {
      chainId: 1,
      address: "0xa3d59c6d24f428dcfedc09724869e7af4d281fdd",
      name: "DeviantsFactions",
      symbol: "DEV",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/32561/thumb/icon.png?1698546192"
    },
    {
      chainId: 1,
      address: "0x524d524b4c9366be706d3a90dcf70076ca037ae3",
      name: "RMRK",
      symbol: "RMRK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18656/thumb/download_%281%29_%281%29.png?1696518126"
    },
    {
      chainId: 1,
      address: "0x52a047ee205701895ee06a375492490ec9c597ce",
      name: "PulseMarkets",
      symbol: "PULSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19011/thumb/photo_2021-11-11_06-24-09.jpg?1696518463"
    },
    {
      chainId: 1,
      address: "0x94dd57da120c7c564d9aa438773068705e828781",
      name: "Journey",
      symbol: "JRNY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33707/thumb/A541vx-O_400x400.jpg?1702854357"
    },
    {
      chainId: 1,
      address: "0x785c34312dfa6b74f6f1829f79ade39042222168",
      name: "Bumper",
      symbol: "BUMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17822/thumb/Bumper_-__Icon-_Inverse_-_Transparent.png?1714758250"
    },
    {
      chainId: 1,
      address: "0x333a4823466879eef910a04d473505da62142069",
      name: "Nation3",
      symbol: "NATION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25106/thumb/orb-white-256.png?1709559789"
    },
    {
      chainId: 1,
      address: "0x1337def16f9b486faed0293eb623dc8395dfe46a",
      name: "ARMOR",
      symbol: "ARMOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13748/thumb/armor.png?1696513491"
    },
    {
      chainId: 1,
      address: "0xeb4c2781e4eba804ce9a9803c67d0893436bb27d",
      name: "renBTC",
      symbol: "RENBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/11370/thumb/Bitcoin.jpg?1696511287"
    },
    {
      chainId: 1,
      address: "0x0aa7efe4945db24d95ca6e117bba65ed326e291a",
      name: "Ojamu",
      symbol: "OJA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18947/thumb/ojamu-icon-PNK.png?1696518402"
    },
    {
      chainId: 1,
      address: "0xd7dcd9b99787c619b4d57979521258d1a7267ad7",
      name: "Evrynet",
      symbol: "EVRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19194/thumb/evry.png?1696518642"
    },
    {
      chainId: 1,
      address: "0x23d894fb4a0f551f2f923fc85e09819d1f3894b2",
      name: "Intellix",
      symbol: "ITX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34406/thumb/itx.jpeg?1704791991"
    },
    {
      chainId: 1,
      address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
      name: "Synapse",
      symbol: "SYN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18024/thumb/synapse_social_icon.png?1696517540"
    },
    {
      chainId: 1,
      address: "0x3a1311b8c404629e38f61d566cefefed083b9670",
      name: "Piccolo Inu",
      symbol: "PINU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19335/thumb/Piccolo-Inu.png?1696518776"
    },
    {
      chainId: 1,
      address: "0x549020a9cb845220d66d3e9c6d9f9ef61c981102",
      name: "Sidus",
      symbol: "SIDUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21401/thumb/SIDUS_coin_logo.png?1696520765"
    },
    {
      chainId: 1,
      address: "0xe7f58a92476056627f9fdb92286778abd83b285f",
      name: "DecentraWeb",
      symbol: "DWEB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18971/thumb/dweb-logo-transparent.png?1696518425"
    },
    {
      chainId: 1,
      address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
      name: "Highstreet",
      symbol: "HIGH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18973/thumb/logosq200200Coingecko.png?1696518427"
    },
    {
      chainId: 1,
      address: "0xc30769d445d1cbbc5f85fcdb4294b827bd3e7dda",
      name: "MissionMars",
      symbol: "MMARS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33942/thumb/image_2023-12-21_15-40-16__2_-removebg-preview.png?1703509049"
    },
    {
      chainId: 1,
      address: "0x064797ac7f833d01faeeae0e69f3af5a52a91fc8",
      name: "Smol Su",
      symbol: "SU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30179/thumb/SmolSu_%281%29.jpg?1696529098"
    },
    {
      chainId: 1,
      address: "0x02d3a27ac3f55d5d91fb0f52759842696a864217",
      name: "Charged Particles",
      symbol: "IONX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15836/thumb/DrKjSQMH_400x400.png?1696515454"
    },
    {
      chainId: 1,
      address: "0x2162f572b25f7358db9376ab58a947a4e45cede1",
      name: "LABEL Foundation",
      symbol: "LBL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19202/thumb/tele_profile_%EB%8C%80%EC%A7%80_1_-_%282%29.png?1696518649"
    },
    {
      chainId: 1,
      address: "0x60e683c6514edd5f758a55b6f393bebbafaa8d5e",
      name: "Page",
      symbol: "PAGE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/19015/thumb/Page_Icon_LG.png?1696518467"
    },
    {
      chainId: 1,
      address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
      name: "SSV Network",
      symbol: "SSV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19155/thumb/ssv.png?1696518606"
    },
    {
      chainId: 1,
      address: "0xf9fbe825bfb2bf3e387af0dc18cac8d87f29dea8",
      name: "Radar",
      symbol: "RADAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13909/thumb/RADAR.png?1696513651"
    },
    {
      chainId: 1,
      address: "0x38d9eb07a7b8df7d86f440a4a5c4a4c1a27e1a08",
      name: "bloXmove",
      symbol: "BLXM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19310/thumb/blxm_200x200.png?1696518752"
    },
    {
      chainId: 1,
      address: "0xf3ae5d769e153ef72b4e3591ac004e89f48107a1",
      name: "Deeper Network",
      symbol: "DPR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14748/thumb/deeper.png?1696514418"
    },
    {
      chainId: 1,
      address: "0xe4dae00bc1c46ea2f44ae71b1beb8b171c15d812",
      name: "PREMA",
      symbol: "PRMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27600/thumb/prmx.png?1696526631"
    },
    {
      chainId: 1,
      address: "0x910c4da718caf4ee38ce5c2490cddaeca689204e",
      name: "Waste Digital Coin",
      symbol: "WACO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19035/thumb/waco.png?1696518487"
    },
    {
      chainId: 1,
      address: "0x2ba8349123de45e931a8c8264c332e6e9cf593f9",
      name: "Blockchain Monster Hunt",
      symbol: "BCMC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19045/thumb/bcmc-coin-200x200.png?1696518496"
    },
    {
      chainId: 1,
      address: "0x9d39a5de30e57443bff2a8307a4256c8797a3497",
      name: "Ethena Staked USDe",
      symbol: "SUSDE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33669/thumb/photo_2023-12-14_17-00-20.jpg?1702696035"
    },
    {
      chainId: 1,
      address: "0xa487bf43cf3b10dffc97a9a744cbb7036965d3b9",
      name: "Deri Protocol",
      symbol: "DERI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13931/thumb/200vs200.jpg?1696513670"
    },
    {
      chainId: 1,
      address: "0xf5b5efc906513b4344ebabcf47a04901f99f09f3",
      name: "UBIX Network",
      symbol: "UBX",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/13000/thumb/1.png?1696512789"
    },
    {
      chainId: 1,
      address: "0x1b8568fbb47708e9e9d31ff303254f748805bf21",
      name: "Scarcity",
      symbol: "SCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19064/thumb/scx_gecko.png?1696518513"
    },
    {
      chainId: 1,
      address: "0x1da4858ad385cc377165a298cc2ce3fce0c5fd31",
      name: "CloutContracts",
      symbol: "CCS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/19072/thumb/200.png?1696518522"
    },
    {
      chainId: 1,
      address: "0x5f64ab1544d28732f0a24f4713c2c8ec0da089f0",
      name: "Domani Protocol",
      symbol: "DEXTF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12634/thumb/0qgT0aMu_400x400.jpg?1696512442"
    },
    {
      chainId: 1,
      address: "0x5b685863494c33f344081f75e5430c260c224a32",
      name: "CORE MultiChain",
      symbol: "CMCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18848/thumb/O4IzY2CQ_400x400.png?1696518309"
    },
    {
      chainId: 1,
      address: "0x3c8d2fce49906e11e71cb16fa0ffeb2b16c29638",
      name: "Nifty League",
      symbol: "NFTL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19224/thumb/NFTL-256x256.png?1696518671"
    },
    {
      chainId: 1,
      address: "0x8ee325ae3e54e83956ef2d5952d3c8bc1fa6ec27",
      name: "Fable Of The Dragon",
      symbol: "TYRANT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27911/thumb/image_%283%29.png?1696526932"
    },
    {
      chainId: 1,
      address: "0xf56408077487cb879c992909c5b5c66d68c02eb4",
      name: "Riot Racers",
      symbol: "RIOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19238/thumb/jyxvIbmJ_400x400.png?1696518684"
    },
    {
      chainId: 1,
      address: "0xc5b3d3231001a776123194cf1290068e8b0c783b",
      name: "LIT",
      symbol: "LIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21344/thumb/LitLogo_CG.png?1696520710"
    },
    {
      chainId: 1,
      address: "0x29de856ee1e2b281c9f6dd3c670272e7c6ea63eb",
      name: "Groge",
      symbol: "GROGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33259/thumb/Groge.png?1701318941"
    },
    {
      chainId: 1,
      address: "0x8765b1a0eb57ca49be7eacd35b24a574d0203656",
      name: "MetaGameHub DAO",
      symbol: "MGH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20625/thumb/mgh.PNG?1696520029"
    },
    {
      chainId: 1,
      address: "0x9ce115f0341ae5dabc8b477b74e83db2018a6f42",
      name: "HairDAO",
      symbol: "HAIR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29620/thumb/LinkedIn_Logo.jpg?1696528556"
    },
    {
      chainId: 1,
      address: "0xed3d4e446a96dc3b181b64b75c3c70da41dc3cbe",
      name: "Vodra",
      symbol: "VDR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19338/thumb/vdr.png?1696518779"
    },
    {
      chainId: 1,
      address: "0x1fac00ccee478eced6a120a50ed2ab28ee7fe32b",
      name: "Bitune",
      symbol: "TUNE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14112/thumb/bittune.png?1704793548"
    },
    {
      chainId: 1,
      address: "0xba8a621b4a54e61c442f5ec623687e2a942225ef",
      name: "Sandclock",
      symbol: "QUARTZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19368/thumb/sandclock.jpg?1696518808"
    },
    {
      chainId: 1,
      address: "0x9e5bd9d9fad182ff0a93ba8085b664bcab00fa68",
      name: "Dinger",
      symbol: "DINGER",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19443/thumb/dinger.png?1696518881"
    },
    {
      chainId: 1,
      address: "0x876a87e17d76e1487186e00792985918abadca6b",
      name: "MemeDefi",
      symbol: "MEMEFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33185/thumb/200x200.png?1700953675"
    },
    {
      chainId: 1,
      address: "0x0ab87046fbb341d058f17cbc4c1133f25a20a52f",
      name: "Governance OHM",
      symbol: "GOHM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21129/thumb/token_wsOHM_logo.png?1696520508"
    },
    {
      chainId: 1,
      address: "0x296233e84c1d7bff11121bf6d60f0ffa39c3f0cf",
      name: "No One",
      symbol: "NOONE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19393/thumb/logo-200x200_%289%29.png?1696518833"
    },
    {
      chainId: 1,
      address: "0x1782bb88ae0aa07031bc05bbe2bd4150c9da223a",
      name: "Clickart ai",
      symbol: "CLICKART",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32985/thumb/2_%282%29.png?1700093960"
    },
    {
      chainId: 1,
      address: "0x3ef389f264e07fff3106a3926f2a166d1393086f",
      name: "Sator",
      symbol: "SAO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19410/thumb/sator-logo-CMC.png?1696518849"
    },
    {
      chainId: 1,
      address: "0xc2544a32872a91f4a553b404c6950e89de901fdb",
      name: "Frax Price Index Share",
      symbol: "FPIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24944/thumb/FPIS_icon.png?1696524099"
    },
    {
      chainId: 1,
      address: "0x1e053d89e08c24aa2ce5c5b4206744dc2d7bd8f5",
      name: "ThunderCore",
      symbol: "TT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4375/thumb/ThunderCore_Logo_Mark_Gradient_%283%29.png?1696504974"
    },
    {
      chainId: 1,
      address: "0xe59b14e43479dc30d77f553e4b5c6fc67e1f6caf",
      name: "LEXA AI",
      symbol: "LEXA",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0x956f47f50a910163d8bf957cf5846d573e7f87ca",
      name: "Fei USD",
      symbol: "FEI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14570/thumb/ZqsF51Re_400x400.png?1696514251"
    },
    {
      chainId: 1,
      address: "0x1e9d0bb190ac34492aa11b80d28c1c86487a341f",
      name: "The Neko",
      symbol: "NEKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22692/thumb/FL6SU9b5_400x400.jpg?1696522003"
    },
    {
      chainId: 1,
      address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
      name: "Bancor Network",
      symbol: "BNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/736/thumb/Bancor_Token.png?1710479159"
    },
    {
      chainId: 1,
      address: "0x389999216860ab8e0175387a0c90e5c52522c945",
      name: "FEG  OLD ",
      symbol: "FEG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/13878/thumb/F-Icon-FEG-200x200-288dpi-01_%281%29.png?1696513622"
    },
    {
      chainId: 1,
      address: "0x005d1123878fc55fbd56b54c73963b234a64af3c",
      name: "Kiba Inu",
      symbol: "KIBA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19525/thumb/kiba.png?1696518959"
    },
    {
      chainId: 1,
      address: "0x7f59b64c6ee521c0d7e590cf8e4b843caa236f96",
      name: "CellMates",
      symbol: "CELL",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/35114/thumb/D6A3351C-79D3-4658-A67B-4361465162EC.png?1707396881"
    },
    {
      chainId: 1,
      address: "0xf1d1a5306daae314af6c5d027a492b313e07e1a0",
      name: "Envoy",
      symbol: "ENV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19631/thumb/env.png?1696519059"
    },
    {
      chainId: 1,
      address: "0x492798fb464e77cb3cda62b9a2c3c65162db198e",
      name: "AmpliFi DAO",
      symbol: "AGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29137/thumb/original-icon-transparent.png?1696528098"
    },
    {
      chainId: 1,
      address: "0xaee433adebe0fbb88daa47ef0c1a513caa52ef02",
      name: "Pontoon",
      symbol: "TOON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19575/thumb/pontoon.PNG?1696519007"
    },
    {
      chainId: 1,
      address: "0xd502f487e1841fdc805130e13eae80c61186bc98",
      name: "Integral",
      symbol: "ITGR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18381/thumb/Integral_icon_purple.png?1704724515"
    },
    {
      chainId: 1,
      address: "0xbededdf2ef49e87037c4fb2ca34d1ff3d3992a11",
      name: "FEG ETH",
      symbol: "FEG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29643/thumb/feg.png?1696528580"
    },
    {
      chainId: 1,
      address: "0x97a3bd8a445cc187c6a751f392e15c3b2134d695",
      name: "Blockster",
      symbol: "BXR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19857/thumb/bxr-left2.png?1696519280"
    },
    {
      chainId: 1,
      address: "0xa4cf2afd3b165975afffbf7e487cdd40c894ab6b",
      name: "Shibaken Finance",
      symbol: "SHIBAKEN",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/15413/thumb/shibak.png?1696515059"
    },
    {
      chainId: 1,
      address: "0x0ab39ac604f992aaec3c36de337c3cd3917a7d26",
      name: "KEEPs Coin",
      symbol: "KVERSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19622/thumb/keeps.PNG?1696519051"
    },
    {
      chainId: 1,
      address: "0x8a6d4c8735371ebaf8874fbd518b56edd66024eb",
      name: "BLOCKS",
      symbol: "BLOCKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19666/thumb/blocks_logo_200200.png?1696519094"
    },
    {
      chainId: 1,
      address: "0x9f52c8ecbee10e00d9faaac5ee9ba0ff6550f511",
      name: "SIPHER",
      symbol: "SIPHER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21070/thumb/SipherToken.png?1696520453"
    },
    {
      chainId: 1,
      address: "0x505a84a03e382331a1be487b632cf357748b65d6",
      name: "SHIBGF",
      symbol: "SHIBGF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19699/thumb/shibgf_logo.png?1696519126"
    },
    {
      chainId: 1,
      address: "0xd0d19f52ad8705e60ff31df75a7aca8f1399a69e",
      name: "404Aliens",
      symbol: "404A",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35249/thumb/logo-e.jpg?1707988473"
    },
    {
      chainId: 1,
      address: "0x44709a920fccf795fbc57baa433cc3dd53c44dbe",
      name: "DappRadar",
      symbol: "RADAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20894/thumb/radar.png?1696520286"
    },
    {
      chainId: 1,
      address: "0x37fc4b48ce93469dbea9918468993c735049642a",
      name: "CropBytes",
      symbol: "CBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19907/thumb/cbx.png?1696519327"
    },
    {
      chainId: 1,
      address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
      name: "SKALE",
      symbol: "SKL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13245/thumb/SKALE_token_300x300.png?1696513021"
    },
    {
      chainId: 1,
      address: "0x0944d5848bd9f60a34ba92aea300d4286696eb76",
      name: "Palette",
      symbol: "PLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22153/thumb/262aoVTp_400x400.jpg?1696521498"
    },
    {
      chainId: 1,
      address: "0x58cb30368ceb2d194740b144eab4c2da8a917dcb",
      name: "ZynCoin",
      symbol: "ZYN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35749/thumb/zyn_logo_new_200_x_200.png?1710219535"
    },
    {
      chainId: 1,
      address: "0x3656bd0f3f07623bb7f429b390d208f894e44ece",
      name: "INFLIV",
      symbol: "IFV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5279/thumb/INFLIV_LOGO_PNG.png?1696505779"
    },
    {
      chainId: 1,
      address: "0xa92c49c403386111c1629aee00936eed2a9e74a6",
      name: "Kollector",
      symbol: "KLTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19926/thumb/kbase_logo.jpg?1696519345"
    },
    {
      chainId: 1,
      address: "0xebf2096e01455108badcbaf86ce30b6e5a72aa52",
      name: "XIDR",
      symbol: "XIDR",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/21126/thumb/XIDR_Logo_256_X_256.png?1696520505"
    },
    {
      chainId: 1,
      address: "0xb475332d25d34b59176f5c1d94cb9bc9b5e3954a",
      name: "Hobbes",
      symbol: "HOBBES",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30928/thumb/hobbes.jpeg?1696529770"
    },
    {
      chainId: 1,
      address: "0x8530b66ca3ddf50e0447eae8ad7ea7d5e62762ed",
      name: "Meta Doge",
      symbol: "METADOGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19656/thumb/metadoge.png?1696519084"
    },
    {
      chainId: 1,
      address: "0xf8e9f10c22840b613cda05a0c5fdb59a4d6cd7ef",
      name: "Dogs Of Elon",
      symbol: "DOE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19942/thumb/doe.png?1696519360"
    },
    {
      chainId: 1,
      address: "0x9be776559fed779cabd67042a7b8987aae592541",
      name: "Bull Market",
      symbol: "BULL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29977/thumb/bull.jpg?1696528902"
    },
    {
      chainId: 1,
      address: "0x39fbbabf11738317a448031930706cd3e612e1b9",
      name: "Wrapped XRP",
      symbol: "WXRP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19952/thumb/WXRP_revision-256px.png?1696519369"
    },
    {
      chainId: 1,
      address: "0xf974b5f9ac9c6632fee8b76c61b0242ce69c839d",
      name: "ZYX",
      symbol: "ZYX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11964/thumb/zyx.png?1696511823"
    },
    {
      chainId: 1,
      address: "0x2920f7d6134f4669343e70122ca9b8f19ef8fa5d",
      name: "MonoX",
      symbol: "MONO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20901/thumb/e51c6UaU_400x400.png?1696520292"
    },
    {
      chainId: 1,
      address: "0x87869a9789291a6cec99f3c3ef2ff71fceb12a8e",
      name: "CoinMerge OS",
      symbol: "CMOS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29327/thumb/cmos.png?1696528277"
    },
    {
      chainId: 1,
      address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
      name: "Cere Network",
      symbol: "CERE",
      decimals: 10,
      logoURI: "https://assets.coingecko.com/coins/images/20008/thumb/cere.png?1696519430"
    },
    {
      chainId: 1,
      address: "0x2223bf1d7c19ef7c06dab88938ec7b85952ccd89",
      name: "Kryxivia Game",
      symbol: "KXA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21225/thumb/kxa.png?1696520599"
    },
    {
      chainId: 1,
      address: "0x4cce605ed955295432958d8951d0b176c10720d5",
      name: "Novatti Australian Digital Dollar",
      symbol: "AUDD",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/33263/thumb/AUDD-Logo-Blue_512.png?1701319895"
    },
    {
      chainId: 1,
      address: "0x26c75c7d815efe6bf5a6decd17d20d1fdad96a08",
      name: "OctopusWallet",
      symbol: "OCW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36095/thumb/200x200.png?1710481847"
    },
    {
      chainId: 1,
      address: "0xfa5b75a9e13df9775cf5b996a049d9cc07c15731",
      name: "28VCK",
      symbol: "VCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20063/thumb/9435.png?1696519481"
    },
    {
      chainId: 1,
      address: "0xe5597f0723eeaba1b26948e06f008bf0fc1e37e6",
      name: "GM",
      symbol: "GM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20066/thumb/PQ29R4D.png?1696519484"
    },
    {
      chainId: 1,
      address: "0x6c862f803ff42a97d4a483ab761256ad8c90f4f8",
      name: "ELIS",
      symbol: "XLS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13613/thumb/Elis-Symbol-Green.png?1696513363"
    },
    {
      chainId: 1,
      address: "0x5d929aa919e489505ccaad8a199619c6dca0c2de",
      name: "BaaSid",
      symbol: "BAAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5463/thumb/baasid.png?1696505940"
    },
    {
      chainId: 1,
      address: "0xc40f23a3e9613e012944f7957edce97899fa920d",
      name: "dHealth",
      symbol: "DHP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20167/thumb/dHealth_Network_Icon_200w.png?1696519580"
    },
    {
      chainId: 1,
      address: "0x509a38b7a1cc0dcd83aa9d06214663d9ec7c7f4a",
      name: "Blocksquare",
      symbol: "BST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23924/thumb/XpkkqPVR_400x400.jpg?1696523122"
    },
    {
      chainId: 1,
      address: "0x5f944b0c4315cb7c3a846b025ab4045da44abf6c",
      name: "Pancake Games",
      symbol: "GCAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20217/thumb/6oc-L2UC_400x400.png?1696519627"
    },
    {
      chainId: 1,
      address: "0xe66b3aa360bb78468c00bebe163630269db3324f",
      name: "Merchant",
      symbol: "MTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17157/thumb/mto.PNG?1696516717"
    },
    {
      chainId: 1,
      address: "0xf1ca9cb74685755965c7458528a36934df52a3ef",
      name: "AVINOC",
      symbol: "AVINOC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4659/thumb/qX7fh69Q_400x400-1.jpg?1696505226"
    },
    {
      chainId: 1,
      address: "0xc4e8a9d47000ab8e59c7031e311762c68215e467",
      name: "STARX",
      symbol: "STARX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8417/thumb/starworks.PNG?1696508606"
    },
    {
      chainId: 1,
      address: "0x74b988156925937bd4e082f0ed7429da8eaea8db",
      name: "Meme Inu",
      symbol: "MEME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20755/thumb/photo_2021-11-20_13-39-45.jpg?1696520151"
    },
    {
      chainId: 1,
      address: "0xbea98c05eeae2f3bc8c3565db7551eb738c8ccab",
      name: "Geyser",
      symbol: "GYSR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12995/thumb/logo_padded_shifted.png?1696512785"
    },
    {
      chainId: 1,
      address: "0x56de8bc61346321d4f2211e3ac3c0a7f00db9b76",
      name: "RENA Finance",
      symbol: "RENA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15667/thumb/photo_2021-05-21_17-31-35.png?1696515297"
    },
    {
      chainId: 1,
      address: "0xd1cd47746b8e72359b28c1c84a4f6a19dc1a0ee5",
      name: "Sonic Suite",
      symbol: "SONIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28489/thumb/155EE8AF-26AA-4CEC-9EC5-18532E779474.jpeg?1696527481"
    },
    {
      chainId: 1,
      address: "0xfc09c7cfd9c175dd9423ca02ae1249579ab12f12",
      name: "Totoro Inu",
      symbol: "TOTORO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/20277/thumb/cLogo.png?1696519683"
    },
    {
      chainId: 1,
      address: "0x0ba470c6b349d2ae4c93d8c2072b8bfdab95e28a",
      name: "Sword Bot",
      symbol: "SWORD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33875/thumb/SWORD.jpg?1703144528"
    },
    {
      chainId: 1,
      address: "0x5fa3418d828e5cd3c61a66e0fc7fa4a35dadf960",
      name: "Avatly",
      symbol: "AVATLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33922/thumb/28738.png?1703370955"
    },
    {
      chainId: 1,
      address: "0x62406995cafd18f57e7375e8e0060725acebce58",
      name: "Firulais Wallet",
      symbol: "FIWT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20716/thumb/FIWT-Logo.png?1696520115"
    },
    {
      chainId: 1,
      address: "0xcfeaead4947f0705a14ec42ac3d44129e1ef3ed5",
      name: "Notional Finance",
      symbol: "NOTE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/20282/thumb/NOTE-340x340.png?1696519687"
    },
    {
      chainId: 1,
      address: "0xe7976c4efc60d9f4c200cc1bcef1a1e3b02c73e7",
      name: "MAX",
      symbol: "MAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6454/thumb/MAX_Token.jpg?1696506816"
    },
    {
      chainId: 1,
      address: "0x2602278ee1882889b946eb11dc0e810075650983",
      name: "Vader Protocol",
      symbol: "VADER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20497/thumb/AcF08Jk1_400x400.jpg?1696519904"
    },
    {
      chainId: 1,
      address: "0x6cadf6abbceb53e631c288778daacf125481c1bb",
      name: "The Citadel",
      symbol: "CITADEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20445/thumb/2023-03-16_22.55.22.jpg?1696519851"
    },
    {
      chainId: 1,
      address: "0x58fad9e3c3ae54c9ba98c3f0e4bf88ab3e8cf3c5",
      name: "SpaceY 2025",
      symbol: "SPAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20499/thumb/spacey2025.PNG?1696519906"
    },
    {
      chainId: 1,
      address: "0x45448e05020576929fcdeabc228e35b420098840",
      name: "Idavoll DAO",
      symbol: "IDV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14229/thumb/71922199.png?1696513943"
    },
    {
      chainId: 1,
      address: "0xac0968a3e2020ac8ca83e60ccf69081ebc6d3bc3",
      name: "Cindrum",
      symbol: "CIND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20449/thumb/1_sbv9l6ArIn7oYIhi0oQWoQ.png?1696519854"
    },
    {
      chainId: 1,
      address: "0x71fc1f555a39e0b698653ab0b475488ec3c34d57",
      name: "Rainmaker Games",
      symbol: "RAIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21485/thumb/Final-Flip-Rain-Makers-44-1.png?1696520845"
    },
    {
      chainId: 1,
      address: "0x31ea0de8119307aa264bb4b38727aab4e36b074f",
      name: "Bit Store",
      symbol: "STORE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20463/thumb/bit_store.PNG?1696519868"
    },
    {
      chainId: 1,
      address: "0xaea46a60368a7bd060eec7df8cba43b7ef41ad85",
      name: "Fetch ai",
      symbol: "FET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5681/thumb/Fetch.jpg?1696506140"
    },
    {
      chainId: 1,
      address: "0x685fb6960ea7f7b24f02e17c8d893b8c33239d48",
      name: "Saiko   The Revival",
      symbol: "SAIKO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28932/thumb/200x200.png?1696527907"
    },
    {
      chainId: 1,
      address: "0x38a94e92a19e970c144ded0b2dd47278ca11cc1f",
      name: "Falcon Nine",
      symbol: "F9",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/16858/thumb/logo-f9.png?1696516425"
    },
    {
      chainId: 1,
      address: "0x31bd628c038f08537e0229f0d8c0a7b18b0cda7b",
      name: "IntelliQuant",
      symbol: "INQU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35471/thumb/cropped-INQU-custom-logo.png?1708761830"
    },
    {
      chainId: 1,
      address: "0x0af5855a348c58a8bbf65bcc7b9bbacd0e7e2238",
      name: "Ulanco",
      symbol: "UAC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20662/thumb/udacity_logo_icon_169367.png?1696520064"
    },
    {
      chainId: 1,
      address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
      name: "ConstitutionDAO",
      symbol: "PEOPLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20612/thumb/GN_UVm3d_400x400.jpg?1696520017"
    },
    {
      chainId: 1,
      address: "0x9ab165d795019b6d8b3e971dda91071421305e5a",
      name: "Aurora Chain",
      symbol: "AOA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4755/thumb/aurora-logo.png?1696505314"
    },
    {
      chainId: 1,
      address: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
      name: "Aurora",
      symbol: "AURORA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20582/thumb/aurora.jpeg?1696519989"
    },
    {
      chainId: 1,
      address: "0xda9fdab21bc4a5811134a6e0ba6ca06624e67c07",
      name: "Quidd",
      symbol: "QUIDD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19725/thumb/quidd.png?1696519150"
    },
    {
      chainId: 1,
      address: "0x2653891204f463fb2a2f4f412564b19e955166ae",
      name: "Gold Fever Native Gold",
      symbol: "NGL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20633/thumb/2ypNydrG_400x400.jpg?1696520037"
    },
    {
      chainId: 1,
      address: "0xac506c7dc601500e997cad42ea446624ed40c743",
      name: "XCeption",
      symbol: "XCEPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33298/thumb/logo_xception_200x200_-1.png?1701402623"
    },
    {
      chainId: 1,
      address: "0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24",
      name: "StarLink",
      symbol: "STARL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16824/thumb/ZxJbRWJ.png?1696516393"
    },
    {
      chainId: 1,
      address: "0x517abf1fcdbd76bc75b532683ada9113e313a128",
      name: "Doke Inu",
      symbol: "DOKE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29234/thumb/Doke_logo.jpg?1696528191"
    },
    {
      chainId: 1,
      address: "0xb549116ac57b47c1b365a890e1d04fd547dfff97",
      name: "MindAI",
      symbol: "MDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36180/thumb/logo200.png?1710757731"
    },
    {
      chainId: 1,
      address: "0x3a707d56d538e85b783e8ce12b346e7fb6511f90",
      name: "Inverse Ethereum Volatility Index Token",
      symbol: "IETHV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16715/thumb/logo_-_2021-06-28T085526.083.png?1696516289"
    },
    {
      chainId: 1,
      address: "0x62d3c05b9c3d916fbc111819bbd3cee52906c1ae",
      name: "Every Game",
      symbol: "EGAME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20758/thumb/egame.png?1696520153"
    },
    {
      chainId: 1,
      address: "0xae78736cd615f374d3085123a210448e74fc6393",
      name: "Rocket Pool ETH",
      symbol: "RETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20764/thumb/reth.png?1696520159"
    },
    {
      chainId: 1,
      address: "0xc6e145421fd494b26dcf2bfeb1b02b7c5721978f",
      name: "Crypto Perx",
      symbol: "CPRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20768/thumb/8iQSd5YY_400x400.jpg?1696520162"
    },
    {
      chainId: 1,
      address: "0x17837004ea685690b32dbead02a274ec4333a26a",
      name: "Bear Inu",
      symbol: "BEAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29517/thumb/bear.png?1696528460"
    },
    {
      chainId: 1,
      address: "0x1892f6ff5fbe11c31158f8c6f6f6e33106c5b10e",
      name: "MegaWorld",
      symbol: "MEGA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28456/thumb/Twitter_AVA1.jpg?1696527451"
    },
    {
      chainId: 1,
      address: "0xe5ef42d0e5e4aa6b36c613d00db8dad303d505f3",
      name: "BTour Chain",
      symbol: "MSOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13141/thumb/msot.png?1696512927"
    },
    {
      chainId: 1,
      address: "0xebe4a49df7885d015329c919bf43e6460a858f1e",
      name: "iShook",
      symbol: "SHK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3037/thumb/2023-12-20_19.32.44.jpg?1703377166"
    },
    {
      chainId: 1,
      address: "0xc01b1979e2244dc94e67891df0af4f7885e57fd4",
      name: "Lanify",
      symbol: "LAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36404/thumb/logo200x200.png?1711369836"
    },
    {
      chainId: 1,
      address: "0x0d85693b4cb4b8bb4d407e33ba1d9de861db80ca",
      name: "Privago AI",
      symbol: "PVGO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36836/thumb/bbb2.jpg?1712560493"
    },
    {
      chainId: 1,
      address: "0x330528172778cc5196d5f6742886c72505e0613d",
      name: "XBot",
      symbol: "XBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31050/thumb/xbot.jpeg?1696529884"
    },
    {
      chainId: 1,
      address: "0x4f311c430540db1d64e635eb55f969f1660b2016",
      name: "Pepe Chain",
      symbol: "PC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31041/thumb/Pepechain_Token.png?1696529876"
    },
    {
      chainId: 1,
      address: "0xddd6a0ecc3c6f6c102e5ea3d8af7b801d1a77ac8",
      name: "UniX",
      symbol: "UNIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20674/thumb/unix.png?1696520075"
    },
    {
      chainId: 1,
      address: "0x1117ac6ad6cdf1a3bc543bad3b133724620522d5",
      name: "MODA DAO",
      symbol: "MODA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20870/thumb/ModaDAO__logomark-primary_3x.png?1696520264"
    },
    {
      chainId: 1,
      address: "0x809826cceab68c387726af962713b64cb5cb3cca",
      name: "Nucleus Vision",
      symbol: "NCASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3135/thumb/nv.jpg?1696503859"
    },
    {
      chainId: 1,
      address: "0x3f68e7b44e9bcb486c2feadb7a2289d9cdfc9088",
      name: "SportsIcon",
      symbol: "ICONS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20856/thumb/icons-coin-gold.png?1696520251"
    },
    {
      chainId: 1,
      address: "0x9e04f519b094f5f8210441e285f603f4d2b50084",
      name: "EarthFund",
      symbol: "1EARTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20822/thumb/earthfund.PNG?1696520215"
    },
    {
      chainId: 1,
      address: "0xd2af830e8cbdfed6cc11bab697bb25496ed6fa62",
      name: "Wrapped OUSD",
      symbol: "WOUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34355/thumb/wousd-200x200.png?1714796664"
    },
    {
      chainId: 1,
      address: "0xdfc3829b127761a3218bfcee7fc92e1232c9d116",
      name: "PRivaCY Coin",
      symbol: "PRCY",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/14151/thumb/prcy.png?1696513870"
    },
    {
      chainId: 1,
      address: "0x70edf1c215d0ce69e7f16fd4e6276ba0d99d4de7",
      name: "CHEQD Network",
      symbol: "CHEQ",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/20855/thumb/CHEQ.png?1706906858"
    },
    {
      chainId: 1,
      address: "0x9f4909cc95fb870bf48c128c1fdbb5f482797632",
      name: "Guzzler",
      symbol: "GZLR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20970/thumb/Screenshot-2021-11-27-at-22-57-22.png?1696520357"
    },
    {
      chainId: 1,
      address: "0xedb171c18ce90b633db442f2a6f72874093b49ef",
      name: "Wrapped Ampleforth",
      symbol: "WAMPL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20825/thumb/photo_2021-11-25_02-05-11.jpg?1696520218"
    },
    {
      chainId: 1,
      address: "0x5224f552f110ec78e6e0468138950ae5f3040942",
      name: "Anomus Coin",
      symbol: "ANOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20865/thumb/w07_TWqn_400x400.png?1696520259"
    },
    {
      chainId: 1,
      address: "0x5eaa69b29f99c84fe5de8200340b4e9b4ab38eac",
      name: "Raze Network",
      symbol: "RAZE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14767/thumb/logo-2.png?1696514437"
    },
    {
      chainId: 1,
      address: "0x7d29a64504629172a429e64183d6673b9dacbfce",
      name: "Vectorspace AI",
      symbol: "VXV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2063/thumb/vectorspace-ai-logo.jpeg?1696503029"
    },
    {
      chainId: 1,
      address: "0x066798d9ef0833ccc719076dab77199ecbd178b0",
      name: "SakeSwap",
      symbol: "SAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12428/thumb/sake.png?1696512249"
    },
    {
      chainId: 1,
      address: "0xe19f85c920b572ca48942315b06d6cac86585c87",
      name: "PLEB Token",
      symbol: "PLEB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29923/thumb/PLEBToken.png?1696528851"
    },
    {
      chainId: 1,
      address: "0xb56a1f3310578f23120182fb2e58c087efe6e147",
      name: "All Coins Yield Capital",
      symbol: "ACYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21109/thumb/acyc.png?1696520489"
    },
    {
      chainId: 1,
      address: "0x8bbe1a2961b41340468d0548c2cd5b7dfa9b684c",
      name: "Handy",
      symbol: "HANDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21944/thumb/Handy_Token_symbol-01.png?1696521293"
    },
    {
      chainId: 1,
      address: "0xc36b4311b21fc0c2ead46f1ea6ce97c9c4d98d3d",
      name: "Creaticles",
      symbol: "CRE8",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21115/thumb/logo-v3-small.png?1696520495"
    },
    {
      chainId: 1,
      address: "0x4554cc10898f92d45378b98d6d6c2dd54c687fb2",
      name: "Juicebox",
      symbol: "JBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21120/thumb/CCeIEmvE_400x400.jpg?1696520499"
    },
    {
      chainId: 1,
      address: "0xde3ae6f3458db211d298da97fdcf13b6c1c8c87f",
      name: "Anonym Chain",
      symbol: "ANC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33670/thumb/200x200_anc.png?1702701458"
    },
    {
      chainId: 1,
      address: "0xa9e8acf069c58aec8825542845fd754e41a9489a",
      name: "PepeCoin",
      symbol: "PEPECOIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30219/thumb/pepecoin.jpeg?1696529130"
    },
    {
      chainId: 1,
      address: "0xd3210f246ae54c5a45a7b4a83315bf718f591bfc",
      name: "ArkiTech",
      symbol: "ARKI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33426/thumb/200.png?1711371418"
    },
    {
      chainId: 1,
      address: "0x337af08bb6980ecb68389c5ed8876d08643abf8a",
      name: "NOVAWCHI",
      symbol: "VACHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29761/thumb/novawchi-infinity-of-nevoverse-coinmarketcap-logo.png?1696528692"
    },
    {
      chainId: 1,
      address: "0xe1bda0c3bfa2be7f740f0119b6a34f057bd58eba",
      name: "Winkies",
      symbol: "WNK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22260/thumb/wnk.png?1696521605"
    },
    {
      chainId: 1,
      address: "0xe07f9d810a48ab5c3c914ba3ca53af14e4491e8a",
      name: "Gyroscope GYD",
      symbol: "GYD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33428/thumb/GYD-gradient_resized_transparent.png?1702316822"
    },
    {
      chainId: 1,
      address: "0x95392f142af1c12f6e39897ff9b09c599666b50c",
      name: "Impostors Blood",
      symbol: "BLOOD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25527/thumb/RV4nKK2RDO47XzfSLgGs_llgXivhdfpI3tso0.png?1696524659"
    },
    {
      chainId: 1,
      address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
      name: "Biconomy",
      symbol: "BICO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21061/thumb/biconomy_logo.jpg?1696520444"
    },
    {
      chainId: 1,
      address: "0x01597e397605bf280674bf292623460b4204c375",
      name: "Bent Finance",
      symbol: "BENT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21274/thumb/bent-logo-200x200.png?1696520645"
    },
    {
      chainId: 1,
      address: "0x6bd361e10c1afed0d95259e7c0115f3a60e4ea99",
      name: "BollyCoin",
      symbol: "BOLLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21610/thumb/IMG-20211208-124337-701.jpg?1696520970"
    },
    {
      chainId: 1,
      address: "0x7d5121505149065b562c789a0145ed750e6e8cdd",
      name: "Victoria VR",
      symbol: "VR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21178/thumb/vr.png?1696520554"
    },
    {
      chainId: 1,
      address: "0x243cacb4d5ff6814ad668c3e225246efa886ad5a",
      name: "Shina Inu",
      symbol: "SHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25208/thumb/coingecko-shina-purple-bg.png?1696524352"
    },
    {
      chainId: 1,
      address: "0x7c84e62859d0715eb77d1b1c4154ecd6abb21bec",
      name: "Shping",
      symbol: "SHPING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2588/thumb/000103_Shping_Logos_Shping_Secondary_Logo.png?1696503392"
    },
    {
      chainId: 1,
      address: "0xe632ea2ef2cfd8fc4a2731c76f99078aef6a4b31",
      name: "THX Network",
      symbol: "THX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21323/thumb/logo-thx-resized-200-200.png?1696520690"
    },
    {
      chainId: 1,
      address: "0x66f73d0fd4161cfad4302dc145ff994375c13475",
      name: "DexGame",
      symbol: "DXGM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21084/thumb/dxgm-token.png?1696520466"
    },
    {
      chainId: 1,
      address: "0xe97db8503dd3e3eb0286aafc50327c598efdb578",
      name: "Jinko AI",
      symbol: "JINKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32633/thumb/Jinko_Logo_BY_Colour.png?1698826087"
    },
    {
      chainId: 1,
      address: "0x8db253a1943dddf1af9bcf8706ac9a0ce939d922",
      name: "Unbound Finance",
      symbol: "UNB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21412/thumb/Unbound_icon_png.png?1696520776"
    },
    {
      chainId: 1,
      address: "0x61a35258107563f6b6f102ae25490901c8760b12",
      name: "Kitty Inu",
      symbol: "KITTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19385/thumb/KITTY.png?1696518825"
    },
    {
      chainId: 1,
      address: "0xd52aae39a2b5cc7812f7b9450ebb61dfef702b15",
      name: "MetaBrands",
      symbol: "MAGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21244/thumb/MAGE-CG.png?1696520617"
    },
    {
      chainId: 1,
      address: "0xe2f2a5c287993345a840db3b0845fbc70f5935a5",
      name: "mStable USD",
      symbol: "MUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11576/thumb/mStable_USD.png?1696511474"
    },
    {
      chainId: 1,
      address: "0xda816459f1ab5631232fe5e97a05bbbb94970c95",
      name: "yvDAI",
      symbol: "YVDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28743/thumb/yvdai.png?1696527723"
    },
    {
      chainId: 1,
      address: "0xb5c578947de0fd71303f71f2c3d41767438bd0de",
      name: "DeHorizon",
      symbol: "DEVT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21373/thumb/A3RjDqet_400x400.jpg?1696520738"
    },
    {
      chainId: 1,
      address: "0x9f9c8ec3534c3ce16f928381372bfbfbfb9f4d24",
      name: "GraphLinq Chain",
      symbol: "GLQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14474/thumb/Logo_Dex_4_correct__%282%29.png?1712018526"
    },
    {
      chainId: 1,
      address: "0x3300b02efa180c99a2f61f4731665b51e4e254c4",
      name: "Hitmakr",
      symbol: "HMKR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36660/thumb/HITMAKR_logo.png?1712042884"
    },
    {
      chainId: 1,
      address: "0x34be5b8c30ee4fde069dc878989686abe9884470",
      name: "SENATE",
      symbol: "SENATE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21272/thumb/siIBOmcs.png?1696520643"
    },
    {
      chainId: 1,
      address: "0x8fac8031e079f409135766c7d5de29cf22ef897c",
      name: "Humans ai",
      symbol: "HEART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21273/thumb/h_logo_1x.png?1696520644"
    },
    {
      chainId: 1,
      address: "0x8f081eb884fd47b79536d28e2dd9d4886773f783",
      name: "bePAY Finance",
      symbol: "BECOIN",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/21275/thumb/logo-becoin.png?1696520646"
    },
    {
      chainId: 1,
      address: "0x612e1726435fe38dd49a0b35b4065b56f49c8f11",
      name: "CryptoCart V2",
      symbol: "CCV2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15210/thumb/DP7-T6rox-400x400_%281%29.png?1696514866"
    },
    {
      chainId: 1,
      address: "0xae6e307c3fe9e922e5674dbd7f830ed49c014c6b",
      name: "Credefi",
      symbol: "CREDI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21396/thumb/e1QbZ4qQ_400x400.jpg?1696520760"
    },
    {
      chainId: 1,
      address: "0xa0f0546eb5e3ee7e8cfc5da12e5949f3ae622675",
      name: "Tokoin",
      symbol: "TOKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8807/thumb/TOKOIN_LOGO_%28no_text%29.png?1696508959"
    },
    {
      chainId: 1,
      address: "0xcaabcaa4ca42e1d86de1a201c818639def0ba7a7",
      name: "Talken",
      symbol: "TALK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18146/thumb/4NNLx3BF_400x400.jpg?1696517648"
    },
    {
      chainId: 1,
      address: "0x9657477ac915f56ca87c253db1320218ec2d5ddd",
      name: "Jake Newman Enterprises",
      symbol: "JNE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32565/thumb/image-200x200.jpg?1698546675"
    },
    {
      chainId: 1,
      address: "0x16cc8367055ae7e9157dbcb9d86fd6ce82522b31",
      name: "Voxel X Network",
      symbol: "VXL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21419/thumb/Voxel-Logo-200x200-Transparent.png?1696520783"
    },
    {
      chainId: 1,
      address: "0xd487892bb4c57edbe7ab401d9fe801c8fe6473f5",
      name: "Uhive",
      symbol: "HVE2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3811/thumb/hve2.png?1696504483"
    },
    {
      chainId: 1,
      address: "0x1c4853ec0d55e420002c5efabc7ed8e0ba7a4121",
      name: "Kanagawa Nami",
      symbol: "OKINAMI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26629/thumb/KANAGAWA_%284%29.png?1696525702"
    },
    {
      chainId: 1,
      address: "0x01ba67aac7f75f647d94220cc98fb30fcc5105bf",
      name: "Lyra Finance",
      symbol: "LYRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21490/thumb/Add-a-heading-26.png?1696520850"
    },
    {
      chainId: 1,
      address: "0xa1817b6d8d890f3943b61648992730373b71f156",
      name: "Mongoose",
      symbol: "MONGOOSE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/21456/thumb/61b142508fba4235f29d57eb_Frame_24_%281%29.png?1696520818"
    },
    {
      chainId: 1,
      address: "0x738865301a9b7dd80dc3666dd48cf034ec42bdda",
      name: "Agoras  Currency of Tau",
      symbol: "AGRS",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/399/thumb/agrs.png?1696501692"
    },
    {
      chainId: 1,
      address: "0x111111517e4929d3dcbdfa7cce55d30d4b6bc4d6",
      name: "ICHI",
      symbol: "ICHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13119/thumb/ICHI_%28Round%29.jpg?1696512907"
    },
    {
      chainId: 1,
      address: "0x98585dfc8d9e7d48f0b1ae47ce33332cf4237d96",
      name: "New Order",
      symbol: "NEWO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21440/thumb/new-order-icon-256px.png?1696520803"
    },
    {
      chainId: 1,
      address: "0xdadb4ae5b5d3099dd1f586f990b845f2404a1c4c",
      name: "Lenny Face",
      symbol: "",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29138/thumb/Lenny_Face.png?1696528099"
    },
    {
      chainId: 1,
      address: "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04",
      name: "Coinweb",
      symbol: "CWEB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21607/thumb/Logo_200x200.png?1696520967"
    },
    {
      chainId: 1,
      address: "0x43d4a3cd90ddd2f8f4f693170c9c8098163502ad",
      name: "Prime",
      symbol: "D2D",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21609/thumb/RJD82RrV_400x400.jpg?1696520970"
    },
    {
      chainId: 1,
      address: "0x24fcfc492c1393274b6bcd568ac9e225bec93584",
      name: "Heroes of Mavia",
      symbol: "MAVIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33895/thumb/2023-12-20_21.21.41_%281%29.jpg?1703230771"
    },
    {
      chainId: 1,
      address: "0x7659ce147d0e714454073a5dd7003544234b6aa0",
      name: "XCAD Network",
      symbol: "XCAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15857/thumb/xcad_logo.jpg?1707832192"
    },
    {
      chainId: 1,
      address: "0x590f820444fa3638e022776752c5eef34e2f89a6",
      name: "Alephium",
      symbol: "ALPH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21598/thumb/Alephium-Logo_200x200_listing.png?1696520959"
    },
    {
      chainId: 1,
      address: "0x2f141ce366a2462f02cea3d12cf93e4dca49e4fd",
      name: "FREEdom coin",
      symbol: "FREE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5585/thumb/free.png?1696506051"
    },
    {
      chainId: 1,
      address: "0x78d448a1d1fedaa3e916f467568e86081e0f4df5",
      name: "MetaBET",
      symbol: "MBET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22778/thumb/y5TphxL.jpeg?1696522080"
    },
    {
      chainId: 1,
      address: "0x77777777772cf0455fb38ee0e75f38034dfa50de",
      name: "XY Finance",
      symbol: "XY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21541/thumb/xy.png?1696520900"
    },
    {
      chainId: 1,
      address: "0xf0f9d895aca5c8678f706fb8216fa22957685a13",
      name: "Cult DAO",
      symbol: "CULT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23331/thumb/quxZPrbC_400x400.jpg?1696522547"
    },
    {
      chainId: 1,
      address: "0x900db999074d9277c5da2a43f252d74366230da0",
      name: "Giveth",
      symbol: "GIV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21792/thumb/GIVToken_200x200.png?1696521145"
    },
    {
      chainId: 1,
      address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
      name: "Aave",
      symbol: "AAVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1696512452"
    },
    {
      chainId: 1,
      address: "0x3ab6ed69ef663bd986ee59205ccad8a20f98b4c2",
      name: "Drep",
      symbol: "DREP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14578/thumb/KotgsCgS_400x400.jpg?1696514258"
    },
    {
      chainId: 1,
      address: "0x15874d65e649880c2614e7a480cb7c9a55787ff6",
      name: "EthereumMax",
      symbol: "EMAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15540/thumb/EMAX-Coin-Final2000x.png?1696515181"
    },
    {
      chainId: 1,
      address: "0x90b831fa3bebf58e9744a14d638e25b4ee06f9bc",
      name: "Mimo Governance",
      symbol: "MIMO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16449/thumb/mimodefi.PNG?1696516045"
    },
    {
      chainId: 1,
      address: "0x0000000de40dfa9b17854cbc7869d80f9f98d823",
      name: "delta theta",
      symbol: "DLTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15697/thumb/logo-DT-square.png?1696515325"
    },
    {
      chainId: 1,
      address: "0xe803178b48a0e560c2b19f3b3d4e504f79d229ce",
      name: "Bobcoin",
      symbol: "BOBC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24264/thumb/bobc.png?1696523448"
    },
    {
      chainId: 1,
      address: "0x7237c0b30b1355f1b76355582f182f6f04b08740",
      name: "MetaGaming Guild",
      symbol: "MGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23287/thumb/mgg.png?1696522506"
    },
    {
      chainId: 1,
      address: "0xfe38fd8d710b0ad367f60cb9fc4de5e7ba95633b",
      name: "Lena",
      symbol: "LENA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34900/thumb/lena.jpeg?1706583908"
    },
    {
      chainId: 1,
      address: "0x19af07b52e5faa0c2b1e11721c52aa23172fe2f5",
      name: "Memes Street",
      symbol: "MEMES",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33604/thumb/Meme_St.png?1702510836"
    },
    {
      chainId: 1,
      address: "0xa5f1dbb0e55bc31f32c6d032bee330288490e722",
      name: "Day By Day",
      symbol: "DBD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21691/thumb/DBD-icon_200x200_%281%29.png?1696521046"
    },
    {
      chainId: 1,
      address: "0x383518188c0c6d7730d91b2c03a03c837814a899",
      name: "Olympus v1",
      symbol: "OHM",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/21496/thumb/OHM.jpg?1696520856"
    },
    {
      chainId: 1,
      address: "0x0a6e18fb2842855c3af925310b0f50a4bfa17909",
      name: "CoinPoker",
      symbol: "CHP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1808/thumb/coinpoker.jpg?1696502810"
    },
    {
      chainId: 1,
      address: "0xda7c0810ce6f8329786160bb3d1734cf6661ca6e",
      name: "Jaypeggers",
      symbol: "JAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30074/thumb/jay.jpg?1696528999"
    },
    {
      chainId: 1,
      address: "0xc73abe8d7a0da644743fe2ad24f4e16bb7ed43f8",
      name: "Website AI",
      symbol: "WEBAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32463/thumb/200x200.png?1698242478"
    },
    {
      chainId: 1,
      address: "0x4cd0c43b0d53bc318cc5342b77eb6f124e47f526",
      name: "FreeRossDAO",
      symbol: "FREE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21648/thumb/free.jpg?1696521006"
    },
    {
      chainId: 1,
      address: "0x4b1d0b9f081468d780ca1d5d79132b64301085d1",
      name: "Lumerin",
      symbol: "LMR",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/24593/thumb/Lumerin-icon.png?1696523767"
    },
    {
      chainId: 1,
      address: "0x162bb2bb5fb03976a69dd25bb9afce6140db1433",
      name: "dog",
      symbol: "DOG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32464/thumb/200.png?1698242675"
    },
    {
      chainId: 1,
      address: "0xd15a1a2a3211b58113e45809f05934252e34e2f8",
      name: "Woozoo Music",
      symbol: "WZM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21891/thumb/logo_200_200_%281%29.png?1696521244"
    },
    {
      chainId: 1,
      address: "0x08d32b0da63e2c3bcf8019c9c5d849d7a9d791e6",
      name: "Dentacoin",
      symbol: "DCN",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/850/thumb/dentacoin.png?1696501986"
    },
    {
      chainId: 1,
      address: "0xa3c519683010d59fa54a4a6c4cac0f55cb20bb3f",
      name: "BetIT",
      symbol: "BETIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33126/thumb/output-onlinepngtools_%281%29.png?1700795370"
    },
    {
      chainId: 1,
      address: "0xe5097d9baeafb89f9bcb78c9290d545db5f9e9cb",
      name: "Hummingbot",
      symbol: "HBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21717/thumb/PDPuf0tJ_400x400.jpg?1696521072"
    },
    {
      chainId: 1,
      address: "0x470ebf5f030ed85fc1ed4c2d36b9dd02e77cf1b7",
      name: "TempleDAO",
      symbol: "TEMPLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20040/thumb/LPK15ZOW_400x400.jpg?1696519459"
    },
    {
      chainId: 1,
      address: "0x7717f2828fe4dac8558d23ee4cdfed9544e9321f",
      name: "OTX EXCHANGE",
      symbol: "OTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33128/thumb/otx_logo.jpg?1700795823"
    },
    {
      chainId: 1,
      address: "0x47b9f01b16e9c9cb99191dca68c9cc5bf6403957",
      name: "Onston",
      symbol: "ONSTON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20669/thumb/onston.PNG?1696520070"
    },
    {
      chainId: 1,
      address: "0x1fbd3df007eb8a7477a1eab2c63483dcc24effd6",
      name: "Scaleswap",
      symbol: "SCA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16360/thumb/thumbnail_1170823958_vertical_logo_lateral_radiance.png?1696515959"
    },
    {
      chainId: 1,
      address: "0xb113c6cf239f60d380359b762e95c13817275277",
      name: "BitMEX",
      symbol: "BMEX",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/21831/thumb/bitmex-token.jpeg?1696521187"
    },
    {
      chainId: 1,
      address: "0xa20f77b7ad5a88badc48800c56507b7274c06fdc",
      name: "Cherry Network",
      symbol: "CHER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21855/thumb/cherry.PNG?1696521209"
    },
    {
      chainId: 1,
      address: "0x3085154623f51b00dedfc6ceeb5197277a66b17b",
      name: "NFTY DeFi Protocol",
      symbol: "NFTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18584/thumb/nfty_logo.png?1696518060"
    },
    {
      chainId: 1,
      address: "0x888888888889c00c67689029d7856aac1065ec11",
      name: "Opium",
      symbol: "OPIUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13758/thumb/opium-token-black_%281%29.png?1696513500"
    },
    {
      chainId: 1,
      address: "0x4daeb4a06f70f4b1a5c329115731fe4b89c0b227",
      name: "Quasacoin",
      symbol: "QUA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21965/thumb/coin_200.png?1696521314"
    },
    {
      chainId: 1,
      address: "0x80c8c3dcfb854f9542567c8dac3f44d709ebc1de",
      name: "Spaceswap MILK2",
      symbol: "MILK2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12771/thumb/milk.png?1696512567"
    },
    {
      chainId: 1,
      address: "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
      name: "CEEK Smart VR",
      symbol: "CEEK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2581/thumb/ceek-smart-vr-token-logo.png?1696503385"
    },
    {
      chainId: 1,
      address: "0x6f2dec5da475333b0af4a3ffc9a33b0211a9a452",
      name: "CryptoTwitter",
      symbol: "CT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30237/thumb/200x200px.png?1696529147"
    },
    {
      chainId: 1,
      address: "0x0000000005c6b7c1fd10915a05f034f90d524d6e",
      name: "TRYC",
      symbol: "TRYC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/21985/thumb/16357.png?1696521333"
    },
    {
      chainId: 1,
      address: "0x9669890e48f330acd88b78d63e1a6b3482652cd9",
      name: "Bincentive",
      symbol: "BCNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9661/thumb/bcnt.png?1696509729"
    },
    {
      chainId: 1,
      address: "0xf61bf4d1a948487d61b8fa63808aac06bda55f98",
      name: "Tr3zor",
      symbol: "TR3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21980/thumb/9T9OoYXE_400x400.jpg?1696521328"
    },
    {
      chainId: 1,
      address: "0x9fc8f0ca1668e87294941b7f627e9c15ea06b459",
      name: "True PNL",
      symbol: "PNL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15282/thumb/256x256logo.png?1696514933"
    },
    {
      chainId: 1,
      address: "0xe6602b34d8510b033e000975b3322537c7172441",
      name: "Frontrow",
      symbol: "FRR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21658/thumb/uZsO4yI7_400x400.jpg?1696521016"
    },
    {
      chainId: 1,
      address: "0x6006fc2a849fedaba8330ce36f5133de01f96189",
      name: "Spaceswap SHAKE",
      symbol: "SHAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12765/thumb/shake.png?1696512562"
    },
    {
      chainId: 1,
      address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
      name: "Gnosis",
      symbol: "GNO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/662/thumb/logo_square_simple_300px.png?1696501854"
    },
    {
      chainId: 1,
      address: "0x9b83f827928abdf18cf1f7e67053572b9bceff3a",
      name: "Artem",
      symbol: "ARTEM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21998/thumb/ARTM_Logo_MAIN_%281%29.png?1696521345"
    },
    {
      chainId: 1,
      address: "0x69b14e8d3cebfdd8196bfe530954a0c226e5008e",
      name: "SpacePi Token",
      symbol: "SPACEPI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35375/thumb/logo200.png?1708415311"
    },
    {
      chainId: 1,
      address: "0xcd4ee6c8052df6742e4b342cf720ff3ac74f415e",
      name: "StellaryAI",
      symbol: "STELAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36170/thumb/200x200.png?1710746923"
    },
    {
      chainId: 1,
      address: "0x84342e932797fc62814189f01f0fb05f52519708",
      name: "Neighbourhoods",
      symbol: "NHT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22055/thumb/social_media_logo_black_bg.png?1696521399"
    },
    {
      chainId: 1,
      address: "0x6bba316c48b49bd1eac44573c5c871ff02958469",
      name: "Gas DAO",
      symbol: "GAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22086/thumb/SjrgK6sf_400x400.jpg?1696521429"
    },
    {
      chainId: 1,
      address: "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
      name: "PARSIQ",
      symbol: "PRQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11973/thumb/DsNgK0O.png?1696511831"
    },
    {
      chainId: 1,
      address: "0x8254e26e453eb5abd29b3c37ac9e8da32e5d3299",
      name: "RBX",
      symbol: "RBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19253/thumb/output-onlinepngtools-9.png?1696518698"
    },
    {
      chainId: 1,
      address: "0x3e5d9d8a63cc8a88748f229999cf59487e90721e",
      name: "MetalSwap",
      symbol: "XMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22075/thumb/Logo_COIN_-_Gradiente.png?1696521419"
    },
    {
      chainId: 1,
      address: "0xe857734840dc188b4283d5af14ab8685467ab87d",
      name: "ESG Chain",
      symbol: "ESGC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22085/thumb/logo-01.png?1696521428"
    },
    {
      chainId: 1,
      address: "0x65ef703f5594d2573eb71aaf55bc0cb548492df4",
      name: "Multichain",
      symbol: "MULTI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22087/thumb/1_Wyot-SDGZuxbjdkaOeT2-A.png?1696521430"
    },
    {
      chainId: 1,
      address: "0x5dd0d493ea59d512efc13d5c1f9d325775192877",
      name: "Pusuke Inu",
      symbol: "PUSUKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28674/thumb/Pusuke_Inu.jpg?1696527658"
    },
    {
      chainId: 1,
      address: "0xb755d5bc7de83232b9df1886bd5cdb38895933b0",
      name: "hiMFERS",
      symbol: "HIMFERS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28719/thumb/hiMFERs.png?1696527700"
    },
    {
      chainId: 1,
      address: "0xdd2e93924bdd4e20c3cf4a8736e5955224fa450e",
      name: "Foho Coin",
      symbol: "FOHO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17933/thumb/FOHO.Coin_colour-02-1.png?1696517454"
    },
    {
      chainId: 1,
      address: "0x7ddc52c4de30e94be3a6a0a2b259b2850f421989",
      name: "Gomining Token",
      symbol: "GOMINING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15662/thumb/GoMining_Logo.png?1714757256"
    },
    {
      chainId: 1,
      address: "0x0f7f961648ae6db43c75663ac7e5414eb79b5704",
      name: "Blockzero Labs",
      symbol: "XIO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10029/thumb/blockzero.jpg?1696510062"
    },
    {
      chainId: 1,
      address: "0xda16cf041e2780618c49dbae5d734b89a6bac9b3",
      name: "Betswap gg",
      symbol: "BSGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22496/thumb/BSGG_Token_Updated.png?1706248804"
    },
    {
      chainId: 1,
      address: "0x2a69655c22eda32ff48d315bb26ed45f150700b4",
      name: "StakerDAO Wrapped Tezos",
      symbol: "WXTZ",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/14763/thumb/wXTZ-token-FullColor.png?1696514432"
    },
    {
      chainId: 1,
      address: "0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d",
      name: "Fuse",
      symbol: "FUSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10347/thumb/fuse.png?1696510348"
    },
    {
      chainId: 1,
      address: "0x43ab765ee05075d78ad8aa79dcb1978ca3079258",
      name: "POW",
      symbol: "POW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22333/thumb/16963.png?1696521677"
    },
    {
      chainId: 1,
      address: "0x7f3141c4d6b047fb930991b450f1ed996a51cb26",
      name: "X",
      symbol: "X",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22334/thumb/x.PNG?1696521678"
    },
    {
      chainId: 1,
      address: "0x28dee01d53fed0edf5f6e310bf8ef9311513ae40",
      name: "BlitzPick",
      symbol: "XBP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2458/thumb/BlitzPredict.jpg?1696503288"
    },
    {
      chainId: 1,
      address: "0xf1b99e3e573a1a9c5e6b2ce818b617f0e664e86b",
      name: "Opyn Squeeth",
      symbol: "OSQTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22806/thumb/DyVT5XPV_400x400.jpg?1696522108"
    },
    {
      chainId: 1,
      address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
      name: "ForTube",
      symbol: "FOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8242/thumb/for.png?1606195375"
    },
    {
      chainId: 1,
      address: "0xde4ce5447ce0c67920a1371605a39187cb6847c8",
      name: "Deesse",
      symbol: "LOVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22524/thumb/GaqpKHEP_400x400.jpg?1696521847"
    },
    {
      chainId: 1,
      address: "0xd7d8f3b8bc8bc48d3acc37879eaba7b85889fa52",
      name: "ClearDAO",
      symbol: "CLH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22389/thumb/clh_small_logo_png.png?1696521733"
    },
    {
      chainId: 1,
      address: "0xa15865d9de09cb96aaa3a9081b3dfc8481f07d33",
      name: "PopeCoin",
      symbol: "POPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30239/thumb/photo_2023-05-01_11.25.54.jpeg?1696529149"
    },
    {
      chainId: 1,
      address: "0x6602e9319f2c5ec0ba31ffcdc4301d7ef03b709e",
      name: "Wrapped OrdBridge",
      symbol: "WBRGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33682/thumb/ologo.jpg?1702719798"
    },
    {
      chainId: 1,
      address: "0x5ba19d656b65f1684cfea4af428c23b9f3628f97",
      name: "AAG",
      symbol: "AAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21382/thumb/aag-token-icon.png?1696520747"
    },
    {
      chainId: 1,
      address: "0x69d9905b2e5f6f5433212b7f3c954433f23c1572",
      name: "Onooks",
      symbol: "OOKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16281/thumb/onooks-logo.png?1696515879"
    },
    {
      chainId: 1,
      address: "0x3d0293f06daf4311b482564330d57c8db6c10893",
      name: "Y Coin",
      symbol: "YCO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/14128/thumb/BIG-POTAT-200x200-removebg-preview.png?1696513849"
    },
    {
      chainId: 1,
      address: "0xe138fda441fc31b36171122397a8a11d6cd2c479",
      name: "Global Trust Coin",
      symbol: "GTC",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/7752/thumb/gtib.png?1696507996"
    },
    {
      chainId: 1,
      address: "0x60f5672a271c7e39e787427a18353ba59a4a3578",
      name: "Pika",
      symbol: "PIKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14419/thumb/pika-logo-2022-nbg.png?1696514110"
    },
    {
      chainId: 1,
      address: "0x72e364f2abdc788b7e918bc238b21f109cd634d7",
      name: "Metaverse Index",
      symbol: "MVI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14684/thumb/MVI_logo.png?1696514357"
    },
    {
      chainId: 1,
      address: "0xa67e9f021b9d208f7e3365b2a155e3c55b27de71",
      name: "KleeKai",
      symbol: "KLEE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15548/thumb/Klee-Kai-Logo.png?1696515189"
    },
    {
      chainId: 1,
      address: "0x52f4d5ee6c91e01be67ca1f64b11ed0ee370817d",
      name: "CIA",
      symbol: "CIA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/21569/thumb/Untitled-design-24.png?1696520929"
    },
    {
      chainId: 1,
      address: "0xb3cb8d5aeff0f4d1f432f353309f47b885e404e3",
      name: "MEVerse",
      symbol: "MEV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24566/thumb/0sp1DWVw_400x400.png?1696523742"
    },
    {
      chainId: 1,
      address: "0x95e05e2abbd26943874ac000d87c3d9e115b543c",
      name: "Raptor",
      symbol: "BIBLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30866/thumb/bible_logo.png?1696529713"
    },
    {
      chainId: 1,
      address: "0x9c32185b81766a051e08de671207b34466dd1021",
      name: "BTC Proxy",
      symbol: "BTCPX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/22630/thumb/MB1aYO7T_400x400.jpg?1696521945"
    },
    {
      chainId: 1,
      address: "0x2f4404c4012476929b6503e1397707480bf23b7f",
      name: "AITravis",
      symbol: "TAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28933/thumb/ava_%283%29.png?1696527907"
    },
    {
      chainId: 1,
      address: "0x375abb85c329753b1ba849a601438ae77eec9893",
      name: "ParagonsDAO",
      symbol: "PDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22642/thumb/PDT_LOGO_200.jpg?1696521956"
    },
    {
      chainId: 1,
      address: "0xb131f337c45d386ceec234e194b2663d5c3d9dcf",
      name: "iCommunity",
      symbol: "ICOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23667/thumb/logo-icommunity.png?1696522869"
    },
    {
      chainId: 1,
      address: "0x39207d2e2feef178fbda8083914554c59d9f8c00",
      name: "MultiPlanetary Inus",
      symbol: "INUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22648/thumb/logo.png?1696521961"
    },
    {
      chainId: 1,
      address: "0x1f31dd60b84ea2a273cfc56876437e069ae80afd",
      name: "Shinji Inu",
      symbol: "SHINJI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/22846/thumb/Attachment_1645539736.png?1696522147"
    },
    {
      chainId: 1,
      address: "0x869dbe51dc214fcb663604b0f7b548592f8c71f5",
      name: "Okidoki Social",
      symbol: "DOKI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27018/thumb/Okidoki_Logo.png?1696526070"
    },
    {
      chainId: 1,
      address: "0x2af1df3ab0ab157e1e2ad8f88a7d04fbea0c7dc6",
      name: "Bankless BED Index",
      symbol: "BED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17175/thumb/BED_Logo_-_No_border.png?1696516734"
    },
    {
      chainId: 1,
      address: "0x64df3aab3b21cc275bb76c4a581cf8b726478ee0",
      name: "Cramer Coin",
      symbol: "CRAMER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27463/thumb/cramercoin.jpg?1696526502"
    },
    {
      chainId: 1,
      address: "0x85f6eb2bd5a062f5f8560be93fb7147e16c81472",
      name: "Franklin",
      symbol: "FLY",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/14810/thumb/fly_logo_sq_bArtboard_4.png?1696514479"
    },
    {
      chainId: 1,
      address: "0x968cbe62c830a0ccf4381614662398505657a2a9",
      name: "Thrupenny",
      symbol: "TPY",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/26799/thumb/rsz_1mpmojfho_400x400.png?1696525861"
    },
    {
      chainId: 1,
      address: "0x5b71bee9d961b1b848f8485eec8d8787f80217f5",
      name: "Bitforex",
      symbol: "BF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5330/thumb/BitForex-Logo.png?1696505825"
    },
    {
      chainId: 1,
      address: "0x5d74468b69073f809d4fae90afec439e69bf6263",
      name: "ClayStack Staked ETH",
      symbol: "CSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33205/thumb/csETH-coingecko.png?1701080702"
    },
    {
      chainId: 1,
      address: "0x58f7345b5295e43aa454911571f13be186655be9",
      name: "Garlicoin",
      symbol: "GRLC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2699/thumb/garlicoin.png?1696503483"
    },
    {
      chainId: 1,
      address: "0xc9b6a17ebb43491635f603a01f8bb3e4b5d22228",
      name: "MAGA Coin ETH",
      symbol: "MAGA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27455/thumb/rsz_jimerkya_400x400.png?1696526495"
    },
    {
      chainId: 1,
      address: "0x80ce3027a70e0a928d9268994e9b85d03bd4cdcf",
      name: "Lokr",
      symbol: "LKR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14692/thumb/lokr.png?1696514364"
    },
    {
      chainId: 1,
      address: "0x3e828ac5c480069d4765654fb4b8733b910b13b2",
      name: "Colony Network",
      symbol: "CLNY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23269/thumb/Logo.png?1696522489"
    },
    {
      chainId: 1,
      address: "0x3541a5c1b04adaba0b83f161747815cd7b1516bc",
      name: "CitaDAO",
      symbol: "KNIGHT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22848/thumb/KNIGHT_TOKEN_LOGO.png?1696522149"
    },
    {
      chainId: 1,
      address: "0x20d4db1946859e2adb0e5acc2eac58047ad41395",
      name: "Moon DAO",
      symbol: "MOONEY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22905/thumb/cVWTHdA.png?1696522202"
    },
    {
      chainId: 1,
      address: "0x41a3dba3d677e573636ba691a70ff2d606c29666",
      name: "BlockWallet",
      symbol: "BLANK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14209/thumb/Group_121417608.png?1696513925"
    },
    {
      chainId: 1,
      address: "0x64bc2ca1be492be7185faa2c8835d9b824c8a194",
      name: "Big Time",
      symbol: "BIGTIME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32251/thumb/-6136155493475923781_121.jpg?1696998691"
    },
    {
      chainId: 1,
      address: "0xa849eaae994fb86afa73382e9bd88c2b6b18dc71",
      name: "MVL",
      symbol: "MVL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3476/thumb/CoinGecko.png?1711620384"
    },
    {
      chainId: 1,
      address: "0xbe9ab37a414c517b2be2bfa5945665bb07379054",
      name: "TomTomCoin",
      symbol: "TOMS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22864/thumb/toms_logo_200.png?1696522164"
    },
    {
      chainId: 1,
      address: "0xc9fe6e1c76210be83dc1b5b20ec7fd010b0b1d15",
      name: "Fringe Finance",
      symbol: "FRIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13222/thumb/frin.png?1696513001"
    },
    {
      chainId: 1,
      address: "0x7ab7d54f8cb054141142f04ba0b3d41ac4c4d61c",
      name: "NOTHING",
      symbol: "NOTHING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33931/thumb/IMG_7800.jpeg?1703418739"
    },
    {
      chainId: 1,
      address: "0x721a1b990699ee9d90b6327faad0a3e840ae8335",
      name: "Lootex",
      symbol: "LOOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22895/thumb/loot.png?1696522192"
    },
    {
      chainId: 1,
      address: "0x2af72850c504ddd3c1876c66a914caee7ff8a46a",
      name: "WhaleRoom",
      symbol: "WHL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14328/thumb/ArEX8tkV_400x400.png?1696514016"
    },
    {
      chainId: 1,
      address: "0xb90cb79b72eb10c39cbdf86e50b1c89f6a235f2e",
      name: "Auditchain",
      symbol: "AUDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6398/thumb/auditchain.png?1696506764"
    },
    {
      chainId: 1,
      address: "0xd16fd95d949f996e3808eeea0e3881c59e76ef1e",
      name: "Para",
      symbol: "PARA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24652/thumb/para.jpg?1696523821"
    },
    {
      chainId: 1,
      address: "0x888888435fde8e7d4c54cab67f206e4199454c60",
      name: "DFX Finance",
      symbol: "DFX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14091/thumb/DFX.png?1696513813"
    },
    {
      chainId: 1,
      address: "0xd94a8f9caed25e63ecc90edfefaf3635ea1e182a",
      name: "Stablecomp",
      symbol: "SCOMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33932/thumb/token-icon-big.png?1703422228"
    },
    {
      chainId: 1,
      address: "0xc383a3833a87009fd9597f8184979af5edfad019",
      name: "iETH v1",
      symbol: "IETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25822/thumb/iETH_100x100.png?1696524907"
    },
    {
      chainId: 1,
      address: "0x429881672b9ae42b8eba0e26cd9c73711b891ca5",
      name: "Pickle Finance",
      symbol: "PICKLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12435/thumb/0M4W6Yr6_400x400.jpg?1696512255"
    },
    {
      chainId: 1,
      address: "0x5d843fa9495d23de997c394296ac7b4d721e841c",
      name: "Relay Chain",
      symbol: "RELAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17816/thumb/relay-logo-200.png?1696517336"
    },
    {
      chainId: 1,
      address: "0x33840024177a7daca3468912363bed8b425015c5",
      name: "Ebox",
      symbol: "EBOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14528/thumb/ebox.png?1696514213"
    },
    {
      chainId: 1,
      address: "0x508b27902c6c14972a10a4e413b9cfa449e9cedb",
      name: "AISignal",
      symbol: "AISIG",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33671/thumb/IMG_20231214_221614_575.png?1702701782"
    },
    {
      chainId: 1,
      address: "0xc631120155621ee625835ec810b9885cdd764cd6",
      name: "Goldex",
      symbol: "GLDX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17814/thumb/gldx-logo-200x200.png?1696517334"
    },
    {
      chainId: 1,
      address: "0x8a40c222996f9f3431f63bf80244c36822060f12",
      name: "FINXFLO",
      symbol: "FXF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13916/thumb/raVh1Iw.png?1696513657"
    },
    {
      chainId: 1,
      address: "0x9c6666d5ff4b53b5eb3bd866664c15d0bfcecaa7",
      name: "Edoverse Zeni",
      symbol: "ZENI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29238/thumb/Edoverse_Logo.png?1696528195"
    },
    {
      chainId: 1,
      address: "0x3c9d6c1c73b31c837832c72e04d3152f051fc1a9",
      name: "BoringDAO  OLD ",
      symbol: "BOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12917/thumb/bor_logo.png?1696512705"
    },
    {
      chainId: 1,
      address: "0xcdf7028ceab81fa0c6971208e83fa7872994bee5",
      name: "Threshold Network",
      symbol: "T",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22228/thumb/nFPNiSbL_400x400.jpg?1696521570"
    },
    {
      chainId: 1,
      address: "0x4e352cf164e64adcbad318c3a1e222e9eba4ce42",
      name: "MUX Protocol",
      symbol: "MCB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11796/thumb/mux.jpg?1696511672"
    },
    {
      chainId: 1,
      address: "0x3a0b022f32b3191d44e5847da12dc0b63fb07c91",
      name: "Spellfire",
      symbol: "SPELLFIRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23107/thumb/17316.png?1696522396"
    },
    {
      chainId: 1,
      address: "0xc8d3dcb63c38607cb0c9d3f55e8ecce628a01c36",
      name: "Matrix Labs",
      symbol: "MATRIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18297/thumb/matrixlabs.png?1696517789"
    },
    {
      chainId: 1,
      address: "0xade6fdaba1643e4d1eef68da7170f234470938c6",
      name: "Harambe",
      symbol: "HARAMBE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23489/thumb/unnamed.jpg?1696522699"
    },
    {
      chainId: 1,
      address: "0xbe56ab825fd35678a32dc35bc4eb17e238e1404f",
      name: "Digits DAO",
      symbol: "DIGITS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23551/thumb/Logo-Digits-DAO-Icon-01.jpg?1696522758"
    },
    {
      chainId: 1,
      address: "0x88800092ff476844f74dc2fc427974bbee2794ae",
      name: "Ambire Wallet",
      symbol: "WALLET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23154/thumb/wallet.PNG?1696522445"
    },
    {
      chainId: 1,
      address: "0xfeef77d3f69374f66429c91d732a244f074bdf74",
      name: "Convex FXS",
      symbol: "CVXFXS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29001/thumb/cvxfxs.png?1696527973"
    },
    {
      chainId: 1,
      address: "0xe9e07fb66976ae5e40cc5f33674725320917b239",
      name: "Target Protocol",
      symbol: "TARGET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36286/thumb/dext-icon.png?1711008303"
    },
    {
      chainId: 1,
      address: "0x3231cb76718cdef2155fc47b5286d82e6eda273f",
      name: "Monerium EUR emoney",
      symbol: "EURE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23354/thumb/eur.png?1696522569"
    },
    {
      chainId: 1,
      address: "0xb624fde1a972b1c89ec1dad691442d5e8e891469",
      name: "SporkDAO",
      symbol: "SPORK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23358/thumb/sporkdao.PNG?1696522573"
    },
    {
      chainId: 1,
      address: "0x09395a2a58db45db0da254c7eaa5ac469d8bdc85",
      name: "SubQuery Network",
      symbol: "SQT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23359/thumb/photo_2021-07-14_11-31-12.jpg?1696522574"
    },
    {
      chainId: 1,
      address: "0x5c1d9aa868a30795f92fae903edc9eff269044bf",
      name: "Changer",
      symbol: "CNG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21786/thumb/cng.png?1696521140"
    },
    {
      chainId: 1,
      address: "0x433fce7dfbec729a79999eaf056cb073b2153eba",
      name: "CoinWealth",
      symbol: "CNW",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/23769/thumb/cw_logo-4955f59a5c8079f246fa07ac71b2541870ca7d906ca1d9c26d74a3870fafef2f_%281%29.png?1696522970"
    },
    {
      chainId: 1,
      address: "0x59d1e836f7b7210a978b25a855085cc46fd090b5",
      name: "AssangeDAO",
      symbol: "JUSTICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23555/thumb/JUSTICE_token_logo.png?1696522761"
    },
    {
      chainId: 1,
      address: "0x00281dfce4cfd72c0b6fda2aaaf077258743f9e8",
      name: "NuriFootBall",
      symbol: "NRFB",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/23360/thumb/pcMlP25e_400x400.jpg?1696522575"
    },
    {
      chainId: 1,
      address: "0xcb56b52316041a62b6b5d0583dce4a8ae7a3c629",
      name: "Cigarette",
      symbol: "CIG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22145/thumb/logo200.png?1696521491"
    },
    {
      chainId: 1,
      address: "0x817bbdbc3e8a1204f3691d14bb44992841e3db35",
      name: "Cudos",
      symbol: "CUDOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13651/thumb/CudosIconTransparent.png?1696513400"
    },
    {
      chainId: 1,
      address: "0xc91a71a1ffa3d8b22ba615ba1b9c01b2bbbf55ad",
      name: "ZigZag",
      symbol: "ZZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26141/thumb/zig_zag.?1696525229"
    },
    {
      chainId: 1,
      address: "0xeeaa40b28a2d1b0b08f6f97bb1dd4b75316c6107",
      name: "CVI",
      symbol: "GOVI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13875/thumb/GOVI.png?1696513619"
    },
    {
      chainId: 1,
      address: "0x4f640f2529ee0cf119a2881485845fa8e61a782a",
      name: "ORE Network",
      symbol: "ORE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18917/thumb/ORE_FullColor.png?1696518374"
    },
    {
      chainId: 1,
      address: "0xe4b91faf8810f8895772e7ca065d4cb889120f94",
      name: "Cat in a Box Fee Token",
      symbol: "BOXFEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29928/thumb/boxFEE.png?1696528856"
    },
    {
      chainId: 1,
      address: "0x67c5870b4a41d4ebef24d2456547a03f1f3e094b",
      name: "GoodDollar",
      symbol: "G",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/14782/thumb/G__Coin_%281%29.png?1696514451"
    },
    {
      chainId: 1,
      address: "0x63a0db25159672326ac8fbf512c409598801b145",
      name: "XPayPro Tech",
      symbol: "XPPT",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/33306/thumb/cg-xpay-logo.png?1701404908"
    },
    {
      chainId: 1,
      address: "0xc502002aeb1b9309fccb016adf50507987fc6c2b",
      name: "GNFT",
      symbol: "GNFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23532/thumb/gnft_200x200.png?1696522740"
    },
    {
      chainId: 1,
      address: "0x94e9eb8b5ab9fd6b9ea3169d55ffade62a01702e",
      name: "BreederDAO",
      symbol: "BREED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25203/thumb/BreederDAO-Breed_Token-FINAL.png?1696524347"
    },
    {
      chainId: 1,
      address: "0x70c4430f9d98b4184a4ef3e44ce10c320a8b7383",
      name: "Gyroscope",
      symbol: "GYFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23584/thumb/Gyroscope_logo_transparent.png?1696522792"
    },
    {
      chainId: 1,
      address: "0x0bf43350076f95e0d16120b4d6bdfa1c9d50bdbd",
      name: "Antfarm Governance Token",
      symbol: "AGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28822/thumb/AGT.png?1696527798"
    },
    {
      chainId: 1,
      address: "0x77d9046ee15faaceb89439ffdde4be071c2f07bd",
      name: "Jiyuu",
      symbol: "JIYUU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28907/thumb/logo_200.png?1696527883"
    },
    {
      chainId: 1,
      address: "0x1982b2f5814301d4e9a8b0201555376e62f82428",
      name: "Aave Interest Bearing STETH",
      symbol: "ASTETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24163/thumb/steth.jpg?1696523352"
    },
    {
      chainId: 1,
      address: "0xa3ee21c306a700e682abcdfe9baa6a08f3820419",
      name: "Creditcoin",
      symbol: "CTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10569/thumb/ctc.png?1696510552"
    },
    {
      chainId: 1,
      address: "0xa2b4c0af19cc16a6cfacce81f192b024d625817d",
      name: "Kishu Inu",
      symbol: "KISHU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/14890/thumb/uVLzCoP.png?1696514553"
    },
    {
      chainId: 1,
      address: "0x5c147e74d63b1d31aa3fd78eb229b65161983b2b",
      name: "Wrapped Flow",
      symbol: "WFLOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24045/thumb/wrapped-flow.png?1696523236"
    },
    {
      chainId: 1,
      address: "0xc98d64da73a6616c42117b582e832812e7b8d57f",
      name: "RSS3",
      symbol: "RSS3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23575/thumb/RSS3.png?1696522783"
    },
    {
      chainId: 1,
      address: "0xc690f7c7fcffa6a82b79fab7508c466fefdfc8c5",
      name: "Lympo",
      symbol: "LYM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2620/thumb/lympo_token.png?1696503417"
    },
    {
      chainId: 1,
      address: "0x865377367054516e17014ccded1e7d814edc9ce4",
      name: "DOLA",
      symbol: "DOLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14287/thumb/dola.png?1696513984"
    },
    {
      chainId: 1,
      address: "0x24a5fe2c2240e58252cdfc43bb94ae67d2ead218",
      name: "Mone Coin",
      symbol: "MONE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35310/thumb/photo_2024-02-08_23-06-34.jpg?1708158583"
    },
    {
      chainId: 1,
      address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
      name: "Dego Finance",
      symbol: "DEGO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12503/thumb/c185FKx.png?1696512318"
    },
    {
      chainId: 1,
      address: "0x1e4ede388cbc9f4b5c79681b7f94d36a11abebc9",
      name: "X2Y2",
      symbol: "X2Y2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23633/thumb/logo-60b81ff87b40b11739105acf5ad1e075.png?1696522837"
    },
    {
      chainId: 1,
      address: "0x37e83a94c6b1bdb816b59ac71dd02cf154d8111f",
      name: "PhotoChromic",
      symbol: "PHCR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23640/thumb/L7vabJibqXHHmGtsIfIEQRaR3SjaE94QSaKWGlqYU7fpuz--nKsWG4BlB6Ddhn5-tGPWo-MDhfZPVAYG7ZM2vpWrVZlSx1Euw78tZcNey6FvpKX6a8w26qBWYeV7wxFzvW7VKieijrMXQ0BkISpt8d6jrCMBvx2ZFKVxF1x31_2X7WhRyqAgIG3epFPNz7v0j0ECaS7HmE0_sTHM4RS3CW1d0a.jpg?1696522844"
    },
    {
      chainId: 1,
      address: "0x6e9730ecffbed43fd876a264c982e254ef05a0de",
      name: "Nord Finance",
      symbol: "NORD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13630/thumb/nord.jpg?1696513378"
    },
    {
      chainId: 1,
      address: "0xdac657ffd44a3b9d8aba8749830bf14beb66ff2d",
      name: "humanDAO",
      symbol: "HDAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21138/thumb/Untitled-2.jpg?1696520516"
    },
    {
      chainId: 1,
      address: "0xa6422e3e219ee6d4c1b18895275fe43556fd50ed",
      name: "Stobox",
      symbol: "STBU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12637/thumb/123456826.png?1696512445"
    },
    {
      chainId: 1,
      address: "0x8de43c9c1cd0a039b945b388f7b038b51f949baf",
      name: "MoonCloud ai",
      symbol: "MCLOUD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36988/thumb/coingecko.jpg?1712947838"
    },
    {
      chainId: 1,
      address: "0xa350da05405cc204e551c4eed19c3039646528d5",
      name: "Blocksport",
      symbol: "BSPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23735/thumb/logo_icon.jpg?1696522938"
    },
    {
      chainId: 1,
      address: "0x95b4ef2869ebd94beb4eee400a99824bf5dc325b",
      name: "cMKR",
      symbol: "CMKR",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17528/thumb/cmkr.PNG?1696517066"
    },
    {
      chainId: 1,
      address: "0x7e6f60e237c34307d516ef80218c2b04bccbca40",
      name: "Trackr",
      symbol: "TRACKR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34433/thumb/photo_2024-01-09_15-28-29_%282%29.jpg?1704869068"
    },
    {
      chainId: 1,
      address: "0x8eedefe828a0f16c8fc80e46a87bc0f1de2d960c",
      name: "DigiMetaverse",
      symbol: "DGMV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23701/thumb/DigiCorpLabs_token.png?1696522902"
    },
    {
      chainId: 1,
      address: "0x3fa729b4548becbad4eab6ef18413470e6d5324c",
      name: "Mover",
      symbol: "MOVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13719/thumb/o0KIvs7T_400x400.jpg?1696513464"
    },
    {
      chainId: 1,
      address: "0xfe459828c90c0ba4bc8b42f5c5d44f316700b430",
      name: "BBS Network",
      symbol: "BBS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23715/thumb/Ni13Pg1K_400x400.jpg?1696522915"
    },
    {
      chainId: 1,
      address: "0xba6b0dbb2ba8daa8f5d6817946393aef8d3a4487",
      name: "Hillstone Finance",
      symbol: "HSF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22335/thumb/logo_-_2022-01-07T094430.368.png?1696521679"
    },
    {
      chainId: 1,
      address: "0x0bb217e40f8a5cb79adf04e1aab60e5abd0dfc1e",
      name: "SWFTCOIN",
      symbol: "SWFTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2346/thumb/SWFTCoin.jpg?1696503223"
    },
    {
      chainId: 1,
      address: "0xea4a2327e75252517535fd013b7c6706609819db",
      name: "Shibarium Name Service",
      symbol: "SNS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29486/thumb/shibarium.jpg?1696528430"
    },
    {
      chainId: 1,
      address: "0xa6586e19ef681b1ac0ed3d46413d199a555dbb95",
      name: "Lets Go Brandon",
      symbol: "LETSGO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24034/thumb/3zKU0T83_400x400.jpeg?1696523226"
    },
    {
      chainId: 1,
      address: "0x3392d8a60b77f8d3eaa4fb58f09d835bd31add29",
      name: "IndiGG",
      symbol: "INDI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23857/thumb/https___bucketeer-e05bbc84-baa3-437e-9518-adb32be77984.s3.amazonaws.com_public_images_0cb39c1f-db6d-4dd9-9143-1f30ee38d74d_743x726.jpeg?1696523058"
    },
    {
      chainId: 1,
      address: "0x7b18e5d77622ba37173801f77745a0654df825ff",
      name: "TraderX",
      symbol: "TX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34051/thumb/logo.jpg?1703744503"
    },
    {
      chainId: 1,
      address: "0xb6dc73987848ba6cb3ce297562723c1a78f85fce",
      name: "Borzoi Coin",
      symbol: "BORZOI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34430/thumb/photo_2024-01-08_05-57-57.jpg?1704868051"
    },
    {
      chainId: 1,
      address: "0xbc6e06778708177a18210181b073da747c88490a",
      name: "MOBLAND",
      symbol: "SYNR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22868/thumb/FullML_Yellow_200px.png?1696522168"
    },
    {
      chainId: 1,
      address: "0x788b6d2b37aa51d916f2837ae25b05f0e61339d1",
      name: "Metavault DAO",
      symbol: "MVD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/23899/thumb/MVD_Coin-simple.png?1696523099"
    },
    {
      chainId: 1,
      address: "0xf1290473e210b2108a85237fbcd7b6eb42cc654f",
      name: "HedgeTrade",
      symbol: "HEDG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7196/thumb/to3Vj4EZ_400x400.jpg?1696507494"
    },
    {
      chainId: 1,
      address: "0x6431fa4b812a2dcc062a38cb55cc7d18135adead",
      name: "RankerDao",
      symbol: "RANKER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23902/thumb/ranker.png?1696523102"
    },
    {
      chainId: 1,
      address: "0x469084939d1c20fae3c73704fe963941c51be863",
      name: "Envision",
      symbol: "VIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23907/thumb/J3JCKVq2.png?1696523107"
    },
    {
      chainId: 1,
      address: "0x3f95aa88ddbb7d9d484aa3d482bf0a80009c52c9",
      name: "Backed ERNX   Bond",
      symbol: "BERNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36755/thumb/b-ERNX-200x200.png?1712993360"
    },
    {
      chainId: 1,
      address: "0x0173661769325565d4f011b2e5cda688689cc87c",
      name: "Quantland",
      symbol: "QLT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/24536/thumb/8jYfKBTk_400x400.jpg?1696523713"
    },
    {
      chainId: 1,
      address: "0x201332bd45c8628d814f870bfb584b385a7c351e",
      name: "Astra Protocol",
      symbol: "ASTRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24083/thumb/Astra_%281%29_%281%29.png?1696523277"
    },
    {
      chainId: 1,
      address: "0x8a3d77e9d6968b780564936d15b09805827c21fa",
      name: "Archethic",
      symbol: "UCO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12330/thumb/Archethic_logo.png?1696512158"
    },
    {
      chainId: 1,
      address: "0x5b1d655c93185b06b00f7925791106132cb3ad75",
      name: "DarkMatter",
      symbol: "DMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23989/thumb/dmt.png?1696523184"
    },
    {
      chainId: 1,
      address: "0xf0dc9fc0669f068e04ad79f7d70618d3f9aad439",
      name: "Oasis Metaverse",
      symbol: "OASIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32703/thumb/oasis_200x200_loogo.png?1698985354"
    },
    {
      chainId: 1,
      address: "0x4fabf135bcf8111671870d4399af739683198f96",
      name: "Xave Coin",
      symbol: "XVC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24084/thumb/k8qjP9t9_400x400.jpg?1696523277"
    },
    {
      chainId: 1,
      address: "0x3f3cd642e81d030d7b514a2ab5e3a5536beb90ec",
      name: "Rho",
      symbol: "RHO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25540/thumb/Rho-icon-03.png?1696524673"
    },
    {
      chainId: 1,
      address: "0x489d79959e6ad1e3fef7c939a2d889deff1668a8",
      name: "Hottie Froggie",
      symbol: "HOTTIE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37030/thumb/200x200.png?1713158526"
    },
    {
      chainId: 1,
      address: "0xf8ebf4849f1fa4faf0dff2106a173d3a6cb2eb3a",
      name: "Troll",
      symbol: "TROLL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29897/thumb/TROLL.jpeg?1696528821"
    },
    {
      chainId: 1,
      address: "0xb44377b74ef1773639b663d0754cb8410a847d02",
      name: "Dream",
      symbol: "DREAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24139/thumb/image0.jpeg?1696523330"
    },
    {
      chainId: 1,
      address: "0x71a28feaee902966dc8d355e7b8aa427d421e7e0",
      name: "LunchDAO",
      symbol: "LUNCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25808/thumb/200x200.png?1696524893"
    },
    {
      chainId: 1,
      address: "0x06f3c323f0238c72bf35011071f2b5b7f43a054c",
      name: "MASQ",
      symbol: "MASQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13699/thumb/masq.png?1696513446"
    },
    {
      chainId: 1,
      address: "0x578b388528f159d026693c3c103100d36ac2ad65",
      name: "SnackboxAI",
      symbol: "SNACK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37149/thumb/SnackboxAI.png?1713462642"
    },
    {
      chainId: 1,
      address: "0xf71a2079566c87e26bcd9766d140d5bfdeeae731",
      name: "Doge69",
      symbol: "DOGE69",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33210/thumb/IMG_20231126_121430_856.jpg?1701084935"
    },
    {
      chainId: 1,
      address: "0x2f9411088cef82fd9fb904eb8092f28eb485c8f6",
      name: "Athens",
      symbol: "ATH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24514/thumb/ATH-logo-round.png?1696523693"
    },
    {
      chainId: 1,
      address: "0x64323d606cfcb1b50998636a182334ad97637987",
      name: "xperp",
      symbol: "XPERP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33107/thumb/xperp-logo.png?1700663572"
    },
    {
      chainId: 1,
      address: "0x60bb16c4a931b1a0b8a7d945c651dd90f41d42cf",
      name: "Finance Blocks",
      symbol: "FBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24117/thumb/financeblocksshadow.png?1696523309"
    },
    {
      chainId: 1,
      address: "0xa774ffb4af6b0a91331c084e1aebae6ad535e6f3",
      name: "flexUSD",
      symbol: "FLEXUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13323/thumb/flexUSD_2x.png?1696513092"
    },
    {
      chainId: 1,
      address: "0xc91b523a59acc63a64f61fc7bbfb4bfc82dd25f2",
      name: "Multiverse",
      symbol: "AI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16329/thumb/multiverse_logo_full_color_rgb_200px_72ppi.png?1696515930"
    },
    {
      chainId: 1,
      address: "0x25722cd432d02895d9be45f5deb60fc479c8781e",
      name: "Sponge  OLD ",
      symbol: "SPONGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30254/thumb/Sea_Sponge_1.png?1696529163"
    },
    {
      chainId: 1,
      address: "0xf725f73caee250ae384ec38bb2c77c38ef2cccea",
      name: "Ape In Records",
      symbol: "AIR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24194/thumb/gCZZdeR.jpeg?1696523382"
    },
    {
      chainId: 1,
      address: "0x961d4921e1718e633bac8ded88c4a1cae44b785a",
      name: "Thunderhead Staked FLIP",
      symbol: "STFLIP",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xff3f8227c3b0241848e1420ec77d61aee2ad5f67",
      name: "TxWorx",
      symbol: "TX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35644/thumb/IMG_2815.jpeg?1709368757"
    },
    {
      chainId: 1,
      address: "0x6247c86b016bc4d9ae141849c0a9eb38c004b742",
      name: "Hotelium",
      symbol: "HTL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8812/thumb/hotelium.PNG?1696508966"
    },
    {
      chainId: 1,
      address: "0x36ac219f90f5a6a3c77f2a7b660e3cc701f68e25",
      name: "Coinmetro",
      symbol: "XCM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3125/thumb/XCM_Token_Logo_.png?1696503850"
    },
    {
      chainId: 1,
      address: "0x3cbc780d2934d55a06069e837fabd3e6fc23dab0",
      name: "DBX",
      symbol: "DBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15682/thumb/logo.png?1696515312"
    },
    {
      chainId: 1,
      address: "0xb58e61c3098d85632df34eecfb899a1ed80921cb",
      name: "Frankencoin",
      symbol: "ZCHF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37150/thumb/Untitled_design_%2818%29.png?1713464171"
    },
    {
      chainId: 1,
      address: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
      name: "crvUSD",
      symbol: "CRVUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30118/thumb/crvusd.jpeg?1696529040"
    },
    {
      chainId: 1,
      address: "0x6dde4ffd6db302bc9a46850f61399e082f6c2122",
      name: "inheritance Art",
      symbol: "IAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24221/thumb/iAI.jpg?1696523407"
    },
    {
      chainId: 1,
      address: "0x8503a7b00b4b52692cc6c14e5b96f142e30547b7",
      name: "Meeds DAO",
      symbol: "MEED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24281/thumb/s-YfFWYu_400x400.png?1696523464"
    },
    {
      chainId: 1,
      address: "0x33cd63136d2f04826a9170b2ed6e09b6c9fb38a5",
      name: "VEROPAD",
      symbol: "VPAD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37151/thumb/IMG_0763_%281%29.png?1713464300"
    },
    {
      chainId: 1,
      address: "0x61035ed28081c1acc38e399c416bfc08fd6e73a1",
      name: "FrouBot",
      symbol: "FROBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32987/thumb/wepik-export-20231029191457FW3V_%281%29.png?1700094955"
    },
    {
      chainId: 1,
      address: "0xbfb2b6870501a6ff17121d676a0a45a38c9eed1e",
      name: "LuckyToad",
      symbol: "TOAD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28867/thumb/Coingecko_listing.png?1696527840"
    },
    {
      chainId: 1,
      address: "0x8f9b4525681f3ea6e43b8e0a57bfff86c0a1dd2e",
      name: "Zeebu",
      symbol: "ZBU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31145/thumb/200x200_Front_token.png?1696529974"
    },
    {
      chainId: 1,
      address: "0x0f59bfdd1d95a3736d2e219f905ae9b2e69c6638",
      name: "KIWI DEPLOYER BOT",
      symbol: "KIWI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35164/thumb/2024-02-10_20.54.15.jpg?1707662977"
    },
    {
      chainId: 1,
      address: "0x3ba925fdeae6b46d0bb4d424d829982cb2f7309e",
      name: "RabbitX",
      symbol: "RBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30048/thumb/RBX.png?1696528970"
    },
    {
      chainId: 1,
      address: "0x144805be43c48ef85435c94e0da4cb4efb1ab4f3",
      name: "MetaBlox",
      symbol: "MBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32988/thumb/Artboard_1_copy_4.png?1700099624"
    },
    {
      chainId: 1,
      address: "0xed04915c23f00a313a544955524eb7dbd823143d",
      name: "Alchemy Pay",
      symbol: "ACH",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/12390/thumb/ACH_%281%29.png?1696512213"
    },
    {
      chainId: 1,
      address: "0x6dc6a27822ae2ca3a47da39a2f2bbd525dd693f8",
      name: "Cyberdoge",
      symbol: "CYDOGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34085/thumb/CD_Logo_200x200.png?1703910686"
    },
    {
      chainId: 1,
      address: "0xa80f2c8f61c56546001f5fc2eb8d6e4e72c45d4c",
      name: "Unique Utility",
      symbol: "UNQT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23382/thumb/UniqueCoin_Logo.jpeg?1708335635"
    },
    {
      chainId: 1,
      address: "0xa8b919680258d369114910511cc87595aec0be6d",
      name: "LUKSO  OLD ",
      symbol: "LYXE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11423/thumb/LYX.png?1696511335"
    },
    {
      chainId: 1,
      address: "0xdd782657af86492771bdb369caeb8c246be362f5",
      name: "RUGAME",
      symbol: "RUG",
      decimals: 12,
      logoURI: "https://assets.coingecko.com/coins/images/29925/thumb/rugame.png?1696528853"
    },
    {
      chainId: 1,
      address: "0x628ab8b061fea2af1239b68efa5e46135d186666",
      name: "XBullion Silver",
      symbol: "SILV",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/24171/thumb/SILV_Logo_%28transparent_circle%29.png?1646816506"
    },
    {
      chainId: 1,
      address: "0x09f098b155d561fc9f7bccc97038b7e3d20baf74",
      name: "ZooDAO",
      symbol: "ZOO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24305/thumb/Zt2BM_8D_400x400.jpg?1696523486"
    },
    {
      chainId: 1,
      address: "0x33f391f4c4fe802b70b77ae37670037a92114a7c",
      name: "Burp",
      symbol: "BURP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17317/thumb/Big_Town_Chef_-__BURP_-_Avatar_3x.png?1696516871"
    },
    {
      chainId: 1,
      address: "0x3c2a309d9005433c1bc2c92ef1be06489e5bf258",
      name: "Wrapped Paycoin",
      symbol: "WPCI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/24390/thumb/new_logo_square_%281%29.png?1696523573"
    },
    {
      chainId: 1,
      address: "0x1864ce27e9f7517047933caae530674e8c70b8a7",
      name: "Pibble",
      symbol: "PIB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2972/thumb/pibble.jpg?1696503713"
    },
    {
      chainId: 1,
      address: "0xa71d0588eaf47f12b13cf8ec750430d21df04974",
      name: "Shiba Predator",
      symbol: "QOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24430/thumb/l1KzMcL.png?1696523611"
    },
    {
      chainId: 1,
      address: "0xd43be54c1aedf7ee4099104f2dae4ea88b18a249",
      name: "Traxx",
      symbol: "TRAXX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24441/thumb/TT.png?1696523622"
    },
    {
      chainId: 1,
      address: "0x01d33fd36ec67c6ada32cf36b31e88ee190b1839",
      name: "Brazilian Digital",
      symbol: "BRZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8472/thumb/MicrosoftTeams-image_%286%29.png?1696508657"
    },
    {
      chainId: 1,
      address: "0x56694577564fdd577a0abb20fe95c1e2756c2a11",
      name: "AdaSwap",
      symbol: "ASW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24453/thumb/rA5cmPtX_400x400.jpg?1696523633"
    },
    {
      chainId: 1,
      address: "0x1afb69dbc9f54d08dab1bd3436f8da1af819e647",
      name: "Melos Studio",
      symbol: "MELOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24411/thumb/18551.png?1696523593"
    },
    {
      chainId: 1,
      address: "0x7bef710a5759d197ec0bf621c3df802c2d60d848",
      name: "SHOPX",
      symbol: "SHOPX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14600/thumb/shopx_icon_.png?1696514279"
    },
    {
      chainId: 1,
      address: "0x436da116249044e8b4464f0cf21dd93311d88190",
      name: "Colizeum",
      symbol: "ZEUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24448/thumb/AB0cGpnx_400x400.jpg?1696523629"
    },
    {
      chainId: 1,
      address: "0x52a8845df664d76c69d2eea607cd793565af42b8",
      name: "ApeX",
      symbol: "APEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25266/thumb/CxpMECpk_400x400_%281%29.png?1696524406"
    },
    {
      chainId: 1,
      address: "0xaa6e8127831c9de45ae56bb1b0d4d4da6e5665bd",
      name: "Index Coop   ETH 2x Flexible Leverage I",
      symbol: "ETH2X-FLI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14392/thumb/ETH2x-FLI_%281%29.png?1696514083"
    },
    {
      chainId: 1,
      address: "0x104f3152d8ebfc3f679392977356962ff36566ac",
      name: "ChainPort",
      symbol: "PORTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24490/thumb/VE-tUL-q_400x400.png?1696523670"
    },
    {
      chainId: 1,
      address: "0xc6bdb96e29c38dc43f014eed44de4106a6a8eb5f",
      name: "Inu Inu",
      symbol: "INUINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26391/thumb/logo-safearea-circle.png?1713146784"
    },
    {
      chainId: 1,
      address: "0x28cca76f6e8ec81e4550ecd761f899110b060e97",
      name: "ArGoApp",
      symbol: "ARGO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15477/thumb/Group_118.png?1696515122"
    },
    {
      chainId: 1,
      address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
      name: "SelfKey",
      symbol: "KEY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2034/thumb/selfkey.png?1696503004"
    },
    {
      chainId: 1,
      address: "0x6570ffe19da7e2b425329b157d9109b87f18304b",
      name: "UNIUM",
      symbol: "UNM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24567/thumb/Unium_logo.png?1696523743"
    },
    {
      chainId: 1,
      address: "0xc8de43bfe33ff496fa14c270d9cb29bda196b9b5",
      name: "Big Eyes",
      symbol: "BIG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30824/thumb/200-200.jpg?1696529677"
    },
    {
      chainId: 1,
      address: "0xc1f33e0cf7e40a67375007104b929e49a581bafe",
      name: "Spot",
      symbol: "SPOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28426/thumb/SPOT_Logo_200x200_sq_small_centered.png?1696527423"
    },
    {
      chainId: 1,
      address: "0xae36155a55f04a696b8362777620027882b31db5",
      name: "Kishimoto",
      symbol: "KISHIMOTO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28011/thumb/kishimoto.png?1696527027"
    },
    {
      chainId: 1,
      address: "0x5a3e6a77ba2f983ec0d371ea3b475f8bc0811ad5",
      name: "0x0 ai  AI Smart Contract",
      symbol: "0X0",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28880/thumb/0x0.png?1696527857"
    },
    {
      chainId: 1,
      address: "0x1d96fd43ee07aa79f8fd003cbdf404fb5ce41ad2",
      name: "Qawalla",
      symbol: "QWLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15242/thumb/qwla.png?1696514896"
    },
    {
      chainId: 1,
      address: "0x594daad7d77592a2b97b725a7ad59d7e188b5bfa",
      name: "Apu Apustaja",
      symbol: "APU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35986/thumb/200x200.png?1710308147"
    },
    {
      chainId: 1,
      address: "0xfa5047c9c78b8877af97bdcb85db743fd7313d4a",
      name: "Rook",
      symbol: "ROOK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13005/thumb/keeper_dao_logo.jpg?1696512794"
    },
    {
      chainId: 1,
      address: "0xcd17fa52528f37facb3028688e62ec82d9417581",
      name: "Materium",
      symbol: "MTRM",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/24613/thumb/mtrm.png?1696523785"
    },
    {
      chainId: 1,
      address: "0x36c79f0b8a2e8a3c0230c254c452973e7a3ba155",
      name: "BetAI",
      symbol: "BAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35714/thumb/betai.jpg?1709630399"
    },
    {
      chainId: 1,
      address: "0x849c479d7a90eb378dbd00e8f166371176244eb1",
      name: "MUU",
      symbol: "MUU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/25620/thumb/muu.jpg?1696524754"
    },
    {
      chainId: 1,
      address: "0xb70eaf5d316192881aac8786c90b7907b83f02e8",
      name: "MetaReset",
      symbol: "RESET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32314/thumb/reset.jpg?1697271138"
    },
    {
      chainId: 1,
      address: "0xde075d9adbd0240b4462f124af926452ad0bac91",
      name: "Bubblefong",
      symbol: "BBF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24634/thumb/BBF-Token-200x200.png?1696523805"
    },
    {
      chainId: 1,
      address: "0x1e2f15302b90edde696593607b6bd444b64e8f02",
      name: "Shiryo",
      symbol: "SHIRYO-INU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19652/thumb/shiryo_inu.png?1696519080"
    },
    {
      chainId: 1,
      address: "0x5fa54fddf1870c344dbfabb37dfab8700ec0def1",
      name: "FrogeX",
      symbol: "FROGEX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/14775/thumb/-p8cz7Bk_400x400.png?1696514444"
    },
    {
      chainId: 1,
      address: "0x821a278dfff762c76410264303f25bf42e195c0c",
      name: "pETH",
      symbol: "PETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28376/thumb/peth.png?1696527377"
    },
    {
      chainId: 1,
      address: "0x3209d14ff61766359e64aceff91877cec2ad968e",
      name: "CouponBay",
      symbol: "CUP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24696/thumb/logo_200.png?1696523862"
    },
    {
      chainId: 1,
      address: "0xa318a1277e26dfcdf6f4095b90d137743d900e61",
      name: "SmartAudit AI",
      symbol: "AUDIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35567/thumb/SmartAudit_AI.png?1709183104"
    },
    {
      chainId: 1,
      address: "0x2596825a84888e8f24b747df29e11b5dd03c81d7",
      name: "Faith Tribe",
      symbol: "FTRB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23939/thumb/ym1Hf4x2_400x400.jpg?1696523135"
    },
    {
      chainId: 1,
      address: "0xaeb3607ec434454ceb308f5cd540875efb54309a",
      name: "Sturdy",
      symbol: "STRDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30581/thumb/SF-Dark-Logomark.png?1696529445"
    },
    {
      chainId: 1,
      address: "0x4086e77c5e993fdb90a406285d00111a974f877a",
      name: "Blockchain Brawlers",
      symbol: "BRWL",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/24701/thumb/fuDdvI8Y_400x400.png?1696523867"
    },
    {
      chainId: 1,
      address: "0x2ecba91da63c29ea80fbe7b52632ca2d1f8e5be0",
      name: "FairERC20",
      symbol: "FERC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30698/thumb/fair.png?1696529568"
    },
    {
      chainId: 1,
      address: "0xfbe878ced08132bd8396988671b450793c44bc12",
      name: "Fox Trading",
      symbol: "FOXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5182/thumb/foxtrading-logo.png?1547040619"
    },
    {
      chainId: 1,
      address: "0xa35923162c49cf95e6bf26623385eb431ad920d3",
      name: "Turbo",
      symbol: "TURBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30117/thumb/TurboMark-QL_200.png?1708079597"
    },
    {
      chainId: 1,
      address: "0xa8b61cff52564758a204f841e636265bebc8db9b",
      name: "Yield Protocol",
      symbol: "YIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14220/thumb/yield.png?1696513935"
    },
    {
      chainId: 1,
      address: "0x7712c34205737192402172409a8f7ccef8aa2aec",
      name: "BlackRock USD Institutional Digital Liq",
      symbol: "BUIDL",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/36291/thumb/blackrock.png?1711013223"
    },
    {
      chainId: 1,
      address: "0xadd353fb2e2c563383ff3272a500f3e7134dafe4",
      name: "Tunachain",
      symbol: "TUNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36213/thumb/Project_Logo_B_Transparent.png?1710836529"
    },
    {
      chainId: 1,
      address: "0x6069c9223e8a5da1ec49ac5525d4bb757af72cd8",
      name: "MUSK Gold",
      symbol: "MUSK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21696/thumb/musk-icon-200x200.png?1696521051"
    },
    {
      chainId: 1,
      address: "0xdc0327d50e6c73db2f8117760592c8bbf1cdcf38",
      name: "Stronger",
      symbol: "STRNGR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24922/thumb/200x200_logo.png?1696524078"
    },
    {
      chainId: 1,
      address: "0x3cbb7f5d7499af626026e96a2f05df806f2200dc",
      name: "PandaDAO",
      symbol: "PANDA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24926/thumb/PandaDAO_logo_512.png?1696524082"
    },
    {
      chainId: 1,
      address: "0x0018d5e01e53878f90feab02f1b2019a21adf8b1",
      name: "Shadowcats",
      symbol: "SHADOWCATS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29140/thumb/Shadowcats.png?1696528101"
    },
    {
      chainId: 1,
      address: "0x3c48ca59bf2699e51d4974d4b6d284ae52076e5e",
      name: "Capital DAO Starter",
      symbol: "CDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20332/thumb/cds.png?1696519736"
    },
    {
      chainId: 1,
      address: "0xb840d10d840ef47c233fec1fd040f5b145a6dfa5",
      name: "STREETH",
      symbol: "STREETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24954/thumb/streeth.png?1696524108"
    },
    {
      chainId: 1,
      address: "0x382a1667c9062f0621362f49076ef6e4fe4c9ec7",
      name: "RushCoin",
      symbol: "RUSH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25053/thumb/Kax1yBSz_400x400.png?1696524204"
    },
    {
      chainId: 1,
      address: "0x9f284e1337a815fe77d2ff4ae46544645b20c5ff",
      name: "Darwinia Commitment",
      symbol: "KTON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11895/thumb/KTON.png?1696511761"
    },
    {
      chainId: 1,
      address: "0xd78cb66b3affd27569782737fa5b842277e1add7",
      name: "GTROK",
      symbol: "GTROK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35643/thumb/20240229_144143.jpg?1709368626"
    },
    {
      chainId: 1,
      address: "0xa1a4e303e9c56962f201c5e834abc1e677a3c4f3",
      name: "CVNX",
      symbol: "CVNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/862/thumb/CVNX-logo.png?1696501996"
    },
    {
      chainId: 1,
      address: "0xb2a63a5dd36c91ec2da59b188ff047f66fac122a",
      name: "Alpha Impact",
      symbol: "FOLO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19988/thumb/folo.PNG?1696519411"
    },
    {
      chainId: 1,
      address: "0xb94acdf8662cd955f137e0c9c9fba535c87b57b4",
      name: "Mona Token",
      symbol: "LISA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32376/thumb/monatoken.png?1698035251"
    },
    {
      chainId: 1,
      address: "0x22987407fd1fc5a971e3fda3b3e74c88666cda91",
      name: "Smart Reward Token",
      symbol: "SRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25035/thumb/me-44EyS_400x400.jpg?1696524187"
    },
    {
      chainId: 1,
      address: "0x329cf160f30d21006bcd24b67eade561e54cde4c",
      name: "CareCoin",
      symbol: "CARE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28378/thumb/46FD299C-3DA4-43E6-A6A2-27F492FC7E4D.jpeg?1696527378"
    },
    {
      chainId: 1,
      address: "0x7c5095bb2dae81bb9a21ee9f1b7815cd710194e5",
      name: "Obama6900",
      symbol: "OBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32378/thumb/obamasmall.jpg?1698036300"
    },
    {
      chainId: 1,
      address: "0x3fab0bbaa03bceaf7c49e2b12877db0142be65fc",
      name: "Castello Coin",
      symbol: "CAST",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/25216/thumb/19705.png?1696524359"
    },
    {
      chainId: 1,
      address: "0xd8b90d2e680ea535eacce1b025c998b347892f68",
      name: "Chatter Shield  OLD ",
      symbol: "SHIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31140/thumb/SHIELD.png?1713491221"
    },
    {
      chainId: 1,
      address: "0x24e89bdf2f65326b94e36978a7edeac63623dafa",
      name: "Tiger King Coin",
      symbol: "TKING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15605/thumb/tigerking.png?1696515239"
    },
    {
      chainId: 1,
      address: "0xc229c69eb3bb51828d0caa3509a05a51083898dd",
      name: "Pintu",
      symbol: "PTU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20281/thumb/image_1_8dd79a68aa.png?1696519686"
    },
    {
      chainId: 1,
      address: "0x4674672bcddda2ea5300f5207e1158185c944bc0",
      name: "Gem Exchange and Trading",
      symbol: "GXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12226/thumb/a.png?1696512059"
    },
    {
      chainId: 1,
      address: "0xef952363c1d990a2fa58f8b379a9fa33bad1dfd1",
      name: "LynKey",
      symbol: "LYNK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/25069/thumb/oOcTsBsg_400x400_%281%29.jpg?1696524217"
    },
    {
      chainId: 1,
      address: "0x6a8fee0e33cb65a7e8d21badca62e87639ef74b3",
      name: "PDX Coin",
      symbol: "PDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25095/thumb/vBi23nWw_400x400.jpg?1696524246"
    },
    {
      chainId: 1,
      address: "0xf67366e83cc9b115ef8cca93baed1f03e6d3ca9a",
      name: "MindVerse",
      symbol: "MVERSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35875/thumb/photo_2024-03-08_14.24.00.jpeg?1709981737"
    },
    {
      chainId: 1,
      address: "0xf81421fc15300c5a8cca9afe12f5cbad502fa756",
      name: "Cardiocoin",
      symbol: "CRDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25135/thumb/gQiyJrGcTRjEN-6bI22FOtHOmYF8-_MMYS_U1gIlUm1wf6QxiGnZ64tIeGNNFk9z5xPPch5FMie2grAN4fXQfcjKI9L0EQDVzDEdYDfqWl8ch4ree_q4pypGPNHeSCxnynfOOLAvd9XbKguJHEJNTLAdSKnWCKu92Kho49SplFvDBplt2ruvOz1v5QB795cnjZg4ZemfgfAB_ipJU1YE4TA3uL.jpg?1696524285"
    },
    {
      chainId: 1,
      address: "0xd87de4ccef2c2fe651bc4d130cb1a365248f21fa",
      name: "Lyfe",
      symbol: "LYFE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28608/thumb/lyfe-32.png?1696527594"
    },
    {
      chainId: 1,
      address: "0xf5cfbc74057c610c8ef151a439252680ac68c6dc",
      name: "Octopus Network",
      symbol: "OCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18025/thumb/octopus_network.png?1696517541"
    },
    {
      chainId: 1,
      address: "0x19e2a43fbbc643c3b2d9667d858d49cad17bc2b5",
      name: "BNS",
      symbol: "BNS",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/25150/thumb/bitbns_logo.png?1696524299"
    },
    {
      chainId: 1,
      address: "0x88303fed02b31db9c7a9eafb711da9ef4a03e5d3",
      name: "Ziktalk",
      symbol: "ZIK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8991/thumb/ziktalk.logo.jpeg?1696509132"
    },
    {
      chainId: 1,
      address: "0xc3dca8f61b275d1e88f3ea31b3e311c49f56b24b",
      name: "NPick Block",
      symbol: "NPICK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25151/thumb/Logo200_%281%29.png?1696524300"
    },
    {
      chainId: 1,
      address: "0xdfddf7a69716124bc346ba556d4b9f9e74c4a8bc",
      name: "Succession",
      symbol: "SCCN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25377/thumb/sccn.png?1696524510"
    },
    {
      chainId: 1,
      address: "0x7f792db54b0e580cdc755178443f0430cf799aca",
      name: "Volt Inu",
      symbol: "VOLT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/25201/thumb/logo200.png?1696524344"
    },
    {
      chainId: 1,
      address: "0xe0c05ec44775e4ad62cdc2eecdf337aa7a143363",
      name: "Mancium",
      symbol: "MANC",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/25084/thumb/IKpuMYuGaMHEE0nrDUwpf6DqLQ5zTfZ1sak6ZqeIe2snV4GqQbh4Eic6hHcPl_OpBmlhcrRJ5kqoGzwB1CezMiDYnwR6rDT08_l8zb3-y3aPhTv7_0x5g4IO9JpQXDViEIqTZ7gYzTXqkcP6MH_uCFxQF-l-ohR0-FdT8O-ZTmNUKm--OuqEf9DVa-miAFp4t2pN-kcJ5Jv8woPj51yk-zna8c.jpg?1696524235"
    },
    {
      chainId: 1,
      address: "0x4521c9ad6a3d4230803ab752ed238be11f8b342f",
      name: "Sanin Inu",
      symbol: "SANI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25222/thumb/B7r0ocfQ_400x400.jpg?1696524365"
    },
    {
      chainId: 1,
      address: "0x823556202e86763853b40e9cde725f412e294689",
      name: "Altered State Machine",
      symbol: "ASTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24893/thumb/ASTO.png?1696524051"
    },
    {
      chainId: 1,
      address: "0x46e98ffe40e408ba6412beb670507e083c8b95ff",
      name: "Primate",
      symbol: "PRIMATE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25245/thumb/benji-logo-512x512.png?1696524386"
    },
    {
      chainId: 1,
      address: "0x5319e86f0e41a06e49eb37046b8c11d78bcad68c",
      name: "Zelwin",
      symbol: "ZLW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11547/thumb/5614.png?1696511447"
    },
    {
      chainId: 1,
      address: "0x149d8290f653deb8e34c037d239d3d8eee9de5ad",
      name: "Kingdomverse",
      symbol: "KING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28607/thumb/_King_logo_%28Color%29.png?1696527593"
    },
    {
      chainId: 1,
      address: "0x1122b6a0e00dce0563082b6e2953f3a943855c1f",
      name: "CENNZnet",
      symbol: "CENNZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3408/thumb/CENNZ_ticker.png?1696504105"
    },
    {
      chainId: 1,
      address: "0xb7b1570e26315baad369b8ea0a943b7f140db9eb",
      name: "DEEPSPACE",
      symbol: "DPS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17953/thumb/f1LFu897_400x400.jpg?1696517473"
    },
    {
      chainId: 1,
      address: "0x0e29e5abbb5fd88e28b2d355774e73bd47de3bcd",
      name: "Hakka Finance",
      symbol: "HAKKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12163/thumb/Hakka-icon.png?1696512001"
    },
    {
      chainId: 1,
      address: "0x547b2f82cecfab9c2b1d36fdda96ef9f58c63b8c",
      name: "Taxa Network",
      symbol: "TXT",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0x0262e9374e95b9667b78136c3897cb4e4ef7f0c2",
      name: "Medifakt",
      symbol: "FAKT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25248/thumb/fxOi9ZYI_400x400.png?1696524389"
    },
    {
      chainId: 1,
      address: "0xc18c07a18198a6340cf4d94855fe5eb6dd33b46e",
      name: "QLINDO",
      symbol: "QLINDO",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/26851/thumb/Qlindo_Token_Green.png?1696525910"
    },
    {
      chainId: 1,
      address: "0xe5caef4af8780e59df925470b050fb23c43ca68c",
      name: "Ferrum Network",
      symbol: "FRM",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/8251/thumb/FRM.png?1696508455"
    },
    {
      chainId: 1,
      address: "0x13a0599c493cc502ed8c4dd26f22f5cedc248fc4",
      name: "Export Motors Platform",
      symbol: "EMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24422/thumb/emp_logo_200.png?1696523603"
    },
    {
      chainId: 1,
      address: "0xc353bf07405304aeab75f4c2fac7e88d6a68f98e",
      name: "Hope money",
      symbol: "HOPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30971/thumb/HOPE.png?1696529810"
    },
    {
      chainId: 1,
      address: "0xa62cc35625b0c8dc1faea39d33625bb4c15bd71c",
      name: "StormX",
      symbol: "STMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1369/thumb/StormX.png?1696502427"
    },
    {
      chainId: 1,
      address: "0xc775c0c30840cb9f51e21061b054ebf1a00acc29",
      name: "Pastel",
      symbol: "PSL",
      decimals: 5,
      logoURI: "https://assets.coingecko.com/coins/images/14293/thumb/A4qGwEij_400x400.jpg?1696513990"
    },
    {
      chainId: 1,
      address: "0x274e7eb07b485cfde53d02270555213447570ac6",
      name: "SubDAO",
      symbol: "GOV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28379/thumb/gov.png?1696527379"
    },
    {
      chainId: 1,
      address: "0xcba78d126f0b1feda0c538bcaf4c852a7a171099",
      name: "MOE",
      symbol: "MOE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31146/thumb/symbol-200.png?1696529975"
    },
    {
      chainId: 1,
      address: "0x08a1c30bbb26425c1031ee9e43fa0b9960742539",
      name: "LandX Governance Token",
      symbol: "LNDX",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/33565/thumb/LNDX-200.png?1702445947"
    },
    {
      chainId: 1,
      address: "0x865ec58b06bf6305b886793aa20a2da31d034e68",
      name: "Mossland",
      symbol: "MOC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2374/thumb/moc.png?1696503240"
    },
    {
      chainId: 1,
      address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
      name: "Tellor Tributes",
      symbol: "TRB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9644/thumb/Blk_icon_current.png?1696509713"
    },
    {
      chainId: 1,
      address: "0x524ebc93beef838f70b4ae54b675d3e971d5884e",
      name: "Challenge Coin",
      symbol: "HERO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26567/thumb/bug-CC-200.png?1696525640"
    },
    {
      chainId: 1,
      address: "0xd05728038681bcc79b2d5aeb4d9b002e66c93a40",
      name: "Eigenpie rETH",
      symbol: "MRETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37160/thumb/mrETH.png?1713503919"
    },
    {
      chainId: 1,
      address: "0x4d4f3715050571a447fffa2cd4cf091c7014ca5c",
      name: "Summer",
      symbol: "SUMMER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25365/thumb/summer.png?1696524498"
    },
    {
      chainId: 1,
      address: "0x4c3bae16c79c30eeb1004fb03c878d89695e3a99",
      name: "Autumn",
      symbol: "AUTUMN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25366/thumb/autumn.png?1696524499"
    },
    {
      chainId: 1,
      address: "0xccba0b2bc4babe4cbfb6bd2f1edc2a9e86b7845f",
      name: "Winter",
      symbol: "WINTER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25367/thumb/winter.png?1696524500"
    },
    {
      chainId: 1,
      address: "0x1a3cbda3853494acab67648ee59afeb7ec3e9334",
      name: "Collateral Network",
      symbol: "COLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29770/thumb/IMG_20230407_101929_020.png?1696528701"
    },
    {
      chainId: 1,
      address: "0x36880f14af2e85cae8e467827fa077d6bf12ea56",
      name: "Jared From Subway",
      symbol: "JARED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30890/thumb/Jared_Logo_200_X_200.png?1696529737"
    },
    {
      chainId: 1,
      address: "0xf9c53268e9de692ae1b2ea5216e24e1c3ad7cb1e",
      name: "Idexo",
      symbol: "IDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18523/thumb/qOiqm7T8_400x400.jpg?1696518004"
    },
    {
      chainId: 1,
      address: "0x310c8f00b9de3c31ab95ea68feb6c877538f7947",
      name: "Undead Blocks",
      symbol: "UNDEAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25382/thumb/AB0Uemhlw6jR.png?1696524515"
    },
    {
      chainId: 1,
      address: "0xb668473944d2e25b6af6d46917eb0233dbac53ae",
      name: "Neton",
      symbol: "NTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25418/thumb/lqT0CJNj_400x400.jpg?1696524549"
    },
    {
      chainId: 1,
      address: "0x4d4d883f920f7c0c36a1be71a02aa0cde2aa22d1",
      name: "Opticash",
      symbol: "OPCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29362/thumb/opticash_logo_256*256.jpg?1696528310"
    },
    {
      chainId: 1,
      address: "0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3",
      name: "HXRO",
      symbol: "HXRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7805/thumb/X_3D_Black_%2810%29.png?1696508044"
    },
    {
      chainId: 1,
      address: "0xa31b1767e09f842ecfd4bc471fe44f830e3891aa",
      name: "Roobee",
      symbol: "ROOBEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8791/thumb/Group_11.png?1696508946"
    },
    {
      chainId: 1,
      address: "0x83249c6794bca5a77eb8c0af9f1a86e055459cea",
      name: "GigaSwap",
      symbol: "GIGA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26919/thumb/final_62fcaacdbcc9640975d3fb7c_822256.png?1696525976"
    },
    {
      chainId: 1,
      address: "0x69e8b9528cabda89fe846c67675b5d73d463a916",
      name: "OPEN Governance",
      symbol: "OPEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13233/thumb/opendao_logo.png?1696513011"
    },
    {
      chainId: 1,
      address: "0xd9adfb67381d392c6e9671f64cdd9014bfcd74f2",
      name: "Morra",
      symbol: "MORRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33180/thumb/MORRA.png?1705245739"
    },
    {
      chainId: 1,
      address: "0xdecade1c6bf2cd9fb89afad73e4a519c867adcf5",
      name: "Experty Wisdom",
      symbol: "WIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13133/thumb/n0MTVBrm_400x400.jpg?1696512920"
    },
    {
      chainId: 1,
      address: "0x22b48e1f20043d1db5f2a11cbf1d520a4f20b198",
      name: "Okuru",
      symbol: "XOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25473/thumb/xot.png?1696524607"
    },
    {
      chainId: 1,
      address: "0x4cff49d0a19ed6ff845a9122fa912abcfb1f68a6",
      name: "WadzPay",
      symbol: "WTK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13083/thumb/200xWadzToken.png?1696512871"
    },
    {
      chainId: 1,
      address: "0x355a824bea1adc22733978a3748271e1bbb34130",
      name: "Metanept",
      symbol: "NEPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26798/thumb/OH1UiJ16_400x400.jpeg?1696525860"
    },
    {
      chainId: 1,
      address: "0x7c07f7abe10ce8e33dc6c5ad68fe033085256a84",
      name: "Interest Compounding ETH Index",
      symbol: "ICETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24483/thumb/icETH-token-logo.png?1696523661"
    },
    {
      chainId: 1,
      address: "0x0b498ff89709d3838a063f1dfa463091f9801c2b",
      name: "BTC 2x Flexible Leverage Index",
      symbol: "BTC2X-FLI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15406/thumb/Copy_of_BTC2x-FLI_token_logo.png?1696515052"
    },
    {
      chainId: 1,
      address: "0xa4cb0dce4849bdcad2d553e9e68644cf40e26cce",
      name: "Baked",
      symbol: "BAKED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19178/thumb/rebaked-logo-full.png?1696518627"
    },
    {
      chainId: 1,
      address: "0x2be056e595110b30ddd5eaf674bdac54615307d9",
      name: "Airpuff",
      symbol: "APUFF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36622/thumb/Airpuff_Icon.jpeg?1711980913"
    },
    {
      chainId: 1,
      address: "0x9b2b931d6ab97b6a887b2c5d8529537e6fe73ebe",
      name: "All In",
      symbol: "ALLIN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28411/thumb/AllIn_V2_%281%29.png?1696527409"
    },
    {
      chainId: 1,
      address: "0x327673ae6b33bd3d90f0096870059994f30dc8af",
      name: "Lympo Market",
      symbol: "LMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15155/thumb/coin_%282%29.png?1696514811"
    },
    {
      chainId: 1,
      address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
      name: "LeverFi",
      symbol: "LEVER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26205/thumb/WI72SpBl_400x400.jpeg?1696525291"
    },
    {
      chainId: 1,
      address: "0xf34b1db61aca1a371fe97bad2606c9f534fb9d7d",
      name: "ArbiSmart",
      symbol: "RBIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21906/thumb/imgonline-com-ua-Resize-cMjOYOwg12bLazt.png?1696521257"
    },
    {
      chainId: 1,
      address: "0x42a7797351dfd281a80807196c8508eb70bb2af9",
      name: "AISociety",
      symbol: "AIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32861/thumb/AIS_Symbol.png?1699669819"
    },
    {
      chainId: 1,
      address: "0xa393473d64d2f9f026b60b6df7859a689715d092",
      name: "Lattice",
      symbol: "LTX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13050/thumb/Lattice.jpg?1696512835"
    },
    {
      chainId: 1,
      address: "0xe55d97a97ae6a17706ee281486e98a84095d8aaf",
      name: "AIPad",
      symbol: "AIPAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28894/thumb/JZadeHu.jpeg?1696527870"
    },
    {
      chainId: 1,
      address: "0x616e8bfa43f920657b3497dbf40d6b1a02d4608d",
      name: "Aura BAL",
      symbol: "AURABAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26538/thumb/auraBAL.png?1696525612"
    },
    {
      chainId: 1,
      address: "0x8eb5bd8c9ab0f8ad28e94693f3c889f490be2ab0",
      name: "PoS 32",
      symbol: "POS32",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27358/thumb/90532f66-9158-4bd4-8928-bcb8ec012579.png?1696526404"
    },
    {
      chainId: 1,
      address: "0x72e9d9038ce484ee986fea183f8d8df93f9ada13",
      name: "SmartCredit",
      symbol: "SMARTCREDIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13036/thumb/smartcredit_logo_02_white_a-1.png?1696512823"
    },
    {
      chainId: 1,
      address: "0x96e61422b6a9ba0e068b6c5add4ffabc6a4aae27",
      name: "Iron Bank EUR",
      symbol: "IBEUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17285/thumb/Iron_Bank_Euro.png?1696516839"
    },
    {
      chainId: 1,
      address: "0xfb19075d77a0f111796fb259819830f4780f1429",
      name: "Fenerbah e",
      symbol: "FB",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/17711/thumb/FB_Logo.png?1696517238"
    },
    {
      chainId: 1,
      address: "0x06874f973dc3c96dc22a10ef0d0609f877f335ea",
      name: "STOA Network",
      symbol: "STA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16710/thumb/RSloE6X1_400x400.jpeg?1696516284"
    },
    {
      chainId: 1,
      address: "0x76dbcba41e11784bfa95ce30e529fa533c3fa4ad",
      name: "Smart Marketing",
      symbol: "SMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21905/thumb/smt-logo.png?1696521257"
    },
    {
      chainId: 1,
      address: "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
      name: "Keep Network",
      symbol: "KEEP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3373/thumb/IuNzUb5b_400x400.jpg?1696504072"
    },
    {
      chainId: 1,
      address: "0x2730d6fdc86c95a74253beffaa8306b40fedecbb",
      name: "UNICORN",
      symbol: "UNI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9383/thumb/54231438.png?1696509482"
    },
    {
      chainId: 1,
      address: "0xd6c67b93a7b248df608a653d82a100556144c5da",
      name: "ExNetwork",
      symbol: "EXNT",
      decimals: 16,
      logoURI: "https://assets.coingecko.com/coins/images/12328/thumb/exnt_logo.png?1696512156"
    },
    {
      chainId: 1,
      address: "0x71dc40668682a124231301414167e4cf7f55383c",
      name: "Mimir",
      symbol: "MIMIR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19551/thumb/xaq5Xlzg_400x400.jpg?1696518984"
    },
    {
      chainId: 1,
      address: "0x80286b475969e032bdfb85639fed4d4f30ea9526",
      name: "FREECZ",
      symbol: "FREECZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33242/thumb/logo.jpeg?1701171276"
    },
    {
      chainId: 1,
      address: "0x2d80f5f5328fdcb6eceb7cacf5dd8aedaec94e20",
      name: "AGA",
      symbol: "AGA",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/12180/thumb/aga-logo.png?1696512017"
    },
    {
      chainId: 1,
      address: "0xd8e2d95c8614f28169757cd6445a71c291dec5bf",
      name: "Grumpy Cat",
      symbol: "GRUMPYCAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30322/thumb/logo_200x200.png?1696529223"
    },
    {
      chainId: 1,
      address: "0x3b7f247f21bf3a07088c2d3423f64233d4b069f7",
      name: "Dynamite",
      symbol: "DYNMT",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/8951/thumb/dynamite_logo.jpg?1696509098"
    },
    {
      chainId: 1,
      address: "0x5abf88cf3444611d13f6d1b39f3f3ee8575c91a2",
      name: "Super Athletes Token",
      symbol: "SAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27761/thumb/SAT_200.png?1696526784"
    },
    {
      chainId: 1,
      address: "0x8484e645a054586a6d6af60c0ee911d7b5180e64",
      name: "DYOR",
      symbol: "DYOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30149/thumb/dyor.jpeg?1696529070"
    },
    {
      chainId: 1,
      address: "0x4e4990e997e1df3f6b39ff49384e2e7e99bc55fe",
      name: "Saudi Bonk",
      symbol: "SAUDIBONK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34812/thumb/SaudiBonk.jpg?1706122838"
    },
    {
      chainId: 1,
      address: "0x828eb9a1934c143808e325754c54ae2c1741ec49",
      name: "Addy",
      symbol: "ADDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36294/thumb/Addy_Logo.jpg?1711016689"
    },
    {
      chainId: 1,
      address: "0xd4fa1460f537bb9085d22c7bccb5dd450ef28e3a",
      name: "Populous",
      symbol: "PPT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/753/thumb/populous.png?1696501907"
    },
    {
      chainId: 1,
      address: "0x86b4dbe5d203e634a12364c0e428fa242a3fba98",
      name: "poundtoken",
      symbol: "GBPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26591/thumb/1GBP_logo_black_%281%29.png?1712869127"
    },
    {
      chainId: 1,
      address: "0x38b7bf4eecf3eb530b1529c9401fc37d2a71a912",
      name: "ClayStack Staked MATIC",
      symbol: "CSMATIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28352/thumb/csMatic.png?1696527356"
    },
    {
      chainId: 1,
      address: "0x332809a8bce4a589da992a4ae495f32fbf4089c6",
      name: "Black Hole",
      symbol: "BLH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33312/thumb/photo_2023-11-28_22-54-07.png?1701412780"
    },
    {
      chainId: 1,
      address: "0xeb953eda0dc65e3246f43dc8fa13f35623bdd5ed",
      name: "Raini",
      symbol: "RAINI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14491/thumb/logo-200x200.png?1696514176"
    },
    {
      chainId: 1,
      address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
      name: "CoW Protocol",
      symbol: "COW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24384/thumb/cow.png?1696523567"
    },
    {
      chainId: 1,
      address: "0x4057db5bd9f67a566aa10e5587b1a964affc6a16",
      name: "Truefeedback",
      symbol: "TFBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8842/thumb/5rd7a55q_400x400.png?1696508994"
    },
    {
      chainId: 1,
      address: "0xf028adee51533b1b47beaa890feb54a457f51e89",
      name: "BMCHAIN",
      symbol: "BMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7419/thumb/bchain_logo.jpg?1696507693"
    },
    {
      chainId: 1,
      address: "0x656c00e1bcd96f256f224ad9112ff426ef053733",
      name: "Efinity",
      symbol: "EFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16558/thumb/efi-200px_%281%29.png?1696516119"
    },
    {
      chainId: 1,
      address: "0x6243d8cea23066d098a15582d81a598b4e8391f4",
      name: "Reflexer Ungovernance",
      symbol: "FLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14123/thumb/EAfYdwgd_400x400.jpg?1696513843"
    },
    {
      chainId: 1,
      address: "0x24c19f7101c1731b85f1127eaa0407732e36ecdd",
      name: "SharedStake Governance v2",
      symbol: "SGTV2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13948/thumb/sgt-png.png?1696513686"
    },
    {
      chainId: 1,
      address: "0x4561de8e0c2bba725d38d266ef62426e62678d82",
      name: "Coniun",
      symbol: "CONI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29771/thumb/16801884918921679374349437Only-Amblem-23.png?1696528702"
    },
    {
      chainId: 1,
      address: "0x74b1af114274335598da72f5c6ed7b954a016eed",
      name: "HitBTC",
      symbol: "HIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16395/thumb/JgMkz95.png?1696515993"
    },
    {
      chainId: 1,
      address: "0x97abee33cd075c58bfdd174e0885e08e8f03556f",
      name: "Sentiment",
      symbol: "SENT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16388/thumb/94SwpUOP_400x400.jpg?1696515986"
    },
    {
      chainId: 1,
      address: "0x569424c5ee13884a193773fdc5d1c5f79c443a51",
      name: "Pine",
      symbol: "PINE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25660/thumb/Logomark-Colour.png?1696524788"
    },
    {
      chainId: 1,
      address: "0xc57f1d079c862b70aa12faab19293f827187aaf6",
      name: "Gilgeous",
      symbol: "GLG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30241/thumb/GLG_200x200.jpg?1696529150"
    },
    {
      chainId: 1,
      address: "0xab93df617f51e1e415b5b4f8111f122d6b48e55c",
      name: "Delta Exchange",
      symbol: "DETO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14610/thumb/deto-logo.png?1696514288"
    },
    {
      chainId: 1,
      address: "0x1494ca1f11d487c2bbe4543e90080aeba4ba3c2b",
      name: "DeFi Pulse Index",
      symbol: "DPI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12465/thumb/defi_pulse_index_set.png?1696512284"
    },
    {
      chainId: 1,
      address: "0x65ad6a2288b2dd23e466226397c8f5d1794e58fc",
      name: "GamyFi",
      symbol: "GFX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14559/thumb/circle-cropped_%281%29.png?1696514241"
    },
    {
      chainId: 1,
      address: "0xaa602de53347579f86b996d2add74bb6f79462b2",
      name: "Zipmex",
      symbol: "ZMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13866/thumb/ZMT_Token.png?1696513611"
    },
    {
      chainId: 1,
      address: "0xa92e7c82b11d10716ab534051b271d2f6aef7df5",
      name: "Ara",
      symbol: "ARA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13877/thumb/ara-icon-200.png?1696513621"
    },
    {
      chainId: 1,
      address: "0x7714f320adca62b149df2579361afec729c5fe6a",
      name: "Tenup",
      symbol: "TUP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6254/thumb/uphIf44J_400x400.jpg?1696506637"
    },
    {
      chainId: 1,
      address: "0xc0eb85285d83217cd7c891702bcbc0fc401e2d9d",
      name: "Hiveterminal",
      symbol: "HVN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/899/thumb/Hiveterminal_token.jpg?1696502022"
    },
    {
      chainId: 1,
      address: "0x7c5a0ce9267ed19b22f8cae653f198e3e8daf098",
      name: "Santiment Network",
      symbol: "SAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/797/thumb/santiment-network-token.png?1696501947"
    },
    {
      chainId: 1,
      address: "0x58002a6b6e659a16de9f02f529b10536e307b0d9",
      name: "Crypto Holding Frank",
      symbol: "CHFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11184/thumb/chft.png?1696511117"
    },
    {
      chainId: 1,
      address: "0x602f65bb8b8098ad804e99db6760fd36208cd967",
      name: "Mops",
      symbol: "MOPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26900/thumb/mops.png?1696525958"
    },
    {
      chainId: 1,
      address: "0xf920e4f3fbef5b3ad0a25017514b769bdc4ac135",
      name: "BABB",
      symbol: "BAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2168/thumb/babb.png?1696503128"
    },
    {
      chainId: 1,
      address: "0x8dbf9a4c99580fc7fd4024ee08f3994420035727",
      name: "ECO",
      symbol: "ECO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27961/thumb/_ECO.png?1696526980"
    },
    {
      chainId: 1,
      address: "0xfcf8eda095e37a41e002e266daad7efc1579bc0a",
      name: "FLEX Coin",
      symbol: "FLEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9108/thumb/coinflex_logo.png?1696509233"
    },
    {
      chainId: 1,
      address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
      name: "BlueSparrow",
      symbol: "BLUESPARROW",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26085/thumb/bluesparrow.?1696525176"
    },
    {
      chainId: 1,
      address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
      name: "Raiden Network",
      symbol: "RDN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1132/thumb/raiden-logo.jpg?1696502225"
    },
    {
      chainId: 1,
      address: "0xe50365f5d679cb98a1dd62d6f6e58e59321bcddf",
      name: "LA",
      symbol: "LA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1051/thumb/LA_token.png?1696502156"
    },
    {
      chainId: 1,
      address: "0x910dfc18d6ea3d6a7124a6f8b5458f281060fa4c",
      name: "X8X",
      symbol: "X8X",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1912/thumb/x8x.png?1696502903"
    },
    {
      chainId: 1,
      address: "0x68d57c9a1c35f63e2c83ee8e49a64e9d70528d25",
      name: "Sirin Labs",
      symbol: "SRN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1872/thumb/sirin-labs-token.png?1696502868"
    },
    {
      chainId: 1,
      address: "0x66761fa41377003622aee3c7675fc7b5c1c2fac5",
      name: "Clearpool",
      symbol: "CPOOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19252/thumb/photo_2022-08-31_12.45.02.jpeg?1696518697"
    },
    {
      chainId: 1,
      address: "0xd98f75b1a3261dab9eed4956c93f33749027a964",
      name: "Share",
      symbol: "SHR",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/3609/thumb/74586729_2443914875881351_2785018663453851648_n.png?1696504289"
    },
    {
      chainId: 1,
      address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
      name: "Libra Credit",
      symbol: "LBA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3673/thumb/libra-credit.png?1696504352"
    },
    {
      chainId: 1,
      address: "0xa6ed258e3126be568a5f53ade7b6a1e478e5ef98",
      name: "Exynos Protocol",
      symbol: "XYN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33652/thumb/photo_2023-12-09_01-43-27_%281%29.jpg?1702544060"
    },
    {
      chainId: 1,
      address: "0x4d67edef87a5ff910954899f4e5a0aaf107afd42",
      name: "BlueSparrow  OLD ",
      symbol: "BLUESPARROW",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19995/thumb/bluesparrow.png?1696519417"
    },
    {
      chainId: 1,
      address: "0x08f7be99ed83369541501d60f4e66f8e34c3f736",
      name: "Cryptoku",
      symbol: "CKU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25813/thumb/Cryptoku.png?1696524898"
    },
    {
      chainId: 1,
      address: "0x11ebe21e9d7bf541a18e1e3ac94939018ce88f0b",
      name: "Pitch FXS",
      symbol: "PITCHFXS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28414/thumb/pitch.png?1696527412"
    },
    {
      chainId: 1,
      address: "0x304645590f197d99fad9fa1d05e7bcdc563e1378",
      name: "Guardian AI",
      symbol: "GUARDIAN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33653/thumb/IMG_7686.PNG?1702545311"
    },
    {
      chainId: 1,
      address: "0x7df571694b35ef60e9b6651967486c8017491f9b",
      name: "DOGE 1 Moon Mission",
      symbol: "DOGE-1",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33973/thumb/200x200.jpg?1703577524"
    },
    {
      chainId: 1,
      address: "0x1bed97cbc3c24a4fb5c069c6e311a967386131f7",
      name: "Yearn Ether",
      symbol: "YETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32220/thumb/yETH-128px.png?1696914909"
    },
    {
      chainId: 1,
      address: "0x973e52691176d36453868d9d86572788d27041a9",
      name: "DxChain",
      symbol: "DX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4700/thumb/VdZwy0Pv_400x400.png?1696505265"
    },
    {
      chainId: 1,
      address: "0x903bef1736cddf2a537176cf3c64579c3867a881",
      name: "Legacy ICHI",
      symbol: "ICHI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26004/thumb/legacy.png?1696525081"
    },
    {
      chainId: 1,
      address: "0x986ee2b944c42d017f52af21c4c69b84dbea35d8",
      name: "BitMart",
      symbol: "BMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5236/thumb/bitmart-token.png?1696505741"
    },
    {
      chainId: 1,
      address: "0xd96e84ddbc7cbe1d73c55b6fe8c64f3a6550deea",
      name: "Gemach",
      symbol: "GMAC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32334/thumb/gmac-200x200.png?1697452788"
    },
    {
      chainId: 1,
      address: "0xa97cd1c5bcee878496fadb4edee081d05239051f",
      name: "AICB",
      symbol: "AICB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32348/thumb/AICB-20230925162643.png?1697471641"
    },
    {
      chainId: 1,
      address: "0xff742d05420b6aca4481f635ad8341f81a6300c2",
      name: "AscendEx",
      symbol: "ASD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5003/thumb/bitmax.png?1696505535"
    },
    {
      chainId: 1,
      address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
      name: "Civic",
      symbol: "CVC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/788/thumb/civic-orange.png?1696501939"
    },
    {
      chainId: 1,
      address: "0x6e605c269e0c92e70beeb85486f1fc550f9380bd",
      name: "Catex",
      symbol: "CATT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6353/thumb/catex.png?1696506725"
    },
    {
      chainId: 1,
      address: "0xea60cd69f2b9fd6eb067bddbbf86a5bdeffbbc55",
      name: "Wecan",
      symbol: "WECAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32150/thumb/Wecan_W_logo_RGB.png?1702947005"
    },
    {
      chainId: 1,
      address: "0x4be10da47a07716af28ad199fbe020501bddd7af",
      name: "XT com",
      symbol: "XT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8391/thumb/XT_token.jpg?1696508583"
    },
    {
      chainId: 1,
      address: "0xe6d2c3cb986db66818c14c7032db05d1d2a6ee74",
      name: "Finexbox",
      symbol: "FNB",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/8419/thumb/p1WP-viw_400x400.jpg?1696508608"
    },
    {
      chainId: 1,
      address: "0xb4bd4628e6efb0cb521d9ec35050c75840320374",
      name: "frETH",
      symbol: "FRETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28734/thumb/freth.png?1696527714"
    },
    {
      chainId: 1,
      address: "0x77d0cb0ab54f9e74b9405a5b3f60da06a78f1aad",
      name: "Wrapped Millix",
      symbol: "WMLX",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/28703/thumb/wrapped_millix-200x200_300-dpi_GC.png?1696527685"
    },
    {
      chainId: 1,
      address: "0x1b073382e63411e3bcffe90ac1b9a43fefa1ec6f",
      name: "Bitpanda Ecosystem",
      symbol: "BEST",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/8738/thumb/BEST-Coin-Logo.png?1696508897"
    },
    {
      chainId: 1,
      address: "0x11eef04c884e24d9b7b4760e7476d06ddf797f36",
      name: "MX",
      symbol: "MX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8545/thumb/MEXC_GLOBAL_LOGO.jpeg?1696508719"
    },
    {
      chainId: 1,
      address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
      name: "Akropolis",
      symbol: "AKRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3328/thumb/Akropolis.png?1696504034"
    },
    {
      chainId: 1,
      address: "0x426fc8be95573230f6e6bc4af91873f0c67b21b4",
      name: "BlackPearl",
      symbol: "BPLC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8931/thumb/EJIpComQ_400x400.png?1696509079"
    },
    {
      chainId: 1,
      address: "0x34d6a0f5c2f5d0082141fe73d93b9dd00ca7ce11",
      name: "Golden",
      symbol: "GOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8939/thumb/4uf1Sim9_400x400.png?1696509087"
    },
    {
      chainId: 1,
      address: "0x187d1018e8ef879be4194d6ed7590987463ead85",
      name: "FUZE",
      symbol: "FUZE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8941/thumb/logo-fuze-fix-big.png?1696509089"
    },
    {
      chainId: 1,
      address: "0xbd89b8d708809e7022135313683663911826977e",
      name: "O MEE",
      symbol: "OME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25099/thumb/logo-mark-full-colour-cmyk-693px_300ppi.jpg?1696524249"
    },
    {
      chainId: 1,
      address: "0xda5fab7affc6dffd24d60e23153d241a3d9f9603",
      name: "Cryptiq WEB3",
      symbol: "CRYPTIQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31583/thumb/cryptiqlogo.png?1702944832"
    },
    {
      chainId: 1,
      address: "0xed03ed872159e199065401b6d0d487d78d9464aa",
      name: "Mexican Peso Tether",
      symbol: "MXNT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/26087/thumb/MXNT_green.jpg?1696525178"
    },
    {
      chainId: 1,
      address: "0x23d7ff057c696fee679c60cef61fee6614218f04",
      name: "Unipoly",
      symbol: "UNP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32510/thumb/20231018_231410.png?1698398961"
    },
    {
      chainId: 1,
      address: "0xa52bffad02b1fe3f86a543a4e81962d3b3bb01a7",
      name: "Duckereum",
      symbol: "DUCKER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26325/thumb/coin.png?1696525407"
    },
    {
      chainId: 1,
      address: "0x6d57b2e05f26c26b549231c866bdd39779e4a488",
      name: "VNX Gold",
      symbol: "VNXAU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28019/thumb/VNX_Token_logo_%283%29.png?1696527035"
    },
    {
      chainId: 1,
      address: "0x79b87d52a03ed26a19c1914be4ce37f812e2056c",
      name: "USP Token",
      symbol: "USP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28855/thumb/USP_Token.png?1696527829"
    },
    {
      chainId: 1,
      address: "0xd9fcd98c322942075a5c3860693e9f4f03aae07b",
      name: "Euler",
      symbol: "EUL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26149/thumb/Coingecko_logo_%281%29.png?1706026067"
    },
    {
      chainId: 1,
      address: "0xdc247546a6551117c8ea82db2cc0ad6e048e5f6e",
      name: "Lush AI",
      symbol: "LUSH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35342/thumb/tokenIcon200x200.png?1708317375"
    },
    {
      chainId: 1,
      address: "0xab2a7b5876d707e0126b3a75ef7781c77c8877ee",
      name: "Quadency Token",
      symbol: "QUAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21364/thumb/GkMXE_7A_400x400.png?1696520730"
    },
    {
      chainId: 1,
      address: "0x9028c2a7f8c8530450549915c5338841db2a5fea",
      name: "FOMO Network",
      symbol: "FOMO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37346/thumb/0x9028c2a7f8c8530450549915c5338841db2a5fea_%281%29.png?1714063793"
    },
    {
      chainId: 1,
      address: "0x1250b98cbde9f99f4c42dcdacee193221f17eb50",
      name: "ArtCoin",
      symbol: "AC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26127/thumb/ngiBSUT7_400x400.png?1696525216"
    },
    {
      chainId: 1,
      address: "0x8a053350ca5f9352a16ded26ab333e2d251dad7c",
      name: "Eigenpie mETH",
      symbol: "MMETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37161/thumb/mmETH.png?1713504066"
    },
    {
      chainId: 1,
      address: "0x6595b8fd9c920c81500dca94e53cdc712513fb1f",
      name: "Olyverse",
      symbol: "OLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13983/thumb/OLY-LOGO.png?1696513715"
    },
    {
      chainId: 1,
      address: "0x473037de59cf9484632f4a27b509cfe8d4a31404",
      name: "STEPN Green Satoshi Token on ETH",
      symbol: "GST-ETH",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/26528/thumb/gst_eth.png?1696525600"
    },
    {
      chainId: 1,
      address: "0x1258d60b224c0c5cd888d37bbf31aa5fcfb7e870",
      name: "NodeAI",
      symbol: "GPU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35432/thumb/NodeAI.png?1708586757"
    },
    {
      chainId: 1,
      address: "0xdc7d16b1e7c54f35a67af95d5a6eecaec27b2a62",
      name: "Pulse AI",
      symbol: "PULSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36331/thumb/photo_2024-03-17_22.26.56.jpeg?1711099075"
    },
    {
      chainId: 1,
      address: "0x930ae5999210724248b36265e8d3696128115946",
      name: "HarryPotterRussellSonic1Inu",
      symbol: "SAITAMA",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31506/thumb/200x200.png?1696530317"
    },
    {
      chainId: 1,
      address: "0x3cb48aeb3d1abadc23d2d8a6894b3a68338381c2",
      name: "PaladinAI",
      symbol: "PALAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33703/thumb/Design_sans_titre_%288%29_%282%29.png?1702826502"
    },
    {
      chainId: 1,
      address: "0xe6f47303032a09c8c0f8ebb713c00e6ed345e8c3",
      name: "Risitas  OLD ",
      symbol: "RISITA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30333/thumb/200x200.png?1696529234"
    },
    {
      chainId: 1,
      address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
      name: "Stargate Finance",
      symbol: "STG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24413/thumb/STG_LOGO.png?1696523595"
    },
    {
      chainId: 1,
      address: "0xcccd1ba9f7acd6117834e0d28f25645decb1736a",
      name: "ECOx",
      symbol: "ECOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27962/thumb/_ECOx.png?1696526981"
    },
    {
      chainId: 1,
      address: "0xd7f0cc50ad69408ae58be033f4f85d2367c2e468",
      name: "Vera",
      symbol: "VERA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18519/thumb/JJXTVFOE_400x400.png?1696518000"
    },
    {
      chainId: 1,
      address: "0x4ce4c025692b3142dbde1cd432ef55b9a8d18701",
      name: "Decanect",
      symbol: "DCNT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27309/thumb/200-x-200-jpeg.jpg?1696526359"
    },
    {
      chainId: 1,
      address: "0xdb8d6d3ac21e4efe3675bbb18514010ac9c5558f",
      name: "Energreen",
      symbol: "EGRN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30583/thumb/energreen.png?1696529447"
    },
    {
      chainId: 1,
      address: "0xbf9e72eeb5adb8b558334c8672950b7a379d4266",
      name: "CubToken",
      symbol: "CUBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26197/thumb/photo-2022-04-20-13-35-28.jpg?1696525283"
    },
    {
      chainId: 1,
      address: "0xa6089dbfed19d1bcd43146bbdca2b8f9d9f84a9a",
      name: "UGOLD Inc ",
      symbol: "UGOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35921/thumb/IMG_20240307_195222_084.jpg?1710221205"
    },
    {
      chainId: 1,
      address: "0x8790f2fc7ca2e7db841307fb3f4e72a03baf7b47",
      name: "Spillways",
      symbol: "SPILLWAYS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28358/thumb/1669791775144_%281%29.png?1696527362"
    },
    {
      chainId: 1,
      address: "0xec12ba5ac0f259e9ac6fc9a3bc23a76ad2fde5d9",
      name: "HugeWin",
      symbol: "HUGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35923/thumb/2024-03-01_17.49.27_%281%29.png?1710221459"
    },
    {
      chainId: 1,
      address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
      name: "Lido DAO",
      symbol: "LDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13573/thumb/Lido_DAO.png?1696513326"
    },
    {
      chainId: 1,
      address: "0x70715e133f3b98af9dcb4897657cd4608d395d49",
      name: "NeuralByte",
      symbol: "NBT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36528/thumb/photo_2024-03-27_10.53.01.jpeg?1711700775"
    },
    {
      chainId: 1,
      address: "0x2598c30330d5771ae9f983979209486ae26de875",
      name: "Any Inu",
      symbol: "AI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34126/thumb/anyinulogo200.png?1704174269"
    },
    {
      chainId: 1,
      address: "0x5d0ebc4ec5ac18d30512fb6287886245061b3dbd",
      name: "Gatsby Inu",
      symbol: "GATSBY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30578/thumb/gatsby.jpeg?1696529442"
    },
    {
      chainId: 1,
      address: "0xa16a609ff4e1a15b6ccb469e7a5dd14e89305283",
      name: "Spume",
      symbol: "SPUME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27089/thumb/D6lMeW9k_400x400.jpeg?1696526138"
    },
    {
      chainId: 1,
      address: "0x4dbc96275a78de1bf92facb2c165c55de62adab1",
      name: "Orange BOT",
      symbol: "ORBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33786/thumb/0x4dbc96275a78de1bf92facb2c165c55de62adab1.png?1702981687"
    },
    {
      chainId: 1,
      address: "0x879054273cb2dad631980fa4efe6d25eefe08aa4",
      name: "Eigenpie frxETH",
      symbol: "MSFRXETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37162/thumb/msfrxETH.png?1713505495"
    },
    {
      chainId: 1,
      address: "0x9cb6dd255a6bbe32130ce645ec45c0a3e9d87a4a",
      name: "NOVAMIND",
      symbol: "NMD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37348/thumb/x_icon.jpg?1714068326"
    },
    {
      chainId: 1,
      address: "0x230f5ed78a45452f726365b8ad1d6866f5faa68f",
      name: "Cryptoforce",
      symbol: "COF",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32855/thumb/IMG_20231108_221331_196.png?1699665059"
    },
    {
      chainId: 1,
      address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
      name: "Adventure Gold",
      symbol: "AGLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18125/thumb/lpgblc4h_400x400.jpg?1696517628"
    },
    {
      chainId: 1,
      address: "0xe46a5e19b19711332e33f33c2db3ea143e86bc10",
      name: "Eigenpie wBETH",
      symbol: "MWBETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37164/thumb/mwBETH.png?1713505825"
    },
    {
      chainId: 1,
      address: "0x416cdaf616a82d7dd46e0dbf36e7d6fe412bc40e",
      name: "Luna28",
      symbol: "LUNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34777/thumb/Logo_%281%29_%281%29.png?1706071100"
    },
    {
      chainId: 1,
      address: "0xb3ad645db386d7f6d753b2b9c3f4b853da6890b8",
      name: "Concentrator",
      symbol: "CTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26364/thumb/%E6%9C%AA%E5%91%BD%E5%90%8D%E7%9A%84%E8%AE%BE%E8%AE%A1.jpg?1696525441"
    },
    {
      chainId: 1,
      address: "0x35b08722aa26be119c1608029ccbc976ac5c1082",
      name: "Eminer",
      symbol: "EM",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9155/thumb/KDbQPKIu_400x400.png?1696509277"
    },
    {
      chainId: 1,
      address: "0xc4c75f2a0cb1a9acc33929512dc9733ea1fd6fde",
      name: "Martin Shkreli Inu",
      symbol: "MSI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26365/thumb/jEYEUxUI_400x400.jpeg?1696525442"
    },
    {
      chainId: 1,
      address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
      name: "Aavegotchi",
      symbol: "GHST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12467/thumb/GHST.png?1696512286"
    },
    {
      chainId: 1,
      address: "0xd0cd466b34a24fcb2f87676278af2005ca8a78c4",
      name: "Popcorn",
      symbol: "POP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21438/thumb/pop-1_200_x_200.png?1696520801"
    },
    {
      chainId: 1,
      address: "0x6e109e9dd7fa1a58bc3eff667e8e41fc3cc07aef",
      name: "CNH Tether",
      symbol: "CNHT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/5251/thumb/cny-tether-logo.png?1696505755"
    },
    {
      chainId: 1,
      address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
      name: "Amp",
      symbol: "AMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12409/thumb/amp-200x200.png?1696512231"
    },
    {
      chainId: 1,
      address: "0x727f064a78dc734d33eec18d5370aef32ffd46e4",
      name: "Orion Money",
      symbol: "ORION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18630/thumb/YtrqPIWc.png?1696518102"
    },
    {
      chainId: 1,
      address: "0xd5930c307d7395ff807f2921f12c5eb82131a789",
      name: "Bolt",
      symbol: "BOLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4489/thumb/bolt.png?1696505078"
    },
    {
      chainId: 1,
      address: "0x6bea7cfef803d1e3d5f7c0103f7ded065644e197",
      name: "Gamma Strategies",
      symbol: "GAMMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21975/thumb/gamma-token-200.png?1696521323"
    },
    {
      chainId: 1,
      address: "0x3b9be07d622accaed78f479bc0edabfd6397e320",
      name: "Lossless",
      symbol: "LSS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15917/thumb/Group_57.png?1696515531"
    },
    {
      chainId: 1,
      address: "0xa52b7ea0365310ca87ab73aef4f2f75c9a999af3",
      name: "Mass Protocol",
      symbol: "MASS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33788/thumb/Mass_200x200.jpeg?1702988300"
    },
    {
      chainId: 1,
      address: "0xc66cdac744916afb6811c71c277d88de90ce8d5b",
      name: "CDbio",
      symbol: "MCD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26957/thumb/mcd.png?1696526012"
    },
    {
      chainId: 1,
      address: "0x243da8a5561cf5642b852c4c4c3fada3f3116d2d",
      name: "DefiPal",
      symbol: "PAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33789/thumb/imresizer-1702861509134.jpg?1702988404"
    },
    {
      chainId: 1,
      address: "0x116c4b65e14449947bc6fa1bbe844cb16a162d53",
      name: "BMAX",
      symbol: "BMAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26427/thumb/BMAX_logo.png?1696525501"
    },
    {
      chainId: 1,
      address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
      name: "Wilder World",
      symbol: "WILD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15407/thumb/wld-logo.png?1712273448"
    },
    {
      chainId: 1,
      address: "0x5f9123d661459af6f398b6f1566f53222612541e",
      name: "MaranBet",
      symbol: "MARAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29787/thumb/token_maran-01_1_%281%29.png?1696528717"
    },
    {
      chainId: 1,
      address: "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
      name: "DAO Maker",
      symbol: "DAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13915/thumb/4.png?1696513656"
    },
    {
      chainId: 1,
      address: "0xd4126f195a8de772eeffa61a4ab6dd43462f4e39",
      name: "Hikari Protocol",
      symbol: "HIKARI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28953/thumb/HIKARI.png?1696527926"
    },
    {
      chainId: 1,
      address: "0xf31120603a27a16314effc37a3f32a42028310af",
      name: "Flack Exchange",
      symbol: "FLACK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34772/thumb/token_%282%29.png?1705993386"
    },
    {
      chainId: 1,
      address: "0x171d76d931529384639bc9aad5b77b77041ed604",
      name: "MetaOctagon",
      symbol: "MOTG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26496/thumb/iJoylNuO_400x400.jpeg?1696525570"
    },
    {
      chainId: 1,
      address: "0x65e9ed59a6c03e97ae984b6c4ff912448ebd3566",
      name: "Ryoshi Research",
      symbol: "RYOSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35346/thumb/Ryoshi-4.png?1708319258"
    },
    {
      chainId: 1,
      address: "0xe9a95d175a5f4c9369f3b74222402eb1b837693b",
      name: "ChangeNOW",
      symbol: "NOW",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/8224/thumb/now.png?1696508430"
    },
    {
      chainId: 1,
      address: "0x4fd51cb87ffefdf1711112b5bd8ab682e54988ea",
      name: "WPT Investing Corp",
      symbol: "WPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26431/thumb/200200.png?1696525505"
    },
    {
      chainId: 1,
      address: "0x1cf3e03f7360288dd01d0a9cfab266cfcdb3e0c1",
      name: "EchoLink",
      symbol: "EKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37059/thumb/echo2-removebg-preview.png?1713172533"
    },
    {
      chainId: 1,
      address: "0xf073bac22dab7faf4a3dd6c6189a70d54110525c",
      name: "Inception Restaked ETH",
      symbol: "INETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34127/thumb/inETH.png?1715036464"
    },
    {
      chainId: 1,
      address: "0x6a6aa13393b7d1100c00a57c76c39e8b6c835041",
      name: "OpenAI ERC",
      symbol: "OPENAIERC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28412/thumb/OpenAI.jpeg?1696527410"
    },
    {
      chainId: 1,
      address: "0x556d4f40982cb95e0714989e0c229c42be8b1499",
      name: "Golteum",
      symbol: "GLTM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28597/thumb/_GLTM-Token-Border200.png?1696527584"
    },
    {
      chainId: 1,
      address: "0xfcc5c47be19d06bf83eb04298b026f81069ff65b",
      name: "Yearn CRV",
      symbol: "YCRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27622/thumb/yearncrvnew_32.png?1696526653"
    },
    {
      chainId: 1,
      address: "0x4aa41bc1649c9c3177ed16caaa11482295fc7441",
      name: "XFai",
      symbol: "XFIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14904/thumb/XFAI_Logo200x200.jpg?1696514567"
    },
    {
      chainId: 1,
      address: "0xc97232527b62efb0d8ed38cf3ea103a6cca4037e",
      name: "LP Yearn CRV Vault",
      symbol: "LP-YCRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27624/thumb/yearncrvlp_32.png?1696526654"
    },
    {
      chainId: 1,
      address: "0x5f4361971667c8198706dec8c59cf7607e405c6e",
      name: "Fileshare Platform",
      symbol: "FSC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/28190/thumb/fsc.png?1696527193"
    },
    {
      chainId: 1,
      address: "0x53fd2342b43ecd24aef1535bc3797f509616ce8c",
      name: "Anarchy",
      symbol: "ANARCHY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26583/thumb/90EWu8yp_400x400.jpg?1696525658"
    },
    {
      chainId: 1,
      address: "0x1cf4592ebffd730c7dc92c1bdffdfc3b9efcf29a",
      name: "Waves",
      symbol: "WAVES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/425/thumb/waves.png?1696501700"
    },
    {
      chainId: 1,
      address: "0x2a7cad775fd9c5c43f996a948660ffc21b4e628c",
      name: "D Drops",
      symbol: "DOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26611/thumb/ddrops_%281%29.png?1696525685"
    },
    {
      chainId: 1,
      address: "0x8f1cece048cade6b8a05dfa2f90ee4025f4f2662",
      name: "Galaxy Fox",
      symbol: "GFOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34882/thumb/GFOX_LOGO.png?1706499381"
    },
    {
      chainId: 1,
      address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
      name: "Blur",
      symbol: "BLUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28453/thumb/blur.png?1696527448"
    },
    {
      chainId: 1,
      address: "0x227c7df69d3ed1ae7574a1a7685fded90292eb48",
      name: "Milady Vault  NFTX ",
      symbol: "MILADY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26540/thumb/256x256.png?1696525614"
    },
    {
      chainId: 1,
      address: "0xb755506531786c8ac63b756bab1ac387bacb0c04",
      name: "ZARP Stablecoin",
      symbol: "ZARP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27333/thumb/zarp_coin.png?1696526381"
    },
    {
      chainId: 1,
      address: "0xed1167b6dc64e8a366db86f2e952a482d0981ebd",
      name: "Lybra",
      symbol: "LBR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29958/thumb/New_LBR_V2.png?1696528884"
    },
    {
      chainId: 1,
      address: "0x1bc71108e898586068caba9ee09397a2d275c092",
      name: "Carbon Crates",
      symbol: "CARB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35454/thumb/Screenshot_2024-02-23_at_1.26.41%E2%80%AFPM.png?1708666068"
    },
    {
      chainId: 1,
      address: "0xd2e5decc08a80be6538f89f9ab8ff296e2f724df",
      name: "STIMA",
      symbol: "STIMA",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/26101/thumb/STIMA_200x200.png?1696525192"
    },
    {
      chainId: 1,
      address: "0x49c8efd98ac8114de2fce73d57e2944aebd5613d",
      name: "AnonTech",
      symbol: "ATEC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36949/thumb/1000002162.jpg?1712897959"
    },
    {
      chainId: 1,
      address: "0xfeb6d5238ed8f1d59dcab2db381aa948e625966d",
      name: "Doge TV",
      symbol: "DGTV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28050/thumb/532a5b9e-8294-4be1-be18-f04a2cf5f0a9.png?1696527063"
    },
    {
      chainId: 1,
      address: "0x075b1bb99792c9e1041ba13afef80c91a1e70fb3",
      name: "Curve fi renBTC wBTC sBTC",
      symbol: "CRVRENWSBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11958/thumb/Curvefi_sbtcCrv_32.png?1696511818"
    },
    {
      chainId: 1,
      address: "0x20e7125677311fca903a8897042b9983f22ea295",
      name: "Freeway",
      symbol: "FWT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13012/thumb/S5h7MHR.png?1696512800"
    },
    {
      chainId: 1,
      address: "0x798d1be841a82a273720ce31c822c61a67a601c3",
      name: "DIGG",
      symbol: "DIGG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/13737/thumb/digg.PNG?1696513481"
    },
    {
      chainId: 1,
      address: "0xbc194e6f748a222754c3e8b9946922c09e7d4e91",
      name: "Lever Network",
      symbol: "LEV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15323/thumb/lever.PNG?1696514972"
    },
    {
      chainId: 1,
      address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
      name: "Audius",
      symbol: "AUDIO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12913/thumb/AudiusCoinLogo_2x.png?1696512701"
    },
    {
      chainId: 1,
      address: "0x8fc17671d853341d9e8b001f5fc3c892d09cb53a",
      name: "BlockGames",
      symbol: "BLOCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36976/thumb/QTR7pMsP_400x400.jpg?1712911941"
    },
    {
      chainId: 1,
      address: "0xda4dd9586d27202a338843dd6b9824d267006783",
      name: "Echain Network",
      symbol: "ECT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28133/thumb/1666808362379-8226c3c3451e049842cfe21d65cb91ad.png?1696527140"
    },
    {
      chainId: 1,
      address: "0x4fc15c91a9c4a9efb404174464687e8e128730c2",
      name: "STAT",
      symbol: "STAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26602/thumb/stat.png?1696525676"
    },
    {
      chainId: 1,
      address: "0x19de6b897ed14a376dda0fe53a5420d2ac828a28",
      name: "Bitget Token",
      symbol: "BGB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11610/thumb/icon_colour.png?1696511504"
    },
    {
      chainId: 1,
      address: "0x513c3200f227ebb62e3b3d00b7a83779643a71cf",
      name: "Uplift",
      symbol: "LIFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20666/thumb/logo-200x200.png?1696520067"
    },
    {
      chainId: 1,
      address: "0x94025780a1ab58868d9b2dbbb775f44b32e8e6e5",
      name: "BetSwirl",
      symbol: "BETS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26618/thumb/icon_200.png?1696525691"
    },
    {
      chainId: 1,
      address: "0xc6956b78e036b87ba2ab9810bf081eb76eedd17a",
      name: "H",
      symbol: "H",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28759/thumb/H.png?1696527738"
    },
    {
      chainId: 1,
      address: "0xcae0dd4bda7ff3e700355c7629b24d5d728bd2ce",
      name: "Bowie",
      symbol: "BOWIE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33218/thumb/logo-200x200.png?1701088140"
    },
    {
      chainId: 1,
      address: "0x68d009f251ff3a271477f77acb704c3b0f32a0c0",
      name: "CHAD",
      symbol: "CHAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35457/thumb/LOGO_RED.png?1708669427"
    },
    {
      chainId: 1,
      address: "0x054f76beed60ab6dbeb23502178c52d6c5debe40",
      name: "DeFiner",
      symbol: "FIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12780/thumb/PdaW8Lb.png?1696512575"
    },
    {
      chainId: 1,
      address: "0x4161725d019690a3e0de50f6be67b07a86a9fae1",
      name: "TokenPocket Token",
      symbol: "TPT",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/7603/thumb/pocket.jpg?1696507861"
    },
    {
      chainId: 1,
      address: "0x758b4684be769e92eefea93f60dda0181ea303ec",
      name: "Phonon DAO",
      symbol: "PHONON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22308/thumb/ezgif-2-e7fb84364d.png?1696521653"
    },
    {
      chainId: 1,
      address: "0xb627a1bf727f578384ba18b2a2b46f4fb924ab3b",
      name: "P3PE HACKER",
      symbol: "P3PE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33219/thumb/download.png?1701088202"
    },
    {
      chainId: 1,
      address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
      name: "Celsius Network",
      symbol: "CEL",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/3263/thumb/CEL_logo.png?1696503976"
    },
    {
      chainId: 1,
      address: "0xa6a840e50bcaa50da017b91a0d86b8b2d41156ee",
      name: "EchoLink  OLD ",
      symbol: "EKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2437/thumb/echolink.png?1696503269"
    },
    {
      chainId: 1,
      address: "0xcb69b067d9d8d6dd1209fe4557c43586e54f9045",
      name: "Possum",
      symbol: "PSM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33596/thumb/PSM.png?1702521046"
    },
    {
      chainId: 1,
      address: "0xa57ed6e54be8125bbe45d6ca330e45ebb71ef11e",
      name: "NEWPEPE",
      symbol: "PEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31729/thumb/photo_2023-09-12_02-04-48_%282%29.jpg?1696530549"
    },
    {
      chainId: 1,
      address: "0xb197a6fdd8ab825332edeba1ab5c4d1bf97fb9a8",
      name: "Shibarium DAO",
      symbol: "SHIBDAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28881/thumb/200x200.png?1696527858"
    },
    {
      chainId: 1,
      address: "0x8888801af4d980682e47f1a9036e589479e835c5",
      name: "88mph",
      symbol: "MPH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13137/thumb/yfU-_Tcj_400x400.png?1696512923"
    },
    {
      chainId: 1,
      address: "0x92e187a03b6cd19cb6af293ba17f2745fd2357d5",
      name: "Unit Protocol",
      symbol: "DUCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13359/thumb/6f38719f-fe83-44ff-af30-7965fd23ac06.png?1696513124"
    },
    {
      chainId: 1,
      address: "0x1045f5ccb01daea4f8eab055f5fcbb7c0e7c89f0",
      name: "DeFiato",
      symbol: "DFIAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13386/thumb/Defiato.png?1696513149"
    },
    {
      chainId: 1,
      address: "0x1bfce574deff725a3f483c334b790e25c8fa9779",
      name: "Tao Ce i",
      symbol: "CETI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36097/thumb/CETI-BLACK-SMALL.png?1710481943"
    },
    {
      chainId: 1,
      address: "0x171120219d3223e008558654ec3254a0f206edb2",
      name: "XX Network",
      symbol: "XX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26670/thumb/skG_l3Eh_400x400.jpeg?1696525742"
    },
    {
      chainId: 1,
      address: "0xaa2d8c9a8bd0f7945143bfd509be3ff23dd78918",
      name: "Artizen",
      symbol: "ATNT",
      decimals: 3,
      logoURI: "https://assets.coingecko.com/coins/images/27263/thumb/ATNT-symbol_200.png?1696526315"
    },
    {
      chainId: 1,
      address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
      name: "ShapeShift FOX",
      symbol: "FOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9988/thumb/FOX.png?1696510025"
    },
    {
      chainId: 1,
      address: "0xc719d010b63e5bbf2c0551872cd5316ed26acd83",
      name: "Etherisc DIP",
      symbol: "DIP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4586/thumb/dip.png?1696505164"
    },
    {
      chainId: 1,
      address: "0x682f3317a8db21ba205dc84a0b7bd5010333bda7",
      name: "DAOGAME",
      symbol: "DAOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33320/thumb/logo_purple.png?1709643510"
    },
    {
      chainId: 1,
      address: "0x9a7703338730b82a803ba050df55f9b3959f3fb2",
      name: "Arise Chikun",
      symbol: "CHIKUN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31043/thumb/WJyGMMxM_400x400.jpg?1696529878"
    },
    {
      chainId: 1,
      address: "0x30dcba0405004cf124045793e1933c798af9e66a",
      name: "Yieldification",
      symbol: "YDF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26699/thumb/logo.png?1696525772"
    },
    {
      chainId: 1,
      address: "0x3f5dd1a1538a4f9f82e543098f01f22480b0a3a8",
      name: "KumaDex Token",
      symbol: "DKUMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26693/thumb/dkumaOG02_CoinGecko.png?1696525767"
    },
    {
      chainId: 1,
      address: "0x52662717e448be36cb54588499d5a8328bd95292",
      name: "Tenshi",
      symbol: "TENSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17170/thumb/TENSHI.png?1696516729"
    },
    {
      chainId: 1,
      address: "0x382e57ca8e4c4db9649884ca77b0a355692d14ac",
      name: "Xyxyx",
      symbol: "XYXYX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35483/thumb/xyxyx_logo.png?1708850265"
    },
    {
      chainId: 1,
      address: "0x8052327f1baf94a9dc8b26b9100f211ee3774f54",
      name: "A2DAO",
      symbol: "ATD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14509/thumb/Logo.jpg?1696514195"
    },
    {
      chainId: 1,
      address: "0xbd04ccc050058a6a422851fa6c0f92bb65eb06ca",
      name: "Pre Retogeum",
      symbol: "PRTG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27397/thumb/IMG_20220921_123729_913.jpg?1696526437"
    },
    {
      chainId: 1,
      address: "0x80122c6a83c8202ea365233363d3f4837d13e888",
      name: "MESSIER",
      symbol: "M87",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25957/thumb/MESSIERlogonew_%281%29.png?1696525036"
    },
    {
      chainId: 1,
      address: "0xc55126051b22ebb829d00368f4b12bde432de5da",
      name: "Redacted",
      symbol: "BTRFLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26745/thumb/redacted_v2.jpg?1696525813"
    },
    {
      chainId: 1,
      address: "0x6a445e9f40e0b97c92d0b8a3366cef1d67f700bf",
      name: "Fidu",
      symbol: "FIDU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25944/thumb/GFI-asset-icon.png?1696525023"
    },
    {
      chainId: 1,
      address: "0xb9d7dddca9a4ac480991865efef82e01273f79c3",
      name: "Boosted LUSD",
      symbol: "BLUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27681/thumb/bLUSD_logo.png?1696526709"
    },
    {
      chainId: 1,
      address: "0x9b81686140e85d28c2236c307dd49b422a663edf",
      name: "Combustion",
      symbol: "FIRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31044/thumb/T-wqdlHF_400x400.jpg?1696529879"
    },
    {
      chainId: 1,
      address: "0x4b13006980acb09645131b91d259eaa111eaf5ba",
      name: "Mycelium",
      symbol: "MYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26874/thumb/MYC_Token.png?1696525933"
    },
    {
      chainId: 1,
      address: "0xd291e7a03283640fdc51b121ac401383a46cc623",
      name: "Rari Governance",
      symbol: "RGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12900/thumb/Rari_Logo_Transparent.png?1696512688"
    },
    {
      chainId: 1,
      address: "0x486f4641ef2b50cc130dadbd27b6f271723873b8",
      name: "Adventurer Gold",
      symbol: "GOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28427/thumb/anon-npc-pixel.png?1696527424"
    },
    {
      chainId: 1,
      address: "0x8e0e57dcb1ce8d9091df38ec1bfc3b224529754a",
      name: "Moon Tropica",
      symbol: "CAH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28470/thumb/MTLOGO.png?1696527464"
    },
    {
      chainId: 1,
      address: "0x5a8291d0f1836726aea75b979a92a47be1ff0cba",
      name: "Cremate",
      symbol: "CRMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33323/thumb/crematelogo.jpeg?1701437525"
    },
    {
      chainId: 1,
      address: "0x9c4a4204b79dd291d6b6571c5be8bbcd0622f050",
      name: "Tracer DAO",
      symbol: "TCR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18271/thumb/tracer_logo.png?1696517765"
    },
    {
      chainId: 1,
      address: "0xa41f142b6eb2b164f8164cae0716892ce02f311f",
      name: "Avocado DAO",
      symbol: "AVG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21102/thumb/logo192_%281%29.png?1696520483"
    },
    {
      chainId: 1,
      address: "0x954a75564cb355ea2d6fccc6c1212fd01fdcb06f",
      name: "PLUMPY DRAGONS",
      symbol: "LOONG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35356/thumb/LOONG.png?1711333621"
    },
    {
      chainId: 1,
      address: "0xf25304e75026e6a35fedca3b0889ae5c4d3c55d8",
      name: "Viridis Network",
      symbol: "VRD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32709/thumb/200x200.png?1698986518"
    },
    {
      chainId: 1,
      address: "0x6c6e2c5a4eb108a1f3c985d5a7f4f233483e952f",
      name: "Etherscape",
      symbol: "SCAPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35408/thumb/Basescape.jpeg?1714884857"
    },
    {
      chainId: 1,
      address: "0x9e32b13ce7f2e80a01932b42553652e053d6ed8e",
      name: "Metis",
      symbol: "METIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15595/thumb/Metis_Black_Bg.png?1702968192"
    },
    {
      chainId: 1,
      address: "0xc2aeedc081d4cb6797a681e9403a82211f97b308",
      name: "Zeal AI",
      symbol: "ZAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35487/thumb/photo_6246877151911591329_y_%282%29.jpg?1708878103"
    },
    {
      chainId: 1,
      address: "0x434cb4fc4b952872967914d430878eee53ebd502",
      name: "ALLPAYCOIN",
      symbol: "APCG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26836/thumb/apcg.png?1696525895"
    },
    {
      chainId: 1,
      address: "0xd9c2d319cd7e6177336b0a9c93c21cb48d84fb54",
      name: "HAPI",
      symbol: "HAPI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14298/thumb/Hapi_logo_square_%281%29.png?1696513995"
    },
    {
      chainId: 1,
      address: "0x42496acd2c7b52ce90ed65ada6cafb0e893e2474",
      name: "BitSwap",
      symbol: "BITS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36633/thumb/BitSwapLogo_%282%29.png?1712022617"
    },
    {
      chainId: 1,
      address: "0x44af2390d7ed22966d3e570bffb648817e4335f0",
      name: "Kaarigar Connect",
      symbol: "KARCON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37178/thumb/logo_karcon.png?1713512944"
    },
    {
      chainId: 1,
      address: "0x73a83269b9bbafc427e76be0a2c1a1db2a26f4c2",
      name: "Civfund Stone",
      symbol: "0NE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25156/thumb/stone.png?1696524304"
    },
    {
      chainId: 1,
      address: "0xef19f4e48830093ce5bc8b3ff7f903a0ae3e9fa1",
      name: "BOTXCOIN",
      symbol: "BOTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6827/thumb/botx.jpg?1696507152"
    },
    {
      chainId: 1,
      address: "0x050d94685c6b0477e1fc555888af6e2bb8dfbda5",
      name: "Inu ",
      symbol: "INU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26259/thumb/inu_tongue_small.gif?1714581358"
    },
    {
      chainId: 1,
      address: "0x03be5c903c727ee2c8c4e9bc0acc860cca4715e2",
      name: "Ternoa",
      symbol: "CAPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15921/thumb/e55393fa-7b4d-40f5-9f36-9a8a6bdcb570.png?1696515534"
    },
    {
      chainId: 1,
      address: "0x678e840c640f619e17848045d23072844224dd37",
      name: "Cratos",
      symbol: "CRTS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17322/thumb/cratos.png?1696516876"
    },
    {
      chainId: 1,
      address: "0x6dca182ac5e3f99985bc4ee0f726d6472ab1ec55",
      name: "Ushi",
      symbol: "USHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27865/thumb/photo_2022-10-17_22-21-01.jpg?1696526883"
    },
    {
      chainId: 1,
      address: "0xaa95f26e30001251fb905d264aa7b00ee9df6c18",
      name: "Kendu Inu",
      symbol: "KENDU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35722/thumb/photo_2024-03-05_01-23-59_%281%29.jpg?1709632285"
    },
    {
      chainId: 1,
      address: "0xca30c93b02514f86d5c86a6e375e3a330b435fb5",
      name: "Backed IB01   Treasury Bond 0 1yr",
      symbol: "BIB01",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31755/thumb/b-IB01-200x200.png?1696530574"
    },
    {
      chainId: 1,
      address: "0x3c4008eca800ec1283e4cf500e68d06bfabc00a8",
      name: "HistoryDAO",
      symbol: "HAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27318/thumb/5961657012978_.pic.jpg?1696526367"
    },
    {
      chainId: 1,
      address: "0x0cba60ca5ef4d42f92a5070a8fedd13be93e2861",
      name: "The Protocol",
      symbol: "THE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27849/thumb/cSar5sDM_400x400.jpg?1696526868"
    },
    {
      chainId: 1,
      address: "0xf12ccd17759367cf139776710b47b00c43d1ac2b",
      name: "emoji ERC20",
      symbol: "EMOJI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34635/thumb/8CC1B5C8-A5E2-45E0-BDEE-404DE38B7C8C.jpeg?1705852614"
    },
    {
      chainId: 1,
      address: "0x992d339532a9c42f1b0e59a57e95f38da38c66f6",
      name: "Soulsaver",
      symbol: "SOUL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27494/thumb/SOUL_LOGO.png?1696526534"
    },
    {
      chainId: 1,
      address: "0x20f031e2eca9e9247eb8c57bab5db9a1daa9c5d1",
      name: "PiuAi",
      symbol: "PAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35488/thumb/200.png?1708879739"
    },
    {
      chainId: 1,
      address: "0x205ed31c867bf715e4182137af95afe9177cd8e7",
      name: "DEFY",
      symbol: "DEFY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26877/thumb/8ybr83fb0ca45cm1yvrcaclwbvcp.jpeg?1696525936"
    },
    {
      chainId: 1,
      address: "0x244517dc59943e8cdfbd424bdb3262c5f04a1387",
      name: "Fluid DAI",
      symbol: "FDAI",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/28473/thumb/fDAI-200x200.png?1696527467"
    },
    {
      chainId: 1,
      address: "0x06576eb3b212d605b797dc15523d9dc9f4f66db4",
      name: "The Crypto Prophecies",
      symbol: "TCP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15054/thumb/tcp.PNG?1696514713"
    },
    {
      chainId: 1,
      address: "0xadc234a4e90e2045f353f5d4fcde66144d23b458",
      name: "Fluid USDT",
      symbol: "FUSDT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/28472/thumb/fUSDT-200x200.png?1696527466"
    },
    {
      chainId: 1,
      address: "0x3be7bf1a5f23bd8336787d0289b70602f1940875",
      name: "VIDT DAO",
      symbol: "VIDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27552/thumb/VIDTDAO_logo.png?1696526588"
    },
    {
      chainId: 1,
      address: "0xbd1848e1491d4308ad18287a745dd4db2a4bd55b",
      name: "Mochi Market",
      symbol: "MOMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14993/thumb/mochi.PNG?1696514657"
    },
    {
      chainId: 1,
      address: "0xb3e2cb7cccfe139f8ff84013823bf22da6b6390a",
      name: "Deutsche Digital Assets",
      symbol: "ICNQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7830/thumb/dda_logo_small.jpg?1696508067"
    },
    {
      chainId: 1,
      address: "0xbea269038eb75bdab47a9c04d0f5c572d94b93d5",
      name: "Wrapped FIO",
      symbol: "WFIO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29183/thumb/fio_light_favicon_transparent_200x200.png?1696528141"
    },
    {
      chainId: 1,
      address: "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b",
      name: "Rally",
      symbol: "RLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12843/thumb/image.png?1696512633"
    },
    {
      chainId: 1,
      address: "0x52a163f4cef6a42fa6b17e0f2a773fc149547c9c",
      name: "BANGER",
      symbol: "BANGER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32881/thumb/banger200x200.png?1699712080"
    },
    {
      chainId: 1,
      address: "0x77f9cf0bd8c500cffdf420e72343893aecc2ec0b",
      name: "Laika",
      symbol: "LAIKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26717/thumb/Laikacmcfinal.png?1696525787"
    },
    {
      chainId: 1,
      address: "0xdd2a36ae937bc134ea694d77fc7e2e36f5d86de0",
      name: "WELD",
      symbol: "WELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18544/thumb/weld.png?1696518023"
    },
    {
      chainId: 1,
      address: "0x757da0e5c253082b0f2bd5105119f71817fe0911",
      name: "Very Special Dragon",
      symbol: "VITO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28527/thumb/Vito200.png?1696527519"
    },
    {
      chainId: 1,
      address: "0x4d5f47fa6a74757f35c14fd3a6ef8e3c9bc514e8",
      name: "Aave v3 WETH",
      symbol: "AWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32882/thumb/WETH_%281%29.png?1699716492"
    },
    {
      chainId: 1,
      address: "0x2f1ee92524285012c02a4e638ec010fa7f61fd94",
      name: "Siphon Life Spell",
      symbol: "SLS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34667/thumb/photo_2024-01-17_04-21-27.jpg?1705654454"
    },
    {
      chainId: 1,
      address: "0x426aedbed16726e3f220cb4fed4d4060b95cca46",
      name: "Bahamas",
      symbol: "BAHAMAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34089/thumb/Bahamas_Logo_200x200.png?1703911941"
    },
    {
      chainId: 1,
      address: "0x5ee5bf7ae06d1be5997a1a72006fe6c607ec6de8",
      name: "Aave v3 WBTC",
      symbol: "AWBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32883/thumb/wbtc.png?1699719908"
    },
    {
      chainId: 1,
      address: "0xfbe6f37d3db3fc939f665cfe21238c11a5447831",
      name: "ETH 2 0",
      symbol: "ETH20",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32079/thumb/BSk76OA8_400x400.jpg?1696530878"
    },
    {
      chainId: 1,
      address: "0x8eb94a06b4716093dbfe335cbdb098deb2dcde1b",
      name: "Half Shiba Inu",
      symbol: "SHIB05",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28957/thumb/halfshib.jpg?1696527930"
    },
    {
      chainId: 1,
      address: "0xe88f8313e61a97cec1871ee37fbbe2a8bf3ed1e4",
      name: "Sora Validator",
      symbol: "VAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13299/thumb/val-gold-256.png?1696513070"
    },
    {
      chainId: 1,
      address: "0xc744df3419a8c9bd4d6b9852a503eb1c5308a326",
      name: "RED TOKEN",
      symbol: "RED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27153/thumb/red.png?1696526204"
    },
    {
      chainId: 1,
      address: "0xe5a3229ccb22b6484594973a03a3851dcd948756",
      name: "Receive Access Ecosystem",
      symbol: "RAE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9428/thumb/Copy_of_raetoken.png?1696509521"
    },
    {
      chainId: 1,
      address: "0x8a8116a794744977941c7d3743517410969aacbb",
      name: "Shiba Punkz",
      symbol: "SPUNK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27163/thumb/shibapunkzlogo.JPG?1696526213"
    },
    {
      chainId: 1,
      address: "0xaa0c5b3567fd1bac8a2a11eb16c3f81a49eea90f",
      name: "MetamonkeyAi",
      symbol: "MMAI",
      decimals: 7,
      logoURI: "https://assets.coingecko.com/coins/images/27208/thumb/mmai_new_logo.png?1696526256"
    },
    {
      chainId: 1,
      address: "0xe9f84d418b008888a992ff8c6d22389c2c3504e0",
      name: "Maximus BASE",
      symbol: "BASE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/27683/thumb/IMG_1131.PNG?1696526711"
    },
    {
      chainId: 1,
      address: "0x1ccf27211e8bf052f6255329ed641b4e94e80603",
      name: "Metababy",
      symbol: "BABY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27175/thumb/7psZaqh0_400x400.jpeg?1696526225"
    },
    {
      chainId: 1,
      address: "0x465a5a630482f3abd6d3b84b39b29b07214d19e5",
      name: "Flux USDC",
      symbol: "FUSDC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29051/thumb/fUSDC_200x200.png?1696528018"
    },
    {
      chainId: 1,
      address: "0xf55cd1e399e1cc3d95303048897a680be3313308",
      name: "Maximus TRIO",
      symbol: "TRIO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/27684/thumb/IMG_1127.PNG?1696526712"
    },
    {
      chainId: 1,
      address: "0xeaf61fc150cd5c3bea75744e830d916e60ea5a9f",
      name: "Typerium",
      symbol: "TYPE",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/4019/thumb/type.png?1696504657"
    },
    {
      chainId: 1,
      address: "0x64b78325d7495d6d4be92f234fa3f3b8d8964b8b",
      name: "Shopping io",
      symbol: "SHOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27242/thumb/shop.png?1696526292"
    },
    {
      chainId: 1,
      address: "0x0b319db00d07c8fadfaaef13c910141a5da0aa8f",
      name: "Fluid TUSD",
      symbol: "FTUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28474/thumb/fTUSD-200x200.png?1696527468"
    },
    {
      chainId: 1,
      address: "0x6b0956258ff7bd7645aa35369b55b61b8e6d6140",
      name: "Maximus LUCKY",
      symbol: "LUCKY",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/27685/thumb/IMG_1129.PNG?1696526713"
    },
    {
      chainId: 1,
      address: "0x777172d858dc1599914a1c4c6c9fc48c99a60990",
      name: "Solidly",
      symbol: "SOLID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28676/thumb/solid_logo_200.png?1701687346"
    },
    {
      chainId: 1,
      address: "0xdbecdd726f6ad8e24afc78fe3cc8eb7b73c2d94d",
      name: "Chaintools",
      symbol: "CTLS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30896/thumb/IMG_0501.png?1696529742"
    },
    {
      chainId: 1,
      address: "0xbe92b510007bd3ec0adb3d1fca338dd631e98de7",
      name: "DegensTogether",
      symbol: "DEGEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30487/thumb/degen_logo_twit.png?1696529373"
    },
    {
      chainId: 1,
      address: "0x291aa47c58558adfc2bcd6f060578fdae1f6570c",
      name: "Minebase",
      symbol: "MBASE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27313/thumb/mbase.png?1696526362"
    },
    {
      chainId: 1,
      address: "0x5891599664ed15c6e88041b4f5bc08594f026f0e",
      name: "JPGoldCoin",
      symbol: "JPGC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27321/thumb/JPGC_LOGO-_Coingecko.png?1696526370"
    },
    {
      chainId: 1,
      address: "0xb4272071ecadd69d933adcd19ca99fe80664fc08",
      name: "CryptoFranc",
      symbol: "XCHF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8465/thumb/WhuiuJBc_400x400.jpg?1696508650"
    },
    {
      chainId: 1,
      address: "0x37f678ad6221a0fd71cda0eca19c8802f4cabf44",
      name: "YUKKY",
      symbol: "YUKKY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30512/thumb/200GpSL05ul_400x400.jpg?1696529397"
    },
    {
      chainId: 1,
      address: "0x3f817b28da4940f018c6b5c0a11c555ebb1264f9",
      name: "3A",
      symbol: "A3A",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33135/thumb/A3A.png?1700801023"
    },
    {
      chainId: 1,
      address: "0x23b586c0e79fb291ccb0244d468847eae9bb90f6",
      name: "R4RE",
      symbol: "R4RE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36559/thumb/R4RE.png?1711902279"
    },
    {
      chainId: 1,
      address: "0xbe042e9d09cb588331ff911c2b46fd833a3e5bd6",
      name: "Pepe Token",
      symbol: "PEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31482/thumb/photo_2023-08-25_07-54-16.jpg?1696530294"
    },
    {
      chainId: 1,
      address: "0x142a774e8b52550e88e196cedd7a5835acb646d0",
      name: "SaitaRealty",
      symbol: "SRLTY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27289/thumb/s_mksCdB_400x400.jpeg?1696526341"
    },
    {
      chainId: 1,
      address: "0xd7c49cee7e9188cca6ad8ff264c1da2e69d4cf3b",
      name: "Nexus Mutual",
      symbol: "NXM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11810/thumb/NXMmain.png?1696511684"
    },
    {
      chainId: 1,
      address: "0x5c1a467e12150864ea15bd394dac3801c2ca3cb0",
      name: "Gamma Wallet",
      symbol: "GAMMA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33221/thumb/GammaWallet.png?1701088418"
    },
    {
      chainId: 1,
      address: "0xba93ef534094f8b7001ece2691168140965341ab",
      name: "Beauty Bakery Linked Operation Transact",
      symbol: "LOTT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27688/thumb/LOTT.jpg?1696526716"
    },
    {
      chainId: 1,
      address: "0x095797fd4297fb79883cc912a5ba6313b15c445d",
      name: "GOLCOIN",
      symbol: "GOLC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27341/thumb/logo_in_the_middle_.png?1696526388"
    },
    {
      chainId: 1,
      address: "0x238cefec182679c27a3035713416fa0a8198b302",
      name: "GoodMeme",
      symbol: "GMEME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30325/thumb/gmeme200smol.png?1696529226"
    },
    {
      chainId: 1,
      address: "0xd75f1f81b69bdd4df8efbb70e9c6f4609009d753",
      name: "YASHA",
      symbol: "YASHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24040/thumb/oX9E7Q7.png?1696523231"
    },
    {
      chainId: 1,
      address: "0x4bdcb66b968060d9390c1d12bd29734496205581",
      name: "Acquire Fi",
      symbol: "ACQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27199/thumb/ACQisotypeSept2022_1000x1000px.png?1696526248"
    },
    {
      chainId: 1,
      address: "0xe2ba8693ce7474900a045757fe0efca900f6530b",
      name: "Flux DAI",
      symbol: "FDAI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29052/thumb/fDAI_200x200.png?1696528019"
    },
    {
      chainId: 1,
      address: "0x72e4f9f808c49a2a61de9c5896298920dc4eeea9",
      name: "HarryPotterObamaSonic10Inu  ETH ",
      symbol: "BITCOIN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/30323/thumb/hpos10i_logo_casino_night-dexview.png?1696529224"
    },
    {
      chainId: 1,
      address: "0x8526be2379e853d5cf02f9823bb9690e1a6ff9e2",
      name: "Habibi",
      symbol: "HABIBI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30683/thumb/HABIBI.png?1696529552"
    },
    {
      chainId: 1,
      address: "0xf951e335afb289353dc249e82926178eac7ded78",
      name: "Swell Ethereum",
      symbol: "SWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30326/thumb/_lB7zEtS_400x400.jpg?1696529227"
    },
    {
      chainId: 1,
      address: "0x8326bf664704966c984a3a46fa37d7a80a52dcf4",
      name: "Dogu Inu",
      symbol: "DOGU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28492/thumb/Coingecko_Dogu_Inu_logo.jpg?1696527485"
    },
    {
      chainId: 1,
      address: "0xa888d9616c2222788fa19f05f77221a290eef704",
      name: "Daruma",
      symbol: "DARUMA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27357/thumb/CGlogo.png?1696526403"
    },
    {
      chainId: 1,
      address: "0x6b32022693210cd2cfc466b9ac0085de8fc34ea6",
      name: "Maximus DECI",
      symbol: "DECI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/27693/thumb/Deci.png?1696526720"
    },
    {
      chainId: 1,
      address: "0x0c90c57aaf95a3a87eadda6ec3974c99d786511f",
      name: "HanChain",
      symbol: "HAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27374/thumb/logo_200.png?1696526418"
    },
    {
      chainId: 1,
      address: "0xc5bcc8ba3f33ab0d64f3473e861bdc0685b19ef5",
      name: "Mechanium",
      symbol: "MECHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24374/thumb/w4K4OOMo_400x400.jpg?1696523558"
    },
    {
      chainId: 1,
      address: "0x32ea3dc70e2962334864a9665254d2433e4ddbfd",
      name: "Sportzchain",
      symbol: "SPN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24915/thumb/Sportzchain_logo_195_195.png?1696524072"
    },
    {
      chainId: 1,
      address: "0xa49d7499271ae71cd8ab9ac515e6694c755d400c",
      name: "Mute",
      symbol: "MUTE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14331/thumb/MUTE.png?1696514019"
    },
    {
      chainId: 1,
      address: "0xd433138d12beb9929ff6fd583dc83663eea6aaa5",
      name: "Bitrue Coin",
      symbol: "BTR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8873/thumb/Bittrue_logo.png?1696509025"
    },
    {
      chainId: 1,
      address: "0xdc349913d53b446485e98b76800b6254f43df695",
      name: "Bezoge Earth",
      symbol: "BEZOGE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15639/thumb/token-logo.png?1696515271"
    },
    {
      chainId: 1,
      address: "0xe453c3409f8ad2b1fe1ed08e189634d359705a5b",
      name: "DGI Game",
      symbol: "DGI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34658/thumb/DGI_Game.png?1705633633"
    },
    {
      chainId: 1,
      address: "0xf90c7f66eac7e2130bf677d69a250b2136cf6697",
      name: "HAKI Token",
      symbol: "HAKI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7945/thumb/haki.png?1696508175"
    },
    {
      chainId: 1,
      address: "0xf9d4daae1300cff251979722c4a3c45857973079",
      name: "bitcastle",
      symbol: "CASTLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26551/thumb/blue_logo03.png?1696525624"
    },
    {
      chainId: 1,
      address: "0xf86cfce1e746456135d7face48c2916d7d3cb676",
      name: "Everflow Token",
      symbol: "EFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36307/thumb/everflow-logo.4884c463824dcb062e4b.png?1711090157"
    },
    {
      chainId: 1,
      address: "0x8a7664e782860e856031d6c31eb3bde721bc362b",
      name: "RektSkulls",
      symbol: "REKT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28910/thumb/REKT_icon_200.png?1696527886"
    },
    {
      chainId: 1,
      address: "0xf3b9569f82b18aef890de263b84189bd33ebe452",
      name: "A Hunters Dream",
      symbol: "CAW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25130/thumb/x-Logo-color-10x.png?1696524280"
    },
    {
      chainId: 1,
      address: "0x1bf7fd22709733ccd7c45ab27dd02c7ec8e50078",
      name: "Quiztok",
      symbol: "QTCON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8208/thumb/QTCON.png?1696508415"
    },
    {
      chainId: 1,
      address: "0x7f280dac515121dcda3eac69eb4c13a52392cace",
      name: "Fancy Games",
      symbol: "FNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21367/thumb/fnc.png?1696520733"
    },
    {
      chainId: 1,
      address: "0x36f8d0d0573ae92326827c4a82fe4ce4c244cab6",
      name: "Morpho Aave Dai Stablecoin",
      symbol: "MADAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29836/thumb/maDAI.jpg?1696528763"
    },
    {
      chainId: 1,
      address: "0x5c0590cde44569bf39ef79e859b367e39cb000f1",
      name: "hiVALHALLA",
      symbol: "HIVALHALLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28911/thumb/hiVALHALLA.png?1696527887"
    },
    {
      chainId: 1,
      address: "0x2d869ae129e308f94cc47e66eaefb448cee0d03e",
      name: "OraiDEX",
      symbol: "ORAIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28104/thumb/oraix.png?1696527113"
    },
    {
      chainId: 1,
      address: "0x1ce270557c1f68cfb577b856766310bf8b47fd9c",
      name: "MongCoin",
      symbol: "MONG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30051/thumb/h3OCGNvn_400x400.jpg?1696528973"
    },
    {
      chainId: 1,
      address: "0xa35b1b31ce002fbf2058d22f30f95d405200a15b",
      name: "Stader ETHx",
      symbol: "ETHX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30870/thumb/staderx.png?1696529717"
    },
    {
      chainId: 1,
      address: "0xb8b295df2cd735b15be5eb419517aa626fc43cd5",
      name: "Staked LINK",
      symbol: "STLINK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29271/thumb/ST.LINK_tokenl_blue.png?1696528224"
    },
    {
      chainId: 1,
      address: "0x66580f80a00deafab4519dc33c35bf44d8a12b00",
      name: "LiqWrap",
      symbol: "LQW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31584/thumb/logo_1.png?1696530401"
    },
    {
      chainId: 1,
      address: "0x848578e351d25b6ec0d486e42677891521c3d743",
      name: "moSOLID",
      symbol: "MOSOLID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28677/thumb/black_mono_logopng.png?1696527661"
    },
    {
      chainId: 1,
      address: "0x1776e1f26f98b1a5df9cd347953a26dd3cb46671",
      name: "Numeraire",
      symbol: "NMR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/752/thumb/numeraire.png?1696501906"
    },
    {
      chainId: 1,
      address: "0x40986a85b4cfcdb054a6cbfb1210194fee51af88",
      name: "UniFarm",
      symbol: "UFARM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15247/thumb/ufarm.jpeg?1696514900"
    },
    {
      chainId: 1,
      address: "0x6923f9b683111dcc0e20124e9a031deeae5dad93",
      name: "Crypto Hub",
      symbol: "HUB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32705/thumb/Untitled_design_%285%29.png?1698985521"
    },
    {
      chainId: 1,
      address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
      name: "Lambda",
      symbol: "LAMB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4703/thumb/lambda_200.png?1696505268"
    },
    {
      chainId: 1,
      address: "0xa02120696c7b8fe16c09c749e4598819b2b0e915",
      name: "WXT Token",
      symbol: "WXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8835/thumb/Wirex.jpg?1696508988"
    },
    {
      chainId: 1,
      address: "0x8c088775e4139af116ac1fa6f281bbf71e8c1c73",
      name: "PUMLx",
      symbol: "PUMLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27253/thumb/pumlx.png?1696526302"
    },
    {
      chainId: 1,
      address: "0x7105e64bf67eca3ae9b123f0e5ca2b83b2ef2da0",
      name: "X7DAO",
      symbol: "X7DAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27709/thumb/X7DAO.png?1696526735"
    },
    {
      chainId: 1,
      address: "0x70008f18fc58928dce982b0a69c2c21ff80dca54",
      name: "X7R",
      symbol: "X7R",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27710/thumb/X7R.png?1696526736"
    },
    {
      chainId: 1,
      address: "0xa5269a8e31b93ff27b887b56720a25f844db0529",
      name: "Morpho Aave USD Coin",
      symbol: "MAUSDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29835/thumb/maUSDC.jpg?1696528762"
    },
    {
      chainId: 1,
      address: "0x07f9702ce093db82dfdc92c2c6e578d6ea8d5e22",
      name: "Oobit",
      symbol: "OBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19855/thumb/obt.png?1696519278"
    },
    {
      chainId: 1,
      address: "0xb15a5aab2a65745314fcd0d7f5080bfa65bd7c03",
      name: "tupelothedog",
      symbol: "TUPELO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34885/thumb/tupelothedog.png?1706538842"
    },
    {
      chainId: 1,
      address: "0xc881255e4d639b42e326158c7b8ccb7f33459261",
      name: "AMMX",
      symbol: "AMMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34546/thumb/ammx_2.png?1705413208"
    },
    {
      chainId: 1,
      address: "0x1376a81fe3ee7d0e431f1ac24286b00f3ccf44e7",
      name: "Welle",
      symbol: "WELLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32715/thumb/WELLE-TKN-1.png?1699000890"
    },
    {
      chainId: 1,
      address: "0xfa3e941d1f6b7b10ed84a0c211bfa8aee907965e",
      name: "HayCoin",
      symbol: "HAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32336/thumb/haycoin.jpeg?1698308493"
    },
    {
      chainId: 1,
      address: "0x674c964ac0e89d847d6b0abd144b797bf78ba56b",
      name: "GreenWorld",
      symbol: "GWD",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/27771/thumb/200x200logo.png?1696526792"
    },
    {
      chainId: 1,
      address: "0x72953a5c32413614d24c29c84a66ae4b59581bbf",
      name: "CLever",
      symbol: "CLEV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27727/thumb/%E6%88%AA%E5%B1%8F2022-10-12_%E4%B8%8A%E5%8D%8810.40.19.png?1696526751"
    },
    {
      chainId: 1,
      address: "0x2e516ba5bf3b7ee47fb99b09eadb60bde80a82e0",
      name: "Eggs",
      symbol: "EGGS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29024/thumb/egg200x200.png?1696527994"
    },
    {
      chainId: 1,
      address: "0x71eeba415a523f5c952cc2f06361d5443545ad28",
      name: "XDAO",
      symbol: "XDAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27363/thumb/token_2.png?1696526408"
    },
    {
      chainId: 1,
      address: "0x9dc9d1c18060b45f3dc15fb8d6ab1895022c63b3",
      name: "BitBullBot",
      symbol: "BBB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34262/thumb/BitBullBot.jpg?1704387899"
    },
    {
      chainId: 1,
      address: "0x9008064e6cf73e27a3aba4b10e69f855a4f8efcc",
      name: "Gemie",
      symbol: "GEM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27745/thumb/icon-transparent.png?1696526767"
    },
    {
      chainId: 1,
      address: "0xa6a1cc527d48585538b137e6abc14b2a55489d11",
      name: "Linework Coin",
      symbol: "LWC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/27739/thumb/Linework-logo_coin_200px-01.png?1696526762"
    },
    {
      chainId: 1,
      address: "0xba41ddf06b7ffd89d1267b5a93bfef2424eb2003",
      name: "Mythos",
      symbol: "MYTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28045/thumb/Mythos_Logos_200x200.png?1696527059"
    },
    {
      chainId: 1,
      address: "0x0ec72cd6690db40b16be166858299f19d4f8e5b0",
      name: "Teh Golden One",
      symbol: "GOLD1",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27290/thumb/teh_golden_one_200x200.png?1696526342"
    },
    {
      chainId: 1,
      address: "0x892a6f9df0147e5f079b0993f486f9aca3c87881",
      name: "xFUND",
      symbol: "XFUND",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/13770/thumb/xfund.png?1696513512"
    },
    {
      chainId: 1,
      address: "0xe2cfbbedbce1bd59b1b799c44282e6396d692b84",
      name: "Dexioprotocol",
      symbol: "DEXIO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27075/thumb/DEXI_cirle_R.png?1696526125"
    },
    {
      chainId: 1,
      address: "0x881ba05de1e78f549cc63a8f6cabb1d4ad32250d",
      name: "00 Token",
      symbol: "00",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27742/thumb/200x200.png?1696526765"
    },
    {
      chainId: 1,
      address: "0x0dcee5f694e492f0dd842a7fbe5bed4c6e4665a6",
      name: "Catboy",
      symbol: "CATBOY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33891/thumb/200x200.png?1703213224"
    },
    {
      chainId: 1,
      address: "0x95cba664fa19d2c24b6d60b707dfa7879b51fd57",
      name: "ApeGPT",
      symbol: "APEGPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34222/thumb/logo200.png?1704298130"
    },
    {
      chainId: 1,
      address: "0xb4357054c3da8d46ed642383f03139ac7f090343",
      name: "Port3 Network",
      symbol: "PORT3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33383/thumb/port3-bc-200x200.png?1710075114"
    },
    {
      chainId: 1,
      address: "0x7cc97bf17c5adabe25f9d19d15a1ec8a1ad65f14",
      name: "Wolverinu",
      symbol: "WOLVERINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27872/thumb/LOGO3232.jpg?1696526890"
    },
    {
      chainId: 1,
      address: "0xb04bf60e468743418e87291d7c9301a5299d984d",
      name: "FOREVER SHIBA",
      symbol: "4SHIBA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29110/thumb/4shiba_logo.png?1696528073"
    },
    {
      chainId: 1,
      address: "0x9d7107c8e30617cadc11f9692a19c82ae8bba938",
      name: "Lucky Roo",
      symbol: "ROO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27943/thumb/lucky200.png?1696526962"
    },
    {
      chainId: 1,
      address: "0xfa93660c3f6a848556bb8e265f994160a1f2b289",
      name: "Community Business Token",
      symbol: "CBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14701/thumb/CBT-Token-Small.png?1696514372"
    },
    {
      chainId: 1,
      address: "0xd624e5c89466a15812c1d45ce1533be1f16c1702",
      name: "UBD Network",
      symbol: "UBDN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33678/thumb/UBD_Network.png?1702717194"
    },
    {
      chainId: 1,
      address: "0x42dbbd5ae373fea2fc320f62d44c058522bb3758",
      name: "Memecoin",
      symbol: "MEM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16370/thumb/mem_gold_200x200_copy.png?1696515969"
    },
    {
      chainId: 1,
      address: "0xe9514a6eba63a0bbbe2faea919e773ebe0f527c1",
      name: "Kekcoin  ETH ",
      symbol: "KEK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33224/thumb/Kekcoin_BTC.png?1701089230"
    },
    {
      chainId: 1,
      address: "0x69ed89ecd35082e031fe52b75123f801db083306",
      name: "Kaeri",
      symbol: "KAERI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27977/thumb/63370e2a1f2bea31fc7f6977_512x512_v2-p-500-2.png?1696526995"
    },
    {
      chainId: 1,
      address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
      name: "ARPA",
      symbol: "ARPA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8506/thumb/9u0a23XY_400x400.jpg?1696508685"
    },
    {
      chainId: 1,
      address: "0x23a2164d482fd2fec9c2d0b66528d42fee7b8817",
      name: "met a meta metameme",
      symbol: "METAMEME",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33679/thumb/logo200x200.jpg?1702718320"
    },
    {
      chainId: 1,
      address: "0x1e917e764bc34d3bc313fe8159a6bd9d9ffd450d",
      name: "WEWE",
      symbol: "WEWE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30458/thumb/IMG_3939.JPG?1696529345"
    },
    {
      chainId: 1,
      address: "0xde9804cc479164fa9e9cb59ad4e65012a12aa827",
      name: "GroceryFi",
      symbol: "GFI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36673/thumb/GfiPng200.png?1712062167"
    },
    {
      chainId: 1,
      address: "0x77a90b04d64189d4d09508612c09219bc6816bdc",
      name: "Toshi Tools",
      symbol: "TOSHI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28959/thumb/toshi_logo_200_by_200.png?1696527932"
    },
    {
      chainId: 1,
      address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
      name: "IQ",
      symbol: "IQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5010/thumb/YAIS3fUh.png?1696505542"
    },
    {
      chainId: 1,
      address: "0x6cd079f296c10eb84a64239b893d4edfa2e1d779",
      name: "PulseCrypt",
      symbol: "PLSCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29776/thumb/PulseCrypt.jpg?1696528707"
    },
    {
      chainId: 1,
      address: "0xaa68fd12a3b0f7aea66fe8f7111ae3f8d9ac5058",
      name: "Tweety",
      symbol: "TWEETY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30861/thumb/tweety_logo.png?1696529708"
    },
    {
      chainId: 1,
      address: "0x31adda225642a8f4d7e90d4152be6661ab22a5a2",
      name: "Hypr Network",
      symbol: "HYPR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33071/thumb/655412078d33fa9fee8e3a1b_hypr_logo_200.png?1700598490"
    },
    {
      chainId: 1,
      address: "0x70d0ff0d3b3f5e69220c09befc70606fa5f89293",
      name: "hiUNDEAD",
      symbol: "HIUNDEAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29031/thumb/hiundead.png?1696528001"
    },
    {
      chainId: 1,
      address: "0xf433089366899d83a9f26a773d59ec7ecf30355e",
      name: "Metal DAO",
      symbol: "MTL",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/763/thumb/Metal.png?1696501916"
    },
    {
      chainId: 1,
      address: "0x294559fa758c88d639fd085751e463fee7806eab",
      name: "Metal Blockchain",
      symbol: "METAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27222/thumb/MB-Logo.png?1710514210"
    },
    {
      chainId: 1,
      address: "0xb045f7f363fe4949954811b113bd56d208c67b23",
      name: "Spider Tanks",
      symbol: "SILK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/28057/thumb/SILK_Logo.png?1696527069"
    },
    {
      chainId: 1,
      address: "0x42dae489f1ca3764aabe1907c22bc18776415fcd",
      name: "VibingCatToken",
      symbol: "VCT",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0x109548dc14c0b8d7908a168202a4ab08bb449613",
      name: "Cloud Binary",
      symbol: "CBY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35733/thumb/CBY-200px.png?1709691425"
    },
    {
      chainId: 1,
      address: "0xefab7248d36585e2340e5d25f8a8d243e6e3193f",
      name: "Dacxi",
      symbol: "DACXI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4466/thumb/dacxi.png?1696505057"
    },
    {
      chainId: 1,
      address: "0x57f12fe6a4e5fe819eec699fadf9db2d06606bb4",
      name: "Neptune Mutual",
      symbol: "NPM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28235/thumb/Neptune_Mutual_Logo_Icon_Regular_128.png?1696527238"
    },
    {
      chainId: 1,
      address: "0xb3e6ee8d2c586fa03ab70aef96b8ae6d12d64ec7",
      name: "hiFIDENZA",
      symbol: "HIFIDENZA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28237/thumb/hifidenza.png?1696527240"
    },
    {
      chainId: 1,
      address: "0xac3211a5025414af2866ff09c23fc18bc97e79b1",
      name: "Dovu  OLD ",
      symbol: "DOV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1072/thumb/dove.png?1696502174"
    },
    {
      chainId: 1,
      address: "0xa0ed3c520dc0632657ad2eaaf19e26c4fd431a84",
      name: "Hippo Wallet",
      symbol: "HPO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28089/thumb/b77170dd-1dd1-4581-91b2-e352794fa045.jpg?1696527099"
    },
    {
      chainId: 1,
      address: "0x2b1d36f5b61addaf7da7ebbd11b35fd8cfb0de31",
      name: "Interport Token",
      symbol: "ITP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28338/thumb/ITP_Logo_200.png?1696527344"
    },
    {
      chainId: 1,
      address: "0xcf4c68db4c2fa0bf58df07b14f45ce7709a716ac",
      name: "Dejitaru Shirudo",
      symbol: "SHIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28500/thumb/200x200_3.PNG?1703024361"
    },
    {
      chainId: 1,
      address: "0xfc4b4ec763722b71eb1d729749b447a9645f5f30",
      name: "DumbMoney",
      symbol: "GME",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32058/thumb/DumbMoney_-_GME_-_Official_Logo_200x200px.png?1696530855"
    },
    {
      chainId: 1,
      address: "0x51395ade06eae126f590e7b06dc8f6baf511f13f",
      name: "hiSQUIGGLE",
      symbol: "HISQUIGGLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28127/thumb/hisquiggle.png?1696527134"
    },
    {
      chainId: 1,
      address: "0x570936840fa942c96ca4c57a170dda494dd9b9c6",
      name: "Decentral ART",
      symbol: "ART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29398/thumb/E58AC31F-1B46-4BAD-B8D8-E01551303E09.jpeg?1696528348"
    },
    {
      chainId: 1,
      address: "0xa1d0e215a23d7030842fc67ce582a6afa3ccab83",
      name: "DFI money",
      symbol: "YFII",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11902/thumb/YFII-logo.78631676.png?1696511768"
    },
    {
      chainId: 1,
      address: "0x4c601dc69affb0d4fc8de1ac303705e432a4a27e",
      name: "Konnect",
      symbol: "KCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25756/thumb/EAO_5JhW_400x400.jpg?1696524842"
    },
    {
      chainId: 1,
      address: "0x49642110b712c1fd7261bc074105e9e44676c68f",
      name: "DinoLFG",
      symbol: "DINO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28239/thumb/F1giO3rXsAAFOsG.jpg?1696527242"
    },
    {
      chainId: 1,
      address: "0xd101dcc414f310268c37eeb4cd376ccfa507f571",
      name: "ResearchCoin",
      symbol: "RSC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28146/thumb/RH_Logo_200x200.png?1696527152"
    },
    {
      chainId: 1,
      address: "0x377de38159bf87111c1523055b4a8c3a1a971722",
      name: "GrokGrow",
      symbol: "GROKGROW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33680/thumb/GrokGrow.png?1702718755"
    },
    {
      chainId: 1,
      address: "0x6d791ff76d2780f7c0403b8ad52de7b369a6154b",
      name: "AFK Trading Bot",
      symbol: "AFK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32813/thumb/AFK_Trading_Bot.png?1699578505"
    },
    {
      chainId: 1,
      address: "0x5e8422345238f34275888049021821e8e08caa1f",
      name: "Frax Ether",
      symbol: "FRXETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28284/thumb/frxETH_icon.png?1696527284"
    },
    {
      chainId: 1,
      address: "0xf21661d0d1d76d3ecb8e1b9f1c923dbfffae4097",
      name: "Realio",
      symbol: "RIO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12206/thumb/Rio.png?1696512042"
    },
    {
      chainId: 1,
      address: "0xf98ab0874b13a7fdc39d7295dedd49850a5d426b",
      name: "KIRA",
      symbol: "KIRA",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/28196/thumb/KIRA_CMC.png?1696527199"
    },
    {
      chainId: 1,
      address: "0xac3e018457b222d93114458476f3e3416abbe38f",
      name: "Staked Frax Ether",
      symbol: "SFRXETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28285/thumb/sfrxETH_icon.png?1696527285"
    },
    {
      chainId: 1,
      address: "0x2a8e1e676ec238d8a992307b495b45b3feaa5e86",
      name: "Origin Dollar",
      symbol: "OUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12589/thumb/ousd-logo-200x200.png?1696512399"
    },
    {
      chainId: 1,
      address: "0x7ca5af5ba3472af6049f63c1abc324475d44efc1",
      name: "KONDUX",
      symbol: "KNDX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28244/thumb/kndx.png?1696527247"
    },
    {
      chainId: 1,
      address: "0x16594930d16f3970e1a4317c6016555cb2e7b7fc",
      name: "TokenBot",
      symbol: "TKB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27106/thumb/tokenbot-logo-icon.png?1696526155"
    },
    {
      chainId: 1,
      address: "0x8d610e20481f4c4f3acb87bba9c46bef7795fdfe",
      name: "Unity Network",
      symbol: "UNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17143/thumb/unity.PNG?1696516702"
    },
    {
      chainId: 1,
      address: "0xe7ef051c6ea1026a70967e8f04da143c67fa4e1f",
      name: "VetMe",
      symbol: "VETME",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28787/thumb/VetMe.png?1709837744"
    },
    {
      chainId: 1,
      address: "0x96362879529c15c484eabc861c435940e7af22bb",
      name: "RPG Maker Ai",
      symbol: "RPGMAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33869/thumb/RPG.jpeg?1703131629"
    },
    {
      chainId: 1,
      address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
      name: "Harvest Finance",
      symbol: "FARM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12304/thumb/FARM_200x200.png?1696512134"
    },
    {
      chainId: 1,
      address: "0x5cb3ce6d081fb00d5f6677d196f2d70010ea3f4a",
      name: "Busy",
      symbol: "BUSY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14966/thumb/busy.PNG?1696514627"
    },
    {
      chainId: 1,
      address: "0x58fcaa970339a9b1f8c0a5b4f3fcd7af2ba3075e",
      name: "Polar Sync",
      symbol: "POLAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18102/thumb/polar-sync-logo-200.jpeg?1696517607"
    },
    {
      chainId: 1,
      address: "0xdc524e3c6910257744c1f93cf15e9f472b5bd236",
      name: "Witch Token",
      symbol: "WITCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17205/thumb/download_%2829%29.png?1696516761"
    },
    {
      chainId: 1,
      address: "0xf7e945fce8f19302aacc7e1418b0a0bdef89327b",
      name: "Galvan",
      symbol: "IZE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29442/thumb/Galvan_%28IZE%29.png?1696528389"
    },
    {
      chainId: 1,
      address: "0xb1191f691a355b43542bea9b8847bc73e7abb137",
      name: "KIRO",
      symbol: "KIRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12688/thumb/logo_kirobo-04.png?1696512491"
    },
    {
      chainId: 1,
      address: "0x9012744b7a564623b6c3e40b144fc196bdedf1a9",
      name: "0xNumber",
      symbol: "OXN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33870/thumb/200x200.png?1703131812"
    },
    {
      chainId: 1,
      address: "0xba58444c8050ed9385b7417533a73644036d21eb",
      name: "Lord of Dragons",
      symbol: "LOGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29471/thumb/sym_1000.png?1696528416"
    },
    {
      chainId: 1,
      address: "0x44aad22afbb2606d7828ca1f8f9e5af00e779ae1",
      name: "Homer",
      symbol: "SIMPSON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30243/thumb/1111.png?1696529152"
    },
    {
      chainId: 1,
      address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
      name: "Origin Protocol",
      symbol: "OGN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3296/thumb/op.jpg?1696504006"
    },
    {
      chainId: 1,
      address: "0xe04f47ff45576249bc5083dfdf987e03d0550113",
      name: "Moonsama",
      symbol: "SAMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28308/thumb/Small.png?1696527312"
    },
    {
      chainId: 1,
      address: "0x599955aa9fbc197a1b717d8da6a7012cafe70ab3",
      name: "Book of Pepe",
      symbol: "BOPE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36314/thumb/1240A08A-6ABE-4913-9B52-05EC784212B7.jpeg?1711092031"
    },
    {
      chainId: 1,
      address: "0xfd0205066521550d7d7ab19da8f72bb004b4c341",
      name: "Timeless",
      symbol: "LIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28714/thumb/timeless-logo_3x.png?1696527695"
    },
    {
      chainId: 1,
      address: "0x8aec4bbdcfb451aa289bfbd3c2f4e34a44ada1be",
      name: "dogwifhat Eth",
      symbol: "DOGWIFHAT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35029/thumb/dogwifhat_Eth.png?1707155488"
    },
    {
      chainId: 1,
      address: "0xce391315b414d4c7555956120461d21808a69f3a",
      name: "Bao Finance V2",
      symbol: "BAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28287/thumb/bao-logo-mark-full-color-rgb-900px-w-72ppi.png?1696527286"
    },
    {
      chainId: 1,
      address: "0x2c5bc2ba3614fd27fcc7022ea71d9172e2632c16",
      name: "Shib Original Vision",
      symbol: "SOV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29601/thumb/photo_2023-03-19_19-07-40_2.png?1696528539"
    },
    {
      chainId: 1,
      address: "0x3496b523e5c00a4b4150d6721320cddb234c3079",
      name: "Numbers Protocol",
      symbol: "NUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20495/thumb/NP_Social_media_profile_pic.png?1696519902"
    },
    {
      chainId: 1,
      address: "0x5f190f9082878ca141f858c1c90b4c59fe2782c5",
      name: "Kudoe",
      symbol: "KDOE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28709/thumb/CG.png?1696527691"
    },
    {
      chainId: 1,
      address: "0xb9ef770b6a5e12e45983c5d80545258aa38f3b78",
      name: "Zus",
      symbol: "ZCN",
      decimals: 10,
      logoURI: "https://assets.coingecko.com/coins/images/4934/thumb/200x200_transparent.png?1696505474"
    },
    {
      chainId: 1,
      address: "0x3106a0a076bedae847652f42ef07fd58589e001f",
      name: "Alkimi",
      symbol: "ADS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17979/thumb/ADS.png?1706546465"
    },
    {
      chainId: 1,
      address: "0x6d52dfefb16bb9cdc78bfca09061e44574886626",
      name: "CPUcoin",
      symbol: "CPU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9544/thumb/uaz.ms.png?1696509626"
    },
    {
      chainId: 1,
      address: "0x38cf6cea814aefd01027a0bbf8a78b7aa95a698e",
      name: "Bypass",
      symbol: "BYPASS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32716/thumb/0x38cf6cea814aefd01027a0bbf8a78b7aa95a698e.jpg?1699000988"
    },
    {
      chainId: 1,
      address: "0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68",
      name: "Inverse Finance",
      symbol: "INV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14205/thumb/inverse_finance.jpg?1696513922"
    },
    {
      chainId: 1,
      address: "0x08f40811c7d6c013744166f3d4cb1a9a92d3d54e",
      name: "NightVerse Game",
      symbol: "NVG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29059/thumb/nvg.png?1696528026"
    },
    {
      chainId: 1,
      address: "0x64d0f55cd8c7133a9d7102b13987235f486f2224",
      name: "SwissBorg",
      symbol: "BORG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2117/thumb/YJUrRy7r_400x400.png?1696503083"
    },
    {
      chainId: 1,
      address: "0xddcea43727558126c00eea772d660dfbe9c39613",
      name: "Grizzly Bot",
      symbol: "GRIZZLY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31611/thumb/gz2.jpg?1696530427"
    },
    {
      chainId: 1,
      address: "0xe0b0af14d5eecc2a7d7d723208593379e349a25c",
      name: "MOZFIRE",
      symbol: "MOZ",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36851/thumb/2024-04-05_21.03.52.jpg?1712626221"
    },
    {
      chainId: 1,
      address: "0x9e46a38f5daabe8683e10793b06749eef7d733d1",
      name: "PolySwarm",
      symbol: "NCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2843/thumb/ImcYCVfX_400x400.jpg?1696503602"
    },
    {
      chainId: 1,
      address: "0xfc1c93a2507975e98b9d0e9260ded61a00152bf1",
      name: "Atlas Navi",
      symbol: "NAVI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28389/thumb/token_icon_-_logo_ATLAS_NAVI_200x200_transparent.png?1696527388"
    },
    {
      chainId: 1,
      address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
      name: "SuperVerse",
      symbol: "SUPER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14040/thumb/SV-Logo-200x200.png?1706880312"
    },
    {
      chainId: 1,
      address: "0x9afa9999e45484adf5d8eed8d9dfe0693bacd838",
      name: "Everyworld",
      symbol: "EVERY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36799/thumb/coin_gecko.png?1714459237"
    },
    {
      chainId: 1,
      address: "0x4ee438be38f8682abb089f2bfea48851c5e71eaf",
      name: "Cryptonovae",
      symbol: "YAE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14693/thumb/yae.png?1696514365"
    },
    {
      chainId: 1,
      address: "0x571042b7138ee957a96a6820fce79c48fe2da816",
      name: "Escrowed LBR",
      symbol: "ESLBR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34394/thumb/eslbr.png?1704785981"
    },
    {
      chainId: 1,
      address: "0xa95c5ebb86e0de73b4fb8c47a45b792cfea28c23",
      name: "stake link",
      symbol: "SDL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28406/thumb/stake.png?1696527404"
    },
    {
      chainId: 1,
      address: "0xe9fa21e671bcfb04e6868784b89c19d5aa2424ea",
      name: "EurocoinToken",
      symbol: "ECTE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7634/thumb/logotoken200x200.png?1696507889"
    },
    {
      chainId: 1,
      address: "0x88a9a52f944315d5b4e917b9689e65445c401e83",
      name: "FEAR",
      symbol: "FEAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15825/thumb/fear-logo-400-400.png?1696515443"
    },
    {
      chainId: 1,
      address: "0x61b34a012646cd7357f58ee9c0160c6d0021fa41",
      name: "Elosys",
      symbol: "ELO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34040/thumb/logo200x200.png?1703693735"
    },
    {
      chainId: 1,
      address: "0x0af0e83d064f160376303ac67dd9a7971af88d4c",
      name: "Match Finance esLBR",
      symbol: "MESLBR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34395/thumb/20240109-160040.png?1704795144"
    },
    {
      chainId: 1,
      address: "0x6d60a8dfb16d09f67d46fcd36a0cd310078257ca",
      name: "Centurion Invest",
      symbol: "CIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28483/thumb/PHOTO-2022-05-27-11-34-42.jpg?1696527476"
    },
    {
      chainId: 1,
      address: "0x04c17b9d3b29a78f7bd062a57cf44fc633e71f85",
      name: "IMPT",
      symbol: "IMPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28486/thumb/IMPT_logo.png?1696527478"
    },
    {
      chainId: 1,
      address: "0xe1d7c7a4596b038ced2a84bf65b8647271c53208",
      name: "NFTY",
      symbol: "NFTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18741/thumb/coingecko.png?1696518206"
    },
    {
      chainId: 1,
      address: "0x8260328d0c405d9ca061d80199102ddc9089e43c",
      name: "Dojo Supercomputer",
      symbol: "DOJO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29728/thumb/Dojo_super.jpeg?1696528658"
    },
    {
      chainId: 1,
      address: "0xa0ef786bf476fe0810408caba05e536ac800ff86",
      name: "Myria",
      symbol: "MYRIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29273/thumb/myria.png?1696528226"
    },
    {
      chainId: 1,
      address: "0x9fd5555d0360adc2b5d92179e9bc36802bba8621",
      name: "APES",
      symbol: "APES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35030/thumb/mmexport1707027461489.jpg?1707156370"
    },
    {
      chainId: 1,
      address: "0x038ed1383763d704d4271fe856ac96b4557e9d06",
      name: "Alphabet",
      symbol: "ALPHABET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35172/thumb/ALPHABET_1-1920x970.png?1707748607"
    },
    {
      chainId: 1,
      address: "0x74e9fee3fcb56bccac22e726cce7a78ca90185e1",
      name: "Rizo",
      symbol: "RIZO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35440/thumb/rizo_200x200_transparent.png?1708614246"
    },
    {
      chainId: 1,
      address: "0x04cb855a5e5c4e92dd90bce82548669b4fe88702",
      name: "BOOK",
      symbol: "BOOK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33034/thumb/book_%281%29.jpg?1700403065"
    },
    {
      chainId: 1,
      address: "0x7a3f7f6675514d4d611b442a4b76752f6ab77670",
      name: "Tora Inu",
      symbol: "TORA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28531/thumb/z9b6m1yS_400x400.png?1696527524"
    },
    {
      chainId: 1,
      address: "0x1db11e86fa9b9a87813a4dd3f747eef12ed55a55",
      name: "Digital Asset Right Token",
      symbol: "DAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36898/thumb/DARTS_200x200.jpg?1712677273"
    },
    {
      chainId: 1,
      address: "0xf17a3fe536f8f7847f1385ec1bc967b2ca9cae8d",
      name: "Alongside Crypto Market Index",
      symbol: "AMKT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28496/thumb/22999.png?1696527488"
    },
    {
      chainId: 1,
      address: "0x792833b894775bd769b3c602ba7172e59a83ab3f",
      name: "City Boys",
      symbol: "TOONS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32586/thumb/photo_2023-10-29_02.57.38.jpeg?1698564589"
    },
    {
      chainId: 1,
      address: "0x893c47bc1ff55c2269236ac7a4288681532161e0",
      name: "Error 404",
      symbol: "ERR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35174/thumb/TOKEN-404---SYMBOL-_-TYPO---PURPLE.jpg?1707749033"
    },
    {
      chainId: 1,
      address: "0xf3c9308111ddbe3552c1f0931d896b10ccd827ce",
      name: "ChartAI",
      symbol: "CX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31896/thumb/200.png?1696530707"
    },
    {
      chainId: 1,
      address: "0x67f4c72a50f8df6487720261e188f2abe83f57d7",
      name: "Wrapped POKT",
      symbol: "WPOKT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/31696/thumb/POKT.jpg?1703257336"
    },
    {
      chainId: 1,
      address: "0x33e07f5055173cf8febede8b21b12d1e2b523205",
      name: "Etherland",
      symbol: "ELAND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14432/thumb/eland_logo.png?1696514122"
    },
    {
      chainId: 1,
      address: "0x428dc22668e6f3468273634067e5545ed5417a3e",
      name: "MiraQle",
      symbol: "MQL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12278/thumb/200_200_%EB%AF%B8%EB%9D%BC%ED%81%B4_%EB%A1%9C%EA%B3%A0.png?1696512107"
    },
    {
      chainId: 1,
      address: "0x9f94b198ce85c19a846c2b1a4d523f40a747a850",
      name: "havoc",
      symbol: "HAVOC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31238/thumb/https___files.gitbook.com_v0_b_gitbook-x-prod.appspot.com_o_organizations_2FUh9uLmLoXru5erqLU4t2_2Flogo_2FQENXQAXAvv7kBdlqdyX2_2F2023-08-01_2013.06.56%281%29.jpg?1696530064"
    },
    {
      chainId: 1,
      address: "0xe95a203b1a91a908f9b9ce46459d101078c2c3cb",
      name: "Ankr Staked ETH",
      symbol: "ANKRETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13403/thumb/aETHc.png?1696513165"
    },
    {
      chainId: 1,
      address: "0x68037790a0229e9ce6eaa8a99ea92964106c4703",
      name: "Parallel",
      symbol: "PAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14153/thumb/par_round_200.png?1696513872"
    },
    {
      chainId: 1,
      address: "0xccdb064a41afcd432bcea6f6d0d1e7c371d0b002",
      name: "Qrolli",
      symbol: "QR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29681/thumb/logoQrolli.png?1696528615"
    },
    {
      chainId: 1,
      address: "0xb23d80f5fefcddaa212212f028021b41ded428cf",
      name: "Echelon Prime",
      symbol: "PRIME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29053/thumb/prime-logo-small-border_%282%29.png?1696528020"
    },
    {
      chainId: 1,
      address: "0x286f851b049ccce1419e09b6468dc3297f86a703",
      name: "hiSEALS",
      symbol: "HISEALS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29191/thumb/63f46d084b94830001ea9a60_hiSEALS_-__Logo.png?1696528150"
    },
    {
      chainId: 1,
      address: "0x049715c70fdbdd2be4814f76a53dc3d6f4367756",
      name: "Nezuko",
      symbol: "NEZUKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30014/thumb/Nezuko_Logo.png?1696528938"
    },
    {
      chainId: 1,
      address: "0x2ba592f78db6436527729929aaf6c908497cb200",
      name: "Cream",
      symbol: "CREAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11976/thumb/Cream.png?1696511834"
    },
    {
      chainId: 1,
      address: "0x8df4197669cf7af9fd29d768c932251a0c2e3e94",
      name: "Ninja404",
      symbol: "NINJA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35175/thumb/mascot.png?1707751710"
    },
    {
      chainId: 1,
      address: "0x3c6a7ab47b5f058be0e7c7fe1a4b7925b8aca40e",
      name: "Cajutel",
      symbol: "CAJ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7354/thumb/RuHhMsFd_400x400.png?1696507637"
    },
    {
      chainId: 1,
      address: "0xd1d92f1c5524d93ced7bf6f418c8bf8abf68ac66",
      name: "Bull Frog",
      symbol: "BULL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31612/thumb/Bull200.png?1696530428"
    },
    {
      chainId: 1,
      address: "0x3001f57f8308b189eb412a64322aad5ef9951290",
      name: "Geometric Energy Corporation",
      symbol: "GEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33326/thumb/Gec.png?1701437951"
    },
    {
      chainId: 1,
      address: "0x0a638f07acc6969abf392bb009f216d22adea36d",
      name: "Brickken",
      symbol: "BKN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18474/thumb/brickken-coin.png?1696517960"
    },
    {
      chainId: 1,
      address: "0xfd09911130e6930bf87f2b0554c44f400bd80d3e",
      name: "Ethix",
      symbol: "ETHIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3031/thumb/ETHIX_icon_256x256-256.png?1696503766"
    },
    {
      chainId: 1,
      address: "0x337dd23d05c27bff099d3604938bfc23a9b25820",
      name: "Marshall Fighting Championship",
      symbol: "MFC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29390/thumb/91C38363-77C4-4D85-A3B7-EFA1C5745DDF.png?1696528341"
    },
    {
      chainId: 1,
      address: "0xf6aeaf0fe66cf2ef2e738ba465fb531ffe39b4e2",
      name: "Aternos Chain",
      symbol: "ATR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33399/thumb/ezgif.com-resize_%2830%29.png?1701684875"
    },
    {
      chainId: 1,
      address: "0x2d787d4f5005bd66ac910c2e821241625c406ed5",
      name: "Berry",
      symbol: "BERRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11016/thumb/Berry_logo.png?1696510963"
    },
    {
      chainId: 1,
      address: "0x9469d013805bffb7d3debe5e7839237e535ec483",
      name: "Darwinia Network",
      symbol: "RING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9443/thumb/RING.png?1696509535"
    },
    {
      chainId: 1,
      address: "0xdf4ef6ee483953fe3b84abd08c6a060445c01170",
      name: "Wrapped Accumulate",
      symbol: "WACME",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/27207/thumb/accumulate-logo-200x200.png?1696526255"
    },
    {
      chainId: 1,
      address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
      name: "Boba Network",
      symbol: "BOBA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20285/thumb/Boba-200x200---white.png?1696519690"
    },
    {
      chainId: 1,
      address: "0x4591dbff62656e7859afe5e45f6f47d3669fbb28",
      name: "Prisma mkUSD",
      symbol: "MKUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31519/thumb/mkUSD_200.png?1696530329"
    },
    {
      chainId: 1,
      address: "0x46cca329970b33e1a007dd4ef0594a1cedb3e72a",
      name: "Yesports",
      symbol: "YESP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29767/thumb/YESP_TOKEN.png?1696528698"
    },
    {
      chainId: 1,
      address: "0x33caf58d14d7cd284cc2d7f2bc878d2d63c8956a",
      name: "Only Possible On Ethereum",
      symbol: "OPOE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32097/thumb/download.png?1696530895"
    },
    {
      chainId: 1,
      address: "0x5ee84583f67d5ecea5420dbb42b462896e7f8d06",
      name: "PulseBitcoin",
      symbol: "PLSB",
      decimals: 12,
      logoURI: "https://assets.coingecko.com/coins/images/28690/thumb/%E2%82%BF.png?1696527673"
    },
    {
      chainId: 1,
      address: "0x341c05c0e9b33c0e38d64de76516b2ce970bb3be",
      name: "Diversified Staked ETH",
      symbol: "DSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28751/thumb/dsETH-logo.png?1696527731"
    },
    {
      chainId: 1,
      address: "0xedc1004886d010751f74ec0ad223819f9f3b1910",
      name: "AgriNode",
      symbol: "AGN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28727/thumb/IMG_20230110_070430_486_%281%29.png?1696527707"
    },
    {
      chainId: 1,
      address: "0x93eeb426782bd88fcd4b48d7b0368cf061044928",
      name: "The Rug Game",
      symbol: "TRG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28750/thumb/TRG_Logo_Circular_200px.png?1696527729"
    },
    {
      chainId: 1,
      address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
      name: "USDC",
      symbol: "USDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/6319/thumb/usdc.png?1696506694"
    },
    {
      chainId: 1,
      address: "0xe7eaec9bca79d537539c00c58ae93117fb7280b9",
      name: "Doge Protocol",
      symbol: "DOGEP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23689/thumb/LjhKBldd_400x400.png?1696522890"
    },
    {
      chainId: 1,
      address: "0x29fa1fee0f4f0ab0e36ef7ab8d7a35439ec6be75",
      name: "SafeStake",
      symbol: "DVT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30016/thumb/safestake.png?1696528940"
    },
    {
      chainId: 1,
      address: "0x1d2d925887f442a27b5393bd5dfbe059910b1ac0",
      name: "ORMIT",
      symbol: "ORMIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36771/thumb/1000005541.jpg?1712285663"
    },
    {
      chainId: 1,
      address: "0x4295c8556afee00264c0789dde2ddd2dba71acfe",
      name: "Bidao Smart Chain",
      symbol: "BISC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29825/thumb/bisc200.png?1696528753"
    },
    {
      chainId: 1,
      address: "0xf4b5470523ccd314c6b9da041076e7d79e0df267",
      name: "blockbank",
      symbol: "BBANK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15081/thumb/blockbank.jpg.png?1696514740"
    },
    {
      chainId: 1,
      address: "0x60be1e1fe41c1370adaf5d8e66f07cf1c2df2268",
      name: "Perion",
      symbol: "PERC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23302/thumb/PERC.png?1696522520"
    },
    {
      chainId: 1,
      address: "0x38029c62dfa30d9fd3cadf4c64e9b2ab21dbda17",
      name: "Dubbz",
      symbol: "DUBBZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28665/thumb/D8EACA06-18ED-4999-8B3A-6339F9E021CE.jpeg?1696527650"
    },
    {
      chainId: 1,
      address: "0x66a3a58f812d0f433daaf1d96e14fd72d1d03d67",
      name: "YAMA Inu",
      symbol: "YAMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31636/thumb/Yama_Inu_Coin_3.png?1696530451"
    },
    {
      chainId: 1,
      address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
      name: "Wrapped NXM",
      symbol: "WNXM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11890/thumb/wNXM.png?1696511757"
    },
    {
      chainId: 1,
      address: "0x147faf8de9d8d8daae129b187f0d02d819126750",
      name: "GeoDB",
      symbol: "GEO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11130/thumb/geodb.png?1696511067"
    },
    {
      chainId: 1,
      address: "0xc76d53f988820fe70e01eccb0248b312c2f1c7ca",
      name: "Inu Token",
      symbol: "INU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30755/thumb/0xc76d53f988820fe70e01eccb0248b312c2f1c7ca.png?1696529624"
    },
    {
      chainId: 1,
      address: "0xcd5fe23c85820f7b72d0926fc9b05b43e359b7ee",
      name: "Wrapped eETH",
      symbol: "WEETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33033/thumb/weETH.png?1701438396"
    },
    {
      chainId: 1,
      address: "0xcfcffe432a48db53f59c301422d2edd77b2a88d7",
      name: "Texan",
      symbol: "TEXAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28731/thumb/texan_logo_200x200.png?1696527711"
    },
    {
      chainId: 1,
      address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
      name: "tomiNet",
      symbol: "TOMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28730/thumb/logo_for_token.png?1696527710"
    },
    {
      chainId: 1,
      address: "0x8ef32a03784c8fd63bbf027251b9620865bd54b6",
      name: "Bullet Gate Betting Token",
      symbol: "BULLET",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31242/thumb/2023-08-09_14.53.31.png?1696530068"
    },
    {
      chainId: 1,
      address: "0x5957c351946d45f74d1a6f034cd9b6ac6654e0d7",
      name: "Chart Roulette",
      symbol: "CR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33111/thumb/IMG_20231121_180645_701.jpg?1700707947"
    },
    {
      chainId: 1,
      address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
      name: "Gitcoin",
      symbol: "GTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15810/thumb/gitcoin.png?1696515429"
    },
    {
      chainId: 1,
      address: "0x94d40b49f020bfebba1a80a0191eb3737b90e8d3",
      name: "Mintera",
      symbol: "MNTE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28774/thumb/Mintera_Logo_CoinGecko.png?1696527753"
    },
    {
      chainId: 1,
      address: "0xfb0489e9753b045ddb35e39c6b0cc02ec6b99ac5",
      name: "AGG",
      symbol: "AGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36772/thumb/agglogo_200.png?1712286053"
    },
    {
      chainId: 1,
      address: "0xe87e15b9c7d989474cb6d8c56b3db4efad5b21e8",
      name: "HOKK Finance",
      symbol: "HOKK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14985/thumb/hokk.png?1696514647"
    },
    {
      chainId: 1,
      address: "0x91368eef9ab8bdc727e4506897656abb87282003",
      name: "Network Spirituality",
      symbol: "NET",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31430/thumb/OGZy3_zy_400x400.jpg?1696530244"
    },
    {
      chainId: 1,
      address: "0xd9788f3931ede4d5018184e198699dc6d66c1915",
      name: "Aave yVault",
      symbol: "YVAAVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28784/thumb/yvAAVE-128-0xd9788f3931Ede4D5018184E198699dC6d66C1915.png?1696527763"
    },
    {
      chainId: 1,
      address: "0x4a3fe75762017db0ed73a71c9a06db7768db5e66",
      name: "COMP yVault",
      symbol: "YVCOMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28786/thumb/yvCOMP-128-0x4A3FE75762017DB0eD73a71C9A06db7768DB5e66.png?1696527765"
    },
    {
      chainId: 1,
      address: "0xdb25ca703181e7484a155dd612b06f57e12be5f0",
      name: "YFI yVault",
      symbol: "YVYFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28785/thumb/yvYFI-128-0xE14d13d8B3b85aF791b2AADD661cDBd5E6097Db1.png?1696527764"
    },
    {
      chainId: 1,
      address: "0xf32aa187d5bc16a2c02a6afb7df1459d0d107574",
      name: "HachikoInu",
      symbol: "INU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16392/thumb/hachikoinu-200px.png?1696515990"
    },
    {
      chainId: 1,
      address: "0x27b5739e22ad9033bcbf192059122d163b60349d",
      name: "Staked Yearn CRV Vault",
      symbol: "ST-YCRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27623/thumb/st-yCRV-128-0x27B5739e22ad9033bcBf192059122d163b60349D.png?1696526654"
    },
    {
      chainId: 1,
      address: "0xf6ccfd6ef2850e84b73adeace9a075526c5910d4",
      name: "THE RUNIX TOKEN",
      symbol: "RUNIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37294/thumb/logo-withText-whiteOnBlack.png?1713948942"
    },
    {
      chainId: 1,
      address: "0x39142c18b6db2a8a41b7018f49e1478837560cad",
      name: "STATS",
      symbol: "STATS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28853/thumb/stats.png?1696527827"
    },
    {
      chainId: 1,
      address: "0xa354f35829ae975e850e23e9615b11da1b3dc4de",
      name: "USDC yVault",
      symbol: "YVUSDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/28779/thumb/yvUSDC-128-0xe2F6b9773BF3A015E2aA70741Bde1498bdB9425b.png?1696527758"
    },
    {
      chainId: 1,
      address: "0x3b27f92c0e212c671ea351827edf93db27cc0c65",
      name: "USDT yVault",
      symbol: "YVUSDT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/28780/thumb/yvUSDT-128-0x7Da96a3891Add058AdA2E826306D812C638D87a7.png?1696527759"
    },
    {
      chainId: 1,
      address: "0xfbeb78a723b8087fd2ea7ef1afec93d35e8bed42",
      name: "UNI yVault",
      symbol: "YVUNI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28781/thumb/yvUNI-128-0xFBEB78a723b8087fD2ea7Ef1afEc93d35E8Bed42.png?1696527760"
    },
    {
      chainId: 1,
      address: "0x00000000051b48047be6dc0ada6de5c3de86a588",
      name: "Baby Shiba Inu",
      symbol: "BABYSHIB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31350/thumb/100x100_%287%29_%282%29.png?1696530167"
    },
    {
      chainId: 1,
      address: "0xbe00734799a67a62af2819825580318ac1b1e4ec",
      name: "ordinex",
      symbol: "ORD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29084/thumb/tw-logo%281%29.png?1696528048"
    },
    {
      chainId: 1,
      address: "0xab85fc558d722a2b7c040ffb77db676bd9e7d322",
      name: "MOROS NET",
      symbol: "MOROS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33147/thumb/Moros.jpg?1700822187"
    },
    {
      chainId: 1,
      address: "0x42b91f1d05afea671a2da3c780eda2abf0a2a366",
      name: "Mineable",
      symbol: "MNB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29272/thumb/mnb.png?1696528225"
    },
    {
      chainId: 1,
      address: "0x03a0657fc10d7169305a0179eb80d4f568cda705",
      name: "Blitz Bots",
      symbol: "BLITZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33854/thumb/photo_2023-12-16_02-17-20.png?1703125111"
    },
    {
      chainId: 1,
      address: "0x17c50d62e6e8d20d2dc18e9ad79c43263d0720d9",
      name: "Not Financial Advice",
      symbol: "NFAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28758/thumb/NFA_Labs_Logo_%281%29.png?1710245293"
    },
    {
      chainId: 1,
      address: "0x8dfc8cc3201425669fae803e1eb125cddd4189ec",
      name: "Okage Inu",
      symbol: "OKAGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28829/thumb/Okage_Inu.png?1696527805"
    },
    {
      chainId: 1,
      address: "0x0c943300d604c732117db2755873a0a0683ee7a9",
      name: "Paradise Defi",
      symbol: "PDF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28827/thumb/photo_2023-01-16_15.08.09.jpeg?1696527803"
    },
    {
      chainId: 1,
      address: "0x6bc08509b36a98e829dffad49fde5e412645d0a3",
      name: "WoofWork io",
      symbol: "WOOF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28903/thumb/WWlogoTransparent_200x200.png?1696527879"
    },
    {
      chainId: 1,
      address: "0x7138eb0d563f3f6722500936a11dcae99d738a2c",
      name: "Lif3",
      symbol: "LIF3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31291/thumb/Tokens.png?1696530112"
    },
    {
      chainId: 1,
      address: "0xed328e9c1179a30ddc1e7595e036aed8760c22af",
      name: "Metacade",
      symbol: "MCADE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29764/thumb/Square_Profile_Photo_1080_x_1080px.png?1699396445"
    },
    {
      chainId: 1,
      address: "0x8c1bed5b9a0928467c9b1341da1d7bd5e10b6549",
      name: "Liquid Staked ETH",
      symbol: "LSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28848/thumb/LsETH-receipt-token-circle.png?1696527824"
    },
    {
      chainId: 1,
      address: "0xd346e8ada104093adcf5f4186087e1ad309bb3b3",
      name: "Shibnaut",
      symbol: "SHIBN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28872/thumb/66EDE430-1CD7-4524-B610-FC58A7DCDA3E.jpeg?1696527850"
    },
    {
      chainId: 1,
      address: "0x6f3277ad0782a7da3eb676b85a8346a100bf9c1c",
      name: "DogPad Finance",
      symbol: "DOGPAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28845/thumb/DogPad.png?1696527821"
    },
    {
      chainId: 1,
      address: "0x1e4746dc744503b53b4a082cb3607b169a289090",
      name: "IPOR",
      symbol: "IPOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28373/thumb/IPOR-token-200x200.png?1696527376"
    },
    {
      chainId: 1,
      address: "0x97872eafd79940c7b24f7bcc1eadb1457347adc9",
      name: "Strips Finance",
      symbol: "STRP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18327/thumb/Logo-Strips-200-x-200px---without-words.png?1696517818"
    },
    {
      chainId: 1,
      address: "0x7a786dac1f315c8a0e9962172ad8ae0c04d9c9b6",
      name: "MemeDAO",
      symbol: "MEMD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30468/thumb/memeDAO_200x200.png?1696529354"
    },
    {
      chainId: 1,
      address: "0xe9287543684f440b2f29983a3472987bf7b0ed12",
      name: "Shiba Nodes",
      symbol: "SHINO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28890/thumb/output-onlinepngtools_%281%29.png?1696527866"
    },
    {
      chainId: 1,
      address: "0xfe67a4450907459c3e1fff623aa927dd4e28c67a",
      name: "Connext",
      symbol: "NEXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31293/thumb/connext.png?1696530113"
    },
    {
      chainId: 1,
      address: "0x91be752d438d5f804345b5acb18de0c431ad470f",
      name: "ETHETF",
      symbol: "ETHETF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32998/thumb/ETHETF_Logo_200x200.png?1700114369"
    },
    {
      chainId: 1,
      address: "0x36e43065e977bc72cb86dbd8405fae7057cdc7fd",
      name: "ArchAngel",
      symbol: "ARCHA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/18814/thumb/Archa_200_x_200_PNG.png?1696518276"
    },
    {
      chainId: 1,
      address: "0x4236f8aaf2b1f3a28420eb15b8e0ddf63201a95e",
      name: "Bermuda",
      symbol: "BMDA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28878/thumb/LOGO.png?1696527855"
    },
    {
      chainId: 1,
      address: "0x24ae2da0f361aa4be46b48eb19c91e02c5e4f27e",
      name: "mevETH",
      symbol: "MEVETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32153/thumb/MEV_logo_2.png?1696598728"
    },
    {
      chainId: 1,
      address: "0x76bc677d444f1e9d57daf5187ee2b7dc852745ae",
      name: "Offshift",
      symbol: "XFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11977/thumb/CsBrPiA.png?1696511835"
    },
    {
      chainId: 1,
      address: "0x2a304fda5a85182dca1d03741bb2f07881b9e095",
      name: "DCOMY",
      symbol: "DCO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29007/thumb/15-38-16-200x200.png?1696527978"
    },
    {
      chainId: 1,
      address: "0x35fa164735182de50811e8e2e824cfb9b6118ac2",
      name: "ether fi Staked ETH",
      symbol: "EETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33049/thumb/ether.fi_eETH.png?1700473063"
    },
    {
      chainId: 1,
      address: "0x674c6ad92fd080e4004b2312b45f796a192d27a0",
      name: "Neutrino Index Token",
      symbol: "XTN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10117/thumb/XTN.png?1712339473"
    },
    {
      chainId: 1,
      address: "0x820802fa8a99901f52e39acd21177b0be6ee2974",
      name: "EUROe Stablecoin",
      symbol: "EUROE",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/28913/thumb/euroe-200x200-round.png?1696527889"
    },
    {
      chainId: 1,
      address: "0x235c8ee913d93c68d2902a8e0b5a643755705726",
      name: "tehBag",
      symbol: "BAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28950/thumb/tehBag-Logo.png?1696527923"
    },
    {
      chainId: 1,
      address: "0x138c2f1123cf3f82e4596d097c118eac6684940b",
      name: "Alpha Coin",
      symbol: "ALPHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22199/thumb/logo2023.png?1696521542"
    },
    {
      chainId: 1,
      address: "0xecbee2fae67709f718426ddc3bf770b26b95ed20",
      name: "Clips",
      symbol: "CLIPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30151/thumb/clips-logo.png?1696529071"
    },
    {
      chainId: 1,
      address: "0xcb50350ab555ed5d56265e096288536e8cac41eb",
      name: "0xCoco",
      symbol: "COCO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31102/thumb/FL1-g3Ns_400x400.jpg?1696529933"
    },
    {
      chainId: 1,
      address: "0x9b110fda4e20db18ad7052f8468a455de7449eb6",
      name: "Calvaria  DoE",
      symbol: "RIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28817/thumb/icon200x200.png?1696527793"
    },
    {
      chainId: 1,
      address: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
      name: "Optimus AI",
      symbol: "OPTI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29328/thumb/photo_2023-11-14_22-41-11.png?1700091127"
    },
    {
      chainId: 1,
      address: "0x7d8d7c26179b7a6aebbf66a91c38ed92d5b4996b",
      name: "Teh Fund",
      symbol: "FUND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28969/thumb/IMG_20230203_091543_056.png?1696527942"
    },
    {
      chainId: 1,
      address: "0x043312456f73d8014d9b84f4337de54995cd2a5b",
      name: "Bonk2 0",
      symbol: "BONK20",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33685/thumb/20231211_114717.jpg?1702731710"
    },
    {
      chainId: 1,
      address: "0xb870679a7fa65b924026f496de7f27c1dd0e5c5f",
      name: "Hello Pets",
      symbol: "PET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14354/thumb/hello_pets.jpg?1696514040"
    },
    {
      chainId: 1,
      address: "0x7e5981c2e072f53a0323d3d80baca3e31fb1550c",
      name: "JovJou",
      symbol: "JOVJOU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32424/thumb/jj_2.png?1698118523"
    },
    {
      chainId: 1,
      address: "0xf134519cbe2042b06ee7ce20df51d09b55559896",
      name: "Mochi",
      symbol: "MOCHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28981/thumb/mochi-logo.png?1696527954"
    },
    {
      chainId: 1,
      address: "0x8954d907520532c1f0d89d42569232fd0f995fdf",
      name: "Tradix",
      symbol: "TX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/28997/thumb/Tradix_Logo.png?1696527969"
    },
    {
      chainId: 1,
      address: "0x045109cf1be9edec048aa0b3d7a323154a1aea65",
      name: "Elevate Token",
      symbol: "ELEV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30085/thumb/elevate.jpeg?1696529009"
    },
    {
      chainId: 1,
      address: "0x52b552c4a698c9b1de4c7fe0dd4462af141f7c3e",
      name: "Alpha Bot Calls",
      symbol: "ABC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31168/thumb/ABC_Token_CG.png?1696529996"
    },
    {
      chainId: 1,
      address: "0x06b884e60794ce02aafab13791b59a2e6a07442f",
      name: "Unbanked",
      symbol: "UNBNK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20171/thumb/logo_-_2021-11-11T115427.135.png?1696519584"
    },
    {
      chainId: 1,
      address: "0x39b0e13a29c2a27ce88cebd21262a232b0633613",
      name: "Grape Governance Token",
      symbol: "GGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30807/thumb/grape_logo.png?1696529664"
    },
    {
      chainId: 1,
      address: "0x3d1e5cf16077f349e999d6b21a4f646e83cd90c5",
      name: "Stakehouse dETH",
      symbol: "DETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33657/thumb/dETH.png?1702598011"
    },
    {
      chainId: 1,
      address: "0x0d8ca4b20b115d4da5c13dc45dd582a5de3e78bf",
      name: "Generaitiv",
      symbol: "GAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29158/thumb/logo-200x200.png?1696528117"
    },
    {
      chainId: 1,
      address: "0xf6043bea98b07f0bea7813aeb22d0cb70c91c0c4",
      name: "MemeDao Ai",
      symbol: "MDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29021/thumb/MemedaoLogo.png?1696527991"
    },
    {
      chainId: 1,
      address: "0xf1fb4cf949277adc3f89c0d6091100789033b7b5",
      name: "Aibot",
      symbol: "AIBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31324/thumb/aibot_200.png?1696530143"
    },
    {
      chainId: 1,
      address: "0xffd822149fa6749176c7a1424e71a417f26189c8",
      name: "Nothing Token",
      symbol: "THING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30327/thumb/fulltrans_%281%29.png?1696529228"
    },
    {
      chainId: 1,
      address: "0xdeadface8503399df4b083ef42fa8e02fd39dead",
      name: "Tribe Token",
      symbol: "TRIBE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33036/thumb/Tribe.jpg?1700403321"
    },
    {
      chainId: 1,
      address: "0xa876f27f13a9eb6e621202cefdd5afc4a90e6457",
      name: "Icy",
      symbol: "IC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29666/thumb/1200.png?1696528601"
    },
    {
      chainId: 1,
      address: "0xfaba6f8e4a5e8ab82f62fe7c39859fa577269be3",
      name: "Ondo",
      symbol: "ONDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26580/thumb/ONDO.png?1696525656"
    },
    {
      chainId: 1,
      address: "0x97c8321b9434db4110b1d75a551e561036ff2e6a",
      name: "WagerOn",
      symbol: "WAGER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32385/thumb/logo.png?1698047095"
    },
    {
      chainId: 1,
      address: "0x4581af35199bbde87a89941220e04e27ce4b0099",
      name: "Maximus Pool Party",
      symbol: "PARTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35369/thumb/Party.png?1708401334"
    },
    {
      chainId: 1,
      address: "0x669c01caf0edcad7c2b8dc771474ad937a7ca4af",
      name: "Wrapped Minima",
      symbol: "WMINIMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29011/thumb/CoinGeko_icon_%28500x500%29.png?1696527982"
    },
    {
      chainId: 1,
      address: "0x207e14389183a94343942de7afbc607f57460618",
      name: "AngelBlock",
      symbol: "THOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25058/thumb/Tholos_circle_gradient_200x200.png?1696524208"
    },
    {
      chainId: 1,
      address: "0xeb2f5a4e1441df330670dc7b0cf4eac0f7ab5fa5",
      name: "hiFRIENDS",
      symbol: "HIFRIENDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29086/thumb/hifriends.png?1696528050"
    },
    {
      chainId: 1,
      address: "0x77e06c9eccf2e797fd462a92b6d7642ef85b0a44",
      name: "Wrapped TAO",
      symbol: "WTAO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29087/thumb/wtao.png?1696528051"
    },
    {
      chainId: 1,
      address: "0x04506dddbf689714487f91ae1397047169afcf34",
      name: "Unlock Maverick",
      symbol: "UNKMAV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31264/thumb/clean.jpg?1696530088"
    },
    {
      chainId: 1,
      address: "0xb685145d7f127b9093d7f9278bae902ef59ff486",
      name: "FREQAI",
      symbol: "FREQAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29122/thumb/The_Razors_Edge.png?1696528084"
    },
    {
      chainId: 1,
      address: "0x1a6658f40e51b372e593b7d2144c1402d5cf33e8",
      name: "PUBLC",
      symbol: "PUBLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29074/thumb/PUBLX_Logo_%28200x200%29.png?1696528040"
    },
    {
      chainId: 1,
      address: "0xce20bb92ccf9bbf5091ef85649e71e552819ad8c",
      name: "Smart Game Finance",
      symbol: "SMART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29072/thumb/smart.png?1696528038"
    },
    {
      chainId: 1,
      address: "0xdd69db25f6d620a7bad3023c5d32761d353d3de9",
      name: "Goerli ETH",
      symbol: "GETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29217/thumb/goerli-eth.png?1696528175"
    },
    {
      chainId: 1,
      address: "0xe3f03cef497c81d2b28a2fae63ae84b373028718",
      name: "MARVIN",
      symbol: "MARVIN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34548/thumb/cg.jpg?1705341719"
    },
    {
      chainId: 1,
      address: "0x1032abe2902a23ddcbab085c20e0e69c33ceb8fa",
      name: "Pepe Predator",
      symbol: "SNAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30205/thumb/Logo_FOR_CG.png?1696529116"
    },
    {
      chainId: 1,
      address: "0x69fa8e7f6bf1ca1fb0de61e1366f7412b827cc51",
      name: "Enreach",
      symbol: "NRCH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/14694/thumb/enreachdao.jpg?1696514366"
    },
    {
      chainId: 1,
      address: "0x06450dee7fd2fb8e39061434babcfc05599a6fb8",
      name: "XEN Crypto",
      symbol: "XEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27713/thumb/Xen.jpeg?1696526739"
    },
    {
      chainId: 1,
      address: "0x4cf89ca06ad997bc732dc876ed2a7f26a9e7f361",
      name: "Mysterium",
      symbol: "MYST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/757/thumb/mysterium.png?1696501911"
    },
    {
      chainId: 1,
      address: "0xe70e1d6a2e971ff6debc21dd2540064c25c9bc0d",
      name: "Spider Spirit",
      symbol: "SPIDER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30741/thumb/200x2001.png?1696529611"
    },
    {
      chainId: 1,
      address: "0xfa4baa6951b6ee382e9ff9af2d523278b99ca6d0",
      name: "House",
      symbol: "HOUSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31202/thumb/hm_icon_200x200.png?1696530029"
    },
    {
      chainId: 1,
      address: "0x4b520c812e8430659fc9f12f6d0c39026c83588d",
      name: "Decentral Games",
      symbol: "DG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21173/thumb/Decentral_Games_Logo-1.png?1696520549"
    },
    {
      chainId: 1,
      address: "0x7a8adcf432ebcc2311b955d176ee4bfed13bb9a7",
      name: "MandoX",
      symbol: "MANDOX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/24968/thumb/NmqN8g7.png?1696524121"
    },
    {
      chainId: 1,
      address: "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
      name: "Hop Protocol",
      symbol: "HOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25445/thumb/hop.png?1696524577"
    },
    {
      chainId: 1,
      address: "0x0888fd2960ddf57cfb561b59d73dd2b9524f6a26",
      name: "Mikawa Inu",
      symbol: "MIKAWA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29168/thumb/IMG_20230215_172257_635.png?1696528126"
    },
    {
      chainId: 1,
      address: "0xddf7fd345d54ff4b40079579d4c4670415dbfd0a",
      name: "SocialGood",
      symbol: "SG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3948/thumb/logo_200.png?1696504592"
    },
    {
      chainId: 1,
      address: "0xb6d78683a4e54b91031acb41510bd8e144fed025",
      name: "CoinForge",
      symbol: "CNFRG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35490/thumb/CoinForge.png?1708884142"
    },
    {
      chainId: 1,
      address: "0x3540dfcad7cf102a2e44aa0e2132fab1c89d7eae",
      name: "SchwiftAI",
      symbol: "SWAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29301/thumb/SchwiftAI.png?1696528253"
    },
    {
      chainId: 1,
      address: "0x36c833eed0d376f75d1ff9dfdee260191336065e",
      name: "Gitcoin Staked ETH Index",
      symbol: "GTCETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29171/thumb/gtcETH-token-logo.png?1696528129"
    },
    {
      chainId: 1,
      address: "0x68b36248477277865c64dfc78884ef80577078f3",
      name: "Everybody",
      symbol: "HOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32272/thumb/HOLD_logo_final_%282%29.png?1697179882"
    },
    {
      chainId: 1,
      address: "0xe6f4a40156c9e8c7addda66848bbb99fdedecf84",
      name: "DeTensor",
      symbol: "DETENSOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36596/thumb/detensor.jpeg?1711950178"
    },
    {
      chainId: 1,
      address: "0xbb556b0ee2cbd89ed95ddea881477723a3aa8f8b",
      name: "AliceNet",
      symbol: "ALCA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29417/thumb/LinkedIn_-_Profile_300_x_300.png?1696528366"
    },
    {
      chainId: 1,
      address: "0x68ffb43026cedc070bfc01b2203d90cab62ccf30",
      name: "Turk Shiba",
      symbol: "TUSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29131/thumb/IMG_20230220_215553_755.jpg?1696528092"
    },
    {
      chainId: 1,
      address: "0x584bc13c7d411c00c01a62e8019472de68768430",
      name: "Hegic",
      symbol: "HEGIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12454/thumb/new.png?1696512274"
    },
    {
      chainId: 1,
      address: "0x8b0fde007458ee153bd0f66cd448af5fb3d99b43",
      name: "Mastermind",
      symbol: "MASTERMIND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29205/thumb/Mastermind.png?1696528164"
    },
    {
      chainId: 1,
      address: "0xed1273928ba97eed7b49e82c2f39d512d7591112",
      name: "NerdBot",
      symbol: "NERD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32386/thumb/nerdbot.png?1698047412"
    },
    {
      chainId: 1,
      address: "0x014337b35167b3711195361bb85259009e50a8a4",
      name: "DecentraNode",
      symbol: "DNODE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35481/thumb/photo_2024-02-24_18.26.48.jpeg?1708849459"
    },
    {
      chainId: 1,
      address: "0xb0ed33f79d89541dfdcb04a8f04bc2c6be025ecc",
      name: "ZeroLiquid",
      symbol: "ZERO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29499/thumb/IMG_20230726_094105_915.png?1696528444"
    },
    {
      chainId: 1,
      address: "0x2559813bbb508c4c79e9ccce4703bcb1f149edd7",
      name: "Hourglass",
      symbol: "WAIT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27516/thumb/Hourglass-Logo.png?1696526555"
    },
    {
      chainId: 1,
      address: "0x0c5cb676e38d6973837b9496f6524835208145a2",
      name: "KaboChan",
      symbol: "KABO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34631/thumb/KaboChan.png?1705548332"
    },
    {
      chainId: 1,
      address: "0x4096fc7119040175589387656f7c6073265f4096",
      name: "4096",
      symbol: "4096",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33687/thumb/icon2.png?1702732239"
    },
    {
      chainId: 1,
      address: "0x6c22910c6f75f828b305e57c6a54855d8adeabf8",
      name: "Satoshis Vision",
      symbol: "SATS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29303/thumb/SATS_123-removebg-preview_%281%29.png?1696528255"
    },
    {
      chainId: 1,
      address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
      name: "Clover Finance",
      symbol: "CLV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15278/thumb/photo_2022-03-24_10-22-33.jpg?1696514930"
    },
    {
      chainId: 1,
      address: "0x8b802513d4aa6f349b197a4ea4c26563cd6fd5b2",
      name: "HIgher IMO",
      symbol: "HIGHER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33518/thumb/download.png?1702132819"
    },
    {
      chainId: 1,
      address: "0xc32db1d3282e872d98f6437d3bcfa57801ca6d5c",
      name: "VoldemortTrumpRobotnik 10Neko",
      symbol: "ETHEREUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31061/thumb/icon_medium.jpg?1696529895"
    },
    {
      chainId: 1,
      address: "0x6d48206b97b164555c8fc7a40d59a7230e055166",
      name: "Sendpicks",
      symbol: "SEND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32824/thumb/Sendpicks.png?1699582373"
    },
    {
      chainId: 1,
      address: "0x23878914efe38d27c4d67ab83ed1b93a74d4086a",
      name: "Aave v3 USDT",
      symbol: "AUSDT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/32884/thumb/USDT.PNG?1699768611"
    },
    {
      chainId: 1,
      address: "0xc97d6c52f3add91fa1c5287a453d7444aecbca83",
      name: "Degen Zoo",
      symbol: "DZOO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29224/thumb/FAGWW5fe_400x400.jpeg?1696528182"
    },
    {
      chainId: 1,
      address: "0xcc9ee9483f662091a1de4795249e24ac0ac2630f",
      name: "Aave v3 rETH",
      symbol: "ARETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32885/thumb/reth.png?1699768947"
    },
    {
      chainId: 1,
      address: "0xf9ca9523e5b5a42c3018c62b084db8543478c400",
      name: "Data Lake",
      symbol: "LAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29279/thumb/VWlCfLlX_400x400.jpeg?1696528232"
    },
    {
      chainId: 1,
      address: "0x4f08705fb8f33affc231ed66e626b40e84a71870",
      name: "Flute",
      symbol: "FLUT",
      decimals: 11,
      logoURI: "https://assets.coingecko.com/coins/images/29148/thumb/TheFlute200x200.png?1696528108"
    },
    {
      chainId: 1,
      address: "0x018008bfb33d285247a21d44e50697654f754e63",
      name: "Aave v3 DAI",
      symbol: "ADAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32886/thumb/dai.png?1699769446"
    },
    {
      chainId: 1,
      address: "0xc1ecfaf43c53bec9b9143ab274f35603fd10b886",
      name: "StarShip ERC20",
      symbol: "SSHIP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31686/thumb/photo_2023-09-11_12-27-23_%281%29.jpg?1696530505"
    },
    {
      chainId: 1,
      address: "0x86eab36585eddb7a949a0b4771ba733d942a8aa7",
      name: "Reddit",
      symbol: "REDDIT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30791/thumb/IMG_0365.jpeg?1696529658"
    },
    {
      chainId: 1,
      address: "0xa700b4eb416be35b2911fd5dee80678ff64ff6c9",
      name: "Aave v3 AAVE",
      symbol: "AAAVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32887/thumb/aave.png?1699773604"
    },
    {
      chainId: 1,
      address: "0xf66cd2f8755a21d3c8683a10269f795c0532dd58",
      name: "coreDAO",
      symbol: "COREDAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23745/thumb/coredao.png?1696522947"
    },
    {
      chainId: 1,
      address: "0x5e8c8a7243651db1384c0ddfdbe39761e8e7e51a",
      name: "Aave v3 LINK",
      symbol: "ALINK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32888/thumb/link.png?1699773900"
    },
    {
      chainId: 1,
      address: "0xc2456d2118299a2efdfe6522ff79aa48fc5d2b00",
      name: "MaruTaro",
      symbol: "MARU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29304/thumb/marutaro_logo.jpg?1696528256"
    },
    {
      chainId: 1,
      address: "0xf5d126077096e5b01bc30ffa5d9324d7202d7cb3",
      name: "CHEW",
      symbol: "CHEW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29377/thumb/IMG_4701.PNG?1696528324"
    },
    {
      chainId: 1,
      address: "0x8a458a9dc9048e005d22849f470891b840296619",
      name: "Aave v3 MKR",
      symbol: "AMKR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32889/thumb/mkr.png?1699774767"
    },
    {
      chainId: 1,
      address: "0x4c612e3b15b96ff9a6faed838f8d07d479a8dd4c",
      name: "Aave v3 sDAI",
      symbol: "ASDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32891/thumb/sdai.png?1699785595"
    },
    {
      chainId: 1,
      address: "0x5888641e3e6cbea6d84ba81edb217bd691d3be38",
      name: "Bobo",
      symbol: "BOBO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29875/thumb/BOBO_200.png?1696528799"
    },
    {
      chainId: 1,
      address: "0x3819f64f282bf135d62168c1e513280daf905e06",
      name: "Hedron",
      symbol: "HDRN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/24208/thumb/hdrn.png?1696523395"
    },
    {
      chainId: 1,
      address: "0x53340a1ef3a0ddeba1d94bbd1e2ff55936f0ea60",
      name: "Bark",
      symbol: "BARK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29341/thumb/BarkLogo200x200.png?1696528290"
    },
    {
      chainId: 1,
      address: "0x295b42684f90c77da7ea46336001010f2791ec8c",
      name: "Xi",
      symbol: "XI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18640/thumb/v5NMxPo.png?1696518111"
    },
    {
      chainId: 1,
      address: "0xf6d2224916ddfbbab6e6bd0d1b7034f4ae0cab18",
      name: "Aave v3 UNI",
      symbol: "AUNI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32893/thumb/UNI.png?1699789595"
    },
    {
      chainId: 1,
      address: "0xc4ee0aa2d993ca7c9263ecfa26c6f7e13009d2b6",
      name: "Hoichi",
      symbol: "HOICHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27227/thumb/3dBs4VvW_400x400.jpeg?1696526278"
    },
    {
      chainId: 1,
      address: "0x562e12e1e792643d168c1fa01c1b7198a0f83c9f",
      name: "BookieBot",
      symbol: "BB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31546/thumb/photo_2023-08-23_17-48-35_200x200.jpg?1696530359"
    },
    {
      chainId: 1,
      address: "0x9a44fd41566876a39655f74971a3a6ea0a17a454",
      name: "Aave v3 LDO",
      symbol: "ALDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32895/thumb/LDO.png?1699790151"
    },
    {
      chainId: 1,
      address: "0xacf8d5e515ed005655dfefa09c22673a37a7cdee",
      name: "FunFi",
      symbol: "FNF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25872/thumb/FNF-200x200.png?1696524955"
    },
    {
      chainId: 1,
      address: "0xff770e4c68e35db85c6e0e89a43750ec02bdb2ac",
      name: "Ordinal BTC",
      symbol: "OBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29244/thumb/Ordinal_BTC.png?1696528200"
    },
    {
      chainId: 1,
      address: "0x49446a0874197839d15395b908328a74ccc96bc0",
      name: "Eigenpie mstETH",
      symbol: "MSTETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37182/thumb/mstETH.png?1713514149"
    },
    {
      chainId: 1,
      address: "0x9b9647431632af44be02ddd22477ed94d14aacaa",
      name: "KOK",
      symbol: "KOK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10502/thumb/logo_navy.png?1696510490"
    },
    {
      chainId: 1,
      address: "0x9ce07410673206c693bcec9b07710767637a564c",
      name: "Monkeys Token",
      symbol: "MONKEYS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29782/thumb/200x200_Monkeys_Logo.png?1696528712"
    },
    {
      chainId: 1,
      address: "0xa53f9dd70055113e13176e291eddb773f85b2650",
      name: "ZEUS AI",
      symbol: "ZEUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32896/thumb/cg_size.jpg?1699790661"
    },
    {
      chainId: 1,
      address: "0x9040e237c3bf18347bb00957dc22167d0f2b999d",
      name: "Standard Protocol",
      symbol: "STND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15100/thumb/STND_logo_black_bg.png?1696514758"
    },
    {
      chainId: 1,
      address: "0x09637e374ec5bab8c9e9654a97c9593e3038c5b3",
      name: "zkProof",
      symbol: "ZKP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29592/thumb/200.png?1696528531"
    },
    {
      chainId: 1,
      address: "0x51a59a02ba906194285e81eb1f98ffa28e7cf4c9",
      name: "Pepe King Prawn",
      symbol: "PEPE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31942/thumb/Pepe_King_Prawn.png?1696530749"
    },
    {
      chainId: 1,
      address: "0xeb575c45004bd7b61c6a8d3446a62a05a6ce18d8",
      name: "Ethlas",
      symbol: "ELS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30331/thumb/ELS_Logo_200x200.png?1696529232"
    },
    {
      chainId: 1,
      address: "0xe0151763455a8a021e64880c238ba1cff3787ff0",
      name: "Aped",
      symbol: "APED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29906/thumb/Aped.png?1696528835"
    },
    {
      chainId: 1,
      address: "0x7d0fe0db46ec0017a89478e98c9ff86109ad4673",
      name: "RuneStone Bot",
      symbol: "RSB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37215/thumb/rsz_logo2_%282%29.png?1713773793"
    },
    {
      chainId: 1,
      address: "0xacdf0dba4b9839b96221a8487e9ca660a48212be",
      name: "High Yield USD",
      symbol: "HYUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30899/thumb/hyusdlogo.png?1700809180"
    },
    {
      chainId: 1,
      address: "0x76fca1adb104770b38581b64d55e67fa5a0f3966",
      name: "ZkTsunami",
      symbol: "ZKT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29253/thumb/Sa72qYMC_400x400.jpg?1696528207"
    },
    {
      chainId: 1,
      address: "0x2a7e415c169ce3a580c6f374dc26f6aaad1eccfe",
      name: "Hachi",
      symbol: "HACHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29262/thumb/HACHI_main_logo__.png?1696528216"
    },
    {
      chainId: 1,
      address: "0x3b0b09f5b14f6d50e6672ae158f9d71893feca18",
      name: "hiBAKC",
      symbol: "HIBAKC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30585/thumb/MicrosoftTeams-image_%2812%29.png?1696529448"
    },
    {
      chainId: 1,
      address: "0x508e00d5cef397b02d260d035e5ee80775e4c821",
      name: "Bitcoin Cats",
      symbol: "1CAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34059/thumb/779e5404024bcd3cec3db54370ea66c.jpg?1703752231"
    },
    {
      chainId: 1,
      address: "0x6f3cbe18e9381dec6026e6cb8166c13944fcfee1",
      name: "FELIX",
      symbol: "FELIX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32897/thumb/200photo_2023-11-11_02-25-13.jpg?1699790963"
    },
    {
      chainId: 1,
      address: "0x722383e1e8994cb8a55cbc1621dc068b62403b1e",
      name: "RunesBot",
      symbol: "RBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37216/thumb/photo_2024-04-19_19.58.40.jpeg?1713773888"
    },
    {
      chainId: 1,
      address: "0xc3681a720605bd6f8fe9a2fabff6a7cdecdc605d",
      name: "Nihao",
      symbol: "NIHAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30619/thumb/nihaowhitecat.png?1696529493"
    },
    {
      chainId: 1,
      address: "0xdefa4e8a7bcba345f687a2f1456f5edd9ce97202",
      name: "Kyber Network Crystal",
      symbol: "KNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14899/thumb/RwdVsGcw_400x400.jpg?1696514562"
    },
    {
      chainId: 1,
      address: "0x861950d091704c80b2a0f69d4b3431f0aed7dc7a",
      name: "Magic BOT",
      symbol: "MAGIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32898/thumb/magic_bot_logo.jpg?1699792367"
    },
    {
      chainId: 1,
      address: "0x7c95e7ad2b349dc2f82d0f1117a44b561fa2699a",
      name: "Gracy",
      symbol: "GRACY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31943/thumb/gracy_200x200.png?1696530750"
    },
    {
      chainId: 1,
      address: "0x6bf765c43030387a983f429c1438e9d2025b7e12",
      name: "McPepe s",
      symbol: "PEPES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29265/thumb/pepes-logo_%282%29.png?1696528218"
    },
    {
      chainId: 1,
      address: "0x238a1fcc2f65ed50c1e1797cf5857cba3e82a55b",
      name: "Moeta",
      symbol: "MOETA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29245/thumb/photo_2023-05-30_21-31-25.jpg?1696528201"
    },
    {
      chainId: 1,
      address: "0x09a3ecafa817268f77be1283176b946c4ff2e608",
      name: "Mirror Protocol",
      symbol: "MIR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13295/thumb/mirror_logo_transparent.png?1696513067"
    },
    {
      chainId: 1,
      address: "0x544d230f0362f3843fda5caa99b94cb2b336e384",
      name: "Magnesium",
      symbol: "MAG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32056/thumb/WhatsApp_Image_2023-09-29_at_15.29.08.jpeg?1696530853"
    },
    {
      chainId: 1,
      address: "0x54012cdf4119de84218f7eb90eeb87e25ae6ebd7",
      name: "Luffy",
      symbol: "LUFFY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17736/thumb/LUFFY_LOGO.png?1696517262"
    },
    {
      chainId: 1,
      address: "0xbfe178cf147fda6490f69fe7e6ae038ff09d2980",
      name: "PSI Gate",
      symbol: "PSI/ACC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35338/thumb/psi-acc_logo.jpg?1708315646"
    },
    {
      chainId: 1,
      address: "0xcae7f3aa6d456463bef0e5b508542b69d96f2904",
      name: "InvectAI",
      symbol: "INVECTAI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29333/thumb/Invect.jpeg?1696528283"
    },
    {
      chainId: 1,
      address: "0x80008bcd713c38af90a9930288d446bc3bd2e684",
      name: "Karate Combat",
      symbol: "KARATE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30384/thumb/karate.jpg?1696529274"
    },
    {
      chainId: 1,
      address: "0xd54619e0b9899d74cc9b981354eb6b59732c43b1",
      name: "GalleryCoin",
      symbol: "GLR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29372/thumb/%EA%B0%A4%EB%9F%AC%EB%A6%AC%EC%BD%94%EC%9D%B8_%EB%A1%9C%EA%B3%A0%28200_200%29.png?1696528319"
    },
    {
      chainId: 1,
      address: "0x6ba75d640bebfe5da1197bb5a2aff3327789b5d3",
      name: "VNX EURO",
      symbol: "VEUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29351/thumb/VNXEUR_%281%29.png?1696528300"
    },
    {
      chainId: 1,
      address: "0x6ef460eb3563cfcc73f8147b0a77daffee71f867",
      name: "Zeus AI",
      symbol: "ZEUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29593/thumb/ZEUS.png?1696528532"
    },
    {
      chainId: 1,
      address: "0xbfc66d8cce39e668fd5d3c10fd1b1eabb82c27b7",
      name: "OVO",
      symbol: "OVO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29514/thumb/ovotoken200.png?1696528458"
    },
    {
      chainId: 1,
      address: "0x8d96b4ab6c741a4c8679ae323a100d74f085ba8f",
      name: "Bazaars",
      symbol: "BZR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26392/thumb/bazaars_logo-color-black-icon.png?1696525469"
    },
    {
      chainId: 1,
      address: "0xfac0403a24229d7e2edd994d50f5940624cbeac2",
      name: "Theopetra",
      symbol: "THEO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29431/thumb/MicrosoftTeams-image_%2884%29.png?1703417298"
    },
    {
      chainId: 1,
      address: "0xefd113cea2f656fe7899a25a06243a6e40406e08",
      name: "THE9",
      symbol: "THE9",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29357/thumb/THE9_logo.png?1696528305"
    },
    {
      chainId: 1,
      address: "0xa1f410f13b6007fca76833ee7eb58478d47bc5ef",
      name: "Rejuve AI",
      symbol: "RJV",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/29366/thumb/2023_Rejuve_Logo_-_Square_-_Teal.jpg?1696528314"
    },
    {
      chainId: 1,
      address: "0x21b8bfbbefc9e2b9a994871ecd742a5132b98aed",
      name: "Crypto Real Estate",
      symbol: "CRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29387/thumb/cre-logo-200.png?1696528333"
    },
    {
      chainId: 1,
      address: "0x4c0bc0b3c734a573d28c627a96b95a1f1a7596fb",
      name: "Husbant",
      symbol: "HUSBANT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32863/thumb/husbant.png?1699670240"
    },
    {
      chainId: 1,
      address: "0xcb129aa11ceaa00da1a92d12e26bb776ef3c3628",
      name: "PowBlocks",
      symbol: "XPB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32520/thumb/logo.png?1698406955"
    },
    {
      chainId: 1,
      address: "0xdcee70654261af21c44c093c300ed3bb97b78192",
      name: "Wrapped OETH",
      symbol: "WOETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29734/thumb/woeth-200x200.png?1714796686"
    },
    {
      chainId: 1,
      address: "0x03f813f7d066c55e3512985186df3b4e6a08e0d6",
      name: "Shepherd Inu",
      symbol: "SINU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30366/thumb/SINU.jpg?1696529263"
    },
    {
      chainId: 1,
      address: "0x0799de3f4e111b70e845edb7a8646d934a51e210",
      name: "50cal",
      symbol: "50CAL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33047/thumb/photo_2023-11-15_01-09-57_%281%29.jpg?1700472328"
    },
    {
      chainId: 1,
      address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
      name: "FUNToken",
      symbol: "FUN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/761/thumb/FUN.png?1696501914"
    },
    {
      chainId: 1,
      address: "0xb69753c06bb5c366be51e73bfc0cc2e3dc07e371",
      name: "POOH",
      symbol: "POOH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30091/thumb/Pooh-icon.png?1696529015"
    },
    {
      chainId: 1,
      address: "0xbcbf09b4b83eb3893d58f0665d21460c04e39d8e",
      name: "Sherlock Defi",
      symbol: "SLOCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30020/thumb/20230425_212153_copy_200x200.jpg?1696528944"
    },
    {
      chainId: 1,
      address: "0xfa05a73ffe78ef8f1a739473e462c54bae6567d9",
      name: "Lunyr",
      symbol: "LUN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/735/thumb/lunyr.png?1696501891"
    },
    {
      chainId: 1,
      address: "0x4df812f6064def1e5e029f1ca858777cc98d2d81",
      name: "Xaurum",
      symbol: "XAUR",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/461/thumb/xaurum.png?1696501719"
    },
    {
      chainId: 1,
      address: "0x4dd942baa75810a3c1e876e79d5cd35e09c97a76",
      name: "Dash 2 Trade",
      symbol: "D2T",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28707/thumb/logo.png?1696527689"
    },
    {
      chainId: 1,
      address: "0x5c8190b76e90b4dd0702740cf6eb0f7ee01ab5e9",
      name: "Archive AI",
      symbol: "ARCAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28939/thumb/pp.JPG?1696527913"
    },
    {
      chainId: 1,
      address: "0x0a58153a0cd1cfaea94ce1f7fdc5d7e679eca936",
      name: "Internet Money  ETH ",
      symbol: "IM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28930/thumb/IM_Circle_200.png?1696527905"
    },
    {
      chainId: 1,
      address: "0x719e7f0dadfdea25b78595da944f44d15d7e6795",
      name: "MUSK DAO",
      symbol: "MUSK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29464/thumb/musk.png?1696528410"
    },
    {
      chainId: 1,
      address: "0x5ac83bfbfcebb3397a40fd259dbe7a4be04237d3",
      name: "Lyfebloc",
      symbol: "LBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30021/thumb/LBT_Token.png?1696528945"
    },
    {
      chainId: 1,
      address: "0x2654e753424a9f02df31cfbc6c5af14a87b6cab5",
      name: "Kendoll Janner",
      symbol: "KEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31260/thumb/android-chrome-512x512.png?1696530084"
    },
    {
      chainId: 1,
      address: "0x5972a9689ee53481ad6301d60e1e15092754ffa3",
      name: "Nodebet",
      symbol: "NBET",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/35500/thumb/photo_2024-02-21_20-48-04.jpg?1708926297"
    },
    {
      chainId: 1,
      address: "0x8b39b70e39aa811b69365398e0aace9bee238aeb",
      name: "Red Kite",
      symbol: "PKF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14422/thumb/red_kite.png?1696514112"
    },
    {
      chainId: 1,
      address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
      name: "dForce",
      symbol: "DF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9709/thumb/xlGxxIjI_400x400.jpg?1696509776"
    },
    {
      chainId: 1,
      address: "0x60a26c05c5372dcded66940d2b56076bce925152",
      name: "SILVER",
      symbol: "SILVER",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32273/thumb/LOGO1.png?1697179980"
    },
    {
      chainId: 1,
      address: "0xb2fd1e0478dbf61772996bcce8a2f1151eeeda37",
      name: "Wrapped Pepe",
      symbol: "WPEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30961/thumb/200.png?1706775966"
    },
    {
      chainId: 1,
      address: "0x13dbd5394c2c7e4bdb85b1838286faa66532a262",
      name: "Sun Tzu",
      symbol: "TZU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30689/thumb/TZU_CG.png?1696529558"
    },
    {
      chainId: 1,
      address: "0xcfc5bd99915aaa815401c5a41a927ab7a38d29cf",
      name: "Threshold USD",
      symbol: "THUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32274/thumb/thusd.png?1697180081"
    },
    {
      chainId: 1,
      address: "0xb186035490c8602ead853ec98be05e3461521ab2",
      name: "Pack",
      symbol: "PACK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29556/thumb/Pack.png?1696528496"
    },
    {
      chainId: 1,
      address: "0x79d4f0232a66c4c91b89c76362016a1707cfbf4f",
      name: "VNX Swiss Franc",
      symbol: "VCHF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29547/thumb/VNXCHF_%282%29.png?1696528488"
    },
    {
      chainId: 1,
      address: "0xf36c5f04127f7470834ed6f98bddc1be62aba48d",
      name: "CryptoAI",
      symbol: "CAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28899/thumb/200blue.png?1696527875"
    },
    {
      chainId: 1,
      address: "0xa7fbd9254f10f8e20a31a593c9e8bc0d041e15f6",
      name: "Orbeon Protocol",
      symbol: "ORBN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29566/thumb/logo_%281%29.png?1696528506"
    },
    {
      chainId: 1,
      address: "0x9625ce7753ace1fa1865a47aae2c5c2ce4418569",
      name: "KAP Games",
      symbol: "KAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27682/thumb/KAP_Logo.png?1696526710"
    },
    {
      chainId: 1,
      address: "0x045da4bfe02b320f4403674b3b7d121737727a36",
      name: "DeFi Franc",
      symbol: "DCHF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28108/thumb/22249.png?1696527116"
    },
    {
      chainId: 1,
      address: "0xebdb54e76bfec9ab4e06ccf6e484e4126f81befc",
      name: "Soul Society",
      symbol: "HON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34781/thumb/symbol-soulsociety-new.png?1706015872"
    },
    {
      chainId: 1,
      address: "0x8e81d527f8fa05d82c514401c8144275174557cd",
      name: " CCB    ",
      symbol: "CCB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34797/thumb/CCB_200x200px.jpg?1711028027"
    },
    {
      chainId: 1,
      address: "0x6aa40d02115090d40dc33c7c5f3cf05112fa4f83",
      name: "PWRCASH",
      symbol: "PWRC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29571/thumb/our_logo.png?1696528511"
    },
    {
      chainId: 1,
      address: "0x059956483753947536204e89bfad909e1a434cc6",
      name: "Mintlayer",
      symbol: "ML",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29454/thumb/mintlayer-icon-coingecko200x200.png?1696528401"
    },
    {
      chainId: 1,
      address: "0xb5d730d442e1d5b119fb4e5c843c48a64202ef92",
      name: "Sabai Ecoverse",
      symbol: "SABAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29573/thumb/Logo_CMC.png?1702661154"
    },
    {
      chainId: 1,
      address: "0xfac77a24e52b463ba9857d6b758ba41ae20e31ff",
      name: "LSDx Finance",
      symbol: "LSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29519/thumb/logo.png?1696528462"
    },
    {
      chainId: 1,
      address: "0xc477d038d5420c6a9e0b031712f61c5120090de9",
      name: "Boson Protocol",
      symbol: "BOSON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14710/thumb/boson_logo.png?1696514381"
    },
    {
      chainId: 1,
      address: "0xd5df655087d99b7b720a5bc8711f296180a4f44b",
      name: "Catgirl Optimus",
      symbol: "OPTIG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29669/thumb/Optigpng.png?1696528604"
    },
    {
      chainId: 1,
      address: "0x857de36f92330e1b9a21e8745c692f2ce13866cb",
      name: "Meta Masters Guild Games",
      symbol: "MEMAGX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36899/thumb/1000039355.jpg?1712677645"
    },
    {
      chainId: 1,
      address: "0x89b69f2d1adffa9a253d40840b6baa7fc903d697",
      name: "Dione",
      symbol: "DIONE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26931/thumb/dione_200x200.png?1696525987"
    },
    {
      chainId: 1,
      address: "0xf915110898d9a455ad2da51bf49520b41655ccea",
      name: "TAI",
      symbol: "TAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30574/thumb/tai.png?1696529439"
    },
    {
      chainId: 1,
      address: "0xaf8942831f3a096f708b8b31f191b8958cf176c5",
      name: "Neural Radiance Field",
      symbol: "NERF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29521/thumb/Neural_Radiance_Field.png?1696528464"
    },
    {
      chainId: 1,
      address: "0x1aa51bc7eb181ce48ce626bf62f8956fa9555136",
      name: "PAWZONE",
      symbol: "PAW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29598/thumb/PAW_Token_Logo.png?1696528536"
    },
    {
      chainId: 1,
      address: "0x516e2758b044433371076a48127b8cfa7b0bdb43",
      name: "Smudge Lord",
      symbol: "SMUDGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30268/thumb/logo-A.png?1696529175"
    },
    {
      chainId: 1,
      address: "0xc89d9aa9d9e54bb196319c6195aea1038d2bc936",
      name: "Trend X",
      symbol: "TRENDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29522/thumb/200.png?1696528465"
    },
    {
      chainId: 1,
      address: "0xf3bb9f16677f2b86efd1dfca1c141a99783fde58",
      name: "Crown Token",
      symbol: "CROWN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30161/thumb/Crown_Token_200_200.png?1696529081"
    },
    {
      chainId: 1,
      address: "0x8cb73eb53fa81f808f704bea15a677b6464a1f90",
      name: "Gauro",
      symbol: "GAURO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31783/thumb/200_png.png?1696530600"
    },
    {
      chainId: 1,
      address: "0x6d3d490964205c8bc8ded39e48e88e8fde45b41f",
      name: "Gooch",
      symbol: "GOOCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30290/thumb/gooch.jpg?1696529195"
    },
    {
      chainId: 1,
      address: "0x823e1b82ce1dc147bbdb25a203f046afab1ce918",
      name: "SpiralDAO Coil",
      symbol: "COIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29773/thumb/200x200.png?1696528704"
    },
    {
      chainId: 1,
      address: "0x9559aaa82d9649c7a7b220e7c461d2e74c9a3593",
      name: "StaFi Staked ETH",
      symbol: "RETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14452/thumb/rETH.png?1696514140"
    },
    {
      chainId: 1,
      address: "0x4e4bffaa8df6f0dc3e5600bbacf7da55f37134fc",
      name: "BlockStar",
      symbol: "BST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29524/thumb/BlockStar_Transparent_200_by_200.png?1696528467"
    },
    {
      chainId: 1,
      address: "0xa66daa57432024023db65477ba87d4e7f5f95213",
      name: "Huobi Pool",
      symbol: "HPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6628/thumb/Huobi_pool_token.png?1696506977"
    },
    {
      chainId: 1,
      address: "0xa0cc4428fbb652c396f28dce8868b8743742a71c",
      name: "Purple AI",
      symbol: "PAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34193/thumb/Purple_AI.png?1704272332"
    },
    {
      chainId: 1,
      address: "0xbb19da2482308ec02a242aced4fe0f09d06b12a7",
      name: "Flash 3 0",
      symbol: "FLASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31151/thumb/logo_200x200.png?1696529979"
    },
    {
      chainId: 1,
      address: "0x1c9a2d6b33b4826757273d47ebee0e2dddcd978b",
      name: "Flux FRAX",
      symbol: "FFRAX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29580/thumb/fFRAX-320.png?1696528519"
    },
    {
      chainId: 1,
      address: "0x81994b9607e06ab3d5cf3afff9a67374f05f27d7",
      name: "Flux USDT",
      symbol: "FUSDT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29581/thumb/fUSDT-320.png?1696528520"
    },
    {
      chainId: 1,
      address: "0x0316eb71485b0ab14103307bf65a021042c6d380",
      name: "Huobi BTC",
      symbol: "HBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12407/thumb/hbtc.png?1696512229"
    },
    {
      chainId: 1,
      address: "0x9db0fb0aebe6a925b7838d16e3993a3976a64aab",
      name: "Bambi",
      symbol: "BAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30597/thumb/Frame_24.png?1696529467"
    },
    {
      chainId: 1,
      address: "0x9ffc3bcde7b68c46a6dc34f0718009925c1867cb",
      name: "Huobi Polkadot",
      symbol: "HDOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14107/thumb/hdot.png?1696513828"
    },
    {
      chainId: 1,
      address: "0xbcd4d5ac29e06e4973a1ddcd782cd035d04bc0b7",
      name: "Quick Intel",
      symbol: "QKNTL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29605/thumb/IMG_6589D0616DF1-1.jpeg?1696528542"
    },
    {
      chainId: 1,
      address: "0x9afb950948c2370975fb91a441f36fdc02737cd4",
      name: "Huobi FIL",
      symbol: "HFIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14109/thumb/HFIL.png?1696513830"
    },
    {
      chainId: 1,
      address: "0x2c000c0093de75a8fa2fccd3d97b314e20b431c3",
      name: "Huobi Litecoin",
      symbol: "HLTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14110/thumb/HLTC.png?1696513831"
    },
    {
      chainId: 1,
      address: "0x4216663ddc7bd10eaf44609df4dd0f91cd2be7f2",
      name: "MicroPepe",
      symbol: "MPEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30153/thumb/logo.jpeg?1696529073"
    },
    {
      chainId: 1,
      address: "0x7b37a55ffb30c11d95f943672ae98f28cfb7b087",
      name: "Fufu Token",
      symbol: "FUFU",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/32225/thumb/6522723afff7e2e198ce38c6_FufuTokenIcon_250x250.png?1696931163"
    },
    {
      chainId: 1,
      address: "0x5c0217e4e126d501896594bec409898a9afc5970",
      name: "Frens Coin",
      symbol: "FRENS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30470/thumb/Frens_200x200.png?1696529356"
    },
    {
      chainId: 1,
      address: "0x9471d30d78a3c9f076ce206d14867a8d8be1efde",
      name: "ZENEX",
      symbol: "ZNX",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/29638/thumb/znx-logo.png?1696528575"
    },
    {
      chainId: 1,
      address: "0xf024e6387392a3c3a03ebd0b9d6b747ff5359417",
      name: "Ordi Launch",
      symbol: "ORLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34889/thumb/Ordinal_Launch.png?1706540288"
    },
    {
      chainId: 1,
      address: "0x00e679ba63b509182c349f5614f0a07cdd0ce0c5",
      name: "Damex Token",
      symbol: "DAMEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30053/thumb/damex.jpg?1696528975"
    },
    {
      chainId: 1,
      address: "0x198d7387fa97a73f05b8578cdeff8f2a1f34cd1f",
      name: "Wrapped Jones AURA",
      symbol: "WJAURA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30103/thumb/geckoAura.png?1696529025"
    },
    {
      chainId: 1,
      address: "0xd2b274cfbf9534f56b59ad0fb7e645e0354f4941",
      name: "XDOGE",
      symbol: "XDOGE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31107/thumb/photo_2023-07-25_13.59.23.jpeg?1696529938"
    },
    {
      chainId: 1,
      address: "0x1234567461d3f8db7496581774bd869c83d51c93",
      name: "BitClave",
      symbol: "CAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1585/thumb/bitclave.png?1696502618"
    },
    {
      chainId: 1,
      address: "0xad6eefb4f4a6ce3e2cd2049c3104f5ce5ed082f0",
      name: "Simpson6900",
      symbol: "SIMPSON690",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32175/thumb/1111.png?1696742771"
    },
    {
      chainId: 1,
      address: "0xcaeda9650ccd356af7776057a105f9e6ffe68213",
      name: "Loong",
      symbol: "LOONG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32176/thumb/200x200.png?1696742804"
    },
    {
      chainId: 1,
      address: "0x41b25ff6431074959532db7435dadaca65a21d1c",
      name: "Claw",
      symbol: "CLAW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29677/thumb/PBixw6K.png?1696528611"
    },
    {
      chainId: 1,
      address: "0x5de8ab7e27f6e7a1fff3e5b337584aa43961beef",
      name: "SmarDex",
      symbol: "SDEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29470/thumb/SDEX_logo_transparent_outside_240x240.png?1696930070"
    },
    {
      chainId: 1,
      address: "0xffe203b59393593965842439ce1e7d7c78109b46",
      name: "Satellite Doge 1 Mission",
      symbol: "DOGE-1",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33316/thumb/logo_200-200.png?1701413684"
    },
    {
      chainId: 1,
      address: "0x69a95185ee2a045cdc4bcd1b1df10710395e4e23",
      name: "Poolz Finance  OLD ",
      symbol: "POOLZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13679/thumb/poolz_logo.png?1696513428"
    },
    {
      chainId: 1,
      address: "0xb939da54f9748440a1b279d42be1296942732288",
      name: "Fonzy",
      symbol: "FONZY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30245/thumb/FONZY_CROWN_2_HANDS_%282%29.png?1696529154"
    },
    {
      chainId: 1,
      address: "0x6732efaf6f39926346bef8b821a04b6361c4f3e5",
      name: "Simple Asymmetry ETH",
      symbol: "SAFETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30426/thumb/safETH_Logo_200_200.png?1699479265"
    },
    {
      chainId: 1,
      address: "0x4c4a50a61bed3b9024d8ffc1f1d168dc8cb1c689",
      name: "The Blu Arctic Water Comp",
      symbol: "BARC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34467/thumb/BARC_200x200.png?1704967819"
    },
    {
      chainId: 1,
      address: "0x50eec6d765792dcfb0913c8403ef2a12e1b861a6",
      name: "Z Cubed",
      symbol: "Z3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29478/thumb/Z3-BLACK-200x200.png?1696528422"
    },
    {
      chainId: 1,
      address: "0xda0c94c73d127ee191955fb46bacd7ff999b2bcd",
      name: "Construct",
      symbol: "STANDARD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20119/thumb/construct200px.png?1696519536"
    },
    {
      chainId: 1,
      address: "0x6fc16de36e040e0c7d1a70d039ef701516516b32",
      name: "ScopexAI",
      symbol: "SCOPEX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35151/thumb/scopex_200x200.jpg?1707559235"
    },
    {
      chainId: 1,
      address: "0xbb3a8fd6ec4bf0fdc6cd2739b1e41192d12b1873",
      name: "Orbofi AI",
      symbol: "OBI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30216/thumb/new_V_test2.png?1696529127"
    },
    {
      chainId: 1,
      address: "0x15f74458ae0bfdaa1a96ca1aa779d715cc1eefe4",
      name: "Grai",
      symbol: "GRAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30427/thumb/GRAI_Token.png?1696529315"
    },
    {
      chainId: 1,
      address: "0x08f5a9235b08173b7569f83645d2c7fb55e8ccd8",
      name: "Tierion",
      symbol: "TNT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/923/thumb/tierion.png?1696502044"
    },
    {
      chainId: 1,
      address: "0x5919dea604631016c15c805e3d948a0384879892",
      name: "The People s Coin",
      symbol: "PEEP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/16777/thumb/peeps.png?1696516349"
    },
    {
      chainId: 1,
      address: "0x7cb683151a83c2b10a30cbb003cda9996228a2ba",
      name: "IYKYK",
      symbol: "IYKYK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30022/thumb/iykyk200.png?1696528946"
    },
    {
      chainId: 1,
      address: "0xbd15ad921e1b480209af549874a2fcb80dc312bf",
      name: "Harpoon",
      symbol: "HRP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29889/thumb/Harpoon.jpeg?1696528813"
    },
    {
      chainId: 1,
      address: "0x5de597849cf72c72f073e9085bdd0dadd8e6c199",
      name: "Finblox",
      symbol: "FBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27087/thumb/fbx.png?1696526136"
    },
    {
      chainId: 1,
      address: "0x9681ee0d91e737c3b60aceba7fbdae61b5462f42",
      name: "Crypto Carbon Energy",
      symbol: "CYCE",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/29824/thumb/CYCE.jpg?1696528752"
    },
    {
      chainId: 1,
      address: "0xf88baf18fab7e330fa0c4f83949e23f52fececce",
      name: "Granary",
      symbol: "GRAIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29740/thumb/Grain.png?1696528670"
    },
    {
      chainId: 1,
      address: "0xd488321ef57ab16b4f334558b1fc4e0213c82db1",
      name: "WCTrades",
      symbol: "WCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36125/thumb/WCTrades.png?1710577456"
    },
    {
      chainId: 1,
      address: "0x87fd01183ba0235e1568995884a78f61081267ef",
      name: "Open Mind Network",
      symbol: "OPMND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35768/thumb/uprptsto_400x400.jpg?1709784632"
    },
    {
      chainId: 1,
      address: "0xf4cc8237fc85f54b64975142ec71a9554ecf4c61",
      name: "Versus",
      symbol: "VS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32230/thumb/avi.png?1696933323"
    },
    {
      chainId: 1,
      address: "0x68b429161ec09a6c1d65ba70727ab1faa5bc4026",
      name: "Ordinal Doge",
      symbol: "ODOGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29323/thumb/o-DOGE-200x200.png?1696528274"
    },
    {
      chainId: 1,
      address: "0x082646b22a3960da69ef7a778c16dd6fb85dd999",
      name: "Fuck Pepe",
      symbol: "FKPEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29894/thumb/Screenshot_7.png?1696528818"
    },
    {
      chainId: 1,
      address: "0x718dab2c7bbd2d9503dc1ce1dbc215abc41a3545",
      name: "XAIGROK",
      symbol: "XAIGROK",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/33584/thumb/20231207_155741.jpg?1702465158"
    },
    {
      chainId: 1,
      address: "0x0364e6c6f4f9ad90f11a39e681bd6c0156b3efdb",
      name: "Bimbo The Dog",
      symbol: "BIMBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34551/thumb/photo_2024-01-12_16.35.16.png?1705368435"
    },
    {
      chainId: 1,
      address: "0x75430d0782a443bd4f1c92c69009599dea53a206",
      name: "Pick Or Rick",
      symbol: "RICK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30653/thumb/Untitled_Artwork_8_%283%29_%281%29.png?1696529523"
    },
    {
      chainId: 1,
      address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
      name: "Perpetual Protocol",
      symbol: "PERP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12381/thumb/60d18e06844a844ad75901a9_mark_only_03.png?1696512205"
    },
    {
      chainId: 1,
      address: "0x049e9f5369358786a1ce6483d668d062cfe547ec",
      name: "Checks Token",
      symbol: "CHECKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30367/thumb/checkstoken-200x200.png?1696529264"
    },
    {
      chainId: 1,
      address: "0x5f18ea482ad5cc6bc65803817c99f477043dce85",
      name: "Agility",
      symbol: "AGI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29781/thumb/14csBMea_400x400.jpg?1696528711"
    },
    {
      chainId: 1,
      address: "0x0f5def84ced3e9e295dae28df96d0b846de92c1a",
      name: "Crypto SDG",
      symbol: "SDG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29816/thumb/SDG_token_Logo_200.png?1696528745"
    },
    {
      chainId: 1,
      address: "0xb7bda6a89e724f63572ce68fddc1a6d1d5d24bcf",
      name: "OGzClub",
      symbol: "OGZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31121/thumb/25832.png?1696529951"
    },
    {
      chainId: 1,
      address: "0xd015422879a1308ba557510345e944b912b9ab73",
      name: "FreeTrump",
      symbol: "TRUMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34699/thumb/photo_2024-01-19_11-00-46.jpg?1705859328"
    },
    {
      chainId: 1,
      address: "0x3a4c122243b53135e7f6bf5b4658092c3a3109ab",
      name: "HustleBot",
      symbol: "HUSTLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32651/thumb/IMG_20231030_233538_062.jpg?1698895135"
    },
    {
      chainId: 1,
      address: "0x10010078a54396f62c96df8532dc2b4847d47ed3",
      name: "Hundred Finance",
      symbol: "HND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18445/thumb/hnd.PNG?1696517933"
    },
    {
      chainId: 1,
      address: "0x247dc9cbbaadabce6e30e2a84ec6c53a419913ad",
      name: "Ethereum Message Service",
      symbol: "EMS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29812/thumb/LogoEMS200x200.png?1696528741"
    },
    {
      chainId: 1,
      address: "0x7da2641000cbb407c329310c461b2cb9c70c3046",
      name: "Delysium",
      symbol: "AGI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29299/thumb/AGI_logo_200.png?1696528251"
    },
    {
      chainId: 1,
      address: "0x519c1001d550c0a1dae7d1fc220f7d14c2a521bb",
      name: "Polkaswap",
      symbol: "PSWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15475/thumb/pswap-token-logomark-ticker-icon-200px-transparent-optimized.png?1696515120"
    },
    {
      chainId: 1,
      address: "0x4872208c83acbfd7f6dea5aa6ce6d5d7aed2ac1c",
      name: "AiMage Tools",
      symbol: "AIMAGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33585/thumb/AiMAGE.jpg?1702465762"
    },
    {
      chainId: 1,
      address: "0x5efcea234f7547de4569aad1215fa5d2adaced38",
      name: "Clown Pepe",
      symbol: "HONK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29890/thumb/Honk.png?1696528814"
    },
    {
      chainId: 1,
      address: "0x00282fd551d03dc033256c4bf119532e8c735d8a",
      name: "Biaocoin",
      symbol: "BIAO",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/30602/thumb/biao_cmc.png?1696529472"
    },
    {
      chainId: 1,
      address: "0xc3c7b03335eb950a2a9207ac5cac0571de34d844",
      name: "BABY WALL STREET MEMES",
      symbol: "BWSM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32174/thumb/BabyWallStreet-2.png?1696742579"
    },
    {
      chainId: 1,
      address: "0x357c915d7c12dc506d13332bb06c932af13e99a0",
      name: "LuckysLeprecoin",
      symbol: "LUCKYSLP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32303/thumb/Luckys_Leprecoin_New_Logo_200x200.png?1697187844"
    },
    {
      chainId: 1,
      address: "0xad1a5b8538a866ecd56ddd328b50ed57ced5d936",
      name: "Good Gensler",
      symbol: "GENSLR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29943/thumb/goodgg-logo-.png?1696528870"
    },
    {
      chainId: 1,
      address: "0x40d16fc0246ad3160ccc09b8d0d3a2cd28ae6c2f",
      name: "GHO",
      symbol: "GHO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30663/thumb/ghoaave.jpeg?1696529533"
    },
    {
      chainId: 1,
      address: "0xcc8e21f599995d1c8367054841b8af5024ddf01b",
      name: "Alpha Gardeners",
      symbol: "AG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31153/thumb/AG.png?1696529981"
    },
    {
      chainId: 1,
      address: "0x0fe0ed7f146cb12e4b9759aff4fa8d34571802ca",
      name: "Pool Partyyy",
      symbol: "PARTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29832/thumb/dioiHjS2_400x400.jpg?1696528760"
    },
    {
      chainId: 1,
      address: "0xc6cc3d07c705e39d11c7f60d8836c7c78d4ac5f1",
      name: "Olea Token",
      symbol: "OLEA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29056/thumb/symbol.png?1696528023"
    },
    {
      chainId: 1,
      address: "0xf04af3f4e4929f7cd25a751e6149a3318373d4fe",
      name: "Spring Token",
      symbol: "SPRING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25364/thumb/spring.png?1696524497"
    },
    {
      chainId: 1,
      address: "0x3ea8ea4237344c9931214796d9417af1a1180770",
      name: "Flux Protocol",
      symbol: "FLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21137/thumb/Flux_Logo.jpg?1712087060"
    },
    {
      chainId: 1,
      address: "0x5138ebe7acaae209d6f0b651e4d02a67ef61f436",
      name: "Graffiti",
      symbol: "GRAF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37639/thumb/graffiti.jpg?1715105663"
    },
    {
      chainId: 1,
      address: "0x30d20208d987713f46dfd34ef128bb16c404d10f",
      name: "Stader",
      symbol: "SD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20658/thumb/SD_Token_Logo.png?1696520060"
    },
    {
      chainId: 1,
      address: "0x53250b5dfa8c911547afeaf18db025024c8e919a",
      name: "Kermit",
      symbol: "KERMIT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29858/thumb/Kermit.png?1696528784"
    },
    {
      chainId: 1,
      address: "0xafe7131a57e44f832cb2de78ade38cad644aac2f",
      name: "Morpho Aave Tether USD",
      symbol: "MAUSDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29834/thumb/maUSDT_%284%29.png?1696528762"
    },
    {
      chainId: 1,
      address: "0x9994e35db50125e0df82e4c2dde62496ce330999",
      name: "Morpho",
      symbol: "MORPHO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29837/thumb/2022-official-morpho-token.png?1696528764"
    },
    {
      chainId: 1,
      address: "0x80f0c1c49891dcfdd40b6e0f960f84e6042bcb6f",
      name: "DBXen",
      symbol: "DXN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29838/thumb/DBXen.jpg?1696528765"
    },
    {
      chainId: 1,
      address: "0xd068c7c941fbbd2300cb2f1841858c2643722dc7",
      name: "DGNAPP AI",
      symbol: "DEGAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29745/thumb/logo_200x200.png?1696528677"
    },
    {
      chainId: 1,
      address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
      name: "Pepe",
      symbol: "PEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29850/thumb/pepe-token.jpeg?1696528776"
    },
    {
      chainId: 1,
      address: "0x159cdaf78be31e730d9e1330adfcfbb79a5fdb95",
      name: "MixToEarn",
      symbol: "MTE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30893/thumb/200x200x.png?1696529739"
    },
    {
      chainId: 1,
      address: "0x427a03fb96d9a94a6727fbcfbba143444090dd64",
      name: "PIXL",
      symbol: "PIXL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33045/thumb/20220531_190522.jpg?1700450022"
    },
    {
      chainId: 1,
      address: "0xea18dc833653172bbe819feb5320d9da9f99799a",
      name: "Dogelon Mars 2 0",
      symbol: "ELON20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30963/thumb/ABE04427-81C7-4AF2-9308-AE35C661E66E.jpeg?1696529803"
    },
    {
      chainId: 1,
      address: "0x0d505c03d30e65f6e9b4ef88855a47a89e4b7676",
      name: "Zoomer",
      symbol: "ZOOMER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30894/thumb/zoooooooooomer.jpg?1696529740"
    },
    {
      chainId: 1,
      address: "0xf5ec1a08902ae0ae5323466c35ea49a37409e4ca",
      name: "SAKURA UNITED PLATFORM",
      symbol: "SUP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32213/thumb/apple200%C3%97200.png?1696827569"
    },
    {
      chainId: 1,
      address: "0xf2a22b900dde3ba18ec2aef67d4c8c1a0dab6aac",
      name: "Monkeys",
      symbol: "MONKEYS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29815/thumb/Monkeys_Elon.png?1696528744"
    },
    {
      chainId: 1,
      address: "0x577fee283e776eec29c9e4d258431982780a38a8",
      name: "Pepa ERC",
      symbol: "PEPA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29866/thumb/3iGdoyL.png?1696528791"
    },
    {
      chainId: 1,
      address: "0xaf75d880b3128981d1fed3292fc02e3fb37acd53",
      name: "TruthGPT",
      symbol: "TRUTH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29867/thumb/TruthGPT.png?1696528792"
    },
    {
      chainId: 1,
      address: "0x93ad9b819c88d98b4c9641470a96e24769ae7922",
      name: "KRYZA Exchange",
      symbol: "KRX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/21249/thumb/krx200150.png?1696520622"
    },
    {
      chainId: 1,
      address: "0x40803cea2b2a32bda1be61d3604af6a814e70976",
      name: "Spool",
      symbol: "SPOOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21532/thumb/spool.png?1696520891"
    },
    {
      chainId: 1,
      address: "0x5c559f3ee9a81da83e069c0093471cb05d84052a",
      name: "BabyPepe",
      symbol: "BABYPEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29869/thumb/BabyPepe200.png?1696528794"
    },
    {
      chainId: 1,
      address: "0x8bcbef61acd66537362f38167f11875134ffcd63",
      name: "Pepe Girl",
      symbol: "PEPEG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29896/thumb/pepe_sad_reverse_200X200.png?1696528820"
    },
    {
      chainId: 1,
      address: "0x571e21a545842c6ce596663cda5caa8196ac1c7a",
      name: "Champignons of Arborethia",
      symbol: "CHAMPZ",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31124/thumb/Champz_logo_square_200x200.png?1704671904"
    },
    {
      chainId: 1,
      address: "0x5026f006b85729a8b14553fae6af249ad16c9aab",
      name: "Wojak",
      symbol: "WOJAK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29856/thumb/wojak.png?1696528782"
    },
    {
      chainId: 1,
      address: "0xee772cec929d8430b4fa7a01cd7fbd159a68aa83",
      name: "Shanghai Inu",
      symbol: "SHANG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29881/thumb/IMG_20230418_174523_393-removebg-preview.png?1696528806"
    },
    {
      chainId: 1,
      address: "0x9dc7094530cb1bcf5442c3b9389ee386738a190c",
      name: "Morpho Aave Curve DAO Token",
      symbol: "MACRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29874/thumb/maCRV.jpg?1696528799"
    },
    {
      chainId: 1,
      address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
      name: "Compound",
      symbol: "COMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10775/thumb/COMP.png?1696510737"
    },
    {
      chainId: 1,
      address: "0xd59d7d2e955533fcd21641da8a70eae9624a3c49",
      name: "MagicRing",
      symbol: "MRING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36905/thumb/photo_2024-04-08_01-09-25.jpg?1712724842"
    },
    {
      chainId: 1,
      address: "0xad8d0de33c43eefe104a279cdb6ae250c12e6214",
      name: "Naruto",
      symbol: "NARUTO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29963/thumb/logo.jpg?1696528889"
    },
    {
      chainId: 1,
      address: "0xf7790914dc335b20aa19d7c9c9171e14e278a134",
      name: "Euro Coinvertible",
      symbol: "EUR-C",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29903/thumb/Screenshot_2023-04-20_at_5.57.42_PM.png?1696528832"
    },
    {
      chainId: 1,
      address: "0x18e5f92103d1b34623738ee79214b1659f2ee109",
      name: "Wrapped CellMates",
      symbol: "WCELL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35154/thumb/755F6B74-7940-475C-9818-4672DEF73BDA.png?1707561272"
    },
    {
      chainId: 1,
      address: "0xe46091dce9c67691bcf22768bbee0bc9e20d4beb",
      name: "WSB Classic",
      symbol: "WSBC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30165/thumb/photo_2023-05-05_07-44-23.jpg?1696529085"
    },
    {
      chainId: 1,
      address: "0x8442e0e292186854bb6875b2a0fc1308b9ded793",
      name: "Print The Pepe",
      symbol: "PP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29964/thumb/printthepepe.PNG?1696528890"
    },
    {
      chainId: 1,
      address: "0x1a963df363d01eebb2816b366d61c917f20e1ebe",
      name: "MEMEME",
      symbol: "MEMEME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29965/thumb/MEMEME_token_image_200px.png?1696528891"
    },
    {
      chainId: 1,
      address: "0x1a11ea9d61588d756d9f1014c3cf0d226aedd279",
      name: "MILEI Token",
      symbol: "MILEI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34697/thumb/MILEI_CIRCLE_200px.png?1705858944"
    },
    {
      chainId: 1,
      address: "0xddd5592cf4759313c649eb4e624a79541ed222ed",
      name: "PepeXL",
      symbol: "PEPEXL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30343/thumb/plogo200.png?1696529243"
    },
    {
      chainId: 1,
      address: "0x5582a479f0c403e207d2578963ccef5d03ba636f",
      name: "Salad",
      symbol: "SALD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29936/thumb/RJV4r-hN_400x400.jpg?1696528864"
    },
    {
      chainId: 1,
      address: "0x244b797d622d4dee8b188b03546acaabd0cf91a0",
      name: "FourCoin",
      symbol: "FOUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30167/thumb/fourcoin.jpeg?1696529087"
    },
    {
      chainId: 1,
      address: "0x553afe6468949e0685959022217336717df5fbe8",
      name: "Palette",
      symbol: "PLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35615/thumb/output-onlinepngtools-13-1.png?1709282022"
    },
    {
      chainId: 1,
      address: "0x4c6e2c495b974b8d4220e370f23c7e0e1da9b644",
      name: "Smiley Coin",
      symbol: "SMILEY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30809/thumb/photo_2023-06-21_03-25-14.jpg?1696529666"
    },
    {
      chainId: 1,
      address: "0x8e729198d1c59b82bd6bba579310c40d740a11c2",
      name: "Alvara Protocol",
      symbol: "ALVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35707/thumb/ALVA.png?1709624242"
    },
    {
      chainId: 1,
      address: "0x755582d6db18003e67eccaa7090421a775280a36",
      name: "FP  JeerGirl",
      symbol: "JEERGIRL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34108/thumb/JEERGIRL.jpg?1703988353"
    },
    {
      chainId: 1,
      address: "0x9d69a8ccb7cbc03d3dbb2c4ab03c0c1fad3e74b0",
      name: "Creatopy Builder",
      symbol: "CREATOPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36335/thumb/IMG_20240321_153859_510.jpg?1711100114"
    },
    {
      chainId: 1,
      address: "0x15f20f9dfdf96ccf6ac96653b7c0abfe4a9c9f0f",
      name: "Wall Street Baby",
      symbol: "WSB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15042/thumb/GMih0pSW_400x400.png?1696514701"
    },
    {
      chainId: 1,
      address: "0xec505c81d6a7567b5bde804870b1038832fe6da1",
      name: "Coinhound",
      symbol: "CND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30056/thumb/%28200x200%29_Coinhound_Icon.png?1696528977"
    },
    {
      chainId: 1,
      address: "0xb8c55c80a1cb7394088a36c6b634dc2bf3c6fb67",
      name: "Pepe Doge",
      symbol: "PEPEDOGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29968/thumb/Pepedoge.jpeg?1696528894"
    },
    {
      chainId: 1,
      address: "0xd7b2c1a7f3c67fb0ea57a7ef29bc1f18d7be3195",
      name: "VoluMint",
      symbol: "VMINT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33745/thumb/volumint_200x200px_clearbg.png?1702924153"
    },
    {
      chainId: 1,
      address: "0x6c4c193bff0a117f0c2b516802abba961a1eeb12",
      name: "Papa",
      symbol: "PAPA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29971/thumb/logo-dex.png?1696528897"
    },
    {
      chainId: 1,
      address: "0x41545f8b9472d758bb669ed8eaeeecd7a9c4ec29",
      name: "Forta",
      symbol: "FORT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25060/thumb/Forta_lgo_%281%29.png?1696524210"
    },
    {
      chainId: 1,
      address: "0x5ad02305ba9a4985390170337582986e419f1a2c",
      name: "Crypto X",
      symbol: "CX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31084/thumb/Logo_W_kBG_%281%29.png?1696529917"
    },
    {
      chainId: 1,
      address: "0x8a7b7b9b2f7d0c63f66171721339705a6188a7d5",
      name: "EtherDoge",
      symbol: "EDOGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1013/thumb/etherdoge.png?1696502125"
    },
    {
      chainId: 1,
      address: "0xb06b8186cc008a79fd6722b1eefad07c14e97da0",
      name: "Sign Token",
      symbol: "SIGN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26495/thumb/PWRjbqG9_400x400.png?1696525569"
    },
    {
      chainId: 1,
      address: "0x0ba74fb26ca523f2dc22fa4318581cc2452eaba1",
      name: "Bogdanoff",
      symbol: "BOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30026/thumb/telegram-cloud-document-1-1809833204887060537_copia_2.png?1696528949"
    },
    {
      chainId: 1,
      address: "0xe07c41e9cdf7e0a7800e4bbf90d414654fd6413d",
      name: "CBDC",
      symbol: "CBDC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31665/thumb/MThOhXH1_400x400.jpg?1696530482"
    },
    {
      chainId: 1,
      address: "0x98e35f5599b57998900e5e0675721c90a5499327",
      name: "BuddyAI",
      symbol: "BUDDY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34109/thumb/photo_2023-12-26_10-13-17.jpg?1703988840"
    },
    {
      chainId: 1,
      address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
      name: "Bounce",
      symbol: "AUCTION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13860/thumb/1_KtgpRIJzuwfHe0Rl0avP_g.jpeg?1696513606"
    },
    {
      chainId: 1,
      address: "0xc7a2572fa8fdb0f7e81d6d3c4e3ccf78fb0dc374",
      name: "Ben s Finale",
      symbol: "FINALE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30661/thumb/tGy9rQvi_400x400.jpg?1696529531"
    },
    {
      chainId: 1,
      address: "0xe1ec350ea16d1ddaff57f31387b2d9708eb7ce28",
      name: "Pepechain",
      symbol: "PC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30059/thumb/Pepechain.png?1696528980"
    },
    {
      chainId: 1,
      address: "0x2047ab3072b52561596ce5e0131bdbb7c848538d",
      name: "Bored Token",
      symbol: "BORED",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28515/thumb/Bored.png?1696527508"
    },
    {
      chainId: 1,
      address: "0x2f5fa8adf5f09a5f9de05b65fe82a404913f02c4",
      name: "TROLL 2 0",
      symbol: "TROLL20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34605/thumb/Troll_2.o.jpg?1705492471"
    },
    {
      chainId: 1,
      address: "0x2c7f442aab99d5e18cfae2291c507c0b5f3c1eb5",
      name: "Keko",
      symbol: "KEKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29967/thumb/ytX0JKjO_400x400.jpg?1696528893"
    },
    {
      chainId: 1,
      address: "0x0414d8c87b271266a5864329fb4932bbe19c0c49",
      name: "WSB Coin",
      symbol: "WSB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30060/thumb/wsb_pfp.png?1696528981"
    },
    {
      chainId: 1,
      address: "0xa3bed4e1c75d00fa6f4e5e6922db7261b5e9acd2",
      name: "mStable Governance  Meta",
      symbol: "MTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11846/thumb/mStable.png?1696511717"
    },
    {
      chainId: 1,
      address: "0xe7ac8545e34771de3706598abb3db9a19af2a07f",
      name: "MONKED",
      symbol: "MONKED",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/30011/thumb/monked200.png?1696528935"
    },
    {
      chainId: 1,
      address: "0xa589d8868607b8d79ee4288ce192796051263b64",
      name: "TATE",
      symbol: "TATE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30034/thumb/Tate_logo_Coingecko.png?1696528957"
    },
    {
      chainId: 1,
      address: "0x81db1949d0e888557bc632f7c0f6698b1f8c9106",
      name: "d acc",
      symbol: "D/ACC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33313/thumb/dddd.png?1701412963"
    },
    {
      chainId: 1,
      address: "0x0f7b3f5a8fed821c5eb60049538a548db2d479ce",
      name: "AirTor Protocol",
      symbol: "ATOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29690/thumb/AirTor.png?1696528623"
    },
    {
      chainId: 1,
      address: "0xb076bda1abc154ddb4ccd9be45542a823aee290e",
      name: "FlexMeme",
      symbol: "FLEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30018/thumb/flexmeme.png?1696528942"
    },
    {
      chainId: 1,
      address: "0xd08623fb2a1f044025eec65886011cf5d0f06b01",
      name: "Larry",
      symbol: "LARRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30460/thumb/Safeimagekit-resized-img.png?1696529347"
    },
    {
      chainId: 1,
      address: "0xde8cd13b812bcd82218754a740b27e76ec1e86ad",
      name: "TRESTLE",
      symbol: "TRESTLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34992/thumb/PNG_-_Logo_-_3485x.png?1706943532"
    },
    {
      chainId: 1,
      address: "0xb4fc1fc74effa5dc15a031eb8159302cfa4f1288",
      name: "OrdiZK",
      symbol: "OZK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33619/thumb/IMG_20231214_094021_481.jpg?1702528631"
    },
    {
      chainId: 1,
      address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
      name: "Aragon",
      symbol: "ANT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/681/thumb/Avatar_Circle_x6.png?1696501871"
    },
    {
      chainId: 1,
      address: "0xb2cb83e8e1b326373b7f1068d10c50ebfa04f070",
      name: "Pepito",
      symbol: "PEPI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30062/thumb/IMG_20230428_101018_444.png?1696528984"
    },
    {
      chainId: 1,
      address: "0x8457ca5040ad67fdebbcc8edce889a335bc0fbfb",
      name: "AltLayer",
      symbol: "ALT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34608/thumb/Logomark_200x200.png?1715107868"
    },
    {
      chainId: 1,
      address: "0xd87d72248093597df8d56d2a53c1ab7c1a0cc8da",
      name: "HAHA",
      symbol: "HAHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30070/thumb/2.png?1696528991"
    },
    {
      chainId: 1,
      address: "0xc5190e7fec4d97a3a3b1ab42dfedac608e2d0793",
      name: "FX1Sports",
      symbol: "FXI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30078/thumb/fx1_sports_logo.jpg?1696529003"
    },
    {
      chainId: 1,
      address: "0x3d2b66bc4f9d6388bd2d97b95b565be1686aefb3",
      name: " LAMBO",
      symbol: "LAMBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30126/thumb/IMG_20230502_225617_622.png?1696529048"
    },
    {
      chainId: 1,
      address: "0x7f4c5447af6a96d8eeaee1d932338cfc57890dbd",
      name: "Dave Coin",
      symbol: "DAVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30703/thumb/davelogo_transparent200x200.png?1696529575"
    },
    {
      chainId: 1,
      address: "0xbbb32f99e6f2cb29337eebaa43c5069386de6e6c",
      name: "Phemex Token",
      symbol: "PT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33314/thumb/phemex_logo.png?1701959611"
    },
    {
      chainId: 1,
      address: "0x2c10c0de3362ff21f8ed6bc7f4ac5e391153fd2c",
      name: "MARKETVIZ",
      symbol: "VIZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30083/thumb/CG_Logo.png?1696529007"
    },
    {
      chainId: 1,
      address: "0xe60779cc1b2c1d0580611c526a8df0e3f870ec48",
      name: "unshETHing Token",
      symbol: "USH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29337/thumb/unsheth_large_logo.png?1696528287"
    },
    {
      chainId: 1,
      address: "0x1f7505f486c22f4338ac2bde67a3e93a547644b9",
      name: "Cat Intelligence Agency",
      symbol: "CIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34728/thumb/cia.jpeg?1706632795"
    },
    {
      chainId: 1,
      address: "0x5f7827fdeb7c20b443265fc2f40845b715385ff2",
      name: "Societe Generale FORGE EURCV",
      symbol: "EURCV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33415/thumb/eurcv_%281%29.png?1701752017"
    },
    {
      chainId: 1,
      address: "0x4bb3205bf648b7f59ef90dee0f1b62f6116bc7ca",
      name: "NBX",
      symbol: "BYN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14746/thumb/NBX.png?1696514416"
    },
    {
      chainId: 1,
      address: "0xe7c8537f92b4feefdc19bd6b4023dfe79400cb30",
      name: "Bones",
      symbol: "BONES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32232/thumb/IMG_20231008_075551_623_%281%29.jpg?1696936788"
    },
    {
      chainId: 1,
      address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
      name: "Stella",
      symbol: "ALPHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12738/thumb/Stella200x200-06.png?1696512537"
    },
    {
      chainId: 1,
      address: "0x0f1e49d6dcfc9eefcce9d5ae3c660f8ead75061a",
      name: "Vinlink",
      symbol: "VNLNK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30139/thumb/VNLNK_Logo.png?1696529060"
    },
    {
      chainId: 1,
      address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
      name: "TrueFi",
      symbol: "TRU",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13180/thumb/truefi_glyph_color.png?1696512963"
    },
    {
      chainId: 1,
      address: "0x5fc111f3fa4c6b32eaf65659cfebdeed57234069",
      name: "0xGasless",
      symbol: "0XGAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33756/thumb/Main_LOGO.jpg?1707051665"
    },
    {
      chainId: 1,
      address: "0x02795795196f563fdafce8dd97fca4871ded51c3",
      name: "Winnerz",
      symbol: "WNZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34924/thumb/wnz.jpeg?1706666326"
    },
    {
      chainId: 1,
      address: "0x666cbfaa3baa2faccfac8854fea1e5db140fb104",
      name: "PLUMS",
      symbol: "PLUMS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30097/thumb/logoPlums.png?1696529021"
    },
    {
      chainId: 1,
      address: "0x7d8146cf21e8d7cbe46054e01588207b51198729",
      name: "BOB Token",
      symbol: "BOB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29929/thumb/bob.png?1696528857"
    },
    {
      chainId: 1,
      address: "0x9bf1d7d63dd7a4ce167cf4866388226eeefa702e",
      name: "Ben",
      symbol: "BEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30175/thumb/BEN_COIN.png?1696529094"
    },
    {
      chainId: 1,
      address: "0x586a7cfe21e55ec0e24f0bfb118f77fe4ca87bab",
      name: "BetbuInu",
      symbol: "CRYPTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31298/thumb/Betbu.jpeg?1696530118"
    },
    {
      chainId: 1,
      address: "0xe9da5e227e3fa4fc933b5f540be021e7ecc3fd81",
      name: "GMFAM",
      symbol: "GMFAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30547/thumb/GMFAM-logo_%282%29.png?1696529419"
    },
    {
      chainId: 1,
      address: "0x4e47951508fd4a4126f8ff9cf5e6fa3b7cc8e073",
      name: "Fluid",
      symbol: "FLUID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31890/thumb/fluidlogo200x200.png?1696530701"
    },
    {
      chainId: 1,
      address: "0xd4f4d0a10bcae123bb6655e8fe93a30d01eebd04",
      name: "LinqAI",
      symbol: "LNQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35645/thumb/cmc-cg-linq-logo_%282%29.png?1709368877"
    },
    {
      chainId: 1,
      address: "0xa1abecc1b3958da78259fa2793653fc48e976420",
      name: "Dogggo",
      symbol: "DOGGGO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34634/thumb/DT-Thumbnail-200x200.png?1705549833"
    },
    {
      chainId: 1,
      address: "0xea7b7dc089c9a4a916b5a7a37617f59fd54e37e4",
      name: "HyperCycle",
      symbol: "HYPC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/29917/thumb/HyperCycle-Logo-2022_icon_copy_%281%29.png?1696528845"
    },
    {
      chainId: 1,
      address: "0xf03d5fc6e08de6ad886fca34abf9a59ef633b78a",
      name: "Capybara Token",
      symbol: "CAPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30223/thumb/capylogo.png?1696529133"
    },
    {
      chainId: 1,
      address: "0xeee0fe52299f2de8e2ed5111cd521ab67dcf0faf",
      name: "The QWAN",
      symbol: "QWAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30613/thumb/qwan.jpg?1696529482"
    },
    {
      chainId: 1,
      address: "0xa8388b8334beb4840d65ed80f858b080dffd7e2b",
      name: "Son Of Pepe",
      symbol: "SOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30895/thumb/IMG_20230701_205503_304_%283%29.png?1696529741"
    },
    {
      chainId: 1,
      address: "0x675ababd3a210566a5e213547523b740be80041a",
      name: "Entropy",
      symbol: "ENT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30102/thumb/Entropy_bi_symbol_200x200.png?1696529025"
    },
    {
      chainId: 1,
      address: "0x02d7a93829b365b7ad4c582dace1493aac50a290",
      name: "Scat",
      symbol: "CAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30429/thumb/output-onlinepngtools.png?1696529317"
    },
    {
      chainId: 1,
      address: "0x223028738503838e89fc5fd5b1a42f1d024d9600",
      name: "DegenInsure",
      symbol: "DGNS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32185/thumb/Frame_12_%282%29.png?1696756306"
    },
    {
      chainId: 1,
      address: "0xb2dbf14d0b47ed3ba02bdb7c954e05a72deb7544",
      name: "MobiFi",
      symbol: "MOFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14697/thumb/MOFI_Coin_Green_200x200.png?1696514369"
    },
    {
      chainId: 1,
      address: "0x8e235f491ae66b82296d58332adc2a021c449c10",
      name: "Tipja",
      symbol: "TIPJA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30182/thumb/logo.jpg?1696529101"
    },
    {
      chainId: 1,
      address: "0x12970e6868f88f6557b76120662c1b3e50a646bf",
      name: "Milady Meme Coin",
      symbol: "LADYS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30194/thumb/logo.png?1696529109"
    },
    {
      chainId: 1,
      address: "0xe45dfc26215312edc131e34ea9299fbca53275ca",
      name: "Relation Native Token",
      symbol: "REL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30656/thumb/2.png?1696529526"
    },
    {
      chainId: 1,
      address: "0x378e1be15be6d6d1f23cfe7090b6a77660dbf14d",
      name: "FOXE",
      symbol: "FOXE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30227/thumb/foxe.jpeg?1696529137"
    },
    {
      chainId: 1,
      address: "0xc961da88bb5e8ee2ba7dfd4c62a875ef80f7202f",
      name: "Haram",
      symbol: "HARAM",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30374/thumb/200x200trans.png?1696529268"
    },
    {
      chainId: 1,
      address: "0xef8e456967122db4c3c160314bde8d2602ad6199",
      name: "Wagmi Coin",
      symbol: "WAGMI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30477/thumb/W.png?1696529363"
    },
    {
      chainId: 1,
      address: "0xb435a47ecea7f5366b2520e45b9bed7e01d2ffae",
      name: "The Nemesis",
      symbol: "NEMS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30590/thumb/nems.png?1696529458"
    },
    {
      chainId: 1,
      address: "0x0ebe30595a44e5288c24161ddfc1e9fa08e33a0c",
      name: "Nyan Meme Coin",
      symbol: "NYAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30197/thumb/n0z-571z_400x400.png?1696529112"
    },
    {
      chainId: 1,
      address: "0x9ff58067bd8d239000010c154c6983a325df138e",
      name: "Propchain",
      symbol: "PROPC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30451/thumb/prop_%281%29.png?1702322253"
    },
    {
      chainId: 1,
      address: "0xe08ef9206a8a7c9337cc6611b4f5226fdafc4772",
      name: "MESSI COIN",
      symbol: "MESSI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30762/thumb/x4aUydEr_400x400.jpg?1696529631"
    },
    {
      chainId: 1,
      address: "0x4fe8d4775b7cb2546b9ee86182081cdf8f77b053",
      name: "KAIJUNO8",
      symbol: "KAIJU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35688/thumb/mmexport1709168349348.jpg?1709533292"
    },
    {
      chainId: 1,
      address: "0x730bcbe5cdc1a3061dfe700774b7b8dd1d4173db",
      name: "DaVinci",
      symbol: "WTF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35734/thumb/IMG_8820.png?1709693722"
    },
    {
      chainId: 1,
      address: "0xc7f950271d118a5bdf250dffc39128dcced8472c",
      name: "Chainback",
      symbol: "ARCHIVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30580/thumb/Chainback-glyph-logo-200.png?1696529444"
    },
    {
      chainId: 1,
      address: "0x9c0bd34bebc33a0e898554cfc91e8a84c728bf9f",
      name: "Pisscoin",
      symbol: "PISS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30459/thumb/A7661040-68D2-4753-B20E-B7416A7F90C2.png?1696529346"
    },
    {
      chainId: 1,
      address: "0xc3b36424c70e0e6aee3b91d1894c2e336447dbd3",
      name: "TokenWatch",
      symbol: "TOKENWATCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34672/thumb/TW_token.png?1705657486"
    },
    {
      chainId: 1,
      address: "0x83f20f44975d03b1b09e64809b757c47f942beea",
      name: "Savings Dai",
      symbol: "SDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32254/thumb/sdai.png?1697015278"
    },
    {
      chainId: 1,
      address: "0xe0f63a424a4439cbe457d80e4f4b51ad25b2c56c",
      name: "SPX6900",
      symbol: "SPX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31401/thumb/sticker_%281%29.jpg?1702371083"
    },
    {
      chainId: 1,
      address: "0x2f123cf3f37ce3328cc9b5b8415f9ec5109b45e7",
      name: "Backed GOVIES 0 6 months EURO",
      symbol: "BC3M",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31870/thumb/b-C3-M-200x200.png?1696530682"
    },
    {
      chainId: 1,
      address: "0x1e2c4fb7ede391d116e6b41cd0608260e8801d59",
      name: "Backed CSPX Core S P 500",
      symbol: "BCSPX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31891/thumb/b-CSPX-200x200.png?1696530702"
    },
    {
      chainId: 1,
      address: "0xfe60fba03048effb4acf3f0088ec2f53d779d3bb",
      name: "3d3d",
      symbol: "3D3D",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30232/thumb/200x200_2.PNG?1696529142"
    },
    {
      chainId: 1,
      address: "0xbbc7f7a6aadac103769c66cbc69ab720f7f9eae3",
      name: "INX Token",
      symbol: "INX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29241/thumb/Tc8Z6xAG_400x400.jpg?1696528197"
    },
    {
      chainId: 1,
      address: "0x226bb599a12c826476e3a771454697ea52e9e220",
      name: "Propy",
      symbol: "PRO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/869/thumb/propy.png?1696502002"
    },
    {
      chainId: 1,
      address: "0xf831938caf837cd505de196bbb408d81a06376ab",
      name: "Jeff",
      symbol: "JEFF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30222/thumb/photo_2023-05-06_23.53.02.jpeg?1696529132"
    },
    {
      chainId: 1,
      address: "0x370a366f402e2e41cdbbe54ecec12aae0cce1955",
      name: "Toad Killer",
      symbol: "TOAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30234/thumb/khLXf12.png?1700669365"
    },
    {
      chainId: 1,
      address: "0x1f17d72cbe65df609315df5c4f5f729efbd00ade",
      name: "GYOSHI",
      symbol: "GYOSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30002/thumb/99245ad73184347ee7c93bfc4f8ca2c2.png?1696528927"
    },
    {
      chainId: 1,
      address: "0x5b649c07e7ba0a1c529deaabed0b47699919b4a2",
      name: "Suzuverse",
      symbol: "SGT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/30549/thumb/Suzuverse.png?1696529421"
    },
    {
      chainId: 1,
      address: "0x335f4e66b9b61cee5ceade4e727fcec20156b2f0",
      name: "ElmoERC",
      symbol: "ELMO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30261/thumb/elmologo-21.png?1696930389"
    },
    {
      chainId: 1,
      address: "0x3f14920c99beb920afa163031c4e47a3e03b3e4a",
      name: " send",
      symbol: "SEND",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/30847/thumb/logo_send_new_africa.png?1709638658"
    },
    {
      chainId: 1,
      address: "0xc666081073e8dff8d3d1c2292a29ae1a2153ec09",
      name: "Digitex",
      symbol: "DGTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2188/thumb/DGTX.png?1696503145"
    },
    {
      chainId: 1,
      address: "0x451fd37983d494bce294295f78a426832376b7df",
      name: "Xeno",
      symbol: "XENO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34702/thumb/tokenlogo200x200.jpg?1705861546"
    },
    {
      chainId: 1,
      address: "0x9dcd367e2afa8d6e5d6cf0306094e3eb7bbaaf4d",
      name: "Crypto Bros",
      symbol: "BROS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30338/thumb/Crypto_Bros_%284%29.png?1696529239"
    },
    {
      chainId: 1,
      address: "0x58083b54013631bacc0bbb6d4efa543fee1d9ce0",
      name: "Force",
      symbol: "FRC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30917/thumb/force_token_1000.png?1696529762"
    },
    {
      chainId: 1,
      address: "0xf7168c8abb0ff80116413a8d95396bbdc318a3ff",
      name: "KEK",
      symbol: "KEKE",
      decimals: 7,
      logoURI: "https://assets.coingecko.com/coins/images/30172/thumb/KEKE.png?1696529092"
    },
    {
      chainId: 1,
      address: "0x4743a7a193cdf202035e9bc6830a07f1607630c4",
      name: "Family Guy",
      symbol: "GUY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30435/thumb/photo_2023-05-16_18-24-10_%281%29.png?1696529323"
    },
    {
      chainId: 1,
      address: "0xf0edac27aa3e85e2d176f689b0025f90c154393a",
      name: "I LOVE SNOOPY",
      symbol: "LOVESNOOPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30340/thumb/dAlRqD6r_400x400.jpg?1696529240"
    },
    {
      chainId: 1,
      address: "0x04c618cdbc1d59142dfeb4b9864835a06983ec2d",
      name: "Joseon Mun",
      symbol: "JSM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30387/thumb/IMG_20230511_130419_023.jpg?1696529276"
    },
    {
      chainId: 1,
      address: "0x5dcd6272c3cbb250823f0b7e6c618bce11b21f90",
      name: "Pear Swap",
      symbol: "PEAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30409/thumb/9zYlZj3H_400x400.jpg?1696529298"
    },
    {
      chainId: 1,
      address: "0x856c4efb76c1d1ae02e20ceb03a2a6a08b0b8dc3",
      name: "Origin Ether",
      symbol: "OETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29733/thumb/OETH.png?1696528663"
    },
    {
      chainId: 1,
      address: "0xd807f7e2818db8eda0d28b5be74866338eaedb86",
      name: "Jim",
      symbol: "JIM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30235/thumb/_jim_Logo.png?1696529145"
    },
    {
      chainId: 1,
      address: "0x168e209d7b2f58f1f24b8ae7b7d35e662bbf11cc",
      name: "LayerAI",
      symbol: "LAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29223/thumb/Favicon_200x200px.png?1696528181"
    },
    {
      chainId: 1,
      address: "0x27f103f86070cc639fef262787a16887d22d8415",
      name: "FOFO Token",
      symbol: "FOFO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30438/thumb/01_%281%29_copy.png?1696529326"
    },
    {
      chainId: 1,
      address: "0x3db045814d0a29d831fe38055cb97a956ef7cafb",
      name: "BlockRemit",
      symbol: "REMIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30360/thumb/20230512_204249_copy_200x200.jpg?1696529259"
    },
    {
      chainId: 1,
      address: "0x382edfe4c6168858c81893fe00fcb7b68914d929",
      name: "SJ741 Emeralds",
      symbol: "EMERALD",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/35360/thumb/emeraldsCoingecko.png?1708363791"
    },
    {
      chainId: 1,
      address: "0xe1a3864dbf62fb94834b108ff6bf439ce70183ac",
      name: "vXDEFI",
      symbol: "VXDEFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30479/thumb/vXDEFI.jpg?1696529365"
    },
    {
      chainId: 1,
      address: "0x9ad37205d608b8b219e6a2573f922094cec5c200",
      name: "iZUMi Finance",
      symbol: "IZI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21791/thumb/izumi-logo-symbol.png?1696521144"
    },
    {
      chainId: 1,
      address: "0x2b9a49417f9c9c8dd18ef5bb37c20637441ad67a",
      name: "greg",
      symbol: "GREG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30415/thumb/photo_2023-05-16_14-37-01.jpg?1696529303"
    },
    {
      chainId: 1,
      address: "0x8881562783028f5c1bcb985d2283d5e170d88888",
      name: "Shuffle",
      symbol: "SHFL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35148/thumb/shuffle_token_200x200.png?1707552712"
    },
    {
      chainId: 1,
      address: "0xcedefe438860d2789da6419b3a19cece2a41038d",
      name: "Love Hate Inu",
      symbol: "LHINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30455/thumb/lhinu.png?1696529342"
    },
    {
      chainId: 1,
      address: "0x9b01637302b6adfc2c82678e2a8d680cff6337b7",
      name: "Fit",
      symbol: "FIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30918/thumb/FIT_Token_1000.png?1696529763"
    },
    {
      chainId: 1,
      address: "0x830a8512db4f6fca51968593e2667156c2c483a8",
      name: "WEN Token",
      symbol: "WEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30400/thumb/kxtrOzUd_400x400.jpg?1696529290"
    },
    {
      chainId: 1,
      address: "0x24249b5a869a445c9b0ce269a08d73c618df9d21",
      name: "HarryPotterTrumpHomerSimpson777Inu",
      symbol: "ETHEREUM",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31320/thumb/hp777_%281%29.jpg?1696530139"
    },
    {
      chainId: 1,
      address: "0x0d248ce39e26fb00f911fb1e7a45a00d8c94341c",
      name: "Butter",
      symbol: "BUTTER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30252/thumb/butterlogotrans.png?1696529161"
    },
    {
      chainId: 1,
      address: "0x77571a64342667f7818520ef004b2b91f47a266b",
      name: "SnailMoon",
      symbol: "SNM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30401/thumb/SnailMoonCoingecko.png?1696529291"
    },
    {
      chainId: 1,
      address: "0x7163436b8efffb469f6bb81cc908b1661d4795e6",
      name: "Esco Coin",
      symbol: "ESCO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30405/thumb/escocoin-06.png?1696529294"
    },
    {
      chainId: 1,
      address: "0x3d330b8d4eb25b0933e564d7284d462346d453ef",
      name: "GROQ",
      symbol: "GROQ",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33268/thumb/GROQ.png?1701357958"
    },
    {
      chainId: 1,
      address: "0xf190dbd849e372ff824e631a1fdf199f38358bcf",
      name: "Capybara Memecoin",
      symbol: "BARA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30399/thumb/Capy_logo.png?1696529289"
    },
    {
      chainId: 1,
      address: "0xa41d2f8ee4f47d3b860a149765a7df8c3287b7f0",
      name: "Syncus",
      symbol: "SYNC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33573/thumb/Syncus.png?1702450708"
    },
    {
      chainId: 1,
      address: "0xeb4f5c4bf62fac1be7e4bef9c7c055bf1c52241d",
      name: "Runic Chain",
      symbol: "RUNIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36044/thumb/logo.png?1710401096"
    },
    {
      chainId: 1,
      address: "0x52284158e02425290f6b627aeb5fff65edf058ad",
      name: "FlappyMoonbird",
      symbol: "FMB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30659/thumb/200_%282%29.jpg?1696529529"
    },
    {
      chainId: 1,
      address: "0xa2e3356610840701bdf5611a53974510ae27e2e1",
      name: "Wrapped Beacon ETH",
      symbol: "WBETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30061/thumb/wbeth-icon.png?1696528983"
    },
    {
      chainId: 1,
      address: "0xb4f8ae8d7d29ac74894cd40ecc24e50f6f146ca6",
      name: "FriendSpot",
      symbol: "SPOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31734/thumb/frenspot-logo_%281%29.png?1696530554"
    },
    {
      chainId: 1,
      address: "0xbddf903f43dc7d9801f3f0034ba306169074ef8e",
      name: "Apes Go Bananas",
      symbol: "AGB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30465/thumb/agb_logo.jpeg?1696529352"
    },
    {
      chainId: 1,
      address: "0x62d04c79c1f3a2d7230ffcd3ab01794e1d153239",
      name: "CryptoPirates",
      symbol: "OGMF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30442/thumb/cryptopirates.png?1696529329"
    },
    {
      chainId: 1,
      address: "0x5c99a6c14f8dc0c2c3655c64a2cef68ff9f771ba",
      name: "Larry the Llama",
      symbol: "LARRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32791/thumb/Larry_the_Llama_Logo_200x200.png?1699427698"
    },
    {
      chainId: 1,
      address: "0xf79c694605f29ddf3f0eb41319c38672ab6fa89f",
      name: "Mackerel",
      symbol: "MACKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33270/thumb/3vQdHnYS_400x400.jpg?1701326383"
    },
    {
      chainId: 1,
      address: "0xdd50c053c096cb04a3e3362e2b622529ec5f2e8a",
      name: "OpenEden TBILL",
      symbol: "TBILL",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/30576/thumb/OE_Logo_200x200_Transparent.png?1696529441"
    },
    {
      chainId: 1,
      address: "0x01eeffcd9a10266ed00946121df097eed173b43d",
      name: "XDoge",
      symbol: "XD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32734/thumb/5365F431-9922-4CC4-BE80-FDB7A86E3764.png?1699219089"
    },
    {
      chainId: 1,
      address: "0x7468d234a8db6f1085dbf4e403553bfed41df95c",
      name: "IO",
      symbol: "IO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32792/thumb/IMG_8756.jpeg?1699429009"
    },
    {
      chainId: 1,
      address: "0x9a0df129e798438a8ad995368bd82baa7eee8913",
      name: "BEEP Coin",
      symbol: "BEEP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30566/thumb/green.png?1696529437"
    },
    {
      chainId: 1,
      address: "0xcae3faa4b6cf660aef18474074949ba0948bc025",
      name: "Generational Wealth",
      symbol: "GEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30419/thumb/ethericon200x200.png?1696529307"
    },
    {
      chainId: 1,
      address: "0x52e7b23e1faba6d83376725e2ccad75efbd8736e",
      name: "BURN",
      symbol: "BURN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30506/thumb/burn.jpg?1696529392"
    },
    {
      chainId: 1,
      address: "0xe8438c23157de97bde8bedd2eeabc8e7e44de18a",
      name: "Lunatics  ETH ",
      symbol: "LUNAT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30526/thumb/whvem.png?1696529402"
    },
    {
      chainId: 1,
      address: "0x2b591e99afe9f32eaa6214f7b7629768c40eeb39",
      name: "HEX",
      symbol: "HEX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/10103/thumb/HEX-logo.png?1696510130"
    },
    {
      chainId: 1,
      address: "0x9352ec6d3e8b54a96b6903a79635c1e2d298b101",
      name: "Bad Santa",
      symbol: "BAD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33271/thumb/IMG_20231128_155805_210.png?1701326565"
    },
    {
      chainId: 1,
      address: "0x3007083eaa95497cd6b2b809fb97b6a30bdf53d3",
      name: "PSYOP",
      symbol: "PSYOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30485/thumb/logo_200.png?1696529371"
    },
    {
      chainId: 1,
      address: "0xd1c8fa30fded3e0031dc24c1646d74108b096cc2",
      name: "Luckyinu",
      symbol: "LUCKY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34998/thumb/Luckyinu_%281%29.png?1706955605"
    },
    {
      chainId: 1,
      address: "0x955d5c14c8d4944da1ea7836bd44d54a8ec35ba1",
      name: "Refund",
      symbol: "RFD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30501/thumb/Avatar_%282%29.png?1696529387"
    },
    {
      chainId: 1,
      address: "0x21e5c85a5b1f38bddde68307af77e38f747cd530",
      name: "Doggensnout Skeptic",
      symbol: "DOGS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35772/thumb/DOG_T200.png?1709838273"
    },
    {
      chainId: 1,
      address: "0xb17d69c91135516b0256c67e8bd32cd238b56161",
      name: "Gravitas",
      symbol: "GRAVITAS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32995/thumb/200photo_2023-11-12_14-07-05.jpg?1700110430"
    },
    {
      chainId: 1,
      address: "0xb5ce43fe2fcffffb2eece95ec413d08def28046f",
      name: "PepElon",
      symbol: "PELO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31371/thumb/7gd1S3fr_400x400.jpg?1696530188"
    },
    {
      chainId: 1,
      address: "0x514910771af9ca656af840dff83e8264ecf986ca",
      name: "Chainlink",
      symbol: "LINK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1696502009"
    },
    {
      chainId: 1,
      address: "0x63f7b1b538a78cb699e5399621b3d2e047c40de4",
      name: "Maxity",
      symbol: "MAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26933/thumb/MAX_token_200.png?1696525989"
    },
    {
      chainId: 1,
      address: "0x6b175474e89094c44da98b954eedeac495271d0f",
      name: "Dai",
      symbol: "DAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9956/thumb/Badge_Dai.png?1696509996"
    },
    {
      chainId: 1,
      address: "0x74a85f68cd947d05585f76118e51b2ed1484a838",
      name: "Diamault",
      symbol: "DVT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32200/thumb/DVT.jpg?1696745951"
    },
    {
      chainId: 1,
      address: "0x2048e0d048224381cac3ea06012ced4a6f122d32",
      name: "BANDS  OLD ",
      symbol: "BANDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35693/thumb/band.png?1714758222"
    },
    {
      chainId: 1,
      address: "0x013062189dc3dcc99e9cee714c513033b8d99e3c",
      name: "Bware",
      symbol: "INFRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30546/thumb/infra-token-square.png?1696529418"
    },
    {
      chainId: 1,
      address: "0xff8c479134a18918059493243943150776cf8cf2",
      name: "Renq Finance",
      symbol: "RENQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29603/thumb/Renq.png?1696528541"
    },
    {
      chainId: 1,
      address: "0xb2e0f591191ee5f6fb8a7f1777a733b6aa92bb55",
      name: "WojakPepe",
      symbol: "WOPE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37067/thumb/WOPE.jpeg?1713179688"
    },
    {
      chainId: 1,
      address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
      name: "Onyxcoin",
      symbol: "XCN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24210/thumb/onyxlogo.jpg?1696523397"
    },
    {
      chainId: 1,
      address: "0x2b896c7f060ae441b76bbe47cddca934ba60f37f",
      name: "BlackLatexFist",
      symbol: "BLF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31871/thumb/BLF_Fist_logo_200px.png?1696530683"
    },
    {
      chainId: 1,
      address: "0x7acc3f723419fa0c1f789618f798e75c5189c24f",
      name: "DADA",
      symbol: "DADA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34999/thumb/Dada.png?1707068797"
    },
    {
      chainId: 1,
      address: "0x2ad9addd0d97ec3cdba27f92bf6077893b76ab0b",
      name: "Planet Token",
      symbol: "PLANET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30767/thumb/Logo-Planet.png?1696529635"
    },
    {
      chainId: 1,
      address: "0xeb31ba344310bc4872c6188ff210d7341a301ea9",
      name: "GuessOnChain",
      symbol: "GUESS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32279/thumb/Guess_200px.png?1697180810"
    },
    {
      chainId: 1,
      address: "0xc03fbf20a586fa89c2a5f6f941458e1fbc40c661",
      name: "COMBO",
      symbol: "COMBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4932/thumb/COMBO.jpg?1696505472"
    },
    {
      chainId: 1,
      address: "0xe0c28a5a2da3920946e8bf821f61f7bea311048b",
      name: "Stakehouse kETH",
      symbol: "KETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33656/thumb/kETH.png?1702597766"
    },
    {
      chainId: 1,
      address: "0x38547d918b9645f2d94336b6b61aeb08053e142c",
      name: "USC",
      symbol: "USC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34124/thumb/USC-Logo.png?1708079628"
    },
    {
      chainId: 1,
      address: "0xecf3672a6d2147e2a77f07069fb48d8cf6f6fbf9",
      name: "Inception mETH",
      symbol: "INMETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34958/thumb/mETH.png?1706773620"
    },
    {
      chainId: 1,
      address: "0x9181f633e9b9f15a32d5e37094f4c93b333e0e92",
      name: "Inception oETH",
      symbol: "INOETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34957/thumb/origin-ether-oeth-logo_1.png?1706773605"
    },
    {
      chainId: 1,
      address: "0x8365332d4baf69bc24ca2401b90c3853ab9f818e",
      name: "Wolf of Wall Street",
      symbol: "WOLF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31461/thumb/Cmc_wolf_2.png?1696530274"
    },
    {
      chainId: 1,
      address: "0xba386a4ca26b85fd057ab1ef86e3dc7bdeb5ce70",
      name: "Jesus Coin",
      symbol: "JESUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30036/thumb/JESUS_COIN_LOGO.png?1696528959"
    },
    {
      chainId: 1,
      address: "0x64d93cf499054170f4c211f91f867f902afaece6",
      name: "Quant AI",
      symbol: "QAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36987/thumb/pepethedev_minimalistic_and_modern_logo_futuristic_fintech_purp.png?1714928548"
    },
    {
      chainId: 1,
      address: "0x33bc4e44054fdb21d5a7cea5c03613782d821e45",
      name: "Xudo",
      symbol: "XUDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30662/thumb/xudo.png?1696529532"
    },
    {
      chainId: 1,
      address: "0xf70ce9ee486106882d3dc43ddbd84e0fa71ac2a5",
      name: "Ducker",
      symbol: "DUCKER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30816/thumb/Ducker_Logo_200x200.png?1696529672"
    },
    {
      chainId: 1,
      address: "0x15e5d3deff5c3a13adca4f313ff44735881ebd6c",
      name: "Meta Art Connection",
      symbol: "MAC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32193/thumb/mac.png?1696745471"
    },
    {
      chainId: 1,
      address: "0xc4b7af50644c661e270fbb8da770049c9fc0bbe1",
      name: "Gelios",
      symbol: "GOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2324/thumb/Gelios_Coingecko.png?1711380304"
    },
    {
      chainId: 1,
      address: "0xb2d2e1309db33b38a19ee2a7cd9cb5de39d76663",
      name: "colR Coin",
      symbol: "COLR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26701/thumb/Untitled_%281%29.png?1696525774"
    },
    {
      chainId: 1,
      address: "0xacb47686b92fdde6d233ec6445c1f8d4d0d59c38",
      name: "Swipe Token",
      symbol: "SWIPE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/30601/thumb/SWIPE_%28200_%C3%97_200_px%29.png?1696529471"
    },
    {
      chainId: 1,
      address: "0x3bf954e809620bf2f1fcb667f1c7d2d2e94350d1",
      name: "Vision City",
      symbol: "VIZ",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30614/thumb/logo.png?1696529483"
    },
    {
      chainId: 1,
      address: "0xda63feff6e6d75cd7a862cd56c625045dcf26e88",
      name: "ChainMiner",
      symbol: "CMINER",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36901/thumb/1000151140.png?1712685143"
    },
    {
      chainId: 1,
      address: "0x7b95ec873268a6bfc6427e7a28e396db9d0ebc65",
      name: "Aave v3 CRV",
      symbol: "ACRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32901/thumb/CRV.png?1699802172"
    },
    {
      chainId: 1,
      address: "0x9c0241e7538b35454735ae453423daf470a25b3a",
      name: "UnityBot",
      symbol: "UNITYBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32864/thumb/UnityBot.png?1699670276"
    },
    {
      chainId: 1,
      address: "0x78a0a62fba6fb21a83fe8a3433d44c73a4017a6f",
      name: "Open Exchange Token",
      symbol: "OXOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30604/thumb/Logo2.png?1696529473"
    },
    {
      chainId: 1,
      address: "0x807534b396919783b7e30383fe57d857bc084338",
      name: "Test",
      symbol: "TEST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31188/thumb/IMG_6480.png?1696530015"
    },
    {
      chainId: 1,
      address: "0xc7b4c17861357b8abb91f25581e7263e08dcb59c",
      name: "Aave v3 SNX",
      symbol: "ASNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32902/thumb/SNX.png?1699802376"
    },
    {
      chainId: 1,
      address: "0xee9e7bb7e55bbc86414047b61d65c9c0d91ffbd0",
      name: "Fracton Protocol",
      symbol: "FT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26809/thumb/CtH9UlRl_400x400.jpeg?1696525869"
    },
    {
      chainId: 1,
      address: "0x2516e7b3f76294e03c42aa4c5b5b4dce9c436fb8",
      name: "Aave v3 BAL",
      symbol: "ABAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32903/thumb/BAL_%281%29.png?1699802595"
    },
    {
      chainId: 1,
      address: "0x4db57d585fa82ca32d25086ddc069d899f08d455",
      name: "Enoch",
      symbol: "ENOCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30810/thumb/20230619_001351.png?1696529667"
    },
    {
      chainId: 1,
      address: "0x9609b540e5dedddb147abbf9812ade06b1e61b2c",
      name: "Steamboat Willie",
      symbol: "MICKEY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35349/thumb/photo_2023-12-30_01.07.19.jpeg?1708340723"
    },
    {
      chainId: 1,
      address: "0xd4e245848d6e1220dbe62e155d89fa327e43cb06",
      name: "Aave v3 FRAX",
      symbol: "AFRAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32904/thumb/FRAX.png?1699802848"
    },
    {
      chainId: 1,
      address: "0x7fa768e035f956c41d6aeaa3bd857e7e5141cad5",
      name: "Inception stETH",
      symbol: "INSTETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34954/thumb/Group_14.png?1706773546"
    },
    {
      chainId: 1,
      address: "0x1ba9843bd4327c6c77011406de5fa8749f7e3479",
      name: "Aave v3 STG",
      symbol: "ASTG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32905/thumb/ST.png?1699803503"
    },
    {
      chainId: 1,
      address: "0x71aef7b30728b9bb371578f36c5a1f1502a5723e",
      name: "Aave v3 1INCH",
      symbol: "A1INCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32906/thumb/1INCH.png?1699804523"
    },
    {
      chainId: 1,
      address: "0xfd07fd5ebea6f24888a397997e262179bf494336",
      name: "Inception osETH",
      symbol: "INOSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34955/thumb/osETH.png?1706773564"
    },
    {
      chainId: 1,
      address: "0xd8e163967fed76806df0097b704ba721b9b37656",
      name: "Cope Coin",
      symbol: "COPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29912/thumb/QxzD6QZa_400x400_1_200x200.jpg?1696528840"
    },
    {
      chainId: 1,
      address: "0x4ad434b8cdc3aa5ac97932d6bd18b5d313ab0f6f",
      name: "EverMoon ERC",
      symbol: "EVERMOON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30720/thumb/evermoon.png?1696529591"
    },
    {
      chainId: 1,
      address: "0xb5b1b659da79a2507c27aad509f15b4874edc0cc",
      name: "Dust Protocol",
      symbol: "DUST",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/24289/thumb/6388d49d-1f00-448d-92bc-f2db1441bbce.?1696523472"
    },
    {
      chainId: 1,
      address: "0x0a44a7ccea34a7563ba1d45a5f757d0b02281124",
      name: "BlockBlend",
      symbol: "BBL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30680/thumb/mdWl1HlW_400x400.jpg?1696529549"
    },
    {
      chainId: 1,
      address: "0x85225ed797fd4128ac45a992c46ea4681a7a15da",
      name: "Hyperbolic Protocol",
      symbol: "HYPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30743/thumb/HP_200x200.png?1696529613"
    },
    {
      chainId: 1,
      address: "0x369733153e6e08d38f2bc72ae2432e855cfbe221",
      name: "XALPHA AI",
      symbol: "XALPHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34503/thumb/XALPHA.png?1705367018"
    },
    {
      chainId: 1,
      address: "0xd8684adc4664bc2a0c78ddc8657dc005e804af15",
      name: "Copycat DAO",
      symbol: "CCD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30728/thumb/twitter-logo.jpeg?1696529599"
    },
    {
      chainId: 1,
      address: "0x1294f4183763743c7c9519bec51773fb3acd78fd",
      name: "Fideum",
      symbol: "FI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33758/thumb/Fideum-token.png?1702955199"
    },
    {
      chainId: 1,
      address: "0x2c022e58c5e3ee213f06f975fd8a0d3a6fe9ca1c",
      name: "FINU",
      symbol: "FINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29309/thumb/FINU_200x200.png?1696528260"
    },
    {
      chainId: 1,
      address: "0x259ce0cb3581995d40cbb03fd4badeaaba1edaff",
      name: "SphereSXS",
      symbol: "SXS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27924/thumb/IMG_0354.jpeg?1703176663"
    },
    {
      chainId: 1,
      address: "0x2b46578b7f06f2b373ad0e0c9b28f800dcc80bf3",
      name: "Echo Bot",
      symbol: "ECHO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31266/thumb/hd1qyGUA_200x200.jpg?1696530090"
    },
    {
      chainId: 1,
      address: "0xda8263d8ce3f726233f8b5585bcb86a3120a58b6",
      name: "DogeClub",
      symbol: "DOGC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30733/thumb/200*200.png?1696529603"
    },
    {
      chainId: 1,
      address: "0x208bcf9cd1d694d1d3c630362e517940e3724d80",
      name: "ORACLE",
      symbol: "ORACLE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32234/thumb/qlasify_%281%29.jpg?1696936966"
    },
    {
      chainId: 1,
      address: "0x445bd590a01fe6709d4f13a8f579c1e4846921db",
      name: "DUMMY",
      symbol: "DUMMY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30650/thumb/a3miYrC7_400x400-removebg-preview%281%29.png?1696529520"
    },
    {
      chainId: 1,
      address: "0x3f17f64f682019599ba51638f74e4b6c127fe725",
      name: "ReviveEth",
      symbol: "REVIVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30770/thumb/IMG_1662.png?1696529638"
    },
    {
      chainId: 1,
      address: "0xf56842af3b56fd72d17cb103f92d027bba912e89",
      name: "Bamboo DeFi",
      symbol: "BAMBOO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13856/thumb/LOGO_BAMBOO_PNG.png?1696513602"
    },
    {
      chainId: 1,
      address: "0x64aa3364f17a4d01c6f1751fd97c2bd3d7e7f1d5",
      name: "Olympus",
      symbol: "OHM",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/14483/thumb/token_OHM_%281%29.png?1696514169"
    },
    {
      chainId: 1,
      address: "0x68a47fe1cf42eba4a030a10cd4d6a1031ca3ca0a",
      name: "Tectum",
      symbol: "TET",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29575/thumb/Icon_TET.png?1696528514"
    },
    {
      chainId: 1,
      address: "0xeaa63125dd63f10874f99cdbbb18410e7fc79dd3",
      name: "Hemule",
      symbol: "HEMULE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33798/thumb/photo_2023-12-18_04-47-31.jpg?1702990624"
    },
    {
      chainId: 1,
      address: "0xf4d861575ecc9493420a3f5a14f85b13f0b50eb3",
      name: "Fractal",
      symbol: "FCL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14096/thumb/FractalID_SM_Profile_Image.jpg?1701799215"
    },
    {
      chainId: 1,
      address: "0xe9b7b5d5e8d2bcc78884f9f9099bfa42a9e5c1a5",
      name: "Zenland",
      symbol: "ZENF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29477/thumb/tokenicon200px.png?1696528421"
    },
    {
      chainId: 1,
      address: "0xf941d3aabf2ee0f5589e68ba6047b8329592b366",
      name: "Good Dog",
      symbol: "HEEL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/27138/thumb/HEEL_New_Logo.png?1696526189"
    },
    {
      chainId: 1,
      address: "0x176bc22e1855cd5cf5a840081c6c5b92b55e2210",
      name: "Gambex",
      symbol: "GBE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32745/thumb/gbe_cg.png?1699262150"
    },
    {
      chainId: 1,
      address: "0xcf9560b9e952b195d408be966e4f6cf4ab8206e5",
      name: "Doctor Evil",
      symbol: "EVIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31240/thumb/EvilLogo200x200.png?1696530066"
    },
    {
      chainId: 1,
      address: "0x017e9db34fc69af0dc7c7b4b33511226971cddc7",
      name: "On Chain Dynamics",
      symbol: "OCD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31639/thumb/Screenshot_2023-09-01_010740.png?1696530455"
    },
    {
      chainId: 1,
      address: "0x545bd6c032efdde65a377a6719def2796c8e0f2e",
      name: "Aave v3 ENS",
      symbol: "AENS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32907/thumb/ens.png?1699816992"
    },
    {
      chainId: 1,
      address: "0x5b502e3796385e1e9755d7043b9c945c3accec9c",
      name: "Aave v3 KNC",
      symbol: "AKNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32908/thumb/kyber.png?1699817281"
    },
    {
      chainId: 1,
      address: "0xe8e531aa894969759d0d4b207a972a3a97d287f0",
      name: "Watcher AI",
      symbol: "WAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36843/thumb/photo_6073264381849879042_c_%281%29.jpg?1712582416"
    },
    {
      chainId: 1,
      address: "0xad038eb671c44b853887a7e32528fab35dc5d710",
      name: "DOLA Borrowing Right",
      symbol: "DBR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28530/thumb/DBR.png?1696527523"
    },
    {
      chainId: 1,
      address: "0x0e9cc0f7e550bd43bd2af2214563c47699f96479",
      name: "UnleashClub",
      symbol: "UNLEASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30804/thumb/UnleashClub.png?1696529662"
    },
    {
      chainId: 1,
      address: "0xab97bf5fb097e503bba2c86b7c56c0059ac0dc06",
      name: "Chanalog",
      symbol: "CHAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32997/thumb/chanalog_token_logo_200.png?1700111084"
    },
    {
      chainId: 1,
      address: "0xbba39fd2935d5769116ce38d46a71bde9cf03099",
      name: "Choise com",
      symbol: "CHO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25935/thumb/cho_%282%29.png?1696525014"
    },
    {
      chainId: 1,
      address: "0x7dedbce5a2e31e4c75f87fea60bf796c17718715",
      name: "Penpie",
      symbol: "PNP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30760/thumb/PNP_Token.png?1696529629"
    },
    {
      chainId: 1,
      address: "0x5eca7b975e34567d9460fa613013a7a6993ad185",
      name: "Blacksmith Token",
      symbol: "BS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30806/thumb/roGLhC57_400x400.jpg?1696529664"
    },
    {
      chainId: 1,
      address: "0x289ff00235d2b98b0145ff5d4435d3e92f9540a6",
      name: "Book of Ethereum",
      symbol: "BOOE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37384/thumb/RGh5luer_400x400.jpg?1714230970"
    },
    {
      chainId: 1,
      address: "0xb76cf92076adbf1d9c39294fa8e7a67579fde357",
      name: "Aave v3 RPL",
      symbol: "ARPL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32909/thumb/RPL.png?1699817497"
    },
    {
      chainId: 1,
      address: "0xc19b6a4ac7c7cc24459f08984bbd09664af17bd1",
      name: "SENSO",
      symbol: "SENSO",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/11064/thumb/senso.png?1696511006"
    },
    {
      chainId: 1,
      address: "0x7448c7456a97769f6cd04f1e83a4a23ccdc46abd",
      name: "Maverick Protocol",
      symbol: "MAV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30850/thumb/MAV_Logo.png?1696529701"
    },
    {
      chainId: 1,
      address: "0x6230f552a1c825d02e1140ccc0d3f5eeec81ca84",
      name: "FusionBot",
      symbol: "FUSION",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31125/thumb/logo.png?1696529955"
    },
    {
      chainId: 1,
      address: "0x38cf11283de05cf1823b7804bc75068bd6296957",
      name: "MoonBot",
      symbol: "MBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31198/thumb/IMAGE_2023-07-27_20_46_47.jpg?1696530025"
    },
    {
      chainId: 1,
      address: "0x819c1a1568934ee59d9f3c8b9640908556c44140",
      name: "Hobbes  OLD ",
      symbol: "HOBBES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29541/thumb/Logo200x200.png?1696528483"
    },
    {
      chainId: 1,
      address: "0x41d321e0365a42058a465dc5bf98242a92c2e9f3",
      name: "XToolsAI",
      symbol: "XTAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36844/thumb/IMAGE_2024-03-27_02_04_19.jpg?1712582480"
    },
    {
      chainId: 1,
      address: "0xea3983fc6d0fbbc41fb6f6091f68f3e08894dc06",
      name: "Unido",
      symbol: "UDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14176/thumb/unido.jpg?1696513894"
    },
    {
      chainId: 1,
      address: "0xbb4f3ad7a2cf75d8effc4f6d7bd21d95f06165ca",
      name: "Sheesh",
      symbol: "SHS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30858/thumb/1111.png?1696529705"
    },
    {
      chainId: 1,
      address: "0xf8c76dbea329ec4fa987afc514f805b21b249d79",
      name: "L",
      symbol: "L",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30846/thumb/lltokenimagelogo.png?1696529696"
    },
    {
      chainId: 1,
      address: "0x198065e69a86cb8a9154b333aad8efe7a3c256f8",
      name: "Koyo",
      symbol: "KOY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29484/thumb/koyo200x200.png?1696528428"
    },
    {
      chainId: 1,
      address: "0x63e28547f0997e8ab265b24b7e5df302f3498ff3",
      name: "FP  WorldOfWomen",
      symbol: "UWOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34111/thumb/WOW.png?1703996347"
    },
    {
      chainId: 1,
      address: "0xd567b5f02b9073ad3a982a099a23bf019ff11d1c",
      name: "Gamestarter",
      symbol: "GAME",
      decimals: 5,
      logoURI: "https://assets.coingecko.com/coins/images/17604/thumb/gpMi14-r_400x400.jpg?1696517136"
    },
    {
      chainId: 1,
      address: "0xbc8e35221904f61b4200ca44a08e4dac387ac83a",
      name: "Fair BERC20",
      symbol: "BERC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30860/thumb/BERClogo3.png_alt_media_token_3c04fa07-9756-4037-8950-e30295030131.png?1696529707"
    },
    {
      chainId: 1,
      address: "0x113c65707c530502fef959308197353f6df97867",
      name: "The Joker Coin",
      symbol: "JOKER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36845/thumb/1000020014.png?1712582992"
    },
    {
      chainId: 1,
      address: "0x5510d26c504b21ef22ca85b7125390bc23ca50e7",
      name: "Homer",
      symbol: "SIMPSON20",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30882/thumb/1111.png?1696529729"
    },
    {
      chainId: 1,
      address: "0x6aa3ecec75ceb388d2e929814ead4fc4cd0648fc",
      name: "Reversal",
      symbol: "RVSL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35453/thumb/Reversal_Logo.png?1708665533"
    },
    {
      chainId: 1,
      address: "0x32eca61dc25d0742f238ce523e66b68867625dad",
      name: "0xFair",
      symbol: "FAIR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35725/thumb/fair-200.png?1709634952"
    },
    {
      chainId: 1,
      address: "0x2a5fa016ffb20c70e2ef36058c08547f344677aa",
      name: "Vitalik Smart Gas",
      symbol: "VSG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35275/thumb/JW9w9bvc_400x400.jpg?1708053854"
    },
    {
      chainId: 1,
      address: "0x089453742936dd35134383aee9d78bee63a69b01",
      name: "Gold",
      symbol: "GOLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31894/thumb/GOLD.png?1696530705"
    },
    {
      chainId: 1,
      address: "0xa203eb78fee91c8459c6d4ef3a899d8724ee5b35",
      name: "Liquid Mercury",
      symbol: "MERC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29297/thumb/cda56b6a-146c-4348-b4ff-5b87980c0f83.jpg?1696528249"
    },
    {
      chainId: 1,
      address: "0x0763fdccf1ae541a5961815c0872a8c5bc6de4d7",
      name: "SUKU",
      symbol: "SUKU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11969/thumb/suku-200.png?1696511828"
    },
    {
      chainId: 1,
      address: "0x4ebe70cb942d5af0a18b9126762637e7098ff5fd",
      name: "G Revolution",
      symbol: "G",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30869/thumb/G_logo.png?1696529716"
    },
    {
      chainId: 1,
      address: "0x32b86b99441480a7e5bd3a26c124ec2373e3f015",
      name: "Bad Idea AI",
      symbol: "BAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30871/thumb/Bad_idea.jpeg?1696529718"
    },
    {
      chainId: 1,
      address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
      name: "Sushi",
      symbol: "SUSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1696512101"
    },
    {
      chainId: 1,
      address: "0xf2ec4a773ef90c58d98ea734c0ebdb538519b988",
      name: "Doge 2 0",
      symbol: "DOGE20",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30902/thumb/2DOGE_200.jpg?1696529747"
    },
    {
      chainId: 1,
      address: "0x5a035e3f1551a15230d0cde3357fb1bf89369261",
      name: "Wooonen",
      symbol: "WOOO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30909/thumb/SGpzsmu.jpg?1696529754"
    },
    {
      chainId: 1,
      address: "0xa62894d5196bc44e4c3978400ad07e7b30352372",
      name: "X",
      symbol: "X",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31144/thumb/X.png?1696529972"
    },
    {
      chainId: 1,
      address: "0x2f573070e6090b3264fe707e2c9f201716f123c7",
      name: "Mumu",
      symbol: "MUMU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29921/thumb/mumuGreen.jpg?1712079227"
    },
    {
      chainId: 1,
      address: "0xf482d79ae6e8725c199213fc909d6bc30df62815",
      name: "Recycle Impact World Association",
      symbol: "RIWA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32158/thumb/RIWA.jpg?1696601500"
    },
    {
      chainId: 1,
      address: "0x8e1308f4808788767a864eee9a4927e38c790352",
      name: "Physics",
      symbol: "PHYSICS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32752/thumb/Physics_Logo_200x200_PNG.png?1699265054"
    },
    {
      chainId: 1,
      address: "0xed35af169af46a02ee13b9d79eb57d6d68c1749e",
      name: "ECOMI",
      symbol: "OMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4428/thumb/ECOMI.png?1696505023"
    },
    {
      chainId: 1,
      address: "0x48c87cdacb6bb6bf6e5cd85d8ee5c847084c7410",
      name: "Hamsters",
      symbol: "HAMS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31055/thumb/hams_logo_s.png?1696529890"
    },
    {
      chainId: 1,
      address: "0x9b44793a0177c84dd01ad81137db696531902871",
      name: "PVP",
      symbol: "PVP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31462/thumb/PVPLOGO.JPEG?1696530275"
    },
    {
      chainId: 1,
      address: "0x7ba5273d53d8a964b0a338e25def0c082f5c29d3",
      name: "WEN",
      symbol: "WEN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31835/thumb/Wen_small.png?1696530649"
    },
    {
      chainId: 1,
      address: "0xf257a2783f6633a149b5966e32432b5bb3462c96",
      name: "RagingElonMarsCoin",
      symbol: "DOGECOIN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31463/thumb/JgNkdCWn_400x400.jpg?1696530276"
    },
    {
      chainId: 1,
      address: "0x3442fbf264b6d723e01775a710850dcef6e6847c",
      name: "VINU Network",
      symbol: "VNN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32196/thumb/Vinu_Network.jpg?1696745619"
    },
    {
      chainId: 1,
      address: "0x0981d9774a59a703db85f5eaa23672283ea31106",
      name: "Pepe Inu",
      symbol: "PEPINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30941/thumb/Pepe_Inu.png?1696529780"
    },
    {
      chainId: 1,
      address: "0xffffffff2ba8f66d4e51811c5190992176930278",
      name: "Furucombo",
      symbol: "COMBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13629/thumb/COMBO_token_ol.png?1696513377"
    },
    {
      chainId: 1,
      address: "0x70be04312f5f66d03708f0a1d6353b3e0f80ddbb",
      name: "BetBot",
      symbol: "BBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31076/thumb/BetBot.png?1696529910"
    },
    {
      chainId: 1,
      address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
      name: "Injective",
      symbol: "INJ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12882/thumb/Secondary_Symbol.png?1696512670"
    },
    {
      chainId: 1,
      address: "0x45f93404ae1e4f0411a7f42bc6a5dc395792738d",
      name: "DGEN",
      symbol: "DGEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31294/thumb/dgen-new-200-200.png?1696530114"
    },
    {
      chainId: 1,
      address: "0xf4aaa9428a881a5c054d0ed041f5749a336c9ab5",
      name: "Mine AI",
      symbol: "MAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35773/thumb/Mine_AI.png?1709793186"
    },
    {
      chainId: 1,
      address: "0xd0b3a986fff305854a7238a8e099cce1ced01a3d",
      name: "Nova",
      symbol: "NOVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30943/thumb/IMG_20230709_210803_010.jpg?1696529782"
    },
    {
      chainId: 1,
      address: "0x14da230d6726c50f759bc1838717f8ce6373509c",
      name: "Kambria",
      symbol: "KAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4784/thumb/kambria.png?1696505340"
    },
    {
      chainId: 1,
      address: "0x111111111117dc0aa78b770fa6a738034120c302",
      name: "1inch",
      symbol: "1INCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1696513230"
    },
    {
      chainId: 1,
      address: "0x1a88df1cfe15af22b3c4c783d4e6f7f9e0c1885d",
      name: "Aave stkGHO",
      symbol: "STKGHO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34849/thumb/stkgho.png?1706260099"
    },
    {
      chainId: 1,
      address: "0xf31826269ac7f452b1274cc884812f426c18ddca",
      name: "MILK Coin",
      symbol: "MILK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35240/thumb/MILK_logo_Background_Removed.png?1707969987"
    },
    {
      chainId: 1,
      address: "0xb8112a01744fe88bc8672cd977378169e33eb9a5",
      name: "Ordinals Inscription Bot",
      symbol: "OIB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33456/thumb/logov2_%281%29_%281%29.png?1701923425"
    },
    {
      chainId: 1,
      address: "0x6c059413686565d5ad6cce6eed7742c42dbc44ca",
      name: "Laelaps",
      symbol: "LAELAPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30986/thumb/laelaps.png?1696529825"
    },
    {
      chainId: 1,
      address: "0xa0d3707c569ff8c87fa923d3823ec5d81c98be78",
      name: "Instadapp ETH v2",
      symbol: "IETHV2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29704/thumb/iETH.png?1696528636"
    },
    {
      chainId: 1,
      address: "0xde67d97b8770dc98c746a3fc0093c538666eb493",
      name: "Bitrock",
      symbol: "BROCK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30987/thumb/20230713_155626.png?1696529826"
    },
    {
      chainId: 1,
      address: "0xd2c869382c7ac9f87ff73548d029d67c0f9dee31",
      name: "Wagie Bot",
      symbol: "WAGIEBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30954/thumb/Wagies3%281%29.png?1696529793"
    },
    {
      chainId: 1,
      address: "0x66861d5f0fbfb7b2711712fef2172c560d08d0ab",
      name: "A Fund Baby",
      symbol: "FUND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30955/thumb/fund_baby.jpg?1696529794"
    },
    {
      chainId: 1,
      address: "0x3127294f1fd3c097ef31e54301069346b29d0209",
      name: "Blast Inu",
      symbol: "BLAST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33226/thumb/photo_2023-11-26_22-31-53-removebg-preview_%281%29.png?1701118741"
    },
    {
      chainId: 1,
      address: "0xa34ee6108fe427f91edce0d6520d9fec0e64f67b",
      name: "Pepe Le Pew Coin",
      symbol: "PLPC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30876/thumb/plpc.png?1696529724"
    },
    {
      chainId: 1,
      address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
      name: "Litentry",
      symbol: "LIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13825/thumb/logo_200x200.png?1696513568"
    },
    {
      chainId: 1,
      address: "0xcf0c122c6b73ff809c693db761e7baebe62b6a2e",
      name: "FLOKI",
      symbol: "FLOKI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/16746/thumb/PNG_image.png?1696516318"
    },
    {
      chainId: 1,
      address: "0x3c3a81e81dc49a522a592e7622a7e711c06bf354",
      name: "Mantle",
      symbol: "MNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30980/thumb/token-logo.png?1696529819"
    },
    {
      chainId: 1,
      address: "0xf6afc05fccea5a53f22a3e39ffee861e016bd9a0",
      name: "LandWolf",
      symbol: "WOLF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30982/thumb/landwolf.jpg?1696529821"
    },
    {
      chainId: 1,
      address: "0xf79c22713f3912be20a324034a91b11e2958a37e",
      name: "Plan Blui",
      symbol: "PBLUI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33227/thumb/TqkFW5A2_400x400.png?1701127038"
    },
    {
      chainId: 1,
      address: "0xc4e30d504fe3b18423d82a34e7ebe529a56f89c2",
      name: "Wojak 2 0 Coin",
      symbol: "WOJAK20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30979/thumb/Wojak_2.0_Logo.png?1696529818"
    },
    {
      chainId: 1,
      address: "0xd38bb40815d2b0c2d2c866e0c72c5728ffc76dd9",
      name: "Symbiosis",
      symbol: "SIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20805/thumb/SymbiosisFinance_logo-150x150.jpeg?1696520198"
    },
    {
      chainId: 1,
      address: "0x3feb4fea5132695542f8ede5076ac43296d17c6d",
      name: "Bitcoin 2 0",
      symbol: "BTC20",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/30984/thumb/btc2-200x200.png?1696529823"
    },
    {
      chainId: 1,
      address: "0x9ce84f6a69986a83d92c324df10bc8e64771030f",
      name: "CHEX Token",
      symbol: "CHEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10349/thumb/logo-dark-200.png?1701121978"
    },
    {
      chainId: 1,
      address: "0x56978e609f2cab06f77c5c8fd75166fcd8f09bd8",
      name: "GenieBot",
      symbol: "GENIE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30874/thumb/IMG_0334.jpeg?1696529722"
    },
    {
      chainId: 1,
      address: "0x18cc2ba8995c6307e355726244adb023cf00522f",
      name: "Monke",
      symbol: "MONKE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30192/thumb/MonkeCG.png?1698675883"
    },
    {
      chainId: 1,
      address: "0x99a01a4d6a4d621094983050d9a2f10b2912e53d",
      name: "VirtuSwap",
      symbol: "VRSW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30629/thumb/VirtuSwap_Logo_Red_200x200.png?1696529502"
    },
    {
      chainId: 1,
      address: "0x99fe3b1391503a1bc1788051347a1324bff41452",
      name: "SX Network  OLD ",
      symbol: "SX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13779/thumb/sx.png?1696513520"
    },
    {
      chainId: 1,
      address: "0x83031984b45553070a088273f341bff7fb4f2f46",
      name: "hiBAYC",
      symbol: "HIBAYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26623/thumb/hibayc.png?1696525696"
    },
    {
      chainId: 1,
      address: "0xce9de5365739b1bed5c8546867aee4209fbb8538",
      name: "Thug Life",
      symbol: "THUG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31036/thumb/IMG_20230717_172433_167.jpg?1696529871"
    },
    {
      chainId: 1,
      address: "0x265f542c1e78068f13d87c6fe0df54f3e9562a48",
      name: "Proof Of Pepe",
      symbol: "POP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31000/thumb/ebEOnrjk_400x400.jpg?1696529838"
    },
    {
      chainId: 1,
      address: "0x46c0f8259c4e4d50320124e52f3040cb9e4d04c7",
      name: "Chatter Shield",
      symbol: "SHIELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37166/thumb/Shield_Logo_200X200.png?1713989944"
    },
    {
      chainId: 1,
      address: "0xbe9f61555f50dd6167f2772e9cf7519790d96624",
      name: "SX Network",
      symbol: "SX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34934/thumb/sx-ntework.jpeg?1706699134"
    },
    {
      chainId: 1,
      address: "0x84412819ae69b10250d0d54d58f454018f1c8a42",
      name: "Scarab Tools",
      symbol: "DUNG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30706/thumb/scarab-cg.png?1696529577"
    },
    {
      chainId: 1,
      address: "0xf31698ddad0d11160fe85c500397a470cd3d492e",
      name: "Wexo",
      symbol: "WEXO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33801/thumb/wexo_token_200x200.png?1702991908"
    },
    {
      chainId: 1,
      address: "0x60eb57d085c59932d5faa6c6026268a4386927d0",
      name: "LOCG",
      symbol: "LOCG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15175/thumb/LOC_GAME.png?1696514830"
    },
    {
      chainId: 1,
      address: "0x4c0f743928ca8fa7fb24ad89669c8a7838f34917",
      name: "STACKER AI",
      symbol: "STACK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32865/thumb/IMG_1751.png?1699670330"
    },
    {
      chainId: 1,
      address: "0x14fee680690900ba0cccfc76ad70fd1b95d10e16",
      name: "PAAL AI",
      symbol: "PAAL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30815/thumb/PaalX.jpg?1696529671"
    },
    {
      chainId: 1,
      address: "0x267eb2a9a13dc304a9deff4277abe850d0852c5f",
      name: "Trace AI",
      symbol: "TAI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31058/thumb/200x200.png?1696529892"
    },
    {
      chainId: 1,
      address: "0x0a266778c113a8f0d3d7aeacd12b74a7da5037a0",
      name: "OLYMPUS",
      symbol: "OLAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33251/thumb/200cg.png?1701237177"
    },
    {
      chainId: 1,
      address: "0x128ad1ad707c3b36e6f2ac9739f9df7516fdb592",
      name: "alfa society",
      symbol: "ALFA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31017/thumb/token_logo_listing.png?1696529853"
    },
    {
      chainId: 1,
      address: "0x4104b135dbc9609fc1a9490e61369036497660c8",
      name: "Spectra",
      symbol: "APW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15597/thumb/spectra.png?1696515232"
    },
    {
      chainId: 1,
      address: "0x0c08638473cafbca3beb113616a1871f4bfad4f9",
      name: "ZooCoin",
      symbol: "ZOO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31230/thumb/ZOO.png?1696530056"
    },
    {
      chainId: 1,
      address: "0x95a4492f028aa1fd432ea71146b433e7b4446611",
      name: "APY Finance",
      symbol: "APY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13041/thumb/1*AvkD-OLocausbxqUzezZ0A.png?1696512828"
    },
    {
      chainId: 1,
      address: "0x163f8c2467924be0ae7b5347228cabf260318753",
      name: "Worldcoin",
      symbol: "WLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31069/thumb/worldcoin.jpeg?1696529903"
    },
    {
      chainId: 1,
      address: "0x553c7f9c780316fc1d34b8e14ac2465ab22a090b",
      name: "Aktionariat RealUnit Schweiz AG Tokeniz",
      symbol: "REALU",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33331/thumb/REALU.png?1701517686"
    },
    {
      chainId: 1,
      address: "0x5aef5bba19e6a1644805bd4f5c93c8557b87c62c",
      name: "DeepFakeAI",
      symbol: "FAKEAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30633/thumb/Safeimagekit-resized-img_%286%29.png?1696529506"
    },
    {
      chainId: 1,
      address: "0x97d4f49eeb0e2c96d5ebaa71ab8418e563ecd9fd",
      name: "Liquid Staking Derivative",
      symbol: "LSD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29188/thumb/LSD.jpg?1696528146"
    },
    {
      chainId: 1,
      address: "0xb459f7204a8ac84f9e7758d6d839ebd01670e35c",
      name: "Lotty",
      symbol: "LOTTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31018/thumb/download.png?1696529854"
    },
    {
      chainId: 1,
      address: "0x3d234a9d23f01c5556ad3dfa88f470f8982ab1b4",
      name: "Vatra INU",
      symbol: "VATR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37225/thumb/vatra-200px.png?1713776351"
    },
    {
      chainId: 1,
      address: "0xfc116ea24f002f600e363bdce4b91715fe5e0392",
      name: "L3T H1M C00K",
      symbol: "DOUGH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35850/thumb/Icon-200x200.png?1709895424"
    },
    {
      chainId: 1,
      address: "0xc5f0f7b66764f6ec8c8dff7ba683102295e16409",
      name: "First Digital USD",
      symbol: "FDUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31079/thumb/firstfigital.jpeg?1696529912"
    },
    {
      chainId: 1,
      address: "0x69e37422cb87d963367f73a119c8ce9a4d529b72",
      name: "Advantis",
      symbol: "ADVT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28549/thumb/Advantis_Logo_%28ROUND%29.png?1709178371"
    },
    {
      chainId: 1,
      address: "0xaa8330fb2b4d5d07abfe7a72262752a8505c6b37",
      name: "Polkacity",
      symbol: "POLC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14066/thumb/vykih1Nq_400x400.png?1696513790"
    },
    {
      chainId: 1,
      address: "0x0000206329b97db379d5e1bf586bbdb969c63274",
      name: "USDA",
      symbol: "USDA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34510/thumb/agUSD-coingecko.png?1705288392"
    },
    {
      chainId: 1,
      address: "0xd2bdaaf2b9cc6981fd273dcb7c04023bfbe0a7fe",
      name: "Aviator",
      symbol: "AVI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31024/thumb/avi-200x200png.png?1711119363"
    },
    {
      chainId: 1,
      address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
      name: "Uniswap",
      symbol: "UNI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12504/thumb/uni.jpg?1696512319"
    },
    {
      chainId: 1,
      address: "0x8c130499d33097d4d000d3332e1672f75b431543",
      name: "Hoppy Token",
      symbol: "HOPPY",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31027/thumb/IMG_1349.jpeg?1696529863"
    },
    {
      chainId: 1,
      address: "0x3d806324b6df5af3c1a81acba14a8a62fe6d643f",
      name: "BarbieCrashBandicootRFK88",
      symbol: "SOLANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31247/thumb/logo_200px.jpg?1696530072"
    },
    {
      chainId: 1,
      address: "0xb446566d6d644249d5d82aab5fea8a5b7da3f691",
      name: "Aktionariat TBo c o Comon Accelerator H",
      symbol: "TBOS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33332/thumb/TBOS.png?1701518908"
    },
    {
      chainId: 1,
      address: "0x8747a3114ef7f0eebd3eb337f745e31dbf81a952",
      name: "Aktionariat ServiceHunter AG Tokenized ",
      symbol: "DQTS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33335/thumb/DQTS.png?1701520936"
    },
    {
      chainId: 1,
      address: "0x33ba0f96980314cf962bd6224b5c3befa5946202",
      name: "nsurance",
      symbol: "N",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32392/thumb/n-logo-200x200.png?1698053006"
    },
    {
      chainId: 1,
      address: "0x3f2d4708f75de6fb60b687fed326697634774deb",
      name: "NeoBot",
      symbol: "NEOBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31033/thumb/20230718_190506_0000.png?1696529869"
    },
    {
      chainId: 1,
      address: "0x4e51a6b3cc6d5ae69a0d44db9de846aeb5a582dd",
      name: "Gyoza",
      symbol: "GYOZA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31083/thumb/logorecized_new.png?1696529916"
    },
    {
      chainId: 1,
      address: "0xf49311af05a4ffb1dbf33d61e9b2d4f0a7d4a71c",
      name: "CompanionBot",
      symbol: "CBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31302/thumb/IMG_20230812_173007_931.jpg?1696530122"
    },
    {
      chainId: 1,
      address: "0x112b08621e27e10773ec95d250604a041f36c582",
      name: "Wrapped Kaspa",
      symbol: "KAS",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31037/thumb/WKAS-256-black-ETH-3.png?1696529872"
    },
    {
      chainId: 1,
      address: "0xbe579b687fd9cd4fd6cb85abc8fbe069ab0be2cb",
      name: "Raw Chicken Experiment",
      symbol: "RCE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35852/thumb/Chicken.png?1709895570"
    },
    {
      chainId: 1,
      address: "0x56528c1df17fd5451451eb6efde297758bc8f9a1",
      name: "Aktionariat Alan Frei Company Tokenized",
      symbol: "AFS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33336/thumb/AFS.png?1701521247"
    },
    {
      chainId: 1,
      address: "0xa64efd5fe826f62e310a951332b519e1e3871489",
      name: "BetaCarbon",
      symbol: "BCAU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31040/thumb/Safeimagekit-resized-img_%281%29.png?1696529875"
    },
    {
      chainId: 1,
      address: "0x848896470d989f30503d8f883c331f63b73b66ea",
      name: "Medicle",
      symbol: "MDI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31082/thumb/Medicle%28MDI%29_NEW_.png?1696529915"
    },
    {
      chainId: 1,
      address: "0xd17c18979a45c0f3604331831c409f7bff64d3c1",
      name: "Farmer Friends",
      symbol: "FRENS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31048/thumb/FRENS_logo.png?1696529883"
    },
    {
      chainId: 1,
      address: "0x7bd44cf5c0566aab26150a0cd5c3d20c5535686f",
      name: "Evil Pepe",
      symbol: "EVILPEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31201/thumb/IMG_20230803_120336_441.png?1696530028"
    },
    {
      chainId: 1,
      address: "0x3dbb00c9be5a327e25caf4f650844c5dba81e34b",
      name: "StaFi Staked MATIC",
      symbol: "RMATIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29610/thumb/rMATIC.png?1696528546"
    },
    {
      chainId: 1,
      address: "0x7c3ed93b03e67c1fa240395b28e38c4386321b58",
      name: "Wally Bot",
      symbol: "WALLY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31046/thumb/IMG_4215.jpeg?1696529881"
    },
    {
      chainId: 1,
      address: "0x67d85a291fcdc862a78812a3c26d55e28ffb2701",
      name: "Asymetrix",
      symbol: "ASX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29984/thumb/Asymetrix_Logo_Only_Square_w200.png?1696528909"
    },
    {
      chainId: 1,
      address: "0x414cbf31c62d99515bfd66497b495a585b52f703",
      name: "Chappie",
      symbol: "CHAP",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/31375/thumb/Frame_563.png?1696530192"
    },
    {
      chainId: 1,
      address: "0xcb8a95e76a16b58c30b01e39dd6aad5949e5e802",
      name: "Tetris",
      symbol: "TETRIS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31100/thumb/tetris.jpeg?1696529931"
    },
    {
      chainId: 1,
      address: "0x2c623d3cc9a2cc158951b8093cb94e80cf56deea",
      name: "NexAI",
      symbol: "NEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31056/thumb/NexAI-LOGO_200x200.png?1696529891"
    },
    {
      chainId: 1,
      address: "0xc9a1f104fbbda8b8752946f7d56d59d28284037f",
      name: "Doug",
      symbol: "DOUG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32639/thumb/DOUG_Logo_200x200.png?1698854273"
    },
    {
      chainId: 1,
      address: "0x12ed0641242e4c6c220e3ca8f616e9d5470ac99a",
      name: "Earn Network",
      symbol: "EARN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33350/thumb/EARN_logo.png?1701561551"
    },
    {
      chainId: 1,
      address: "0x3f57c35633cb29834bb7577ba8052eab90f52a02",
      name: "Defender Bot",
      symbol: "DFNDR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34816/thumb/defenderbott.png?1706173844"
    },
    {
      chainId: 1,
      address: "0x8dbd1331b1de57835b24657ed21d0691e2e7362a",
      name: "SentimentAI",
      symbol: "SENT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34817/thumb/sentlogo.jpg?1706175707"
    },
    {
      chainId: 1,
      address: "0x19f8ed44aa2f5580d44ca6ed2a0e9bb33a08922d",
      name: "X Mass",
      symbol: "X-MASS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33337/thumb/IMG_9351.jpeg?1701525066"
    },
    {
      chainId: 1,
      address: "0x9be236ee350d18aaaf18619c5776d4096e94a0c7",
      name: "RATIO",
      symbol: "RATIO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32975/thumb/IMG_20231112_075548_885.jpg?1700069403"
    },
    {
      chainId: 1,
      address: "0x7ae075546e8042dc263fa0eb6519ce0a04eabb93",
      name: "Metal Tools",
      symbol: "METAL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31340/thumb/logonew.png?1696530158"
    },
    {
      chainId: 1,
      address: "0xa4be4cdc552891a6702e1ae9645ef445179a4463",
      name: "INOFi",
      symbol: "FON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31343/thumb/FON.png?1696530161"
    },
    {
      chainId: 1,
      address: "0x27206f5a9afd0c51da95f20972885545d3b33647",
      name: "KuKu",
      symbol: "KUKU",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/31177/thumb/IMG_20230801_131536_144.jpg?1696530005"
    },
    {
      chainId: 1,
      address: "0xde0220b69ce3e855a0124433a8e8d093f53a6be4",
      name: "Where Did The ETH Go ",
      symbol: "WHETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31486/thumb/WHETH_logo_transparent_200px.png?1696530297"
    },
    {
      chainId: 1,
      address: "0x6a6bfdd2174ade27258fe96b9afae3758dec14f2",
      name: "Solareum",
      symbol: "SOLAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33338/thumb/IMG_20231130_223554_575.jpg?1701525234"
    },
    {
      chainId: 1,
      address: "0xe8e8486228753e01dbc222da262aa706bd67e601",
      name: "Arch Ethereum Web3",
      symbol: "WEB3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26562/thumb/WEB3-TOKEN.png?1696525635"
    },
    {
      chainId: 1,
      address: "0x3d5fa1cf7d356474f72c8cb24f7a6117b40f8c40",
      name: "Saintbot",
      symbol: "SAINT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31165/thumb/1SDHoUxG_400x400.jpg?1696529993"
    },
    {
      chainId: 1,
      address: "0x21413c119b0c11c5d96ae1bd328917bc5c8ed67e",
      name: "GenomesDAO GENE",
      symbol: "GENE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20807/thumb/1637683704200x200.png?1696520200"
    },
    {
      chainId: 1,
      address: "0x2388821b40f3ab780f09e97b42b7b577d37a6d5e",
      name: "GROKX",
      symbol: "GROKX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33339/thumb/IMG_7246.jpeg?1701525504"
    },
    {
      chainId: 1,
      address: "0x4551d8ec1257092cd42b85824c45f944083c7885",
      name: "Cloud Mining Technologies",
      symbol: "CXM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34622/thumb/CXM.png?1705504480"
    },
    {
      chainId: 1,
      address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
      name: "Origin DeFi Governance",
      symbol: "OGV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26353/thumb/ogv-200x200.png?1696525431"
    },
    {
      chainId: 1,
      address: "0x4309e88d1d511f3764ee0f154cee98d783b61f09",
      name: "Onchain AI",
      symbol: "OCAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31191/thumb/onchain_200.jpeg?1696530019"
    },
    {
      chainId: 1,
      address: "0xafe53eea0cfe20198328890b69107d5fd8159a77",
      name: "XAI",
      symbol: "X",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31117/thumb/LOGO.jpg?1696529947"
    },
    {
      chainId: 1,
      address: "0x7016c6f4dba9a9a48a47a2fe73a1b9271432d1d5",
      name: "Fanbase",
      symbol: "WFNB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32445/thumb/Fanbase.png?1698238933"
    },
    {
      chainId: 1,
      address: "0xb1c064c3f2908f741c9dea4afc5773238b53e6cc",
      name: "WarioXRPDumbledoreYugioh69Inu",
      symbol: "XRP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31167/thumb/ETYYcV7I_400x400.jpg?1696529995"
    },
    {
      chainId: 1,
      address: "0xa3c31927a092bd54eb9a0b5dfe01d9db5028bd4f",
      name: "Espresso Bot",
      symbol: "ESPR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31091/thumb/ESPR.png?1696529923"
    },
    {
      chainId: 1,
      address: "0x6ad9a31f02f1e790ff85584ea3c3d0001e45cd64",
      name: "Ethane",
      symbol: "C2H6",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31118/thumb/Ethane200x200.png?1696529948"
    },
    {
      chainId: 1,
      address: "0xaaee1a9723aadb7afa2810263653a34ba2c21c7a",
      name: "Mog Coin",
      symbol: "MOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31059/thumb/MOG_LOGO_200x200.png?1696529893"
    },
    {
      chainId: 1,
      address: "0x903ff0ba636e32de1767a4b5eeb55c155763d8b7",
      name: "None Trading",
      symbol: "NONE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31137/thumb/None-200x200.png?1696529966"
    },
    {
      chainId: 1,
      address: "0x0001a500a6b18995b03f44bb040a5ffc28e45cb0",
      name: "Autonolas",
      symbol: "OLAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31099/thumb/OLAS-token.png?1696529930"
    },
    {
      chainId: 1,
      address: "0xbd7e92cf6f857be8541fca6abfb72aef8e16c307",
      name: "Prodigy Bot",
      symbol: "PRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31171/thumb/PRODIGY_LOGO_clean_%283%29.png?1696529999"
    },
    {
      chainId: 1,
      address: "0xb131f4a55907b10d1f0a50d8ab8fa09ec342cd74",
      name: "Memecoin",
      symbol: "MEME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32528/thumb/memecoin_%282%29.png?1698912168"
    },
    {
      chainId: 1,
      address: "0xe0c8b298db4cffe05d1bea0bb1ba414522b33c1b",
      name: "nuco cloud",
      symbol: "NCDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8932/thumb/NCDT_Token.png?1712562605"
    },
    {
      chainId: 1,
      address: "0xe2f98dd7506807ef82d1988aa77c320bc52f8df4",
      name: "Hold On for Dear Life",
      symbol: "HODL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32636/thumb/HODL.jpg?1698850454"
    },
    {
      chainId: 1,
      address: "0xba3335588d9403515223f109edc4eb7269a9ab5d",
      name: "Gearbox",
      symbol: "GEAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21630/thumb/gear.png?1696520990"
    },
    {
      chainId: 1,
      address: "0x94b888e11a9e960a9c3b3528eb6ac807b27ca62e",
      name: "Inception lsETH",
      symbol: "INLSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34951/thumb/LSETH.png?1706771493"
    },
    {
      chainId: 1,
      address: "0x0a13a5929e5f0ff0eaba4bd9e9512c91fce40280",
      name: "XAI Corp",
      symbol: "XAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30992/thumb/XAI.png?1700491072"
    },
    {
      chainId: 1,
      address: "0x9138c8779a0ac8a84d69617d5715bd8afa23c650",
      name: "Floor Cheese Burger",
      symbol: "FLRBRG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31526/thumb/YvPr4oRZ_400x400.jpg?1696530335"
    },
    {
      chainId: 1,
      address: "0xaaaf91d9b90df800df4f55c205fd6989c977e73a",
      name: "Monolith",
      symbol: "TKN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/675/thumb/Monolith.png?1696501865"
    },
    {
      chainId: 1,
      address: "0xeda8b016efa8b1161208cf041cd86972eee0f31e",
      name: "IHT Real Estate Protocol",
      symbol: "IHT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3158/thumb/iht-real-estate-protocol.png?1696503880"
    },
    {
      chainId: 1,
      address: "0x59c6766de1dc50a9c9db86cb0461b5ce07408ab7",
      name: "Spurdo",
      symbol: "SPURDO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31342/thumb/photo_2023-08-16_19-23-12_%281%29.png?1696530160"
    },
    {
      chainId: 1,
      address: "0xff836a5821e69066c87e268bc51b849fab94240c",
      name: "Real Smurf Cat",
      symbol: "SMURFCAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31751/thumb/SMURFCAT.png?1708079642"
    },
    {
      chainId: 1,
      address: "0x8edc62648236c20e528adb675ad3f3047697186f",
      name: "ApePudgyCloneXAzukiMilady",
      symbol: "NFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34703/thumb/IMG_8634.jpeg?1705862379"
    },
    {
      chainId: 1,
      address: "0x695afdb42edff97af470a15920a66df81a234c0e",
      name: "Wrapped MOXY",
      symbol: "WMOXY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31221/thumb/Moxy_200x_200_Logo.png?1696530047"
    },
    {
      chainId: 1,
      address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
      name: "AdEx",
      symbol: "ADX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/847/thumb/adex.jpeg?1696501984"
    },
    {
      chainId: 1,
      address: "0x419c4db4b9e25d6db2ad9691ccb832c8d9fda05e",
      name: "Dragonchain",
      symbol: "DRGN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1289/thumb/dragonchain.png?1696502360"
    },
    {
      chainId: 1,
      address: "0xb244b3574a5627849fca2057e3854340def63071",
      name: "Veil Exchange",
      symbol: "VEIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32624/thumb/HeIMUGIE_400x400.jpg?1698822478"
    },
    {
      chainId: 1,
      address: "0x60927b83ddd2096f38f22a8a2d84cf863402d1a1",
      name: "Eternal AI",
      symbol: "MIND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33340/thumb/download.png?1701525697"
    },
    {
      chainId: 1,
      address: "0x3bd7d4f524d09f4e331577247a048d56e4b67a7f",
      name: "5ire",
      symbol: "5IRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25246/thumb/16919.png?1696524387"
    },
    {
      chainId: 1,
      address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
      name: "LimeWire",
      symbol: "LMWR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30356/thumb/LimeWire_Logo_Icon_200x200_%281%29.png?1696529256"
    },
    {
      chainId: 1,
      address: "0x3ee4b152824b657644c7a9b50694787e80eb8f4a",
      name: "Bazed Games",
      symbol: "BAZED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31195/thumb/IMG_1849.jpeg?1696530023"
    },
    {
      chainId: 1,
      address: "0x925206b8a707096ed26ae47c84747fe0bb734f59",
      name: "WhiteBIT Coin",
      symbol: "WBT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/27045/thumb/wbt_token.png?1696526096"
    },
    {
      chainId: 1,
      address: "0x6c3ea9036406852006290770bedfcaba0e23a0e8",
      name: "PayPal USD",
      symbol: "PYUSD",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/31212/thumb/PYUSD_Logo_%282%29.png?1696530039"
    },
    {
      chainId: 1,
      address: "0xe1a70b24e109f7a8b39806c554e123efc6769e91",
      name: "Liquid Savings DAI",
      symbol: "LSDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31219/thumb/lsdai-logo.png?1696530045"
    },
    {
      chainId: 1,
      address: "0x4efce4c758ddfb3911a1a1282a29ce0bdb16ef86",
      name: "WOW",
      symbol: "",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33341/thumb/logo_%283%29.png?1701525830"
    },
    {
      chainId: 1,
      address: "0x312d43881860807fa04b193d69744d087fc3308a",
      name: "BRC 20 DEX",
      symbol: "BD20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35209/thumb/logo.jpg?1711030438"
    },
    {
      chainId: 1,
      address: "0xf62ac0fcae17f9195280ced4de978313effe2daa",
      name: "Nchart Token",
      symbol: "CHART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31169/thumb/n_200.png?1696529997"
    },
    {
      chainId: 1,
      address: "0x343cf59a43bd7ddd38b7236a478139a86a26222b",
      name: "Caesar s Arena",
      symbol: "CAESAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32623/thumb/logo32.png?1698821024"
    },
    {
      chainId: 1,
      address: "0xb622907fbff6cbf7c3ce355173251e3edb13a606",
      name: "FortuneBets",
      symbol: "FRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32966/thumb/fortune-white-on-red.png?1700054670"
    },
    {
      chainId: 1,
      address: "0xf4308b0263723b121056938c2172868e408079d0",
      name: "CryoDAO",
      symbol: "CRYO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34624/thumb/cryo-icon.png?1705504846"
    },
    {
      chainId: 1,
      address: "0xe0a6136f866684c0f19936c0c42a8c181c066f1b",
      name: "Tidalflats",
      symbol: "TIDE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33250/thumb/TIDE.jpg?1701236279"
    },
    {
      chainId: 1,
      address: "0xd075e95423c5c4ba1e122cae0f4cdfa19b82881b",
      name: "OpesAI",
      symbol: "WPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16647/thumb/ai.png?1696516208"
    },
    {
      chainId: 1,
      address: "0x280df82db83abb0a4c734bb02afc7985a1c8eaf2",
      name: "Etherpets",
      symbol: "EPETS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34928/thumb/112.png?1706686505"
    },
    {
      chainId: 1,
      address: "0x1cdd2eab61112697626f7b4bb0e23da4febf7b7c",
      name: "Bridged Tether  Wormhole ",
      symbol: "USDTSO",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/22881/thumb/USDTso_wh_small.png?1696522179"
    },
    {
      chainId: 1,
      address: "0x2d886570a0da04885bfd6eb48ed8b8ff01a0eb7e",
      name: "Blockchain Bets",
      symbol: "BCB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28694/thumb/200x200.jpg?1696527676"
    },
    {
      chainId: 1,
      address: "0x4501a82790ef2587dfeb93dc038541228e516597",
      name: "Hydra",
      symbol: "HYDRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32062/thumb/GDQ7c1hj_400x400.jpg?1696530859"
    },
    {
      chainId: 1,
      address: "0xda47862a83dac0c112ba89c6abc2159b95afd71c",
      name: "Prisma Governance Token",
      symbol: "PRISMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31520/thumb/PRISMA_200.png?1696530330"
    },
    {
      chainId: 1,
      address: "0x8c6778023c3d4fd79ddd14810079f64c39e9e43d",
      name: "0xAISwap",
      symbol: "0XAISWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32739/thumb/0x-AISwap-logo.png?1699236607"
    },
    {
      chainId: 1,
      address: "0x423f4e6138e475d85cf7ea071ac92097ed631eea",
      name: "PondCoin",
      symbol: "PNDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31215/thumb/pond-coin.jpeg?1696530042"
    },
    {
      chainId: 1,
      address: "0xdd23410f1fff27279c7314ff4735e71852084ddf",
      name: "Volume AI",
      symbol: "VAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35869/thumb/photo_2024-02-29_17-06-28.jpg?1709973817"
    },
    {
      chainId: 1,
      address: "0xed4e879087ebd0e8a77d66870012b5e0dffd0fa4",
      name: "AstroPepeX",
      symbol: "APX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31839/thumb/cglogo.png?1699223398"
    },
    {
      chainId: 1,
      address: "0xbf0b8b7475edb32d103001efd19fdd2753d7b76d",
      name: "Abachi",
      symbol: "ABI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31225/thumb/Abachi.png?1696530051"
    },
    {
      chainId: 1,
      address: "0x99f618edcfedca1fcc8302e14daa84802114a8c5",
      name: "DecentraBNB",
      symbol: "DBNB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26544/thumb/Screenshot_2022-07-22_at_18.16.11.png?1696525617"
    },
    {
      chainId: 1,
      address: "0x8e3fa615392688ddd9bf8f25d1f8dc744ac1a12c",
      name: "DumbMoney",
      symbol: "GME",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34929/thumb/DUMBMONEYICON.jpg?1706687792"
    },
    {
      chainId: 1,
      address: "0xabec00542d141bddf58649bfe860c6449807237c",
      name: "CruxDecussata",
      symbol: "X",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31246/thumb/Asset_1.png?1696530071"
    },
    {
      chainId: 1,
      address: "0x3af33bef05c2dcb3c7288b77fe1c8d2aeba4d789",
      name: "Kromatika",
      symbol: "KROM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20541/thumb/KROM_Transparent.png?1696519948"
    },
    {
      chainId: 1,
      address: "0x12272c264ca580d2190b16db14cea3815f52060c",
      name: "GROKBOT",
      symbol: "GROKBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33424/thumb/Group_79.png?1701768966"
    },
    {
      chainId: 1,
      address: "0x733b5056a0697e7a4357305fe452999a0c409feb",
      name: "IMVU",
      symbol: "VCORE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30682/thumb/VCORE_Logo_200x200.png?1696529551"
    },
    {
      chainId: 1,
      address: "0x07e0edf8ce600fb51d44f51e3348d77d67f298ae",
      name: "HarryPotterObamaPacMan8Inu",
      symbol: "XRP",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31241/thumb/Pacman_Logo200x200.png?1696530067"
    },
    {
      chainId: 1,
      address: "0xd0d56273290d339aaf1417d9bfa1bb8cfe8a0933",
      name: "Foom",
      symbol: "FOOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31308/thumb/f.png?1696530127"
    },
    {
      chainId: 1,
      address: "0x32a5fc22e20903e78171977359b500060b7316bf",
      name: "Paw a Gotchi",
      symbol: "PAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33116/thumb/pawagotchi_200px.png?1700732363"
    },
    {
      chainId: 1,
      address: "0x3f0c858c26775df75e45934b189154c436bd7335",
      name: "SuperFrank",
      symbol: "CHFP",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32531/thumb/SuperFrank_logo1080x1080_nobackground_noletters_centered.png?1698461197"
    },
    {
      chainId: 1,
      address: "0x66a39d581961d4cfa9bd3953ccc4e7ec7bd56716",
      name: "Yellow Team",
      symbol: "YELLOW",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31441/thumb/yellowteamclick.jpeg?1696530255"
    },
    {
      chainId: 1,
      address: "0xe86df1970055e9caee93dae9b7d5fd71595d0e18",
      name: "Bitcoin20",
      symbol: "BTC20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31284/thumb/BTC20_logo_%281%29.png?1696530107"
    },
    {
      chainId: 1,
      address: "0x209a78d23f825950a5df4d6d21288e5212b44f2c",
      name: "AlphaNova",
      symbol: "ANVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35210/thumb/LiquidAlpha-Logo.png?1709176634"
    },
    {
      chainId: 1,
      address: "0x3e34eabf5858a126cb583107e643080cee20ca64",
      name: "Linq",
      symbol: "LINQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31328/thumb/IMG_1185.jpeg?1696530147"
    },
    {
      chainId: 1,
      address: "0xa406844323f1603701e6ad95adc8a082213a68ce",
      name: "PolyBet",
      symbol: "PBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37413/thumb/PBT.png?1714374863"
    },
    {
      chainId: 1,
      address: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
      name: "sUSD",
      symbol: "SUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1696505546"
    },
    {
      chainId: 1,
      address: "0xc3960227e41c3f54e9b399ce216149dea5315c34",
      name: "Changpeng Zhao",
      symbol: "CZ",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33193/thumb/IMG_20231204_224120_835.jpg?1701798785"
    },
    {
      chainId: 1,
      address: "0xc14b4d4ca66f40f352d7a50fd230ef8b2fb3b8d4",
      name: "Blocktools",
      symbol: "TOOLS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31313/thumb/blocktools.jpeg?1696530132"
    },
    {
      chainId: 1,
      address: "0x01e87d74b11f656a673a3e7c441425816213eb0c",
      name: "Sonic",
      symbol: "HOTDOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31480/thumb/Sonic-The-Hot-Dog-NO-BG-NO-TEXT-1.png?1696530292"
    },
    {
      chainId: 1,
      address: "0xbe1bc2e2338defcd88e7f9f5f745ddb222180ab9",
      name: "TeSo",
      symbol: "TESO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31329/thumb/8A255A9F-4860-4D3C-9CDF-A20DC488FD7A.jpeg?1696530148"
    },
    {
      chainId: 1,
      address: "0xed354cae598148846aa9694254c854fc7051163c",
      name: "Shido  OLD ",
      symbol: "SHIDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26674/thumb/Shido.png?1696525746"
    },
    {
      chainId: 1,
      address: "0xca4b70beccabce29efa5bc5c86311e5d38461842",
      name: "Sybulls",
      symbol: "SYBL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31316/thumb/sybulls.png?1696530135"
    },
    {
      chainId: 1,
      address: "0xe2512a2f19f0388ad3d7a5263eaa82acd564827b",
      name: "Shido",
      symbol: "SHIDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32070/thumb/SHIDO.png?1696530867"
    },
    {
      chainId: 1,
      address: "0x98e1f56b334438e3f0bde22d92f5bfd746e0631f",
      name: "Illuminati",
      symbol: "ILUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32362/thumb/ILLUMINATI_200x200.png?1698067399"
    },
    {
      chainId: 1,
      address: "0x0f3b904172f937748af7f09353b016219a14562c",
      name: "Polygon Star",
      symbol: "POS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31947/thumb/logo.png?1696530753"
    },
    {
      chainId: 1,
      address: "0x14778860e937f509e651192a90589de711fb88a9",
      name: "CyberConnect",
      symbol: "CYBER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31274/thumb/cyberconnect.png?1696530098"
    },
    {
      chainId: 1,
      address: "0x20945ca1df56d237fd40036d47e866c7dccd2114",
      name: "Nsure Network",
      symbol: "NSURE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12948/thumb/Nsure_token.png?1696512737"
    },
    {
      chainId: 1,
      address: "0x7d60de2e7d92cb5c863bc82f8d59b37c59fc0a7a",
      name: "DeeLance",
      symbol: "DLANCE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31404/thumb/Deelancer-Final-LOGO.png?1696530220"
    },
    {
      chainId: 1,
      address: "0x982b50e55394641ca975a0eec630b120b671391a",
      name: "Ecoterra",
      symbol: "ECOTERRA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31563/thumb/ECOTERRA.png?1696530376"
    },
    {
      chainId: 1,
      address: "0xa9fbcc25435ad713a9468d8c89dd7baae8914e3a",
      name: "Prophet",
      symbol: "PROPHET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31908/thumb/Logo_200x200.png?1696530717"
    },
    {
      chainId: 1,
      address: "0xa3d4bee77b05d4a0c943877558ce21a763c4fa29",
      name: "The Root Network",
      symbol: "ROOT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/33122/thumb/6T1Tapl__400x400.jpg?1700740439"
    },
    {
      chainId: 1,
      address: "0x1a44e35d5451e0b78621a1b3e7a53dfaa306b1d0",
      name: "baoETH ETH StablePool",
      symbol: "B-BAOETH-ETH-BPT",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0x966e770030209c95f974f37edbde65d98e853354",
      name: "Maxx",
      symbol: "MAXX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30488/thumb/D9E6AF16-95F9-4550-87B5-E60C50DB1E02.png?1696529375"
    },
    {
      chainId: 1,
      address: "0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb",
      name: "sETH",
      symbol: "SETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8843/thumb/sETH.png?1696508995"
    },
    {
      chainId: 1,
      address: "0xfe18be6b3bd88a2d2a7f928d00292e7a9963cfc6",
      name: "sBTC",
      symbol: "SBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8838/thumb/sBTC.png?1696508990"
    },
    {
      chainId: 1,
      address: "0x9ee8c380e1926730ad89e91665ff27063b13c90a",
      name: "Coupon Assets",
      symbol: "CA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32202/thumb/ca.jpg?1696746380"
    },
    {
      chainId: 1,
      address: "0xc740181345c65552333e1edc797e03f11852b1c8",
      name: "Kento",
      symbol: "KNTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31352/thumb/knto-cg-200.png?1696530169"
    },
    {
      chainId: 1,
      address: "0x5044d567f7b30891639d982a05726a6bfe8bae6a",
      name: "Brainers",
      symbol: "BRAINERS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36127/thumb/Brainers.png?1710579156"
    },
    {
      chainId: 1,
      address: "0x8ed97a637a790be1feff5e888d43629dc05408f6",
      name: "Non Playable Coin",
      symbol: "NPC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31193/thumb/NPC_200x200.png?1696530021"
    },
    {
      chainId: 1,
      address: "0x0ae055097c6d159879521c384f1d2123d1f195e6",
      name: "STAKE",
      symbol: "STAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11061/thumb/xdai.png?1696511003"
    },
    {
      chainId: 1,
      address: "0xfe6f2e70f30a0894d0aee79e11653275e89c7bd6",
      name: "Karen Pepe",
      symbol: "KEPE",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xfae30394a76796dc3df37c2714f5fc12083dfdb0",
      name: "NakaChain",
      symbol: "NAKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36269/thumb/1CR4up2C_400x400.jpg?1711003041"
    },
    {
      chainId: 1,
      address: "0x8efe7dd5984640537b6596fb28b762f6c000f184",
      name: "Dark Forest",
      symbol: "DARK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31377/thumb/Dark_Forest.png?1696530194"
    },
    {
      chainId: 1,
      address: "0x401e6d25c2991824299aa5dbe67c82486a64381d",
      name: "bonsAI Network",
      symbol: "BNSAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37670/thumb/Token.png?1715184157"
    },
    {
      chainId: 1,
      address: "0x87d73e916d7057945c9bcd8cdd94e42a6f47f776",
      name: "NFTX",
      symbol: "NFTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13574/thumb/NFTX_%28Real%29.jpg?1696513327"
    },
    {
      chainId: 1,
      address: "0xb1a822ce8c799b0777ed1f260113819247e1bf26",
      name: "HairyPlotterFTX",
      symbol: "FTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32116/thumb/HairyPlotterFTX.png?1696585812"
    },
    {
      chainId: 1,
      address: "0x3250577e12b9469915c1fa3a71c22817ca44c4d9",
      name: "Socrates",
      symbol: "SOC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34895/thumb/socrates.jpeg?1706580533"
    },
    {
      chainId: 1,
      address: "0x285db79fa7e0e89e822786f48a7c98c6c1dc1c7d",
      name: "Magic Internet Cash",
      symbol: "MIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31405/thumb/MICsmall.png?1696530221"
    },
    {
      chainId: 1,
      address: "0x9778ac3d5a2f916aa9abf1eb85c207d990ca2655",
      name: "OG SMINEM",
      symbol: "OGSM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32574/thumb/Sminem_portrait__2_-removebg-preview.png?1698554514"
    },
    {
      chainId: 1,
      address: "0xfcaf0e4498e78d65526a507360f755178b804ba8",
      name: "NicCageWaluigiElmo42069Inu",
      symbol: "SHIB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31378/thumb/NicCageWaluigiElmo42069Inu.png?1696530195"
    },
    {
      chainId: 1,
      address: "0x03475e14de25908ed484eb99ad38d68cb6399807",
      name: "Blue Team",
      symbol: "BLUE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31443/thumb/blueteam.jpeg?1696530257"
    },
    {
      chainId: 1,
      address: "0x320ed4c7243e35a00f9ca30a1ae60929d15eae37",
      name: "The Blox Project",
      symbol: "BLOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32397/thumb/blox.png?1698054451"
    },
    {
      chainId: 1,
      address: "0xca5b0ae1d104030a9b8f879523508efd86c14483",
      name: "Benji Bananas",
      symbol: "BENJI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31022/thumb/BenjiTokens_FinalFlat.png?1696529858"
    },
    {
      chainId: 1,
      address: "0xebb82c932759b515b2efc1cfbb6bf2f6dbace404",
      name: "shares finance",
      symbol: "SHARES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31379/thumb/shares.jpeg?1696530196"
    },
    {
      chainId: 1,
      address: "0xc9cb16ac87c43697b838c64ee416d748817f2b77",
      name: "Groooook",
      symbol: "GROOOOOK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33351/thumb/20231120143459.png?1701561790"
    },
    {
      chainId: 1,
      address: "0xb1f136a74e18e4e2921febbf25820d1bb65b5647",
      name: "hiPunks",
      symbol: "HIPUNKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26739/thumb/hipunks.png?1696525808"
    },
    {
      chainId: 1,
      address: "0xcaa79bf8b1d00bf3d4f6dbec6221955871c04618",
      name: "CrocBot",
      symbol: "CROC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31382/thumb/Frame_123.png?1696530199"
    },
    {
      chainId: 1,
      address: "0xb7cfe05915ef0c040c6dde2007c9ddab26259e04",
      name: "Molly",
      symbol: "MOLLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34628/thumb/Molly.png?1705547025"
    },
    {
      chainId: 1,
      address: "0x7b744eea1deca2f1b7b31f15ba036fa1759452d7",
      name: "El Hippo",
      symbol: "HIPP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31384/thumb/HIPP.png?1696530201"
    },
    {
      chainId: 1,
      address: "0x0a693a301215aad39d83a32a5b5279f2d238851b",
      name: "Pepe OG",
      symbol: "POG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31597/thumb/photo_2023-09-04_17.43.39.jpeg?1696530414"
    },
    {
      chainId: 1,
      address: "0x34df29dd880e9fe2cec0f85f7658b75606fb2870",
      name: "Navy seal",
      symbol: "NAVYSEAL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31406/thumb/Navyseal.jpg?1696530222"
    },
    {
      chainId: 1,
      address: "0x32bd822d615a3658a68b6fdd30c2fcb2c996d678",
      name: "Eigenpie swETH",
      symbol: "MSWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37167/thumb/mswETH.png?1713507053"
    },
    {
      chainId: 1,
      address: "0x69cd13d248830602a60b1f20ab11f5049385877d",
      name: "Baby Pepe",
      symbol: "BABYPEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31417/thumb/output-onlinepngtools_%281%29.png?1696530232"
    },
    {
      chainId: 1,
      address: "0x4594cffbfc09bc5e7ecf1c2e1c1e24f0f7d29036",
      name: "0 Knowledge Network",
      symbol: "0KN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31626/thumb/200x200.png?1696530442"
    },
    {
      chainId: 1,
      address: "0xa72332af4a7efbce221903e7a09175be64f0400d",
      name: "Gumball Machine",
      symbol: "GUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35277/thumb/gumball.jpg?1708080490"
    },
    {
      chainId: 1,
      address: "0x6988a804c74fd04f37da1ea4781cea68c9c00f86",
      name: "Tribal Token",
      symbol: "TRIBL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27774/thumb/PFP_black_%281%29.png?1696526795"
    },
    {
      chainId: 1,
      address: "0xcd6926193308d3b371fdd6a6219067e550000000",
      name: "Nest Protocol",
      symbol: "NEST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11284/thumb/52954052.png?1696511207"
    },
    {
      chainId: 1,
      address: "0xa9ad6830180f9c150349f2cecadd710586e35cb7",
      name: "ETH Stable",
      symbol: "ETHS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31464/thumb/ETHS.jpeg?1696530277"
    },
    {
      chainId: 1,
      address: "0xe221db71c5c527149bdf56c4d13a54cf55e543c1",
      name: "Aktionariat Technologies of Understandi",
      symbol: "VIDS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33252/thumb/VIDS.PNG?1701254720"
    },
    {
      chainId: 1,
      address: "0xa88842ae47dbe87116cf7001dddd1b246fcd8262",
      name: "hiENS3",
      symbol: "HIENS3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27262/thumb/hiens3.png?1696526315"
    },
    {
      chainId: 1,
      address: "0x33bd66c334274989b673a8e8c8d1a3f1b8de5889",
      name: "hiODBS",
      symbol: "HIODBS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27296/thumb/hiodbs.png?1696526348"
    },
    {
      chainId: 1,
      address: "0xbbeca80a4c99c3b1bd3c10e64595d0fc7dc26ee0",
      name: "hiMEEBITS",
      symbol: "HIMEEBITS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28126/thumb/himeebit.png?1696527133"
    },
    {
      chainId: 1,
      address: "0x3700adfd26d5bc062cb8b8a77e68fbd43f58ecab",
      name: "hiDOODLES",
      symbol: "HIDOODLES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27427/thumb/hidoodles.png?1696526468"
    },
    {
      chainId: 1,
      address: "0x12aef5c60c2c86c8ecd3079f22f285f326371340",
      name: "hiSAND33",
      symbol: "HISAND33",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27006/thumb/logo.ab86781.png?1696526059"
    },
    {
      chainId: 1,
      address: "0x00a7ec2f2b451cb0233e8adbf4c9a951027c2b02",
      name: "hiENS4",
      symbol: "HIENS4",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26921/thumb/62f9ec6fd1c44e000102051d_MicrosoftTeams-image.png?1696525978"
    },
    {
      chainId: 1,
      address: "0x5362ca75aa3c0e714bc628296640c43dc5cb9ed6",
      name: "Dejitaru Hoshi",
      symbol: "HOSHI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31488/thumb/Hoshi_200x200_-_Copy.png?1696530299"
    },
    {
      chainId: 1,
      address: "0x7a83ff237e7870d8d6c3485920ebe654d2841315",
      name: "hiOD",
      symbol: "HIOD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28238/thumb/hiod.png?1696527241"
    },
    {
      chainId: 1,
      address: "0x00c5ca160a968f47e7272a0cfcda36428f386cb6",
      name: "USDEBT",
      symbol: "USDEBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31448/thumb/200x200.png?1710861880"
    },
    {
      chainId: 1,
      address: "0x635f15eb7aa2e62d122f6b1f9f519fdccf4abdda",
      name: "hiMAYC",
      symbol: "HIMAYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27602/thumb/himayc.png?1696526633"
    },
    {
      chainId: 1,
      address: "0x082716b6734b31791407d7dd0e2a2c41260029b2",
      name: "hiCOOLCATS",
      symbol: "HICOOLCATS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28603/thumb/hicoolcats.png?1696527589"
    },
    {
      chainId: 1,
      address: "0x764104dc24dadff01150253a58c82337984b4319",
      name: "hiCLONEX",
      symbol: "HICLONEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28436/thumb/hiclonex.png?1696527433"
    },
    {
      chainId: 1,
      address: "0x15c1cab705b9ddb9ffeeea608ed8bafcdd4c0396",
      name: "HXAcoin",
      symbol: "HXA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31315/thumb/HXA_Ticker_image_%281%29.png?1699280752"
    },
    {
      chainId: 1,
      address: "0x0b0a8c7c34374c1d0c649917a97eee6c6c929b1b",
      name: "Shiba V Pepe",
      symbol: "SHEPE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31599/thumb/photo_2023-08-30_01-36-19_%282%29.png?1696530415"
    },
    {
      chainId: 1,
      address: "0x669db4c47f89f21554ebd825a744888725fd9491",
      name: "hiPENGUINS",
      symbol: "HIPENGUINS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28381/thumb/63856bebcd8c700001b23c42_hiPENGUINS-_Logo.png?1696527381"
    },
    {
      chainId: 1,
      address: "0xc1ad0aa69454603a5dee55cf9bd9341e01328544",
      name: "hiGAZERS",
      symbol: "HIGAZERS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28316/thumb/higazers.png?1696527322"
    },
    {
      chainId: 1,
      address: "0x4b7ffcb2b92fb4890f22f62a52fb7a180eab818e",
      name: "DIVA Protocol",
      symbol: "DIVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31467/thumb/DIVA-200px-square.png?1696530280"
    },
    {
      chainId: 1,
      address: "0xc0da2786176dac9eda661c566828950ca571348c",
      name: "Aktionariat Art Leasing And Invest AG T",
      symbol: "ARTS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33352/thumb/ART.png?1701562351"
    },
    {
      chainId: 1,
      address: "0x8a3c710e41cd95799c535f22dbae371d7c858651",
      name: "Xccelerate",
      symbol: "XLRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31425/thumb/Xccelerate.png?1696530240"
    },
    {
      chainId: 1,
      address: "0x7721a4cb6190edb11d47f51c20968436eccdafb8",
      name: "Guiser",
      symbol: "GUISE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31426/thumb/GUISE.jpg?1696530241"
    },
    {
      chainId: 1,
      address: "0xa995d67fd0187b4b8fea3a60e11f31a08e4ac40b",
      name: "Aktionariat Pension Dynamics AG Tokeniz",
      symbol: "PDS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33353/thumb/PD.png?1701563333"
    },
    {
      chainId: 1,
      address: "0x4e8de529fe22dee9266b029cdfc52142b82e0e2f",
      name: "Aktionariat Outlawz Food AG Tokenized S",
      symbol: "VEGS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33355/thumb/VEG.png?1701563721"
    },
    {
      chainId: 1,
      address: "0x43e54c2e7b3e294de3a155785f52ab49d87b9922",
      name: "Aladdin sdCRV",
      symbol: "ASDCRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31428/thumb/asdCRV_logo.jpg?1696530243"
    },
    {
      chainId: 1,
      address: "0x17729f7ffddd4ed480cf4cfb1668ef90d1e6a24e",
      name: "EventsX",
      symbol: "EVEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34397/thumb/evex_logo.jpg?1704787275"
    },
    {
      chainId: 1,
      address: "0x24a6a37576377f63f194caa5f518a60f45b42921",
      name: "Float Protocol",
      symbol: "BANK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14116/thumb/FLOAT-Bank_LOGO-reduced_01.png?1696513836"
    },
    {
      chainId: 1,
      address: "0xe4ab0be415e277d82c38625b72bd7dea232c2e7d",
      name: "XRP20",
      symbol: "XRP20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31435/thumb/xrp20_logo_resize.png?1696530250"
    },
    {
      chainId: 1,
      address: "0x456815812b3129a4389ea4d73e9706697cc91373",
      name: "0xS",
      symbol: "0XS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31453/thumb/Logo200x200.png?1696530267"
    },
    {
      chainId: 1,
      address: "0x43d7e65b8ff49698d9550a7f315c87e67344fb59",
      name: "Shiba Saga",
      symbol: "SHIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31437/thumb/51nmYxm3_400x400.jpg?1696530252"
    },
    {
      chainId: 1,
      address: "0xd5dc24c9ef8a21e6d7caa603f9502e4a0dc7fe8a",
      name: "Red Team",
      symbol: "RED",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31439/thumb/red_team_click.jpeg?1696530254"
    },
    {
      chainId: 1,
      address: "0x9078deb4736b7e2181beb8db276dfbfa7f21f821",
      name: "Monk gg",
      symbol: "MONKGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31502/thumb/Lu4Pg4jC_400x400.jpg?1696530313"
    },
    {
      chainId: 1,
      address: "0x70b790d0948a760e80bc3f892b142f7779b538b2",
      name: "Dora Factory",
      symbol: "DORA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31552/thumb/DORA.jpg?1696530364"
    },
    {
      chainId: 1,
      address: "0x73c6a7491d0db90bdb0060308cde0f49dfd1d0b0",
      name: "DogeBonk",
      symbol: "DOBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31455/thumb/200x200.png?1696530269"
    },
    {
      chainId: 1,
      address: "0xd87996ff3d06858bfc20989aef50cc5fcd4d84ca",
      name: "Golden Inu",
      symbol: "GOLDEN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31473/thumb/git-200x200.png?1704456922"
    },
    {
      chainId: 1,
      address: "0xfbbe098ee65238e4d9f771404edddcbf89cd689b",
      name: "Treemeister",
      symbol: "TREE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31529/thumb/TREELOGO.png?1696530338"
    },
    {
      chainId: 1,
      address: "0xd3b9a9e5ee4aab3963c95dd715882def4f22b449",
      name: "Revhub",
      symbol: "REVHUB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31841/thumb/Revhub.jpg?1696530655"
    },
    {
      chainId: 1,
      address: "0x3a6dc7eefef660be5c254c8aa1b710202151e345",
      name: "dPARROT",
      symbol: "PARROT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31601/thumb/coingecko.jpg?1696530417"
    },
    {
      chainId: 1,
      address: "0x297e4e5e59ad72b1b0a2fd446929e76117be0e0a",
      name: "Smart Valor",
      symbol: "VALOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/7231/thumb/1._SMART_VALOR__Logo_NEW.png?1696507527"
    },
    {
      chainId: 1,
      address: "0x2f8221e82e0d4669ad66eabf02a5baed43ea49e7",
      name: "Newsly",
      symbol: "NEWS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31489/thumb/byk_Sy1X_400x400.jpg?1696530300"
    },
    {
      chainId: 1,
      address: "0x9baa12a9e3b9dc355f162082762f95626367d087",
      name: "Handz of Gods",
      symbol: "HANDZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31531/thumb/40B0eCTs_400x400.jpg?1696530340"
    },
    {
      chainId: 1,
      address: "0x97de57ec338ab5d51557da3434828c5dbfada371",
      name: "eUSD  OLD ",
      symbol: "EUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30047/thumb/ethereum-eth-logo-colored_4_%281%29_%281%29.png?1696528969"
    },
    {
      chainId: 1,
      address: "0xdf3ac4f479375802a821f7b7b46cd7eb5e4262cc",
      name: "eUSD",
      symbol: "EUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31603/thumb/eusd.png?1696530419"
    },
    {
      chainId: 1,
      address: "0x7ad16874759348f04b6b6119463d66c07ae54899",
      name: "PIRB",
      symbol: "PIRB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31653/thumb/pirb_geckologo.png?1696530468"
    },
    {
      chainId: 1,
      address: "0x53020f42f6da51b50cf6e23e45266ef223122376",
      name: "BlockSpot Network",
      symbol: "SPOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33078/thumb/token_%285%29_%281%29.png?1700550027"
    },
    {
      chainId: 1,
      address: "0x51fe05eac152494908ff1ebbd50e116e960baf64",
      name: "X GPT",
      symbol: "XGPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31559/thumb/XGPT_Logo.png?1696530372"
    },
    {
      chainId: 1,
      address: "0xd82fd4d6d62f89a1e50b1db69ad19932314aa408",
      name: "Liquis",
      symbol: "LIQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31587/thumb/Liqblue.png?1696530404"
    },
    {
      chainId: 1,
      address: "0xaf2ca40d3fc4459436d11b94d21fa4b8a89fb51d",
      name: "COTI Governance Token",
      symbol: "GCOTI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32930/thumb/gCOTI_logo_icon200x200.png?1700669092"
    },
    {
      chainId: 1,
      address: "0xec21890967a8ceb3e55a3f79dac4e90673ba3c2e",
      name: "BEBE",
      symbol: "BEBE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/34932/thumb/1000003129.jpg?1706694024"
    },
    {
      chainId: 1,
      address: "0x52d30b949bdbc63780e5a263cf436d4df983fe58",
      name: "Zenith Wallet",
      symbol: "ZW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31670/thumb/ZENITH.jpg?1696530486"
    },
    {
      chainId: 1,
      address: "0x4208aa4d7a9a10f4f8bb7f6400c1b2161d946969",
      name: "DongCoin",
      symbol: "DONG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31499/thumb/DONG_LOGO.png?1696530310"
    },
    {
      chainId: 1,
      address: "0x03ee5026c07d85ff8ae791370dd0f4c1ae6c97fc",
      name: "0x Leverage",
      symbol: "OXL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31977/thumb/Ox.jpeg?1696530780"
    },
    {
      chainId: 1,
      address: "0xaa247c0d81b83812e1abf8bab078e4540d87e3fb",
      name: "Meson Network",
      symbol: "MSN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34981/thumb/meson-token-icon200.png?1714275908"
    },
    {
      chainId: 1,
      address: "0xa0117792d4b100fd329b37e8ab4181df8a5b3326",
      name: "BREPE",
      symbol: "BREPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31561/thumb/cmc_200x200_logo_transparency.png?1696530374"
    },
    {
      chainId: 1,
      address: "0x9532ca064278ce3ba4fcc66cebec6d9f04f58f70",
      name: "Bot Compiler",
      symbol: "BOTC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31513/thumb/imageedit_1_8217440916.png?1696530323"
    },
    {
      chainId: 1,
      address: "0x0258f474786ddfd37abce6df6bbb1dd5dfc4434a",
      name: "Orion",
      symbol: "ORN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/11841/thumb/new_logo.jpeg?1696511712"
    },
    {
      chainId: 1,
      address: "0x1028083026fe1e8e1e79170ceae0edbad07b052d",
      name: "MonkCoin",
      symbol: "MONK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31725/thumb/MonkCoin.jpg?1696530546"
    },
    {
      chainId: 1,
      address: "0xe4efdd2eb216a4620cfa55c5cc67bd09dc64ff24",
      name: " ",
      symbol: "",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31535/thumb/KB0nEHf__400x400.jpg?1696530344"
    },
    {
      chainId: 1,
      address: "0xf6f31b8afbf8e3f7fc8246bef26093f02838da98",
      name: "Unicorn Metaverse",
      symbol: "UNIVERSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33077/thumb/rar4.JPG?1700549656"
    },
    {
      chainId: 1,
      address: "0xa3cb87080e68ad54d00573983d935fa85d168fde",
      name: "InfinityBit Token",
      symbol: "IBIT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31562/thumb/ibit-200x200cg.png?1696530375"
    },
    {
      chainId: 1,
      address: "0xf47245e9a3ba3dca8b004e34afc1290b1d435a52",
      name: "Magical Blocks",
      symbol: "MBLK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33186/thumb/13441700648242_.pic.jpg?1700953813"
    },
    {
      chainId: 1,
      address: "0xa946fb6b6b860c68df3c293f1e2c3881b243e08c",
      name: "Dragon",
      symbol: "DRAGON",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xb281d84989c06e2a6ccdc5ea7bf1663c79a1c31a",
      name: "stoicDAO",
      symbol: "ZETA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33343/thumb/lCisSJAU_400x400.jpg?1701528682"
    },
    {
      chainId: 1,
      address: "0x6f8b23296394d20ec048fbdec8ebc0ca90f5c8f1",
      name: "TUF Token",
      symbol: "TUF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28410/thumb/2022-12-06_10.10.16.jpg?1696527408"
    },
    {
      chainId: 1,
      address: "0x08d0222a206d1aee59a9b66969c04fd1e8a0f864",
      name: "Momo v2",
      symbol: "MOMOV2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31515/thumb/momo.jpg?1696530325"
    },
    {
      chainId: 1,
      address: "0x07c904d8c04323ef9fe6bf13aaeba05b62c54825",
      name: "Eeyor",
      symbol: "EEYOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31565/thumb/200eeyor.png?1696530378"
    },
    {
      chainId: 1,
      address: "0x226d6d842d49b4d757bef1632053a198d5d9c8aa",
      name: "Block Browser",
      symbol: "BLOCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31538/thumb/photo_2023-08-29_01-46-11.jpg?1696530347"
    },
    {
      chainId: 1,
      address: "0xc3ade5ace1bbb033ccae8177c12ecbfa16bd6a9d",
      name: "Inception swETH",
      symbol: "INSWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34943/thumb/swETH.png?1706757072"
    },
    {
      chainId: 1,
      address: "0xdb81f7b3f0b2baebd5009cddade5c9a9c82378bb",
      name: "Jjmoji",
      symbol: "JJ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33344/thumb/JJ.jpg?1701529096"
    },
    {
      chainId: 1,
      address: "0xfbd5fd3f85e9f4c5e8b40eec9f8b8ab1caaa146b",
      name: "Treat Token",
      symbol: "TREAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31518/thumb/treat.jpg?1696530328"
    },
    {
      chainId: 1,
      address: "0x19be3a0f1a6cccc99b3cdc13475613e559be551c",
      name: "FrenBot",
      symbol: "MEF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31573/thumb/frenbot_logo.png?1697699412"
    },
    {
      chainId: 1,
      address: "0x3540abe4f288b280a0740ad5121aec337c404d15",
      name: "TPRO Network",
      symbol: "TPRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26694/thumb/tpro-logo-200x200.png?1712870769"
    },
    {
      chainId: 1,
      address: "0x06d6f0dd6703a1cfe16025dcc55f36f017887627",
      name: "Montage Token",
      symbol: "MTGX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36903/thumb/Montage-200x200.png?1712699912"
    },
    {
      chainId: 1,
      address: "0x68aae81b4241ffe03d3552d42a69940604fe28bf",
      name: "Muffin",
      symbol: "MUFFIN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37023/thumb/muffin_coingecko.png?1713155913"
    },
    {
      chainId: 1,
      address: "0xdcc97d2c1048e8f3f2fc58ace9024ab8b350e4b1",
      name: "BENCOIN",
      symbol: "BEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32701/thumb/BEN_COIN_BACK_%281%29.png?1698985208"
    },
    {
      chainId: 1,
      address: "0xc0804a4eae02fdf7516f55a12990d282640a4961",
      name: "OpenPool",
      symbol: "OPL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31541/thumb/0xc0804a4eae02fdf7516f55a12990d282640a4961.png?1696530354"
    },
    {
      chainId: 1,
      address: "0xd1b5651e55d4ceed36251c61c50c889b36f6abb5",
      name: "Stake DAO CRV",
      symbol: "SDCRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27756/thumb/scCRV-2.png?1696526779"
    },
    {
      chainId: 1,
      address: "0x8929e9dbd2785e3ba16175e596cdd61520fee0d1",
      name: "Altitude",
      symbol: "ALTD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30114/thumb/logo.png?1696529036"
    },
    {
      chainId: 1,
      address: "0xd561a593d9dd8b9a0e3a487dfb517c9371d6dda7",
      name: "Meow Meme",
      symbol: "MEOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36128/thumb/Meow_Meme_Coin.png?1710579427"
    },
    {
      chainId: 1,
      address: "0x8353b92201f19b4812eee32efd325f7ede123718",
      name: "ScamFari",
      symbol: "SCM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31267/thumb/Ava_Scamfari_%281%29.png?1696530091"
    },
    {
      chainId: 1,
      address: "0x8423b76be8ef6ca7400a6b4c334d29c1d5d4572c",
      name: "HarryPotterObamaInu",
      symbol: "INU",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31607/thumb/harry_logo.png?1696530423"
    },
    {
      chainId: 1,
      address: "0xca7013ba4bf76bcdc3ffc71735896682644f47c2",
      name: "Degen",
      symbol: "DGN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31606/thumb/Degen.png?1696530422"
    },
    {
      chainId: 1,
      address: "0x75ce16d11b83605aa039d40d7d846ff23064fb65",
      name: "DUBX",
      symbol: "DUB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31605/thumb/dubx200*200.png?1696530421"
    },
    {
      chainId: 1,
      address: "0x2e19067cbeb38d6554d31a1a83aefc4018a1688a",
      name: "Coinback",
      symbol: "CBK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31576/thumb/F1090BAA-54E3-4F9A-AFAA-57BA89E144CB.PNG?1696530393"
    },
    {
      chainId: 1,
      address: "0xcb27e0b9530d5107302e3e0691dd0f64faf498b0",
      name: "Pepe Of Wallstreet",
      symbol: "POW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31579/thumb/photo_2023-09-04_15-13-35_%281%29.jpg?1696530396"
    },
    {
      chainId: 1,
      address: "0x1142866f451d9d5281c5c8349a332bd338e552a1",
      name: "SuperMarioPorsche911Inu",
      symbol: "SILKROAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31649/thumb/smp911i_logo400x400_%283%29.jpg?1696530464"
    },
    {
      chainId: 1,
      address: "0xe925aa77d51746b865e5c05165a879820cb4b720",
      name: "C Cash",
      symbol: "CCASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31644/thumb/200x.png?1696530460"
    },
    {
      chainId: 1,
      address: "0x7aa2f174fbc4d0a17b34adfb9b3e1dc029b46d76",
      name: "RADA Foundation",
      symbol: "RADA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31645/thumb/1.png?1696530461"
    },
    {
      chainId: 1,
      address: "0xc47ef9b19c3e29317a50f5fbe594eba361dada4a",
      name: "Edelcoin",
      symbol: "EDLC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/31621/thumb/edelcoin_logo_200_%281%29.png?1696530437"
    },
    {
      chainId: 1,
      address: "0x24edded3f03abb2e9d047464294133378bddb596",
      name: "SECT BOT",
      symbol: "SECT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33525/thumb/IMG_7387.png?1702138186"
    },
    {
      chainId: 1,
      address: "0x9f891b5ecbd89dd8a5ee4d1d80efc3fe78b306cb",
      name: "SONIK",
      symbol: "SONIK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31693/thumb/Sonik_Logo_%281%29.png?1696530511"
    },
    {
      chainId: 1,
      address: "0x29d7139271398d0c2e22523fda06e023dcb07f8f",
      name: "KlubCoin",
      symbol: "KLUB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32869/thumb/klub.jpg?1701141365"
    },
    {
      chainId: 1,
      address: "0x4e452b391a86c9240e98df7277ce0bea5be08e43",
      name: "Pax Unitas",
      symbol: "PAXU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31648/thumb/IMG_11C5EA8BD781-1.jpeg?1696530463"
    },
    {
      chainId: 1,
      address: "0x5ebffc53c3b8a71120789a211f9b91c79c78d1e0",
      name: "SOJUDAO",
      symbol: "SOJU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31627/thumb/1.png?1696530443"
    },
    {
      chainId: 1,
      address: "0x473f4068073cd5b2ab0e4cc8e146f9edc6fb52cc",
      name: "NutCoin",
      symbol: "NUT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37569/thumb/icon-2_200x200.png?1714886224"
    },
    {
      chainId: 1,
      address: "0x9b0e1c344141fb361b842d397df07174e1cdb988",
      name: "EmotiCoin",
      symbol: "EMOTI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31630/thumb/200x200_logo_1.png?1696530446"
    },
    {
      chainId: 1,
      address: "0x3294395e62f4eb6af3f1fcf89f5602d90fb3ef69",
      name: "Celo  Wormhole ",
      symbol: "CELO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32400/thumb/celo_wh.png?1698055352"
    },
    {
      chainId: 1,
      address: "0xbb63e6be33bc5b5386d7ab0529dc6c400f2ac2ec",
      name: "Cuckadoodledoo",
      symbol: "CUCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31631/thumb/Cuckman__%281%29.png?1696530447"
    },
    {
      chainId: 1,
      address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
      name: "MANTRA",
      symbol: "OM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12151/thumb/OM_Token.png?1696511991"
    },
    {
      chainId: 1,
      address: "0x6fdb90535c09b82825e38d41edf5e66211d4b442",
      name: "Yield Magnet",
      symbol: "MAGNET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32821/thumb/IMG_0410.jpeg?1699582097"
    },
    {
      chainId: 1,
      address: "0x7d7513bba1af295574c24bbe425873d0c431ff9f",
      name: "Worldcore coin",
      symbol: "WCC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35511/thumb/1000956327.png?1709637554"
    },
    {
      chainId: 1,
      address: "0x890a60b4450484847380bddca0c3c3ee2ff0dfbe",
      name: "X Ratio AI",
      symbol: "XRAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36130/thumb/200x200cmc.png?1710579759"
    },
    {
      chainId: 1,
      address: "0x96add417293a49e80f024734e96cfd8b355bcc14",
      name: "LiquidLayer",
      symbol: "LILA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32547/thumb/photo_2023-10-08_12-09-02.jpg?1698474657"
    },
    {
      chainId: 1,
      address: "0x3adf095d04311d7bf05c838f0d3dc34a83d81ab6",
      name: "SHILLD",
      symbol: "SHILLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31675/thumb/200x200.png?1696530491"
    },
    {
      chainId: 1,
      address: "0x3ec15c4745e21ab3831d1f51c492e3b5582d6239",
      name: "PICKLE",
      symbol: "PICKLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31717/thumb/ezgif.com-resize_%287%29.png?1696530538"
    },
    {
      chainId: 1,
      address: "0x37dba54fdc402aff647ce06c66972f5d662c326d",
      name: "MELON",
      symbol: "MELON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31701/thumb/Melon_Icon_200px_2.png?1696530525"
    },
    {
      chainId: 1,
      address: "0x9863bcc2fb23dfdf5fe275aa4c5575a32a580911",
      name: "PEPURAI",
      symbol: "PEPURAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31702/thumb/Pepurai-_LOGO_%282%29.png?1696530526"
    },
    {
      chainId: 1,
      address: "0x75c97384ca209f915381755c582ec0e2ce88c1ba",
      name: "FINE",
      symbol: "FINE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31703/thumb/05220a_054ff0bb5d7c41db99db6332923ac4fd_mv2.png?1696530527"
    },
    {
      chainId: 1,
      address: "0xa9049425b938c46ac3e312d4cdaeccb26282aeb2",
      name: "WickedBet Casino",
      symbol: "WIK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31721/thumb/WB_B_W.png?1696530542"
    },
    {
      chainId: 1,
      address: "0x69d29f1b0cc37d8d3b61583c99ad0ab926142069",
      name: "Pepe Inverted",
      symbol: "",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31948/thumb/photo_2023-09-25_14-05-49.jpg?1696530754"
    },
    {
      chainId: 1,
      address: "0x59d9356e565ab3a36dd77763fc0d87feaf85508c",
      name: "Mountain Protocol USD",
      symbol: "USDM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31719/thumb/usdm.png?1696530540"
    },
    {
      chainId: 1,
      address: "0x7d51888c5abb7cdfa9cdd6a50673c7f8afaccd7f",
      name: "DuckDAO",
      symbol: "DD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33325/thumb/duckdao_dd_token_icon.png?1701437826"
    },
    {
      chainId: 1,
      address: "0xa40640458fbc27b6eefedea1e9c9e17d4cee7a21",
      name: "Anchored Coins AEUR",
      symbol: "AEUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33469/thumb/aeur-icon2.png?1701944612"
    },
    {
      chainId: 1,
      address: "0xddcc69879e1d2376ce799051afa98c689f234cca",
      name: "SmartMoney",
      symbol: "SMRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35280/thumb/Smartmoney.jpeg?1708054880"
    },
    {
      chainId: 1,
      address: "0xadf7c35560035944e805d98ff17d58cde2449389",
      name: "Spectral",
      symbol: "SPEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36138/thumb/spectral_logo_200x200.png?1710684002"
    },
    {
      chainId: 1,
      address: "0x1063181dc986f76f7ea2dd109e16fc596d0f522a",
      name: "Cybria",
      symbol: "CYBA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31694/thumb/Cybria_Logo_200x200.png?1696530512"
    },
    {
      chainId: 1,
      address: "0x485c665d8eeaca7987c48057ffd0591e2aaa797e",
      name: "Metamundo",
      symbol: "MMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31724/thumb/batch_MM_logo.png?1696530545"
    },
    {
      chainId: 1,
      address: "0x4ba942d56a3b95b03c0af7a91b7294e0e95271f4",
      name: "Super Cycle",
      symbol: "RICH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32754/thumb/SUPERCYCLE.png?1699265229"
    },
    {
      chainId: 1,
      address: "0xadd8abdea5cb95f4dcd8e128eeef64f023615a6a",
      name: "Cheezburger",
      symbol: "CHZB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32048/thumb/20230930_071301.jpg?1696530845"
    },
    {
      chainId: 1,
      address: "0xbc8b7ff89eb2b73ecdd579f81424a3b582200808",
      name: "Curve Inu",
      symbol: "CRVY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31759/thumb/0x7ojNgl_400x400.jpg?1696530578"
    },
    {
      chainId: 1,
      address: "0x03049b395147713ae53c0617093675b4b86dde78",
      name: "BobaCat",
      symbol: "PSPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31777/thumb/cg.png?1696530595"
    },
    {
      chainId: 1,
      address: "0x0c21638d4bcb88568f88bc84a50e317715f8de8a",
      name: "GrokDogeX",
      symbol: "GDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32756/thumb/GDX.jpg?1699280011"
    },
    {
      chainId: 1,
      address: "0x55a8f6c6b3aa58ad6d1f26f6afeded78f32e19f4",
      name: "Aegis Ai",
      symbol: "AEGIS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33169/thumb/UXDa3TDq_400x400.jpg?1700909114"
    },
    {
      chainId: 1,
      address: "0x4fbaf51b95b024d0d7cab575be2a1f0afedc9b64",
      name: "BONK on ETH",
      symbol: "BONK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37672/thumb/bonkethlogo_%282%29.png?1715186040"
    },
    {
      chainId: 1,
      address: "0x428487ad75dc9197cccb496629ab516974329dc1",
      name: "RealAliensEnjoyingLiquidity",
      symbol: "RAEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31735/thumb/rael_logo_%282%29.jpg?1696530554"
    },
    {
      chainId: 1,
      address: "0xdf2c7238198ad8b389666574f2d8bc411a4b7428",
      name: "Mainframe",
      symbol: "MFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3293/thumb/Mainframe_Token_Logo.png?1696504003"
    },
    {
      chainId: 1,
      address: "0x6d47a7be5d410910eef7ee2a3d34931f98f36812",
      name: "INDEX20",
      symbol: "I20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31737/thumb/200px.jpg?1696530556"
    },
    {
      chainId: 1,
      address: "0x4d9b0b7a6db042cb990d36a0df5aa2960e552f16",
      name: "Hpohs888inu",
      symbol: "TETHER",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31355/thumb/200xlogo.png?1696530172"
    },
    {
      chainId: 1,
      address: "0xdefcafe7eac90d31bbba841038df365de3c4e207",
      name: "0xDEFCAFE",
      symbol: "CAFE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31738/thumb/200x200.png?1696530557"
    },
    {
      chainId: 1,
      address: "0x93999d3fcab15cc052cf96b739580fc11e015944",
      name: "NoGas",
      symbol: "NGS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34049/thumb/0x93999d3fcab15cc052cf96b739580fc11e015944_%281%29.jpg?1703733938"
    },
    {
      chainId: 1,
      address: "0x5fe72ed557d8a02fff49b3b826792c765d5ce162",
      name: "Shezmu",
      symbol: "SHEZMU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31772/thumb/ShezmuPlainblk.png?1696530590"
    },
    {
      chainId: 1,
      address: "0x503cd987998824192578d0d7950148445667287c",
      name: "FOGnet",
      symbol: "FOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31743/thumb/fognet_logo_512-pso36yibc3wmls8sg2l5arxqptos6g1glqowa3rgik.png?1696530562"
    },
    {
      chainId: 1,
      address: "0x2c056f9402a0627bc0e580365bb12979fc011e2c",
      name: "Squid Game 2 0",
      symbol: "SQUID2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30932/thumb/SQUID2_LOGO_%28200x200%29.png?1696529774"
    },
    {
      chainId: 1,
      address: "0xbfabde619ed5c4311811cf422562709710db587d",
      name: "Diva Staking",
      symbol: "DIVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31792/thumb/2024-02-17_11.56.27.jpg?1709885558"
    },
    {
      chainId: 1,
      address: "0xd115a61a25c059c78cd34b97fab7ab25dfc84bc3",
      name: "Jesus",
      symbol: "RAPTOR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30745/thumb/Favicon_%281%29.png?1696529615"
    },
    {
      chainId: 1,
      address: "0x4c45bbec2ff7810ef4a77ad7bd4757c446fe4155",
      name: "Jungle Labz",
      symbol: "JNGL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31742/thumb/Jungle.png?1696530561"
    },
    {
      chainId: 1,
      address: "0x2de7b02ae3b1f11d51ca7b2495e9094874a064c0",
      name: "SHIB2",
      symbol: "SHIB2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31776/thumb/IMG_6344_2.jpg?1696530594"
    },
    {
      chainId: 1,
      address: "0x33349b282065b0284d756f0577fb39c158f935e6",
      name: "Maple",
      symbol: "MPL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14097/thumb/Maple_Logo_Mark_Maple_Orange.png?1696513819"
    },
    {
      chainId: 1,
      address: "0x18a3563c21062897950bb09339c82b9686a35667",
      name: "EtherNexus",
      symbol: "ENXS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29855/thumb/logo-circle.png?1696528781"
    },
    {
      chainId: 1,
      address: "0x089729b0786c8803cff972c16e402f3344d079ea",
      name: "BlockGPT",
      symbol: "BGPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30872/thumb/BLOCKEM_%282%29.png?1707925988"
    },
    {
      chainId: 1,
      address: "0xcdd0d11de0225b528b3a20d6436392c8260969d0",
      name: "Trade Bionic",
      symbol: "ONIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32357/thumb/9ca5f792-9bee-4d1f-942b-7ef09234510d_2.JPG?1697476642"
    },
    {
      chainId: 1,
      address: "0xd27b128dc6536309cdebf7f1aff0cb7717bc0268",
      name: "Etherempires",
      symbol: "ETE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31804/thumb/IMG_20230919_125717_505.png?1696530619"
    },
    {
      chainId: 1,
      address: "0x1af4f195a8aaa7ffd752c28a13b719b84056f0d6",
      name: "NFT Track Protocol",
      symbol: "NTP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27108/thumb/NTP_Symbol_CoinGecko.jpg?1696526161"
    },
    {
      chainId: 1,
      address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
      name: "Huobi",
      symbol: "HT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2822/thumb/huobi-token-logo.png?1696503584"
    },
    {
      chainId: 1,
      address: "0xcc09f34accdb36ee3ed98358a3b8a6ae5c29ea07",
      name: "Anon Web3",
      symbol: "AW3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31814/thumb/IMG_2336.png?1696530628"
    },
    {
      chainId: 1,
      address: "0x339e6c8d204b1aaa3fb74bc7ba15b9fb6648b7d2",
      name: "Omega Cloud",
      symbol: "OMEGA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35930/thumb/2024-03-10_00.16.57.jpg?1710225569"
    },
    {
      chainId: 1,
      address: "0xcdeb595293511115d9d9d44b189cc0da4a08cfaf",
      name: "Jellyfish Mobile",
      symbol: "JFISH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31879/thumb/jelly-fish-mix-white_%282%29.png?1696530691"
    },
    {
      chainId: 1,
      address: "0x5faa989af96af85384b8a938c2ede4a7378d9875",
      name: "Galxe",
      symbol: "GAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24530/thumb/galaxy.jpg?1696523708"
    },
    {
      chainId: 1,
      address: "0xd22a61e8503bea5842e5e0126ca9ffc4dd492084",
      name: "Strawberry Elephant",
      symbol: "",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31819/thumb/photo_2023-09-15_23-44-10.jpg?1696530633"
    },
    {
      chainId: 1,
      address: "0x561cf9121e89926c27fa1cfc78dfcc4c422937a4",
      name: "Squid Game",
      symbol: "SQUID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33074/thumb/photo_2023-11-17_14.18.23.jpeg?1700542677"
    },
    {
      chainId: 1,
      address: "0x9e18d5bab2fa94a6a95f509ecb38f8f68322abd3",
      name: "AMATERASU OMIKAMI",
      symbol: "OMIKAMI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31821/thumb/Omikami_BTC_AMZN.png?1696530635"
    },
    {
      chainId: 1,
      address: "0x5da151b95657e788076d04d56234bd93e409cb09",
      name: "OTSea",
      symbol: "OTSEA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31900/thumb/logo200x200.png?1712254528"
    },
    {
      chainId: 1,
      address: "0xce3ee7435a5bedbe73b92f39828b0cfd9d0ff568",
      name: "UniDexAI",
      symbol: "UDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35571/thumb/IMG_2678.png?1709193542"
    },
    {
      chainId: 1,
      address: "0xe2cfd7a01ec63875cd9da6c7c1b7025166c2fa2f",
      name: "Hyper",
      symbol: "HYPER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35931/thumb/C046D3BF-912C-4FE5-AEAD-6F1F2093AD92.png?1710225712"
    },
    {
      chainId: 1,
      address: "0x52d134c6db5889fad3542a09eaf7aa90c0fdf9e4",
      name: "Backed IBTA   Treasury Bond 1 3yr",
      symbol: "BIBTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31880/thumb/b-IBTA-200x200.png?1696530692"
    },
    {
      chainId: 1,
      address: "0x8bf30e9f44e5d068a9d0c20da22660997a532e33",
      name: "GhostDAG org",
      symbol: "GDAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33152/thumb/GD256.png?1700825767"
    },
    {
      chainId: 1,
      address: "0x162433c934aa74ba147e05150b1206b2c922f71d",
      name: "Creso  OLD ",
      symbol: "CRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32541/thumb/CRESO.png?1698473415"
    },
    {
      chainId: 1,
      address: "0x55b2cfcfe99110c773f00b023560dd9ef6c8a13b",
      name: "Index Coop CoinDesk ETH Trend Index",
      symbol: "CDETI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32358/thumb/cdETI-logo.png?1697940129"
    },
    {
      chainId: 1,
      address: "0x7d3b4f8d5dd14a0c263c4bee7be434c15e188d3e",
      name: "Moe",
      symbol: "MOE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32680/thumb/moe.png?1698934350"
    },
    {
      chainId: 1,
      address: "0x182c00807f2d4904d02d5e0d179600ff6a3ae67c",
      name: "BTEX",
      symbol: "BTEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31884/thumb/BTEX_200x200.png?1696530695"
    },
    {
      chainId: 1,
      address: "0xb48361032956d52f1ade21c73c273644f4ea24ca",
      name: "MOONERIUM",
      symbol: "MOONERIUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33081/thumb/200.png?1700552508"
    },
    {
      chainId: 1,
      address: "0xd6d9f4385bff8670d66a708b258969913619a673",
      name: "LEETCoin",
      symbol: "LEET",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32934/thumb/logo100.png?1699870536"
    },
    {
      chainId: 1,
      address: "0x33abe795f9c1b6136608c36db211bd7590f5fdae",
      name: "Landwolf",
      symbol: "WOLF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36996/thumb/stnMC5pk_400x400.jpg?1713027939"
    },
    {
      chainId: 1,
      address: "0x244748587f145c0571e92e85429d711d1b4cc43a",
      name: "Chooky",
      symbol: "CHOO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31833/thumb/Chooky_V2.png?1707776702"
    },
    {
      chainId: 1,
      address: "0x00c8555542158fff0feb892c8e000a8d1831762c",
      name: "Mori Finance",
      symbol: "MORI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31885/thumb/MORI.jpg?1696530696"
    },
    {
      chainId: 1,
      address: "0x41ea5d41eeacc2d5c4072260945118a13bb7ebce",
      name: "Creso",
      symbol: "CRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32954/thumb/CRE.jpg?1699941230"
    },
    {
      chainId: 1,
      address: "0xa1db57defd15be659cfbc612a13195adf5b237c6",
      name: "ManaCoin",
      symbol: "MNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31906/thumb/social-update.png?1696530715"
    },
    {
      chainId: 1,
      address: "0x9b5c38cc2d1ba05ed87c8f8a2418475bacb20073",
      name: "Vector Space Biosciences  Inc ",
      symbol: "SBIO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31837/thumb/Hex.png?1696530651"
    },
    {
      chainId: 1,
      address: "0x1b19c19393e2d034d8ff31ff34c81252fcbbee92",
      name: "OUSG",
      symbol: "OUSG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29023/thumb/OUSG.png?1696527993"
    },
    {
      chainId: 1,
      address: "0xb62e24b747eaa41454857cf6011832117df59cb8",
      name: "Epiko",
      symbol: "EPIKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31909/thumb/EPIKO_Light_200x200.png?1703118804"
    },
    {
      chainId: 1,
      address: "0x2df7d0e4903029717c949cad204075a3d75c8806",
      name: "Sweet",
      symbol: "SWEET",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31959/thumb/0x2df7d0e4903029717c949cad204075a3d75c8806.png?1696530765"
    },
    {
      chainId: 1,
      address: "0x697a79af2de4af9e9aa0d08905374556ad1353bb",
      name: "NinaPumps",
      symbol: "NINA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31910/thumb/pqT9YDIi_400x400-removebg-preview_%281%29.png?1696530718"
    },
    {
      chainId: 1,
      address: "0x0176b898e92e814c06cc379e508ceb571f70bd40",
      name: "Tipcoin",
      symbol: "TIP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31845/thumb/tip.png?1696530659"
    },
    {
      chainId: 1,
      address: "0xa6345ffadfa23dfc9014bce72ff2fa8712e54231",
      name: "Pepe Prophet",
      symbol: "KEK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31932/thumb/20231009_185537.png?1696963573"
    },
    {
      chainId: 1,
      address: "0xa1f830aa68b53fd3ee3bb86d7f8254e604740c8b",
      name: "ChainSwap",
      symbol: "CHAINS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32657/thumb/logo-cs_%281%29.png?1698899704"
    },
    {
      chainId: 1,
      address: "0x3419875b4d3bca7f3fdda2db7a476a79fd31b4fe",
      name: "DizzyHavoc",
      symbol: "DZHV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35575/thumb/dizzyhavoc_circle_3_200_200_transparentBg.png?1709194317"
    },
    {
      chainId: 1,
      address: "0x5713c26280647adad2f25bb54376943ecaa9d8e3",
      name: "Elon Xmas",
      symbol: "XMAS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33721/thumb/Elon_Xmas.png?1702885377"
    },
    {
      chainId: 1,
      address: "0x1abaea1f7c830bd89acc67ec4af516284b1bc33c",
      name: "EURC",
      symbol: "EURC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/26045/thumb/euro.png?1696525125"
    },
    {
      chainId: 1,
      address: "0x83e817e1574e2201a005ec0f7e700ed5606f555e",
      name: "mPendle",
      symbol: "MPENDLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31918/thumb/mPendle.png?1696530726"
    },
    {
      chainId: 1,
      address: "0xacc48f65f8701f376bc4ba13f4bc103f31dda74e",
      name: "Swift",
      symbol: "SWIFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31979/thumb/Safeimagekit-resized-img_%284%29.png?1696530782"
    },
    {
      chainId: 1,
      address: "0x1903be033d3e436dd79a8cf9030675bcf97ab589",
      name: "Be ikta ",
      symbol: "BJK",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/32038/thumb/BJK_200x200_2.png?1696530835"
    },
    {
      chainId: 1,
      address: "0x76af4cb74c8d4da51403d672a799e94b5958c230",
      name: "Feels Good Man",
      symbol: "GOOD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31980/thumb/Feels_Good_Man.png?1696530783"
    },
    {
      chainId: 1,
      address: "0x901ea3606d567f9f1e964639d5cbb8659080be8a",
      name: "CoinW",
      symbol: "CWT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31999/thumb/cwt_%281%29.jpeg?1696530800"
    },
    {
      chainId: 1,
      address: "0x40e9187078032afe1a30cfcf76e4fe3d7ab5c6c5",
      name: "AIgentX",
      symbol: "AIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31860/thumb/logo22.jpg?1698917072"
    },
    {
      chainId: 1,
      address: "0xddf688e96cb2531a69bf6347c02f069266c1aa81",
      name: "MEMEVENGERS",
      symbol: "MMVG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32000/thumb/MMVG.jpg?1696530801"
    },
    {
      chainId: 1,
      address: "0x32fd949e1953b21b7a8232ef4259cd708b4e0847",
      name: "HyperBC",
      symbol: "HBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32003/thumb/hbt_%281%29.png?1696530803"
    },
    {
      chainId: 1,
      address: "0x653aab62056b92641116d63927de6141d780e596",
      name: "Anchored Coins ACHF",
      symbol: "ACHF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33471/thumb/logo_achf.png?1701946601"
    },
    {
      chainId: 1,
      address: "0x667210a731447f8b385e068205759be2311b86d4",
      name: "ETF The Token",
      symbol: "ETF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31892/thumb/%E2%96%B2_%282%29.png?1696530703"
    },
    {
      chainId: 1,
      address: "0x64c79c8c59a2be17c8d651f73e5ee7942eebdc9e",
      name: "Elon Cat",
      symbol: "SCHRODINGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31893/thumb/png_%285%29_%281%29.png?1696530704"
    },
    {
      chainId: 1,
      address: "0xf1102d6d2a531124fa043d18a06c394a81aaa866",
      name: "Shiba Inu Classic",
      symbol: "SHIBC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31941/thumb/Shiba_Inu_Classic.png?1696530748"
    },
    {
      chainId: 1,
      address: "0x38f9bb135ea88033f4377b9ea0fb5cfb773fec2f",
      name: "Alpha Shards",
      symbol: "ALPHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32002/thumb/alpha_%281%29.jpeg?1696530802"
    },
    {
      chainId: 1,
      address: "0x4eea955f63d7e24ea7272651a29c7c70f7c2a9ae",
      name: "EastGate Pharmaceuticals",
      symbol: "EGP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31866/thumb/IMG_20230921_002259_489.jpg?1696530678"
    },
    {
      chainId: 1,
      address: "0x34ba042827996821cffeb06477d48a2ff9474483",
      name: "Shib2 0",
      symbol: "SHIB20",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/30940/thumb/unnamed.jpg?1696529779"
    },
    {
      chainId: 1,
      address: "0x20561172f791f915323241e885b4f7d5187c36e1",
      name: "Calcium",
      symbol: "CAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31971/thumb/callogo.jpg?1696530776"
    },
    {
      chainId: 1,
      address: "0x0e74a58557555cb44415df5a960d9eb14e96142a",
      name: "VegasBot",
      symbol: "VEGAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31983/thumb/logoblk.jpg?1696530786"
    },
    {
      chainId: 1,
      address: "0xda30f261a962d5aae94c9ecd170544600d193766",
      name: "Orbler",
      symbol: "ORBR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24056/thumb/orbr200.png?1696523246"
    },
    {
      chainId: 1,
      address: "0x642ac912a58428767fa14a26a749f9a1b001ba92",
      name: "XX",
      symbol: "XX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31972/thumb/200.png?1696530777"
    },
    {
      chainId: 1,
      address: "0x9f5e508182e1cbd23ea5ef65d1d6c342beb7d6d3",
      name: " JONES",
      symbol: "JONES",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34588/thumb/ALEX_JONES_LOGO_200px_CoinGecko.jpg?1705425283"
    },
    {
      chainId: 1,
      address: "0x015628ce9150db1bce2fbb717a09e846f8a32436",
      name: "Big Bonus Coin  ETH ",
      symbol: "BBC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32660/thumb/BBC-ETH-logo.png?1698900727"
    },
    {
      chainId: 1,
      address: "0x2ef8a2ccb058915e00e16aa13cc6e36f19d8893b",
      name: "ValiDAO",
      symbol: "VDO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33748/thumb/200x200.png?1712694763"
    },
    {
      chainId: 1,
      address: "0xeb935deb517e4c2abc282e5e251ed4d05db79e93",
      name: "Fort Block Games",
      symbol: "FBG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35354/thumb/photo_2024-02-18_10-27-38.jpg?1708360479"
    },
    {
      chainId: 1,
      address: "0xd09124e8a1e3d620e8807ad1d968021a5495cee8",
      name: "Eigenpie cbETH",
      symbol: "MCBETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37168/thumb/mcbETH.png?1713508013"
    },
    {
      chainId: 1,
      address: "0x0b38210ea11411557c13457d4da7dc6ea731b88a",
      name: "API3",
      symbol: "API3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13256/thumb/api3.jpg?1696513031"
    },
    {
      chainId: 1,
      address: "0xd8c0b13b551718b808fc97ead59499d5ef862775",
      name: "Gala Music",
      symbol: "MUSIC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/33472/thumb/gmusic.jpeg?1701947141"
    },
    {
      chainId: 1,
      address: "0x356e17967206efb413b60ab0ba44e269063a26c9",
      name: "Of Course I Still Love You",
      symbol: "OCISLY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32035/thumb/IMG_20230927_151428_156_%281%29.jpg?1696530831"
    },
    {
      chainId: 1,
      address: "0xfd4ca4a692f14d88af3e7ae13cf00d5095213b25",
      name: "Wiskers",
      symbol: "WSKR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32124/thumb/1.png?1696587384"
    },
    {
      chainId: 1,
      address: "0x0058c8581b9fed6864faa654505bc89890cdb2dd",
      name: "BabySmurf9000",
      symbol: "BS9000",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32088/thumb/logo2.png?1701897911"
    },
    {
      chainId: 1,
      address: "0x79c6ffe2ccbca761e9e289a69432bffb0b744876",
      name: "Pineapple Owl",
      symbol: "PINEOWL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32089/thumb/Pineapple_Owl_Logo_Alt.png?1696530887"
    },
    {
      chainId: 1,
      address: "0xa9c1eae6b76c09f84a89ff785ee4001a2b7294ce",
      name: "EchoBlock",
      symbol: "EBLOCK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36788/thumb/photo_2024-03-26_06-32-10.jpg?1712416695"
    },
    {
      chainId: 1,
      address: "0x4730fb1463a6f1f44aeb45f6c5c422427f37f4d0",
      name: "FOUR",
      symbol: "FOUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3434/thumb/FOUR.png?1696504127"
    },
    {
      chainId: 1,
      address: "0xfd1450a131599ff34f3be1775d8c8bf79e353d8c",
      name: "Shiba",
      symbol: "SHIBA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32299/thumb/IMG_20231011_081456_897.jpg?1697186075"
    },
    {
      chainId: 1,
      address: "0x6f91d21de4e40b3b80636b6b3ba425b636b798cf",
      name: "Wall Street Bets",
      symbol: "WSB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32095/thumb/GOoZ5azT_400x400.jpg?1696530893"
    },
    {
      chainId: 1,
      address: "0x8d85b9553896bd8159e608cb958628e01ed10916",
      name: "STONED",
      symbol: "STONED",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32108/thumb/TemA4ZCP_400x400.jpg?1696530904"
    },
    {
      chainId: 1,
      address: "0xa9d54f37ebb99f83b603cc95fc1a5f3907aaccfd",
      name: "Pikaboss",
      symbol: "PIKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32061/thumb/logocg.png?1696530858"
    },
    {
      chainId: 1,
      address: "0x87fdd1e031b356bdc1c55a3231cfe266552d8284",
      name: "PBM Coin",
      symbol: "PBMC",
      decimals: 14,
      logoURI: "https://assets.coingecko.com/coins/images/32063/thumb/PBM_Coin_%28Sep_23%29.png?1696530860"
    },
    {
      chainId: 1,
      address: "0x1cfa5641c01406ab8ac350ded7d735ec41298372",
      name: "Convertible JPY Token",
      symbol: "CJPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31356/thumb/CJPY_logo.png?1696530173"
    },
    {
      chainId: 1,
      address: "0x2c95d751da37a5c1d9c5a7fd465c1d50f3d96160",
      name: "WASSIE",
      symbol: "WASSIE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30144/thumb/logo-coingecko.png?1696529065"
    },
    {
      chainId: 1,
      address: "0x5aa158404fed6b4730c13f49d3a7f820e14a636f",
      name: "ULTRON",
      symbol: "ULX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26977/thumb/ULTRON-Profile-Pic.jpg?1696526031"
    },
    {
      chainId: 1,
      address: "0x95640a134721475bc78594c8ea66c0182c7b9a50",
      name: "Metroxynth",
      symbol: "MXH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34346/thumb/metroxynth-logo-200x200.png?1704698264"
    },
    {
      chainId: 1,
      address: "0x1236ea13c7339287cd00ab196aaa8217006b04dc",
      name: "Epic League",
      symbol: "EPL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32139/thumb/epl_symbol_200.png?1696591947"
    },
    {
      chainId: 1,
      address: "0xe063f04f280c60aeca68b38341c2eecbec703ae2",
      name: "f x  Protocol Leveraged ETH",
      symbol: "XETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32165/thumb/0xe063f04f280c60aeca68b38341c2eecbec703ae2.png?1696724194"
    },
    {
      chainId: 1,
      address: "0x365accfca291e7d3914637abf1f7635db165bb09",
      name: "f x  Protocol",
      symbol: "FXN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31889/thumb/FXN_200x200.png?1696530700"
    },
    {
      chainId: 1,
      address: "0x394d14d78850e516fa5eb88f843ef43196e136b0",
      name: "Dignity Gold",
      symbol: "DIGAU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37183/thumb/dignitygold_32.png?1713514309"
    },
    {
      chainId: 1,
      address: "0x170dec83c7753aaad20c01a0016b5a2e143990d4",
      name: "Wigger",
      symbol: "WIGGER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32128/thumb/SmartSelect_20231003_234100_Telegram.jpg?1696588180"
    },
    {
      chainId: 1,
      address: "0x6cf9788cda282aeb729477f6bda9c4db082b5746",
      name: "KingdomGame",
      symbol: "KINGDOM",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/32147/thumb/Kingdom200x200.png?1696596846"
    },
    {
      chainId: 1,
      address: "0x405154cfaf5ea4ef57b65b86959c73dd079fa312",
      name: "Alice AI",
      symbol: "ALICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36605/thumb/Alice_AI.png?1711964052"
    },
    {
      chainId: 1,
      address: "0xed1ddc491a2c8b1f7d6e8933580a47e124ea38db",
      name: "Intelligence On Chain",
      symbol: "IOC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32418/thumb/IMG_20231017_174915_959.jpg?1698116981"
    },
    {
      chainId: 1,
      address: "0x9aaf731799e824a74a4d3a14e6b00bcc28c327db",
      name: "Jable",
      symbol: "JAB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32131/thumb/Jab.png?1696588461"
    },
    {
      chainId: 1,
      address: "0x583019ff0f430721ada9cfb4fac8f06ca104d0b4",
      name: "Staked Yearn Ether",
      symbol: "ST-YETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32222/thumb/st-yETH-128px.png?1696914941"
    },
    {
      chainId: 1,
      address: "0x34dce75a3d1910cc9d188aa5a75fb9addcae0fcc",
      name: "XV",
      symbol: "XV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33432/thumb/XV_Token_logo_black_background_200_by_200.png?1701818327"
    },
    {
      chainId: 1,
      address: "0x4f27633e8b1cfd5e043c68cdcd81c0bbfdb1cf14",
      name: "WhatBot",
      symbol: "WHAT",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xb39364b51d2c97b62b838bc5213b8627eb469101",
      name: "Swot AI",
      symbol: "SWOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35281/thumb/HLL21bqf_400x400_%281%29.jpg?1708054966"
    },
    {
      chainId: 1,
      address: "0x36737b4ac153c762d6a767056e1af7b17573a6b9",
      name: "GOLD",
      symbol: "GOLD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32155/thumb/LOGO.jpg?1696598967"
    },
    {
      chainId: 1,
      address: "0x53805a76e1f5ebbfe7115f16f9c87c2f7e633726",
      name: "f x  Protocol Fractional ETH",
      symbol: "FETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32166/thumb/0x53805a76e1f5ebbfe7115f16f9c87c2f7e633726.png?1696724197"
    },
    {
      chainId: 1,
      address: "0xf0610eb7d8ee12d59412da32625d5e273e78ff0b",
      name: "MasterDEX",
      symbol: "MDEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32311/thumb/MASTERDEX_logo-02_%282%29.png?1697188983"
    },
    {
      chainId: 1,
      address: "0x257508ca6341337dd243d54afd964e19375b4af9",
      name: "Oracle Tools",
      symbol: "OT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35582/thumb/IMG_2695.png?1709202522"
    },
    {
      chainId: 1,
      address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
      name: "Reserve Rights",
      symbol: "RSR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8365/thumb/rsr.png?1696508558"
    },
    {
      chainId: 1,
      address: "0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697",
      name: "Ovr",
      symbol: "OVR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13429/thumb/LOGO-OVER-ICON-200X200PX.png?1699396496"
    },
    {
      chainId: 1,
      address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
      name: "Dusk",
      symbol: "DUSK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5217/thumb/image_widget_biddfvxd454b1.png?1696505726"
    },
    {
      chainId: 1,
      address: "0x10f2cf6ef155460c5b716080eb57928652867f2e",
      name: "Alan Musk",
      symbol: "MUSK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32262/thumb/28422.png?1707509906"
    },
    {
      chainId: 1,
      address: "0xa338b5a4bbd8053994bb6c55d770fc2447d66b88",
      name: "Emerging Assets Group",
      symbol: "EAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32265/thumb/0xa338b5a4bbd8053994bb6c55d770fc2447d66b88_%281%29.png?1697029815"
    },
    {
      chainId: 1,
      address: "0xee3c722d177559f73288cec91fa3e4bbfd8c27fc",
      name: "Douglas Adams",
      symbol: "HHGTTG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32837/thumb/HHGTTG200.jpg?1706880868"
    },
    {
      chainId: 1,
      address: "0x82967568a57625675b260ebab1294038c9accc6e",
      name: "Nova DAO",
      symbol: "NOVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34464/thumb/200x200_nova.png?1704965570"
    },
    {
      chainId: 1,
      address: "0xbe1dbe6741fb988fb571ab1e28cffb36e3c62629",
      name: "Massive Protocol",
      symbol: "MAV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25134/thumb/logo.png?1696524284"
    },
    {
      chainId: 1,
      address: "0xf7c1caaa2b29458e8f9a6c45348e385351971209",
      name: "Parobot",
      symbol: "PARO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36997/thumb/1ty3P5iC_400x400.jpg?1713029362"
    },
    {
      chainId: 1,
      address: "0xb504035a11e672e12a099f32b1672b9c4a78b22f",
      name: "SAFEREUM",
      symbol: "SAFEREUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32179/thumb/FD173148-2002-420F-B138-E8DB70F754A0.png?1696743020"
    },
    {
      chainId: 1,
      address: "0xa922a70569a7555518bf4ded5094661a965e23ca",
      name: "MN Bridge",
      symbol: "MNB",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32199/thumb/MNB.jpg?1696745894"
    },
    {
      chainId: 1,
      address: "0x0eb1e72204c42de2263d37db606fb25c21d649b8",
      name: "Astro X",
      symbol: "ASTROX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34465/thumb/logo_astro_x-01.png?1704965967"
    },
    {
      chainId: 1,
      address: "0x6b448aeb3bfd1dcbe337d59f6dee159daab52768",
      name: "Resistor AI",
      symbol: "TOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36790/thumb/logo-square.png?1712418946"
    },
    {
      chainId: 1,
      address: "0xc581b735a1688071a1746c968e0798d642ede491",
      name: "Euro Tether",
      symbol: "EURT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/17385/thumb/Tether_new.png?1696516934"
    },
    {
      chainId: 1,
      address: "0x556bb0b27e855e6f2cebb47174495b9bbeb97ff1",
      name: "Ctrl",
      symbol: "CTRL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33356/thumb/ctrl_200x200.png?1701600824"
    },
    {
      chainId: 1,
      address: "0x38e382f74dfb84608f3c1f10187f6bef5951de93",
      name: "Multibit",
      symbol: "MUBI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33051/thumb/multi.jpg?1700473994"
    },
    {
      chainId: 1,
      address: "0x34bc13de8e5124a7c47d4b7ff7c5ade6ee34faba",
      name: "Project Dojo",
      symbol: "DOJO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33156/thumb/Project_Dojo_logo_transparent_200x200.png?1700827030"
    },
    {
      chainId: 1,
      address: "0x3d000462fb9826804a45c0ea869b83b69587f2db",
      name: "Spatial Computing",
      symbol: "CMPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35780/thumb/Spatial_%281%29.jpeg?1709812474"
    },
    {
      chainId: 1,
      address: "0x8c282c35b5e1088bb208991c151182a782637699",
      name: "Monai",
      symbol: "MONAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35661/thumb/2024-03-02_02.02.09.png?1709453630"
    },
    {
      chainId: 1,
      address: "0x0a8f4c4f23d72857745e26695dcd8dedf8e349b9",
      name: "Marksman",
      symbol: "MARKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33658/thumb/mlogo.png?1702598130"
    },
    {
      chainId: 1,
      address: "0x76e222b07c53d28b89b0bac18602810fc22b49a8",
      name: "Joe Coin",
      symbol: "JOE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32333/thumb/joe.png?1697452551"
    },
    {
      chainId: 1,
      address: "0xd721706581d97ecd202bbab5c71b5a85f0f78e69",
      name: "DOGE 1",
      symbol: "DOGE1",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32298/thumb/200.png?1697185878"
    },
    {
      chainId: 1,
      address: "0xe0a458bf4acf353cb45e211281a334bb1d837885",
      name: "4Chan",
      symbol: "4CHAN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30124/thumb/4CHAN.png?1696529046"
    },
    {
      chainId: 1,
      address: "0xb58e26ac9cc14c0422c2b419b0ca555ee4dcb7cb",
      name: "Niza Global",
      symbol: "NIZA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32328/thumb/NizaCoin-logo-transaprent.png?1697451581"
    },
    {
      chainId: 1,
      address: "0xb70835d7822ebb9426b56543e391846c107bd32c",
      name: "Game",
      symbol: "GTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2046/thumb/game.png?1696503014"
    },
    {
      chainId: 1,
      address: "0x87d907568a0761ea45d2917e324557920668f224",
      name: "Grok2 0",
      symbol: "GROK20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32942/thumb/G2C_200px.jpeg?1699874312"
    },
    {
      chainId: 1,
      address: "0x44971abf0251958492fee97da3e5c5ada88b9185",
      name: "BasedAI",
      symbol: "BASEDAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36607/thumb/1000004475.png?1711964332"
    },
    {
      chainId: 1,
      address: "0x8390a1da07e376ef7add4be859ba74fb83aa02d5",
      name: "Grok",
      symbol: "GROK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32788/thumb/GROK.png?1707579427"
    },
    {
      chainId: 1,
      address: "0x4507cef57c46789ef8d1a19ea45f4216bae2b528",
      name: "TokenFi",
      symbol: "TOKEN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32507/thumb/MAIN_TokenFi_logo_icon.png?1698918427"
    },
    {
      chainId: 1,
      address: "0xdddddd4301a082e62e84e43f474f044423921918",
      name: "Rhino fi",
      symbol: "DVF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16414/thumb/rhinologo.png?1697736807"
    },
    {
      chainId: 1,
      address: "0x8f0f56472c3e5730b1ea2f444e7829288da261e6",
      name: "Rogue MAV",
      symbol: "RMAV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32384/thumb/rMAV.png?1698045143"
    },
    {
      chainId: 1,
      address: "0x77777feddddffc19ff86db637967013e6c6a116c",
      name: "Tornado Cash",
      symbol: "TORN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13496/thumb/ZINt8NSB_400x400.jpg?1696513257"
    },
    {
      chainId: 1,
      address: "0xc7c53760375530e5af29fded5e13989325299382",
      name: "WORLD PEACE COIN",
      symbol: "WPC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32331/thumb/image01_%282%29_2.jpg?1697452381"
    },
    {
      chainId: 1,
      address: "0xcac1277aa6ecb68b84fad070910d37029e810b79",
      name: "BitDelta",
      symbol: "BDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36609/thumb/200x200_BDT.png?1711973432"
    },
    {
      chainId: 1,
      address: "0x1a2eb478fa07125c9935a77b3c03a82470801e30",
      name: "Amino",
      symbol: "AMO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32677/thumb/IMG_6956.png?1698920127"
    },
    {
      chainId: 1,
      address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
      name: "Polygon",
      symbol: "MATIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4713/thumb/polygon.png?1698233745"
    },
    {
      chainId: 1,
      address: "0x276e84edc5bd94731b65c207dc1512fc5391572f",
      name: "Potion Exchange",
      symbol: "PTN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33475/thumb/output-onlinepngtools_%289%29.png?1702013459"
    },
    {
      chainId: 1,
      address: "0xb14ebf566511b9e6002bb286016ab2497b9b9c9d",
      name: "Hypersign Identity",
      symbol: "HID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16158/thumb/hypersign.png?1696515762"
    },
    {
      chainId: 1,
      address: "0x13c4aa5c3f5bb1109c267e520a87c89684d3e73c",
      name: "Verify Authentificator Bot",
      symbol: "VERIFY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32845/thumb/logo.png?1699589566"
    },
    {
      chainId: 1,
      address: "0x2534588fa8ecddf160c6c0ae7d62523604df0a75",
      name: "Arcade Arcoin",
      symbol: "ARCN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33476/thumb/2023-12-06_16.34.14.jpg?1702013632"
    },
    {
      chainId: 1,
      address: "0x686d1596e5632fe0471961e7977e8efe371b0b21",
      name: "SurrealVerse",
      symbol: "AZEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32448/thumb/IMG_3734.jpeg?1698239938"
    },
    {
      chainId: 1,
      address: "0xeda43fa2f35ea174a7e9b73658b18a7da00adf38",
      name: "Namx",
      symbol: "NAMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32437/thumb/Screenshot_2023-10-18_at_13.20.36.png?1698226504"
    },
    {
      chainId: 1,
      address: "0xf017d3690346eb8234b85f74cee5e15821fee1f4",
      name: "GEKKO",
      symbol: "GEKKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32439/thumb/gekko_%281%29.png?1698228341"
    },
    {
      chainId: 1,
      address: "0x455e53cbb86018ac2b8092fdcd39d8444affc3f6",
      name: "Polygon Ecosystem Token",
      symbol: "POL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32440/thumb/polygon.png?1698233684"
    },
    {
      chainId: 1,
      address: "0xae3359ed3c567482fb0102c584c23daa2693eacf",
      name: "DORK",
      symbol: "DORK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32704/thumb/Coin_2.png?1698985483"
    },
    {
      chainId: 1,
      address: "0x390e61f798267fe7aa9bbe61be8bb1776250d44c",
      name: "T2T2",
      symbol: "T2T2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32856/thumb/T2T2.png?1699697712"
    },
    {
      chainId: 1,
      address: "0x0257ffd7ea2ebba4aaa090c7adbdd032a08c1f74",
      name: "ZELIX",
      symbol: "ZELIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32453/thumb/ZX_Logo_20230724_200x200.png?1701866637"
    },
    {
      chainId: 1,
      address: "0x7a8946eda77817126ffe301249f6dc4c7df293c3",
      name: "Dyl",
      symbol: "DYL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32550/thumb/Dyl-pfp-200x.png?1698479973"
    },
    {
      chainId: 1,
      address: "0xd1f17b7a6bff962659ed608bcd6d318bb5fbb249",
      name: "Zuzalu Inu",
      symbol: "ZUZALU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34552/thumb/zuzalu_0xd1f17b7a6bff962659ed608bcd6d318bb5fbb2491705497250930.jpg?1706250673"
    },
    {
      chainId: 1,
      address: "0x0ee27a1f959ea7ea2aa171a7e2e48fd9f17bb8eb",
      name: "First GROK AI",
      symbol: "GROK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33005/thumb/Untitled_design_%2829%29.png?1700122635"
    },
    {
      chainId: 1,
      address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
      name: "PowerPool Concentrated Voting Power",
      symbol: "CVP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12266/thumb/Powerpool.jpg?1696512097"
    },
    {
      chainId: 1,
      address: "0xff00644ca76def7a3f7501a281ffe45934aefbfe",
      name: "Shadow Wizard Money Gang",
      symbol: "GANG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32452/thumb/logo.png?1698240659"
    },
    {
      chainId: 1,
      address: "0xd939212f16560447ed82ce46ca40a63db62419b5",
      name: "Mega Yacht Cult",
      symbol: "MYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32456/thumb/Untitled_design_%283%29_%281%29.png?1698241312"
    },
    {
      chainId: 1,
      address: "0x27c57f84236780881be694a18e149bb5bb78c21f",
      name: "LiquidityRush",
      symbol: "LIQR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34846/thumb/liqr_%281%29.jpg?1706254692"
    },
    {
      chainId: 1,
      address: "0xbeef8e0982874e0292e6c5751c5a4092b3e1beef",
      name: "Staked BIFI",
      symbol: "MOOBIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32597/thumb/319381e63428d3c2ab6e035d5f3abd76.png?1698682355"
    },
    {
      chainId: 1,
      address: "0x746dda2ea243400d5a63e0700f190ab79f06489e",
      name: "BOSagora",
      symbol: "BOA",
      decimals: 7,
      logoURI: "https://assets.coingecko.com/coins/images/9202/thumb/Picture1.png?1696509320"
    },
    {
      chainId: 1,
      address: "0x4c746edf20762dc201ac40135e0c13e400d23d58",
      name: "GOD Coin",
      symbol: "GOD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33360/thumb/_kJ-LILu_400x400.jpg?1701603268"
    },
    {
      chainId: 1,
      address: "0x72831eebef4e3f3697a6b216e3713958210ae8cd",
      name: "Blob",
      symbol: "BLOB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35309/thumb/Blob.jpeg?1708158035"
    },
    {
      chainId: 1,
      address: "0x96f6ef951840721adbf46ac996b59e0235cb985c",
      name: "Ondo US Dollar Yield",
      symbol: "USDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31700/thumb/usdy_%281%29.png?1696530524"
    },
    {
      chainId: 1,
      address: "0xa444ec96ee01bb219a44b285de47bf33c3447ad5",
      name: "LEOX",
      symbol: "LEOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29980/thumb/LEOX-LOGO-BLACK-2.jpg?1696528905"
    },
    {
      chainId: 1,
      address: "0x01194726b1b55bbf99cb083ba8e5dcc0834adbc3",
      name: "ArcadeFi",
      symbol: "ARCADE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35504/thumb/IMG_8212.jpeg?1708935437"
    },
    {
      chainId: 1,
      address: "0x7cdbfc86a0bfa20f133748b0cf5cea5b787b182c",
      name: "TokenSight",
      symbol: "TKST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32514/thumb/token-coingecko.png?1698401758"
    },
    {
      chainId: 1,
      address: "0x1123d17fcf93ed2b41440317503346a0fdfe3ed7",
      name: "Prometheum Prodigy",
      symbol: "PMPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32522/thumb/IMG_1277.jpeg?1708596900"
    },
    {
      chainId: 1,
      address: "0x9f4a8167ca311a87b0d03aafa44e0d2c3d8a3631",
      name: "BlockBox",
      symbol: "BBOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32521/thumb/IMG_0229.jpeg?1698407087"
    },
    {
      chainId: 1,
      address: "0xf1dba5c1972778763409447d9adedabbbeb177c1",
      name: "GEXC FINANCE",
      symbol: "GEXC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35505/thumb/gexc200.png?1708935648"
    },
    {
      chainId: 1,
      address: "0xabd601423a2cd5723cb546acc5c40fb01c3422cf",
      name: "Baby X",
      symbol: "BABYX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32525/thumb/topimg.png?1698411093"
    },
    {
      chainId: 1,
      address: "0x617ead3c59ded3ea1bb17881118cf310144b450f",
      name: "The Secret Coin",
      symbol: "TSC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32545/thumb/IMG_2160.jpeg?1698474245"
    },
    {
      chainId: 1,
      address: "0x67f3086f7823eaf35f5aaadfb2e9b9c5b09578cf",
      name: "InsightX",
      symbol: "INX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32552/thumb/android-chrome-192x192.png?1698480297"
    },
    {
      chainId: 1,
      address: "0x02e7f808990638e9e67e1f00313037ede2362361",
      name: "KiboShib",
      symbol: "KIBSHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29335/thumb/foto_no_exif_%2811%29%282%29_%281%29.png?1696528285"
    },
    {
      chainId: 1,
      address: "0x0080428794a79a40ae03cf6e6c1d56bd5467a4a2",
      name: "LONG  ETH ",
      symbol: "LONG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32559/thumb/IMG_20231005_122433_189.jpg?1698544869"
    },
    {
      chainId: 1,
      address: "0x5df2aa6d903410b2a747c90dbf2de0de7b15ac60",
      name: "0xgambit",
      symbol: "0XG",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32579/thumb/logo.png?1698558743"
    },
    {
      chainId: 1,
      address: "0x2b91c5a73b7c4a70a61536429a2bf45461d85b27",
      name: "Riggers",
      symbol: "RIG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35159/thumb/Rigger_transparent.png?1707567408"
    },
    {
      chainId: 1,
      address: "0x7e877b99897d514da01bd1d177e693ec639961af",
      name: "Oggy Inu  ETH ",
      symbol: "OGGY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32619/thumb/Oggy_logo_200x200.png?1698756117"
    },
    {
      chainId: 1,
      address: "0xbb9fd9fa4863c03c574007ff3370787b9ce65ff6",
      name: "HILO",
      symbol: "HILO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28661/thumb/cmchiloo.png?1696527646"
    },
    {
      chainId: 1,
      address: "0x961c8c0b1aad0c0b10a51fef6a867e3091bcef17",
      name: "Dypius  OLD ",
      symbol: "DYP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13480/thumb/DYP-200x200px.png?1696513241"
    },
    {
      chainId: 1,
      address: "0xd51e4965ad973e8c1e1f22369bb884e6914b012c",
      name: "ZenoCard",
      symbol: "ZENO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36529/thumb/IMG_20240324_220958_106_%281%29.png?1711700883"
    },
    {
      chainId: 1,
      address: "0xd12b2859227b88c8065b6216e6e1b980d8dfe152",
      name: "SatNode",
      symbol: "SND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35214/thumb/New_Project_%283%29_%281%29.png?1707898354"
    },
    {
      chainId: 1,
      address: "0x8ed955a2b7d2c3a17a9d05daca95e01818f8c11e",
      name: "APF coin",
      symbol: "APFC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30990/thumb/photo_2023-10-28_09-48-25.jpg?1698518912"
    },
    {
      chainId: 1,
      address: "0xa8c08d8bb15a2d1a4d3b78def9c635ef1e340e16",
      name: "SERBIAN DANCING LADY",
      symbol: "",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32688/thumb/IMG_20231101_105021_023.jpg?1698938977"
    },
    {
      chainId: 1,
      address: "0x6c74ebb3d9b4a1e77558f1871cd9c8ef07b4dfb2",
      name: "The Autism Token",
      symbol: "TISM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32794/thumb/tism_logo_resized.png?1699445572"
    },
    {
      chainId: 1,
      address: "0x745407c86df8db893011912d3ab28e68b62e49b0",
      name: "MahaDAO",
      symbol: "MAHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13404/thumb/MAHA_Token.png?1696513166"
    },
    {
      chainId: 1,
      address: "0xe785ec36356b973d8c0a071d478940d6f42c0178",
      name: "Bigfoot Monster",
      symbol: "BIGF",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/32795/thumb/Safeimagekit-resized-img_%284%29.png?1699445622"
    },
    {
      chainId: 1,
      address: "0x6ae2a128cd07d672164ca9f2712ea737d198dd41",
      name: "Goat Trading",
      symbol: "GOAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35160/thumb/logo-light1.png?1707569994"
    },
    {
      chainId: 1,
      address: "0x39b46b212bdf15b42b166779b9d1787a68b9d0c3",
      name: "Dypius",
      symbol: "DYP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33016/thumb/RS-zDhFE_400x400.jpg?1700157370"
    },
    {
      chainId: 1,
      address: "0xd1e64bcc904cfdc19d0faba155a9edc69b4bcdae",
      name: "Pikamoon",
      symbol: "PIKA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36366/thumb/Pikamoon.png?1711336684"
    },
    {
      chainId: 1,
      address: "0xd0a6053f087e87a25dc60701ba6e663b1a548e85",
      name: "BLOCKLORDS",
      symbol: "LRDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34775/thumb/LRDS_PNG.png?1706001771"
    },
    {
      chainId: 1,
      address: "0x201b5b64438843553e3c3671810ae671c93c685c",
      name: "Megabot",
      symbol: "MEGABOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32796/thumb/Megabot.jpg?1699445692"
    },
    {
      chainId: 1,
      address: "0x6d5777dce2541175adf6d49cadd666f3ab0ac142",
      name: "Cartman",
      symbol: "CARTMAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32797/thumb/2023-11-02_20.50.51.jpg?1699445925"
    },
    {
      chainId: 1,
      address: "0x0f4dc5ada841cf5a7652e52d04ae786070cc9472",
      name: "Aktionariat Green Monkey Club AG Tokeni",
      symbol: "GMCS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33366/thumb/GMCS.png?1701613728"
    },
    {
      chainId: 1,
      address: "0xbe6be64e9e5042b6e84e4c27956cce6353efa5f5",
      name: "Beg",
      symbol: "BEG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32799/thumb/beg100px.png?1699446876"
    },
    {
      chainId: 1,
      address: "0xcd54df3c19a7ae672897f2a09821d2c287d36326",
      name: "Baby Memecoin",
      symbol: "BABYMEME",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32838/thumb/bd0e18c5-ac94-424b-a6ea-9d654770be1f-18213305.png?1699587642"
    },
    {
      chainId: 1,
      address: "0xb71bdc7014f3740d0267d41d632cab8371f8ba3c",
      name: "MILEI",
      symbol: "MILEI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33489/thumb/IMG_7308.png?1702029479"
    },
    {
      chainId: 1,
      address: "0x973e00eee6d180b5a0eb08ce3047ac4ea7a45cd5",
      name: "TOTO",
      symbol: "TOTO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35215/thumb/200X200.png?1707898793"
    },
    {
      chainId: 1,
      address: "0x9d67d207b0cbdbd6dc50f465555cc777bd51159e",
      name: "Useless Utility",
      symbol: "UU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33368/thumb/0x9d67d207b0cbdbd6dc50f465555cc777bd51159e.png?1701619663"
    },
    {
      chainId: 1,
      address: "0x80592d613a383f2ba3c42e4c247067289ee60152",
      name: "TurboBot",
      symbol: "TURBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32747/thumb/FFxY5qST_400x400.jpeg?1699262654"
    },
    {
      chainId: 1,
      address: "0x7df18e4efd6e6f73cfb462937dac40fe42533016",
      name: "ZKitty Bot",
      symbol: "ZKITTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31474/thumb/AnN0reNi_400x400.jpg?1696530286"
    },
    {
      chainId: 1,
      address: "0x614da3b37b6f66f7ce69b4bbbcf9a55ce6168707",
      name: "MMX",
      symbol: "MMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33161/thumb/mmx.png?1700830276"
    },
    {
      chainId: 1,
      address: "0xbd713f15673b9861b6123840f6e0eba03d6aae51",
      name: "Eyebot",
      symbol: "EYEBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33369/thumb/IMG_0672.jpeg?1701619837"
    },
    {
      chainId: 1,
      address: "0x26f9111a358385dc46a832cf1a1a021ee72e58a1",
      name: "Zook Protocol",
      symbol: "ZOOK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32706/thumb/20231102_124343.jpg?1698985803"
    },
    {
      chainId: 1,
      address: "0xa2fe5e51729be71261bcf42854012827bc44c044",
      name: "BURN",
      symbol: "BURN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32652/thumb/Burn.jpg?1698895268"
    },
    {
      chainId: 1,
      address: "0x1783d3979038d986f3959adf7dbfc527f42c4269",
      name: "Utopia Bot",
      symbol: "UB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32718/thumb/CG_Transparent_Logo_200x200.png?1699001180"
    },
    {
      chainId: 1,
      address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
      name: "Lido Staked Ether",
      symbol: "STETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13442/thumb/steth_logo.png?1696513206"
    },
    {
      chainId: 1,
      address: "0xf3e66b03d098d0482be9cb3d6999787231a93ed9",
      name: "PromptIDE",
      symbol: "PROMPTIDE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32753/thumb/PromptIDE_Logo_%283%29.jpg?1707469846"
    },
    {
      chainId: 1,
      address: "0x13630da53ac2f3004e6e2a127546935ad932f92f",
      name: "Wagyu",
      symbol: "WAGYU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33295/thumb/200x200.png?1701401886"
    },
    {
      chainId: 1,
      address: "0xbf19eead55a6b100667f04f8fbc5371e03e8ab2e",
      name: "Inception cbETH",
      symbol: "INCBETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34948/thumb/cbETH.png?1706770383"
    },
    {
      chainId: 1,
      address: "0xb61ebb6bceb7635ecd7e59884ee2e2bcdfd810ba",
      name: "XSHIB",
      symbol: "XSHIB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32839/thumb/LOGOSHIB.jpg?1699587693"
    },
    {
      chainId: 1,
      address: "0x753cd33a41a7b4857681ab2498ce66ae977aa3de",
      name: "VaxLabs",
      symbol: "VLABS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35311/thumb/vaxlab_png-tbg.png?1708158748"
    },
    {
      chainId: 1,
      address: "0x99cffb50aad37d17955253f3a4070556b5127a0b",
      name: "MEGALODON",
      symbol: "MEGA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33371/thumb/mega.jpg?1701620157"
    },
    {
      chainId: 1,
      address: "0x1e7a53220c128d100b56970ce88ee963a9511370",
      name: "PNPCoin",
      symbol: "PNPC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33520/thumb/PNPC-200.png?1702133448"
    },
    {
      chainId: 1,
      address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
      name: "Wrapped Bitcoin",
      symbol: "WBTC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/7598/thumb/wrapped_bitcoin_wbtc.png?1696507857"
    },
    {
      chainId: 1,
      address: "0xda9b11cd701e10c2ec1a284f80820edd128c5246",
      name: "Inception wbETH",
      symbol: "INWBETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34944/thumb/WBETH.png?1706757148"
    },
    {
      chainId: 1,
      address: "0x47879db9e657e644082071b48e2f33d80f369f02",
      name: "XINU  ETH ",
      symbol: "XINU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32712/thumb/xinu.jpg?1699000456"
    },
    {
      chainId: 1,
      address: "0x4e1a609ec87cf6477613f515f6eb64ef2d31089a",
      name: "Aktionariat Green Consensus AG Tokenize",
      symbol: "DGCS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33372/thumb/GCS.png?1701648529"
    },
    {
      chainId: 1,
      address: "0xd9dcd611bed2be9a4700c725a3810870b9bff094",
      name: "MaxxChain",
      symbol: "PWR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31321/thumb/PWR_Logo_200x200.jpg?1696530140"
    },
    {
      chainId: 1,
      address: "0x83f5b9c25cc8fce0a7d4a1bda904bf13cfcdd9da",
      name: "FP  DeGods",
      symbol: "UDEGODS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32765/thumb/degods_%281%29.png?1699332561"
    },
    {
      chainId: 1,
      address: "0x8ab98330473101309db94b625f9997366a518223",
      name: "PlasticHero",
      symbol: "PTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32771/thumb/Ticker_%282%29.png?1699343244"
    },
    {
      chainId: 1,
      address: "0xa100eafdef0099700933538ee795cfad5505b689",
      name: "FP  Captainz",
      symbol: "UCAPTAINZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32775/thumb/Captains.png?1699347464"
    },
    {
      chainId: 1,
      address: "0x6cd7fc3118a8ffa40af0f99f3cbda54b0c6d4d1d",
      name: "FP  Milady",
      symbol: "UMIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32768/thumb/milady_logo.9816562c.png?1699337545"
    },
    {
      chainId: 1,
      address: "0xbc526a4ae9632d42291ad9d5ef29d36dd4d0ce26",
      name: "FP  MoonBirds",
      symbol: "UMOONBIRDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32777/thumb/mmoonbirds_%281%29.png?1699348940"
    },
    {
      chainId: 1,
      address: "0xa07dcc1abfe20d29d87a32e2ba89876145dafb0a",
      name: "FP  Doodle",
      symbol: "UDOODLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32776/thumb/mdoodle_%281%29.png?1699348365"
    },
    {
      chainId: 1,
      address: "0x36a17b52b5322846fcf894ee1535c8aa23df6765",
      name: "FP  Potatoz",
      symbol: "UPOTATOZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32779/thumb/mpotatoz_%282%29.png?1699350069"
    },
    {
      chainId: 1,
      address: "0xae05559e5bc86ecca132956fa0482dd7d4b2d76d",
      name: "FP  CloneX",
      symbol: "UCLONEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32767/thumb/clonex_logo.30687847_%281%29.png?1699336155"
    },
    {
      chainId: 1,
      address: "0xedae06a2dbdd21038608adce58fd173afdba5add",
      name: "FP  LilPudgys",
      symbol: "ULP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32782/thumb/lp_%281%29.png?1699351240"
    },
    {
      chainId: 1,
      address: "0x9f83ed4fdf636e8b0562ac704267346712b44c36",
      name: "FP  Mfers",
      symbol: "UMFER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32783/thumb/mfer_%281%29.png?1699351834"
    },
    {
      chainId: 1,
      address: "0xf59ae934f6fe444afc309586cc60a84a0f89aaea",
      name: "Polkadex",
      symbol: "PDEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14833/thumb/dIze5Ztl_400x400.jpg?1696514500"
    },
    {
      chainId: 1,
      address: "0x34635280737b5bfe6c7dc2fc3065d60d66e78185",
      name: "Convex Prisma",
      symbol: "CVXPRISMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32961/thumb/cvxprisma.png?1700026172"
    },
    {
      chainId: 1,
      address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
      name: "Automata",
      symbol: "ATA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15985/thumb/ATA.jpg?1696515598"
    },
    {
      chainId: 1,
      address: "0xf19308f923582a6f7c465e5ce7a9dc1bec6665b1",
      name: "TitanX",
      symbol: "TITANX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32762/thumb/TitanXpng_%281%29.png?1704456654"
    },
    {
      chainId: 1,
      address: "0x8c3d11360a70fb708762b394be8ef23e3a633e3f",
      name: "FP  BoredApeKennelClub",
      symbol: "UBAKC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32778/thumb/UBAKC_%281%29.png?1699349512"
    },
    {
      chainId: 1,
      address: "0x433fb346139e4eb5e513ae5fd77bd98614b153b1",
      name: "FP  Beanz",
      symbol: "UBEANZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32784/thumb/beanz_%281%29.png?1699352128"
    },
    {
      chainId: 1,
      address: "0x4fa5836b58d6f1877a616e7833c7350781e21202",
      name: "FP  Otherdeed",
      symbol: "UOTHR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32766/thumb/othr_%281%29.png?1699332911"
    },
    {
      chainId: 1,
      address: "0xc57bf43f8ca4458309386f9a3e8246a8cadcca51",
      name: "DOXcoin",
      symbol: "DOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36857/thumb/201.png?1712641116"
    },
    {
      chainId: 1,
      address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
      name: "Loopring",
      symbol: "LRC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/913/thumb/LRC.png?1696502034"
    },
    {
      chainId: 1,
      address: "0x904f36d74bed2ef2729eaa1c7a5b70dea2966a02",
      name: "Blueberry",
      symbol: "BLB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35312/thumb/Blueberry_Logo.png?1708159808"
    },
    {
      chainId: 1,
      address: "0x3a645ff83560231aab0f9c830ba108b06c94e34a",
      name: "Lunar",
      symbol: "LUNAR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35510/thumb/image_2024-02-26_165146229.png?1708937508"
    },
    {
      chainId: 1,
      address: "0x1e971b5b21367888239f00da16f0a6b0effecb03",
      name: "LEEROY JENKINS",
      symbol: "LEEROY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32774/thumb/IMG_20231106_175636_467.jpg?1699343781"
    },
    {
      chainId: 1,
      address: "0x569d0e52c3dbe95983bcc2434cb9f69d905be919",
      name: "Roaring Kitty",
      symbol: "ROAR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33986/thumb/logo_200_by_200.png?1703585719"
    },
    {
      chainId: 1,
      address: "0x3850952491606a0e420eb929b1a2e1a450d013f1",
      name: "PanoVerse",
      symbol: "PANO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32812/thumb/0x3850952491606a0e420eb929b1a2e1a450d013f1.png?1699544500"
    },
    {
      chainId: 1,
      address: "0xba10085f901ae4048134e556d579cfd1bfaf89cf",
      name: "FP  Elemental",
      symbol: "UELEM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32785/thumb/elemental_%281%29.png?1699352536"
    },
    {
      chainId: 1,
      address: "0x02de007d412266a2e0fa9287c103474170f06560",
      name: "Exorde",
      symbol: "EXD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28684/thumb/logo-exorde.png?1696527668"
    },
    {
      chainId: 1,
      address: "0x19a71179fd41c19f8dfb1f38343482bec0271e3c",
      name: "Spectrum Marketplace",
      symbol: "SPEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32820/thumb/download.png?1699582062"
    },
    {
      chainId: 1,
      address: "0x42f1ffeabd9551aec26d70257c8a4d4c31b72180",
      name: "FP  0N1Force",
      symbol: "U0N1",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32786/thumb/0N1.png?1699353080"
    },
    {
      chainId: 1,
      address: "0x97bd0d0a3e9635325ec0b383cff62914a7d50642",
      name: "FP  SappySeals",
      symbol: "USAPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32787/thumb/saps_%281%29.png?1699353354"
    },
    {
      chainId: 1,
      address: "0x68d1c2a170bac7f73d7680970345fcf8ddec79bb",
      name: "VirtuBlock",
      symbol: "VB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36858/thumb/VB_200x200.png?1712642037"
    },
    {
      chainId: 1,
      address: "0xa88920b4a35f7d0e81bc586ce1875036fced9154",
      name: "Kabuni",
      symbol: "KBC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32827/thumb/Kabuni_Coin.1.png?1699585193"
    },
    {
      chainId: 1,
      address: "0x8b4d316e40ac4baf08957963210c6cff683a152b",
      name: "No Decimal",
      symbol: "SCARCE",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/34153/thumb/Untitled_design_%2857%29.png?1704208481"
    },
    {
      chainId: 1,
      address: "0x6b985d38b1fc891bb57bff59573626b1896d4aa1",
      name: "Fido",
      symbol: "FIDO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32943/thumb/Fido_circle.png?1701863458"
    },
    {
      chainId: 1,
      address: "0xa2d6b59758d307df27d5809426252d91a060cb24",
      name: "Aktionariat Parknsleep AG Tokenized Sha",
      symbol: "PNS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33376/thumb/PN.png?1701650053"
    },
    {
      chainId: 1,
      address: "0xa89b728708be04f57c7a33c6f790b6f077298e26",
      name: "ReptilianZuckerBidenBartcoin",
      symbol: "BART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32599/thumb/bart.png?1698724602"
    },
    {
      chainId: 1,
      address: "0x9047b76d7fb3d8bc3342616c56028430ebc74290",
      name: "Bishop",
      symbol: "BISHOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32868/thumb/5YeVwATD_400x400.jpg?1699672895"
    },
    {
      chainId: 1,
      address: "0x2c540c3c7be7af98278dc6963e092cd450009d1f",
      name: "Sparko",
      symbol: "SPARKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32964/thumb/recursos-cripto-95.png?1700020107"
    },
    {
      chainId: 1,
      address: "0xf538296e7dd856af7044deec949489e2f25705bc",
      name: "Illumicati",
      symbol: "MILK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32829/thumb/ILLUMICATI_CG.png?1699585511"
    },
    {
      chainId: 1,
      address: "0x1e3778dd6dbfdc1c5b89f95f7c098b21e80ec4fa",
      name: "Victory Impact",
      symbol: "VIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32814/thumb/1000084688.png?1699578648"
    },
    {
      chainId: 1,
      address: "0xa5e0b9118ce23dd1eec52cd93cf59e8ea3b3ff56",
      name: "JUDAS",
      symbol: "JUDAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32938/thumb/photo_2023-11-12_10-29-13.jpg?1699872126"
    },
    {
      chainId: 1,
      address: "0x183395dbd0b5e93323a7286d1973150697fffcb3",
      name: "Convex FXN",
      symbol: "CVXFXN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32962/thumb/cvxfxn.png?1700026163"
    },
    {
      chainId: 1,
      address: "0x2adcbee886d23eff5adecc7767bf102e4a1ce151",
      name: "Aktionariat AyurVeda AG Tokenized Share",
      symbol: "VEDA",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33377/thumb/VEDA.png?1701650144"
    },
    {
      chainId: 1,
      address: "0xae9d553c85eef99c0ef9169f0d49ef33f5275f94",
      name: "Dex Sniffer",
      symbol: "DS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32944/thumb/DS.jpg?1699887500"
    },
    {
      chainId: 1,
      address: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0",
      name: "Wrapped stETH",
      symbol: "WSTETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18834/thumb/wstETH.png?1696518295"
    },
    {
      chainId: 1,
      address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
      name: "Synthetix Network",
      symbol: "SNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3406/thumb/SNX.png?1696504103"
    },
    {
      chainId: 1,
      address: "0xd2960d83c53085b5631f4d0be4916806e40ef1f3",
      name: "OOFP",
      symbol: "OOFP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34590/thumb/Picsart_24-01-16_09-13-09-109.jpg?1705428823"
    },
    {
      chainId: 1,
      address: "0xa0d69e286b938e21cbf7e51d71f6a4c8918f482f",
      name: "Electronic USD",
      symbol: "EUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28445/thumb/0xa0d69e286b938e21cbf7e51d71f6a4c8918f482f.png?1696527441"
    },
    {
      chainId: 1,
      address: "0x3408636a7825e894ac5521ca55494f89f96df240",
      name: "PymeDAO",
      symbol: "PYME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31490/thumb/tokenLogo.png?1696530301"
    },
    {
      chainId: 1,
      address: "0x0b61c4f33bcdef83359ab97673cb5961c6435f4e",
      name: "HOLD",
      symbol: "EARN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32575/thumb/200.png?1698554742"
    },
    {
      chainId: 1,
      address: "0x97d2fc7d16bc34121c3311f2e2e05d298c19956f",
      name: "WoofOracle",
      symbol: "WFO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35788/thumb/Android.png?1709799277"
    },
    {
      chainId: 1,
      address: "0x2b81945875f892aff04af0a298d35fb2cf848c7b",
      name: "Web",
      symbol: "WEB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32957/thumb/WEB300.jpg?1699971838"
    },
    {
      chainId: 1,
      address: "0xdc9ac3c20d1ed0b540df9b1fedc10039df13f99c",
      name: "xMoney",
      symbol: "UTK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1824/thumb/200x200.png?1696723239"
    },
    {
      chainId: 1,
      address: "0x1c001d1c9e8c7b8dc717c714d30b31480ab360f5",
      name: "Gigantix Wallet",
      symbol: "GTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33285/thumb/logo.png?1701391200"
    },
    {
      chainId: 1,
      address: "0x17be403329ced6df4fdb8278f039bc6ffd3d537f",
      name: "EMMI GG",
      symbol: "EMMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33286/thumb/EMMI.jpg?1701391439"
    },
    {
      chainId: 1,
      address: "0xba25b2281214300e4e649fead9a6d6acd25f1c0a",
      name: "Tree",
      symbol: "TREE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33727/thumb/circle_green.png?1709894067"
    },
    {
      chainId: 1,
      address: "0x2817cecf94465a9f7becf43d9b7c8025e88a4213",
      name: "Weave6",
      symbol: "WX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35789/thumb/400_*_400.png?1709799390"
    },
    {
      chainId: 1,
      address: "0x5bb15141bb6def6d2bafeed8ff84bf889c0c573b",
      name: "LakeViewMeta",
      symbol: "LVM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27097/thumb/200x200logo.png?1696526146"
    },
    {
      chainId: 1,
      address: "0x0b4663216b812e4a2f0fc2029ff1232958f4bf8c",
      name: "IUCN Coin",
      symbol: "IUCN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32984/thumb/RiCiW7D.png?1700092792"
    },
    {
      chainId: 1,
      address: "0x35282d87011f87508d457f08252bc5bfa52e10a0",
      name: "ULTRA",
      symbol: "ULTRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35315/thumb/ultra-logo.png?1708161054"
    },
    {
      chainId: 1,
      address: "0xaee9ba9ce49fe810417a36408e34d9962b653e78",
      name: "Snibbu",
      symbol: "SNIBBU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35933/thumb/photo_2023-05-02_14.17.15.jpeg?1710338968"
    },
    {
      chainId: 1,
      address: "0xd3131fb503e9a20261402aec98caf0603cb913f5",
      name: "Calico Cat",
      symbol: "CALIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33167/thumb/CALIC.jpg?1700907915"
    },
    {
      chainId: 1,
      address: "0x6dda263994aab33f5ed612294e26f2a13df0da05",
      name: "IQ Protocol",
      symbol: "IQT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23274/thumb/-zCkqMuQ.jpeg?1700084588"
    },
    {
      chainId: 1,
      address: "0x4be2b2c45b432ba362f198c08094017b61e3bdc6",
      name: "Marswap",
      symbol: "MSWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31280/thumb/Mars-1.png?1696530103"
    },
    {
      chainId: 1,
      address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
      name: "Decentraland",
      symbol: "MANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/878/thumb/decentraland-mana.png?1696502010"
    },
    {
      chainId: 1,
      address: "0x85516e8862ab543ea15972b7809256efec0696ea",
      name: "ROCK",
      symbol: "ROCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32976/thumb/ROCK3.png?1700069603"
    },
    {
      chainId: 1,
      address: "0xca9d8ef4ba15ae66347b3d22afe2970b89980f88",
      name: "Innova DeFi",
      symbol: "INNOVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34023/thumb/Innova.png?1703672390"
    },
    {
      chainId: 1,
      address: "0x5ca83216fae72717332469e6a2eb28c4bf9af9ec",
      name: "0xCalls",
      symbol: "0XC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34257/thumb/0xcall.jpeg?1713250285"
    },
    {
      chainId: 1,
      address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
      name: "Bone ShibaSwap",
      symbol: "BONE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16916/thumb/bone_icon.png?1696516487"
    },
    {
      chainId: 1,
      address: "0xb4725590574bb8afae4a3f44f05f9c0f5ebd8f4b",
      name: "Hole Guys",
      symbol: "HOLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33538/thumb/download.png?1702377725"
    },
    {
      chainId: 1,
      address: "0x9b06f3c5de42d4623d7a2bd940ec735103c68a76",
      name: "Volta Club",
      symbol: "VOLTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31602/thumb/volta-200x200.png?1696530418"
    },
    {
      chainId: 1,
      address: "0xab5d6508e4726141d29c6074ab366afa03f4ec8d",
      name: "Cybertruck",
      symbol: "TRUCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33168/thumb/TRUCK.jpg?1700908260"
    },
    {
      chainId: 1,
      address: "0x9cf0ed013e67db12ca3af8e7506fe401aa14dad6",
      name: "Spectre AI",
      symbol: "SPECTRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33066/thumb/Spectre.png?1710264243"
    },
    {
      chainId: 1,
      address: "0x57a5a0567187ff4a8dcc1a9bba86155e355878f2",
      name: "Inception ETHx",
      symbol: "INETHX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34950/thumb/EthX.png?1706771369"
    },
    {
      chainId: 1,
      address: "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988",
      name: "Virtua",
      symbol: "TVK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13330/thumb/virtua_original.png?1696513099"
    },
    {
      chainId: 1,
      address: "0xa43a7c62d56df036c187e1966c03e2799d8987ed",
      name: "TruFin Staked MATIC",
      symbol: "TRUMATIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32416/thumb/TruMATIC_logo_250px_%281%29.png?1698114190"
    },
    {
      chainId: 1,
      address: "0x9a1722b1f4a1bb2f271211ade8e851afc54f77e5",
      name: "Eigenpie ETHx",
      symbol: "METHX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37169/thumb/mETHx.png?1713508078"
    },
    {
      chainId: 1,
      address: "0x761a3557184cbc07b7493da0661c41177b2f97fa",
      name: "ValleyDAO",
      symbol: "GROW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32991/thumb/valleydao_200x200.png?1700168068"
    },
    {
      chainId: 1,
      address: "0x77ebcf0659bbf4e68d8ce6d84bb25c5cde207b97",
      name: "MOOxMOO",
      symbol: "MOOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32493/thumb/MOOX.jpg?1698293551"
    },
    {
      chainId: 1,
      address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
      name: "Rocket Pool",
      symbol: "RPL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2090/thumb/rocket_pool_%28RPL%29.png?1696503058"
    },
    {
      chainId: 1,
      address: "0xe3944ab788a60ca266f1eec3c26925b95f6370ad",
      name: "Precipitate ai",
      symbol: "RAIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32405/thumb/RAIN_200-removebg-preview.png?1711371589"
    },
    {
      chainId: 1,
      address: "0xfa2629b9cf3998d52726994e0fcdb750224d8b9d",
      name: "Inception ankrETH",
      symbol: "INANKRETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34952/thumb/ankrETH.png?1706772250"
    },
    {
      chainId: 1,
      address: "0x79ca240990ec3f11381a8f80529828aad0628658",
      name: "DiVinciPay",
      symbol: "DVNCI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33091/thumb/DVNCI_Token_Logo_Crop.png?1700603214"
    },
    {
      chainId: 1,
      address: "0x081a4c60fbc381dc861bae6629c93d835d5f9a89",
      name: "Modulus Domain Service",
      symbol: "MODS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29844/thumb/_MODS.png?1696528771"
    },
    {
      chainId: 1,
      address: "0xc8168d5665f4418353728ac970713e09c0b7c20e",
      name: "Monke",
      symbol: "MONKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33492/thumb/monkelogochipUntitled-1.png?1709173538"
    },
    {
      chainId: 1,
      address: "0xe831f96a7a1dce1aa2eb760b1e296c6a74caa9d5",
      name: "Nexum",
      symbol: "NEXM",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/23472/thumb/200_-_200_coinmarketcap.png?1696522683"
    },
    {
      chainId: 1,
      address: "0x0000000000085d4780b73119b644ae5ecd22b376",
      name: "TrueUSD",
      symbol: "TUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3449/thumb/tusd.png?1696504140"
    },
    {
      chainId: 1,
      address: "0xacdbfcbd4d6d4e9fe72c3ba4280d728ab2ace30f",
      name: "TargetWatch Bot",
      symbol: "TWB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33086/thumb/TARGET_%283%29.png?1700602262"
    },
    {
      chainId: 1,
      address: "0xa704662ecb62be83f88ca1a3b5277a381cb32dce",
      name: "Bee Tools",
      symbol: "BUZZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33089/thumb/TOKEN_IMAGE.jpg?1700602823"
    },
    {
      chainId: 1,
      address: "0xc1c146e09640fe9e5d670288cc43c6269949d9a1",
      name: "Robotrade",
      symbol: "ROBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33256/thumb/photo_2023-11-28_09-42-35.jpg?1701313072"
    },
    {
      chainId: 1,
      address: "0xdb8ad3c6d7f9f364d59af9a62c3139cf5c6be88e",
      name: "XNOVA",
      symbol: "XNOVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33087/thumb/Transparent_Logo_%28Black-Purple%29_%282%29.png?1700602472"
    },
    {
      chainId: 1,
      address: "0xf1df7305e4bab3885cab5b1e4dfc338452a67891",
      name: "PaLM AI",
      symbol: "PALM",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33097/thumb/PalmProfile01Artboard_6_2x.png?1703862864"
    },
    {
      chainId: 1,
      address: "0xd298fe9fa71ad553e35997b19af19fb435038521",
      name: "Frog Wif Hat",
      symbol: "FWIF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35583/thumb/Frog_Wif_Hat_Logo_200x200.png?1709202634"
    },
    {
      chainId: 1,
      address: "0x60867b79a68abecb78351b2dbb5fdec4282c5acb",
      name: "VZZN",
      symbol: "VZZN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33101/thumb/f5040863b9414c388fdad66039175828.png?1700639092"
    },
    {
      chainId: 1,
      address: "0x382ac32e9abe17f424a74e8ce0a92c0f18788f9a",
      name: "Hottel",
      symbol: "HOTT",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xe0bd989ec7417374a1c0d9d4fb8b692d1a9e27eb",
      name: "Blackwater Labs",
      symbol: "BWL",
      decimals: 10,
      logoURI: "https://assets.coingecko.com/coins/images/34670/thumb/200x200.png?1705656297"
    },
    {
      chainId: 1,
      address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
      name: "Render",
      symbol: "RNDR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11636/thumb/rndr.png?1696511529"
    },
    {
      chainId: 1,
      address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
      name: "Illuvium",
      symbol: "ILV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14468/thumb/logo-200x200.png?1696514154"
    },
    {
      chainId: 1,
      address: "0xa0dd6dd7775e93eb842db0aa142c9c581031ed3b",
      name: "Mind",
      symbol: "MND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33540/thumb/mind-logo-black-resized.png?1702378297"
    },
    {
      chainId: 1,
      address: "0x9abfc0f085c82ec1be31d30843965fcc63053ffe",
      name: "QSTAR",
      symbol: "Q",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33177/thumb/C33809C9-D900-437D-A78A-52A8C48423AA.jpeg?1700924002"
    },
    {
      chainId: 1,
      address: "0x23dc3f6859e122b25b2cd5f3cf2335310b0f2b77",
      name: "DeSME",
      symbol: "DESME",
      decimals: 5,
      logoURI: "https://assets.coingecko.com/coins/images/33187/thumb/Logo-%28PNG%29%28200%29.png?1700954161"
    },
    {
      chainId: 1,
      address: "0x8be8b0dde627dd6be9a4b7fcadd04899aabdb2b1",
      name: "Rand",
      symbol: "RND",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/33114/thumb/rnd_icon_200.png?1705089933"
    },
    {
      chainId: 1,
      address: "0x68592c5c98c4f4a8a4bc6da2121e65da3d1c0917",
      name: "Stable USDLR",
      symbol: "USDLR",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/33115/thumb/0x68592c5c98c4f4a8a4bc6da2121e65da3d1c0917.png?1700731571"
    },
    {
      chainId: 1,
      address: "0xfea156a736dee69da8740185f7d38e14f2d99ae7",
      name: "Querio",
      symbol: "QRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33820/thumb/querio.jpeg?1703047270"
    },
    {
      chainId: 1,
      address: "0x7865ec47bef9823ad0010c4970ed90a5e8107e53",
      name: "NeoAudit AI",
      symbol: "NAAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33181/thumb/logo-on-black_%282%29.png?1700925393"
    },
    {
      chainId: 1,
      address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
      name: "FTX",
      symbol: "FTT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9026/thumb/F.png?1696509161"
    },
    {
      chainId: 1,
      address: "0x1e241521f4767853b376c2fe795a222a07d588ee",
      name: "Uni Terminal",
      symbol: "UNIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33458/thumb/Logo.png?1701925230"
    },
    {
      chainId: 1,
      address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
      name: "Axie Infinity",
      symbol: "AXS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13029/thumb/axie_infinity_logo.png?1696512817"
    },
    {
      chainId: 1,
      address: "0x3b6564b5da73a41d3a66e6558a98fd0e9e1e77ad",
      name: "Unitus",
      symbol: "UTS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33178/thumb/IMG_0051.jpeg?1700924333"
    },
    {
      chainId: 1,
      address: "0xf1c9acdc66974dfb6decb12aa385b9cd01190e38",
      name: "StakeWise Staked ETH",
      symbol: "OSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33117/thumb/Frame_27513839.png?1700732599"
    },
    {
      chainId: 1,
      address: "0x1a8b8e526d093476ac5c488a3ea057f8de9c0dee",
      name: "JEFFWorld Token",
      symbol: "JEFF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33188/thumb/output-onlinepngtools_%283%29.png?1700954618"
    },
    {
      chainId: 1,
      address: "0x8dd09822e83313adca54c75696ae80c5429697ff",
      name: "Sifu Vision",
      symbol: "SIFU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35601/thumb/quewxQN.png?1709267056"
    },
    {
      chainId: 1,
      address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
      name: "Curve DAO",
      symbol: "CRV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12124/thumb/Curve.png?1696511967"
    },
    {
      chainId: 1,
      address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
      name: "Maker",
      symbol: "MKR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1364/thumb/Mark_Maker.png?1696502423"
    },
    {
      chainId: 1,
      address: "0xa2762ba628b962f93498d8893b6e4346140fe96d",
      name: "Intrepid Token",
      symbol: "INT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33229/thumb/int.png?1701257932"
    },
    {
      chainId: 1,
      address: "0xd88611a629265c9af294ffdd2e7fa4546612273e",
      name: "MPRO Lab",
      symbol: "MPRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35128/thumb/mpro.jpeg?1707440015"
    },
    {
      chainId: 1,
      address: "0xe13cf110176e0dd6590536cd391b8a3522475f82",
      name: "RentAI",
      symbol: "RENT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36421/thumb/RENT_TRANSPARENT_200.png?1711428441"
    },
    {
      chainId: 1,
      address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
      name: "Ethereum Name Service",
      symbol: "ENS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19785/thumb/acatxTm8_400x400.jpg?1696519207"
    },
    {
      chainId: 1,
      address: "0x8f602ee5b1f8de67120c427717cbe2770f3cf320",
      name: "Starry",
      symbol: "STARRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33190/thumb/STARRY.jpg?1700968743"
    },
    {
      chainId: 1,
      address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
      name: "0x Protocol",
      symbol: "ZRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/863/thumb/0x.png?1696501996"
    },
    {
      chainId: 1,
      address: "0x4f4a556361b8b4869f97b8709ff47c1b057ea13b",
      name: "MAGA",
      symbol: "TRUMP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33235/thumb/logo_200px.png?1701147167"
    },
    {
      chainId: 1,
      address: "0xfed802a7e561d6324818358790b176a01d765f19",
      name: "BlockRock",
      symbol: "FED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33236/thumb/d4ac260d-4ee6-4450-b302-6dbd7dde85db.jpeg?1701147502"
    },
    {
      chainId: 1,
      address: "0xbd617a1359086e33ff339ea0b9c6de479a3f5943",
      name: "Ide x ai",
      symbol: "IDE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33240/thumb/logo_ide-1-150x150.png?1701148159"
    },
    {
      chainId: 1,
      address: "0x4f604735c1cf31399c6e711d5962b2b3e0225ad3",
      name: "Glo Dollar",
      symbol: "USDGLO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29319/thumb/glo_logo_coingecko.png?1696528270"
    },
    {
      chainId: 1,
      address: "0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec",
      name: "VEMP",
      symbol: "VEMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18074/thumb/VEMP_Token_200x200.png?1696517581"
    },
    {
      chainId: 1,
      address: "0xf282484234d905d7229a6c22a0e46bb4b0363ee0",
      name: "Revswap",
      symbol: "RVS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33437/thumb/20231205_174957.png?1701847754"
    },
    {
      chainId: 1,
      address: "0x661ecf29b533e7d09f67f597af77eeaf3cc6b1e7",
      name: "0xNude",
      symbol: "NUDE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33459/thumb/0xNude.png?1701925329"
    },
    {
      chainId: 1,
      address: "0x1e354f9ab5bcc9fb981f31b794c5fe13f7a89218",
      name: "Neural Tensor Dynamics",
      symbol: "NTD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36532/thumb/Neural_Tensor_Dynamics.png?1711705100"
    },
    {
      chainId: 1,
      address: "0x6f38e0f1a73c96cb3f42598613ea3474f09cb200",
      name: "Draggable Aktionariat AG",
      symbol: "DAKS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/28988/thumb/AKS.png?1696527961"
    },
    {
      chainId: 1,
      address: "0xc5b490371870201e2fe6308850507db6e9cba732",
      name: "Baby GROK",
      symbol: "BROK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33239/thumb/200x200_bork.png?1701147976"
    },
    {
      chainId: 1,
      address: "0xb0f92f94d02a4d634fd394c1889fe3cab1fcffc7",
      name: "DogeBoy",
      symbol: "DOGB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33241/thumb/IMG_20231127_212135_822.png?1701170913"
    },
    {
      chainId: 1,
      address: "0x2e880962a9609aa3eab4def919fe9e917e99073b",
      name: "Aktionariat Boss Info AG Tokenized Shar",
      symbol: "BOSS",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33248/thumb/BOSS_%281%29.png?1701172435"
    },
    {
      chainId: 1,
      address: "0x7c68e725b0b2ffcba8947fded4198c3d1db041e6",
      name: "Pongo",
      symbol: "PONGO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37556/thumb/X_200.png?1714753471"
    },
    {
      chainId: 1,
      address: "0x443f9ff91a72f1482d13dfd40eec107bb84ca1e5",
      name: "FarmBot",
      symbol: "FARM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33440/thumb/farmbotlogo200px.jpeg?1701849705"
    },
    {
      chainId: 1,
      address: "0xbaac2b4491727d78d2b78815144570b9f2fe8899",
      name: "The Doge NFT",
      symbol: "DOG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18111/thumb/Doge.png?1696517615"
    },
    {
      chainId: 1,
      address: "0xabc93b1c8ffa3a69f478068676360021bbaab4bf",
      name: "DigiFund Capital V2",
      symbol: "DFUND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33378/thumb/dfund.png?1701660694"
    },
    {
      chainId: 1,
      address: "0x9d1a74967eca155782edf8e84782c74db33fc499",
      name: "AI COM",
      symbol: "AICOM",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33246/thumb/BbLZo3AH_400x400.jpg?1701172033"
    },
    {
      chainId: 1,
      address: "0x23feef978f2f8e9aeb26028d09b5d303b6c6a057",
      name: "Sacabambaspis",
      symbol: "SACA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33299/thumb/photo_2023-11-30_03.46.16.jpeg?1701402704"
    },
    {
      chainId: 1,
      address: "0xb970e14df2161c0a2f32eba35901f2446581b482",
      name: "Reaktor",
      symbol: "RKR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33291/thumb/REAKTOR.png?1701400698"
    },
    {
      chainId: 1,
      address: "0x8b12bd54ca9b2311960057c8f3c88013e79316e3",
      name: "Reach",
      symbol: "REACH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33776/thumb/reach.jpeg?1702970338"
    },
    {
      chainId: 1,
      address: "0x7f716b4777169ebd8ff132acfff59399049a137b",
      name: "Gameluk",
      symbol: "GAME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35697/thumb/Gameluk-logo-200*200.png?1709549680"
    },
    {
      chainId: 1,
      address: "0xbf40440703a3f7092b2e73c2f7868727275dbbda",
      name: "Keep Finance",
      symbol: "KEEP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35699/thumb/Keep-icon-200*200.png?1709550148"
    },
    {
      chainId: 1,
      address: "0x824e35f7a75324f99300afac75ecf7354e17ea26",
      name: "TIA",
      symbol: "TIA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/23994/thumb/tia.png?1696523188"
    },
    {
      chainId: 1,
      address: "0x2d3590fac07b91c9451e8d16c372ece9758f040f",
      name: "ratsDAO",
      symbol: "RAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33385/thumb/200x200.png?1701671914"
    },
    {
      chainId: 1,
      address: "0xf995771a957c19319a7d8d58b4082b049420340f",
      name: "BONK Inu",
      symbol: "BONKI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33510/thumb/IMG_20231207_184637_498_%282%29.jpg?1702041006"
    },
    {
      chainId: 1,
      address: "0x9dc251f27a7477313242a022181d4b5a3a1e4a0f",
      name: "Unibets AI",
      symbol: "BETS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33388/thumb/_BETS.jpg?1701677276"
    },
    {
      chainId: 1,
      address: "0x30b593f8c3ab37615359b4e0e6df2e06d55bb55d",
      name: "FXDX",
      symbol: "FXDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32730/thumb/ICONIC_LOGO_BLACK_PNG_%281%29.png?1699217673"
    },
    {
      chainId: 1,
      address: "0x4ffe9cc172527df1e40d0b2efe1e9f05884a13da",
      name: "DEDPRZ",
      symbol: "USA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33381/thumb/NewDcoin_%283%29.png?1705599002"
    },
    {
      chainId: 1,
      address: "0x551d0501cd5df92663c3d12c3201c9d70ba79998",
      name: "All Your Base",
      symbol: "YOBASE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33595/thumb/Group_48095820logo_cmc.png?1702476376"
    },
    {
      chainId: 1,
      address: "0x44face2e310e543f6d85867eb06fb251e3bfe1fc",
      name: "404 Bakery",
      symbol: "BAKE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35130/thumb/404_4_%282%29.png?1707440511"
    },
    {
      chainId: 1,
      address: "0x68f108fb7141ffe36b832c5c225d9e7e474bd664",
      name: "Pepinu",
      symbol: "PEPINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36133/thumb/PEPINU_CG.png?1714673869"
    },
    {
      chainId: 1,
      address: "0xb4c25205f7a76ae08cbe95e27864106e1b93732c",
      name: "Extropic AI",
      symbol: "EXTROPIC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33408/thumb/Picsart_23-12-04_05-49-36-727.png?1701700613"
    },
    {
      chainId: 1,
      address: "0xd5fa38027462691769b8a8ba6c444890103b5b94",
      name: "Dawg Coin",
      symbol: "DAWG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33409/thumb/dawg_%281%29.jpg?1701700702"
    },
    {
      chainId: 1,
      address: "0x922d8563631b03c2c4cf817f4d18f6883aba0109",
      name: "Houdini Swap",
      symbol: "LOCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35132/thumb/LOCK_Logo.png?1707443455"
    },
    {
      chainId: 1,
      address: "0x378878af3228d23891de306cb2b123d837d0dcf1",
      name: "Anonify",
      symbol: "ONI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35426/thumb/Token-image_%281%29.png?1708572251"
    },
    {
      chainId: 1,
      address: "0x2fb652314c3d850e9049057bbe9813f1eee882d3",
      name: "RocketX Exchange",
      symbol: "RVF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14728/thumb/avatar-correct-size-official.png?1696514397"
    },
    {
      chainId: 1,
      address: "0xe3668873d944e4a949da05fc8bde419eff543882",
      name: "Yearn yPRISMA",
      symbol: "YPRISMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33481/thumb/Asset_yPRISMA__Type_Main.png?1702020049"
    },
    {
      chainId: 1,
      address: "0xe90ce7764d8401d19ed3733a211bd3b06c631bc0",
      name: "The Other Party",
      symbol: "POD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33478/thumb/Twitter_header_-_4.png?1702017433"
    },
    {
      chainId: 1,
      address: "0x559cc0850361afe1973c0ba5d0a3446c8a5ad678",
      name: "Avatar404",
      symbol: "",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35589/thumb/avatar404.jpeg?1709204091"
    },
    {
      chainId: 1,
      address: "0x3eb9c7ee5f72e51f61e832137719fe8d1e53a2ce",
      name: "DecentraMind",
      symbol: "DMIND",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33315/thumb/IMG_20231130_105535_975.jpg?1701413610"
    },
    {
      chainId: 1,
      address: "0xd5f7838f5c461feff7fe49ea5ebaf7728bb0adfa",
      name: "Mantle Staked Ether",
      symbol: "METH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33345/thumb/symbol_transparent_bg.png?1701697066"
    },
    {
      chainId: 1,
      address: "0xe73cec024b30a7195af80d13f3b6917d80af11d8",
      name: "GOATED",
      symbol: "GOAT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34735/thumb/IMG_20240121_025525_360.jpg?1705943971"
    },
    {
      chainId: 1,
      address: "0x01bf66becdcfd6d59a5ca18869f494fea086cdfd",
      name: "KUMA Protocol US KUMA Interest Bearing ",
      symbol: "USK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33445/thumb/USK.png?1701888523"
    },
    {
      chainId: 1,
      address: "0xaf4ce7cd4f8891ecf1799878c3e9a35b8be57e09",
      name: "KUMA Protocol Wrapped USK",
      symbol: "WUSK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33446/thumb/USK.png?1701888542"
    },
    {
      chainId: 1,
      address: "0x5e72ad4bf50c952b11a63b6769d02bb486a9a897",
      name: "Lucky8",
      symbol: "888",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33448/thumb/Frame_742.png?1701856566"
    },
    {
      chainId: 1,
      address: "0x79349edd0b8e83ffaa1af2e6ba0c8ce87731c267",
      name: "WcDonalds",
      symbol: "WCD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35897/thumb/wcdonalds.png?1710163437"
    },
    {
      chainId: 1,
      address: "0x38c2a4a7330b22788374b8ff70bba513c8d848ca",
      name: "Truflation",
      symbol: "TRUF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36642/thumb/TRUF_Token_Logo_Blue.png?1712034385"
    },
    {
      chainId: 1,
      address: "0x5a4a503f4745c06a07e29d9a9dd88ab52f7a505b",
      name: "Eigenpie ankrETH",
      symbol: "MANKRETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37170/thumb/mankrETH.png?1713508127"
    },
    {
      chainId: 1,
      address: "0x17f7fea5f87d0f289d9827be78fc96027f8ed724",
      name: "Aktionariat EHC Kloten Sport AG Tokeniz",
      symbol: "EHCK",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/33390/thumb/EHCK.png?1701680177"
    },
    {
      chainId: 1,
      address: "0xc47b0443f8608943c596168504bb6d4a062e0edc",
      name: "Lacostoken",
      symbol: "LCSN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33282/thumb/20231129_210945.png?1701362709"
    },
    {
      chainId: 1,
      address: "0x273b8e7adddcb4de101416300fcd3688c0612a27",
      name: "Rabbit Games",
      symbol: "RAIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33807/thumb/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20231218214054.jpg?1702993200"
    },
    {
      chainId: 1,
      address: "0x64d5fea7d2d600918b76159285994d6ed218f264",
      name: "Tao Accounting System",
      symbol: "TAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35591/thumb/tas-logo.png?1709204338"
    },
    {
      chainId: 1,
      address: "0x6bfdb6f4e65ead27118592a41eb927cea6956198",
      name: "FAME AI",
      symbol: "FMC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33574/thumb/20231205-153104.png?1702450853"
    },
    {
      chainId: 1,
      address: "0xc7937b44532bf4c0a1f0de3a46c79dddb6dd169d",
      name: "Deez Nuts  ERC404 ",
      symbol: "DN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35592/thumb/deez-nuts.png?1709204399"
    },
    {
      chainId: 1,
      address: "0x310718274509a38cc5559a1ff48c5edbe75a382b",
      name: "Eigenpie oETH",
      symbol: "MOETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37171/thumb/mOETH.png?1713508180"
    },
    {
      chainId: 1,
      address: "0x490bd60a5d3e1207fba9b699017561434cc8c675",
      name: "Bugs Bunny",
      symbol: "BUGS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33398/thumb/Bugs_200x200.png?1701684815"
    },
    {
      chainId: 1,
      address: "0xad8f047d9b742565bb9e10c7655bd3ee9c1eab75",
      name: "Grok Chain",
      symbol: "GROC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33400/thumb/photo_2023-11-29_17-47-05.png?1701684970"
    },
    {
      chainId: 1,
      address: "0xbe9f4f6c8dadb2ac61f31eb1f5171e27d8552df7",
      name: "Chiba Neko",
      symbol: "CHIBA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32555/thumb/logo.png?1714613968"
    },
    {
      chainId: 1,
      address: "0x1d00e86748573c322f4cc41518aa0e77bd912eb4",
      name: "Ethereum Reserve Dollar USDE",
      symbol: "USDE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33542/thumb/USDE_200*200.png?1702383206"
    },
    {
      chainId: 1,
      address: "0xa408090a36cef0b23c3f518484a4e06c7c7df27c",
      name: "FuzangLong",
      symbol: "LONG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35134/thumb/photo_2024-02-08_08-07-28.jpg?1707444987"
    },
    {
      chainId: 1,
      address: "0xa069add2d093f9df0e82ab64ec7dd0320cb4f65d",
      name: "GPUBot",
      symbol: "GPUBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35627/thumb/GPUBot.png?1709291157"
    },
    {
      chainId: 1,
      address: "0x9f8ae89b695fd1773175ccb9106a90ce868acab0",
      name: "AltFi",
      symbol: "ALT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33418/thumb/altfi_200x200.png?1701762359"
    },
    {
      chainId: 1,
      address: "0x470c8950c0c3aa4b09654bc73b004615119a44b5",
      name: "Kizuna",
      symbol: "KIZUNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32113/thumb/IMG_9968.png?1696585475"
    },
    {
      chainId: 1,
      address: "0xf7ff660cbdcc5d0ba48988119144425974d88792",
      name: "Scope Sniper",
      symbol: "SCOPE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33419/thumb/photo_2023-11-30_08-53-48.jpg?1701766212"
    },
    {
      chainId: 1,
      address: "0x878fcc2bdcccff8c56812607b9a58f29b274c4f0",
      name: "Derp Coin",
      symbol: "DERP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30262/thumb/logo-200x200-transparent.png?1696529170"
    },
    {
      chainId: 1,
      address: "0x0c7b199ac2bca0dba8d1785480648f0318b9a7b8",
      name: "OrdiBot",
      symbol: "ORDIBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33462/thumb/OIG_%281%29.png?1701927925"
    },
    {
      chainId: 1,
      address: "0xe3e24b4ea87935e15bbe99a24e9ace9998e4614d",
      name: "Aidi Finance",
      symbol: "AIDI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29675/thumb/aidi_finance.png?1696528610"
    },
    {
      chainId: 1,
      address: "0xedf978ee4beafbeefd7a0f55faa5a7c6c3cd467d",
      name: "FP  CoolCats",
      symbol: "UCOOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32781/thumb/cool_%281%29.png?1699350874"
    },
    {
      chainId: 1,
      address: "0xd01d133166820557db7138963bcd9009c54e4c33",
      name: "ChainEx",
      symbol: "CEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33477/thumb/ChainEx-2.png?1702013835"
    },
    {
      chainId: 1,
      address: "0x710287d1d39dcf62094a83ebb3e736e79400068a",
      name: "enqAI",
      symbol: "ENQAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29908/thumb/icon.png?1702507913"
    },
    {
      chainId: 1,
      address: "0xbfba57800bce200915499078289299c86af4a379",
      name: "ORDINAL BITCOIN",
      symbol: "OBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33940/thumb/IMG_0418.jpeg?1703503503"
    },
    {
      chainId: 1,
      address: "0x9e20461bc2c4c980f62f1b279d71734207a6a356",
      name: "OmniCat",
      symbol: "OMNI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33917/thumb/2023-12-21_21.39.10.jpg?1703321588"
    },
    {
      chainId: 1,
      address: "0xe6f28389daf01ae12b33ee5e7f1e130c454e8494",
      name: "AntiBot",
      symbol: "ATB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33495/thumb/IMG_5554.png?1702076259"
    },
    {
      chainId: 1,
      address: "0x78993f9bee8b68f2531a92427595405f294161db",
      name: "0xBET",
      symbol: "0XBET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35790/thumb/V7LdNy1d_400x400.jpg?1709799471"
    },
    {
      chainId: 1,
      address: "0xaf69d0518d341af4961b5fcfdb86a3e3453f1dc5",
      name: "Longchenchen",
      symbol: "LONG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33505/thumb/longerc20.jpg?1702039017"
    },
    {
      chainId: 1,
      address: "0x4a88ebf6f76b04f5e0e71a351a22e573f636affe",
      name: "Yoyo Market",
      symbol: "YOYO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33548/thumb/yoyopngcg.png?1702499846"
    },
    {
      chainId: 1,
      address: "0x6034e0d6999741f07cb6fb1162cbaa46a1d33d36",
      name: "Molecules of Korolchuk IP NFT",
      symbol: "VITA-FAST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33055/thumb/Vita-FAST_1024px.png?1700475313"
    },
    {
      chainId: 1,
      address: "0x553531c45eabc2f3343d19885262ac784046fd5f",
      name: "CyOp",
      symbol: "CYOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33598/thumb/CYOP.jpg?1702477495"
    },
    {
      chainId: 1,
      address: "0xa685406eff334b1368318d0325fc2cdc0e7086f1",
      name: "PARTY",
      symbol: "PARTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33550/thumb/party-logo-200x200.png?1702397278"
    },
    {
      chainId: 1,
      address: "0x87c22db324b8b0637c8f09d2670ae7777651dbb8",
      name: "Root Protocol",
      symbol: "ISME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36564/thumb/root-0313_%282%29.jpg?1711906595"
    },
    {
      chainId: 1,
      address: "0x7658b8cd4719080ad377dfe28dfc19c761a3cb75",
      name: "MevAI",
      symbol: "MAI",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xa4ffdf3208f46898ce063e25c1c43056fa754739",
      name: "AthenaDAO",
      symbol: "ATH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33349/thumb/ATH_Token_Black_Logo.png?1701981879"
    },
    {
      chainId: 1,
      address: "0xb5c23f694810a8a6a37fede38004150ee0dd3821",
      name: "0xTools",
      symbol: "0XT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/33551/thumb/2023-12-10_19.37.28.jpg?1702428574"
    },
    {
      chainId: 1,
      address: "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97",
      name: "Gods Unchained",
      symbol: "GODS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17139/thumb/10631.png?1696516698"
    },
    {
      chainId: 1,
      address: "0x04c154b66cb340f3ae24111cc767e0184ed00cc6",
      name: "Dinero Staked ETH",
      symbol: "PXETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33608/thumb/pxETH-icon-transbg_72dpi.png?1702512024"
    },
    {
      chainId: 1,
      address: "0xf5b339d3912d5c72e16440b63a9c1df6024de93c",
      name: "Baby Grok",
      symbol: "BABYGROK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33397/thumb/HZdZYbd2_400x400.jpg?1701684676"
    },
    {
      chainId: 1,
      address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
      name: "NEXO",
      symbol: "NEXO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3695/thumb/nexo.png?1696504370"
    },
    {
      chainId: 1,
      address: "0x000000000075f13bcf2e6652e84821e8b544f6f9",
      name: "Signet",
      symbol: "SIG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33552/thumb/st.png?1702428755"
    },
    {
      chainId: 1,
      address: "0x3e316791842a271ab1e138ff7408c015efd9c6be",
      name: "Vortex AI",
      symbol: "VXAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33571/thumb/IMG_20231210_193633_029.jpg?1702449851"
    },
    {
      chainId: 1,
      address: "0x9ca98c8b217c3b45074834908555d36af2ac6449",
      name: "SatsBridge",
      symbol: "SABR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34813/thumb/1000002973.png?1706123473"
    },
    {
      chainId: 1,
      address: "0x9ba021b0a9b958b5e75ce9f6dff97c7ee52cb3e6",
      name: "Dinero apxETH",
      symbol: "APXETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33609/thumb/apxETH-icon-transbg_72dpi.png?1702512027"
    },
    {
      chainId: 1,
      address: "0x795a7e7a0f6b84ee1f2bc9e70a74dbbb49cef9a3",
      name: "Intrinsic Number Up",
      symbol: "INU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33631/thumb/INU_LOGO_CG___CMC.png?1705766451"
    },
    {
      chainId: 1,
      address: "0x5441765d3ab74e0347df52ffab5a69e5146b5d26",
      name: "BTCMEME",
      symbol: "BTCMEME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33600/thumb/IMG_20231212_162704_611.jpg?1702509475"
    },
    {
      chainId: 1,
      address: "0x668308d77be3533c909a692302cb4d135bf8041c",
      name: "Inception sfrxETH",
      symbol: "INSFRXETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34949/thumb/sfrxETH.png?1706770412"
    },
    {
      chainId: 1,
      address: "0x0cdbbc7fe1c8da0cc41ba96d7edb4cce5982f23f",
      name: "UNITS LIMITED SUPPLY",
      symbol: "ULS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33560/thumb/dark_token.png?1702429859"
    },
    {
      chainId: 1,
      address: "0x01202c9a1adfc1475c960c23bdf7530698330fa0",
      name: "Judge AI",
      symbol: "JUDGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34959/thumb/4MUdYI7V_200x200.jpg?1706774333"
    },
    {
      chainId: 1,
      address: "0x01e1d7cbd3bc0eb1030485f33708421011459459",
      name: "TOAD",
      symbol: "TOAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33716/thumb/TOAD.png?1702897534"
    },
    {
      chainId: 1,
      address: "0x102c776ddb30c754ded4fdcc77a19230a60d4e4f",
      name: "Floor Protocol",
      symbol: "FLC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32433/thumb/Floor_Protocol_browser_logo_mark.png?1702379738"
    },
    {
      chainId: 1,
      address: "0x36705e789d0d1ba53fd9bb93512722018b0a089e",
      name: "CortexLoop",
      symbol: "CRTX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35793/thumb/ava-1_%284%29.png?1709800646"
    },
    {
      chainId: 1,
      address: "0xa187927c9185108458647aeec193ef4a62d3bd80",
      name: "Meta Minigames",
      symbol: "MMG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35380/thumb/MMG_Black_%281%29.png?1708422554"
    },
    {
      chainId: 1,
      address: "0x40c3b81fb887016c0ad02436309c2b265d069a05",
      name: "Chief Troll Officer",
      symbol: "CTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34736/thumb/IMG_1873.jpeg?1705944614"
    },
    {
      chainId: 1,
      address: "0x64a5b80089c0fb4858a8c2ca9c2988a484539fd8",
      name: "Print Mining",
      symbol: "PRINT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33606/thumb/Print_miner_%28Custom%29.jpg?1702511022"
    },
    {
      chainId: 1,
      address: "0x5e05f367a1923b2a886e2f2bc45c2278a0b9b448",
      name: "BRC20 BOT",
      symbol: "BRCBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33607/thumb/IMG_20231206_032536_412.jpg?1702511057"
    },
    {
      chainId: 1,
      address: "0xe73d2faeeb9dec890c905b707b574627d5302cb3",
      name: "Defi Radar",
      symbol: "DRADAR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34304/thumb/Safeimagekit-resized-img_%2819%29.png?1704612554"
    },
    {
      chainId: 1,
      address: "0x6a4f9a1372235c3fea4fb07170a635b26417382b",
      name: "Wonderland Capital",
      symbol: "ALICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33485/thumb/Wonderland.png?1702028786"
    },
    {
      chainId: 1,
      address: "0x146ae546b7a2d676e5ed9e5d92647c8ddb8e2388",
      name: "Grand Theft Degens",
      symbol: "GTD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33633/thumb/Grand_Theft_Degens.jpg?1702535287"
    },
    {
      chainId: 1,
      address: "0xdc5e9445169c73cf21e1da0b270e8433cac69959",
      name: "Ketaicoin",
      symbol: "ETHEREUM",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31326/thumb/photo_2023-08-15_21-35-43.jpg?1696530145"
    },
    {
      chainId: 1,
      address: "0xcc9e0bd9438ca0056653d134de794abeaff8c676",
      name: "Leslie",
      symbol: "LESLIE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33189/thumb/IMG_0721_%282%29.png?1700955081"
    },
    {
      chainId: 1,
      address: "0x6dd5f0038474dc29a0adc6ad34d37b0ba53e5435",
      name: "DEXED",
      symbol: "DEXED",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35617/thumb/coingecko.png?1709283896"
    },
    {
      chainId: 1,
      address: "0xf2041be4ea84599818799eed882389a8a30d2226",
      name: "NeuralBot",
      symbol: "NEURAL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33717/thumb/Neuralbot_ai.png?1702880084"
    },
    {
      chainId: 1,
      address: "0xd9a442856c234a39a81a089c06451ebaa4306a72",
      name: "pufETH",
      symbol: "PUFETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35176/thumb/pufETH-200-200-resolution.png?1707753174"
    },
    {
      chainId: 1,
      address: "0x695d38eb4e57e0f137e36df7c1f0f2635981246b",
      name: "Meme AI Coin",
      symbol: "MEMEAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34356/thumb/MEMEAI.png?1704706407"
    },
    {
      chainId: 1,
      address: "0xeb9e3c6cda17c8755a4e8a1cc944afb7fc7d7905",
      name: "MatchTrade",
      symbol: "MATCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34520/thumb/Frame_16.png?1705301241"
    },
    {
      chainId: 1,
      address: "0x45e412e1878080815d6d51d47b83d17869433459",
      name: "Chief Troll Officer",
      symbol: "CTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34518/thumb/Untitled_design-13.png?1705295928"
    },
    {
      chainId: 1,
      address: "0xfe1b621235227bfa14ed81be2ba4e5e4447b52c0",
      name: "ORDINAL TOOLS",
      symbol: "ORT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33623/thumb/photo_2023-12-13_21-16-24.jpg?1702529153"
    },
    {
      chainId: 1,
      address: "0xd23b160e4a0db09ca35a79948e04cf6eafb5283a",
      name: "Blend Protocol",
      symbol: "BLEND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33766/thumb/Blend_Protocol_Logo_tsp.png?1702967995"
    },
    {
      chainId: 1,
      address: "0x13c4b558f6663329c13c838cc0b5b796f7fc0531",
      name: "Horizon",
      symbol: "HRZN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33740/thumb/moon.jpg?1702903432"
    },
    {
      chainId: 1,
      address: "0x2056ec69ac5afaf210b851ff74de4c194fcd986e",
      name: "Port AI",
      symbol: "POAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36792/thumb/image_2024-03-25_19-40-43.png?1712421434"
    },
    {
      chainId: 1,
      address: "0x12652c6d93fdb6f4f37d48a8687783c782bb0d10",
      name: "Entangle",
      symbol: "NGL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34522/thumb/entangle.jpeg?1705302451"
    },
    {
      chainId: 1,
      address: "0x455ad1bc4e18fd4e369234b6e11d88acbc416758",
      name: "BRC App",
      symbol: "BRCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34244/thumb/BRC_X_Banners-19.jpg?1704338085"
    },
    {
      chainId: 1,
      address: "0x9b3a8159e119eb09822115ae08ee1526849e1116",
      name: "Meme Alliance",
      symbol: "MMA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33765/thumb/200x200.png?1709978615"
    },
    {
      chainId: 1,
      address: "0xaf1eeb83c364ad9ffeb5f97f223c1705d4810033",
      name: "MoneyArk",
      symbol: "MARK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33987/thumb/LOGO.png?1703692373"
    },
    {
      chainId: 1,
      address: "0x57ca1f39b0757b8610617e90fa9b2980ccebfece",
      name: "OrdinalsFi",
      symbol: "ORDIFI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33723/thumb/ordinalsfi200.png?1702885610"
    },
    {
      chainId: 1,
      address: "0x600d601d8b9eb5de5ac90fefc68d0d08801bfd3f",
      name: "Element",
      symbol: "ELMT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/33775/thumb/ELMT_Logo_Mark_Filled_-_Neon_LG.png?1702970207"
    },
    {
      chainId: 1,
      address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
      name: "Celer Network",
      symbol: "CELR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4379/thumb/Celr.png?1696504978"
    },
    {
      chainId: 1,
      address: "0x1eb7bd905855c483db19f53c8c4d42db42a159fc",
      name: "Nordic Ai",
      symbol: "NRDC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36793/thumb/NordicAI_logo_%281%29.png?1712421635"
    },
    {
      chainId: 1,
      address: "0xdf87270e04bc5ac140e93571d0dd0c6f4a058b41",
      name: "Moolahverse",
      symbol: "MLH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33724/thumb/mlh-logo-200x200.png?1702886528"
    },
    {
      chainId: 1,
      address: "0x5483dc6abda5f094865120b2d251b5744fc2ecb5",
      name: "TaoPad",
      symbol: "TPAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33664/thumb/TAOWHITE.png?1702631267"
    },
    {
      chainId: 1,
      address: "0x1e610de0d7acfa1d820024948a91d96c5c9ce6b9",
      name: "FP  BoredApeYachtClub",
      symbol: "UBAYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32690/thumb/bayctoken.png?1698974036"
    },
    {
      chainId: 1,
      address: "0x3acfc40a19520d97648eb7c0891e747b7f2b0283",
      name: "FP  Azuki",
      symbol: "UAZUKI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32676/thumb/vsF28_QV_400x400.jpg?1698911738"
    },
    {
      chainId: 1,
      address: "0x30f7c830e0c2f4bec871df809d73e27ef19eb151",
      name: "FP  PudgyPenguins",
      symbol: "UPPG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32691/thumb/pudgy_penguins_64_64.png?1698974130"
    },
    {
      chainId: 1,
      address: "0x359108ca299ca693502ef217e2109ad02aa4277c",
      name: "FP  MutantApeYachtClub",
      symbol: "UMAYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32675/thumb/mayc_logo.69fd41b5.png?1698911670"
    },
    {
      chainId: 1,
      address: "0xec19caef9c046f5f87a497154766742ab9c90820",
      name: "FP  Y00ts",
      symbol: "UY00TS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32780/thumb/y00ts_%281%29.png?1699350631"
    },
    {
      chainId: 1,
      address: "0xad161afae7db2a048b042bd68e11c38c9c042cc1",
      name: "FP  Nakamigos",
      symbol: "UNKMGS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32757/thumb/nakamigos.jpg?1699310532"
    },
    {
      chainId: 1,
      address: "0xb53b9e28b98c47e87acfd5a85eeb44a0940ecb12",
      name: "Ordible",
      symbol: "ORB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34524/thumb/IMG_5471.PNG?1705303671"
    },
    {
      chainId: 1,
      address: "0xf827f77422d6dff7b4e1bc87fec88606082b2199",
      name: "MuskX",
      symbol: "MUSKX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34650/thumb/output-onlinepngtools.png?1705593083"
    },
    {
      chainId: 1,
      address: "0x0e13914f4fe838e96346ce42f588193eb17d92b6",
      name: "Lemon Terminal",
      symbol: "LEMON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33837/thumb/cmc.png?1703107858"
    },
    {
      chainId: 1,
      address: "0x0a6e481cb5f2d976b2edac4f67dcc824ccdae4af",
      name: "Audify",
      symbol: "AUDI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34251/thumb/emoji.png?1704339102"
    },
    {
      chainId: 1,
      address: "0xe46a1d19962ea120765d3139c588ffd617be04a8",
      name: "EverETH",
      symbol: "EETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34525/thumb/EETH_LOGO.png?1705303995"
    },
    {
      chainId: 1,
      address: "0x1bb9b64927e0c5e207c9db4093b3738eef5d8447",
      name: "Vector Reserve",
      symbol: "VEC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34876/thumb/vec200.png?1709644054"
    },
    {
      chainId: 1,
      address: "0xb7be27ba608641f0b6f152c8b432757f3685d2b0",
      name: "FP  Meebits",
      symbol: "U",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32769/thumb/meebits_logo.d8ecd01f_%281%29.png?1699337785"
    },
    {
      chainId: 1,
      address: "0x2dc917b722184ece1dcb9bb9dddfb1d63ccd25eb",
      name: "White Rhinoceros",
      symbol: "WHRH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33311/thumb/20231127_183017.png?1701412616"
    },
    {
      chainId: 1,
      address: "0x6a6b457becae7ef1cf9f22510d136c4aac0fc6d2",
      name: "Molly AI",
      symbol: "MOLLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33796/thumb/MOLLY.png?1702990017"
    },
    {
      chainId: 1,
      address: "0x328a268b191ef593b72498a9e8a481c086eb21be",
      name: "MetaZero",
      symbol: "MZERO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33759/thumb/1500x500-3.jpeg?1702960079"
    },
    {
      chainId: 1,
      address: "0xde7d85157d9714eadf595045cc12ca4a5f3e2adb",
      name: "STP",
      symbol: "STPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8713/thumb/STP.png?1696508875"
    },
    {
      chainId: 1,
      address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
      name: "Prom",
      symbol: "PROM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8825/thumb/Ticker.png?1696508978"
    },
    {
      chainId: 1,
      address: "0x43fe2b0c5485c10e772a1843e32a7642ace5b88c",
      name: "Red Pill",
      symbol: "RPILL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33896/thumb/2023-12-21_07.20.32.jpg?1703233932"
    },
    {
      chainId: 1,
      address: "0xe94e8e29bd3db22917e83d019af7babdf8b9adf6",
      name: "Dextensor",
      symbol: "TAOS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36136/thumb/Dextensor.png?1710599523"
    },
    {
      chainId: 1,
      address: "0xd3843c6be03520f45871874375d618b3c7923019",
      name: "Ordinal Bridge",
      symbol: "ORDIBRIDGE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33906/thumb/Ordibridge.jpeg?1703241141"
    },
    {
      chainId: 1,
      address: "0xf92d62ed69242d655e685c96b98f32f1409c3262",
      name: "AlienForm",
      symbol: "A4M",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34129/thumb/200x200_a4m_new.png?1712695102"
    },
    {
      chainId: 1,
      address: "0xb48fe88717c1a6020cc256a7d6f0e4a285bc9660",
      name: "Scom Coin",
      symbol: "SCOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33908/thumb/Scom_Coin.jpg?1703241874"
    },
    {
      chainId: 1,
      address: "0xf3ff80d631f7eec2c90180a3cddb3b95e87e2612",
      name: "Coco",
      symbol: "COCO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33949/thumb/IMG_7817.jpeg?1703537940"
    },
    {
      chainId: 1,
      address: "0x97d0cfeb4fde54b430307c9482d6f79c761fe9b6",
      name: "Epoch Island",
      symbol: "EPOCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33684/thumb/EpochLogo_200x200.png?1702731332"
    },
    {
      chainId: 1,
      address: "0x7236a7ad67976ee07961ab26ed6f4cd23f7a9bd1",
      name: "TXN Club",
      symbol: "TXN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33157/thumb/200x200.png?1700827374"
    },
    {
      chainId: 1,
      address: "0xa58a83361936471b50e2d1c7f99d422e6d73d397",
      name: "X Rise",
      symbol: "XRISE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33953/thumb/logo2x2.png?1703561044"
    },
    {
      chainId: 1,
      address: "0xc256f81d35a54c3599b424171d719e9ae87b2e9b",
      name: "Zoopia",
      symbol: "ZOOA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33955/thumb/twitter_D8EKrscj_400x400.jpg?1703561621"
    },
    {
      chainId: 1,
      address: "0x04815313e9329e8905a77251a1781cfa7934259a",
      name: "wagmicatgirlkanye420etfmoon1000x",
      symbol: "HOOD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33843/thumb/Hood.png?1703121051"
    },
    {
      chainId: 1,
      address: "0x74588af8de14287e91d89758636d277d66f217b6",
      name: "0xOS AI",
      symbol: "0XOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34007/thumb/0xOS_AI.png?1703621360"
    },
    {
      chainId: 1,
      address: "0xaedf386b755465871ff874e3e37af5976e247064",
      name: "Fasttoken",
      symbol: "FTN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28478/thumb/lightenicon_200x200.png?1696527472"
    },
    {
      chainId: 1,
      address: "0x4a029f7bcf33acb03547d8fa7be840347973e24e",
      name: "Mazze",
      symbol: "MAZZE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35548/thumb/logo200x200.png?1709094900"
    },
    {
      chainId: 1,
      address: "0xc28eb2250d1ae32c7e74cfb6d6b86afc9beb6509",
      name: "OPEN Ticketing Ecosystem",
      symbol: "OPN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36612/thumb/TOKEN.png?1711975511"
    },
    {
      chainId: 1,
      address: "0x8e1a7f380963945061c4460b0f9c6dc0bdafd94f",
      name: "XMas Santa Rally",
      symbol: "XMRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33777/thumb/IMG_6546.jpeg?1702970697"
    },
    {
      chainId: 1,
      address: "0xc9f00080d96cea3ef92d2e2e563d4cd41fb5bb36",
      name: "BLOX",
      symbol: "BLOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33794/thumb/BLOXLOGO200x200.png?1702989708"
    },
    {
      chainId: 1,
      address: "0x621879c6239d8ab9b82712fb56e7be880ce0c6ee",
      name: "OmniBotX",
      symbol: "OMNIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33588/thumb/Safeimagekit-resized-img_%2812%29.png?1702466793"
    },
    {
      chainId: 1,
      address: "0x30d0e4e6fb0330e45a13e1e06260837f27015de5",
      name: "Year of the Dragon",
      symbol: "YOD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34053/thumb/Year_of_the_Dragon.png?1703746442"
    },
    {
      chainId: 1,
      address: "0xdc7da87115d4464e8aac99920a533d401bf72a50",
      name: "ICE NET",
      symbol: "ICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34056/thumb/ICE-logo-01.png?1703748227"
    },
    {
      chainId: 1,
      address: "0x44ff8620b8ca30902395a7bd3f2407e1a091bf73",
      name: "Virtual Protocol",
      symbol: "VIRTUAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34057/thumb/LOGOMARK.png?1708356054"
    },
    {
      chainId: 1,
      address: "0x0f0bbaf936f7ada2aca5b80bed7b655758d66950",
      name: "WIFPEPEMOGINU",
      symbol: "WIFPEPEMOG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35686/thumb/200x200.jpg?1709531939"
    },
    {
      chainId: 1,
      address: "0xc71b5f631354be6853efe9c3ab6b9590f8302e81",
      name: "Polyhedra Network",
      symbol: "ZK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36198/thumb/ZK.jpg?1710812518"
    },
    {
      chainId: 1,
      address: "0x89d584a1edb3a70b3b07963f9a3ea5399e38b136",
      name: "AIT Protocol",
      symbol: "AIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33962/thumb/ait-logo-200x200.png?1703567800"
    },
    {
      chainId: 1,
      address: "0x8b227d72570d3ead66014bca8305cbef7f90d1ee",
      name: "LIZA",
      symbol: "LIZA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32841/thumb/Liza.png?1699589053"
    },
    {
      chainId: 1,
      address: "0xcb0d82f4dfa503c9e3b8abc7a3caa01175b2da39",
      name: "AurusX",
      symbol: "AX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27871/thumb/AurusX_token_2D.jpg?1696526889"
    },
    {
      chainId: 1,
      address: "0xe084d3069a9b6d1b2d09d21ffad4a03d1b6496da",
      name: "PUSHD",
      symbol: "PUSHD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34309/thumb/Pushd.jpg?1704614504"
    },
    {
      chainId: 1,
      address: "0xbd6323a83b613f668687014e8a5852079494fb68",
      name: "BlackrockTradingCurrency",
      symbol: "BTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34656/thumb/imresizer-%282%29.png?1705632165"
    },
    {
      chainId: 1,
      address: "0x00c2999c8b2adf4abc835cc63209533973718eb1",
      name: "New World Order",
      symbol: "STATE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27387/thumb/icon.png?1696526428"
    },
    {
      chainId: 1,
      address: "0x7567d006f6be77e3d87aa831855cb4102e37b17d",
      name: "Three Hundred AI",
      symbol: "THND",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0x72f713d11480dcf08b37e1898670e736688d218d",
      name: "Nettensor",
      symbol: "NAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35630/thumb/logoclip_%28200_x_200_piksel%29.png?1709293129"
    },
    {
      chainId: 1,
      address: "0x4b1e80cac91e2216eeb63e29b957eb91ae9c2be8",
      name: "Jupiter Project",
      symbol: "JUP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10351/thumb/logo512.png?1696510352"
    },
    {
      chainId: 1,
      address: "0xb9f69c75a3b67425474f8bcab9a3626d8b8249e1",
      name: "Memefi Toybox 404",
      symbol: "TOYBOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35147/thumb/200x200_MemeFI_logo.png?1707552368"
    },
    {
      chainId: 1,
      address: "0xb84f00b5ab187bc795d61389ac2418d4e7c77bb0",
      name: "Balance Network Finance",
      symbol: "BALANCE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34530/thumb/20240113_025010.png?1705307118"
    },
    {
      chainId: 1,
      address: "0xed9f6aa6532869576211fd6367e3c328810fbeb3",
      name: "GPTPlus",
      symbol: "GPTPLUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34194/thumb/gptplus-icon.png?1704272397"
    },
    {
      chainId: 1,
      address: "0xcf60870dcedcad18d987af20687ca4717cae0533",
      name: "Degen Fighting Championship",
      symbol: "DFC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34211/thumb/DFC-200x200.png?1704276680"
    },
    {
      chainId: 1,
      address: "0x3e156234501c41a041a178ff547e295609c4769a",
      name: "TeleCard",
      symbol: "TCARD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36073/thumb/IMG_1889_%281%29.png?1710412075"
    },
    {
      chainId: 1,
      address: "0xd05d90a656fc375ac1478689d7bcd31098f2dd1f",
      name: "ChainFactory",
      symbol: "FACTORY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34204/thumb/CFicon_200x200.png?1704275410"
    },
    {
      chainId: 1,
      address: "0xdc9cb148ecb70876db0abeb92f515a5e1dc9f580",
      name: "Green Bitcoin",
      symbol: "GBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37001/thumb/Green_Bitcoin.png?1713070667"
    },
    {
      chainId: 1,
      address: "0xf2dfdbe1ea71bbdcb5a4662a16dbf5e487be3ebe",
      name: "DeCloud",
      symbol: "CLOUD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35135/thumb/Nl1XLwPV_400x400.jpg?1707445040"
    },
    {
      chainId: 1,
      address: "0x04fa0d235c4abf4bcf4787af4cf447de572ef828",
      name: "UMA",
      symbol: "UMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10951/thumb/UMA.png?1696510900"
    },
    {
      chainId: 1,
      address: "0xc3d2b3e23855001508e460a6dbe9f9e3116201af",
      name: "GATEWAY TO MARS",
      symbol: "MARS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34083/thumb/MARS-LOGO-BLACK-200x200.png?1703910355"
    },
    {
      chainId: 1,
      address: "0x0aa8a7d1fb4c64b3b1dcea9a7ade81c59c25b95b",
      name: "AstraAI",
      symbol: "ASTRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33138/thumb/CG_200x200.png?1700810557"
    },
    {
      chainId: 1,
      address: "0x2a8d8fcb18d132d77373eb02b22d8e7d378f4437",
      name: "TeraHertz Capital",
      symbol: "THZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34283/thumb/CmDc-Q7W_400x400_%281%29.jpg?1704453174"
    },
    {
      chainId: 1,
      address: "0x56d811088235f11c8920698a204a5010a788f4b3",
      name: "bZx Protocol",
      symbol: "BZRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11811/thumb/bzrx.png?1696511684"
    },
    {
      chainId: 1,
      address: "0x9c2b4b0da5ebd20c29ef20758064554a55a88b68",
      name: "ByteAI",
      symbol: "BYTE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36432/thumb/photo_2024-03-20_20.40.45.jpeg?1711435137"
    },
    {
      chainId: 1,
      address: "0x046eee2cc3188071c02bfc1745a6b17c656e3f3d",
      name: "Rollbit Coin",
      symbol: "RLB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24552/thumb/unziL6wO_400x400.jpg?1696523729"
    },
    {
      chainId: 1,
      address: "0xd7c9f0e536dc865ae858b0c0453fe76d13c3beac",
      name: "XAI Stablecoin",
      symbol: "XAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28254/thumb/Xai_logo.png?1696527256"
    },
    {
      chainId: 1,
      address: "0xe469699f617bfd0fbffcd575970d34c2cecffa9f",
      name: "VuzzMind",
      symbol: "VUZZ",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34294/thumb/tokenlogogecko.png?1704606291"
    },
    {
      chainId: 1,
      address: "0xcd24ba0e3364233ee9301c1d608a14753c8739c5",
      name: "DeepSouth AI",
      symbol: "SOUTH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34348/thumb/CGpng.png?1704701256"
    },
    {
      chainId: 1,
      address: "0x0808e6c4400bde1d70db0d02170b67de05e07ef5",
      name: "Wrapped LYX  SigmaSwap ",
      symbol: "WLYX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34338/thumb/wLYX.png?1704679928"
    },
    {
      chainId: 1,
      address: "0xc5170dd7386247cdb8c48545c803f5d0e3347022",
      name: "Titanium22",
      symbol: "TI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31197/thumb/200PX.png?1704048243"
    },
    {
      chainId: 1,
      address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
      name: "DODO",
      symbol: "DODO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12651/thumb/dodo_logo.png?1696512458"
    },
    {
      chainId: 1,
      address: "0xe4b4c008ff36e3c50c4299c223504a480de9c833",
      name: "Secret Society",
      symbol: "SS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36865/thumb/622BD442-4493-4AF9-8DF9-CF464B7AFC44.png?1712644574"
    },
    {
      chainId: 1,
      address: "0xcffcfdada28ab44d5440301470dcd410e75c4765",
      name: "Parifi",
      symbol: "PRF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34710/thumb/parifi200x200.png?1705894380"
    },
    {
      chainId: 1,
      address: "0xeac32927cf2785cbe0d515298cab448538a8cdd7",
      name: "StudioAi",
      symbol: "SAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34468/thumb/200x200.png?1704968139"
    },
    {
      chainId: 1,
      address: "0x26a37f5a0200ad622f6db7cd687c78b7049ee841",
      name: "WatchTowers AI",
      symbol: "WTS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34469/thumb/wts.jpeg?1704968199"
    },
    {
      chainId: 1,
      address: "0x078c4adf3fee52eb77f6018d9805dfc69e911d39",
      name: "Eternity GLORY Token",
      symbol: "GLORY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34903/thumb/glory-200x200.png?1706594822"
    },
    {
      chainId: 1,
      address: "0xab14f1262ea8d910756828cbe08e6cedfb66360d",
      name: "TORO",
      symbol: "TORO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34442/thumb/T_coin.png?1704874974"
    },
    {
      chainId: 1,
      address: "0x3235b13708f178af6f110de7177ed5de10c1093d",
      name: "Mongol NFT",
      symbol: "MNFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23718/thumb/swI93LWg_400x400.jpg?1696522918"
    },
    {
      chainId: 1,
      address: "0x6733f0283711f225a447e759d859a70b0c0fd2bc",
      name: "Vector Reserve Staked vETH",
      symbol: "SVETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35289/thumb/svETH200.png?1709593889"
    },
    {
      chainId: 1,
      address: "0x3ecab35b64345bfc472477a653e4a3abe70532d9",
      name: "EnterButton",
      symbol: "ENTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19677/thumb/ENTC_symbol.png?1696519104"
    },
    {
      chainId: 1,
      address: "0x6c10d1611a5a95cb967e4bcab5791fd101194949",
      name: "X Project ERC",
      symbol: "XERS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35009/thumb/xofficiallogobluesky.jpg?1707101426"
    },
    {
      chainId: 1,
      address: "0xe80c0cd204d654cebe8dd64a4857cab6be8345a3",
      name: "JPEG d  OLD ",
      symbol: "JPEG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24025/thumb/et_43CNi_400x400.jpg?1696523217"
    },
    {
      chainId: 1,
      address: "0x2f3d0d2317802a65faac6e4cd94067c37b4d4804",
      name: "DECENTRACARD",
      symbol: "DCARD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34533/thumb/DC_Logo_5_200x200.png?1705323804"
    },
    {
      chainId: 1,
      address: "0x20bc71ddf242b88502d9819e02d45ad0d4a586c8",
      name: "Gravitron",
      symbol: "GTRON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33622/thumb/photo_2023-12-13_08-36-33.jpg?1702529102"
    },
    {
      chainId: 1,
      address: "0x33f289d91286535c47270c8479f6776fb3adeb3e",
      name: "BoxBet",
      symbol: "BXBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32495/thumb/logo.png?1706725462"
    },
    {
      chainId: 1,
      address: "0xfeff7b68bc540826da22b296c82a4b8b6b845f41",
      name: "United Emirates Of Fun",
      symbol: "UEFN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34353/thumb/LOGO_200.png?1704703932"
    },
    {
      chainId: 1,
      address: "0xbded8a4dc74a940eab68703167db89b1712b68ea",
      name: "KASPAMINING",
      symbol: "KMN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34451/thumb/logo_200x200.png?1704901486"
    },
    {
      chainId: 1,
      address: "0x5c1ac4e697a2814812a284509e1f1b8aa34a25f3",
      name: "Avante",
      symbol: "AXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33667/thumb/logo.png.png?1702693688"
    },
    {
      chainId: 1,
      address: "0x75858677e27c930fb622759feaffee2b754af07f",
      name: "Phantasma",
      symbol: "SOUL",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/4130/thumb/phantasma.png?1696504758"
    },
    {
      chainId: 1,
      address: "0x2a85556a6701a02e75bc4de8ec340c6de1b29f72",
      name: "TOKA",
      symbol: "TOKA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34418/thumb/photo_2023-12-22_23.51.07_%281%29_2.jpeg?1704821179"
    },
    {
      chainId: 1,
      address: "0x3632dc4d741bfa40dbf3b23b63dd3a25a3061de3",
      name: "0xEngage",
      symbol: "ENGAGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34420/thumb/200x200.png?1704821589"
    },
    {
      chainId: 1,
      address: "0x8ab2ff0116a279a99950c66a12298962d152b83c",
      name: "Ordiswap",
      symbol: "ORDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33910/thumb/IMG-20240113-WA0018.jpg.jpg?1705169306"
    },
    {
      chainId: 1,
      address: "0xce722f60f35c37ab295adc4e6ba45bcc7ca89dd6",
      name: "JPEG d",
      symbol: "JPGD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35303/thumb/jpgd.jpeg?1708095973"
    },
    {
      chainId: 1,
      address: "0xae54e48c2263e889399ad29bfff401feaf08fd57",
      name: "DiversityEquity Inclusion",
      symbol: "DEI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34535/thumb/Wei_Icon.png?1705324644"
    },
    {
      chainId: 1,
      address: "0x15f73a3ab443ee6ebf36c605c7868159ce5d028c",
      name: "SmartsetToken",
      symbol: "SST",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34385/thumb/IMG_6239.jpeg?1704779818"
    },
    {
      chainId: 1,
      address: "0xfc5e4ed56153b57aa8ef769eba3e79e58e19be93",
      name: "SOLAV",
      symbol: "SOLAV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34483/thumb/White_Background.png?1705042967"
    },
    {
      chainId: 1,
      address: "0x0af55d5ff28a3269d69b98680fd034f115dd53ac",
      name: "BankSocial",
      symbol: "BSL",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/15738/thumb/banksocial_small.png?1696515363"
    },
    {
      chainId: 1,
      address: "0x4e241a9ec66832a16bceaeb9156e524487f061d7",
      name: "ETF Rocks",
      symbol: "ETF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34633/thumb/logo-etf-color-200x200.png?1705548981"
    },
    {
      chainId: 1,
      address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
      name: "The Sandbox",
      symbol: "SAND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12129/thumb/sandbox_logo.jpg?1696511971"
    },
    {
      chainId: 1,
      address: "0xd836d22531d810f192ba6bd0ba3c28c35d4606c2",
      name: "BONKBEST",
      symbol: "BONKBEST",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34421/thumb/IMG_20240108_204110_824.jpg?1704821712"
    },
    {
      chainId: 1,
      address: "0x44c7272b212e033d71b694733c150ff8526c1a0e",
      name: "Crimson",
      symbol: "CRM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34383/thumb/Crimson.png?1704779607"
    },
    {
      chainId: 1,
      address: "0x3b0fccbd5dae0570a70f1fb6d8d666a33c89d71e",
      name: "FloorDAO",
      symbol: "FLOOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35217/thumb/1_MH1_7DcG64sDKJMnz_SFNg.png?1707907538"
    },
    {
      chainId: 1,
      address: "0x186ef81fd8e77eec8bffc3039e7ec41d5fc0b457",
      name: "Inspect",
      symbol: "INSP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33422/thumb/200_%281%29.png?1701767509"
    },
    {
      chainId: 1,
      address: "0x12ef10a4fc6e1ea44b4ca9508760ff51c647bb71",
      name: "Restake Finance",
      symbol: "RSTK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33885/thumb/rstk.png?1703148117"
    },
    {
      chainId: 1,
      address: "0x8b9b95292f890df47fff5ac9cbe93d5fc242bd51",
      name: "BeFi Labs",
      symbol: "BEFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34384/thumb/Logo1_Brave.png?1704779725"
    },
    {
      chainId: 1,
      address: "0x8b3870df408ff4d7c3a26df852d41034eda11d81",
      name: "IOI Token",
      symbol: "IOI",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/15952/thumb/IOI_new_logo.png?1696515564"
    },
    {
      chainId: 1,
      address: "0x550775e17ed6767621a1aed580e6eb29ede981e9",
      name: "Agnus AI",
      symbol: "AGN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34387/thumb/photo_2024-01-08_14.11.37.jpeg?1704780575"
    },
    {
      chainId: 1,
      address: "0x92098551e613dfdcd4d7c7b2c35615709e4e0397",
      name: "ArtemisAI",
      symbol: "ATAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34452/thumb/black_logo_big.png?1704931121"
    },
    {
      chainId: 1,
      address: "0x45b3cf56896c4547426a4145ad1d0ae971120214",
      name: "404Blocks",
      symbol: "404BLOCKS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35219/thumb/404.png?1707918003"
    },
    {
      chainId: 1,
      address: "0xedb73d4ed90be7a49d06d0d940055e6d181d22fa",
      name: "Blueprint oBLUE",
      symbol: "OBLUE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35539/thumb/photo_2024-02-17_18-41-11.jpg?1709089813"
    },
    {
      chainId: 1,
      address: "0xcd8c163cc0ec3a53ce6bec89e665fb97cce51c42",
      name: "beecasinogames",
      symbol: "BEECASINO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36435/thumb/beecasino-profile.jpg?1711438474"
    },
    {
      chainId: 1,
      address: "0x55ff0f50f639e7acfe06694e6d018bd7678e6da9",
      name: "Mineshield",
      symbol: "MNS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36625/thumb/MINESHIELD_200x200.png?1711982251"
    },
    {
      chainId: 1,
      address: "0xcefde37817da4fc51ddc24e3820ad316784ee04b",
      name: "Sonata Network",
      symbol: "SONA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34486/thumb/IMG_20240111_220818_164.png?1705044900"
    },
    {
      chainId: 1,
      address: "0x3a429a151ad985e678a834f9db057163181f58e8",
      name: "ENCRYPT",
      symbol: "ENCR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34271/thumb/EncryptLogo.jpg?1714457885"
    },
    {
      chainId: 1,
      address: "0x03dde9e5bb31ee40a471476e2fccf75c67921062",
      name: "EML Protocol",
      symbol: "EML",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30950/thumb/EML_LOGO.png?1696529788"
    },
    {
      chainId: 1,
      address: "0x51d29b072ff42c712e4185723a5a7974920995ed",
      name: "ChartHub",
      symbol: "CHT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34456/thumb/photo_2024-01-08_00-43-08_%282%29.jpg?1704933058"
    },
    {
      chainId: 1,
      address: "0x102fa93ef3d2dc5b0b9ed3e7b3bf832796cb7b95",
      name: "Boss Blockchain",
      symbol: "BBC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34400/thumb/Safeimagekit-resized-img_%2820%29.png?1704788308"
    },
    {
      chainId: 1,
      address: "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
      name: "ParaSwap",
      symbol: "PSP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20403/thumb/ep7GqM19_400x400.jpg?1696519812"
    },
    {
      chainId: 1,
      address: "0xa562912e1328eea987e04c2650efb5703757850c",
      name: "Drops",
      symbol: "DROPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35795/thumb/IMG_1170_%282%29.jpeg?1709801958"
    },
    {
      chainId: 1,
      address: "0xfae103dc9cf190ed75350761e95403b7b8afa6c0",
      name: "Restaked Swell ETH",
      symbol: "RSWETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34489/thumb/rswETH_Icon.png?1706865484"
    },
    {
      chainId: 1,
      address: "0x76952fc1087fdae2e6aa4e5a1cec9e1117a60b00",
      name: "NY Blockchain",
      symbol: "NYBC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34462/thumb/NYBC-200X200_%E7%94%BB%E6%9D%BF_1_%E5%89%AF%E6%9C%AC_29.jpg?1704961756"
    },
    {
      chainId: 1,
      address: "0x943af2ece93118b973c95c2f698ee9d15002e604",
      name: "GameGPT",
      symbol: "DUEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34491/thumb/duel.jpeg?1705056819"
    },
    {
      chainId: 1,
      address: "0x574d22e2555cac0ce71e44778f6de2e7487ae229",
      name: "SoonVerse",
      symbol: "SOON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29448/thumb/1.png?1696528395"
    },
    {
      chainId: 1,
      address: "0xbbbbbbbb46a1da0f0c3f64522c275baa4c332636",
      name: "ZKBase",
      symbol: "ZKB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13585/thumb/image_2024-01-16_172847810.png?1705397359"
    },
    {
      chainId: 1,
      address: "0x72fc1c1c926bd26712f62e7485392cd405478f05",
      name: "Bark Gas Token",
      symbol: "BARK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34562/thumb/Bark_Gas_Token.png?1705400669"
    },
    {
      chainId: 1,
      address: "0x40e64405f18e4fb01c6fc39f4f0c78df5ef9d0e0",
      name: "Cosmic Network",
      symbol: "COSMIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37006/thumb/cosmic.jpeg?1713072590"
    },
    {
      chainId: 1,
      address: "0x8248270620aa532e4d64316017be5e873e37cc09",
      name: "DevvE",
      symbol: "DEVVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35136/thumb/DevvE.png?1707445824"
    },
    {
      chainId: 1,
      address: "0x91dfbee3965baaee32784c2d546b7a0c62f268c9",
      name: "Forj",
      symbol: "BONDLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13322/thumb/FORJ_twitter_twitter-linked_in_profile_%281%29.png?1696513091"
    },
    {
      chainId: 1,
      address: "0x9bf3be1e445d5d386f891a1eccc3245e5a3670a4",
      name: "FACET",
      symbol: "FACET",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34825/thumb/FACET.jpg?1706191458"
    },
    {
      chainId: 1,
      address: "0xf2fdd9c25d7bc8002ce89716d1be484b2d976944",
      name: "  Payments",
      symbol: "XPAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34745/thumb/xpay_%281%29.jpg?1705949795"
    },
    {
      chainId: 1,
      address: "0xc0b6addde76be6a09231edc12a5e3794c11f594f",
      name: "FlexGPU",
      symbol: "FGPU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35796/thumb/flexGPU.png?1709802187"
    },
    {
      chainId: 1,
      address: "0x7c5b267ed81009aa7374b5ca7e5137da47045ba8",
      name: "TAIKAI",
      symbol: "TKAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34827/thumb/TKAI.jpg?1706191900"
    },
    {
      chainId: 1,
      address: "0x2e1cb26689a0b8763d15ffe9d7b1c637cd9282d4",
      name: "OPTA Global",
      symbol: "OPTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37257/thumb/CMClogo.png?1713865216"
    },
    {
      chainId: 1,
      address: "0xb551b43af192965f74e3dfaa476c890b403cad95",
      name: "DataBot",
      symbol: "DATA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31508/thumb/Databot_LOGO_coingecko.png?1696530318"
    },
    {
      chainId: 1,
      address: "0x8d9d725aaa3f6236763ff548051657a342c37623",
      name: "NED",
      symbol: "NED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34704/thumb/NED_logo_%281%29.png?1705891856"
    },
    {
      chainId: 1,
      address: "0xecd48f326e70388d993694de59b4542ce8af7649",
      name: "Froggy Friends",
      symbol: "TADPOLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35138/thumb/tadpole.jpeg?1707447320"
    },
    {
      chainId: 1,
      address: "0x6c061d18d2b5bbfbe8a8d1eeb9ee27efd544cc5d",
      name: "Monarch",
      symbol: "MNRCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35139/thumb/mnrc.jpeg?1707449200"
    },
    {
      chainId: 1,
      address: "0xce246eea10988c495b4a90a905ee9237a0f91543",
      name: "VaultCraft",
      symbol: "VCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33237/thumb/VCX_Token_200x200.png?1701147660"
    },
    {
      chainId: 1,
      address: "0xb369daca21ee035312176eb8cf9d88ce97e0aa95",
      name: "Skol",
      symbol: "SKOL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35934/thumb/skollogo_200x200.png?1710264034"
    },
    {
      chainId: 1,
      address: "0x218de5e6324c5351c3a2bf0c40d76f585b8de04d",
      name: "Stake Together",
      symbol: "STPETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34709/thumb/stake-together.png?1705894276"
    },
    {
      chainId: 1,
      address: "0x9ab51734fc5d5fdd8abb58941840a5df1e3f3a99",
      name: "Olympia AI",
      symbol: "PIA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37261/thumb/olym200.png?1713866464"
    },
    {
      chainId: 1,
      address: "0x949d48eca67b17269629c7194f4b727d4ef9e5d6",
      name: "Merit Circle",
      symbol: "MC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19304/thumb/Db4XqML.png?1696518747"
    },
    {
      chainId: 1,
      address: "0x525a8f6f3ba4752868cde25164382bfbae3990e1",
      name: "Nym",
      symbol: "NYM",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/24488/thumb/NYM_Token.png?1696523668"
    },
    {
      chainId: 1,
      address: "0xbc391e78b0ea0d1db04890732742494e7fbfc118",
      name: "NIRVANA",
      symbol: "VANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32469/thumb/vana.jpg?1698259899"
    },
    {
      chainId: 1,
      address: "0xa067237f8016d5e3770cf08b20e343ab9ee813d5",
      name: "Greelance",
      symbol: "GRL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31387/thumb/G-logo.jpg?1696530204"
    },
    {
      chainId: 1,
      address: "0x9511ff502f982643935a39206f98a6c18d4527cf",
      name: "BlockDefend AI",
      symbol: "DEFEND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36438/thumb/BlockDefend_AI.png?1711440094"
    },
    {
      chainId: 1,
      address: "0x6553565eac5daa9bfc5e2892b36291634c9b2ad6",
      name: "Rake com",
      symbol: "RAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33791/thumb/rake_200x200.png?1702988861"
    },
    {
      chainId: 1,
      address: "0xfe98796e0af4ababd716508429e51ff9ac1bb4d5",
      name: "Transactra Finance",
      symbol: "TRSCT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35636/thumb/logo.png?1709294261"
    },
    {
      chainId: 1,
      address: "0x069d89974f4edabde69450f9cf5cf7d8cbd2568d",
      name: "BVM",
      symbol: "BVM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35938/thumb/twitter-pfp.png?1710232498"
    },
    {
      chainId: 1,
      address: "0x5e21d1ee5cf0077b314c381720273ae82378d613",
      name: "The Infinite Garden",
      symbol: "ETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34540/thumb/film.jpg?1705338132"
    },
    {
      chainId: 1,
      address: "0xc01154b4ccb518232d6bbfc9b9e6c5068b766f82",
      name: "NEXUS",
      symbol: "NEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35797/thumb/LLm7P2IL_400x400.jpg?1709802342"
    },
    {
      chainId: 1,
      address: "0xde5d2530a877871f6f0fc240b9fce117246dadae",
      name: "Juice",
      symbol: "JUICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35942/thumb/juiceCG.png?1710233232"
    },
    {
      chainId: 1,
      address: "0x95fe3151105ad90c6dc30dc51fdf038ae7bb7f77",
      name: "Blackder AI",
      symbol: "BLD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37259/thumb/200x200.png?1713865886"
    },
    {
      chainId: 1,
      address: "0x00b4651795193daca7e73b5ddd031dfde8ca5720",
      name: "CHAINMAIL",
      symbol: "MAIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33431/thumb/Z_hlFCgV_400x400.jpg?1701818031"
    },
    {
      chainId: 1,
      address: "0x750c3a0a0ce9984eeb8c5d146dff024b584e5e33",
      name: "zkHive",
      symbol: "ZKHIVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35940/thumb/IMG_4449.jpeg?1710233140"
    },
    {
      chainId: 1,
      address: "0xf96287ea71abb5c8c58961c7a3cd3982a505e264",
      name: "Stem AI",
      symbol: "STEM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34660/thumb/Stem_AI.png?1705636636"
    },
    {
      chainId: 1,
      address: "0x0f5c78f152152dda52a2ea45b0a8c10733010748",
      name: "XOX Labs",
      symbol: "XOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34611/thumb/0164CF6D-8683-418C-9ACB-C6D63B9E1CCB.jpeg?1705499880"
    },
    {
      chainId: 1,
      address: "0xe2976a66e8cef3932cdaeb935e114dcd5ce20f20",
      name: "ChessFish",
      symbol: "CFSH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34623/thumb/TokenLogo.png?1705504570"
    },
    {
      chainId: 1,
      address: "0x8ed2fc62d6850eaadcb717465752dab591286839",
      name: "Elyssa",
      symbol: "ELY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31187/thumb/IMG_20230720_174915_364.jpg?1696530014"
    },
    {
      chainId: 1,
      address: "0x619e398858a3110df4d89056a15a40338a01e65f",
      name: "Garbage",
      symbol: "GARBAGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33624/thumb/CircleLogo_200x200_EH_%281%29.png?1702532702"
    },
    {
      chainId: 1,
      address: "0x179f782d7fbe745f40b20e0c7dbb6205d43fa4b9",
      name: "Inspire AI",
      symbol: "INSP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35540/thumb/VJwHPSjF_200x200.jpg?1709092810"
    },
    {
      chainId: 1,
      address: "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f",
      name: "OriginTrail",
      symbol: "TRAC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1877/thumb/TRAC.jpg?1696502873"
    },
    {
      chainId: 1,
      address: "0x4447743d42680f7fbb56e87b3617463113ca649e",
      name: "MeshWave",
      symbol: "MWAVE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36696/thumb/ava-1_%281%29.png?1712117270"
    },
    {
      chainId: 1,
      address: "0xa711bcc2b6f5c4fc3dfaccc2a01148765cbbab1c",
      name: "Grok1 5",
      symbol: "GROK15",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34838/thumb/IMG_20240123_045540_147.jpg?1706240605"
    },
    {
      chainId: 1,
      address: "0xbf1aa3a0e1294b3b996533f5d648dec2e59bad05",
      name: "Funarcade",
      symbol: "FAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34767/thumb/FAT_logo_200x200.png?1705992218"
    },
    {
      chainId: 1,
      address: "0x2960d71855a521c8414d29a27218efdb67c34180",
      name: "Leaxcoin",
      symbol: "LEAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6918/thumb/X_C0tYzl_400x400.jpg?1696507236"
    },
    {
      chainId: 1,
      address: "0x1650978997e5898db8eeffdb7c530bb223b71c79",
      name: "Flashpad Token",
      symbol: "FLASH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34835/thumb/200.jpg?1706230764"
    },
    {
      chainId: 1,
      address: "0xdefb0b264032e4e128b00d02b3fd0aa00331237b",
      name: "Buddha",
      symbol: "BUDDHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34079/thumb/BUDDHA-Profile_Pic_111.png?1714503766"
    },
    {
      chainId: 1,
      address: "0x5d56b6581d2e7e7574adce2dc593f499a53d7505",
      name: "Church of the Machina",
      symbol: "MACHINA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34720/thumb/machina_logo.png?1705916393"
    },
    {
      chainId: 1,
      address: "0x96a5399d07896f757bd4c6ef56461f58db951862",
      name: "DragonX win",
      symbol: "DRAGONX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34724/thumb/DragonX_%281%29.png?1705918646"
    },
    {
      chainId: 1,
      address: "0x661013bb8d1c95d86d9c85f76e9004561f1bb36f",
      name: "DeFi Robot",
      symbol: "DRBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34725/thumb/defiRobot-logo.jpg?1705918727"
    },
    {
      chainId: 1,
      address: "0x435998003ccb7abeaa392494c89f7799fe241db5",
      name: "Interns",
      symbol: "INTERN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34727/thumb/IMG_1926.jpeg?1705919202"
    },
    {
      chainId: 1,
      address: "0x61b57bdc01e3072fab3e9e2f3c7b88d482734e05",
      name: "MetaZooMee",
      symbol: "MZM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31708/thumb/MZM-200px_%281%29.png?1696530531"
    },
    {
      chainId: 1,
      address: "0x148255a3b10666d9788ec48bc61ea3e48974bf2c",
      name: "Decentralized Music Chain",
      symbol: "DMCC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34760/thumb/feed.jpeg?1705985058"
    },
    {
      chainId: 1,
      address: "0xd57187e56e5b31b4d7813d7ceea1e9f9b97ee82f",
      name: "zkInfra",
      symbol: "ZKIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36517/thumb/IMG_20240327_124751_784.jpg?1711694787"
    },
    {
      chainId: 1,
      address: "0x8ccd897ca6160ed76755383b201c1948394328c7",
      name: "Balance AI",
      symbol: "BAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34732/thumb/Balance_AI.png?1705921540"
    },
    {
      chainId: 1,
      address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
      name: "Cartesi",
      symbol: "CTSI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11038/thumb/Cartesi_Logo.png?1696510982"
    },
    {
      chainId: 1,
      address: "0xf4cccfda0781ae019a9d4e1853dcd3e288daaa89",
      name: "Da Pinchi",
      symbol: "PINCHI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34739/thumb/CGTlogo.png?1705946139"
    },
    {
      chainId: 1,
      address: "0x7ae4f8885f6cfa41a692cb9da3789cfa6a83e9f2",
      name: "GenomesDAO GENOME",
      symbol: "GENOME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36763/thumb/images.jpg?1712282056"
    },
    {
      chainId: 1,
      address: "0xa1f3aca66403d29b909605040c30ae1f1245d14c",
      name: "Adapt3r Digital Treasury Bill Fund",
      symbol: "TFBILL",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/34761/thumb/s3hkVoBT_400x400.png?1705986984"
    },
    {
      chainId: 1,
      address: "0x80d69e79258fe9d056c822461c4eb0b4ca8802e2",
      name: "Inception rETH",
      symbol: "INRETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34956/thumb/rETH.png?1706773577"
    },
    {
      chainId: 1,
      address: "0xd8f1460044925d2d5c723c7054cd9247027415b7",
      name: "Clipper SAIL",
      symbol: "SAIL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31380/thumb/SAIL-Logo.png?1696530197"
    },
    {
      chainId: 1,
      address: "0x1c2884c71629c7d4e378ec95d03bfaf9f6fa5afe",
      name: "Bundl Tools",
      symbol: "BUNDL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34748/thumb/Bundl_Tools.png?1705953621"
    },
    {
      chainId: 1,
      address: "0x0b6f3ea2814f3fff804ba5d5c237aebbc364fba9",
      name: "Unagi Token",
      symbol: "UNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34733/thumb/unagi.png?1705922276"
    },
    {
      chainId: 1,
      address: "0xdc63269ea166b70d4780b3a11f5c825c2b761b01",
      name: "PAWSWAP",
      symbol: "PAW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28946/thumb/PawLogo.png?1699394612"
    },
    {
      chainId: 1,
      address: "0xc3cc3076cb304494775b3193ef1aa080ba6bf962",
      name: "OrdiGen",
      symbol: "ODGN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34881/thumb/ODGN.jpg?1706499113"
    },
    {
      chainId: 1,
      address: "0x50b806c5fe274c07e46b96be8c68d2fd2d9597b4",
      name: "TUCKER CARLSON",
      symbol: "TUCKER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34804/thumb/tucker_logo_transparent.png?1706094592"
    },
    {
      chainId: 1,
      address: "0x5f48d1fd6814cd1cd38aeb895755e57d519196d1",
      name: "Trophy",
      symbol: "WINS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31007/thumb/icon_wins.png?1696529844"
    },
    {
      chainId: 1,
      address: "0x7340ea46360576dc46ef49bce99bc5072c32421d",
      name: "DollarSqueeze",
      symbol: "DSQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30764/thumb/DS.png?1696529632"
    },
    {
      chainId: 1,
      address: "0xd4318fa09c45cfb6355ded6085b0d698b64ec1cd",
      name: "Federal AI",
      symbol: "FEDAI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/34912/thumb/fed-ai-logo-200px.png?1706604536"
    },
    {
      chainId: 1,
      address: "0xb19189fb36c816f3e0f16065057b07b790998fdc",
      name: "Serum SER",
      symbol: "SER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27757/thumb/Untitled_%28200_x_200_px%29.png?1699041628"
    },
    {
      chainId: 1,
      address: "0xb9f599ce614feb2e1bbe58f180f370d05b39344e",
      name: "PepeFork",
      symbol: "PORK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34913/thumb/pork.png?1706606047"
    },
    {
      chainId: 1,
      address: "0x576e2bed8f7b46d34016198911cdf9886f78bea7",
      name: "MAGA",
      symbol: "TRUMP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31498/thumb/Maga-Trump-Logo-200px.png?1696530309"
    },
    {
      chainId: 1,
      address: "0x891de5f139791ddf9dbabf519cfe2a049f8fc6d3",
      name: "Dibbles",
      symbol: "DIBBLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34860/thumb/dibbles_logo.png?1706351813"
    },
    {
      chainId: 1,
      address: "0x3a97e00b48d56bd5e0502e1a2a8c036a040e1b99",
      name: "JACKBOT",
      symbol: "JBOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34177/thumb/JBOT.jpg?1704219980"
    },
    {
      chainId: 1,
      address: "0xc4727c419acfb49c8660736506ca023a4e8509e0",
      name: "NodifiAI",
      symbol: "NODIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36795/thumb/dexcreener_%281%29.png?1712434294"
    },
    {
      chainId: 1,
      address: "0xa74a05b17d72e9b0781d973e7963dfaacd266b94",
      name: "Oasis",
      symbol: "OASIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35546/thumb/IMG_20240224_152139_778.png?1709094500"
    },
    {
      chainId: 1,
      address: "0xec70ff4a5b09110e4d20ada4f2db4a86ec61fac6",
      name: "Grape",
      symbol: "GRP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31106/thumb/grape_logo-removebg-preview_%281%29.png?1696529937"
    },
    {
      chainId: 1,
      address: "0xc8bf8bc34874e07f6a0d4abc8be22ba9e372631b",
      name: "SmartWorld Global Token",
      symbol: "SWGT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/35040/thumb/IMG_20240204_024533_022.png?1707192592"
    },
    {
      chainId: 1,
      address: "0x95d8bf2f57cf973251972b496dc6b1d9c6b5bce3",
      name: "Blue",
      symbol: "BLUE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35234/thumb/photo_2023-11-08_08-59-01-removebg-preview-removebg-preview.png?1707935380"
    },
    {
      chainId: 1,
      address: "0x504624040e0642921c2c266a9ac37cafbd8cda4e",
      name: "Love Power Coin",
      symbol: "LOVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37561/thumb/LOVE.jpg?1714874439"
    },
    {
      chainId: 1,
      address: "0xc106b98c4d0b3f1c92da0e9a6089e9c63ceacbb0",
      name: "TrendAppend",
      symbol: "TRND",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35190/thumb/TrendApp_-_Copy.jpg?1707817712"
    },
    {
      chainId: 1,
      address: "0x926ff6584b5905cc793cfb19bfc0ad6443671f47",
      name: "Pablo DeFi",
      symbol: "PABLO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34799/thumb/FSNlYKG.png?1706074430"
    },
    {
      chainId: 1,
      address: "0x77be1ba1cd2d7a63bffc772d361168cc327dd8bc",
      name: "Meow Meow Coin",
      symbol: "MEOW",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35079/thumb/meow.jpeg?1707301706"
    },
    {
      chainId: 1,
      address: "0xd555498a524612c67f286df0e0a9a64a73a7cdc7",
      name: "DeFrogs",
      symbol: "DEFROGS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35080/thumb/defrogs.jpeg?1707303202"
    },
    {
      chainId: 1,
      address: "0x6953f27db0701e22616e701dba91acc2e4b6deca",
      name: "Starbot",
      symbol: "STAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34917/thumb/Logo_transparent_small.png?1706613080"
    },
    {
      chainId: 1,
      address: "0x3e362038fd3d08887d498944d489af7909619a9b",
      name: "CHOW CHOW",
      symbol: "CHOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34803/thumb/CHOW_CHOW.png?1706094366"
    },
    {
      chainId: 1,
      address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
      name: "Powerledger",
      symbol: "POWR",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/1104/thumb/Powerledger_Northstar_colour_digital_%282%29.png?1706702222"
    },
    {
      chainId: 1,
      address: "0x5eed99d066a8caf10f3e4327c1b3d8b673485eed",
      name: "Garden",
      symbol: "SEED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34671/thumb/icon.png?1705656915"
    },
    {
      chainId: 1,
      address: "0xdfb03da57a3c56124c72a47729a1d0ed54d38ff5",
      name: "Hedex",
      symbol: "HEDEX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35236/thumb/IMG_8082.png?1707935959"
    },
    {
      chainId: 1,
      address: "0xea81dab2e0ecbc6b5c4172de4c22b6ef6e55bd8f",
      name: "Plebbit",
      symbol: "PLEB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31903/thumb/WgMdNjT4_400x400.png?1696530713"
    },
    {
      chainId: 1,
      address: "0xf091867ec603a6628ed83d274e835539d82e9cc8",
      name: "ZetaChain",
      symbol: "ZETA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26718/thumb/Twitter_icon.png?1696525788"
    },
    {
      chainId: 1,
      address: "0x613577bfea8ba6571f6b7a86716d04c80a3fbeb4",
      name: "LNDRY",
      symbol: "LNDRY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33357/thumb/lndry.jpeg?1701602475"
    },
    {
      chainId: 1,
      address: "0x9a96ec9b57fb64fbc60b423d1f4da7691bd35079",
      name: "Ajna Protocol",
      symbol: "AJNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30187/thumb/AJNA-Icon-200.png?1696529105"
    },
    {
      chainId: 1,
      address: "0x944824290cc12f31ae18ef51216a223ba4063092",
      name: "Masa",
      symbol: "MASA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35538/thumb/masa.png?1712635899"
    },
    {
      chainId: 1,
      address: "0xb3999f658c0391d94a37f7ff328f3fec942bcadc",
      name: "Hashflow",
      symbol: "HFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26136/thumb/hashflow-icon-cmc.png?1696525224"
    },
    {
      chainId: 1,
      address: "0x5a9261b023692405f2f680240c6b010638e416dd",
      name: "Storm Warfare",
      symbol: "JAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35045/thumb/janus_token.jpeg?1707201471"
    },
    {
      chainId: 1,
      address: "0xb7037457de15fed6cbecc0c62d5d610834b958ec",
      name: "Whirl",
      symbol: "WHIRL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34966/thumb/CG_LOGO.png?1706806621"
    },
    {
      chainId: 1,
      address: "0xa8dfdfdf9d288e909a96178e15731a6f4048a7aa",
      name: "ScanAI",
      symbol: "SCAN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34970/thumb/1000005375.jpg?1706851346"
    },
    {
      chainId: 1,
      address: "0x8110af6bd2af3f5c4586032ff813c8934451abbe",
      name: "Cypher AI",
      symbol: "CYPHER",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35946/thumb/IMG_3059.jpeg?1710234192"
    },
    {
      chainId: 1,
      address: "0x4c73c1c8c95de5674d53604b15d968485414cb32",
      name: "Bomb Shelter Inu",
      symbol: "BOOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35947/thumb/BOOM_LOGO.png?1710234299"
    },
    {
      chainId: 1,
      address: "0xbdcd291c32e06bbf2d7b1ffc823959e3258e3583",
      name: "WASD Studios",
      symbol: "WASD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36442/thumb/logo200.png?1711440765"
    },
    {
      chainId: 1,
      address: "0x7d225c4cc612e61d26523b099b0718d03152edef",
      name: "FlokiFork",
      symbol: "FORK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35048/thumb/floki-inu-floki-logo200x200.png?1707206165"
    },
    {
      chainId: 1,
      address: "0x39a9728fb398583154e6cc5e3defa60908f58e2f",
      name: "BEFY",
      symbol: "BEFY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34964/thumb/Logo-orange_%281%29.png?1706803795"
    },
    {
      chainId: 1,
      address: "0xdaa7699352ac8709f3d2fd092226d3dd7da40474",
      name: "OPCAT",
      symbol: "OPCAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34965/thumb/photo_2024-01-22_14.49.24.png?1706803957"
    },
    {
      chainId: 1,
      address: "0x1b54a6fa1360bd71a0f28f77a1d6fba215d498c3",
      name: "Casinu Inu",
      symbol: "CASINU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34978/thumb/casinuLOGOCG.png?1706861457"
    },
    {
      chainId: 1,
      address: "0x344d6117ae0984f3afdd23e593f92d95a83dcd0e",
      name: "Skibidi Toilet",
      symbol: "TOILET",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32832/thumb/IMG_1165.jpeg?1705778817"
    },
    {
      chainId: 1,
      address: "0xd4568d313fa2d5c6eba37c9f30f6fb8d1c552ddd",
      name: "Ledgity Token",
      symbol: "LDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35046/thumb/ldy-token.png?1707204910"
    },
    {
      chainId: 1,
      address: "0x0447d3454b25935eed47f65b4bd22b9b23be326a",
      name: "Opal",
      symbol: "GEM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34925/thumb/opal.jpeg?1706671563"
    },
    {
      chainId: 1,
      address: "0xd69a0a9682f679f50e34de40105a93bebb2ff43d",
      name: "Mackerel",
      symbol: "MACKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33618/thumb/macke-icon.png?1702528445"
    },
    {
      chainId: 1,
      address: "0x10703ca5e253306e2ababd68e963198be8887c81",
      name: "0xScans",
      symbol: "SCAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34983/thumb/photo_2024-02-01_20-12-00.jpg?1706873450"
    },
    {
      chainId: 1,
      address: "0x8c688327c9371bb3bd69f6e1f1a6d8c9ca0880a7",
      name: "   D D ",
      symbol: "DADA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34988/thumb/0202_DADA.jpg?1706880001"
    },
    {
      chainId: 1,
      address: "0x149cac67f1cd5d80651e7c9bb359ec285d821a05",
      name: "Minterest",
      symbol: "MINTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29455/thumb/MINTY.png?1706817774"
    },
    {
      chainId: 1,
      address: "0x1bbe973bef3a977fc51cbed703e8ffdefe001fed",
      name: "Portal",
      symbol: "PORTAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35436/thumb/portal.jpeg?1708590254"
    },
    {
      chainId: 1,
      address: "0xfe39c384d702914127a005523f9915addb9bd59b",
      name: "Hippocrat",
      symbol: "HPO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4243/thumb/Hippocrat_Token_Logo_ver.1.0.jpg?1707157531"
    },
    {
      chainId: 1,
      address: "0xe9572938bcbf08adcee86fd12a7c0d08dc4ab841",
      name: "Inscribe",
      symbol: "INS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34960/thumb/nwb4N3Gx_400x400.jpg?1706788569"
    },
    {
      chainId: 1,
      address: "0x00aba6fe5557de1a1d565658cbddddf7c710a1eb",
      name: "EasyFi V2",
      symbol: "EZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12742/thumb/Logo_Icon.png?1696512540"
    },
    {
      chainId: 1,
      address: "0x72fca22c6070b4cf68abdb719fa484d9ef10a73b",
      name: "Sowa AI",
      symbol: "SOWA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36798/thumb/sowa_ai_logo.png?1712441273"
    },
    {
      chainId: 1,
      address: "0x6b0faca7ba905a86f221ceb5ca404f605e5b3131",
      name: "DeFi",
      symbol: "DEFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34369/thumb/defi_logo.png?1704905360"
    },
    {
      chainId: 1,
      address: "0xfc0b60e0df5dc9d4b72d957ca2d251cee308019a",
      name: "SLG GAMES",
      symbol: "SLG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26436/thumb/SLG_LOGO18.jpg?1706730326"
    },
    {
      chainId: 1,
      address: "0xc3f8143212871014b472ea83285af7f25928dee4",
      name: "SOHOTRN",
      symbol: "SOHOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34719/thumb/SOHOTRN.png?1705916112"
    },
    {
      chainId: 1,
      address: "0x8df5066cf67d909eb67b82854cf54026d31fffae",
      name: "KOI",
      symbol: "KOI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33927/thumb/coingecko.png?1703408786"
    },
    {
      chainId: 1,
      address: "0x97effb790f2fbb701d88f89db4521348a2b77be8",
      name: "Convergence Finance",
      symbol: "CVG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34989/thumb/AVI.png?1706887801"
    },
    {
      chainId: 1,
      address: "0x723696965f47b990dff00064fcaca95f0ee01123",
      name: "Alpha Radar AI",
      symbol: "ARBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31873/thumb/ARBOT_logo_200*200.png?1696530685"
    },
    {
      chainId: 1,
      address: "0x43415eb6ff9db7e26a15b704e7a3edce97d31c4e",
      name: "Superstate Short Duration U S  Governme",
      symbol: "USTB",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/35012/thumb/ustb.jpeg?1707102680"
    },
    {
      chainId: 1,
      address: "0xb81914f05daf95802eb30726a399733e0696cd79",
      name: "Hola",
      symbol: "HOLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35050/thumb/Hola.png?1707210683"
    },
    {
      chainId: 1,
      address: "0x78223d31298107f3e310b09797b07967832046a6",
      name: "ROYAL SMART FUTURE TOKEN",
      symbol: "RSFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26630/thumb/RSF200x200.png?1696525703"
    },
    {
      chainId: 1,
      address: "0xbef26bd568e421d6708cca55ad6e35f8bfa0c406",
      name: "bitsCrunch Token",
      symbol: "BCUT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34832/thumb/logo-256_%281%29.png?1710244462"
    },
    {
      chainId: 1,
      address: "0x0305f515fa978cf87226cf8a9776d25bcfb2cc0b",
      name: "Pepe 2 0",
      symbol: "PEPE20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30853/thumb/PEPE_2.0.png?1707684909"
    },
    {
      chainId: 1,
      address: "0xa849cd6239906f23b63ba34441b73a5c6eba8a00",
      name: "HashMind",
      symbol: "HASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35014/thumb/IMG_20240203_223037_717.jpg?1707107441"
    },
    {
      chainId: 1,
      address: "0x2c06ba9e7f0daccbc1f6a33ea67e85bb68fbee3a",
      name: "Lends",
      symbol: "LENDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35015/thumb/logo-200x200.png?1707107578"
    },
    {
      chainId: 1,
      address: "0xe16f2ec94e8a0819eb93022c45e05d582f4e5c15",
      name: "Anzen Private Credit",
      symbol: "PCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35018/thumb/Anzen-Logo-Symbol-Color_small_square.png?1707110484"
    },
    {
      chainId: 1,
      address: "0xe085ff62e049b5e3a8d12bc6dffc2dfa329a8894",
      name: "FlexBot",
      symbol: "FLEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35016/thumb/flexbot.jpeg?1707108134"
    },
    {
      chainId: 1,
      address: "0x177c3973b16c16fb5d934ca92b6e6afb03383268",
      name: "Potion 404",
      symbol: "P404",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35141/thumb/JYgmhV72_400x400.jpg?1707454768"
    },
    {
      chainId: 1,
      address: "0x6ef3d766dfe02dc4bf04aae9122eb9a0ded25615",
      name: "Prime Staked ETH",
      symbol: "PRIMEETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34994/thumb/PrimeETH_Token_Logo.png?1706951612"
    },
    {
      chainId: 1,
      address: "0x2d9996f3b9d2e73540fdbfdfe81d71e9e08cbf03",
      name: "BoysClub",
      symbol: "BOYSCLUB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37262/thumb/1000006430.jpg?1713866548"
    },
    {
      chainId: 1,
      address: "0x99b600d0a4abdbc4a6796225a160bcf3d5ce2a89",
      name: "Solareum",
      symbol: "SRM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30072/thumb/green_lrg_transparent.png?1696528993"
    },
    {
      chainId: 1,
      address: "0xc0db17bc219c5ca8746c29ee47862ee3ad742f4a",
      name: "ScottyTheAi",
      symbol: "SCOTTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35052/thumb/scotty_logo_200_x_200.png?1707305097"
    },
    {
      chainId: 1,
      address: "0x60c0d11c10a0c04acb47c6296156bdffac62ef97",
      name: "BBCGoldCoin",
      symbol: "BBCG",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/35064/thumb/Gold_Token_Icon_kl_transp-1.png?1707241154"
    },
    {
      chainId: 1,
      address: "0x42069d11a2cc72388a2e06210921e839cfbd3280",
      name: "GnomeLand",
      symbol: "GNOME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35201/thumb/logopng.png?1707841763"
    },
    {
      chainId: 1,
      address: "0x4b7265d153886a7dc717e815862acde6ff7b5bc8",
      name: "DENCHCOIN",
      symbol: "DENCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11103/thumb/Dench3-e1582923464559.png?1696511043"
    },
    {
      chainId: 1,
      address: "0x0d88ed6e74bbfd96b831231638b66c05571e824f",
      name: "Aventus",
      symbol: "AVT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/901/thumb/1673958879448.jpeg?1696502024"
    },
    {
      chainId: 1,
      address: "0xaecc217a749c2405b5ebc9857a16d58bdc1c367f",
      name: "Pawthereum  OLD ",
      symbol: "PAWTH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/19275/thumb/pawth.png?1696518718"
    },
    {
      chainId: 1,
      address: "0x18084fba666a33d37592fa2633fd49a74dd93a88",
      name: "tBTC",
      symbol: "TBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11224/thumb/0x18084fba666a33d37592fa2633fd49a74dd93a88.png?1696511155"
    },
    {
      chainId: 1,
      address: "0x6d7497751656618fc38cfb5478994a20f7e235df",
      name: "SPYRO",
      symbol: "SPYRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35203/thumb/IMG_8253.jpeg?1707843227"
    },
    {
      chainId: 1,
      address: "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
      name: "Artificial Liquid Intelligence",
      symbol: "ALI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22062/thumb/Logo_Circle_720_%281%29.png?1696521405"
    },
    {
      chainId: 1,
      address: "0x38d64ce1bdf1a9f24e0ec469c9cade61236fb4a0",
      name: "Vector ETH",
      symbol: "VETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35085/thumb/vETH200.png?1709644096"
    },
    {
      chainId: 1,
      address: "0xa1290d69c65a6fe4df752f95823fae25cb99e5a7",
      name: "Kelp DAO Restaked ETH",
      symbol: "RSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33800/thumb/Icon___Dark.png?1702991855"
    },
    {
      chainId: 1,
      address: "0xc82e3db60a52cf7529253b4ec688f631aad9e7c2",
      name: "Arc",
      symbol: "ARC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24235/thumb/arc.png?1696523420"
    },
    {
      chainId: 1,
      address: "0xf5264e1673c9365e7c5d4d1d8b440bbf131ff435",
      name: "vitalek buteren",
      symbol: "VITALEK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35949/thumb/small.jpg?1710238389"
    },
    {
      chainId: 1,
      address: "0xb5c457ddb4ce3312a6c5a2b056a1652bd542a208",
      name: "EtherRock404",
      symbol: "ROCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35095/thumb/0.png?1707372403"
    },
    {
      chainId: 1,
      address: "0x6e8908cfa881c9f6f2c64d3436e7b80b1bf0093f",
      name: "Bistroo",
      symbol: "BIST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15645/thumb/bistroo.png?1696515277"
    },
    {
      chainId: 1,
      address: "0xbe33f57f41a20b2f00dec91dcc1169597f36221f",
      name: "Rug",
      symbol: "RUG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35096/thumb/photo_2024-02-06_19-27-44.jpg?1707372728"
    },
    {
      chainId: 1,
      address: "0xfc10cd3895f2c66d6639ec33ae6360d6cfca7d6d",
      name: "YES",
      symbol: "YES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32939/thumb/yeslogo2.jpg?1707169040"
    },
    {
      chainId: 1,
      address: "0xfa219a9bd37712ef04e5b04abce9ace538ffafb7",
      name: "Pet the Dog",
      symbol: "DOGPET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35097/thumb/s01PN6T7_400x400.jpg?1707374459"
    },
    {
      chainId: 1,
      address: "0x1f0efa15e9cb7ea9596257da63fecc36ba469b30",
      name: "Anon",
      symbol: "ANON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35098/thumb/ANON.jpg?1707412821"
    },
    {
      chainId: 1,
      address: "0x9e9fbde7c7a83c43913bddc8779158f1368f0413",
      name: "Pandora",
      symbol: "PANDORA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34996/thumb/PandoraToken.png?1706954340"
    },
    {
      chainId: 1,
      address: "0x44d03e7ee25caee19172eaddf5fbfbff07990c7e",
      name: "Duel Royale",
      symbol: "ROYALE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35549/thumb/Duel_Royale.png?1709095119"
    },
    {
      chainId: 1,
      address: "0x0c48250eb1f29491f1efbeec0261eb556f0973c7",
      name: "Aimbot AI",
      symbol: "AIMBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31200/thumb/200x200.jpg?1696530027"
    },
    {
      chainId: 1,
      address: "0x626e8036deb333b408be468f951bdb42433cbf18",
      name: "AIOZ Network",
      symbol: "AIOZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14631/thumb/aioz-logo-200.png?1696514309"
    },
    {
      chainId: 1,
      address: "0x72adadb447784dd7ab1f472467750fc485e4cb2d",
      name: "Worldcore  OLD ",
      symbol: "WRC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/1358/thumb/1000956327.png?1708951434"
    },
    {
      chainId: 1,
      address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
      name: "The Graph",
      symbol: "GRT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13397/thumb/Graph_Token.png?1696513159"
    },
    {
      chainId: 1,
      address: "0xbe59baad09b07086ee6c39bd0fc234c157c31ccc",
      name: "LONG TOTEM",
      symbol: "LONG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35103/thumb/IMG_20240206_184148_122.jpg?1707380395"
    },
    {
      chainId: 1,
      address: "0x57f5e098cad7a3d1eed53991d4d66c45c9af7812",
      name: "Wrapped USDM",
      symbol: "WUSDM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33785/thumb/wUSDM_PNG_240px.png?1702981552"
    },
    {
      chainId: 1,
      address: "0x8b91f277501cf8322ebe34f137dd35b384b353c7",
      name: "CoreAI",
      symbol: "CORE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35106/thumb/Black_And_White._Global_Technology_Abstract_Logo.__%287%29_%281%29.png?1707381177"
    },
    {
      chainId: 1,
      address: "0xdc1de096ed4ec5b48f4b0496a6ecee3d63e74f53",
      name: "ERROR404",
      symbol: "PNF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35144/thumb/IMG_20240209_071114_878.jpg?1707468943"
    },
    {
      chainId: 1,
      address: "0x5c77bffc54e33ee4ae303a168a4a0e45b238d09c",
      name: "WORMZ",
      symbol: "WORMZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35105/thumb/logo_200x200.png?1707506487"
    },
    {
      chainId: 1,
      address: "0x5fd82ad8a72252a7a449aded99efec7dd8efa690",
      name: "The GameHub",
      symbol: "GHUB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36718/thumb/photo_2024-04-02_10.33.14.jpeg?1712128679"
    },
    {
      chainId: 1,
      address: "0xfd20e1b78c353877a25274c85fb5566277e5f60e",
      name: "HighNoon",
      symbol: "NOON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33867/thumb/Noon200x200.png?1703130601"
    },
    {
      chainId: 1,
      address: "0xf250b1f6193941bb8bff4152d719edf1a59c0e69",
      name: "AiRealm Tech",
      symbol: "AIRM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35066/thumb/IMG_20240203_120402_573.png?1707287784"
    },
    {
      chainId: 1,
      address: "0xd289ea09aeece390629e9414d41b4d9d9bf43fd9",
      name: "AI Technology",
      symbol: "AITEK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35107/thumb/a99PT0iF_400x400.jpg?1707381565"
    },
    {
      chainId: 1,
      address: "0x337c8a3f0cd0580b29e9ee5d7829645709c8f6d2",
      name: "BOBA",
      symbol: "BOBA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37137/thumb/2024-04-17_16.37.10.jpg?1713419002"
    },
    {
      chainId: 1,
      address: "0x354c8cda7e3b737d360513a0dc5abcee8ee1cea3",
      name: "BABYTRUMP",
      symbol: "BABYTRUMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34750/thumb/babytrumpNEWlogo200.png?1705954645"
    },
    {
      chainId: 1,
      address: "0x2781246fe707bb15cee3e5ea354e2154a2877b16",
      name: "ELYSIA",
      symbol: "EL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10887/thumb/CeyRVXPY_400x400.jpg?1696510840"
    },
    {
      chainId: 1,
      address: "0x65d72aa8da931f047169112fcf34f52dbaae7d18",
      name: "f x  rUSD",
      symbol: "RUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36338/thumb/rusd.png?1711105384"
    },
    {
      chainId: 1,
      address: "0x62d0a8458ed7719fdaf978fe5929c6d342b0bfce",
      name: "Beam",
      symbol: "BEAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32417/thumb/chain-logo.png?1698114384"
    },
    {
      chainId: 1,
      address: "0x249ca82617ec3dfb2589c4c17ab7ec9765350a18",
      name: "Verse",
      symbol: "VERSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28424/thumb/verselogo.png?1696527421"
    },
    {
      chainId: 1,
      address: "0xb8a87405d9a4f2f866319b77004e88dff66c0d92",
      name: "Sora AI",
      symbol: "SORA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35293/thumb/IMG_20240315_205215_106.jpg?1710729039"
    },
    {
      chainId: 1,
      address: "0xb90b2a35c65dbc466b04240097ca756ad2005295",
      name: "BOBO Coin",
      symbol: "BOBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30388/thumb/bobologo.png?1696529277"
    },
    {
      chainId: 1,
      address: "0x6930450a416252c7206fbce76c01ecc850a36cb9",
      name: "SHEBOSHIS",
      symbol: "SHEB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35291/thumb/SHEB_11200.jpg?1708080526"
    },
    {
      chainId: 1,
      address: "0x686f2404e77ab0d9070a46cdfb0b7fecdd2318b0",
      name: "LORDS",
      symbol: "LORDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22171/thumb/Frame_1.png?1696521515"
    },
    {
      chainId: 1,
      address: "0x0e186357c323c806c1efdad36d217f7a54b63d18",
      name: "Curio Gas Token",
      symbol: "CGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37476/thumb/Screenshot_2024-05-04_004346.png?1714754678"
    },
    {
      chainId: 1,
      address: "0x61db59daf2af68310fffa003d3b2f452260b673c",
      name: "Laurion 404",
      symbol: "LAURION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35233/thumb/k9sEsCqR_400x400.png?1707935032"
    },
    {
      chainId: 1,
      address: "0x352a4b34b8e9f43b869f6f80728978cccdced406",
      name: "Sound LinX",
      symbol: "SDLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37299/thumb/200x200_logo.png?1713951254"
    },
    {
      chainId: 1,
      address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
      name: "Shiba Inu",
      symbol: "SHIB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11939/thumb/shiba.png?1696511800"
    },
    {
      chainId: 1,
      address: "0xf161cdb9aa33b2f48be273dae3f3bbb2330ad3e5",
      name: "AZUR Token",
      symbol: "AZUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35384/thumb/azur_logo_200_%284%29.png?1708446037"
    },
    {
      chainId: 1,
      address: "0x1a59eec501745ad6bdfc37558ddacb38ca5a8c48",
      name: "Cosmic",
      symbol: "COSMIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35119/thumb/download.png?1707409910"
    },
    {
      chainId: 1,
      address: "0x1e7572fb16e176d40d28090e51a7a9ea08f68199",
      name: "Meow Coin",
      symbol: "MEOW",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37339/thumb/meow_coin.jpeg?1714046511"
    },
    {
      chainId: 1,
      address: "0xcc4304a31d09258b0029ea7fe63d032f52e44efe",
      name: "TrustSwap",
      symbol: "SWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11795/thumb/Untitled_design-removebg-preview.png?1696511671"
    },
    {
      chainId: 1,
      address: "0x46305b2ebcd92809d5fcef577c20c28a185af03c",
      name: "Shadowladys DN404",
      symbol: "SHADOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35243/thumb/fixed_logo.png?1707986261"
    },
    {
      chainId: 1,
      address: "0x9c7d4fb43919def524c1a9d92fe836169eaf0615",
      name: "Landwolf",
      symbol: "WOLF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35907/thumb/COINGECKO_NEW_UPDATE.png?1710338755"
    },
    {
      chainId: 1,
      address: "0x9e91f79070926a191e41367d40ad582686f9e66d",
      name: "STYLE Protocol",
      symbol: "STYLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37507/thumb/style.jpeg?1714618775"
    },
    {
      chainId: 1,
      address: "0xb7955695d1df86f35bfbda5e5b7d3069a5639a19",
      name: "Bully",
      symbol: "BULLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35252/thumb/Bully.png?1707992406"
    },
    {
      chainId: 1,
      address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
      name: "Basic Attention",
      symbol: "BAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1696501867"
    },
    {
      chainId: 1,
      address: "0xa3b3beaf9c0a6160a8e47f000c094d34121f1a57",
      name: "Coffee Club Token",
      symbol: "COFFEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35248/thumb/Coffee_Club_Token.png?1707988187"
    },
    {
      chainId: 1,
      address: "0x40a7df3df8b56147b781353d379cb960120211d7",
      name: "Moby",
      symbol: "MOBY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35146/thumb/photo_2024-02-13_09-43-04.jpg?1707846594"
    },
    {
      chainId: 1,
      address: "0xe99379955b676d5a7ebe3f42f2b684796e48d437",
      name: "EGG ETH",
      symbol: "EGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35388/thumb/eggcoingecko.png?1708450304"
    },
    {
      chainId: 1,
      address: "0xce6e54daa1ea95fb3530859d69d4bdb978dd821b",
      name: "Ordibank",
      symbol: "ORBK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35736/thumb/obank_light_200x200.png?1710247386"
    },
    {
      chainId: 1,
      address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
      name: "Radworks",
      symbol: "RAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14013/thumb/radicle.png?1696513741"
    },
    {
      chainId: 1,
      address: "0x3005003bda885dee7c74182e5fe336e9e3df87bb",
      name: "LENX XD",
      symbol: "XD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34496/thumb/XD.png?1705264686"
    },
    {
      chainId: 1,
      address: "0x33e80a92a9ea73dd02f6e732d1702d58c68388ca",
      name: "XBANKING",
      symbol: "XB",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/31650/thumb/Web_1920_%E2%80%93_1.png?1696530465"
    },
    {
      chainId: 1,
      address: "0x826180541412d574cf1336d22c0c0a287822678a",
      name: "Chainflip",
      symbol: "FLIP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25576/thumb/kdt_AgmT_400x400.png?1696524709"
    },
    {
      chainId: 1,
      address: "0xb60acd2057067dc9ed8c083f5aa227a244044fd6",
      name: "Tensorplex Staked TAO",
      symbol: "STTAO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35330/thumb/stTAO_Logo.png?1708268881"
    },
    {
      chainId: 1,
      address: "0xf3617e8a04265160b9ee10253a2c78565571cb76",
      name: "Blepe the Blue",
      symbol: "BLEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35391/thumb/photo_2024-02-20_03.15.26.jpeg?1708452233"
    },
    {
      chainId: 1,
      address: "0xe08cd119df4c2f147f623559d6985b8afe315873",
      name: "Bacon",
      symbol: "BACON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35414/thumb/CG_BACON.JPEG?1708504711"
    },
    {
      chainId: 1,
      address: "0x19efa7d0fc88ffe461d1091f8cbe56dc2708a84f",
      name: "UNITAO",
      symbol: "UNITAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35743/thumb/rsz_logo11.png?1709976563"
    },
    {
      chainId: 1,
      address: "0xe2f95ee8b72ffed59bc4d2f35b1d19b909a6e6b3",
      name: "EGGX",
      symbol: "EGGX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35372/thumb/Eggx_item_200x200.png?1708401789"
    },
    {
      chainId: 1,
      address: "0x909c1b012d1a56584484bc39969da13ee11e8fa6",
      name: "ARENA SUPPLY CRATE",
      symbol: "SPLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35395/thumb/SupplyCrate.png?1708454681"
    },
    {
      chainId: 1,
      address: "0x47d20c7800906e01adfc890f283c110ba70a6c97",
      name: "Azure",
      symbol: "AZR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34898/thumb/azure200.png?1706582792"
    },
    {
      chainId: 1,
      address: "0xbc544207ff1c5b2bc47a35f745010b603b97e99e",
      name: "AI PIN",
      symbol: "AI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34235/thumb/AiPin-200px.png?1704306335"
    },
    {
      chainId: 1,
      address: "0xdb82c0d91e057e05600c8f8dc836beb41da6df14",
      name: "Smart Layer Network",
      symbol: "SLN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35397/thumb/sln.jpeg?1708488815"
    },
    {
      chainId: 1,
      address: "0x9c2dc0c3cc2badde84b0025cf4df1c5af288d835",
      name: "Coreto",
      symbol: "COR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12856/thumb/COR.png?1696512646"
    },
    {
      chainId: 1,
      address: "0x62126ec407eae34393ab88b1f5d57e8566e570be",
      name: "Virtumate",
      symbol: "MATE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35520/thumb/IMG_9102.jpeg?1709006618"
    },
    {
      chainId: 1,
      address: "0xe8b1e79d937c648ce1fe96e6739ddb2714058a18",
      name: "ColonizeMars",
      symbol: "GTM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35278/thumb/GTM_LOGO.jpg?1708054688"
    },
    {
      chainId: 1,
      address: "0xeb51b8dc2d43469c0f0b7365c8a18438907bdf21",
      name: "Shiva Inu",
      symbol: "SHIV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36461/thumb/Shiv_200200.jpg?1711509775"
    },
    {
      chainId: 1,
      address: "0x8b8aa7777e18408c07b0ed52ca3dd5bdab34eb7e",
      name: "Paradox",
      symbol: "PDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35448/thumb/Paradox.png?1708620624"
    },
    {
      chainId: 1,
      address: "0xa599ab9ee3837be7c5f7b8abf0ce10bc49a2b779",
      name: "Spider",
      symbol: "SPIDER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35450/thumb/Black_BG_Spider-Logo.png?1708664882"
    },
    {
      chainId: 1,
      address: "0x478156deabfac918369044d52a6bdb5cc5597994",
      name: "Schrodinger",
      symbol: "SGR",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/36288/thumb/Project_Schrodinger_Logo_Square_200x200.png?1711009156"
    },
    {
      chainId: 1,
      address: "0x9c05d54645306d4c4ead6f75846000e1554c0360",
      name: "21 co Wrapped ADA",
      symbol: "21ADA",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/34614/thumb/21ADA.png?1705503285"
    },
    {
      chainId: 1,
      address: "0x48afbbd342f64ef8a9ab1c143719b63c2ad81710",
      name: "mpETH",
      symbol: "MPETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35401/thumb/mpETH-jpeg.jpg?1708541939"
    },
    {
      chainId: 1,
      address: "0x1814b8a33446549ed5766ab3250b670498699bd6",
      name: "InnoviaTrust",
      symbol: "INVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37425/thumb/IMG_20240426_165247_519.jpg?1714378573"
    },
    {
      chainId: 1,
      address: "0x875773784af8135ea0ef43b5a374aad105c5d39e",
      name: "IDLE",
      symbol: "IDLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13286/thumb/image.png?1696513058"
    },
    {
      chainId: 1,
      address: "0x83e9f223e1edb3486f876ee888d76bfba26c475a",
      name: "BlockchainSpace",
      symbol: "GUILD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21271/thumb/BednjMw.png?1696520642"
    },
    {
      chainId: 1,
      address: "0x2f57430a6ceda85a67121757785877b4a71b8e6d",
      name: "DefiPlaza",
      symbol: "DFP2",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19552/thumb/profile-round.png?1696518985"
    },
    {
      chainId: 1,
      address: "0xbec771d15f7e67bc0bb4571c7eb409228cc6fef9",
      name: "BribeAI",
      symbol: "BRAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36494/thumb/bribeai_logo.png?1711613014"
    },
    {
      chainId: 1,
      address: "0xbf72ee725f9b06dc564324774801acebad061946",
      name: "DApp AI",
      symbol: "DAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35741/thumb/Dapp_profile-picture.png?1713897886"
    },
    {
      chainId: 1,
      address: "0xba0dda8762c24da9487f5fa026a9b64b695a07ea",
      name: "OX Coin",
      symbol: "OX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35365/thumb/logo.png?1708395976"
    },
    {
      chainId: 1,
      address: "0xd0bcb2c156a3507670f9bedc319a6409c41ba68e",
      name: "DeepL",
      symbol: "DEEPL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35525/thumb/photo_2024-02-23_17-54-05.jpg?1709015938"
    },
    {
      chainId: 1,
      address: "0xb93746dc7a8bf5e381ffb278085b1f62bd0a1fc8",
      name: "Sendex AI",
      symbol: "SENDEX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35602/thumb/cg.png?1709277111"
    },
    {
      chainId: 1,
      address: "0x958a03181806cb8807bef40e864e55f89b3393d3",
      name: "UTIX",
      symbol: "UTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35619/thumb/utxlogo.png?1709287098"
    },
    {
      chainId: 1,
      address: "0x1a7e4e63778b4f12a199c062f3efdd288afcbce8",
      name: "EURA",
      symbol: "EURA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19479/thumb/agEUR-4.png?1710726218"
    },
    {
      chainId: 1,
      address: "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
      name: "Ampleforth",
      symbol: "AMPL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/4708/thumb/Ampleforth.png?1696505273"
    },
    {
      chainId: 1,
      address: "0x8d6cebd76f18e1558d4db88138e2defb3909fad6",
      name: "MAI  Ethereum ",
      symbol: "MIMATIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35521/thumb/mimatic-red.png?1709007081"
    },
    {
      chainId: 1,
      address: "0x808688c820ab080a6ff1019f03e5ec227d9b522b",
      name: "Bag",
      symbol: "BAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35417/thumb/BAG-coingecko.png?1709393428"
    },
    {
      chainId: 1,
      address: "0xce5464b006a10d20c5fc56a19618212a129eed45",
      name: "Egostation",
      symbol: "ESTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36816/thumb/1000104152.jpg?1712550282"
    },
    {
      chainId: 1,
      address: "0x66d5c66e7c83e0682d947176534242c9f19b3365",
      name: "Staked Vector",
      symbol: "SVEC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35462/thumb/sVEC200.png?1709644177"
    },
    {
      chainId: 1,
      address: "0xf411903cbc70a74d22900a5de66a2dda66507255",
      name: "Verasity",
      symbol: "VRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14025/thumb/VRA.jpg?1696513752"
    },
    {
      chainId: 1,
      address: "0x1495bc9e44af1f8bcb62278d2bec4540cf0c05ea",
      name: "Zero1 Labs",
      symbol: "DEAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36315/thumb/512x512-xion-ava03.png?1711092111"
    },
    {
      chainId: 1,
      address: "0x788d86e00ab31db859c3d6b80d5a9375801d7f2a",
      name: "TENET",
      symbol: "TENET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30108/thumb/tenet_original.png?1696529030"
    },
    {
      chainId: 1,
      address: "0xef3daa5fda8ad7aabff4658f1f78061fd626b8f0",
      name: "MUZZLE",
      symbol: "MUZZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35527/thumb/muzz-token-200.png?1709024198"
    },
    {
      chainId: 1,
      address: "0xae4533189c7281501f04ba4b7c37e3aded402902",
      name: "World Friendship Cash",
      symbol: "WFCA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31997/thumb/wfca.jpg?1696530798"
    },
    {
      chainId: 1,
      address: "0xf4fb9bf10e489ea3edb03e094939341399587b0c",
      name: "AirDAO",
      symbol: "AMB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/1041/thumb/amb.png?1696502148"
    },
    {
      chainId: 1,
      address: "0x559babc46a6ab52fd11b2790bce01f0a434a8b4e",
      name: "TrendGuru",
      symbol: "TRENDGURU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35728/thumb/TrendGuru.png?1709662816"
    },
    {
      chainId: 1,
      address: "0xe485e2f1bab389c08721b291f6b59780fec83fd7",
      name: "Shutter",
      symbol: "SHU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35524/thumb/Shutter_logo.png?1709014167"
    },
    {
      chainId: 1,
      address: "0x2907dcbc51191a5d7494077d1156fffc34f110ab",
      name: "Dibbles 404",
      symbol: "ERRDB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35747/thumb/download_%281%29.png?1709715045"
    },
    {
      chainId: 1,
      address: "0xd155fa55c40d010335aa152891aa687e2f3090bd",
      name: "AInalysis",
      symbol: "AIL",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35603/thumb/ainalysis_200x200.png?1709277575"
    },
    {
      chainId: 1,
      address: "0x7a65cb87f596caf31a4932f074c59c0592be77d7",
      name: "Zypto Token",
      symbol: "ZYPTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19089/thumb/image_2024-02-23_172710251.png?1708680432"
    },
    {
      chainId: 1,
      address: "0xc5842df170b8c8d09eb851a8d5db3dfa00669e3f",
      name: "Xero AI",
      symbol: "XEROAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36539/thumb/Untitled_design_%285%29.png?1711708210"
    },
    {
      chainId: 1,
      address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
      name: "ApeCoin",
      symbol: "APE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24383/thumb/apecoin.jpg?1696523566"
    },
    {
      chainId: 1,
      address: "0xd979c468a68062e7bdff4ba6df7842dfd3492e0f",
      name: "Beoble",
      symbol: "BBL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35011/thumb/beoble_200px.png?1707102471"
    },
    {
      chainId: 1,
      address: "0xe020b01b6fbd83066aa2e8ee0ccd1eb8d9cc70bf",
      name: "Arcade",
      symbol: "ARCD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33112/thumb/OFFICIAL_ARCD_TOKEN_SYMBOL_64x64.png?1711190585"
    },
    {
      chainId: 1,
      address: "0xd417144312dbf50465b1c641d016962017ef6240",
      name: "Covalent",
      symbol: "CQT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14168/thumb/CQT_Logo.png?1711563318"
    },
    {
      chainId: 1,
      address: "0x3429d03c6f7521aec737a0bbf2e5ddcef2c3ae31",
      name: "Pixels",
      symbol: "PIXEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35100/thumb/pixel-icon.png?1708339519"
    },
    {
      chainId: 1,
      address: "0x8e3a59427b1d87db234dd4ff63b25e4bf94672f4",
      name: "Kelp Earned Points",
      symbol: "KEP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35560/thumb/kep.png?1709163916"
    },
    {
      chainId: 1,
      address: "0x74fe27e70db10147f8b6b38b3c9d12bbdcf3b5af",
      name: "iRYDE",
      symbol: "IRYDE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35530/thumb/3pIMg6HT.jpg?1709032145"
    },
    {
      chainId: 1,
      address: "0x8fe815417913a93ea99049fc0718ee1647a2a07c",
      name: "XSwap",
      symbol: "XSWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36000/thumb/XSwap_Icon_%282%29.png?1710320467"
    },
    {
      chainId: 1,
      address: "0xdda31d354a519ecfb0bc2a536b5e7be147c0f7f4",
      name: "Everlodge",
      symbol: "ELDG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35532/thumb/1000034240.png?1709032461"
    },
    {
      chainId: 1,
      address: "0x54da724e13d64619a36e1ee6f4bf92d5a410da41",
      name: "Secured On Blockchain  OLD ",
      symbol: "SOB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32511/thumb/IMG_20230914_104422_780_%281%29.png?1698399012"
    },
    {
      chainId: 1,
      address: "0xb813322cd994a2f7808c340ea12e0a2283a7a757",
      name: "Cosmo Baby",
      symbol: "CBABY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35533/thumb/ComcoBaby_Icon_%282%29.png?1709032682"
    },
    {
      chainId: 1,
      address: "0x7ba441772fdd56dda03e7e91284db2ea2ba237da",
      name: "ALPHABYTE",
      symbol: "ALPHA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35537/thumb/Alphabyte.jpeg?1709033596"
    },
    {
      chainId: 1,
      address: "0x4a27e9aab8f8ba9de06766c8476ed1d16494e35f",
      name: "PEPEGOLD",
      symbol: "PEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26864/thumb/logo-200x200.png?1696525924"
    },
    {
      chainId: 1,
      address: "0xb08c567824cdcb530b9da4adc3a3001ee2f170ae",
      name: "Wh1t3h1v3",
      symbol: "HIVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35622/thumb/hive.jpg?1709289785"
    },
    {
      chainId: 1,
      address: "0xd5d86fc8d5c0ea1ac1ac5dfab6e529c9967a45e9",
      name: "NFT Worlds",
      symbol: "WRLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22112/thumb/ZyBrRgfO.jpg?1696521454"
    },
    {
      chainId: 1,
      address: "0xf7498c98789957f4ee53b3e37ff5b7ef8a6cfc7b",
      name: "DEVAI",
      symbol: "0XDEV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33294/thumb/DevAi.jpg?1702294618"
    },
    {
      chainId: 1,
      address: "0x239015de0f0121f2c80134558decbba75ea056c6",
      name: "Wand",
      symbol: "WAND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35606/thumb/wand_wizard_200x200.png?1709280453"
    },
    {
      chainId: 1,
      address: "0xeb4628418e1acbba62bc72c9b7a53b1865ff283d",
      name: "0x404",
      symbol: "XFOUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35623/thumb/0x404.png?1709289914"
    },
    {
      chainId: 1,
      address: "0x3ea4055ab599f5cbb580d2c5e56d2fcff7db98cb",
      name: "TALYS",
      symbol: "TALYS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37109/thumb/logo_transparent_border_200px-200px.png?1713895742"
    },
    {
      chainId: 1,
      address: "0xa6c0c097741d55ecd9a3a7def3a8253fd022ceb9",
      name: "AVA",
      symbol: "AVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3014/thumb/AVA_Logo_160x160px_Black.png?1696503750"
    },
    {
      chainId: 1,
      address: "0x0e4e7f2aecf408aff4f82f067677050239bdc58a",
      name: "Fungify Token",
      symbol: "FUNG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35607/thumb/FUNG-logo-200x200.png?1709280585"
    },
    {
      chainId: 1,
      address: "0x62cf53a8d024c785e6bd49b83d94a74e1f9c48b1",
      name: "Aimee",
      symbol: "AIMEE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35608/thumb/aimeelogo200x200.png?1709280851"
    },
    {
      chainId: 1,
      address: "0x102dc1840f0c3c179670f21fa63597e82df34e60",
      name: "Virtucloud",
      symbol: "VIRTU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35610/thumb/1000004130.png?1709281192"
    },
    {
      chainId: 1,
      address: "0x95ccffae3eb8767d4a941ec43280961dde89f4de",
      name: "TaoBank",
      symbol: "TBANK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35612/thumb/200x200.png?1709281616"
    },
    {
      chainId: 1,
      address: "0x352a3144e88d23427993938cfd780291d95ef091",
      name: "Eigenpie OsETH",
      symbol: "MOSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37204/thumb/mosETH.png?1713764694"
    },
    {
      chainId: 1,
      address: "0xe2353069f71a27bbbe66eeabff05de109c7d5e19",
      name: "Bonsai3",
      symbol: "SEED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33162/thumb/logo-bonsai3200x200.png?1700830408"
    },
    {
      chainId: 1,
      address: "0x92f419fb7a750aed295b0ddf536276bf5a40124f",
      name: "Tatsu",
      symbol: "TATSU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35581/thumb/download.png?1709202359"
    },
    {
      chainId: 1,
      address: "0xf76c15cbf1fa9d60a7af39e660d6d7c62ef8021e",
      name: "Wagyu Protocol",
      symbol: "WAGYU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35698/thumb/200c.png?1709549986"
    },
    {
      chainId: 1,
      address: "0x408e41876cccdc0f92210600ef50372656052a38",
      name: "Ren",
      symbol: "REN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3139/thumb/REN.png?1696503862"
    },
    {
      chainId: 1,
      address: "0x1c3d163219bb74f430411b95d66b72056f366ec1",
      name: "ENO",
      symbol: "ENO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26501/thumb/Logo_%281%29.png?1709565574"
    },
    {
      chainId: 1,
      address: "0xfd26e39807772251c3bb90fb1fcd9ce5b80c5c24",
      name: "Codex Multichain",
      symbol: "CODEX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33980/thumb/200x200.jpg?1703580135"
    },
    {
      chainId: 1,
      address: "0x9fdfb933ee990955d3219d4f892fd1f786b47c9b",
      name: "Meme Kombat",
      symbol: "MK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35750/thumb/MKName_200.png?1709718615"
    },
    {
      chainId: 1,
      address: "0x51015f4fefe3366c6f62539140149f8088888888",
      name: "Nuk em Loans",
      symbol: "NUKEM",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35239/thumb/it-s-a-blank-te_62950976_%282%29.png?1707936386"
    },
    {
      chainId: 1,
      address: "0xe8196181c5fe192b83c5ca34be910d93d691d935",
      name: "Self Operating AI",
      symbol: "SOAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35757/thumb/20240305_131444.png?1709724035"
    },
    {
      chainId: 1,
      address: "0xf938346d7117534222b48d09325a6b8162b3a9e7",
      name: "Choppy",
      symbol: "CHOPPY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35731/thumb/200x200.png?1709691279"
    },
    {
      chainId: 1,
      address: "0xe96edd48cf0c6e930ce55f171a721017b28e0f08",
      name: "NexusAI",
      symbol: "NEXUSAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36238/thumb/NexusAI.png?1710918464"
    },
    {
      chainId: 1,
      address: "0x73454acfddb7a36a3cd8eb171fbea86c6a55e550",
      name: "BuildAI",
      symbol: "BUILD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35460/thumb/no-bg-1.png?1714009122"
    },
    {
      chainId: 1,
      address: "0xa0e7626287bd02cbe3531c65148261bf0c0ed98b",
      name: "Shill Guard Token",
      symbol: "SGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33176/thumb/SHILL_GUARD_TOKEN_SGT_LOGO.png?1700923841"
    },
    {
      chainId: 1,
      address: "0x6b96c78d4472031f1fbed2d1c4bd3895e9212344",
      name: "TAOx",
      symbol: "TAOX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35842/thumb/logo-taox.jpeg?1709889951"
    },
    {
      chainId: 1,
      address: "0xd5eb7e91ae88ea2550f9bfd04208399c95df4dc7",
      name: "DogLibre",
      symbol: "DOGL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37011/thumb/doglibre.jpeg?1713141966"
    },
    {
      chainId: 1,
      address: "0x3824255df9eabc9347abcaa5872b1763fe9d47bc",
      name: "NodeStation AI",
      symbol: "NDS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37187/thumb/NodeStation_AI_200x200.png?1713666678"
    },
    {
      chainId: 1,
      address: "0x9ae380f0272e2162340a5bb646c354271c0f5cfc",
      name: "Conic",
      symbol: "CNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24747/thumb/cnc.png?1696523909"
    },
    {
      chainId: 1,
      address: "0x9d14bce1daddf408d77295bb1be9b343814f44de",
      name: "Koi",
      symbol: "KOI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35766/thumb/Koi_logo.png?1709782399"
    },
    {
      chainId: 1,
      address: "0x4b6d036d0bc62a633acca6d10956e9dbbb16748f",
      name: "Blood Crystal",
      symbol: "BC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35834/thumb/BloodCrystalToken_200x200.png?1709888447"
    },
    {
      chainId: 1,
      address: "0x0d827543d120f49f0614ca1cb2fa18f96ac817f0",
      name: "Samurai Bot",
      symbol: "SAMBO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36047/thumb/6523753be331313328630eae_Sambo_logo_stacked_transparent-p-500.png?1710401756"
    },
    {
      chainId: 1,
      address: "0x9194337c06405623c0f374e63fa1cc94e2788c58",
      name: "CYBONK",
      symbol: "CYBONK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35802/thumb/cybonk_%281%29.png?1709839583"
    },
    {
      chainId: 1,
      address: "0x1ef846ce0da79d8d4e111bf8c5117cd1209a0478",
      name: "Ethereum Inu",
      symbol: "ETHINU",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/34875/thumb/1000024435.jpg?1706496056"
    },
    {
      chainId: 1,
      address: "0x142f4330ab3eda738cb373791c2e99cc325bed20",
      name: "Secured On Blockchain",
      symbol: "SOB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36725/thumb/sob.jpeg?1712143555"
    },
    {
      chainId: 1,
      address: "0x73c69d24ad28e2d43d03cbf35f79fe26ebde1011",
      name: "Archimedes Finance",
      symbol: "ARCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28970/thumb/arch.png?1696527943"
    },
    {
      chainId: 1,
      address: "0x1f769203d2abcb78f5a77dd15c0078c50fb13287",
      name: "Azure Wallet",
      symbol: "AZURE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35753/thumb/Azure.jpeg?1709723218"
    },
    {
      chainId: 1,
      address: "0xe2808d7298f0d4111ea1773d3320f5d80eab83e8",
      name: "WAVX Exchange",
      symbol: "WAVX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35758/thumb/WAVX.png?1709811960"
    },
    {
      chainId: 1,
      address: "0xbe7458bc543cf2df43ac109d2f713dffe6417aa4",
      name: "Athenas AI",
      symbol: "ATH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35820/thumb/ath200.png?1709886629"
    },
    {
      chainId: 1,
      address: "0xefb20cd759f617ab59b758a1f06de02feb5e8bd5",
      name: "TaoHarvest",
      symbol: "TAH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35840/thumb/500x500.jpg?1709889331"
    },
    {
      chainId: 1,
      address: "0x391fb9429d8685d5d0f14a185fc0820c6ac2817e",
      name: "NeonAI",
      symbol: "NEONAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35691/thumb/Untitled_design%282%29.png?1709535075"
    },
    {
      chainId: 1,
      address: "0xea55f9d4a1bcea5e3e806f169f33f0092d5fb7f0",
      name: "Gemtools",
      symbol: "GEMS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35815/thumb/53121b16-ddea-4b35-b43a-53335d8426ea.png?1709885212"
    },
    {
      chainId: 1,
      address: "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
      name: "Sweat Economy",
      symbol: "SWEAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25057/thumb/fhD9Xs16_400x400.jpg?1696524208"
    },
    {
      chainId: 1,
      address: "0x03aa6298f1370642642415edc0db8b957783e8d6",
      name: "NetMind Token",
      symbol: "NMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35328/thumb/NMT-logo.png?1708267799"
    },
    {
      chainId: 1,
      address: "0x0e6d98de664a28a32b584c72e606ff7dea898dc6",
      name: "Produce AI",
      symbol: "PRAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35817/thumb/200_logo.png?1709885406"
    },
    {
      chainId: 1,
      address: "0x05f72d4555e71ef3f5862627828fc2f830d3ccb1",
      name: "DegenMasters AI",
      symbol: "DMAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35827/thumb/favicon2_200x200.png?1709887422"
    },
    {
      chainId: 1,
      address: "0x49fb8ad7578148e17c3ef0c344ce23a66ed372c4",
      name: "tao bot",
      symbol: "TAOBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35829/thumb/taobot200.png?1709887868"
    },
    {
      chainId: 1,
      address: "0xff055ff1ec9aa85f14e757d769f9d52d023f2e3b",
      name: "NodeHUB",
      symbol: "NHUB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35846/thumb/photo_2024-03-07_20.54.49.jpeg?1709891015"
    },
    {
      chainId: 1,
      address: "0x747e550a7b848ace786c3cfe754aa78febc8a022",
      name: "DODO",
      symbol: "DODO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35955/thumb/listings.png?1710252222"
    },
    {
      chainId: 1,
      address: "0x6ab98d9e04cfb57c6b6e9800a5a43a9946a6523d",
      name: "RUNodE",
      symbol: "RUDES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36500/thumb/200x200.png?1711872443"
    },
    {
      chainId: 1,
      address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
      name: "Ooki",
      symbol: "OOKI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21719/thumb/Ooki_Token.png?1696521074"
    },
    {
      chainId: 1,
      address: "0x07e128e823d2b9b22edbda43820aa1a72de99613",
      name: "Host AI",
      symbol: "HOSTAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35854/thumb/200.png?1709895690"
    },
    {
      chainId: 1,
      address: "0xaf6aca2769be86b9910165bff78fea643c086c61",
      name: "Decentra Ecosystem",
      symbol: "DCE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35499/thumb/photo_2024-02-19_01.png?1708926162"
    },
    {
      chainId: 1,
      address: "0xe3b9cfb8ea8a4f1279fbc28d3e15b4d2d86f18a0",
      name: "Fottie",
      symbol: "FOTTIE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35860/thumb/fottie_logo_medium_%281%29.png?1709920764"
    },
    {
      chainId: 1,
      address: "0x423352f2c6e0e72422b69af03aba259310146d90",
      name: "Reality Metaverse",
      symbol: "RMV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29806/thumb/rltm.png?1696528735"
    },
    {
      chainId: 1,
      address: "0x3e5d4ed373596f00a5fc78ceb49994d9dc665aa9",
      name: "Gem AI",
      symbol: "GEMAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35992/thumb/gem_ai_logo_200x200.png?1710315447"
    },
    {
      chainId: 1,
      address: "0x2e1e15c44ffe4df6a0cb7371cd00d5028e571d14",
      name: "Mettalex",
      symbol: "MTLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12730/thumb/nrEqFTEW_400x400.jpg?1696512529"
    },
    {
      chainId: 1,
      address: "0x02a97fd243b8301bcd6ba3a87693162d6bd130bd",
      name: "SempsunAi2 0",
      symbol: "SMAI20",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35898/thumb/Artboard_14.png?1710164614"
    },
    {
      chainId: 1,
      address: "0x72cdb56e9d96c64fb52e8cdeda7475f3aa843f59",
      name: "TAOPlay",
      symbol: "TAOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35899/thumb/photo_2024-03-08_00-54-55.jpg?1710164992"
    },
    {
      chainId: 1,
      address: "0xd9812f24f34e0d727bbf6ea7caaee05b7f7a2603",
      name: "TensorSpace",
      symbol: "TPU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35862/thumb/TensorSpace.png?1709969045"
    },
    {
      chainId: 1,
      address: "0xb528edbef013aff855ac3c50b381f253af13b997",
      name: "Aevo",
      symbol: "AEVO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35893/thumb/aevo.png?1710138340"
    },
    {
      chainId: 1,
      address: "0xac51066d7bec65dc4589368da368b212745d63e8",
      name: "My Neighbor Alice",
      symbol: "ALICE",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/14375/thumb/alice_logo.jpg?1696514067"
    },
    {
      chainId: 1,
      address: "0x86b5e2642d094078ad7fe4e0a61f1f4eb4e3280c",
      name: "SynthAI",
      symbol: "SYNTHAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35865/thumb/Logo_SynthAI_Logogram.png?1709970520"
    },
    {
      chainId: 1,
      address: "0xfa816739edaac4ebf329219d4ef575085cc28037",
      name: "Search",
      symbol: "0XSEARCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35866/thumb/photo_2024-03-07_21.13.29.jpeg?1709970596"
    },
    {
      chainId: 1,
      address: "0x6a7eff1e2c355ad6eb91bebb5ded49257f3fed98",
      name: "OpSec",
      symbol: "OPSEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34284/thumb/IMG_8108.jpeg?1704453267"
    },
    {
      chainId: 1,
      address: "0xa1147413cbf11737eff228fb0073c5ce101e9d87",
      name: " CRATE",
      symbol: "CRATE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35652/thumb/CRATE_LOGO.png?1709379820"
    },
    {
      chainId: 1,
      address: "0x38604d52d3a89b16a90053ae0c6d009504a9a5b8",
      name: "Cloud AI",
      symbol: "CLD",
      decimals: 10,
      logoURI: "https://assets.coingecko.com/coins/images/35870/thumb/cloudai-transparent.png?1709973949"
    },
    {
      chainId: 1,
      address: "0x8e32b8a41f2e86a3ee198912ac8d756c84295b40",
      name: "Track The Funds Bot",
      symbol: "TTF",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34337/thumb/ttf-logo-200.png?1704679746"
    },
    {
      chainId: 1,
      address: "0x39de85301c78f4d623e5c05cde2fd119a3a92cd9",
      name: "blobs",
      symbol: "BLOBS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35964/thumb/blobs200tnps.png?1710259853"
    },
    {
      chainId: 1,
      address: "0x57b49219614859176ddb029298486b6c30193cbd",
      name: "Oracle AI",
      symbol: "ORACLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35463/thumb/Oracle_AI_200x200.png?1708677748"
    },
    {
      chainId: 1,
      address: "0xb36cf340a35f9860d0bb59afb0355580f0000dad",
      name: "Padre",
      symbol: "PADRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36079/thumb/favicon_200x200_transparent_png.png?1710414755"
    },
    {
      chainId: 1,
      address: "0xfe7290b932cd0d5aec29c57394e87cdaa41cc054",
      name: "Smart AI",
      symbol: "SMART",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37356/thumb/200x200.png?1714103604"
    },
    {
      chainId: 1,
      address: "0x7086e014fd59e66567a986e7b401a5810c2361ce",
      name: "QUANTUM HUB",
      symbol: "QUANTUM",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35965/thumb/2024-03-10_22.19.52.png?1710260969"
    },
    {
      chainId: 1,
      address: "0xfe0c30065b384f05761f15d0cc899d4f9f9cc0eb",
      name: "Ether fi",
      symbol: "ETHFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35958/thumb/etherfi.jpeg?1710254562"
    },
    {
      chainId: 1,
      address: "0x661c70333aa1850ccdbae82776bb436a0fcfeefb",
      name: "eBTC",
      symbol: "EBTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37189/thumb/ebtc-logo_3.png?1713669815"
    },
    {
      chainId: 1,
      address: "0xa939c02dba8f237b40d2a3e96ad4252b00bb8a72",
      name: "Eigenpie LsETH",
      symbol: "MLSETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37205/thumb/mLsETH.png?1713764884"
    },
    {
      chainId: 1,
      address: "0xda251891e21e6edb0e6828e77621c7b98ea4e8ba",
      name: "Meme Moguls",
      symbol: "MGLS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35975/thumb/IMG_20240311_163933_476.jpg?1710298041"
    },
    {
      chainId: 1,
      address: "0x70b02a7d6d86c8ed2193d3c167468ebae28b9538",
      name: "WorldTao",
      symbol: "WTAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35973/thumb/world_tao.jpeg?1710297866"
    },
    {
      chainId: 1,
      address: "0x609c117183c9264af6ee54fe3f290f212b31afbf",
      name: " CryptoPunks 721",
      symbol: "721",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35974/thumb/CPunks.png?1710297918"
    },
    {
      chainId: 1,
      address: "0x571d9b73dc04ed88b4e273e048c8d4848f83b779",
      name: "Super Closed Source",
      symbol: "CLOSEDAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35977/thumb/400x400.jpg?1710306253"
    },
    {
      chainId: 1,
      address: "0x134359b7c852c82e4ebdd16a61020e6b81dd6a6b",
      name: "Bet Lounge",
      symbol: "BETZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35994/thumb/200px-07.png?1710777520"
    },
    {
      chainId: 1,
      address: "0x8dce83eca4af45dbe618da1779f9aaca43201084",
      name: "AlphaKEK AI",
      symbol: "AIKEK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35445/thumb/alphakek_-_Copy.png?1708620097"
    },
    {
      chainId: 1,
      address: "0x9094c15f2f535a765e8a2dac20b05148be7044cd",
      name: "Fusion Ai",
      symbol: "FUSION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35980/thumb/Fusion_Ai_200x200.png?1710306750"
    },
    {
      chainId: 1,
      address: "0x3c0bb14e8367c384885a97bac6d5cceab474ed75",
      name: "Artificial idiot",
      symbol: "AII",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36082/thumb/AII_200x200.png?1710415710"
    },
    {
      chainId: 1,
      address: "0x56b8be7c2d3ffe0d8d6feb4d4eb4650c3ea10bb6",
      name: "LocalAI",
      symbol: "LOCAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35984/thumb/photo_6012793510064931894_c.jpg?1710307895"
    },
    {
      chainId: 1,
      address: "0xc092a137df3cf2b9e5971ba1874d26487c12626d",
      name: "Ring AI",
      symbol: "RING",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35995/thumb/Logo_PP_200x200_circle.png?1710315842"
    },
    {
      chainId: 1,
      address: "0x22514ffb0d7232a56f0c24090e7b68f179faa940",
      name: "QORPO WORLD",
      symbol: "QORPO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35585/thumb/qorpo.jpeg?1709203322"
    },
    {
      chainId: 1,
      address: "0xfd4f2caf941b6d737382dce420b368de3fc7f2d4",
      name: "Patex",
      symbol: "PATEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35987/thumb/ajhjO1Bk_400x400.jpg?1710313200"
    },
    {
      chainId: 1,
      address: "0x4f45acfd7361e283170e28394bbe18395407e0f0",
      name: "LinkTensor",
      symbol: "LTS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35990/thumb/4XIsLD9h_400x400.jpg?1710314291"
    },
    {
      chainId: 1,
      address: "0xf94e7d0710709388bce3161c32b4eea56d3f91cc",
      name: "Destra Network",
      symbol: "DSYNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35996/thumb/Destra_Network.png?1710316001"
    },
    {
      chainId: 1,
      address: "0x8e4d27d772099e18900caf5dcc36cb612dcee886",
      name: "Architex",
      symbol: "ARCX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36026/thumb/arcx.jpeg?1710387472"
    },
    {
      chainId: 1,
      address: "0xe842e272a18625319cc36f64eb9f97e5ad0c32af",
      name: "YAK",
      symbol: "YAK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35674/thumb/cg.png?1709509096"
    },
    {
      chainId: 1,
      address: "0xb418ded94300913fccbef784a49150f46f0fb827",
      name: "TERRIER",
      symbol: "BULL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36001/thumb/IMG_3130.jpeg?1710320533"
    },
    {
      chainId: 1,
      address: "0xdd4ce03b97085e5023d3a5fbff6e4f2c4dffb7c3",
      name: "PORA AI",
      symbol: "PORA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36015/thumb/download.png?1710326560"
    },
    {
      chainId: 1,
      address: "0x78e3b2ee11950df78a35fd924e92fbb8d1403780",
      name: "Helga Inu",
      symbol: "HELGA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36201/thumb/logo2.png?1710832936"
    },
    {
      chainId: 1,
      address: "0x19ae49b9f38dd836317363839a5f6bfbfa7e319a",
      name: "SaitaChain Coin",
      symbol: "STC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33665/thumb/Saitama_200pxby200px-1.png?1703066750"
    },
    {
      chainId: 1,
      address: "0x2a8bf9e7c91c6e3237095e07eb3defbce358df00",
      name: "OpClouds",
      symbol: "OPC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36004/thumb/IMG_20240312_002726_458.jpg?1710323036"
    },
    {
      chainId: 1,
      address: "0x49e1cc8d19e4c52bde82412f900f35ea5e9b5901",
      name: "TAOVM",
      symbol: "TAOVM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36005/thumb/200.png?1710323142"
    },
    {
      chainId: 1,
      address: "0xd775997452923437ca96065ba15ed02f4a33ed39",
      name: "dragon wif hat",
      symbol: "DWIF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36037/thumb/logo.png?1710397494"
    },
    {
      chainId: 1,
      address: "0xd55210bb6898c021a19de1f58d27b71f095921ee",
      name: "Chickencoin",
      symbol: "CHKN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36684/thumb/gekologo.jpg?1712070948"
    },
    {
      chainId: 1,
      address: "0xd2ac55ca3bbd2dd1e9936ec640dcb4b745fde759",
      name: "Index Coop Bitcoin 2x Index",
      symbol: "BTC2X",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36017/thumb/BTC2x-token-logo.png?1710327454"
    },
    {
      chainId: 1,
      address: "0x65c4c0517025ec0843c9146af266a2c5a2d148a2",
      name: "Index Coop Ethereum 2x Index",
      symbol: "ETH2X",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36018/thumb/ETH2x-token-logo.png?1710327494"
    },
    {
      chainId: 1,
      address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
      name: "Tether",
      symbol: "USDT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/325/thumb/Tether.png?1696501661"
    },
    {
      chainId: 1,
      address: "0xbf7bc9e63635dc11b335d52b0349d0100a53a1a7",
      name: "LinkTao",
      symbol: "LTAO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35963/thumb/Tao.jpeg?1710258313"
    },
    {
      chainId: 1,
      address: "0xe4129c7b229812212f88d1bd6a223c45622e6b85",
      name: "Looted Network",
      symbol: "LOOT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35518/thumb/Looted_Network.png?1709006038"
    },
    {
      chainId: 1,
      address: "0x93109af5638be68ed2d0e094f618777ff1051d28",
      name: "UNIT DAO",
      symbol: "UN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34306/thumb/UNITDao.png?1704614014"
    },
    {
      chainId: 1,
      address: "0x085780639cc2cacd35e474e71f4d000e2405d8f6",
      name: "f x  Protocol fxUSD",
      symbol: "FXUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36202/thumb/fxUSD.jpg?1710833113"
    },
    {
      chainId: 1,
      address: "0x4d243e8f511045f0d5f9d0288bc628737b10c079",
      name: "Jason  Eth ",
      symbol: "JASON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36232/thumb/jason_%281%29.jpeg?1710906316"
    },
    {
      chainId: 1,
      address: "0x0d3bd40758df4f79aad316707fcb809cd4815ffe",
      name: "21 co Wrapped XRP",
      symbol: "21XRP",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/34615/thumb/XRP.png?1705503368"
    },
    {
      chainId: 1,
      address: "0xcf91b70017eabde82c9671e30e5502d312ea6eb2",
      name: "I love puppies",
      symbol: "PUPPIES",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35708/thumb/1000005823.jpg?1709624357"
    },
    {
      chainId: 1,
      address: "0x81994dfbbe69c9e03226c2ebe62f7352dc3db812",
      name: "RaidSharksBot",
      symbol: "SHARX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36056/thumb/raidsharkbot-brand-icon-light-circle-colored.png?1710404378"
    },
    {
      chainId: 1,
      address: "0x693170bd3c37dcd46168d8b399aa7551a32de2af",
      name: "TAO Subnet Sharding",
      symbol: "TAOSHARD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36051/thumb/LOGO_COIN_2-removebg-preview.png?1710402750"
    },
    {
      chainId: 1,
      address: "0x1ae7e1d0ce06364ced9ad58225a1705b3e5db92b",
      name: "lmeow",
      symbol: "LMEOW",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35794/thumb/Untitled_design_200%281%29.png?1709801192"
    },
    {
      chainId: 1,
      address: "0x8c7ac134ed985367eadc6f727d79e8295e11435c",
      name: "The Balkan Dwarf",
      symbol: "KEKEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32563/thumb/download-compresskaru.com.png?1698546378"
    },
    {
      chainId: 1,
      address: "0x5ca135cb8527d76e932f34b5145575f9d8cbe08e",
      name: "Frax Price Index",
      symbol: "FPI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24945/thumb/FPI_icon.png?1696524100"
    },
    {
      chainId: 1,
      address: "0x0c79e09497c9862479c9e6499c61342b5fe3e6b2",
      name: "HashPower AI",
      symbol: "HASH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36055/thumb/photo_2024-03-10_19-30-59_%282%29.jpg?1710403993"
    },
    {
      chainId: 1,
      address: "0x8c213ae332274e6314bf4cf989604e7f61162967",
      name: "Dongo AI",
      symbol: "DONGO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36058/thumb/pfp.png?1712164948"
    },
    {
      chainId: 1,
      address: "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa",
      name: "QANplatform",
      symbol: "QANX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15977/thumb/qanx.png?1696515591"
    },
    {
      chainId: 1,
      address: "0x70fd93fb088150e203d2243b9bd3190276f80c70",
      name: "Birddog",
      symbol: "BIRDDOG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37565/thumb/181D06EC-1826-454D-9564-BE83F96FF6D7.png?1714878440"
    },
    {
      chainId: 1,
      address: "0x73af41fe7054057218e0eb07fe43ba5f25c7d79f",
      name: "CASHCAB",
      symbol: "CAB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36062/thumb/s7xKrsPT_400x400.jpg?1710405287"
    },
    {
      chainId: 1,
      address: "0xe9eccde9d26fcbb5e93f536cfc4510a7f46274f8",
      name: "infraX",
      symbol: "INFRA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36063/thumb/RENDR.png?1710405370"
    },
    {
      chainId: 1,
      address: "0xad913dcd987fe54ce823e4b755f90598cd62bb15",
      name: "MFERS",
      symbol: "MFERS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36064/thumb/logo200.png?1710405377"
    },
    {
      chainId: 1,
      address: "0x410e731c2970dce3add351064acf5ce9e33fdbf0",
      name: "ONBUFF",
      symbol: "ONIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12252/thumb/d4suDHSzEZjDXc0uxFGPZXfDFp0L1tfoEusBx03zB1bvMLLbxa7Yq5naXAOutkirIlLXacFRRebX_hF2Ez69_fIPUfr2LuN0Z_UrXTLYds4aT95C6eHGXsZnezMHKAaOmjLpKto0xPTiYkXExvEvXrqL7O_J1wecb4eJsgwCoVprMLpm89BdKO9IyMmpNsfbW7JJFMiHgL8vq9fPhaeEi.jpg?1696512083"
    },
    {
      chainId: 1,
      address: "0x6a26edf3bbc9f154ca9175216ceb9812f5305e6e",
      name: "Pixel",
      symbol: "PIXE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35251/thumb/Pixel_200x200_transparent.png?1708889564"
    },
    {
      chainId: 1,
      address: "0x85e0b9d3e7e4dba7e59090c533906d0e9211d8b6",
      name: "Ishi",
      symbol: "ISHI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36109/thumb/logo.jpg?1714156592"
    },
    {
      chainId: 1,
      address: "0x2ae21de576e0fe0367651ddcf76e04dd0608c076",
      name: "Gambit",
      symbol: "GAMBIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36070/thumb/oHwe1V3Q_400x400.jpg?1710406381"
    },
    {
      chainId: 1,
      address: "0xb87b96868644d99cc70a8565ba7311482edebf6e",
      name: "OnChain Pepe 404",
      symbol: "OCP404",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35271/thumb/download_%282%29.png?1708017745"
    },
    {
      chainId: 1,
      address: "0xb2606492712d311be8f41d940afe8ce742a52d44",
      name: "zkLend",
      symbol: "ZEND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35979/thumb/zkLend_ZEND_logo_square_transparent_background_%281%29.png?1710306648"
    },
    {
      chainId: 1,
      address: "0x668d78571f124415581b38d32fa9a16f1aaa8417",
      name: "1ex",
      symbol: "1EX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34927/thumb/1ex_logo_200%D1%85200.png?1706686304"
    },
    {
      chainId: 1,
      address: "0x994bf19e32584255d82896d1477488e87012f209",
      name: "ComputingAi",
      symbol: "CPU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36150/thumb/IMG_20240316_201708_467.jpg?1710740157"
    },
    {
      chainId: 1,
      address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
      name: "Bella Protocol",
      symbol: "BEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12478/thumb/Bella.png?1696512296"
    },
    {
      chainId: 1,
      address: "0x3d1c949a761c11e4cc50c3ae6bdb0f24fd7a39da",
      name: "Neurahub",
      symbol: "NEURA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36471/thumb/Untitled_design_%2882%29.png?1713297257"
    },
    {
      chainId: 1,
      address: "0x05fe069626543842439ef90d9fa1633640c50cf1",
      name: "Eve AI",
      symbol: "EVEAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29830/thumb/200-X-200.png?1696528758"
    },
    {
      chainId: 1,
      address: "0xa76cec201e939660f8afb1fb8d5865d069df0750",
      name: "Wanna Bot",
      symbol: "WANNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36161/thumb/Wanna.Bot_-_Logo_%28CoinGecko%29.png?1710744457"
    },
    {
      chainId: 1,
      address: "0x2d17b511a85b401980cc0fed15a8d57fdb8eec60",
      name: "Pigeon Park",
      symbol: "PGENZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36162/thumb/Transparent_200x200.png?1710744848"
    },
    {
      chainId: 1,
      address: "0x000000000503be77a5ed27bef2c19943a8b5ae73",
      name: "Xtremeverse",
      symbol: "XTREME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36163/thumb/xnet_logo.jpg?1710745012"
    },
    {
      chainId: 1,
      address: "0xcb21311d3b91b5324f6c11b4f5a656fcacbff122",
      name: "QuantixAI",
      symbol: "QAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36166/thumb/07.png?1710745602"
    },
    {
      chainId: 1,
      address: "0x78ba134c3ace18e69837b01703d07f0db6fb0a60",
      name: "Sentinel Bot Ai",
      symbol: "SNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36171/thumb/sentinelbotai.jpeg?1710746986"
    },
    {
      chainId: 1,
      address: "0x7039cd6d7966672f194e8139074c3d5c4e6dcf65",
      name: "Super Trump",
      symbol: "STRUMP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36083/thumb/Super_Trump.png?1710418492"
    },
    {
      chainId: 1,
      address: "0x018dd3a0dd7f213cc822076b3800816d3ce1ed86",
      name: "HotKeySwap",
      symbol: "HOTKEY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35614/thumb/HOTKEY.jpg?1709281878"
    },
    {
      chainId: 1,
      address: "0x0ec78ed49c2d27b315d462d43b5bab94d2c79bf8",
      name: "MEOW",
      symbol: "MEOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21530/thumb/meowchain.jpeg?1714399782"
    },
    {
      chainId: 1,
      address: "0x6af53c6ec427525f7240e211941223288a0e7c66",
      name: "Warped Games",
      symbol: "WARPED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33307/thumb/Warped-ICON-COLOR-ORANGE.png?1709639013"
    },
    {
      chainId: 1,
      address: "0xcdb4a8742ed7d0259b51e3454c46c9d6c48d5e88",
      name: "GPT Protocol",
      symbol: "GPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35929/thumb/gpt.png?1710225428"
    },
    {
      chainId: 1,
      address: "0x4a220e6096b25eadb88358cb44068a3248254675",
      name: "Quant",
      symbol: "QNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3370/thumb/5ZOu7brX_400x400.jpg?1696504070"
    },
    {
      chainId: 1,
      address: "0xda558a295e8d2c1438f7b4806e283940dec7e6db",
      name: "Tracker AI",
      symbol: "TRACK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36131/thumb/icon_only_transparent_%282%29.png?1713750551"
    },
    {
      chainId: 1,
      address: "0x740a5ac14d0096c81d331adc1611cf2fd28ae317",
      name: "Plebz",
      symbol: "PLEB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36185/thumb/Unknown-1.jpeg?1712340924"
    },
    {
      chainId: 1,
      address: "0x622984873c958e00aa0f004cbdd2b5301cf0b132",
      name: "Gauss0x",
      symbol: "GAUSS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36192/thumb/gaussian200x200.png?1710761823"
    },
    {
      chainId: 1,
      address: "0x1131d427ecd794714ed00733ac0f851e904c8398",
      name: "GenBox",
      symbol: "GENAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37570/thumb/photo_2024-04-24_03-55-50.jpg?1714924494"
    },
    {
      chainId: 1,
      address: "0x004626a008b1acdc4c74ab51644093b155e59a23",
      name: "Angle Staked EURA",
      symbol: "STEUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32036/thumb/stEUR-x4.png?1696530832"
    },
    {
      chainId: 1,
      address: "0xc8dfb57d83bf561457b1a3f6ce22956bb554bcab",
      name: "TradeMaster ninja",
      symbol: "TRDM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36190/thumb/Transparent_200x200.png?1710761061"
    },
    {
      chainId: 1,
      address: "0xf02c2dc9b3cb7f1ba21ccd82dff4ebc92da8996f",
      name: "TensorScan AI",
      symbol: "TSA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36193/thumb/TensorScanAI_200x200.png?1710762625"
    },
    {
      chainId: 1,
      address: "0x902169d471b62f22ffadc690ca292ec454d0b260",
      name: "Reboot World",
      symbol: "RBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36244/thumb/Reboot-Logo_200-1.png?1710921335"
    },
    {
      chainId: 1,
      address: "0x93c5a00b41fb5f3906b421b2399ac64b79fdbd42",
      name: "Voidz",
      symbol: "VDZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36474/thumb/XcJAYXs7_400x400.jpg?1711527406"
    },
    {
      chainId: 1,
      address: "0x518b63da813d46556fea041a88b52e3caa8c16a8",
      name: "Antfarm Token",
      symbol: "ATF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28821/thumb/ATF.png?1696527797"
    },
    {
      chainId: 1,
      address: "0x1a3a8cf347b2bf5890d3d6a1b981c4f4432c8661",
      name: "Flying Avocado Cat",
      symbol: "FAC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34223/thumb/Flying_Avocado_Cat.jpg?1704298390"
    },
    {
      chainId: 1,
      address: "0x722a89f1b925fe41883978219c2176aecc7d6699",
      name: "Kinka",
      symbol: "XNK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36217/thumb/kinka_logomark.png?1710838184"
    },
    {
      chainId: 1,
      address: "0x82a605d6d9114f4ad6d5ee461027477eeed31e34",
      name: "Sensay",
      symbol: "SNSY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36121/thumb/sensay.jpeg?1710495398"
    },
    {
      chainId: 1,
      address: "0x0022228a2cc5e7ef0274a7baa600d44da5ab5776",
      name: "Angle Staked USDA",
      symbol: "STUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34509/thumb/stUSD_copie.png?1705288386"
    },
    {
      chainId: 1,
      address: "0x4123a133ae3c521fd134d7b13a2dec35b56c2463",
      name: "Open Custody Protocol",
      symbol: "OPEN",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/17541/thumb/OPEN-Token-Black.png?1712837762"
    },
    {
      chainId: 1,
      address: "0x72b886d09c117654ab7da13a14d603001de0b777",
      name: "XDEFI",
      symbol: "XDEFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19524/thumb/FilledLogo.png?1696518958"
    },
    {
      chainId: 1,
      address: "0xccccb68e1a848cbdb5b60a974e07aae143ed40c3",
      name: "HYCHAIN",
      symbol: "TOPIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31283/thumb/HYCHAIN_Avatar_Circle.png?1710500962"
    },
    {
      chainId: 1,
      address: "0xb2d007293a421471586d6bc3fbfeb1990fdfa2e6",
      name: "Governance VEC",
      symbol: "GVEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36215/thumb/200x200.png?1710836830"
    },
    {
      chainId: 1,
      address: "0x0d3cbed3f69ee050668adf3d9ea57241cba33a2b",
      name: "PlayDapp",
      symbol: "PDA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14316/thumb/PDA-symbol.png?1710234068"
    },
    {
      chainId: 1,
      address: "0x5ea49ff332b7ad99c486347c1c2bcc73d1e22b9b",
      name: "Synthetic AI",
      symbol: "SAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36247/thumb/photo_2024-03-18_22.59.08.jpeg?1710923867"
    },
    {
      chainId: 1,
      address: "0xaaf449bf8a33a32575c31ba8cbb90612dd95acfa",
      name: "MBD Financials",
      symbol: "MBD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25617/thumb/mbd.jpeg?1713954436"
    },
    {
      chainId: 1,
      address: "0x23150e1db43a04ae1ea993b76dd3c37156cabe0f",
      name: "Teq Network",
      symbol: "TEQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36282/thumb/200.png?1711006401"
    },
    {
      chainId: 1,
      address: "0x6d0bb9b6ce385e28ea4ebb7d76dcb3a1aaf7bc4b",
      name: "CREAT OR",
      symbol: "CRET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35470/thumb/CRET_Logo.png?1708759906"
    },
    {
      chainId: 1,
      address: "0x08ba718f288c3b12b01146816bef9fa03cc635bc",
      name: "Centaurify",
      symbol: "CENT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20512/thumb/Centaurify_Symbol_Black-01.png?1696519918"
    },
    {
      chainId: 1,
      address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
      name: "WETH",
      symbol: "WETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1696503332"
    },
    {
      chainId: 1,
      address: "0xb831717e73dba259ce632b54cfe233d5ead60a1a",
      name: "Telenode",
      symbol: "TNODE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36252/thumb/152A9947-A302-4697-8B16-5364E5C083B8_%281%29.png?1710924819"
    },
    {
      chainId: 1,
      address: "0x35ca1e5a9b1c09fa542fa18d1ba4d61c8edff852",
      name: "Schrodi",
      symbol: "SCHRODI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36255/thumb/apzs3q26_200x200.jpg?1710927534"
    },
    {
      chainId: 1,
      address: "0x8947da500eb47f82df21143d0c01a29862a8c3c5",
      name: "Thales",
      symbol: "THALES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18388/thumb/CLVZJN_C_400x400.png?1696517879"
    },
    {
      chainId: 1,
      address: "0x236501327e701692a281934230af0b6be8df3353",
      name: "Fluence",
      symbol: "FLT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36339/thumb/fluence.png?1711106498"
    },
    {
      chainId: 1,
      address: "0x32b053f2cba79f80ada5078cb6b305da92bde6e1",
      name: "NEURALAI",
      symbol: "NEURAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36341/thumb/NeuralAI_Token_Logo.png?1712340484"
    },
    {
      chainId: 1,
      address: "0x725024200cd4e1f259fcf2b7153d37fb477e139c",
      name: "Flovi Inu",
      symbol: "FLOVI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36734/thumb/1000038565.jpg?1712171719"
    },
    {
      chainId: 1,
      address: "0x070e984fda37dd942f5c953f6b2375339adac308",
      name: "Axe Cap",
      symbol: "AXE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31339/thumb/axe_cap_icon_200x200.png?1696530157"
    },
    {
      chainId: 1,
      address: "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
      name: "RARI",
      symbol: "RARI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11845/thumb/rf_logo_%281%29.jpeg?1711076091"
    },
    {
      chainId: 1,
      address: "0x2eead196943d6a140ee337a5536de01979ebac9d",
      name: "Token Sentry Bot",
      symbol: "SENTRY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36756/thumb/photo_2024-04-01_13-14-28-removebg-preview.jpg?1712245537"
    },
    {
      chainId: 1,
      address: "0x50b275a15e4f5004aa96f972a30e6a9c718b203f",
      name: "StorageChain",
      symbol: "WSTOR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33844/thumb/coinmarketcaplogo.png?1703121289"
    },
    {
      chainId: 1,
      address: "0x83869de76b9ad8125e22b857f519f001588c0f62",
      name: "EXMO Coin",
      symbol: "EXM",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/9154/thumb/200x200.png?1696509276"
    },
    {
      chainId: 1,
      address: "0x486d95c40feba650c38e98cd9d7979d9cd88cea0",
      name: "0xGPU ai",
      symbol: "0XG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36373/thumb/0xGPU_200x200.png?1711339982"
    },
    {
      chainId: 1,
      address: "0xccc80ce58995baae4e5867e5cde3bd9f8b242376",
      name: "God Of Ethereum",
      symbol: "GOE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37567/thumb/1000018327.png?1714881612"
    },
    {
      chainId: 1,
      address: "0xc61edb127f58f42f47a8be8aebe83cf602a53878",
      name: "Castle Of Blackwater",
      symbol: "COBE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36002/thumb/COBEcoinLOGO.png?1711118569"
    },
    {
      chainId: 1,
      address: "0x85d19fb57ca7da715695fcf347ca2169144523a7",
      name: "Conan",
      symbol: "CONAN",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/35566/thumb/android-chrome-192x192.png?1714758795"
    },
    {
      chainId: 1,
      address: "0x443459d45c30a03f90037d011cbe22e2183d3b12",
      name: "TypeAI",
      symbol: "TYPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34484/thumb/Type_AI_%28Custom%29.jpg?1705044610"
    },
    {
      chainId: 1,
      address: "0x0a3bb08b3a15a19b4de82f8acfc862606fb69a2d",
      name: "iZUMi Bond USD",
      symbol: "IUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25388/thumb/iusd-logo-symbol-10k%E5%A4%A7%E5%B0%8F.png?1696524521"
    },
    {
      chainId: 1,
      address: "0xd47bdf574b4f76210ed503e0efe81b58aa061f3d",
      name: "TRVL",
      symbol: "TRVL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20911/thumb/trvl.jpeg?1696520301"
    },
    {
      chainId: 1,
      address: "0xac9518ba93eeb2336a03137d254d8cc2e4d0fa38",
      name: "EDUM",
      symbol: "EDUM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32634/thumb/edum_logo_750.png?1698826232"
    },
    {
      chainId: 1,
      address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
      name: "Badger",
      symbol: "BADGER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13287/thumb/badger_dao_logo.jpg?1696513059"
    },
    {
      chainId: 1,
      address: "0xba100000625a3754423978a60c9317c58a424e3d",
      name: "Balancer",
      symbol: "BAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11683/thumb/Balancer.png?1696511572"
    },
    {
      chainId: 1,
      address: "0x97225fae89b370e7721f961d1145e64df56f2482",
      name: "Smoked Token Burn",
      symbol: "BURN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36345/thumb/Smoked_Token_Burn.png?1711187183"
    },
    {
      chainId: 1,
      address: "0xe304283c3e60cefaf7ea514007cf4e8fdc3d869d",
      name: "Gecoin",
      symbol: "GEC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25646/thumb/62162f0d583e5a047dc02e7e_gecoin_200x200.png?1696524779"
    },
    {
      chainId: 1,
      address: "0xf65b5c5104c4fafd4b709d9d60a185eae063276c",
      name: "Truebit Protocol",
      symbol: "TRU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15053/thumb/Truebit.png?1696514712"
    },
    {
      chainId: 1,
      address: "0x2e4e1093b4e80e3cc73c92264715ca984bad7e55",
      name: "ZionWallet",
      symbol: "ZION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36381/thumb/IMG_20240323_020534_446.png?1711347294"
    },
    {
      chainId: 1,
      address: "0x1b78ffbc66139466c4a432f763afce8d4c991060",
      name: "Cloudnet Ai",
      symbol: "CNAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36574/thumb/cloud.jpeg?1711943190"
    },
    {
      chainId: 1,
      address: "0x0f76d32cdccdcbd602a55af23eaf58fd1ee17245",
      name: "Backed ERNA   Bond",
      symbol: "BERNA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36757/thumb/b-ERNA-200x200.png?1712245846"
    },
    {
      chainId: 1,
      address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
      name: "yearn finance",
      symbol: "YFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yearn.jpg?1696511720"
    },
    {
      chainId: 1,
      address: "0x4b9278b94a1112cad404048903b8d343a810b07e",
      name: "Hifi Finance",
      symbol: "HIFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28712/thumb/hft.png?1696527693"
    },
    {
      chainId: 1,
      address: "0x2407d54b42a570aeb63819d433a63676163cb6d6",
      name: "Renegade",
      symbol: "RNGD",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/35327/thumb/ren%28200_x_200_px%29.png?1708267655"
    },
    {
      chainId: 1,
      address: "0xc6221ac4e99066ea5443acd67d6108f874e2533d",
      name: "Decentralized Cloud Infra",
      symbol: "DCI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36575/thumb/dci.jpeg?1711943349"
    },
    {
      chainId: 1,
      address: "0xc4c244f1dbca07083fee35220d2169957c275e68",
      name: "Steak",
      symbol: "STEAK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36597/thumb/Small_STEAK_Token_Logo_%28200_x_200_px%29.png?1711950525"
    },
    {
      chainId: 1,
      address: "0x477a3d269266994f15e9c43a8d9c0561c4928088",
      name: " ",
      symbol: "YAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36578/thumb/DP.png?1711944185"
    },
    {
      chainId: 1,
      address: "0x680c89c40de9d14aa608a1122363cad18783f837",
      name: "EPICBOTS",
      symbol: "EPIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36469/thumb/LOGO01_-_200x200.png?1711518285"
    },
    {
      chainId: 1,
      address: "0x329cae8c175ac6773d5e79bd30624b953c68a308",
      name: "Misty Meets Pepe",
      symbol: "MISTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37647/thumb/logo_200px.png?1715145235"
    },
    {
      chainId: 1,
      address: "0x766d2fcece1e3eef32aae8711ab886ee95fd5b2a",
      name: "MAGA VP",
      symbol: "MVP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37462/thumb/1000017296.jpg?1714451792"
    },
    {
      chainId: 1,
      address: "0x69457a1c9ec492419344da01daf0df0e0369d5d0",
      name: "Fjord Foundry",
      symbol: "FJO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36510/thumb/fjord.png?1711682800"
    },
    {
      chainId: 1,
      address: "0xb45ad160634c528cc3d2926d9807104fa3157305",
      name: "sDOLA",
      symbol: "SDOLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35495/thumb/sDOLAlogoFINAL.png?1708922289"
    },
    {
      chainId: 1,
      address: "0xfbe44cae91d7df8382208fcdc1fe80e40fbc7e9a",
      name: "The Next Gem AI",
      symbol: "GEMAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36515/thumb/pixelcut-export-1715067678359-removebg-preview.jpg?1715107360"
    },
    {
      chainId: 1,
      address: "0x51573c4c228de0227d3b1e6e598981f8054e8807",
      name: "NOMADS",
      symbol: "NOMADS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36758/thumb/nomads.jpg?1712246083"
    },
    {
      chainId: 1,
      address: "0xc5ba042bf8832999b17c9036e8212f49dce0501a",
      name: "YOUR AI",
      symbol: "YOURAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36260/thumb/yourai-ticker_%281%29.png?1710929542"
    },
    {
      chainId: 1,
      address: "0x96884fcaac082db4b32601ada5b177fd6cbffa88",
      name: "ZkLock",
      symbol: "ZKLK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36586/thumb/IMG_20240328_215725_691.jpg?1711947986"
    },
    {
      chainId: 1,
      address: "0x72a93697a5ac73cfee39ff87298220f77c538611",
      name: "The Dare",
      symbol: "DARE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36818/thumb/DARE.png?1712550833"
    },
    {
      chainId: 1,
      address: "0xb17548c7b510427baac4e267bea62e800b247173",
      name: "Swarm Markets",
      symbol: "SMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17488/thumb/swarm-SMT-token-symbol_200x200.png?1696517029"
    },
    {
      chainId: 1,
      address: "0x50739bd5b6aff093ba2371365727c48a420a060d",
      name: "CryptoGPT",
      symbol: "CRGPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36590/thumb/1000036412.jpg?1711949110"
    },
    {
      chainId: 1,
      address: "0x5cc5e64ab764a0f1e97f23984e20fd4528356a6a",
      name: "XRGB",
      symbol: "XRGB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35447/thumb/log2.png?1708620430"
    },
    {
      chainId: 1,
      address: "0x9cdb8ea1002541a816b271363d64b2787631885f",
      name: "Wrapped Trade AI",
      symbol: "WTAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36472/thumb/TradeAI_Logo_200x200.png?1711525843"
    },
    {
      chainId: 1,
      address: "0xf3768d6e78e65fc64b8f12ffc824452130bd5394",
      name: "Kerosene",
      symbol: "KEROSENE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36603/thumb/kerosene.jpeg?1711960633"
    },
    {
      chainId: 1,
      address: "0x02f92800f57bcd74066f5709f1daa1a4302df875",
      name: "Peapods Finance",
      symbol: "PEAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33711/thumb/NAzHgbTW_400x400.png?1702856653"
    },
    {
      chainId: 1,
      address: "0x85f7cfe910393fb5593c65230622aa597e4223f1",
      name: "Nitefeeder",
      symbol: "NITEFEEDER",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37126/thumb/Nitefeeder_Logo_200x200.png?1713372066"
    },
    {
      chainId: 1,
      address: "0x47e5c76f155083f1aee39578311a2a5faa938a82",
      name: "Trinique",
      symbol: "TNQ",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/36533/thumb/TNQ_LOGO.png?1711705168"
    },
    {
      chainId: 1,
      address: "0x13f7b4581df403542286563c2f762077b2a368da",
      name: "Cloak",
      symbol: "CLOAK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36657/thumb/Dextools_Icon.png?1712042390"
    },
    {
      chainId: 1,
      address: "0xf614e54d972bab297172765ca83683288f3eae36",
      name: "RawBlock",
      symbol: "RWB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36819/thumb/photo_2024-03-18_04-07-55_%281%29-removebg-preview.jpg?1712551052"
    },
    {
      chainId: 1,
      address: "0x66e535e8d2ebf13f49f3d49e5c50395a97c137b1",
      name: "Molten",
      symbol: "MOLTEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36726/thumb/moltenmesh.png?1712147407"
    },
    {
      chainId: 1,
      address: "0x67466be17df832165f8c80a5a120ccc652bd7e69",
      name: "LandWolf",
      symbol: "WOLF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37403/thumb/wolflogo.png?1714368267"
    },
    {
      chainId: 1,
      address: "0xa67d87058b2f4e958b38717909565b6daefb95fe",
      name: "Ionic Pocket Token",
      symbol: "INP",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36671/thumb/200x200_%282%29.png?1712061406"
    },
    {
      chainId: 1,
      address: "0x7dd9c5cba05e151c895fde1cf355c9a1d5da6429",
      name: "Golem",
      symbol: "GLM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/542/thumb/Golem_Submark_Positive_RGB.png?1696501761"
    },
    {
      chainId: 1,
      address: "0x033bbde722ea3cdcec73cffea6581df9f9c257de",
      name: "Velar",
      symbol: "VELAR",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/35763/thumb/200.png?1710245034"
    },
    {
      chainId: 1,
      address: "0x8af78f0c818302164f73b2365fe152c2d1fe80e1",
      name: "Financie Token",
      symbol: "FNCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29099/thumb/VcJQzCWT_400x400.jpg?1696528062"
    },
    {
      chainId: 1,
      address: "0x644192291cc835a93d6330b24ea5f5fedd0eef9e",
      name: "AllianceBlock Nexera",
      symbol: "NXRA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29181/thumb/nxra.png?1712255778"
    },
    {
      chainId: 1,
      address: "0x5488eff1976e4a56b4255e926d419a7054df196a",
      name: "Citty Meme Coin",
      symbol: "CITTY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36878/thumb/200x200.jpg?1712646838"
    },
    {
      chainId: 1,
      address: "0x814a870726edb7dfc4798300ae1ce3e5da0ac467",
      name: "daCat",
      symbol: "DACAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34801/thumb/200x200.png?1706075099"
    },
    {
      chainId: 1,
      address: "0x82f13ab56cc0d1b727e8253a943f0de75b048b0b",
      name: "PlayFi",
      symbol: "PLAYFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36773/thumb/pfiCircleLogo_Alt_Alpha_200.png?1712287250"
    },
    {
      chainId: 1,
      address: "0x7fed466b893c716235e1b8d685c913f7d2797463",
      name: "TensorHub",
      symbol: "THUB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36779/thumb/Tensor.jpeg?1712310491"
    },
    {
      chainId: 1,
      address: "0x2903bd7db50f300b0884f7a15904baffc77f3ec7",
      name: "Arcade",
      symbol: "ARC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36682/thumb/Arcade_200_x_200.png?1712067926"
    },
    {
      chainId: 1,
      address: "0x00000000e88649dd6aab90088ca25d772d4607d0",
      name: "Underworld",
      symbol: "UDW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36704/thumb/UDW-HR-Ticker.jpg?1712125179"
    },
    {
      chainId: 1,
      address: "0x0f17eeccc84739b9450c88de0429020e2dec05eb",
      name: "Otacon AI",
      symbol: "OTACON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32475/thumb/otacon_logo-square_200x200.png?1698285813"
    },
    {
      chainId: 1,
      address: "0xd2ca93093e05366dbc2bf88c3bb189a5141fb6f6",
      name: "SignAI",
      symbol: "SAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36781/thumb/signai_logo_trans_500.png?1712311353"
    },
    {
      chainId: 1,
      address: "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e",
      name: "Moonchain",
      symbol: "MXC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/4604/thumb/M_1-modified.png?1712206949"
    },
    {
      chainId: 1,
      address: "0x07bac35846e5ed502aa91adf6a9e7aa210f2dcbe",
      name: "Sifchain",
      symbol: "EROWAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14044/thumb/EROWAN.png?1696513770"
    },
    {
      chainId: 1,
      address: "0xad53ed3fee57160f026189eb91e73e9317fa92f1",
      name: "zkTAO",
      symbol: "ZAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36782/thumb/photo_2024-04-04_20-59-25.jpg?1712329957"
    },
    {
      chainId: 1,
      address: "0x6eef75b8f067b5853a36da5561f52a8f22faa9af",
      name: "TaoStack",
      symbol: "TST",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36720/thumb/Logomark_Taostack.png?1712129260"
    },
    {
      chainId: 1,
      address: "0xf857c938829c2a53557fb3fbb1c85d10a5227e03",
      name: "ECL",
      symbol: "ECL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37194/thumb/Eucild-200.png?1713675682"
    },
    {
      chainId: 1,
      address: "0x7de91b204c1c737bcee6f000aaa6569cf7061cb7",
      name: "Robonomics Network",
      symbol: "XRT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/7024/thumb/Robonomics-Network-logo.png?1696507330"
    },
    {
      chainId: 1,
      address: "0xba5bde662c17e2adff1075610382b9b691296350",
      name: "SuperRare",
      symbol: "RARE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17753/thumb/RARE.png?1709598473"
    },
    {
      chainId: 1,
      address: "0xca14007eff0db1f8135f4c25b34de49ab0d42766",
      name: "Starknet",
      symbol: "STRK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26433/thumb/starknet.png?1696525507"
    },
    {
      chainId: 1,
      address: "0x84018071282d4b2996272659d9c01cb08dd7327f",
      name: "Blendr Network",
      symbol: "BLENDR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35765/thumb/Blendr_Network.png?1709752266"
    },
    {
      chainId: 1,
      address: "0x00b78238925c320159023c2ac9ef89da8f16d007",
      name: "VPS Ai",
      symbol: "VPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36250/thumb/200px_Logo.png?1710924510"
    },
    {
      chainId: 1,
      address: "0x891e33c8a49ed9f59be3726834ad78cf597b56e9",
      name: "Green Games",
      symbol: "BETTED",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29287/thumb/ficha_icon_CG.png?1696528239"
    },
    {
      chainId: 1,
      address: "0xc0a4df35568f116c370e6a6a6022ceb908eeddac",
      name: "UX Chain",
      symbol: "UX",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/20635/thumb/yArLkbL.png?1696520039"
    },
    {
      chainId: 1,
      address: "0x03a9d7c8caf836de35666c5f7e317306b54fdd4e",
      name: "JC Coin",
      symbol: "JCC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36980/thumb/jc-coin200x200.png?1712939502"
    },
    {
      chainId: 1,
      address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
      name: "Axelar",
      symbol: "AXL",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/27277/thumb/V-65_xQ1_400x400.jpeg?1696526329"
    },
    {
      chainId: 1,
      address: "0xebb1afb0a4ddc9b1f84d9aa72ff956cd1c1eb4be",
      name: "The Emerald Company",
      symbol: "EMRLD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36554/thumb/emrld_logo_200x200px.png?1711898920"
    },
    {
      chainId: 1,
      address: "0xeeee2a622330e6d2036691e983dee87330588603",
      name: "Asko",
      symbol: "ASKO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11773/thumb/ASKO_Token_200x200.png?1714887208"
    },
    {
      chainId: 1,
      address: "0xe635efcfac44c5f44508f4d17c3a96cb4ce421dd",
      name: "Defispot",
      symbol: "SPOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36813/thumb/Defispot_200x200_icon.jpg?1712548786"
    },
    {
      chainId: 1,
      address: "0xb8176941f1b5173dfdbadcc5d387829b27e98138",
      name: "DeOrbit Network",
      symbol: "DEORBIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36960/thumb/IMG_20240411_010755_512.jpg?1712906910"
    },
    {
      chainId: 1,
      address: "0x8a2279d4a90b6fe1c4b30fa660cc9f926797baa2",
      name: "Chromia",
      symbol: "CHR",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/5000/thumb/Chromia.png?1696505533"
    },
    {
      chainId: 1,
      address: "0x3585c1ee4a9c2144510084182b96af961f4ce10d",
      name: "GenAi",
      symbol: "GENAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36811/thumb/-yaP5LZ9_400x400.jpg?1712547717"
    },
    {
      chainId: 1,
      address: "0xee372d2b7e7c83de7e345267b5e4efc1899a4fab",
      name: "Xtrack AI",
      symbol: "XTRACK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36826/thumb/f16d1dda-c158-4fc2-8dad-c3b910ea5958.jpeg?1712556425"
    },
    {
      chainId: 1,
      address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
      name: "Ocean Protocol",
      symbol: "OCEAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3687/thumb/ocean-protocol-logo.jpg?1696504363"
    },
    {
      chainId: 1,
      address: "0xf898bae008cd85046431ab0a75f00689d6aa1b1c",
      name: "0xVPN org",
      symbol: "VPN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36921/thumb/0xf898bae008cd85046431ab0a75f00689d6aa1b1c.png?1712797462"
    },
    {
      chainId: 1,
      address: "0xad5fdc8c3c18d50315331fca7f66efe5033f6c4c",
      name: "Crazy Frog Coin",
      symbol: "CRAZY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33451/thumb/photo_2023-12-05_09.13.36.jpeg?1701859131"
    },
    {
      chainId: 1,
      address: "0xe5018913f2fdf33971864804ddb5fca25c539032",
      name: "OpenLM RevShare Token",
      symbol: "OLM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37186/thumb/Group_1000006185.png?1714009113"
    },
    {
      chainId: 1,
      address: "0x4fabb145d64652a948d72533023f6e7a623c7c53",
      name: "BUSD",
      symbol: "BUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSDLOGO.jpg?1696509654"
    },
    {
      chainId: 1,
      address: "0x32c6f1c1731ff8f98ee2ede8954f696446307846",
      name: "Bearded Dragon",
      symbol: "BEARDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34836/thumb/200x200.jpg?1706266367"
    },
    {
      chainId: 1,
      address: "0x6e79b51959cf968d87826592f46f819f92466615",
      name: "Hoppy",
      symbol: "HOPPY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37197/thumb/IMG_20240419_013423_844.jpg?1713677587"
    },
    {
      chainId: 1,
      address: "0x46947241be767bd05dc843755a991265170dac27",
      name: "Bandwidth AI",
      symbol: "BPS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36962/thumb/Bandwidth_AI.png?1712907332"
    },
    {
      chainId: 1,
      address: "0x89deb6c8918a42457bd6ddbcaaf979216c4d774c",
      name: "HapticAI",
      symbol: "HAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36939/thumb/logo.png?1712850711"
    },
    {
      chainId: 1,
      address: "0xe973e453977195422b48e1852a207b7ee9c913c7",
      name: "ADreward",
      symbol: "AD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29639/thumb/ADreward_AD_Logo_CoinGecko_200X200_%EB%B6%88%ED%88%AC%EB%AA%85.png?1696528576"
    },
    {
      chainId: 1,
      address: "0x0b452278223d3954f4ac050949d7998e373e7e43",
      name: "Shita kiri Suzume",
      symbol: "SUZUME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26813/thumb/shitakiri_cmc.png?1696525873"
    },
    {
      chainId: 1,
      address: "0xb8e3e431ffb17dac4bedec04b901a3c03179fd1b",
      name: "DogePepe",
      symbol: "DOPE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/37049/thumb/DuhyZzFj_400x400.jpg?1713165301"
    },
    {
      chainId: 1,
      address: "0x3fca2cd116121decd03043fbaba39f60651de903",
      name: "Fuxion Labs",
      symbol: "FUXE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37025/thumb/%D9%A2%D9%A0%D9%A2%D9%A4%D9%A0%D9%A4%D9%A1%D9%A3_%D9%A1%D9%A4%D9%A5%D9%A7%D9%A1%D9%A0.jpg?1713156776"
    },
    {
      chainId: 1,
      address: "0xa8c8cfb141a3bb59fea1e2ea6b79b5ecbcd7b6ca",
      name: "Synternet",
      symbol: "NOIA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/3269/thumb/Twitter-Profile-01.png?1714005625"
    },
    {
      chainId: 1,
      address: "0x4e432a62733a7ee38ad2e16b3cc0731457ea5b55",
      name: "QChain QDT",
      symbol: "QDT",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/26502/thumb/qdt_logo.png?1696525575"
    },
    {
      chainId: 1,
      address: "0xf1e345ea7c33fd6c05f5512a780eb5839ee31674",
      name: "Telefy",
      symbol: "TELE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26485/thumb/WhatsApp_Image_2022-07-20_at_2.51.42_AM.jpeg?1696525558"
    },
    {
      chainId: 1,
      address: "0x6e0615a03ed9527a6013fcd5b556e36ef4dab1ff",
      name: "HNB Protocol",
      symbol: "HNB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26182/thumb/newhnblogo.png?1696525269"
    },
    {
      chainId: 1,
      address: "0x6c5ba91642f10282b576d91922ae6448c9d52f4e",
      name: "Phala",
      symbol: "PHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12451/thumb/phala.png?1696512270"
    },
    {
      chainId: 1,
      address: "0xa130e3a33a4d84b04c3918c4e5762223ae252f80",
      name: "Swash",
      symbol: "SWASH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18774/thumb/Swash_icon_GP.png?1712869197"
    },
    {
      chainId: 1,
      address: "0x60e254e35dd712394b3aba7a1d19114732e143dd",
      name: "RivusDAO",
      symbol: "RIVUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36965/thumb/IMG_0167.png?1712907932"
    },
    {
      chainId: 1,
      address: "0x84fad63f8f26335f4f1bebc9fbf5ba277fd23c9e",
      name: "Arma Block",
      symbol: "AB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37112/thumb/SSM.jpg?1713329715"
    },
    {
      chainId: 1,
      address: "0xf1376bcef0f78459c0ed0ba5ddce976f1ddf51f4",
      name: "Universal ETH",
      symbol: "UNIETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28477/thumb/uniETH_200.png?1696527471"
    },
    {
      chainId: 1,
      address: "0x36096eb8c11729fdd7685d5e1b82b17d542c38ce",
      name: "NousAI",
      symbol: "NOUS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37020/thumb/logo_150.png?1713154924"
    },
    {
      chainId: 1,
      address: "0x1317d2a56520e64bfe3c2ecd89b6a8b3fb1d6a08",
      name: "HaiperAI",
      symbol: "HAIPERAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37021/thumb/HAIPER_SQUARE_HD_%282%29.png?1713155245"
    },
    {
      chainId: 1,
      address: "0x649004e1c9fd8b0241d544bd78fc4eb3d3b4d199",
      name: "INOVAI",
      symbol: "INOVAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37010/thumb/INOVAI_200x200.png?1713079066"
    },
    {
      chainId: 1,
      address: "0xbf5495efe5db9ce00f80364c8b423567e58d2110",
      name: "Renzo Restaked ETH",
      symbol: "EZETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34753/thumb/Ezeth_logo_circle.png?1713496404"
    },
    {
      chainId: 1,
      address: "0xe5c6f5fef89b64f36bfccb063962820136bac42f",
      name: "Hoppy The Frog",
      symbol: "HOPPY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36745/thumb/IMG_0207-modified.png?1714321914"
    },
    {
      chainId: 1,
      address: "0x3330bfb7332ca23cd071631837dc289b09c33333",
      name: "Rubic",
      symbol: "RBC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12629/thumb/rubic.png?1696512437"
    },
    {
      chainId: 1,
      address: "0x8ce9137d39326ad0cd6491fb5cc0cba0e089b6a9",
      name: "Solar",
      symbol: "SXP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9368/thumb/swipe.png?1696509466"
    },
    {
      chainId: 1,
      address: "0x8afe4055ebc86bd2afb3940c0095c9aca511d852",
      name: "Arbius",
      symbol: "AIUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35246/thumb/arbius-200x-logo.png?1707987961"
    },
    {
      chainId: 1,
      address: "0x76aab5fd2243d99eac92d4d9ebf23525d3ace4ec",
      name: "GG MetaGame",
      symbol: "GGMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37040/thumb/200x200_GG_MetaGame.png?1713162096"
    },
    {
      chainId: 1,
      address: "0xf19693068120185664e211f619c4f0530ce07088",
      name: "BANK AI",
      symbol: "BANK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31407/thumb/bankai.jpeg?1713247357"
    },
    {
      chainId: 1,
      address: "0x0501b9188436e35bb10f35998c40adc079003866",
      name: "AI Analysis Token",
      symbol: "AIAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33672/thumb/aia-logo-icon200.png?1702702028"
    },
    {
      chainId: 1,
      address: "0xc4058f6a829ddd684e1b7589b33312827f0a47bb",
      name: "aNDY",
      symbol: "ANDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37076/thumb/IMG_1087.jpeg?1713248763"
    },
    {
      chainId: 1,
      address: "0xb10cc888cb2cce7036f4c7ecad8a57da16161338",
      name: "Switch Token",
      symbol: "SWITCH",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/30140/thumb/SWITCH-200x200-Circle_Token.jpg?1696529061"
    },
    {
      chainId: 1,
      address: "0x15fa5d3dbd11a831b72b92c1705bc9f801e233cb",
      name: "PointPay",
      symbol: "PXP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37084/thumb/pointpay-removebg-preview.png?1713253076"
    },
    {
      chainId: 1,
      address: "0x2614f29c39de46468a921fd0b41fdd99a01f2edf",
      name: "HELIOS",
      symbol: "HLX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35650/thumb/HeliosPNG.png?1709375257"
    },
    {
      chainId: 1,
      address: "0xaada04204e9e1099daf67cf3d5d137e84e41cf41",
      name: "Peepo",
      symbol: "PEEPO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30006/thumb/20230425_175833.png?1696528931"
    },
    {
      chainId: 1,
      address: "0x000000000a1c6659ac226dbb1c5bdc648df72e9e",
      name: "Looter",
      symbol: "LOOTER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35837/thumb/LMdtc2Xz_400x400_%281%29.jpg?1709889187"
    },
    {
      chainId: 1,
      address: "0x7d0c49057c09501595a8ce23b773bb36a40b521f",
      name: "PREME Token",
      symbol: "PREME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36091/thumb/PREME_Token.png?1710477118"
    },
    {
      chainId: 1,
      address: "0xae35dc90bb0bb9139f25fba6282b43aa02a9b9ca",
      name: "Runebound",
      symbol: "RUNE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37098/thumb/200.png?1713287738"
    },
    {
      chainId: 1,
      address: "0x6630e3a2ec1e7e0a2f9f1d2289a9a89b0551683a",
      name: "dogwifsaudihat",
      symbol: "WIFSA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36885/thumb/Qr2lN8au_400x400.jpg?1712649792"
    },
    {
      chainId: 1,
      address: "0xfc4913214444af5c715cc9f7b52655e788a569ed",
      name: "Icosa  ETH ",
      symbol: "ICSA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37540/thumb/icosa.jpeg?1714705688"
    },
    {
      chainId: 1,
      address: "0x5796136ac98f83e732b99edf783ad247c997e8ef",
      name: "zkArchive",
      symbol: "ZKARCH",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37206/thumb/ZKARCH.jpg?1713767440"
    },
    {
      chainId: 1,
      address: "0x4b7c762af92dbd917d159eb282b85aa13e955739",
      name: "Poodl Inu",
      symbol: "POODL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37100/thumb/Poodl_Inu.png?1713290212"
    },
    {
      chainId: 1,
      address: "0x25b4f5d4c314bcd5d7962734936c957b947cb7cf",
      name: "TG Casino",
      symbol: "TGC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34473/thumb/TGC_Logo_200x200.png?1704998035"
    },
    {
      chainId: 1,
      address: "0xae41b275aaaf484b541a5881a2dded9515184cca",
      name: "ChainSwap",
      symbol: "CSWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35888/thumb/ChainSwap.png?1710121063"
    },
    {
      chainId: 1,
      address: "0x8a0a9b663693a22235b896f70a229c4a22597623",
      name: "Scalia Infrastructure",
      symbol: "SCALE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35653/thumb/Scalia_Infrastructure.png?1709380021"
    },
    {
      chainId: 1,
      address: "0x292fcdd1b104de5a00250febba9bc6a5092a0076",
      name: "HashAI",
      symbol: "HASHAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36743/thumb/HashAI.png?1712212747"
    },
    {
      chainId: 1,
      address: "0x1f557fb2aa33dce484902695ca1374f413875519",
      name: "Vestate",
      symbol: "VES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35475/thumb/IMG_0759.png?1708772732"
    },
    {
      chainId: 1,
      address: "0xbc61e13ca6830fc7f035fd0e90a01cd08be6dcaa",
      name: "Mars Battle",
      symbol: "SHOOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36553/thumb/icon.png?1711896644"
    },
    {
      chainId: 1,
      address: "0x0e6641e62baa87d77e01ab1c7e9d2f323f26942b",
      name: "AssetLink",
      symbol: "ASET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33907/thumb/Logo3D-NOBG.png?1703241821"
    },
    {
      chainId: 1,
      address: "0x564a80d0123bdd750fb6a9993834968fc595c09a",
      name: "Super Best Friends",
      symbol: "SUBF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36368/thumb/1000017215.jpg?1711338058"
    },
    {
      chainId: 1,
      address: "0x15e6e0d4ebeac120f9a97e71faa6a0235b85ed12",
      name: "SatoshiVM",
      symbol: "SAVM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34659/thumb/SatoshiVM.jpeg?1705635248"
    },
    {
      chainId: 1,
      address: "0x3c4b6e6e1ea3d4863700d7f76b36b7f3d3f13e3d",
      name: "Voyager",
      symbol: "VGX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/794/thumb/Voyager-vgx.png?1696501945"
    },
    {
      chainId: 1,
      address: "0xbddc20ed7978b7d59ef190962f441cd18c14e19f",
      name: "Crypto Asset Governance Alliance",
      symbol: "CAGA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32846/thumb/200px_caga_transparent.png?1707469892"
    },
    {
      chainId: 1,
      address: "0x9727eaf447203be268e5d471b6503bf47a71ea72",
      name: "Arky",
      symbol: "ARKY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37557/thumb/ARKY200.png?1714840130"
    },
    {
      chainId: 1,
      address: "0xc668695dcbcf682de106da94bde65c9bc79362d3",
      name: "Shadow Node",
      symbol: "SVPN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36124/thumb/Group_13127_copy_%28200p%29.png?1710502856"
    },
    {
      chainId: 1,
      address: "0x7137e8a3b069c3f787c4ffbb901b91e4ba47d082",
      name: "Zeus",
      symbol: "ZEUS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36847/thumb/zeusdog.jpg?1713034053"
    },
    {
      chainId: 1,
      address: "0x95ac17ce4021417e25b8edf807366fc3be091b5e",
      name: "Zaar",
      symbol: "ZAAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30901/thumb/zaar.jpeg?1713753409"
    },
    {
      chainId: 1,
      address: "0x91fbb2503ac69702061f1ac6885759fc853e6eae",
      name: "K9 Finance DAO",
      symbol: "KNINE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35824/thumb/k9_200_X_200.png?1709886958"
    },
    {
      chainId: 1,
      address: "0x3b21418081528845a6df4e970bd2185545b712ba",
      name: "Chi Protocol",
      symbol: "CHI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34067/thumb/Chi-Logo.png?1708079610"
    },
    {
      chainId: 1,
      address: "0xf6ce4be313ead51511215f1874c898239a331e37",
      name: "Bird Dog",
      symbol: "BIRDDOG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/36707/thumb/photo_2024-04-17_01-49-44.jpg?1713382145"
    },
    {
      chainId: 1,
      address: "0x724313985dcb55d432d3888ddc0b9e3d3859e86d",
      name: "BitRunes",
      symbol: "BRUNE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37265/thumb/BitRunes.png?1713867578"
    },
    {
      chainId: 1,
      address: "0xa728aa2de568766e2fa4544ec7a77f79c0bf9f97",
      name: "JokInTheBox",
      symbol: "JOK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37363/thumb/jok_pp_2_200X200.png?1714110620"
    },
    {
      chainId: 1,
      address: "0xab622b253e441928affa6e2efb2f0f9a8bf6890d",
      name: "NutCoin",
      symbol: "NUT",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/9535/thumb/logo_%2825%29.png?1696509617"
    },
    {
      chainId: 1,
      address: "0x3e29793c9bdeb6ce5a84c2beced91ad50c530b16",
      name: "ChainZoom",
      symbol: "ZOOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37241/thumb/1000006617.jpg?1713859754"
    },
    {
      chainId: 1,
      address: "0x28e67eb7aaa8f5dd9cb7be2b2e3dad6b25edb1ab",
      name: "Freaky KEKE",
      symbol: "KEKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37244/thumb/FreakyKEKE-200x200.png?1713860401"
    },
    {
      chainId: 1,
      address: "0x3d875a26d9afcbf4f58c920509c876b594499c87",
      name: "K Chain",
      symbol: "KCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25531/thumb/IMG_3487.PNG?1696524664"
    },
    {
      chainId: 1,
      address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
      name: "Pax Dollar",
      symbol: "USDP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/6013/thumb/Pax_Dollar.png?1696506427"
    },
    {
      chainId: 1,
      address: "0x607496f14918891594177c24a983e901c1896e63",
      name: "GOLD CAT",
      symbol: "GOLDCAT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37268/thumb/zzUr8L_n_400x400.jpg?1713886460"
    },
    {
      chainId: 1,
      address: "0x3e2c956b4ab4807b2f942235c9074d9bd069e9f0",
      name: "IPVERSE",
      symbol: "IPV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25778/thumb/IPVERSE.png?1714365488"
    },
    {
      chainId: 1,
      address: "0x9e22b4f836a461ddc7765e5fad693688e76e6069",
      name: "Chad Frog",
      symbol: "CHAD",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37364/thumb/CHAD200.jpg?1714110736"
    },
    {
      chainId: 1,
      address: "0x5afe3855358e112b5647b952709e6165e1c1eeee",
      name: "Safe",
      symbol: "SAFE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27032/thumb/Artboard_1_copy_8circle-1.png?1696526084"
    },
    {
      chainId: 1,
      address: "0x6e2a43be0b1d33b726f0ca3b8de60b3482b8b050",
      name: "Arkham",
      symbol: "ARKM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30929/thumb/Arkham_Logo_CG.png?1696529771"
    },
    {
      chainId: 1,
      address: "0x8decef6c5d56a07e532b014fbb97db05c7380cbe",
      name: "FairEx",
      symbol: "FRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37321/thumb/8078e022-a739-464d-bd31-5adb9d246acf.jpeg?1713980310"
    },
    {
      chainId: 1,
      address: "0x16c22a91c705ec3c2d5945dbe2aca37924f1d2ed",
      name: "Elon s Pet Fish ERIC",
      symbol: "ERIC",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37176/thumb/eiric-logo-200x200.png?1713987341"
    },
    {
      chainId: 1,
      address: "0x3916ea28cccc5ce0a58535dd2635a5c12ddd4457",
      name: "Tangle Network",
      symbol: "TNET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37300/thumb/tg_profile-3.png?1713951610"
    },
    {
      chainId: 1,
      address: "0x5d303e548728c8c472fa23955afd2d6301db427d",
      name: "Shibabitcoin",
      symbol: "SHIBTC",
      decimals: 20,
      logoURI: "https://assets.coingecko.com/coins/images/37304/thumb/Shibabitcoin.png?1713952171"
    },
    {
      chainId: 1,
      address: "0x4022754bf8857395383c63326391f289d1bb14b9",
      name: "DRIVE3",
      symbol: "DRV3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37487/thumb/drv.jpg?1714491815"
    },
    {
      chainId: 1,
      address: "0xe92344b4edf545f3209094b192e46600a19e7c2d",
      name: "zKML",
      symbol: "ZKML",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35238/thumb/I66UdAOY_400x400.jpg?1708003991"
    },
    {
      chainId: 1,
      address: "0x396c95abe154b3b2ed204cf45c8726aa7ad47a4d",
      name: "Gradient Protocol",
      symbol: "GDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37305/thumb/1000199694.jpg?1713952287"
    },
    {
      chainId: 1,
      address: "0x342f4ca388896e6300bb899aca2d8619cbefcece",
      name: "Innovai",
      symbol: "INO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37307/thumb/InnovaiLogo200x200.png?1713952452"
    },
    {
      chainId: 1,
      address: "0xc78b628b060258300218740b1a7a5b3c82b3bd9f",
      name: "Commune AI",
      symbol: "COMAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35013/thumb/Wrapped_Commune_AI.png?1707103767"
    },
    {
      chainId: 1,
      address: "0xa89e2871a850e0e6fd8f0018ec1fc62fa75440d4",
      name: "Ready to Fight",
      symbol: "RTF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37322/thumb/Frame_21313315692.png?1714002508"
    },
    {
      chainId: 1,
      address: "0xbb126042235e6bd38b17744cb31a8bf4a206c045",
      name: "fanC",
      symbol: "FANC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26500/thumb/hJ6MD49P_400x400.jpeg?1696525574"
    },
    {
      chainId: 1,
      address: "0xabd0e3535ecfbf6959b1798220335faf1b7ada3a",
      name: "Predict Crypto",
      symbol: "PREAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37361/thumb/IMG_4784.JPG?1714109782"
    },
    {
      chainId: 1,
      address: "0x793a5d8b30aab326f83d20a9370c827fea8fdc51",
      name: "Gorilla In A Coupe",
      symbol: "GIAC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36016/thumb/Gorilla_In_A_Coupe.png?1710326800"
    },
    {
      chainId: 1,
      address: "0x9b4a69de6ca0defdd02c0c4ce6cb84de5202944e",
      name: "PROOF Platform",
      symbol: "PROOF",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/32478/thumb/PROOF_icon_-_200.png?1698286769"
    },
    {
      chainId: 1,
      address: "0x6715515f5aa98e8bd3624922e1ba91e6f5fc4402",
      name: "SatoshiSync",
      symbol: "SSNC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36777/thumb/ssnc.jpeg?1712654999"
    },
    {
      chainId: 1,
      address: "0x748509433ef209c4d11ada51347d5724a5da0ca5",
      name: "Andy on ETH",
      symbol: "ANDY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37330/thumb/V7hhqYRg_311.png?1714028798"
    },
    {
      chainId: 1,
      address: "0xe1c7e30c42c24582888c758984f6e382096786bd",
      name: "Curate",
      symbol: "XCUR",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/13327/thumb/400x400_%281%29_%283%29_%282%29.png?1696513096"
    },
    {
      chainId: 1,
      address: "0x1a3496c18d558bd9c6c8f609e1b129f67ab08163",
      name: "DEAPCOIN",
      symbol: "DEP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10970/thumb/DEAPcoin_01.png?1696510917"
    },
    {
      chainId: 1,
      address: "0x032c3ec6d4c894844fd855874062a86592801cc9",
      name: "Converge Bot",
      symbol: "CONVERGE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33519/thumb/cg.png?1712560854"
    },
    {
      chainId: 1,
      address: "0x68bbed6a47194eff1cf514b50ea91895597fc91e",
      name: "ANDY ETH",
      symbol: "ANDY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35910/thumb/IMG_20240309_044840_797.jpg?1710179397"
    },
    {
      chainId: 1,
      address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
      name: "Yield Guild Games",
      symbol: "YGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17358/thumb/Shield_Mark_-_Colored_-_Iridescent.png?1696516909"
    },
    {
      chainId: 1,
      address: "0xb60fdf036f2ad584f79525b5da76c5c531283a1b",
      name: "Nemo Sum",
      symbol: "NEMO",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37575/thumb/200x200.png?1714929206"
    },
    {
      chainId: 1,
      address: "0x255f1b39172f65dc6406b8bee8b08155c45fe1b6",
      name: "HarambeCoin",
      symbol: "HARAMBE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36043/thumb/HarambeCoin_full_cameo_200.png?1710400612"
    },
    {
      chainId: 1,
      address: "0x60158131416f5e53d55d73a11be2e203cb26abcc",
      name: "Hyper",
      symbol: "EON",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/35247/thumb/EON_Token_200_x_200.png?1707987981"
    },
    {
      chainId: 1,
      address: "0x6b89b97169a797d94f057f4a0b01e2ca303155e4",
      name: "Chad Coin",
      symbol: "CHAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29863/thumb/Elipsa_3_1500x1500.png?1714240722"
    },
    {
      chainId: 1,
      address: "0x8dba4bc68126bd186fbb62c976539d1558c9fe73",
      name: "PEPEBOMB",
      symbol: "PEPE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37411/thumb/photo_2024-04-27_17-15-14.jpg?1714373512"
    },
    {
      chainId: 1,
      address: "0xce872db165d4f5623af9c29e03afd416bc5f67bc",
      name: "StakeVault Network",
      symbol: "SVN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37433/thumb/SVN.png?1714379860"
    },
    {
      chainId: 1,
      address: "0x4cb1e6c430bb4b874869fd6049ed07ae975b02f1",
      name: "Bndr",
      symbol: "SWIPES",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37491/thumb/Logocoingeko.png?1714499814"
    },
    {
      chainId: 1,
      address: "0x6c28aef8977c9b773996d0e8376d2ee379446f2f",
      name: "Quickswap  OLD ",
      symbol: "QUICK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13970/thumb/quick.png?1696513704"
    },
    {
      chainId: 1,
      address: "0xdd66781d0e9a08d4fbb5ec7bac80b691be27f21d",
      name: "AxonDAO Governance Token",
      symbol: "AXGT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35290/thumb/AXGT-logo-7.png?1708076161"
    },
    {
      chainId: 1,
      address: "0x864ac60596435031cdd28257091c26c62e53e44d",
      name: "AMAX",
      symbol: "AMAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37500/thumb/AMAX-4_%282%29.jpg?1714542115"
    },
    {
      chainId: 1,
      address: "0xde342a3e269056fc3305f9e315f4c40d917ba521",
      name: "Byte",
      symbol: "BYTE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33527/thumb/Byte200.jpeg?1702138460"
    },
    {
      chainId: 1,
      address: "0x313cae7ad4454aac7b208c1f089da2b0e5825e46",
      name: "RepubliK",
      symbol: "RPK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32950/thumb/RPK_Token_Logo_2x.png?1699935349"
    },
    {
      chainId: 1,
      address: "0xb29dc1703facd2967bb8ade2e392385644c6dca9",
      name: "Gaga  Pepe ",
      symbol: "GAGA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36546/thumb/gaga200x200.png?1711734371"
    },
    {
      chainId: 1,
      address: "0xc434268603ca8854e0be1a3ff15cad73bd6ec49a",
      name: "Zapicorn",
      symbol: "ZAPI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33153/thumb/download.png?1700825821"
    },
    {
      chainId: 1,
      address: "0x94be6962be41377d5beda8dfe1b100f3bf0eacf3",
      name: "DORK LORD  ETH ",
      symbol: "DORKL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31654/thumb/%E1%97%AAO%E1%96%87K_%E1%92%AAO%E1%96%87%E1%97%AA.png?1696530469"
    },
    {
      chainId: 1,
      address: "0x02020595e6a34a03a8e9c1f5624b1b7713810083",
      name: "Spectra Chain",
      symbol: "SPCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36791/thumb/0x02020595e6a34a03a8e9c1f5624b1b7713810083.jpg?1712421016"
    },
    {
      chainId: 1,
      address: "0x5ce6f2c0e2a1b4540894f286254bf13b1110d240",
      name: "Bricks",
      symbol: "BRX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36963/thumb/brx_logo_symbol_2024_200x200.png?1712907453"
    },
    {
      chainId: 1,
      address: "0x420698ebc9b7c225731c02d887d0729057339d39",
      name: "Chuck",
      symbol: "CHUCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36750/thumb/IMG_0741.jpeg?1712218300"
    },
    {
      chainId: 1,
      address: "0xb7cffebb06621287c7850ffefb22c30252e78e6b",
      name: "Drift Token",
      symbol: "DRIFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37455/thumb/DRIFT.jpg?1714451680"
    },
    {
      chainId: 1,
      address: "0x69420e3a3aa9e17dea102bb3a9b3b73dcddb9528",
      name: "Elon",
      symbol: "ELON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37515/thumb/elonlogo.png?1714630893"
    },
    {
      chainId: 1,
      address: "0x57e114b691db790c35207b2e685d4a43181e6061",
      name: "Ethena",
      symbol: "ENA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36530/thumb/ethena.png?1711701436"
    },
    {
      chainId: 1,
      address: "0xa059b81568fee88791de88232e838465826cf419",
      name: "THREE",
      symbol: "THREE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37486/thumb/Real_Three_logo_%28200_x_200_%D0%BF%D0%B8%D0%BA%D1%81.%29-3.png?1714674839"
    },
    {
      chainId: 1,
      address: "0x7f9b09f4717072cf4dc18b95d1b09e2b30c76790",
      name: "Vault AI",
      symbol: "VAULT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32578/thumb/IMG_6957.jpeg?1698558686"
    },
    {
      chainId: 1,
      address: "0xd28cca138166f1d6dae560a0e15e5be2a97c819d",
      name: "BANDS",
      symbol: "BANDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37587/thumb/bands.jpeg?1714976058"
    },
    {
      chainId: 1,
      address: "0xbc188b5dbb155b6ea693d46d98bf60b8482939b9",
      name: "Apollo FTW",
      symbol: "FTW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37526/thumb/apollo-ftw-cmc.png?1714639185"
    },
    {
      chainId: 1,
      address: "0x3f91ad19af450b44cf5176b4de719d77cb19eec7",
      name: "Luxury Travel Token",
      symbol: "LTT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37545/thumb/LTT_logo_200x200.png?1714733838"
    },
    {
      chainId: 1,
      address: "0x55c3a56e638e96c91f98735cc86f60a6820e6a44",
      name: "GavCoin",
      symbol: "GAV",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37525/thumb/GAV200.jpg?1714637917"
    },
    {
      chainId: 1,
      address: "0xd699b83e43415b774b6ed4ce9999680f049af2ab",
      name: "Bubsy AI",
      symbol: "BUBSY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37612/thumb/Bubsy_Logo_%28200px%29.png?1715057915"
    },
    {
      chainId: 1,
      address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
      name: "dYdX",
      symbol: "ETHDYDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17500/thumb/hjnIm9bV.jpg?1696517040"
    },
    {
      chainId: 1,
      address: "0x3b50805453023a91a8bf641e279401a0b23fa6f9",
      name: "Renzo",
      symbol: "REZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37327/thumb/renzo_200x200.png?1714025012"
    },
    {
      chainId: 1,
      address: "0xcbf4d5efa82e32a9187385480a7c74cb062b956c",
      name: "Satoshi Nakamoto",
      symbol: "SATOSHI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37611/thumb/SATOSHI_LOGO.PNG?1715054986"
    },
    {
      chainId: 1,
      address: "0x9f04c2bd696a6191246144ba762456a24c457520",
      name: "AITaxBot",
      symbol: "AITAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37613/thumb/AITaxBot.png?1715058483"
    },
    {
      chainId: 1,
      address: "0xf819d9cb1c2a819fd991781a822de3ca8607c3c9",
      name: "Unibot",
      symbol: "UNIBOT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30462/thumb/logonoline_%281%29.png?1696529349"
    },
    {
      chainId: 1,
      address: "0x96e99106d9c58573171dd6c19d767d2ae7ec0435",
      name: "Pyges",
      symbol: "PYGES",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37616/thumb/.png.?1715061787"
    },
    {
      chainId: 1,
      address: "0xf5d791eebfc229c4fe976e8328ed2c261690cb34",
      name: "Book Of Bitcoin",
      symbol: "BOOB",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37624/thumb/IMG_9021.jpeg?1715068444"
    },
    {
      chainId: 1,
      address: "0x8805792d41facb22b6f47d468b06af36ff3fc1c5",
      name: "UPMAX",
      symbol: "MAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37625/thumb/Logo_Cricle.png?1715068895"
    },
    {
      chainId: 1,
      address: "0x5027fc44a7ba114b8f494b1e4970900c6652fedf",
      name: "Arcana Network",
      symbol: "XAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23373/thumb/Arcana_-_Logomark_-_White_on_Pink_2x.png?1712340381"
    },
    {
      chainId: 1,
      address: "0x2541a36be4cd39286ed61a3e6afc2307602489d6",
      name: "Dogecoin20",
      symbol: "DOGE20",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37628/thumb/exOalaX3_400x400.png?1715069462"
    },
    {
      chainId: 1,
      address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
      name: "Serum",
      symbol: "SRM",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/11970/thumb/serum-logo.png?1696511829"
    },
    {
      chainId: 1,
      address: "0xd1d2eb1b1e90b638588728b4130137d262c87cae",
      name: "GALA",
      symbol: "GALA",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/12493/thumb/GALA_token_image_-_200PNG.png?1709725869"
    },
    {
      chainId: 1,
      address: "0xfb5c6815ca3ac72ce9f5006869ae67f18bf77006",
      name: "pSTAKE Finance",
      symbol: "PSTAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23931/thumb/PSTAKE_Dark.png?1696523129"
    },
    {
      chainId: 1,
      address: "0x888888848b652b3e3a0f34c96e00eec0f3a23f72",
      name: "Alien Worlds",
      symbol: "TLM",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/14676/thumb/kY-C4o7RThfWrDQsLCAG4q4clZhBDDfJQVhWUEKxXAzyQYMj4Jmq1zmFwpRqxhAJFPOa0AsW_PTSshoPuMnXNwq3rU7Imp15QimXTjlXMx0nC088mt1rIwRs75GnLLugWjSllxgzvQ9YrP4tBgclK4_rb17hjnusGj_c0u2fx0AvVokjSNB-v2poTj0xT9BZRCbzRE3-lF1.jpg?1696514350"
    },
    {
      chainId: 1,
      address: "0x17d2628d30f8e9e966c9ba831c9b9b01ea8ea75c",
      name: "ISKRA Token",
      symbol: "ISK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27428/thumb/ISKRA_logo.png?1696526469"
    },
    {
      chainId: 1,
      address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
      name: "Ethernity Chain",
      symbol: "ERN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14238/thumb/logo_black.png?1715198164"
    },
    {
      chainId: 1,
      address: "0x8cedb0680531d26e62abdbd0f4c5428b7fdc26d5",
      name: "Micro GPT",
      symbol: "MICRO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37633/thumb/0x8cedb0680531d26e62abdbd0f4c5428b7fdc26d5.jpg?1715101374"
    },
    {
      chainId: 1,
      address: "0x8b683c400457ef31f3c27c90acb6ab69304d1b77",
      name: "Zydio AI",
      symbol: "ZDAI",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/37655/thumb/Zydio_AI_200x200.png?1715160554"
    },
    {
      chainId: 1,
      address: "0x90b7e285ab6cf4e3a2487669dba3e339db8a3320",
      name: "Yellow Duckies",
      symbol: "DUCKIES",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/27630/thumb/duckies_logo.png?1706528164"
    },
    {
      chainId: 1,
      address: "0x66d79b8f60ec93bfce0b56f5ac14a2714e509a99",
      name: "MAP Protocol",
      symbol: "MAPO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/10085/thumb/logos_%283%29.png?1714041325"
    },
    {
      chainId: 1,
      address: "0xfe80d611c6403f70e5b1b9b722d2b3510b740b2b",
      name: "Equilibria Finance",
      symbol: "EQB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30645/thumb/QLLK8pmR_400x400.jpg?1696529516"
    },
    {
      chainId: 1,
      address: "0x0921799cb1d702148131024d18fcde022129dc73",
      name: "LightLink",
      symbol: "LL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35357/thumb/lightlink-ticker-200.png?1708362303"
    },
    {
      chainId: 1,
      address: "0x912529007bc0d2a5464a6a211ebfe217dfb75dff",
      name: "Cadence Protocol",
      symbol: "CAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34323/thumb/CAD_200_200_transparent.png?1704646661"
    },
    {
      chainId: 1,
      address: "0x7135b32e9903bdb4e19a8b1d22fc2038964b8451",
      name: "EarlyFans",
      symbol: "EARLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37614/thumb/Logo_200x200.png?1715061001"
    },
    {
      chainId: 1,
      address: "0x572975ff6d5136c81c8d7448b6361ef9eefe1ab0",
      name: "Wrapped Staked USDT",
      symbol: "WSTUSDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31160/thumb/wstusdt.jpeg?1696529988"
    },
    {
      chainId: 1,
      address: "0x4af8aa621df6dd3e2d653188a357fc2b35c6a037",
      name: "SELFCrypto",
      symbol: "SELF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30805/thumb/Isotype_1_200x200.png?1696529663"
    },
    {
      chainId: 1,
      address: "0x414ac1853329b3704df0caf7749cd296c7f3b750",
      name: "Anzen Private Credit",
      symbol: "PCT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35018/thumb/Anzen-Logo-Symbol-Color_small_square.png?1707110484"
    },
    {
      chainId: 1,
      address: "0x77774a06271d6a305caccdbc06f847def05c7777",
      name: "Gyrowin",
      symbol: "GW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32329/thumb/Brandlogo_1-200x200.png?1697451818"
    },
    {
      chainId: 1,
      address: "0xc4170fd71eced3c80badca77f4e12e8aac1e3436",
      name: "Kryptomon",
      symbol: "KMON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17886/thumb/kryptomon.png?1696517407"
    },
    {
      chainId: 1,
      address: "0xbc6378faae98fb2207bb6c35c0f8ce5846fd4c6c",
      name: "8Bit Chain",
      symbol: "W8BIT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35459/thumb/8BIT-200x200.PNG?1708675050"
    },
    {
      chainId: 1,
      address: "0x438e48ed4ce6beecf503d43b9dbd3c30d516e7fd",
      name: "UWON",
      symbol: "UWON",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35593/thumb/2024-02-29_10.53.39.jpg?1709221802"
    },
    {
      chainId: 1,
      address: "0x9377e3c3180dddfcda4e4217ed21f2f7c3b235a0",
      name: "Cavada",
      symbol: "CAVADA",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/35476/thumb/cavada_main.png?1708773117"
    },
    {
      chainId: 1,
      address: "0x911d86c72155c33993d594b0ec7e6206b4c803da",
      name: "Wrapped Staked LINK",
      symbol: "WSTLINK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35678/thumb/wstlink_logo.png?1709525182"
    },
    {
      chainId: 1,
      address: "0xf0187b76be05c1fcaa24f39c0a3aab4434099c4f",
      name: "Aether Games",
      symbol: "AEG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29916/thumb/coin_200x198.png?1708678337"
    },
    {
      chainId: 1,
      address: "0xed2d13a70acbd61074fc56bd0d0845e35f793e5e",
      name: "Planet Mojo",
      symbol: "MOJO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36670/thumb/MOJOIcon.jpg?1712061269"
    },
    {
      chainId: 1,
      address: "0x50d5118fb90d572b9d42ba65e0addc4900867809",
      name: "Osean",
      symbol: "OSEAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30968/thumb/oceana.png?1696529808"
    },
    {
      chainId: 1,
      address: "0x01824357d7d7eaf4677bc17786abd26cbdec9ad7",
      name: "Forward",
      symbol: "FORWARD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20866/thumb/182860872_110384464503974_4805876988713020861_n.png?1696520260"
    },
    {
      chainId: 1,
      address: "0x039d2e8f097331278bd6c1415d839310e0d5ece4",
      name: "Linda",
      symbol: "LINDA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33699/thumb/linda-logo-200.png?1705166731"
    },
    {
      chainId: 1,
      address: "0xcb19b6b4971bd4206bab176c75b1efe3e28ee5a8",
      name: "Seneca",
      symbol: "SEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32852/thumb/200x200.png?1699663676"
    },
    {
      chainId: 1,
      address: "0xb712d62fe84258292d1961b5150a19bc4ab49026",
      name: "Chainge",
      symbol: "XCHNG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16526/thumb/chainge.jpeg?1708099639"
    },
    {
      chainId: 1,
      address: "0xb51b97dd5569fab69495316b5a065cccff4b829d",
      name: "Astrafer",
      symbol: "ASTRAFER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26246/thumb/ATSRA_Token.png?1696525331"
    },
    {
      chainId: 1,
      address: "0x5052fa4a2a147eaaa4c0242e9cc54a10a4f42070",
      name: "HANePlatform",
      symbol: "HANEP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35202/thumb/HANeP_200px.png?1707842735"
    },
    {
      chainId: 1,
      address: "0xa80505c408c4defd9522981cd77e026f5a49fe63",
      name: "NEUY",
      symbol: "NEUY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25870/thumb/logo200x200.png?1696524953"
    },
    {
      chainId: 1,
      address: "0x0000000000300dd8b0230efcfef136ecdf6abcde",
      name: "DegenX",
      symbol: "DGNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27204/thumb/logo-200-200.png?1705413440"
    },
    {
      chainId: 1,
      address: "0xe0dcb3e02798d1c6a9650fe1381015ec34705153",
      name: "Match Token",
      symbol: "MATCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34082/thumb/MATCH.jpg?1703910229"
    },
    {
      chainId: 1,
      address: "0x92cc36d66e9d739d50673d1f27929a371fb83a67",
      name: "Wagmi",
      symbol: "WAGMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31887/thumb/wagmi_token_logo.png?1696530698"
    },
    {
      chainId: 1,
      address: "0xf1264873436a0771e440e2b28072fafcc5eebd01",
      name: "Kenshi",
      symbol: "KNS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30759/thumb/kenshi.jpg?1696529628"
    },
    {
      chainId: 1,
      address: "0x27eb7aa2cce204012f7d9cd4d49baa746ec5ab63",
      name: "GGTKN",
      symbol: "GGTKN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26275/thumb/ggtokenofficiallogo.png?1696525358"
    },
    {
      chainId: 1,
      address: "0x174c47d6a4e548ed2b7d369dc0ffb2e60a6ac0f8",
      name: "Amulet Protocol",
      symbol: "AMU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/34716/thumb/AMT200x200.png?1705904544"
    },
    {
      chainId: 1,
      address: "0x2c2d8a078b33bf7782a16acce2c5ba6653a90d5f",
      name: "L3USD",
      symbol: "L3USD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26937/thumb/L3USD.png?1696525993"
    },
    {
      chainId: 1,
      address: "0x872952d3c1caf944852c5adda65633f1ef218a26",
      name: "Liquid Crypto",
      symbol: "LQDX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33627/thumb/LQDX.png?1702533263"
    },
    {
      chainId: 1,
      address: "0xd3cc9d8f3689b83c91b7b59cab4946b063eb894a",
      name: "Venus",
      symbol: "XVS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12677/thumb/download.jpg?1696512482"
    },
    {
      chainId: 1,
      address: "0x95987b0cdc7f65d989a30b3b7132a38388c548eb",
      name: "Pundi X PURSE",
      symbol: "PURSE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20419/thumb/HobiV7k__400x400.jpg?1696519827"
    },
    {
      chainId: 1,
      address: "0x39162d9f64c0f9d64d14eac3b6d5a15d3d569eea",
      name: "MrWeb Finance",
      symbol: "AMA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27173/thumb/jd0i3xri_400x400.jpeg?1696526223"
    },
    {
      chainId: 1,
      address: "0x79f05c263055ba20ee0e814acd117c20caa10e0c",
      name: "Ice Open Network",
      symbol: "ICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34674/thumb/ion-coingecko-200w.png?1714009819"
    },
    {
      chainId: 1,
      address: "0xd3ac016b1b8c80eeadde4d186a9138c9324e4189",
      name: "Okcash",
      symbol: "OK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/274/thumb/ok-logo-200px.png?1696501624"
    },
    {
      chainId: 1,
      address: "0xbbcb0356bb9e6b3faa5cbf9e5f36185d53403ac9",
      name: "Backed Coinbase Global",
      symbol: "BCOIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31872/thumb/b-COIN-200x200.png?1696530684"
    },
    {
      chainId: 1,
      address: "0x2cb5d9fd89d48c516f11904117c57e3934f39524",
      name: "PEPE UWU",
      symbol: "CUTE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33691/thumb/Resized_AvEWEWA5_200x200_%281%29.png?1702796454"
    },
    {
      chainId: 1,
      address: "0x9424fde68418b71ea1d3de95547ef67f4dc8f573",
      name: "BandZai Token",
      symbol: "BZAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30825/thumb/BZAI_coin.png?1696529678"
    },
    {
      chainId: 1,
      address: "0x75cb71325a44fb102a742626b723054acb7e1394",
      name: "Anime",
      symbol: "ANI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13792/thumb/ani.png?1696513541"
    },
    {
      chainId: 1,
      address: "0xe20b9e246db5a0d21bf9209e4858bc9a3ff7a034",
      name: "Wrapped Banano",
      symbol: "WBAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32617/thumb/WBAN.jpg?1698749253"
    },
    {
      chainId: 1,
      address: "0xbb6cf73a00f480d0951ba979a7606857cdde626b",
      name: "Arix",
      symbol: "ARIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13485/thumb/ARIX.png?1696513245"
    },
    {
      chainId: 1,
      address: "0x30b47e13ccee15d6fa7a80994c94bb9b4a4bb973",
      name: "Scratch Meme Coin",
      symbol: "SCRATS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31323/thumb/logo_%283%29.png?1696530142"
    },
    {
      chainId: 1,
      address: "0x830eb1204380e9c44434db8700257025358707c6",
      name: "Goons of Balatroon",
      symbol: "GOB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27104/thumb/TokenLogo200x200.png?1702250134"
    },
    {
      chainId: 1,
      address: "0x0a77ef9bf662d62fbf9ba4cf861eaa83f9cc4fec",
      name: "X World Games",
      symbol: "XWG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17847/thumb/200_200_%281%29_%281%29.png?1696790226"
    },
    {
      chainId: 1,
      address: "0xe35009059cb55ded065027e9832a2c564aff7512",
      name: "SecureChain AI",
      symbol: "SCAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31680/thumb/SCAI-icon-3.png?1696530499"
    },
    {
      chainId: 1,
      address: "0x137ddb47ee24eaa998a535ab00378d6bfa84f893",
      name: "Radiant Capital",
      symbol: "RDNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26536/thumb/Radiant-Logo-200x200.png?1696525610"
    },
    {
      chainId: 1,
      address: "0xaf6a1125d4cc55a4110dc63cd2ff6e005afb8676",
      name: "PunkCity",
      symbol: "PUNK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31049/thumb/F4FDA24D-1B29-4CBB-8346-854D1BFFE75A.png?1696529883"
    },
    {
      chainId: 1,
      address: "0x4563554284aa7148d6e6d0351519e954ba3b6e02",
      name: "Xend Finance",
      symbol: "RWA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14496/thumb/WeChat_Image_20210325163206.png?1696514181"
    },
    {
      chainId: 1,
      address: "0xa10bf0aba0c7953f279c4cb8192d3b5de5ea56e8",
      name: "Tarot",
      symbol: "TAROT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31800/thumb/TAROT.jpg?1696530615"
    },
    {
      chainId: 1,
      address: "0xf97e2a78f1f3d1fd438ff7cc3bb7de01e5945b83",
      name: "holoride",
      symbol: "RIDE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21626/thumb/RIDE_Token_Symbol_MASTER.png?1696520986"
    },
    {
      chainId: 1,
      address: "0x9d3d07439069c9bbc8d626397cf98cb343ac0a72",
      name: "Technology Metal Network Global",
      symbol: "TMNG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32834/thumb/TMN_Logo_dark_silver_2.PNG?1699586186"
    },
    {
      chainId: 1,
      address: "0x2f11eeee0bf21e7661a22dbbbb9068f4ad191b86",
      name: "Backed NIU Technologies",
      symbol: "BNIU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31869/thumb/b-NIU-200x200.png?1696530681"
    },
    {
      chainId: 1,
      address: "0x37613d64258c0fe09d5e53eecb091da5b8fa8707",
      name: "Pi Protocol",
      symbol: "PIP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27476/thumb/LOGO_%281%29.png?1696526514"
    },
    {
      chainId: 1,
      address: "0x9fd22a17b4a96da3f83797d122172c450381fb88",
      name: "Jefe",
      symbol: "JEFE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/25336/thumb/JEFE_200.png?1696524470"
    },
    {
      chainId: 1,
      address: "0xf68d4d917592f3a62417ace42592f15296cc33a0",
      name: "COINHUB",
      symbol: "CHB",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/26818/thumb/a08jRqRh_400x400.jpg?1696525877"
    },
    {
      chainId: 1,
      address: "0xa48f322f8b3edff967629af79e027628b9dd1298",
      name: "Davos Protocol",
      symbol: "DUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28775/thumb/dusd_logo_200x200.png?1696527754"
    },
    {
      chainId: 1,
      address: "0x59f4f336bf3d0c49dbfba4a74ebd2a6ace40539a",
      name: "Catcoin",
      symbol: "CAT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/25279/thumb/cat5.png?1696524419"
    },
    {
      chainId: 1,
      address: "0x5e7f20e72c21f6d0bf0a2814fd4164176401cf8e",
      name: "Demeter",
      symbol: "DEO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25582/thumb/7zyskNC.png?1696524714"
    },
    {
      chainId: 1,
      address: "0x20b3b07e9c0e37815e2892ab09496559f57c3603",
      name: "USDV",
      symbol: "USDV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31806/thumb/200x200.png?1696530621"
    },
    {
      chainId: 1,
      address: "0x9bd69bc59118ce0fbce9b03551a765a779bd25cf",
      name: "zkEra Finance",
      symbol: "ZKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33928/thumb/zke.png?1703409212"
    },
    {
      chainId: 1,
      address: "0x4190818ffeb4c7349fa59eeb08eb6e7ab70d9aa7",
      name: "LFi",
      symbol: "LFI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31897/thumb/LFi_Token.png?1696530708"
    },
    {
      chainId: 1,
      address: "0xc819617f360f6347d222f260e9f4987ca1d0f879",
      name: "ICLICK Inu",
      symbol: "ICLICK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32060/thumb/Iclick.png?1696530857"
    },
    {
      chainId: 1,
      address: "0x7df4122d3eae29fc8fb6be58d9177e8e560be4fb",
      name: "BlockChainCoinX",
      symbol: "XCCX",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/32276/thumb/xccxx.png?1697180263"
    },
    {
      chainId: 1,
      address: "0x000000e29fa2bd3e5c215ffc71aa66b29c9769a2",
      name: "Ethereum Express",
      symbol: "ETE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31600/thumb/200X200.png?1696530416"
    },
    {
      chainId: 1,
      address: "0x00000000ba2ca30042001abc545871380f570b1f",
      name: "ArithFi",
      symbol: "ATF",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32122/thumb/2.Profile.png?1696586855"
    },
    {
      chainId: 1,
      address: "0x96543ef8d2c75c26387c1a319ae69c0bee6f3fe7",
      name: "Kujira",
      symbol: "KUJI",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/20685/thumb/kuji-200x200.png?1696520085"
    },
    {
      chainId: 1,
      address: "0x1b3c515f58857e141a966b33182f2f3feecc10e9",
      name: "USK",
      symbol: "USK",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/27274/thumb/usk.png?1696526326"
    },
    {
      chainId: 1,
      address: "0x772722b55cdc2a086abd064267a17855eb15e8b3",
      name: "MintMe com Coin",
      symbol: "MINTME",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5127/thumb/MINTME_logo.png?1696505647"
    },
    {
      chainId: 1,
      address: "0xb5b29320d2dde5ba5bafa1ebcd270052070483ec",
      name: "YieldETH  Sommelier ",
      symbol: "YIELDETH",
      decimals: 18
    },
    {
      chainId: 1,
      address: "0xb399511642fe1666c6a07f83483e6e4feaed9a00",
      name: "The Standard EURO",
      symbol: "EUROS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32231/thumb/EUROs-coingecko.png?1696936278"
    },
    {
      chainId: 1,
      address: "0x580e933d90091b9ce380740e3a4a39c67eb85b4c",
      name: "GameSwift",
      symbol: "GSWIFT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30949/thumb/GameSwift_Token.png?1696529788"
    },
    {
      chainId: 1,
      address: "0x4e9e4ab99cfc14b852f552f5fb3aa68617825b6c",
      name: "Solarcoin",
      symbol: "SLR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/152/thumb/solarcoin.png?1696501524"
    },
    {
      chainId: 1,
      address: "0x3a856d4effa670c54585a5d523e96513e148e95d",
      name: "TriasLab",
      symbol: "TRIAS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/13963/thumb/5ELqtwp__400x400_%281%29.jpg?1696513699"
    },
    {
      chainId: 1,
      address: "0xb2ee0adbe0ef1281025d0676511bb1df14600f4d",
      name: "FORE Protocol",
      symbol: "FORE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31001/thumb/EXCHANGE_LOGO_FORE.png?1696529839"
    },
    {
      chainId: 1,
      address: "0xa4335da338ec4c07c391fc1a9bf75f306adadc08",
      name: "ARYZE eUSD",
      symbol: "EUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32422/thumb/ARYZE_eUSD.png?1698118313"
    },
    {
      chainId: 1,
      address: "0xc03b43d492d904406db2d7d57e67c7e8234ba752",
      name: "Wrapped USDR",
      symbol: "WUSDR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/28800/thumb/wUSDRlogo.png?1696527777"
    },
    {
      chainId: 1,
      address: "0xcc503242b574bc01145da7e2a743b43fb395ec91",
      name: "ROVI Protocol",
      symbol: "ROVI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28936/thumb/rovi-coin.png?1696527910"
    },
    {
      chainId: 1,
      address: "0x2512c545a0117353e4e9acddff860342640d3cf6",
      name: "WHEE",
      symbol: "WHEE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30285/thumb/whee.jpg?1696529190"
    },
    {
      chainId: 1,
      address: "0x1f3f677ecc58f6a1f9e2cf410df4776a8546b5de",
      name: "VNDC",
      symbol: "VNDC",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/9670/thumb/vndc-gold-coin.png?1696509740"
    },
    {
      chainId: 1,
      address: "0xf05897cfe3ce9bbbfe0751cbe6b1b2c686848dcb",
      name: "CateCoin",
      symbol: "CATE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15364/thumb/logo.png?1696515013"
    },
    {
      chainId: 1,
      address: "0xb2492e97a68a6e4b9e9a11b99f6c42e5accd38c7",
      name: "Veloce",
      symbol: "VEXT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31214/thumb/VEXT_Logo.jpg?1696530041"
    },
    {
      chainId: 1,
      address: "0xdd1b6b259986571a85da82a84f461e1c212591c0",
      name: "BlazeX",
      symbol: "BLAZEX",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/31194/thumb/200x200.png?1696530022"
    },
    {
      chainId: 1,
      address: "0x73fbd93bfda83b111ddc092aa3a4ca77fd30d380",
      name: "SophiaVerse",
      symbol: "SOPH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30050/thumb/Icon_200x200.png?1696528972"
    },
    {
      chainId: 1,
      address: "0xf2b2f7b47715256ce4ea43363a867fdce9353e3a",
      name: "Bitgert",
      symbol: "BRISE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17388/thumb/200x200.png?1696516937"
    },
    {
      chainId: 1,
      address: "0x8f006d1e1d9dc6c98996f50a4c810f17a47fbf19",
      name: "Pleasure Coin",
      symbol: "NSFW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15315/thumb/pleasurecoin-icon.png?1696514965"
    },
    {
      chainId: 1,
      address: "0xd20523b39faf1d6e9023a4d6085f87b7b0de7926",
      name: "OATH",
      symbol: "OATH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24075/thumb/OATH.png?1698051304"
    },
    {
      chainId: 1,
      address: "0x25931894a86d47441213199621f1f2994e1c39aa",
      name: "ChainGPT",
      symbol: "CGPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29306/thumb/200x200.png?1696528257"
    },
    {
      chainId: 1,
      address: "0x152649ea73beab28c5b49b26eb48f7ead6d4c898",
      name: "PancakeSwap",
      symbol: "CAKE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12632/thumb/pancakeswap-cake-logo_%281%29.png?1696512440"
    },
    {
      chainId: 1,
      address: "0x4eea762311be76f9071aa01058c047ad12a017a1",
      name: "GBURN",
      symbol: "GBURN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33048/thumb/Untitled_design_-_2023-11-10T174143.724.png?1700472805"
    },
    {
      chainId: 1,
      address: "0x39d5313c3750140e5042887413ba8aa6145a9bd2",
      name: "Empyreal",
      symbol: "EMP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31374/thumb/emplogotransparent_%281%29.png?1696530191"
    },
    {
      chainId: 1,
      address: "0x6b66ccd1340c479b07b390d326eadcbb84e726ba",
      name: "Seamless Protocol",
      symbol: "SEAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33480/thumb/Seamless_Logo_Black_Transparent.png?1702019657"
    },
    {
      chainId: 1,
      address: "0x0b925ed163218f6662a35e0f0371ac234f9e9371",
      name: "Aave v3 wstETH",
      symbol: "AWSTETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32890/thumb/WSTETH.png?1699776336"
    },
    {
      chainId: 1,
      address: "0x3fe6a295459fae07df8a0cecc36f37160fe86aa9",
      name: "Aave v3 LUSD",
      symbol: "ALUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32894/thumb/LUSD.png?1699789893"
    },
    {
      chainId: 1,
      address: "0x582d872a1b094fc48f5de31d3b73f2d9be47def1",
      name: "Toncoin",
      symbol: "TON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17980/thumb/ton_symbol.png?1696517498"
    },
    {
      chainId: 1,
      address: "0xade6057fcafa57d6d51ffa341c64ce4814995995",
      name: "Backed ZPR1   1 3 Month T Bill",
      symbol: "BZPR1",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32867/thumb/b-ZPR1-200x200.png?1699671603"
    },
    {
      chainId: 1,
      address: "0xd711d7d893de57dc13ff465763218770bd42db1d",
      name: "ARYZE eGBP",
      symbol: "EGBP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32989/thumb/ARYZE_eGBP.png?1700099647"
    },
    {
      chainId: 1,
      address: "0xb55ee890426341fe45ee6dc788d2d93d25b59063",
      name: "Love io",
      symbol: "LOVE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33011/thumb/IMG_7458.png?1700124277"
    },
    {
      chainId: 1,
      address: "0x31e4efe290973ebe91b3a875a7994f650942d28f",
      name: "Shrapnel",
      symbol: "SHRAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32793/thumb/shrapnel.png?1699441661"
    },
    {
      chainId: 1,
      address: "0x31a2e08f4232329e4eddb025c0275f43c9cd56d7",
      name: "LUSD",
      symbol: "LUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33592/thumb/LUSD.jpg?1702471959"
    },
    {
      chainId: 1,
      address: "0x735fa792e731a2e8f83f32eb539841b7b72e6d8f",
      name: "ARYZE eEUR",
      symbol: "EEUR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32421/thumb/ARYZE_eEUR.png?1698118176"
    },
    {
      chainId: 1,
      address: "0xe939f011a3d8fc0aa874c97e8156053a903d7176",
      name: "DOLZ io",
      symbol: "DOLZ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33605/thumb/dolz_200.png?1702510960"
    },
    {
      chainId: 1,
      address: "0x75d86078625d1e2f612de2627d34c7bc411c18b8",
      name: "AGII",
      symbol: "AGII",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32371/thumb/AGII.png?1699534856"
    },
    {
      chainId: 1,
      address: "0xe6828d65bf5023ae1851d90d8783cc821ba7eee1",
      name: "ApeBond",
      symbol: "ABOND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33814/thumb/l-_N-wAO_400x400.jpg?1703020501"
    },
    {
      chainId: 1,
      address: "0xa2c2c937333165d4c5f2dc5f31a43e1239fecfeb",
      name: "Hera Finance",
      symbol: "HERA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24751/thumb/logo-icon-200x.png?1696523913"
    },
    {
      chainId: 1,
      address: "0x1f7e5118521b550bb1a9b435727c003eb033fc51",
      name: "Angola",
      symbol: "AGLA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27547/thumb/8SGgovDI_400x400.png?1696526584"
    },
    {
      chainId: 1,
      address: "0xbf27b3163c25113be5439d56f8acf2209ef3e5bd",
      name: "Hotel of Secrets",
      symbol: "HOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31567/thumb/Hotel_of_Secrets_icon.png?1696530379"
    },
    {
      chainId: 1,
      address: "0x8b9f7e9586633ca4abffb1f746da8daed7849cb2",
      name: "Cremation Coin",
      symbol: "CREMAT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29793/thumb/photo_2023-02-07_04-43-14.jpg?1696528723"
    },
    {
      chainId: 1,
      address: "0x388d819724dd6d71760a38f00dc01d310d879771",
      name: "JustMoney",
      symbol: "JM",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/25450/thumb/jm.png?1696524581"
    },
    {
      chainId: 1,
      address: "0x4b19c70da4c6fa4baa0660825e889d2f7eabc279",
      name: "Gamium",
      symbol: "GMM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22749/thumb/gamium_logotype_social_media.png?1713382179"
    },
    {
      chainId: 1,
      address: "0xdad33e12e61dc2f2692f2c12e6303b5ade7277ba",
      name: "Brewlabs",
      symbol: "BREWLABS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/21928/thumb/7xgmOCBW_400x400.jpg?1696521278"
    },
    {
      chainId: 1,
      address: "0x186d0ba3dfc3386c464eecd96a61fbb1e2da00bf",
      name: "Trava Finance",
      symbol: "TRAVA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17553/thumb/TRAVA_OFFICIAL_LOGO.png?1696517089"
    },
    {
      chainId: 1,
      address: "0x333000333b26ee30214b4af6419d9ab07a450400",
      name: "MELD",
      symbol: "MELD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30170/thumb/Twitter.jpg?1696529090"
    },
    {
      chainId: 1,
      address: "0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b",
      name: "Cronos",
      symbol: "CRO",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/7310/thumb/cro_token_logo.png?1696507599"
    },
    {
      chainId: 1,
      address: "0x7cfea0dd176651e7b5a1ced9c4faf8ee295315fd",
      name: "Prime Numbers Ecosystem",
      symbol: "PRNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22669/thumb/primenumers_favicon_01.png?1696521981"
    },
    {
      chainId: 1,
      address: "0xf33893de6eb6ae9a67442e066ae9abd228f5290c",
      name: "GroveCoin",
      symbol: "GRV",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/25549/thumb/200x200.png?1696524682"
    },
    {
      chainId: 1,
      address: "0x5b8650cd999b23cf39ab12e3213fbc8709c7f5cb",
      name: "MaziMatic",
      symbol: "MAZI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30490/thumb/4de906d9d4104a16b4334d8ec8f75284.png?1696529377"
    },
    {
      chainId: 1,
      address: "0x9ed7e4b1bff939ad473da5e7a218c771d1569456",
      name: "Reunit Wallet",
      symbol: "REUNI",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/29492/thumb/reunit_200.png?1696528436"
    },
    {
      chainId: 1,
      address: "0x91a69021b0baef3445e51726458a0ce601471846",
      name: "Ethos Reserve Note",
      symbol: "ERN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29744/thumb/ERN200x200.png?1696528676"
    },
    {
      chainId: 1,
      address: "0x9d1089802ee608ba84c5c98211afe5f37f96b36c",
      name: "Fluid USDC",
      symbol: "FUSDC",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/28471/thumb/fUSDC-200x200.png?1696527465"
    },
    {
      chainId: 1,
      address: "0xa75e7928d3de682e3f44da60c26f33117c4e6c5c",
      name: "Propel",
      symbol: "PEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21290/thumb/img_circle_1.png?1696520660"
    },
    {
      chainId: 1,
      address: "0x15a3081b541e8dad25c4a5e0c4c4b4e8d105b2e8",
      name: "Pepe Original Version",
      symbol: "POV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30121/thumb/our_logo.png?1696529043"
    },
    {
      chainId: 1,
      address: "0x1bd55090b8878630e57fae6ebd11fd61d16dfc9f",
      name: "ArchLoot",
      symbol: "ALT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28919/thumb/7.png?1696527894"
    },
    {
      chainId: 1,
      address: "0x0ae38f7e10a43b5b2fb064b42a2f4514cba909ef",
      name: "unshETH Ether",
      symbol: "UNSHETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30365/thumb/ush.png?1696529262"
    },
    {
      chainId: 1,
      address: "0x490e3f4af13e1616ec97a8c6600c1061a8d0253e",
      name: "Terran Coin",
      symbol: "TRR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15351/thumb/TERRAN-500px.png?1696515000"
    },
    {
      chainId: 1,
      address: "0x849a226f327b89e3133d9930d927f9eb9346f8c9",
      name: "Crypto Global United",
      symbol: "CGU",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/20751/thumb/2022_CGU-MG_RGB.png?1696520148"
    },
    {
      chainId: 1,
      address: "0x3c917054e03485808137eb306eafa8da0ab695cd",
      name: "Orbcity",
      symbol: "ORB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24332/thumb/OrbCity_Logo.png?1713409621"
    },
    {
      chainId: 1,
      address: "0xb8c77482e45f1f44de1745f52c74426c631bdd52",
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/825/thumb/bnb-icon2_2x.png?1696501970"
    },
    {
      chainId: 1,
      address: "0xa670d7237398238de01267472c6f13e5b8010fd1",
      name: "Sommelier",
      symbol: "SOMM",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/23308/thumb/somm_new.png?1696522525"
    },
    {
      chainId: 1,
      address: "0xffa188493c15dfaf2c206c97d8633377847b6a52",
      name: "Wefi Finance",
      symbol: "WEFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30540/thumb/wefi.png?1696529412"
    },
    {
      chainId: 1,
      address: "0xd8fa690304d2b2824d918c0c7376e2823704557a",
      name: "SquidGrow",
      symbol: "SQUIDGROW",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26573/thumb/Squidgrow-Logo.png?1696525645"
    },
    {
      chainId: 1,
      address: "0x395e925834996e558bdec77cd648435d620afb5b",
      name: "ThreeFold",
      symbol: "TFT",
      decimals: 7,
      logoURI: "https://assets.coingecko.com/coins/images/6704/thumb/black_logo_on_white_background_%282%29.jpg?1696507044"
    },
    {
      chainId: 1,
      address: "0x8db4beaccd1698892821a9a0dc367792c0cb9940",
      name: "Ignore Fud",
      symbol: "4TOKEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29626/thumb/200x200.png?1696528562"
    },
    {
      chainId: 1,
      address: "0x26aad156ba8efa501b32b42ffcdc8413f90e9c99",
      name: "Open Campus",
      symbol: "EDU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29948/thumb/EDU_Logo.png?1696528874"
    },
    {
      chainId: 1,
      address: "0x837d904a3799c0769079be9ecbaddf1abd4ccd6e",
      name: "Tarot V1",
      symbol: "TAROT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17881/thumb/tarot-200px.png?1696517403"
    },
    {
      chainId: 1,
      address: "0xdcfa8c46ec015d4bf13d6be492cb7a8eb4580899",
      name: "impactMarket",
      symbol: "PACT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21907/thumb/PACT_Token_Ticker_Blue_2x.png?1696521258"
    },
    {
      chainId: 1,
      address: "0x4184aa04215e5d716dd4c213fed519acadc68f92",
      name: "ONUS",
      symbol: "ONUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24599/thumb/ONUS_200.png?1696523773"
    },
    {
      chainId: 1,
      address: "0xb012be90957d70d9a070918027655f998c123a88",
      name: "Hermes DAO",
      symbol: "HMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29283/thumb/Hermes_DAO.png?1696528235"
    },
    {
      chainId: 1,
      address: "0x0b7f0e51cd1739d6c96982d55ad8fa634dd43a9c",
      name: "Dream Machine Token",
      symbol: "DMT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30505/thumb/dmt.png?1696529391"
    },
    {
      chainId: 1,
      address: "0xcdb37a4fbc2da5b78aa4e41a432792f9533e85cc",
      name: "CheckDot",
      symbol: "CDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20370/thumb/token-200x200_%281%29.png?1696519781"
    },
    {
      chainId: 1,
      address: "0x0a5e677a6a24b2f1a2bf4f3bffc443231d2fdec8",
      name: "dForce USD",
      symbol: "USX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17422/thumb/usx_32.png?1696516969"
    },
    {
      chainId: 1,
      address: "0x4c584cd339bdde73b7f5210486dd8bbeee3fde6d",
      name: "ShibElon",
      symbol: "SHIBELON",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/20434/thumb/shibelon.png?1696519841"
    },
    {
      chainId: 1,
      address: "0xa64d5d1eb67748226d84812b45711453f1118c32",
      name: "Cheems Inu  NEW ",
      symbol: "CINU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29393/thumb/cinu.png?1696528343"
    },
    {
      chainId: 1,
      address: "0x075067a4b236f68f123fc0553f4560311937491d",
      name: "CATpay",
      symbol: "CATPAY",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/24731/thumb/catpay.png?1696523894"
    },
    {
      chainId: 1,
      address: "0xf3e07812ebc8604fddb0aa35ff79a03f48f48948",
      name: "JournArt",
      symbol: "JART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29412/thumb/JournArt%28200%29.png?1696528361"
    },
    {
      chainId: 1,
      address: "0xbccd27062ae1a2bea5731c904b96edfb163aba21",
      name: "Dogcoin",
      symbol: "DOGS",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/29065/thumb/1024_%281%29.png?1696528032"
    },
    {
      chainId: 1,
      address: "0x9f90b457dea25ef802e38d470dda7343691d8fe1",
      name: "Crosschain IOTX",
      symbol: "CIOTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18331/thumb/iotx.PNG?1696517822"
    },
    {
      chainId: 1,
      address: "0xe28027c99c7746ffb56b0113e5d9708ac86fae8f",
      name: "KING Coin",
      symbol: "KING",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/30183/thumb/king.png?1696529102"
    },
    {
      chainId: 1,
      address: "0xbe03e60757f21f4b6fc8f16676ad9d5b1002e512",
      name: "Raini Studios Token",
      symbol: "RST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32077/thumb/rst_200x200.png?1696530874"
    },
    {
      chainId: 1,
      address: "0x5bdc32663ec75e85ff4abc2cae7ae8b606a2cfca",
      name: "Cookies Protocol",
      symbol: "CP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28432/thumb/IMG_20221207_200805_897.jpg?1696527429"
    },
    {
      chainId: 1,
      address: "0x25ec98773d7b4ced4cafab96a2a1c0945f145e10",
      name: "Staked USDT",
      symbol: "STUSDT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31135/thumb/2veJywVy_400x400.jpg?1696529964"
    },
    {
      chainId: 1,
      address: "0x188fb5f5ae5bbe4154d5778f2bbb2fb985c94d25",
      name: "OpenBlox",
      symbol: "OBX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26150/thumb/OBX_token-black_background_preview.png?1696525239"
    },
    {
      chainId: 1,
      address: "0x263b6b028f3e4ed8c4329eb2b5f409ee38d97296",
      name: "World Mobile Token",
      symbol: "WMT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/17333/thumb/Colored_Token.png?1696516885"
    },
    {
      chainId: 1,
      address: "0xc0b314a8c08637685fc3dafc477b92028c540cfb",
      name: "Wombat Exchange",
      symbol: "WOM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26946/thumb/Wombat_Token.png?1696526001"
    },
    {
      chainId: 1,
      address: "0x5fab9761d60419c9eeebe3915a8fa1ed7e8d2e1b",
      name: "DIMO",
      symbol: "DIMO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28383/thumb/Token_Logo.png?1696527383"
    },
    {
      chainId: 1,
      address: "0x672f4fa517894496b8a958b4b3fca068ce513a39",
      name: "DexCheck AI",
      symbol: "DCK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26412/thumb/DexCheck_logo_%282%29.png?1696525488"
    },
    {
      chainId: 1,
      address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
      name: "SPACE ID",
      symbol: "ID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29468/thumb/sid_token_logo_%28green2%29.png?1696528413"
    },
    {
      chainId: 1,
      address: "0x6731827cb6879a2091ce3ab3423f7bf20539b579",
      name: "Empower",
      symbol: "MPWR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25456/thumb/MPWR_200x200.png?1696524587"
    },
    {
      chainId: 1,
      address: "0xb50721bcf8d664c30412cfbc6cf7a15145234ad1",
      name: "Arbitrum",
      symbol: "ARB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16547/thumb/photo_2023-03-29_21.47.00.jpeg?1696516109"
    },
    {
      chainId: 1,
      address: "0x77f2be773ca0887ba2b3ef8344c8cf13c98d8ca7",
      name: "FloraChain",
      symbol: "FYT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29078/thumb/flora.png?1696528044"
    },
    {
      chainId: 1,
      address: "0xa89bf95c5f15a847c8eb8d348cd7fed719ad7d80",
      name: "Chat AI",
      symbol: "AI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29441/thumb/200.png?1696528389"
    },
    {
      chainId: 1,
      address: "0x1c98b54d673c026c8286badca3e840aaf72931a3",
      name: "Stackswap",
      symbol: "STSW",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/29727/thumb/22.png?1696528657"
    },
    {
      chainId: 1,
      address: "0x1151cb3d861920e07a38e03eead12c32178567f6",
      name: "Bonk",
      symbol: "BONK",
      decimals: 5,
      logoURI: "https://assets.coingecko.com/coins/images/28600/thumb/bonk.jpg?1696527587"
    },
    {
      chainId: 1,
      address: "0x510975eda48a97e0ca228dd04d1217292487bea6",
      name: "PROJECT XENO",
      symbol: "GXE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29000/thumb/gxe.png?1696527972"
    },
    {
      chainId: 1,
      address: "0xb2cabf797bc907b049e4ccb5b84d13be3a8cfc21",
      name: "Arable Protocol",
      symbol: "ACRE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23659/thumb/acre_token-02.png?1696522862"
    },
    {
      chainId: 1,
      address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
      name: "Wrapped Fantom",
      symbol: "WFTM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16036/thumb/Fantom.png?1696515646"
    },
    {
      chainId: 1,
      address: "0x56c03b8c4fa80ba37f5a7b60caaaef749bb5b220",
      name: "CANTO",
      symbol: "CANTO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26959/thumb/canto-network.png?1696526014"
    },
    {
      chainId: 1,
      address: "0xc9c4fd7579133701fa2769b6955e7e56bb386db1",
      name: "Bridge Oracle",
      symbol: "BRG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12512/thumb/brg.png?1696512327"
    },
    {
      chainId: 1,
      address: "0xd1420af453fd7bf940573431d416cace7ff8280c",
      name: "Answer Governance",
      symbol: "AGOV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14383/thumb/AgoV_Logo1.png?1696514074"
    },
    {
      chainId: 1,
      address: "0xb4a3b0faf0ab53df58001804dda5bfc6a3d59008",
      name: "Sperax",
      symbol: "SPA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12232/thumb/sperax_logo.jpg?1696512065"
    },
    {
      chainId: 1,
      address: "0x969786c4a8884013d1c9ff18dcca2aedbbbfaa8f",
      name: "Gamerse",
      symbol: "LFG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19582/thumb/gamerse.PNG?1696519013"
    },
    {
      chainId: 1,
      address: "0xb9d27bc093ed0a3b7c18366266704cfe5e7af77b",
      name: "Carbify",
      symbol: "CBY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29892/thumb/Carbify_logo.png?1696528816"
    },
    {
      chainId: 1,
      address: "0x977b6fc5de62598b08c85ac8cf2b745874e8b78c",
      name: "Aave v3 cbETH",
      symbol: "ACBETH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32892/thumb/cbETH.png?1699789253"
    },
    {
      chainId: 1,
      address: "0x92df60c51c710a1b1c20e42d85e221f3a1bfc7f2",
      name: "ApeSwap",
      symbol: "BANANA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14870/thumb/banana.png?1696514534"
    },
    {
      chainId: 1,
      address: "0x2aeabde1ab736c59e9a19bed67681869eef39526",
      name: "DOVU",
      symbol: "DOVU",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/31930/thumb/Dovu_Icon_Black_%281%29.png?1696530738"
    },
    {
      chainId: 1,
      address: "0xff9c1f21c621696c4f91cf781ec31bd913ee2c26",
      name: " com  Ordinals ",
      symbol: "COM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/33700/thumb/com200.jpg?1702823408"
    },
    {
      chainId: 1,
      address: "0xe2dc070524a6e305ddb64d8513dc444b6a1ec845",
      name: "Nash",
      symbol: "NEX",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/3246/thumb/Nash_M.png?1696503962"
    },
    {
      chainId: 1,
      address: "0x0f3adc247e91c3c50bc08721355a41037e89bc20",
      name: "Anchor Protocol",
      symbol: "ANC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14420/thumb/anchor_protocol_logo.jpg?1696514111"
    },
    {
      chainId: 1,
      address: "0x965697b4ef02f0de01384d0d4f9f782b1670c163",
      name: "Oxygen",
      symbol: "OXY",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/13509/thumb/8DjBZ79V_400x400.jpg?1696513271"
    },
    {
      chainId: 1,
      address: "0x499568c250ab2a42292261d6121525d70691894b",
      name: "KROWN",
      symbol: "KRW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16530/thumb/KRW_token_logo_200x200.png?1696516093"
    },
    {
      chainId: 1,
      address: "0x06ddb3a8bc0abc14f85e974cf1a93a6f8d4909d9",
      name: "8Pay",
      symbol: "8PAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14667/thumb/8pay.jpeg?1696514342"
    },
    {
      chainId: 1,
      address: "0x6dc02164d75651758ac74435806093e421b64605",
      name: "XAYA",
      symbol: "WCHI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/2091/thumb/xaya200x200.png?1696503058"
    },
    {
      chainId: 1,
      address: "0xfb62ae373aca027177d1c18ee0862817f9080d08",
      name: "My DeFi Pet",
      symbol: "DPET",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15321/thumb/mydefi.PNG?1696514970"
    },
    {
      chainId: 1,
      address: "0x92a42db88ed0f02c71d439e55962ca7cab0168b5",
      name: "TRDGtoken",
      symbol: "TRDG",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/14371/thumb/200x200.png?1696514063"
    },
    {
      chainId: 1,
      address: "0x3079f61704e9efa2bcf1db412f735d8d4cfa26f4",
      name: "HappyFans",
      symbol: "HAPPY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19027/thumb/O1pUoR8G_400x400.jpeg?1696518478"
    },
    {
      chainId: 1,
      address: "0xee1cea7665ba7aa97e982edeaecb26b59a04d035",
      name: "ORAO Network",
      symbol: "ORAO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15189/thumb/orao.PNG?1696514846"
    },
    {
      chainId: 1,
      address: "0x7b4328c127b85369d9f82ca0503b000d09cf9180",
      name: "Dogechain",
      symbol: "DC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26828/thumb/dogechain.jpeg?1696525887"
    },
    {
      chainId: 1,
      address: "0x05fb86775fd5c16290f1e838f5caaa7342bd9a63",
      name: "Hacken",
      symbol: "HAI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/11081/thumb/hacken-symbol-with-bg.png?1696511022"
    },
    {
      chainId: 1,
      address: "0xa771b49064da011df051052848477f18dba1d2ac",
      name: "Handshake",
      symbol: "HNS",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/10562/thumb/circle-handshakeLogo.png?1696510545"
    },
    {
      chainId: 1,
      address: "0x45fdb1b92a649fb6a64ef1511d3ba5bf60044838",
      name: "SpiceUSD",
      symbol: "USDS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25697/thumb/USDS.png?1696524824"
    },
    {
      chainId: 1,
      address: "0x8bcd06492416a749c9369009b3429861b7f27f6e",
      name: "BlackHat Coin",
      symbol: "BLKC",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/15987/thumb/logo_light.png?1696515600"
    },
    {
      chainId: 1,
      address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
      name: "Coin98",
      symbol: "C98",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17117/thumb/logo.png?1696516677"
    },
    {
      chainId: 1,
      address: "0x396ec402b42066864c406d1ac3bc86b575003ed8",
      name: "Buying com",
      symbol: "BUY",
      decimals: 2,
      logoURI: "https://assets.coingecko.com/coins/images/5290/thumb/buying_200x200.png?1696505788"
    },
    {
      chainId: 1,
      address: "0x180dae91d6d56235453a892d2e56a3e40ba81df8",
      name: "DOJO",
      symbol: "DOJO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16396/thumb/074606deafab3872.png?1696515994"
    },
    {
      chainId: 1,
      address: "0x8287c7b963b405b7b8d467db9d79eec40625b13a",
      name: "Swingby",
      symbol: "SWINGBY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11861/thumb/swingby.png?1696511731"
    },
    {
      chainId: 1,
      address: "0x1d7ca62f6af49ec66f6680b8606e634e55ef22c1",
      name: "Starter xyz",
      symbol: "START",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14301/thumb/logo_poly_sym.png?1696513997"
    },
    {
      chainId: 1,
      address: "0x6c7b97c7e09e790d161769a52f155125fac6d5a1",
      name: "Polylauncher",
      symbol: "ANGEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17739/thumb/Polylauncher_-_200_x_200.png?1696517266"
    },
    {
      chainId: 1,
      address: "0x31f69de127c8a0ff10819c0955490a4ae46fcc2a",
      name: "Obyte",
      symbol: "GBYTE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/561/thumb/byteball.png?1696501768"
    },
    {
      chainId: 1,
      address: "0x8848812bd31aeee33313c10a840ffc3169078c5b",
      name: "CrossFi",
      symbol: "CRFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15162/thumb/11901619752967_.pic_hd.png?1696514817"
    },
    {
      chainId: 1,
      address: "0x667fd83e24ca1d935d36717d305d54fa0cac991c",
      name: "Collector Coin",
      symbol: "AGS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16918/thumb/AGS.png?1696516489"
    },
    {
      chainId: 1,
      address: "0x9393fdc77090f31c7db989390d43f454b1a6e7f3",
      name: "Dark Energy Crystals",
      symbol: "DEC",
      decimals: 3,
      logoURI: "https://assets.coingecko.com/coins/images/12923/thumb/DEC_token.png?1696512711"
    },
    {
      chainId: 1,
      address: "0x8861cff2366c1128fd699b68304ad99a0764ef9a",
      name: "Cyclone Protocol",
      symbol: "CYC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14065/thumb/b3_DFjFp_400x400.jpg?1696513790"
    },
    {
      chainId: 1,
      address: "0xdb726152680ece3c9291f1016f1d36f3995f6941",
      name: "Media Network",
      symbol: "MEDIA",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/15142/thumb/media50x50.png?1696514798"
    },
    {
      chainId: 1,
      address: "0x34965f73cfa05bf8d8af37cb4af64fa950605ea8",
      name: "CoinWind",
      symbol: "COW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15766/thumb/logo.c3d2c062.png?1696515390"
    },
    {
      chainId: 1,
      address: "0x9ac07635ddbde5db18648c360defb00f5f22537e",
      name: "Museum of Crypto Art",
      symbol: "MOCA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15829/thumb/photo_2021-06-04_09.36.16.jpeg?1696515447"
    },
    {
      chainId: 1,
      address: "0x7645ddfeeceda57e41f92679c4acd83c56a81d14",
      name: "Flux Protocol",
      symbol: "FLUX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15002/thumb/logo.dabc411c.png?1696514665"
    },
    {
      chainId: 1,
      address: "0xf99d58e463a2e07e5692127302c20a191861b4d6",
      name: "Anyswap",
      symbol: "ANY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12242/thumb/anyswap.jpg?1696512074"
    },
    {
      chainId: 1,
      address: "0x9fda7ceec4c18008096c2fe2b85f05dc300f94d0",
      name: "Gaj Finance",
      symbol: "GAJ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15257/thumb/logo200x200.png?1696514910"
    },
    {
      chainId: 1,
      address: "0xe0b0c16038845bed3fcf70304d3e167df81ce225",
      name: "CrossSwap",
      symbol: "CSWAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18002/thumb/cross.png?1696517518"
    },
    {
      chainId: 1,
      address: "0x939b462ee3311f8926c047d2b576c389092b1649",
      name: "LiquidApps",
      symbol: "DAPP",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/8116/thumb/dapp-logo.jpg?1696508334"
    },
    {
      chainId: 1,
      address: "0xef3a930e1ffffacd2fc13434ac81bd278b0ecc8d",
      name: "Stafi",
      symbol: "FIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12423/thumb/FIS.png?1696512244"
    },
    {
      chainId: 1,
      address: "0x154e35c2b0024b3e079c5c5e4fc31c979c189ccb",
      name: "Raid",
      symbol: "RAID",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18133/thumb/raid_200_oswlvz.png?1696517636"
    },
    {
      chainId: 1,
      address: "0x9d79d5b61de59d882ce90125b18f74af650acb93",
      name: "Neutrino System Base",
      symbol: "NSBT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/13268/thumb/NSBT.png?1712107101"
    },
    {
      chainId: 1,
      address: "0x3405a1bd46b85c5c029483fbecf2f3e611026e45",
      name: "WOWswap",
      symbol: "WOW",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14101/thumb/Group-423.png?1696513823"
    },
    {
      chainId: 1,
      address: "0x12bb890508c125661e03b09ec06e404bc9289040",
      name: "Radio Caca",
      symbol: "RACA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17841/thumb/ez44_BSs_400x400.jpg?1696517365"
    },
    {
      chainId: 1,
      address: "0xca1262e77fb25c0a4112cfc9bad3ff54f617f2e6",
      name: "Jax Network",
      symbol: "WJXN",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/18737/thumb/photo.jpg?1696518203"
    },
    {
      chainId: 1,
      address: "0x968f6f898a6df937fc1859b323ac2f14643e3fed",
      name: "Newscrypto Coin",
      symbol: "NWC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/9805/thumb/Tu1_NI3s_%281%29.png?1696509862"
    },
    {
      chainId: 1,
      address: "0xfbc4f3f645c4003a2e4f4e9b51077d2daa9a9341",
      name: "Zedxion",
      symbol: "ZEDXION",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18841/thumb/ZEDXION.png?1696518302"
    },
    {
      chainId: 1,
      address: "0xdb85f6685950e285b1e611037bebe5b34e2b7d78",
      name: "Zano",
      symbol: "ZANO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/8370/thumb/zano.png?1696508563"
    },
    {
      chainId: 1,
      address: "0xf6719e1a8fcbb1b9c290019e37e004966a8916c9",
      name: "Polygen",
      symbol: "PGEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21476/thumb/polygen-logo_1.jpeg?1696520837"
    },
    {
      chainId: 1,
      address: "0x65e6b60ea01668634d68d0513fe814679f925bad",
      name: "PixelVerse",
      symbol: "PIXEL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19934/thumb/pixelverse.PNG?1696519352"
    },
    {
      chainId: 1,
      address: "0x081131434f93063751813c619ecca9c4dc7862a3",
      name: "Mines of Dalarnia",
      symbol: "DAR",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/19837/thumb/dar.png?1696519259"
    },
    {
      chainId: 1,
      address: "0xac57de9c1a09fec648e93eb98875b212db0d460b",
      name: "Baby Doge Coin",
      symbol: "BABYDOGE",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/16125/thumb/babydoge.jpg?1696515731"
    },
    {
      chainId: 1,
      address: "0x55af5865807b196bd0197e0902746f31fbccfa58",
      name: "Spookyswap",
      symbol: "BOO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15223/thumb/logo_200x200.png?1696514878"
    },
    {
      chainId: 1,
      address: "0x9fb83c0635de2e815fd1c21b3a292277540c2e8d",
      name: "RealFevr",
      symbol: "FEVR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17136/thumb/Fevr-Token.png?1696516695"
    },
    {
      chainId: 1,
      address: "0x0343131c0257ac21ea5a8dc83841f071efd9285c",
      name: "Zenith Chain",
      symbol: "ZENITH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21266/thumb/Jqtp-OVG_400x400.png?1696520637"
    },
    {
      chainId: 1,
      address: "0xd8c1232fcd219286e341271385bd70601503b3d7",
      name: "Dogira",
      symbol: "DOGIRA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/14634/thumb/IQgaRw0.png?1696514312"
    },
    {
      chainId: 1,
      address: "0xb6dd77fd132dcaa10f1858734e838a0fa7431580",
      name: "Filipcoin",
      symbol: "FCP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21354/thumb/filip.PNG?1696520719"
    },
    {
      chainId: 1,
      address: "0x93e32efafd24973d45f363a76d73ccb9edf59986",
      name: "Bitlocus",
      symbol: "BTL",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/20913/thumb/btl.png?1696520304"
    },
    {
      chainId: 1,
      address: "0x42baf1f659d765c65ade5bb7e08eb2c680360d9d",
      name: "Cornucopias",
      symbol: "COPI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21452/thumb/g56WwJDA_400x400.jpg?1696520814"
    },
    {
      chainId: 1,
      address: "0xe1590a6fa0cff9c960181cb77d8a873601772f64",
      name: "WallStreetBets DApp",
      symbol: "WSB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15093/thumb/Pe1mrDu.png?1696514751"
    },
    {
      chainId: 1,
      address: "0xdf09a216fac5adc3e640db418c0b956076509503",
      name: "Poken",
      symbol: "PKN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21574/thumb/G10VNBAR_400x400.jpg?1696520934"
    },
    {
      chainId: 1,
      address: "0x45c2f8c9b4c0bdc76200448cc26c48ab6ffef83f",
      name: "Domi",
      symbol: "DOMI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21633/thumb/Transparent_Circle_Logo_2.png?1696520993"
    },
    {
      chainId: 1,
      address: "0xa87135285ae208e22068acdbff64b11ec73eaa5a",
      name: "LunarCrush",
      symbol: "LUNR",
      decimals: 4,
      logoURI: "https://assets.coingecko.com/coins/images/19256/thumb/LunarCrush-Earn-Logo.png?1708183703"
    },
    {
      chainId: 1,
      address: "0x965b85d4674f64422c4898c8f8083187f02b32c0",
      name: "Filecoin Standard Full Hashrate",
      symbol: "SFIL",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/21669/thumb/_70BfuBY_400x400.jpg?1696521026"
    },
    {
      chainId: 1,
      address: "0xa47c8bf37f92abed4a126bda807a7b7498661acd",
      name: "Wrapped USTC",
      symbol: "USTC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15462/thumb/ust.png?1696515108"
    },
    {
      chainId: 1,
      address: "0xaad483f97f13c6a20b9d05d07c397ce85c42c393",
      name: "Woonkly Power",
      symbol: "WOOP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14494/thumb/Icono_Infinito_Circular_Blanco_Fondo_Azul_2x.png?1696514179"
    },
    {
      chainId: 1,
      address: "0xbd100d061e120b2c67a24453cf6368e63f1be056",
      name: "iDypius",
      symbol: "IDYP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/21976/thumb/iDYP-200x200px.png?1696521324"
    },
    {
      chainId: 1,
      address: "0x77a1f4e744d810239f465043e35d067ca33de259",
      name: "Voice Street",
      symbol: "VST",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23147/thumb/LbMUkaD9_400x400.jpg?1696522439"
    },
    {
      chainId: 1,
      address: "0x7118057ff0f4fd0994fb9d2d94de8231d5cca79e",
      name: "ReSource Protocol",
      symbol: "SOURCE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20740/thumb/source.png?1696520138"
    },
    {
      chainId: 1,
      address: "0x9ab70e92319f0b9127df78868fd3655fb9f1e322",
      name: "WeWay",
      symbol: "WWY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22418/thumb/wwy.png?1696521760"
    },
    {
      chainId: 1,
      address: "0x25b24b3c47918b7962b3e49c4f468367f73cc0e0",
      name: "AXL INU",
      symbol: "AXL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22191/thumb/Original_Logo-01.png?1696521535"
    },
    {
      chainId: 1,
      address: "0xa693b19d2931d498c5b318df961919bb4aee87a5",
      name: "TerraUSD  Wormhole ",
      symbol: "UST",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/21150/thumb/UST_wh_small.png?1696520528"
    },
    {
      chainId: 1,
      address: "0x7c9f4c87d911613fe9ca58b579f737911aad2d43",
      name: "MATIC  Wormhole ",
      symbol: "MATICPO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22947/thumb/MATICpo_wh_small.png?1696522243"
    },
    {
      chainId: 1,
      address: "0x845e2e8b42dced7dedcdba9bde32c9e338224f97",
      name: "Satozhi",
      symbol: "SATOZ",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/14786/thumb/0GeSrIaQ_400x400.jpg?1696514455"
    },
    {
      chainId: 1,
      address: "0x85f138bfee4ef8e540890cfb48f620571d67eda3",
      name: "Avalanche  Wormhole ",
      symbol: "AVAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22943/thumb/AVAX_wh_small.png?1696522240"
    },
    {
      chainId: 1,
      address: "0x566957ef80f9fd5526cd2bef8be67035c0b81130",
      name: "Bridged USD Coin  Wormhole POS ",
      symbol: "USDCPO",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/22945/thumb/USDCpo_wh_small.png?1696522242"
    },
    {
      chainId: 1,
      address: "0x2f75113b13d136f861d212fa9b572f2c79ac81c4",
      name: "Ekta",
      symbol: "EKTA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22350/thumb/token.jpg?1696521693"
    },
    {
      chainId: 1,
      address: "0xc669928185dbce49d2230cc9b0979be6dc797957",
      name: "BitTorrent",
      symbol: "BTT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22457/thumb/btt_logo.png?1696521780"
    },
    {
      chainId: 1,
      address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
      name: "Smooth Love Potion",
      symbol: "SLP",
      decimals: 0,
      logoURI: "https://assets.coingecko.com/coins/images/10366/thumb/SLP.png?1696510368"
    },
    {
      chainId: 1,
      address: "0xc4bb7277a74678f053259cb1f96140347efbfd46",
      name: "Coin of the champions",
      symbol: "COC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18478/thumb/COC-Yellow-Transparent-1.png?1696517963"
    },
    {
      chainId: 1,
      address: "0x9b17baadf0f21f03e35249e0e59723f34994f806",
      name: "NFTmall",
      symbol: "GEM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16217/thumb/Icon-1000x1000.png?1696515817"
    },
    {
      chainId: 1,
      address: "0xee9801669c6138e84bd50deb500827b776777d28",
      name: "O3 Swap",
      symbol: "O3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/15460/thumb/o3.png?1696515107"
    },
    {
      chainId: 1,
      address: "0x7825e833d495f3d1c28872415a4aee339d26ac88",
      name: "Wrapped Telos",
      symbol: "WTLOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23952/thumb/TLOS.png?1705598803"
    },
    {
      chainId: 1,
      address: "0x2217e5921b7edfb4bb193a6228459974010d2198",
      name: "Qmall",
      symbol: "QMALL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23630/thumb/tjVN6bQ5_400x400.jpg?1696522834"
    },
    {
      chainId: 1,
      address: "0xd3c51de3e6dd9b53d7f37699afb3ee3bf9b9b3f4",
      name: "MContent",
      symbol: "MCONTENT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/16781/thumb/Image_mcontent.jpeg?1696516353"
    },
    {
      chainId: 1,
      address: "0x1f36fb2d91d9951cf58ae4c1956c0b77e224f1e9",
      name: "VCGamers",
      symbol: "VCG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22371/thumb/VCG-Token-Logo-PNG.png?1696521714"
    },
    {
      chainId: 1,
      address: "0xe580074a10360404af3abfe2d524d5806d993ea3",
      name: "PayBolt",
      symbol: "PAY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24175/thumb/logo.png?1696523363"
    },
    {
      chainId: 1,
      address: "0x20d60c6eb195868d4643f2c9b0809e4de6cc003d",
      name: "PlayNity",
      symbol: "PLY",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/21479/thumb/ply.png?1696520840"
    },
    {
      chainId: 1,
      address: "0x809e130e10e787139c54e1d12d3d1971b7a675bf",
      name: "Minted",
      symbol: "MTD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26893/thumb/MTD_Token_%282%29.png?1696525951"
    },
    {
      chainId: 1,
      address: "0x1ab43204a195a0fd37edec621482afd3792ef90b",
      name: "Aurigami",
      symbol: "PLY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24074/thumb/EbB5N8IN_400x400.jpg?1696523268"
    },
    {
      chainId: 1,
      address: "0xf655c8567e0f213e6c634cd2a68d992152161dc6",
      name: "Impermax",
      symbol: "IBEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27606/thumb/IqwOmX-c_400x400.jpeg?1696526637"
    },
    {
      chainId: 1,
      address: "0x19193f450086d0442157b852081976d41657ad56",
      name: "Nunu Spirits",
      symbol: "NNT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24378/thumb/NNT_99cc33.png?1696523561"
    },
    {
      chainId: 1,
      address: "0xc17c30e98541188614df99239cabd40280810ca3",
      name: "EverRise",
      symbol: "RISE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/16367/thumb/Logo_EverRise_Icon_logo.png?1696515966"
    },
    {
      chainId: 1,
      address: "0x32462ba310e447ef34ff0d15bce8613aa8c4a244",
      name: "Dohrnii",
      symbol: "DHN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24966/thumb/dhn.png?1696524119"
    },
    {
      chainId: 1,
      address: "0x198d14f2ad9ce69e76ea330b374de4957c3f850a",
      name: "APENFT",
      symbol: "NFT",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/15687/thumb/apenft.jpg?1696515316"
    },
    {
      chainId: 1,
      address: "0x16b3e050e9e2f0ac4f1bea1b3e4fdc43d7f062dd",
      name: "Sombra",
      symbol: "SMBR",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/17884/thumb/SMBR_120x120.png?1703029115"
    },
    {
      chainId: 1,
      address: "0x446f2a8a39cc730ef378be759a3c57f1a3fe824c",
      name: "NanoByte",
      symbol: "NBT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23698/thumb/WpcmdLW.png?1696522899"
    },
    {
      chainId: 1,
      address: "0x420a24c9c65bd44c48bfb1cc8d6cd1ea8b1ac840",
      name: "JumpToken",
      symbol: "JMPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22603/thumb/200x200.png?1696521919"
    },
    {
      chainId: 1,
      address: "0x4550003152f12014558e5ce025707e4dd841100f",
      name: "Kaizen Finance",
      symbol: "KZEN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24396/thumb/PKl5OVRv_400x400.png?1696523579"
    },
    {
      chainId: 1,
      address: "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
      name: "USDD",
      symbol: "USDD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25380/thumb/UUSD.jpg?1696524513"
    },
    {
      chainId: 1,
      address: "0xf6e06b54855eff198a2d9a8686113665499a6134",
      name: "Celestial",
      symbol: "CELT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18683/thumb/celt.png?1696518152"
    },
    {
      chainId: 1,
      address: "0x9767203e89dcd34851240b3919d4900d3e5069f1",
      name: "A4 Finance",
      symbol: "A4",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/21992/thumb/ba384ad07217a4be75cb85314f5760f7.jpg?1696521340"
    },
    {
      chainId: 1,
      address: "0x40a9a694197a0b4b92f2aad48da6bc1b6ff194e9",
      name: "LFG",
      symbol: "LFG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30910/thumb/LFG.jpg?1696529755"
    },
    {
      chainId: 1,
      address: "0xbd8fdda057de7e0162b7a386bec253844b5e07a5",
      name: "Jarvis",
      symbol: "JARVIS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35812/thumb/jarvis.png?1709873633"
    },
    {
      chainId: 1,
      address: "0x345887cdb19e12833ed376bbf8b8b38269f5f5c8",
      name: "Carbon Browser",
      symbol: "CSIX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28905/thumb/csix.png?1696527881"
    },
    {
      chainId: 1,
      address: "0x06677dc4fe12d3ba3c7ccfd0df8cd45e4d4095bf",
      name: "Work Quest",
      symbol: "WQT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30040/thumb/WQT-1_%281%29.png?1696528963"
    },
    {
      chainId: 1,
      address: "0x70bc0dc6414eb8974bc70685f798838a87d8cce4",
      name: "Chirpley",
      symbol: "CHRP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27243/thumb/Chirpley-Logo_200x200.png?1696526293"
    },
    {
      chainId: 1,
      address: "0xbc0899e527007f1b8ced694508fcb7a2b9a46f53",
      name: "Basket",
      symbol: "BSKT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34661/thumb/BSKT_Logo.png?1705636891"
    },
    {
      chainId: 1,
      address: "0xbb63a9b64a80e9338b8ea298c51765e57c4f159c",
      name: "Picasso",
      symbol: "PICA",
      decimals: 12,
      logoURI: "https://assets.coingecko.com/coins/images/28286/thumb/PICA.png?1696527286"
    },
    {
      chainId: 1,
      address: "0xcf67815cce72e682eb4429eca46843bed81ca739",
      name: "GAM3S GG",
      symbol: "G3",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35662/thumb/G3_logo.jpg?1709454143"
    },
    {
      chainId: 1,
      address: "0xb92ba0a6a843379499770de82aa936d6ba0fd8ca",
      name: "Youwho",
      symbol: "YOU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25353/thumb/youwho_200.png?1696524487"
    },
    {
      chainId: 1,
      address: "0xd3c325848d7c6e29b574cb0789998b2ff901f17e",
      name: "OneArt",
      symbol: "1ART",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19307/thumb/token_light_3x.png?1696518749"
    },
    {
      chainId: 1,
      address: "0x6c249b6f6492864d914361308601a7abb32e68f8",
      name: "Brillion",
      symbol: "DUA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27976/thumb/Screenshot_2023-06-13_at_11.58.02_AM.png?1696526994"
    },
    {
      chainId: 1,
      address: "0xaef420fd77477d9dc8b46d704d44dd09d6c27866",
      name: "Cogito Finance",
      symbol: "CGV",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/30731/thumb/CGV.png?1698667079"
    },
    {
      chainId: 1,
      address: "0x50327c6c5a14dcade707abad2e27eb517df87ab5",
      name: "Wrapped Tron",
      symbol: "WTRX",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/22471/thumb/xOesRfpN_400x400.jpg?1696521795"
    },
    {
      chainId: 1,
      address: "0x983d8edb44ca96c0595f3c456ebdd47855911f34",
      name: "War Legends",
      symbol: "WAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30672/thumb/wZBMVBr2_400x400.jpg?1696529542"
    },
    {
      chainId: 1,
      address: "0x967fb0d760ed3ce53afe2f0a071674cccae73550",
      name: "XANA",
      symbol: "XETA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24379/thumb/XANA_Logo_neon_pink.png?1696523562"
    },
    {
      chainId: 1,
      address: "0xdd13dedecebda566322195bc4451d672a148752c",
      name: "PRIMAL",
      symbol: "PRIMAL",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28435/thumb/PRIMAL_ICON_200px.jpg?1696527432"
    },
    {
      chainId: 1,
      address: "0x560363bda52bc6a44ca6c8c9b4a5fadbda32fa60",
      name: "Seedify fund",
      symbol: "SFUND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/14614/thumb/Favicon_Icon.png?1696514292"
    },
    {
      chainId: 1,
      address: "0xc7026a20a640bc71b9074f7aed52a00cd9147091",
      name: "Tegro",
      symbol: "TGR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26564/thumb/512x512.png?1696525637"
    },
    {
      chainId: 1,
      address: "0x69c2fcae7e30b429166bd616a322e32bec036bcf",
      name: "MuratiAI",
      symbol: "MURATIAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30433/thumb/Muratilogo.png?1696529321"
    },
    {
      chainId: 1,
      address: "0xae788f80f2756a86aa2f410c651f2af83639b95b",
      name: "GensoKishi Metaverse",
      symbol: "MV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/23143/thumb/geno.png?1696522435"
    },
    {
      chainId: 1,
      address: "0x1416946162b1c2c871a73b07e932d2fb6c932069",
      name: "Energi",
      symbol: "NRG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/5795/thumb/3218.png?1696506239"
    },
    {
      chainId: 1,
      address: "0xb990d93c308a31c737aa91839e8ba8eaf4017d7a",
      name: "PirateCash",
      symbol: "PIRATE",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/7155/thumb/logo_%281%29.png?1696507453"
    },
    {
      chainId: 1,
      address: "0x5f1f11a3dd7a0c39da1baa3c7b8585b52a77f435",
      name: "ASAN VERSE",
      symbol: "ASAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28189/thumb/200200_copy.png?1696527192"
    },
    {
      chainId: 1,
      address: "0x9b25889c493ae6df34ceef1ecb10d77c1ba73318",
      name: "Mean DAO",
      symbol: "MEAN",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/21557/thumb/89934951.png?1696520918"
    },
    {
      chainId: 1,
      address: "0xb0c7a3ba49c7a6eaba6cd4a96c55a1391070ac9a",
      name: "Magic",
      symbol: "MAGIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18623/thumb/magic.png?1696518095"
    },
    {
      chainId: 1,
      address: "0x9f826324bb9bdcf7e7eb274bedc417bd45d74f39",
      name: "MilkAI",
      symbol: "MILKAI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/29055/thumb/MilkAI.jpeg?1696528022"
    },
    {
      chainId: 1,
      address: "0x83d6c8c06ac276465e4c92e7ac8c23740f435140",
      name: "HMX",
      symbol: "HMX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31206/thumb/HMXlogo_CG.png?1696530033"
    },
    {
      chainId: 1,
      address: "0x5b52bfb8062ce664d74bbcd4cd6dc7df53fd7233",
      name: "ZENIQ",
      symbol: "ZENIQ",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29284/thumb/zeniq.png?1696528236"
    },
    {
      chainId: 1,
      address: "0xe636f94a71ec52cc61ef21787ae351ad832347b7",
      name: "Creo Engine",
      symbol: "CREO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25419/thumb/17000.png?1696524549"
    },
    {
      chainId: 1,
      address: "0x378e97d19cf319eb311748ff4d9971dc349c8ad4",
      name: "AlphaScan AI",
      symbol: "ASCN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/31180/thumb/AlphaScan_logo.jpg?1696530008"
    },
    {
      chainId: 1,
      address: "0x9348e94a447bf8b2ec11f374d3f055fd47d936df",
      name: "For Loot And Glory",
      symbol: "FLAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20726/thumb/token_logo.ico?1696520124"
    },
    {
      chainId: 1,
      address: "0xc3589f56b6869824804a5ea29f2c9886af1b0fce",
      name: "Honey",
      symbol: "HNY",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/12895/thumb/hnys.png?1696512683"
    },
    {
      chainId: 1,
      address: "0x1901f826dfcbfd9d3138936932366b3493a50893",
      name: "Sphynx Labs",
      symbol: "SPHYNX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30142/thumb/photo_2023-05-03_21.44.17.jpeg?1696529063"
    },
    {
      chainId: 1,
      address: "0xe7c3755482d0da522678af05945062d4427e0923",
      name: "ALEX Lab",
      symbol: "ALEX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25837/thumb/ALEX_Token.png?1696524922"
    },
    {
      chainId: 1,
      address: "0xb533687ef77459093368c43e95f8df1c2b5a1f7a",
      name: "Nekoverse  City of Greed Anima Spirit G",
      symbol: "ASG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/32655/thumb/asg.png?1698895535"
    },
    {
      chainId: 1,
      address: "0xdb0170e2d0c1cc1b2e7a90313d9b9afa4f250289",
      name: "ADAPad",
      symbol: "ADAPAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18273/thumb/EhSqPTtG_400x400.jpg?1696517767"
    },
    {
      chainId: 1,
      address: "0x43044f861ec040db59a7e324c40507addb673142",
      name: "Cap",
      symbol: "CAP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/11775/thumb/cap.png?1696511654"
    },
    {
      chainId: 1,
      address: "0xc2708a3a4ba7f64bddc1a49f92f941bc77cad23a",
      name: "Waves Ducks",
      symbol: "EGG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17298/thumb/200x200_pixel.png?1696516851"
    },
    {
      chainId: 1,
      address: "0x8bbf1dccbedd5c70d8e793d432fb56b848dd1698",
      name: "Ape In",
      symbol: "APEIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18262/thumb/apein.PNG?1696517757"
    },
    {
      chainId: 1,
      address: "0xb8e3bb633f7276cc17735d86154e0ad5ec9928c0",
      name: "VelasPad",
      symbol: "VLXPAD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18535/thumb/11654.png?1696518015"
    },
    {
      chainId: 1,
      address: "0x16ba8efe847ebdfef99d399902ec29397d403c30",
      name: "Oh  Finance",
      symbol: "OH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19493/thumb/oh-token-logo-200.png?1696518929"
    },
    {
      chainId: 1,
      address: "0xd373576a9e738f37dc6882328358ff69c4caf4c6",
      name: "Zam io",
      symbol: "ZAM",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19522/thumb/zam.png?1696518956"
    },
    {
      chainId: 1,
      address: "0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32",
      name: "Staked FRAX",
      symbol: "SFRAX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35383/thumb/sfrax.png?1708445569"
    },
    {
      chainId: 1,
      address: "0xd2ba23de8a19316a638dc1e7a9adda1d74233368",
      name: "Quickswap",
      symbol: "QUICK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25393/thumb/quickswap.png?1696524525"
    },
    {
      chainId: 1,
      address: "0xfceb206e1a80527908521121358b5e26caabaa75",
      name: "Main",
      symbol: "MAIN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25258/thumb/logo_circle.png?1696524398"
    },
    {
      chainId: 1,
      address: "0x614d7f40701132e25fe6fc17801fbd34212d2eda",
      name: "SafeBlast",
      symbol: "BLAST",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/15686/thumb/safeblast.png?1696515315"
    },
    {
      chainId: 1,
      address: "0x8fc8f8269ebca376d046ce292dc7eac40c8d358a",
      name: "DeFiChain",
      symbol: "DFI",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/11757/thumb/symbol-defi-blockchain_200.png?1696511638"
    },
    {
      chainId: 1,
      address: "0x7a5d3a9dcd33cb8d527f7b5f96eb4fef43d55636",
      name: "RadioShack",
      symbol: "RADIO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25307/thumb/ZVoPiysPJq6dPIZm_Se-6vjmsBepwhHlTQfdYZRILbHyVVTRUYCO-wmJJ4zT10HXCGv1j-ZyWr2u2sBaVlap5Y-ILqeXZuIquWdBDxxG0E0qDpgH7omLqYdgWWLSM_TUK9d1PiiYdu6bERdCDaucgFjlqwmhVQK4uV4jyUiXzchVUnu8Qt6SnxlNxz88G0mQ_tfiwkFv_vKqtgb1CcPycVZVz9.jpg?1696524444"
    },
    {
      chainId: 1,
      address: "0x614577036f0a024dbc1c88ba616b394dd65d105a",
      name: "GENIUS AI",
      symbol: "GNUS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36914/thumb/IMG_5346.png?1712769235"
    },
    {
      chainId: 1,
      address: "0x26dcfbfa8bc267b250432c01c982eaf81cc5480c",
      name: "Ankr Staked MATIC",
      symbol: "ANKRMATIC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25742/thumb/a-matic-c-da4ec10dc9723e695700e25dbf8c8edf.png?1696524833"
    },
    {
      chainId: 1,
      address: "0xafcdd4f666c84fed1d8bd825aa762e3714f652c9",
      name: "Vita Inu",
      symbol: "VINU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20594/thumb/vita-inu-head-wallet-icon-transparent.png?1696520000"
    },
    {
      chainId: 1,
      address: "0x9e6b19874e97fe8e8cad77f2c0ab5e7a693e5dbf",
      name: "StrongHands Finance",
      symbol: "ISHND",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20158/thumb/ISHND_512x512px.png?1696519571"
    },
    {
      chainId: 1,
      address: "0x5f018e73c185ab23647c82bd039e762813877f0e",
      name: "Shack",
      symbol: "SHACK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25699/thumb/shack_no_bg_no_pad3.png?1696524826"
    },
    {
      chainId: 1,
      address: "0x40fed5691e547885cabd7a2990de719dcc8497fc",
      name: "Safe Haven",
      symbol: "SHA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/2584/thumb/safehaven.png?1696503388"
    },
    {
      chainId: 1,
      address: "0x18a1ea69a50a85752b7bc204a2c45a95ce6e429d",
      name: "Spice Trade",
      symbol: "SPICE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25770/thumb/SPICE.png?1696524857"
    },
    {
      chainId: 1,
      address: "0x57d579f483854c62fef850b8a5332b0d8424b7e2",
      name: "OpenSwap One",
      symbol: "OPENX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/19274/thumb/X_color.png?1696518717"
    },
    {
      chainId: 1,
      address: "0x93581991f68dbae1ea105233b67f7fa0d6bdee7b",
      name: "Evmos",
      symbol: "EVMOS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24023/thumb/evmos.png?1696523216"
    },
    {
      chainId: 1,
      address: "0x4c3a8eceb656ec63eae80a4ebd565e4887db6160",
      name: "SokuSwap",
      symbol: "SOKU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/18378/thumb/VCIEHaG.png?1696517870"
    },
    {
      chainId: 1,
      address: "0x88536c9b2c4701b8db824e6a16829d5b5eb84440",
      name: "Atlas USV",
      symbol: "USV",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/22066/thumb/7iUyjg5t.png?1696521410"
    },
    {
      chainId: 1,
      address: "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
      name: "Elk Finance",
      symbol: "ELK",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17813/thumb/elk.png?1696517333"
    },
    {
      chainId: 1,
      address: "0x2e7b0d4f9b2eaf782ed3d160e3a0a4b1a7930ada",
      name: "Ceres",
      symbol: "CERES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/17959/thumb/sQLDgqx.png?1696517478"
    },
    {
      chainId: 1,
      address: "0xc72633f995e98ac3bb8a89e6a9c4af335c3d6e44",
      name: "Omnisea",
      symbol: "OSEA",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26475/thumb/293837892_407994084681555_3167689470652146992_n.png?1696525547"
    },
    {
      chainId: 1,
      address: "0x2b867efd2de4ad2b583ca0cb3df9c4040ef4d329",
      name: "Lucky Block",
      symbol: "LBLOCK",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/23126/thumb/logo-200x200-LB-09.png?1696522417"
    },
    {
      chainId: 1,
      address: "0xe3c408bd53c31c085a1746af401a4042954ff740",
      name: "GMT",
      symbol: "GMT",
      decimals: 8,
      logoURI: "https://assets.coingecko.com/coins/images/23597/thumb/token-gmt-200x200.png?1703153841"
    },
    {
      chainId: 1,
      address: "0x2c4f1df9c7de0c59778936c9b145ff56813f3295",
      name: "AssetMantle",
      symbol: "MNTL",
      decimals: 6,
      logoURI: "https://assets.coingecko.com/coins/images/25181/thumb/thumbnail.png?1696524326"
    },
    {
      chainId: 1,
      address: "0x57b59f981730c6257df57cf6f0d98283749a9eeb",
      name: "BUILD",
      symbol: "BUILD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26533/thumb/BUILD.png?1696525607"
    },
    {
      chainId: 1,
      address: "0xde16ce60804a881e9f8c4ebb3824646edecd478d",
      name: "MagicCraft",
      symbol: "MCRT",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/21318/thumb/mcrt.png?1696520686"
    },
    {
      chainId: 1,
      address: "0x839e71613f9aa06e5701cf6de63e303616b0dde3",
      name: "VVS Finance",
      symbol: "VVS",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/20210/thumb/8glAYOTM_400x400.jpg?1696519620"
    },
    {
      chainId: 1,
      address: "0x8616e8ea83f048ab9a5ec513c9412dd2993bce3f",
      name: "handleUSD",
      symbol: "FXUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26954/thumb/fxUSDlogo.png?1696526009"
    },
    {
      chainId: 1,
      address: "0x256d1fce1b1221e8398f65f9b36033ce50b2d497",
      name: "Alvey Chain",
      symbol: "WALV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26964/thumb/logo200x200.png?1696526019"
    },
    {
      chainId: 1,
      address: "0xb28f803a8772e6584a65ab6dfc535ae6fef8a0b2",
      name: "Lunafi",
      symbol: "LFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/24594/thumb/lfi.png?1696523768"
    },
    {
      chainId: 1,
      address: "0xc285b7e09a4584d027e5bc36571785b515898246",
      name: "Coin98 Dollar",
      symbol: "CUSD",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26588/thumb/CUSD-01.png?1696525663"
    },
    {
      chainId: 1,
      address: "0x2f32b39023da7d6a6486a85d12b346eb9c2a0d19",
      name: "Ferro",
      symbol: "FER",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/26111/thumb/FER_Token.png?1696525201"
    },
    {
      chainId: 1,
      address: "0xb0b195aefa3650a6908f15cdac7d92f8a5791b0b",
      name: "BOB",
      symbol: "BOB",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27266/thumb/Bob-logo.png?1696526318"
    },
    {
      chainId: 1,
      address: "0xa719cb79af39a9c10eda2755e0938bce35e9de24",
      name: "Starfish Finance",
      symbol: "SEAN",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27533/thumb/SEAN_Token_icon.png?1696526570"
    },
    {
      chainId: 1,
      address: "0x3b79a28264fc52c7b4cea90558aa0b162f7faf57",
      name: "Wonderful Memories",
      symbol: "WMEMO",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/22392/thumb/wMEMO.png?1696521735"
    },
    {
      chainId: 1,
      address: "0x19b22dbadc298c359a1d1b59e35f352a2b40e33c",
      name: "tPLATINUM",
      symbol: "TXPT",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27830/thumb/tPLATINUM_%28TXPT%29_Token.png?1696526849"
    },
    {
      chainId: 1,
      address: "0xe4a6f23fb9e00fca037aa0ea0a6954de0a6c53bf",
      name: "tGOLD",
      symbol: "TXAU",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27828/thumb/tGOLD_token_2D.jpg?1696526846"
    },
    {
      chainId: 1,
      address: "0x34abce75d2f8f33940c721dca0f562617787bff3",
      name: "tSILVER",
      symbol: "TXAG",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/27829/thumb/tSILVER_token_2D.jpg?1696526848"
    },
    {
      chainId: 1,
      address: "0x6b431b8a964bfcf28191b07c91189ff4403957d0",
      name: "CorgiAI",
      symbol: "CORGIAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/30933/thumb/Token.png?1696529775"
    },
    {
      chainId: 1,
      address: "0x61ec85ab89377db65762e234c946b5c25a56e99e",
      name: "HTX DAO",
      symbol: "HTX",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35491/thumb/Frame_1321318576.png?1708908626"
    },
    {
      chainId: 1,
      address: "0x40a32606a4ce9b4f350421642ebf65c052d5389b",
      name: "TonUP",
      symbol: "UP",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34038/thumb/5.png?1703693495"
    },
    {
      chainId: 1,
      address: "0x12996c7b23c4012149bf9f5663ff9aa08a9cf2e4",
      name: "White Yorkshire",
      symbol: "WSH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36769/thumb/20240403_001638.png?1712285274"
    },
    {
      chainId: 1,
      address: "0x1db06f39c14d813d7b1ccb275a93f5b052de1cac",
      name: "Xave",
      symbol: "XAV",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/28299/thumb/Xave_logo_gradient.png?1696527298"
    },
    {
      chainId: 1,
      address: "0xac87d4cbb82ce7f4bcf31dbdc0024306cfd3ec5a",
      name: "KEI Finance",
      symbol: "KEI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/29840/thumb/200x200.png?1696528767"
    },
    {
      chainId: 1,
      address: "0xd7b675cd5c84a13d1d0f84509345530f6421b57c",
      name: "Corridor Finance",
      symbol: "OOOI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36057/thumb/corridor-logo-without-text-8bit.jpg?1710404509"
    },
    {
      chainId: 1,
      address: "0xeaa260c1d247135cec29ec10fb6acedf2a55dc6b",
      name: "TheADA",
      symbol: "TADA",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/33782/thumb/200x200.jpg?1702980786"
    },
    {
      chainId: 1,
      address: "0xb299751b088336e165da313c33e3195b8c6663a6",
      name: "StarHeroes",
      symbol: "STAR",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34147/thumb/Screenshot_2024-03-08_180444.png?1709892309"
    },
    {
      chainId: 1,
      address: "0xce108380c39e4fe9dace9d5597e048bcc5ef743b",
      name: "Blueshift",
      symbol: "BLUES",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/25028/thumb/blues_token_200_200.png?1696524180"
    },
    {
      chainId: 1,
      address: "0x68449870eea84453044bd430822827e21fd8f101",
      name: "Zaibot",
      symbol: "ZAI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35781/thumb/zai.jpeg?1709795384"
    },
    {
      chainId: 1,
      address: "0x527856315a4bcd2f428ea7fa05ea251f7e96a50a",
      name: "CeDeFiAi",
      symbol: "CDFI",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36863/thumb/CeDeFiAi.png?1712643622"
    },
    {
      chainId: 1,
      address: "0x9482c407d32204462d8cbbc0755e96c39b79878e",
      name: "Archly Finance",
      symbol: "ARC",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/37308/thumb/arc-logo-circle-200.png?1713952763"
    },
    {
      chainId: 1,
      address: "0xb0ffa8000886e57f86dd5264b9582b2ad87b2b91",
      name: "Wormhole",
      symbol: "W",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/35087/thumb/womrhole_logo_full_color_rgb_2000px_72ppi_fb766ac85a.png?1708688954"
    },
    {
      chainId: 1,
      address: "0xc36983d3d9d379ddfb306dfb919099cb6730e355",
      name: "Colle AI",
      symbol: "COLLE",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/36676/thumb/E9Yq4waZ.png?1712062887"
    },
    {
      chainId: 1,
      address: "0x1155db64b59265f57533bc0f9ae012fffd34eb7f",
      name: "Yaku",
      symbol: "YAKU",
      decimals: 9,
      logoURI: "https://assets.coingecko.com/coins/images/26785/thumb/yaku_logo.png?1706636424"
    },
    {
      chainId: 1,
      address: "0x19373ecbb4b8cc2253d70f2a246fa299303227ba",
      name: "Orchai",
      symbol: "OCH",
      decimals: 18,
      logoURI: "https://assets.coingecko.com/coins/images/34236/thumb/orchai_logo_white_copy_4x-8_%281%29.png?1704307670"
    }
  ],
  version: {
    major: 333,
    minor: 2,
    patch: 1
  }
};

// src/utils.ts
var auctionHouseMap = {
  [AuctionType.SEALED_BID]: "batchAuctionHouse",
  [AuctionType.FIXED_PRICE_BATCH]: "batchAuctionHouse"
};
var catalogueMap = {
  [AuctionType.SEALED_BID]: "batchCatalogue",
  [AuctionType.FIXED_PRICE_BATCH]: "batchCatalogue"
};
var moduleMap = {
  [AuctionType.SEALED_BID]: "encryptedMarginalPrice",
  [AuctionType.FIXED_PRICE_BATCH]: "fixedPriceBatch"
};
function getContractsByModuleType(auction) {
  const auctionModule = moduleMap[auction.auctionType];
  const abi = axisContracts.abis[auctionModule];
  const address = axisContracts.addresses[auction.chainId][auctionModule];
  if (!abi || !address) {
    throw new Error(`Can't find abi/address for ${auction.auctionType}`);
  }
  return { abi, address };
}
function getAuctionHouse(auction) {
  if (auction.chainId == null) {
    return {
      abi: axisContracts.abis.batchAuctionHouse,
      address: "0x"
    };
  }
  const contractName = auction.auctionType ? auctionHouseMap[auction.auctionType] : "batchAuctionHouse";
  return {
    abi: axisContracts.abis[contractName],
    address: axisContracts.addresses[auction.chainId][contractName]
  };
}
function getCatalogue(auction) {
  const catalogueName = catalogueMap[auction.auctionType];
  const abi = axisContracts.abis[catalogueName];
  const address = axisContracts.addresses[auction.chainId][catalogueName];
  if (!abi || !address) {
    return void 0;
  }
  return {
    abi,
    address
  };
}
var isTestnet = (chainId) => testnetDeployments.find((testnet) => testnet.chain.id === chainId) !== void 0;
var mainnetTokens = mainnet_tokenlist_default.tokens;
var getMainnetTokenFromSymbol = (tokenSymbol) => {
  return mainnetTokens.find((token) => token.symbol === tokenSymbol);
};
function getDeploymentConfiguration(chainId) {
  return [mainnetDeployments, testnetDeployments].flat().find((d) => d.chain.id === chainId);
}
export {
  allDeployments,
  axisContracts,
  defaultTokenlist,
  deployments,
  getAuctionHouse,
  getCatalogue,
  getContractsByModuleType,
  getDeploymentConfiguration as getDeployment,
  getMainnetTokenFromSymbol,
  isTestnet,
  mainnetDeployments,
  mainnets,
  testnetDeployments,
  testnets
};
/*! Bundled license information:

@noble/hashes/esm/utils.js:
  (*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) *)
*/
//# sourceMappingURL=index.js.map